(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3067"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3067"] = parcelRequire;
}
parcelRequire.register("efXw5", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("cfZzL")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("cfZzL")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("cfZzL")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("cfZzL")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("cfZzL")).createElementVNode; });
$parcel$export(module.exports, "createSlots", function () { return (parcelRequire("cfZzL")).createSlots; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("cfZzL")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("cfZzL")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("cfZzL")).createVNode; });
$parcel$export(module.exports, "defineAsyncComponent", function () { return (parcelRequire("cfZzL")).defineAsyncComponent; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("cfZzL")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("cfZzL")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("cfZzL")).getCurrentInstance; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("gGESn")).getCurrentScope; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("cfZzL")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("cfZzL")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("cfZzL")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("cfZzL")).inject; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("gGESn")).isReactive; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("gGESn")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("gGESn")).markRaw; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("cfZzL")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("cfZzL")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("4bH2P")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("4bH2P")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("cfZzL")).onActivated; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("cfZzL")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("cfZzL")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("cfZzL")).onUnmounted; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("cfZzL")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("cfZzL")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("cfZzL")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("cfZzL")).pushScopeId; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("gGESn")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("gGESn")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("cfZzL")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("cfZzL")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("cfZzL")).resolveComponent; });
$parcel$export(module.exports, "resolveDirective", function () { return (parcelRequire("cfZzL")).resolveDirective; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("cfZzL")).resolveDynamicComponent; });
$parcel$export(module.exports, "toHandlers", function () { return (parcelRequire("cfZzL")).toHandlers; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("gGESn")).toRaw; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("cfZzL")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("cfZzL")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("cfZzL")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("cfZzL")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("brqXq")).createApp; });
$parcel$export(module.exports, "Transition", function () { return (parcelRequire("brqXq")).Transition; });
$parcel$export(module.exports, "vModelCheckbox", function () { return (parcelRequire("brqXq")).vModelCheckbox; });
$parcel$export(module.exports, "vModelDynamic", function () { return (parcelRequire("brqXq")).vModelDynamic; });
$parcel$export(module.exports, "vModelRadio", function () { return (parcelRequire("brqXq")).vModelRadio; });
$parcel$export(module.exports, "vModelSelect", function () { return (parcelRequire("brqXq")).vModelSelect; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("brqXq")).vModelText; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("brqXq")).vShow; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("brqXq")).withKeys; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("brqXq")).withModifiers; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("gGESn")).effectScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("gGESn")).onScopeDispose; });
$parcel$export(module.exports, "shallowReadonly", function () { return (parcelRequire("gGESn")).shallowReadonly; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("gGESn")).shallowRef; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("gGESn")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("gGESn")).toRefs; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("gGESn")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("4bH2P")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("4bH2P")).toDisplayString; });

var $cfZzL = parcelRequire("cfZzL");parcelRequire("brqXq");parcelRequire("gGESn");parcelRequire("4bH2P");
function $a610a22ad0622e37$var$initDev() {
    (0, $cfZzL.initCustomFormatter)();
}
const $a610a22ad0622e37$export$ef7acd7185315e22 = ()=>{};

});
parcelRequire.register("cfZzL", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $8ec6a6735a74a56f$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $8ec6a6735a74a56f$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $8ec6a6735a74a56f$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $8ec6a6735a74a56f$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $8ec6a6735a74a56f$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $8ec6a6735a74a56f$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $8ec6a6735a74a56f$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $8ec6a6735a74a56f$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $8ec6a6735a74a56f$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $8ec6a6735a74a56f$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "watchEffect", function () { return $8ec6a6735a74a56f$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watchPostEffect", function () { return $8ec6a6735a74a56f$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watch", function () { return $8ec6a6735a74a56f$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "withDirectives", function () { return $8ec6a6735a74a56f$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "useTransitionState", function () { return $8ec6a6735a74a56f$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $8ec6a6735a74a56f$export$6d1641039221b5cb; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $8ec6a6735a74a56f$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $8ec6a6735a74a56f$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $8ec6a6735a74a56f$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $8ec6a6735a74a56f$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $8ec6a6735a74a56f$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $8ec6a6735a74a56f$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $8ec6a6735a74a56f$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "defineAsyncComponent", function () { return $8ec6a6735a74a56f$export$d75d499b4c16cf21; });
$parcel$export(module.exports, "onUpdated", function () { return $8ec6a6735a74a56f$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onActivated", function () { return $8ec6a6735a74a56f$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $8ec6a6735a74a56f$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $8ec6a6735a74a56f$export$13348a43ccacfe58; });
$parcel$export(module.exports, "resolveComponent", function () { return $8ec6a6735a74a56f$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $8ec6a6735a74a56f$export$b44c564a05ca975; });
$parcel$export(module.exports, "resolveDirective", function () { return $8ec6a6735a74a56f$export$a1989e995cd481be; });
$parcel$export(module.exports, "renderList", function () { return $8ec6a6735a74a56f$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createSlots", function () { return $8ec6a6735a74a56f$export$85738f8fcd0a5430; });
$parcel$export(module.exports, "renderSlot", function () { return $8ec6a6735a74a56f$export$4abee4c34694ada1; });
$parcel$export(module.exports, "createBlock", function () { return $8ec6a6735a74a56f$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "toHandlers", function () { return $8ec6a6735a74a56f$export$2fb94ff667a6a1a; });
$parcel$export(module.exports, "computed", function () { return $8ec6a6735a74a56f$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "provide", function () { return $8ec6a6735a74a56f$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $8ec6a6735a74a56f$export$a976684a0efeb93f; });
$parcel$export(module.exports, "createTextVNode", function () { return $8ec6a6735a74a56f$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $8ec6a6735a74a56f$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $8ec6a6735a74a56f$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $8ec6a6735a74a56f$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $8ec6a6735a74a56f$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $8ec6a6735a74a56f$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $8ec6a6735a74a56f$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createStaticVNode", function () { return $8ec6a6735a74a56f$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "createCommentVNode", function () { return $8ec6a6735a74a56f$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $8ec6a6735a74a56f$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $8ec6a6735a74a56f$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $8ec6a6735a74a56f$export$aed4979be6a60047; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("gGESn")).getCurrentScope; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("gGESn")).isReactive; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("gGESn")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("gGESn")).markRaw; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("gGESn")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("gGESn")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("gGESn")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("4bH2P")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("4bH2P")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("4bH2P")).normalizeStyle; });

var $gGESn = parcelRequire("gGESn");

var $4bH2P = parcelRequire("4bH2P");
const $8ec6a6735a74a56f$var$stack = [];
function $8ec6a6735a74a56f$var$pushWarningContext(vnode) {
    $8ec6a6735a74a56f$var$stack.push(vnode);
}
function $8ec6a6735a74a56f$var$popWarningContext() {
    $8ec6a6735a74a56f$var$stack.pop();
}
function $8ec6a6735a74a56f$export$c106dd0671a0fc2d(msg, ...args) {
    var vnode;
    return;
}
function $8ec6a6735a74a56f$var$getComponentTrace() {
    let currentVNode = $8ec6a6735a74a56f$var$stack[$8ec6a6735a74a56f$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $8ec6a6735a74a56f$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$8ec6a6735a74a56f$var$formatTraceEntry(entry));
    });
    return logs;
}
function $8ec6a6735a74a56f$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$8ec6a6735a74a56f$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$8ec6a6735a74a56f$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $8ec6a6735a74a56f$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$8ec6a6735a74a56f$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $8ec6a6735a74a56f$var$formatProp(key, value1, raw) {
    if ((0, $4bH2P.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            `${key}=${value1}`
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        `${key}=${value1}`
    ];
    else if ((0, $gGESn.isRef)(value1)) {
        value1 = $8ec6a6735a74a56f$var$formatProp(key, (0, $gGESn.toRaw)(value1.value), true);
        return raw ? value1 : [
            `${key}=Ref<`,
            value1,
            `>`
        ];
    } else if ((0, $4bH2P.isFunction)(value1)) return [
        `${key}=fn${value1.name ? `<${value1.name}>` : ``}`
    ];
    else {
        value1 = (0, $gGESn.toRaw)(value1);
        return raw ? value1 : [
            `${key}=`,
            value1
        ];
    }
}
function $8ec6a6735a74a56f$export$dfbcecb440255e4a(val, type) {
    return;
}
const $8ec6a6735a74a56f$var$ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $8ec6a6735a74a56f$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $8ec6a6735a74a56f$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $8ec6a6735a74a56f$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $4bH2P.isFunction)(fn)) {
        const res = $8ec6a6735a74a56f$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $4bH2P.isPromise)(res)) res.catch((err)=>{
            $8ec6a6735a74a56f$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($8ec6a6735a74a56f$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $8ec6a6735a74a56f$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $8ec6a6735a74a56f$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $8ec6a6735a74a56f$var$logError(err, type, contextVNode, throwInDev);
}
function $8ec6a6735a74a56f$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $8ec6a6735a74a56f$var$isFlushing = false;
let $8ec6a6735a74a56f$var$isFlushPending = false;
const $8ec6a6735a74a56f$var$queue = [];
let $8ec6a6735a74a56f$var$flushIndex = 0;
const $8ec6a6735a74a56f$var$pendingPostFlushCbs = [];
let $8ec6a6735a74a56f$var$activePostFlushCbs = null;
let $8ec6a6735a74a56f$var$postFlushIndex = 0;
const $8ec6a6735a74a56f$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $8ec6a6735a74a56f$var$currentFlushPromise = null;
const $8ec6a6735a74a56f$var$RECURSION_LIMIT = 100;
function $8ec6a6735a74a56f$export$bdd553fddd433dcb(fn) {
    const p = $8ec6a6735a74a56f$var$currentFlushPromise || $8ec6a6735a74a56f$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $8ec6a6735a74a56f$var$findInsertionIndex(id) {
    let start = $8ec6a6735a74a56f$var$flushIndex + 1;
    let end = $8ec6a6735a74a56f$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $8ec6a6735a74a56f$var$getId($8ec6a6735a74a56f$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $8ec6a6735a74a56f$var$queueJob(job) {
    if (!$8ec6a6735a74a56f$var$queue.length || !$8ec6a6735a74a56f$var$queue.includes(job, $8ec6a6735a74a56f$var$isFlushing && job.allowRecurse ? $8ec6a6735a74a56f$var$flushIndex + 1 : $8ec6a6735a74a56f$var$flushIndex)) {
        if (job.id == null) $8ec6a6735a74a56f$var$queue.push(job);
        else $8ec6a6735a74a56f$var$queue.splice($8ec6a6735a74a56f$var$findInsertionIndex(job.id), 0, job);
        $8ec6a6735a74a56f$var$queueFlush();
    }
}
function $8ec6a6735a74a56f$var$queueFlush() {
    if (!$8ec6a6735a74a56f$var$isFlushing && !$8ec6a6735a74a56f$var$isFlushPending) {
        $8ec6a6735a74a56f$var$isFlushPending = true;
        $8ec6a6735a74a56f$var$currentFlushPromise = $8ec6a6735a74a56f$var$resolvedPromise.then($8ec6a6735a74a56f$var$flushJobs);
    }
}
function $8ec6a6735a74a56f$var$invalidateJob(job) {
    const i = $8ec6a6735a74a56f$var$queue.indexOf(job);
    if (i > $8ec6a6735a74a56f$var$flushIndex) $8ec6a6735a74a56f$var$queue.splice(i, 1);
}
function $8ec6a6735a74a56f$export$59536a0199721cab(cb) {
    if (!(0, $4bH2P.isArray)(cb)) {
        if (!$8ec6a6735a74a56f$var$activePostFlushCbs || !$8ec6a6735a74a56f$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $8ec6a6735a74a56f$var$postFlushIndex + 1 : $8ec6a6735a74a56f$var$postFlushIndex)) $8ec6a6735a74a56f$var$pendingPostFlushCbs.push(cb);
    } else $8ec6a6735a74a56f$var$pendingPostFlushCbs.push(...cb);
    $8ec6a6735a74a56f$var$queueFlush();
}
function $8ec6a6735a74a56f$var$flushPreFlushCbs(seen, i = $8ec6a6735a74a56f$var$isFlushing ? $8ec6a6735a74a56f$var$flushIndex + 1 : 0) {
    for(; i < $8ec6a6735a74a56f$var$queue.length; i++){
        const cb = $8ec6a6735a74a56f$var$queue[i];
        if (cb && cb.pre) {
            $8ec6a6735a74a56f$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $8ec6a6735a74a56f$var$flushPostFlushCbs(seen) {
    if ($8ec6a6735a74a56f$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($8ec6a6735a74a56f$var$pendingPostFlushCbs)
        ];
        $8ec6a6735a74a56f$var$pendingPostFlushCbs.length = 0;
        if ($8ec6a6735a74a56f$var$activePostFlushCbs) {
            $8ec6a6735a74a56f$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $8ec6a6735a74a56f$var$activePostFlushCbs = deduped;
        $8ec6a6735a74a56f$var$activePostFlushCbs.sort((a, b)=>$8ec6a6735a74a56f$var$getId(a) - $8ec6a6735a74a56f$var$getId(b));
        for($8ec6a6735a74a56f$var$postFlushIndex = 0; $8ec6a6735a74a56f$var$postFlushIndex < $8ec6a6735a74a56f$var$activePostFlushCbs.length; $8ec6a6735a74a56f$var$postFlushIndex++)$8ec6a6735a74a56f$var$activePostFlushCbs[$8ec6a6735a74a56f$var$postFlushIndex]();
        $8ec6a6735a74a56f$var$activePostFlushCbs = null;
        $8ec6a6735a74a56f$var$postFlushIndex = 0;
    }
}
const $8ec6a6735a74a56f$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $8ec6a6735a74a56f$var$comparator = (a, b)=>{
    const diff = $8ec6a6735a74a56f$var$getId(a) - $8ec6a6735a74a56f$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $8ec6a6735a74a56f$var$flushJobs(seen) {
    $8ec6a6735a74a56f$var$isFlushPending = false;
    $8ec6a6735a74a56f$var$isFlushing = true;
    $8ec6a6735a74a56f$var$queue.sort($8ec6a6735a74a56f$var$comparator);
    const check = (0, $4bH2P.NOOP);
    try {
        for($8ec6a6735a74a56f$var$flushIndex = 0; $8ec6a6735a74a56f$var$flushIndex < $8ec6a6735a74a56f$var$queue.length; $8ec6a6735a74a56f$var$flushIndex++){
            const job = $8ec6a6735a74a56f$var$queue[$8ec6a6735a74a56f$var$flushIndex];
            if (job && job.active !== false) $8ec6a6735a74a56f$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $8ec6a6735a74a56f$var$flushIndex = 0;
        $8ec6a6735a74a56f$var$queue.length = 0;
        $8ec6a6735a74a56f$var$flushPostFlushCbs(seen);
        $8ec6a6735a74a56f$var$isFlushing = false;
        $8ec6a6735a74a56f$var$currentFlushPromise = null;
        if ($8ec6a6735a74a56f$var$queue.length || $8ec6a6735a74a56f$var$pendingPostFlushCbs.length) $8ec6a6735a74a56f$var$flushJobs(seen);
    }
}
function $8ec6a6735a74a56f$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $8ec6a6735a74a56f$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $8ec6a6735a74a56f$var$getComponentName(instance.type);
            $8ec6a6735a74a56f$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $8ec6a6735a74a56f$var$isHmrUpdating = false;
const $8ec6a6735a74a56f$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $8ec6a6735a74a56f$var$map = /* @__PURE__ */ new Map();
function $8ec6a6735a74a56f$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $8ec6a6735a74a56f$var$map.get(id);
    if (!record) {
        $8ec6a6735a74a56f$var$createRecord(id, instance.type);
        record = $8ec6a6735a74a56f$var$map.get(id);
    }
    record.instances.add(instance);
}
function $8ec6a6735a74a56f$var$unregisterHMR(instance) {
    $8ec6a6735a74a56f$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $8ec6a6735a74a56f$var$createRecord(id, initialDef) {
    if ($8ec6a6735a74a56f$var$map.has(id)) return false;
    $8ec6a6735a74a56f$var$map.set(id, {
        initialDef: $8ec6a6735a74a56f$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $8ec6a6735a74a56f$var$normalizeClassComponent(component) {
    return $8ec6a6735a74a56f$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $8ec6a6735a74a56f$var$rerender(id, newRender) {
    const record = $8ec6a6735a74a56f$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $8ec6a6735a74a56f$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $8ec6a6735a74a56f$var$isHmrUpdating = true;
        instance.update();
        $8ec6a6735a74a56f$var$isHmrUpdating = false;
    });
}
function $8ec6a6735a74a56f$var$reload(id, newComp) {
    const record = $8ec6a6735a74a56f$var$map.get(id);
    if (!record) return;
    newComp = $8ec6a6735a74a56f$var$normalizeClassComponent(newComp);
    $8ec6a6735a74a56f$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $8ec6a6735a74a56f$var$normalizeClassComponent(instance.type);
        if (!$8ec6a6735a74a56f$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $8ec6a6735a74a56f$var$updateComponentDef(oldComp, newComp);
            $8ec6a6735a74a56f$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $8ec6a6735a74a56f$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $8ec6a6735a74a56f$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) $8ec6a6735a74a56f$var$queueJob(instance.parent.update);
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $8ec6a6735a74a56f$export$59536a0199721cab(()=>{
        for (const instance of instances)$8ec6a6735a74a56f$var$hmrDirtyComponents.delete($8ec6a6735a74a56f$var$normalizeClassComponent(instance.type));
    });
}
function $8ec6a6735a74a56f$var$updateComponentDef(oldComp, newComp) {
    (0, $4bH2P.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $8ec6a6735a74a56f$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $8ec6a6735a74a56f$export$6922d3b3a607469e;
let $8ec6a6735a74a56f$var$buffer = [];
let $8ec6a6735a74a56f$var$devtoolsNotInstalled = false;
function $8ec6a6735a74a56f$var$emit$1(event, ...args) {
    if ($8ec6a6735a74a56f$export$6922d3b3a607469e) $8ec6a6735a74a56f$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$8ec6a6735a74a56f$var$devtoolsNotInstalled) $8ec6a6735a74a56f$var$buffer.push({
        event: event,
        args: args
    });
}
function $8ec6a6735a74a56f$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $8ec6a6735a74a56f$export$6922d3b3a607469e = hook;
    if ($8ec6a6735a74a56f$export$6922d3b3a607469e) {
        $8ec6a6735a74a56f$export$6922d3b3a607469e.enabled = true;
        $8ec6a6735a74a56f$var$buffer.forEach(({ event: event, args: args })=>$8ec6a6735a74a56f$export$6922d3b3a607469e.emit(event, ...args));
        $8ec6a6735a74a56f$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $8ec6a6735a74a56f$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(()=>{
            if (!$8ec6a6735a74a56f$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $8ec6a6735a74a56f$var$devtoolsNotInstalled = true;
                $8ec6a6735a74a56f$var$buffer = [];
            }
        }, 3e3);
    } else {
        $8ec6a6735a74a56f$var$devtoolsNotInstalled = true;
        $8ec6a6735a74a56f$var$buffer = [];
    }
}
function $8ec6a6735a74a56f$var$devtoolsInitApp(app, version) {
    $8ec6a6735a74a56f$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $8ec6a6735a74a56f$export$ffb0004e005737fa,
        Text: $8ec6a6735a74a56f$export$5f1af8db9871e1d6,
        Comment: $8ec6a6735a74a56f$export$4d299b491347818a,
        Static: $8ec6a6735a74a56f$export$c1b9a1d3af45b7b6
    });
}
function $8ec6a6735a74a56f$var$devtoolsUnmountApp(app) {
    $8ec6a6735a74a56f$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $8ec6a6735a74a56f$var$devtoolsComponentAdded = /* @__PURE__ */ $8ec6a6735a74a56f$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $8ec6a6735a74a56f$var$devtoolsComponentUpdated = /* @__PURE__ */ $8ec6a6735a74a56f$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $8ec6a6735a74a56f$var$_devtoolsComponentRemoved = /* @__PURE__ */ $8ec6a6735a74a56f$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $8ec6a6735a74a56f$var$devtoolsComponentRemoved = (component)=>{
    if ($8ec6a6735a74a56f$export$6922d3b3a607469e && typeof $8ec6a6735a74a56f$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$8ec6a6735a74a56f$export$6922d3b3a607469e.cleanupBuffer(component)) $8ec6a6735a74a56f$var$_devtoolsComponentRemoved(component);
};
function $8ec6a6735a74a56f$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $8ec6a6735a74a56f$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $8ec6a6735a74a56f$var$devtoolsPerfStart = /* @__PURE__ */ $8ec6a6735a74a56f$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $8ec6a6735a74a56f$var$devtoolsPerfEnd = /* @__PURE__ */ $8ec6a6735a74a56f$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $8ec6a6735a74a56f$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $8ec6a6735a74a56f$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $8ec6a6735a74a56f$var$devtoolsComponentEmit(component, event, params) {
    $8ec6a6735a74a56f$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $8ec6a6735a74a56f$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $4bH2P.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $4bH2P.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $4bH2P.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $4bH2P.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $4bH2P.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $4bH2P.toHandlerKey)((0, $4bH2P.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $4bH2P.toHandlerKey)((0, $4bH2P.hyphenate)(event))];
    if (handler) $8ec6a6735a74a56f$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $8ec6a6735a74a56f$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $8ec6a6735a74a56f$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $4bH2P.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $8ec6a6735a74a56f$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $4bH2P.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $4bH2P.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $4bH2P.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $4bH2P.extend)(normalized, raw);
    if ((0, $4bH2P.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $8ec6a6735a74a56f$var$isEmitListener(options, key) {
    if (!options || !(0, $4bH2P.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $4bH2P.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $4bH2P.hasOwn)(options, (0, $4bH2P.hyphenate)(key)) || (0, $4bH2P.hasOwn)(options, key);
}
let $8ec6a6735a74a56f$var$currentRenderingInstance = null;
let $8ec6a6735a74a56f$var$currentScopeId = null;
function $8ec6a6735a74a56f$var$setCurrentRenderingInstance(instance) {
    const prev = $8ec6a6735a74a56f$var$currentRenderingInstance;
    $8ec6a6735a74a56f$var$currentRenderingInstance = instance;
    $8ec6a6735a74a56f$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $8ec6a6735a74a56f$export$ac020265ca2cc4cd(id) {
    $8ec6a6735a74a56f$var$currentScopeId = id;
}
function $8ec6a6735a74a56f$export$f2dc6805dc11834e() {
    $8ec6a6735a74a56f$var$currentScopeId = null;
}
const $8ec6a6735a74a56f$export$15ba313e13f3dd04 = (_id)=>$8ec6a6735a74a56f$export$694b237e827a3d23;
function $8ec6a6735a74a56f$export$694b237e827a3d23(fn, ctx = $8ec6a6735a74a56f$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $8ec6a6735a74a56f$export$c20bee82f26f1e27(-1);
        const prevInstance = $8ec6a6735a74a56f$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $8ec6a6735a74a56f$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $8ec6a6735a74a56f$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $8ec6a6735a74a56f$var$accessedAttrs = false;
function $8ec6a6735a74a56f$var$markAttrsAccessed() {
    $8ec6a6735a74a56f$var$accessedAttrs = true;
}
function $8ec6a6735a74a56f$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $8ec6a6735a74a56f$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            result = $8ec6a6735a74a56f$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $8ec6a6735a74a56f$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $8ec6a6735a74a56f$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $8ec6a6735a74a56f$var$blockStack.length = 0;
        $8ec6a6735a74a56f$export$d3da1ecaf1206c58(err, instance, 1);
        result = $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $4bH2P.isModelListener))) fallthroughAttrs = $8ec6a6735a74a56f$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $8ec6a6735a74a56f$var$setCurrentRenderingInstance(prev);
    return result;
}
const $8ec6a6735a74a56f$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $8ec6a6735a74a56f$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $8ec6a6735a74a56f$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $8ec6a6735a74a56f$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($8ec6a6735a74a56f$export$3868d13f8734ae81(child)) {
            if (child.type !== $8ec6a6735a74a56f$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $8ec6a6735a74a56f$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $4bH2P.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $8ec6a6735a74a56f$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $4bH2P.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $8ec6a6735a74a56f$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $8ec6a6735a74a56f$export$4d299b491347818a;
};
function $8ec6a6735a74a56f$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $8ec6a6735a74a56f$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$8ec6a6735a74a56f$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $8ec6a6735a74a56f$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $8ec6a6735a74a56f$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$8ec6a6735a74a56f$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $8ec6a6735a74a56f$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $8ec6a6735a74a56f$var$isSuspense = (type)=>type.__isSuspense;
const $8ec6a6735a74a56f$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $8ec6a6735a74a56f$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $8ec6a6735a74a56f$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $8ec6a6735a74a56f$var$hydrateSuspense,
    create: $8ec6a6735a74a56f$var$createSuspenseBoundary,
    normalize: $8ec6a6735a74a56f$var$normalizeSuspenseChildren
};
const $8ec6a6735a74a56f$export$74bf444e3cd11ea5 = $8ec6a6735a74a56f$var$SuspenseImpl;
function $8ec6a6735a74a56f$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $4bH2P.isFunction)(eventListener)) eventListener();
}
function $8ec6a6735a74a56f$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $8ec6a6735a74a56f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $8ec6a6735a74a56f$var$triggerEvent(vnode, "onPending");
        $8ec6a6735a74a56f$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $8ec6a6735a74a56f$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $8ec6a6735a74a56f$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($8ec6a6735a74a56f$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $8ec6a6735a74a56f$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $8ec6a6735a74a56f$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $8ec6a6735a74a56f$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $8ec6a6735a74a56f$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $8ec6a6735a74a56f$var$setActiveBranch(suspense, newBranch);
    } else {
        $8ec6a6735a74a56f$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $8ec6a6735a74a56f$var$hasWarned = false;
function $8ec6a6735a74a56f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $8ec6a6735a74a56f$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $4bH2P.toNumber)(vnode.props.timeout) : void 0;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container2, anchor2, 0);
                };
                let { anchor: anchor2 } = suspense;
                if (activeBranch) {
                    anchor2 = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
            }
            $8ec6a6735a74a56f$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor) $8ec6a6735a74a56f$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $8ec6a6735a74a56f$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, isSVG: isSVG2 } = suspense;
            $8ec6a6735a74a56f$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                isSVG2, slotScopeIds, optimized);
                $8ec6a6735a74a56f$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $8ec6a6735a74a56f$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $8ec6a6735a74a56f$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $8ec6a6735a74a56f$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $8ec6a6735a74a56f$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $8ec6a6735a74a56f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $8ec6a6735a74a56f$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $8ec6a6735a74a56f$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $8ec6a6735a74a56f$var$normalizeSuspenseSlot(children.fallback) : $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$4d299b491347818a);
}
function $8ec6a6735a74a56f$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $4bH2P.isFunction)(s)) {
        const trackBlock = $8ec6a6735a74a56f$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $8ec6a6735a74a56f$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $8ec6a6735a74a56f$var$currentBlock;
            $8ec6a6735a74a56f$var$closeBlock();
        }
    }
    if ((0, $4bH2P.isArray)(s)) {
        const singleChild = $8ec6a6735a74a56f$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $8ec6a6735a74a56f$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $8ec6a6735a74a56f$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $4bH2P.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $8ec6a6735a74a56f$export$59536a0199721cab(fn);
}
function $8ec6a6735a74a56f$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $8ec6a6735a74a56f$var$updateHOCHostEl(parentComponent, el);
    }
}
function $8ec6a6735a74a56f$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $8ec6a6735a74a56f$export$ede35fc0e5500309(effect, options) {
    return $8ec6a6735a74a56f$var$doWatch(effect, null, options);
}
function $8ec6a6735a74a56f$export$b7f27ea67102d543(effect, options) {
    return $8ec6a6735a74a56f$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $8ec6a6735a74a56f$export$2035654f31b0e555(effect, options) {
    return $8ec6a6735a74a56f$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $8ec6a6735a74a56f$var$INITIAL_WATCHER_VALUE = {};
function $8ec6a6735a74a56f$export$3db5d71bdb2d5499(source, cb, options) {
    return $8ec6a6735a74a56f$var$doWatch(source, cb, options);
}
function $8ec6a6735a74a56f$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $4bH2P.EMPTY_OBJ)) {
    var _a;
    const warnInvalidSource = (s)=>{
        $8ec6a6735a74a56f$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = (0, $gGESn.getCurrentScope)() === ((_a = $8ec6a6735a74a56f$var$currentInstance) == null ? void 0 : _a.scope) ? $8ec6a6735a74a56f$var$currentInstance : null;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $gGESn.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $gGESn.isShallow)(source);
    } else if ((0, $gGESn.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $4bH2P.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $gGESn.isReactive)(s) || (0, $gGESn.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $gGESn.isRef)(s)) return s.value;
                else if ((0, $gGESn.isReactive)(s)) return $8ec6a6735a74a56f$var$traverse(s);
                else if ((0, $4bH2P.isFunction)(s)) return $8ec6a6735a74a56f$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $4bH2P.isFunction)(source)) {
        if (cb) getter = ()=>$8ec6a6735a74a56f$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $8ec6a6735a74a56f$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $4bH2P.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$8ec6a6735a74a56f$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $8ec6a6735a74a56f$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    let ssrCleanup;
    if ($8ec6a6735a74a56f$var$isInSSRComponentSetup) {
        onCleanup = (0, $4bH2P.NOOP);
        if (!cb) getter();
        else if (immediate) $8ec6a6735a74a56f$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $8ec6a6735a74a56f$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $4bH2P.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($8ec6a6735a74a56f$var$INITIAL_WATCHER_VALUE) : $8ec6a6735a74a56f$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $4bH2P.hasChanged)(v1, oldValue[i])) : (0, $4bH2P.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $8ec6a6735a74a56f$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $8ec6a6735a74a56f$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $8ec6a6735a74a56f$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$8ec6a6735a74a56f$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$8ec6a6735a74a56f$var$queueJob(job);
    }
    const effect = new (0, $gGESn.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $8ec6a6735a74a56f$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    const unwatch = ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $4bH2P.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $8ec6a6735a74a56f$var$instanceWatch(source, value1, options) {
    const publicThis = this.proxy;
    const getter = (0, $4bH2P.isString)(source) ? source.includes(".") ? $8ec6a6735a74a56f$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $4bH2P.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    const cur = $8ec6a6735a74a56f$var$currentInstance;
    $8ec6a6735a74a56f$var$setCurrentInstance(this);
    const res = $8ec6a6735a74a56f$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $8ec6a6735a74a56f$var$setCurrentInstance(cur);
    else $8ec6a6735a74a56f$var$unsetCurrentInstance();
    return res;
}
function $8ec6a6735a74a56f$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $8ec6a6735a74a56f$var$traverse(value1, seen) {
    if (!(0, $4bH2P.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $gGESn.isRef)(value1)) $8ec6a6735a74a56f$var$traverse(value1.value, seen);
    else if ((0, $4bH2P.isArray)(value1)) for(let i = 0; i < value1.length; i++)$8ec6a6735a74a56f$var$traverse(value1[i], seen);
    else if ((0, $4bH2P.isSet)(value1) || (0, $4bH2P.isMap)(value1)) value1.forEach((v1)=>{
        $8ec6a6735a74a56f$var$traverse(v1, seen);
    });
    else if ((0, $4bH2P.isPlainObject)(value1)) for(const key in value1)$8ec6a6735a74a56f$var$traverse(value1[key], seen);
    return value1;
}
function $8ec6a6735a74a56f$var$validateDirectiveName(name) {
    if ((0, $4bH2P.isBuiltInDirective)(name)) $8ec6a6735a74a56f$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $8ec6a6735a74a56f$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $8ec6a6735a74a56f$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $8ec6a6735a74a56f$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value1, arg, modifiers = (0, $4bH2P.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $4bH2P.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $8ec6a6735a74a56f$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $gGESn.pauseTracking)();
            $8ec6a6735a74a56f$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $gGESn.resetTracking)();
        }
    }
}
function $8ec6a6735a74a56f$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $8ec6a6735a74a56f$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $8ec6a6735a74a56f$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $8ec6a6735a74a56f$var$TransitionHookValidator = [
    Function,
    Array
];
const $8ec6a6735a74a56f$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onEnter: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onAfterEnter: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onEnterCancelled: $8ec6a6735a74a56f$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onLeave: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onAfterLeave: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onLeaveCancelled: $8ec6a6735a74a56f$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onAppear: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onAfterAppear: $8ec6a6735a74a56f$var$TransitionHookValidator,
    onAppearCancelled: $8ec6a6735a74a56f$var$TransitionHookValidator
};
const $8ec6a6735a74a56f$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $8ec6a6735a74a56f$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $8ec6a6735a74a56f$export$f13e630aa3915748();
        const state = $8ec6a6735a74a56f$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $8ec6a6735a74a56f$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $8ec6a6735a74a56f$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $gGESn.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $8ec6a6735a74a56f$var$emptyPlaceholder(child);
            const innerChild = $8ec6a6735a74a56f$var$getKeepAliveChild(child);
            if (!innerChild) return $8ec6a6735a74a56f$var$emptyPlaceholder(child);
            const enterHooks = $8ec6a6735a74a56f$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $8ec6a6735a74a56f$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $8ec6a6735a74a56f$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $8ec6a6735a74a56f$export$4d299b491347818a && (!$8ec6a6735a74a56f$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $8ec6a6735a74a56f$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $8ec6a6735a74a56f$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $8ec6a6735a74a56f$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $8ec6a6735a74a56f$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $8ec6a6735a74a56f$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $8ec6a6735a74a56f$export$abd95b5f5e8a8837 = $8ec6a6735a74a56f$var$BaseTransitionImpl;
function $8ec6a6735a74a56f$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $8ec6a6735a74a56f$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $8ec6a6735a74a56f$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $8ec6a6735a74a56f$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $4bH2P.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el._leaveCb) el._leaveCb(true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $8ec6a6735a74a56f$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $8ec6a6735a74a56f$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $8ec6a6735a74a56f$var$emptyPlaceholder(vnode) {
    if ($8ec6a6735a74a56f$var$isKeepAlive(vnode)) {
        vnode = $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $8ec6a6735a74a56f$var$getKeepAliveChild(vnode) {
    return $8ec6a6735a74a56f$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $8ec6a6735a74a56f$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $8ec6a6735a74a56f$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $8ec6a6735a74a56f$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $8ec6a6735a74a56f$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($8ec6a6735a74a56f$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $8ec6a6735a74a56f$export$4d299b491347818a) ret.push(key != null ? $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $8ec6a6735a74a56f$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $4bH2P.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $4bH2P.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $8ec6a6735a74a56f$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $8ec6a6735a74a56f$export$d75d499b4c16cf21(source) {
    if ((0, $4bH2P.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $8ec6a6735a74a56f$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $8ec6a6735a74a56f$var$currentInstance;
            if (resolvedComp) return ()=>$8ec6a6735a74a56f$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $8ec6a6735a74a56f$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $8ec6a6735a74a56f$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$8ec6a6735a74a56f$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $8ec6a6735a74a56f$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $gGESn.ref)(false);
            const error = (0, $gGESn.ref)();
            const delayed = (0, $gGESn.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $8ec6a6735a74a56f$var$isKeepAlive(instance.parent.vnode)) $8ec6a6735a74a56f$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $8ec6a6735a74a56f$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $8ec6a6735a74a56f$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $8ec6a6735a74a56f$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $8ec6a6735a74a56f$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $8ec6a6735a74a56f$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $8ec6a6735a74a56f$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $8ec6a6735a74a56f$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $8ec6a6735a74a56f$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $4bH2P.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $4bH2P.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $8ec6a6735a74a56f$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $8ec6a6735a74a56f$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$8ec6a6735a74a56f$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $8ec6a6735a74a56f$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $8ec6a6735a74a56f$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$8ec6a6735a74a56f$var$matches(include, name));
            exclude && pruneCache((name)=>!$8ec6a6735a74a56f$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $8ec6a6735a74a56f$var$getInnerChild(instance.subTree));
        };
        $8ec6a6735a74a56f$export$6d1641039221b5cb(cacheSubtree);
        $8ec6a6735a74a56f$export$5876c47052fb88b1(cacheSubtree);
        $8ec6a6735a74a56f$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $8ec6a6735a74a56f$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $8ec6a6735a74a56f$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $8ec6a6735a74a56f$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$8ec6a6735a74a56f$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $8ec6a6735a74a56f$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $8ec6a6735a74a56f$var$getComponentName($8ec6a6735a74a56f$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$8ec6a6735a74a56f$var$matches(include, name)) || exclude && name && $8ec6a6735a74a56f$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $8ec6a6735a74a56f$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $8ec6a6735a74a56f$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $8ec6a6735a74a56f$export$70eb8a58709972df = $8ec6a6735a74a56f$var$KeepAliveImpl;
function $8ec6a6735a74a56f$var$matches(pattern, name) {
    if ((0, $4bH2P.isArray)(pattern)) return pattern.some((p)=>$8ec6a6735a74a56f$var$matches(p, name));
    else if ((0, $4bH2P.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $4bH2P.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $8ec6a6735a74a56f$export$ba52d824b95a2154(hook, target) {
    $8ec6a6735a74a56f$var$registerKeepAliveHook(hook, "a", target);
}
function $8ec6a6735a74a56f$export$bf1440eeaf5fa709(hook, target) {
    $8ec6a6735a74a56f$var$registerKeepAliveHook(hook, "da", target);
}
function $8ec6a6735a74a56f$var$registerKeepAliveHook(hook, type, target = $8ec6a6735a74a56f$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $8ec6a6735a74a56f$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($8ec6a6735a74a56f$var$isKeepAlive(current.parent.vnode)) $8ec6a6735a74a56f$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $8ec6a6735a74a56f$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $8ec6a6735a74a56f$var$injectHook(type, hook, keepAliveRoot, true);
    $8ec6a6735a74a56f$export$13348a43ccacfe58(()=>{
        (0, $4bH2P.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $8ec6a6735a74a56f$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $8ec6a6735a74a56f$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $8ec6a6735a74a56f$var$injectHook(type, hook, target = $8ec6a6735a74a56f$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $gGESn.pauseTracking)();
            $8ec6a6735a74a56f$var$setCurrentInstance(target);
            const res = $8ec6a6735a74a56f$export$dae85862a8d94378(hook, target, type, args);
            $8ec6a6735a74a56f$var$unsetCurrentInstance();
            (0, $gGESn.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $8ec6a6735a74a56f$var$createHook = (lifecycle)=>(hook, target = $8ec6a6735a74a56f$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$8ec6a6735a74a56f$var$isInSSRComponentSetup || lifecycle === "sp") && $8ec6a6735a74a56f$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $8ec6a6735a74a56f$export$23b7aeb0d671f804 = $8ec6a6735a74a56f$var$createHook("bm");
const $8ec6a6735a74a56f$export$6d1641039221b5cb = $8ec6a6735a74a56f$var$createHook("m");
const $8ec6a6735a74a56f$export$ab91988a13872e4c = $8ec6a6735a74a56f$var$createHook("bu");
const $8ec6a6735a74a56f$export$5876c47052fb88b1 = $8ec6a6735a74a56f$var$createHook("u");
const $8ec6a6735a74a56f$export$40c420df62d2614 = $8ec6a6735a74a56f$var$createHook("bum");
const $8ec6a6735a74a56f$export$13348a43ccacfe58 = $8ec6a6735a74a56f$var$createHook("um");
const $8ec6a6735a74a56f$export$ebf0c601f267bceb = $8ec6a6735a74a56f$var$createHook("sp");
const $8ec6a6735a74a56f$export$898295a813d662eb = $8ec6a6735a74a56f$var$createHook("rtg");
const $8ec6a6735a74a56f$export$2b41f4235363e921 = $8ec6a6735a74a56f$var$createHook("rtc");
function $8ec6a6735a74a56f$export$6a3a15856e50ad19(hook, target = $8ec6a6735a74a56f$var$currentInstance) {
    $8ec6a6735a74a56f$var$injectHook("ec", hook, target);
}
const $8ec6a6735a74a56f$var$COMPONENTS = "components";
const $8ec6a6735a74a56f$var$DIRECTIVES = "directives";
function $8ec6a6735a74a56f$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $8ec6a6735a74a56f$var$resolveAsset($8ec6a6735a74a56f$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $8ec6a6735a74a56f$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $8ec6a6735a74a56f$export$b44c564a05ca975(component) {
    if ((0, $4bH2P.isString)(component)) return $8ec6a6735a74a56f$var$resolveAsset($8ec6a6735a74a56f$var$COMPONENTS, component, false) || component;
    else return component || $8ec6a6735a74a56f$var$NULL_DYNAMIC_COMPONENT;
}
function $8ec6a6735a74a56f$export$a1989e995cd481be(name) {
    return $8ec6a6735a74a56f$var$resolveAsset($8ec6a6735a74a56f$var$DIRECTIVES, name);
}
function $8ec6a6735a74a56f$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $8ec6a6735a74a56f$var$currentRenderingInstance || $8ec6a6735a74a56f$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $8ec6a6735a74a56f$var$COMPONENTS) {
            const selfName = $8ec6a6735a74a56f$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $4bH2P.camelize)(name) || selfName === (0, $4bH2P.capitalize)((0, $4bH2P.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $8ec6a6735a74a56f$var$resolve(instance[type] || Component[type], name) || // global registration
        $8ec6a6735a74a56f$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $8ec6a6735a74a56f$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $4bH2P.camelize)(name)] || registry[(0, $4bH2P.capitalize)((0, $4bH2P.camelize)(name))]);
}
function $8ec6a6735a74a56f$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $4bH2P.isArray)(source) || (0, $4bH2P.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $4bH2P.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $8ec6a6735a74a56f$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $4bH2P.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $8ec6a6735a74a56f$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($8ec6a6735a74a56f$var$currentRenderingInstance.isCE || $8ec6a6735a74a56f$var$currentRenderingInstance.parent && $8ec6a6735a74a56f$var$isAsyncWrapper($8ec6a6735a74a56f$var$currentRenderingInstance.parent) && $8ec6a6735a74a56f$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $8ec6a6735a74a56f$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $8ec6a6735a74a56f$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $8ec6a6735a74a56f$var$ensureValidVNode(slot(props));
    const rendered = $8ec6a6735a74a56f$export$9f2dfe8048dfb22b($8ec6a6735a74a56f$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $8ec6a6735a74a56f$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$8ec6a6735a74a56f$export$3868d13f8734ae81(child)) return true;
        if (child.type === $8ec6a6735a74a56f$export$4d299b491347818a) return false;
        if (child.type === $8ec6a6735a74a56f$export$ffb0004e005737fa && !$8ec6a6735a74a56f$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $8ec6a6735a74a56f$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $4bH2P.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $8ec6a6735a74a56f$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($8ec6a6735a74a56f$var$isStatefulComponent(i)) return $8ec6a6735a74a56f$var$getExposeProxy(i) || i.proxy;
    return $8ec6a6735a74a56f$var$getPublicInstance(i.parent);
};
const $8ec6a6735a74a56f$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $4bH2P.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$8ec6a6735a74a56f$var$getPublicInstance(i.parent),
    $root: (i)=>$8ec6a6735a74a56f$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $8ec6a6735a74a56f$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$8ec6a6735a74a56f$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $8ec6a6735a74a56f$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $8ec6a6735a74a56f$var$instanceWatch.bind(i) : (0, $4bH2P.NOOP)
});
const $8ec6a6735a74a56f$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $8ec6a6735a74a56f$var$hasSetupBinding = (state, key)=>state !== (0, $4bH2P.EMPTY_OBJ) && !state.__isScriptSetup && (0, $4bH2P.hasOwn)(state, key);
const $8ec6a6735a74a56f$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($8ec6a6735a74a56f$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $4bH2P.EMPTY_OBJ) && (0, $4bH2P.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $4bH2P.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $4bH2P.EMPTY_OBJ) && (0, $4bH2P.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $8ec6a6735a74a56f$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $8ec6a6735a74a56f$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $gGESn.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $4bH2P.EMPTY_OBJ) && (0, $4bH2P.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $4bH2P.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value1) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($8ec6a6735a74a56f$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value1;
            return true;
        } else {
            if (data !== (0, $4bH2P.EMPTY_OBJ) && (0, $4bH2P.hasOwn)(data, key)) {
                data[key] = value1;
                return true;
            } else if ((0, $4bH2P.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value1;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $4bH2P.EMPTY_OBJ) && (0, $4bH2P.hasOwn)(data, key) || $8ec6a6735a74a56f$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $4bH2P.hasOwn)(normalizedProps, key) || (0, $4bH2P.hasOwn)(ctx, key) || (0, $4bH2P.hasOwn)($8ec6a6735a74a56f$var$publicPropertiesMap, key) || (0, $4bH2P.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $4bH2P.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $8ec6a6735a74a56f$var$target;
const $8ec6a6735a74a56f$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $4bH2P.extend)({}, $8ec6a6735a74a56f$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $8ec6a6735a74a56f$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $4bH2P.isGloballyWhitelisted)(key);
        return has;
    }
});
function $8ec6a6735a74a56f$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($8ec6a6735a74a56f$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$8ec6a6735a74a56f$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $4bH2P.NOOP)
        });
    });
    return target;
}
function $8ec6a6735a74a56f$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $4bH2P.NOOP)
        });
    });
}
function $8ec6a6735a74a56f$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $gGESn.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($8ec6a6735a74a56f$var$isReservedPrefix(key[0])) {
                $8ec6a6735a74a56f$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $4bH2P.NOOP)
            });
        }
    });
}
const $8ec6a6735a74a56f$var$warnRuntimeUsage = (method)=>$8ec6a6735a74a56f$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $8ec6a6735a74a56f$export$80b33eababae110e() {
    return null;
}
function $8ec6a6735a74a56f$export$51ecece22fc17ddc() {
    return null;
}
function $8ec6a6735a74a56f$export$da25b65ca24b518a(exposed) {}
function $8ec6a6735a74a56f$export$77e79129327f3d0d(options) {}
function $8ec6a6735a74a56f$export$1b3acd4bb805b712() {
    return null;
}
function $8ec6a6735a74a56f$export$acd55aa037e791bb() {}
function $8ec6a6735a74a56f$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $8ec6a6735a74a56f$export$9203a8e84125433c() {
    return $8ec6a6735a74a56f$var$getContext().slots;
}
function $8ec6a6735a74a56f$export$75e29435042cd2ea() {
    return $8ec6a6735a74a56f$var$getContext().attrs;
}
function $8ec6a6735a74a56f$export$fb78bd113157f1a1(props, name, options) {
    const i = $8ec6a6735a74a56f$export$f13e630aa3915748();
    if (options && options.local) {
        const proxy = (0, $gGESn.ref)(props[name]);
        $8ec6a6735a74a56f$export$3db5d71bdb2d5499(()=>props[name], (v1)=>proxy.value = v1);
        $8ec6a6735a74a56f$export$3db5d71bdb2d5499(proxy, (value1)=>{
            if (value1 !== props[name]) i.emit(`update:${name}`, value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit(`update:${name}`, value);
        }
    };
}
function $8ec6a6735a74a56f$var$getContext() {
    const i = $8ec6a6735a74a56f$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $8ec6a6735a74a56f$var$createSetupContext(i));
}
function $8ec6a6735a74a56f$var$normalizePropsOrEmits(props) {
    return (0, $4bH2P.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $8ec6a6735a74a56f$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $8ec6a6735a74a56f$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $4bH2P.isArray)(opt) || (0, $4bH2P.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $8ec6a6735a74a56f$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $4bH2P.isArray)(a) && (0, $4bH2P.isArray)(b)) return a.concat(b);
    return (0, $4bH2P.extend)({}, $8ec6a6735a74a56f$var$normalizePropsOrEmits(a), $8ec6a6735a74a56f$var$normalizePropsOrEmits(b));
}
function $8ec6a6735a74a56f$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $8ec6a6735a74a56f$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $8ec6a6735a74a56f$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $8ec6a6735a74a56f$var$unsetCurrentInstance();
    if ((0, $4bH2P.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $8ec6a6735a74a56f$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$8ec6a6735a74a56f$var$setCurrentInstance(ctx)
    ];
}
function $8ec6a6735a74a56f$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $8ec6a6735a74a56f$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $8ec6a6735a74a56f$var$shouldCacheAccess = true;
function $8ec6a6735a74a56f$var$applyOptions(instance) {
    const options = $8ec6a6735a74a56f$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $8ec6a6735a74a56f$var$shouldCacheAccess = false;
    if (options.beforeCreate) $8ec6a6735a74a56f$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $8ec6a6735a74a56f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $4bH2P.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $4bH2P.isObject)(data)) ;
        else instance.data = (0, $gGESn.reactive)(data);
    }
    $8ec6a6735a74a56f$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $4bH2P.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $4bH2P.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $4bH2P.NOOP);
        const set = !(0, $4bH2P.isFunction)(opt) && (0, $4bH2P.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $4bH2P.NOOP);
        const c = $8ec6a6735a74a56f$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$8ec6a6735a74a56f$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $4bH2P.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $8ec6a6735a74a56f$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $8ec6a6735a74a56f$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $4bH2P.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($8ec6a6735a74a56f$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($8ec6a6735a74a56f$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($8ec6a6735a74a56f$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($8ec6a6735a74a56f$export$5876c47052fb88b1, updated);
    registerLifecycleHook($8ec6a6735a74a56f$export$ba52d824b95a2154, activated);
    registerLifecycleHook($8ec6a6735a74a56f$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($8ec6a6735a74a56f$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($8ec6a6735a74a56f$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($8ec6a6735a74a56f$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($8ec6a6735a74a56f$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($8ec6a6735a74a56f$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($8ec6a6735a74a56f$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $4bH2P.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $4bH2P.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $8ec6a6735a74a56f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $4bH2P.NOOP)) {
    if ((0, $4bH2P.isArray)(injectOptions)) injectOptions = $8ec6a6735a74a56f$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $4bH2P.isObject)(opt)) {
            if ("default" in opt) injected = $8ec6a6735a74a56f$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $8ec6a6735a74a56f$export$a976684a0efeb93f(opt.from || key);
        } else injected = $8ec6a6735a74a56f$export$a976684a0efeb93f(opt);
        if ((0, $gGESn.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $8ec6a6735a74a56f$var$callHook(hook, instance, type) {
    $8ec6a6735a74a56f$export$dae85862a8d94378((0, $4bH2P.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $8ec6a6735a74a56f$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $8ec6a6735a74a56f$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $4bH2P.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $4bH2P.isFunction)(handler)) $8ec6a6735a74a56f$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $4bH2P.isFunction)(raw)) $8ec6a6735a74a56f$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $4bH2P.isObject)(raw)) {
        if ((0, $4bH2P.isArray)(raw)) raw.forEach((r)=>$8ec6a6735a74a56f$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $4bH2P.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $4bH2P.isFunction)(handler)) $8ec6a6735a74a56f$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $8ec6a6735a74a56f$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$8ec6a6735a74a56f$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $8ec6a6735a74a56f$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $4bH2P.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $8ec6a6735a74a56f$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $8ec6a6735a74a56f$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$8ec6a6735a74a56f$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $8ec6a6735a74a56f$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $8ec6a6735a74a56f$var$internalOptionMergeStrats = {
    data: $8ec6a6735a74a56f$var$mergeDataFn,
    props: $8ec6a6735a74a56f$var$mergeEmitsOrPropsOptions,
    emits: $8ec6a6735a74a56f$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $8ec6a6735a74a56f$var$mergeObjectOptions,
    computed: $8ec6a6735a74a56f$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $8ec6a6735a74a56f$var$mergeAsArray,
    created: $8ec6a6735a74a56f$var$mergeAsArray,
    beforeMount: $8ec6a6735a74a56f$var$mergeAsArray,
    mounted: $8ec6a6735a74a56f$var$mergeAsArray,
    beforeUpdate: $8ec6a6735a74a56f$var$mergeAsArray,
    updated: $8ec6a6735a74a56f$var$mergeAsArray,
    beforeDestroy: $8ec6a6735a74a56f$var$mergeAsArray,
    beforeUnmount: $8ec6a6735a74a56f$var$mergeAsArray,
    destroyed: $8ec6a6735a74a56f$var$mergeAsArray,
    unmounted: $8ec6a6735a74a56f$var$mergeAsArray,
    activated: $8ec6a6735a74a56f$var$mergeAsArray,
    deactivated: $8ec6a6735a74a56f$var$mergeAsArray,
    errorCaptured: $8ec6a6735a74a56f$var$mergeAsArray,
    serverPrefetch: $8ec6a6735a74a56f$var$mergeAsArray,
    // assets
    components: $8ec6a6735a74a56f$var$mergeObjectOptions,
    directives: $8ec6a6735a74a56f$var$mergeObjectOptions,
    // watch
    watch: $8ec6a6735a74a56f$var$mergeWatchOptions,
    // provide / inject
    provide: $8ec6a6735a74a56f$var$mergeDataFn,
    inject: $8ec6a6735a74a56f$var$mergeInject
};
function $8ec6a6735a74a56f$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $4bH2P.extend)((0, $4bH2P.isFunction)(to) ? to.call(this, this) : to, (0, $4bH2P.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $8ec6a6735a74a56f$var$mergeInject(to, from) {
    return $8ec6a6735a74a56f$var$mergeObjectOptions($8ec6a6735a74a56f$var$normalizeInject(to), $8ec6a6735a74a56f$var$normalizeInject(from));
}
function $8ec6a6735a74a56f$var$normalizeInject(raw) {
    if ((0, $4bH2P.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $8ec6a6735a74a56f$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $8ec6a6735a74a56f$var$mergeObjectOptions(to, from) {
    return to ? (0, $4bH2P.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $8ec6a6735a74a56f$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $4bH2P.isArray)(to) && (0, $4bH2P.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $4bH2P.extend)(/* @__PURE__ */ Object.create(null), $8ec6a6735a74a56f$var$normalizePropsOrEmits(to), $8ec6a6735a74a56f$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $8ec6a6735a74a56f$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $4bH2P.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $8ec6a6735a74a56f$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $8ec6a6735a74a56f$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $4bH2P.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $8ec6a6735a74a56f$var$uid$1 = 0;
function $8ec6a6735a74a56f$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $4bH2P.isFunction)(rootComponent)) rootComponent = (0, $4bH2P.extend)({}, rootComponent);
        if (rootProps != null && !(0, $4bH2P.isObject)(rootProps)) rootProps = null;
        const context = $8ec6a6735a74a56f$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $8ec6a6735a74a56f$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $8ec6a6735a74a56f$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $4bH2P.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $4bH2P.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $8ec6a6735a74a56f$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $8ec6a6735a74a56f$var$devtoolsInitApp(app, $8ec6a6735a74a56f$export$83d89fbfd8236492);
                    }
                    return $8ec6a6735a74a56f$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $8ec6a6735a74a56f$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext (fn) {
                $8ec6a6735a74a56f$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $8ec6a6735a74a56f$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
let $8ec6a6735a74a56f$var$currentApp = null;
function $8ec6a6735a74a56f$export$abe1e183e22e10ad(key, value1) {
    if (!$8ec6a6735a74a56f$var$currentInstance) ;
    else {
        let provides = $8ec6a6735a74a56f$var$currentInstance.provides;
        const parentProvides = $8ec6a6735a74a56f$var$currentInstance.parent && $8ec6a6735a74a56f$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $8ec6a6735a74a56f$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $8ec6a6735a74a56f$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $8ec6a6735a74a56f$var$currentInstance || $8ec6a6735a74a56f$var$currentRenderingInstance;
    if (instance || $8ec6a6735a74a56f$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $8ec6a6735a74a56f$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $4bH2P.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $8ec6a6735a74a56f$export$caf6761f24fc571a() {
    return !!($8ec6a6735a74a56f$var$currentInstance || $8ec6a6735a74a56f$var$currentRenderingInstance || $8ec6a6735a74a56f$var$currentApp);
}
function $8ec6a6735a74a56f$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $4bH2P.def)(attrs, $8ec6a6735a74a56f$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $8ec6a6735a74a56f$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $gGESn.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $8ec6a6735a74a56f$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $8ec6a6735a74a56f$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $gGESn.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($8ec6a6735a74a56f$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value1 = rawProps[key];
                if (options) {
                    if ((0, $4bH2P.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $4bH2P.camelize)(key);
                        props[camelizedKey] = $8ec6a6735a74a56f$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($8ec6a6735a74a56f$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $4bH2P.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $4bH2P.hyphenate)(key)) === key || !(0, $4bH2P.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $8ec6a6735a74a56f$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $4bH2P.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $gGESn.trigger)(instance, "set", "$attrs");
}
function $8ec6a6735a74a56f$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $4bH2P.isReservedProp)(key)) continue;
        const value1 = rawProps[key];
        let camelKey;
        if (options && (0, $4bH2P.hasOwn)(options, camelKey = (0, $4bH2P.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$8ec6a6735a74a56f$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $gGESn.toRaw)(props);
        const castValues = rawCastValues || (0, $4bH2P.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $8ec6a6735a74a56f$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $4bH2P.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $8ec6a6735a74a56f$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $4bH2P.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $4bH2P.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $8ec6a6735a74a56f$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $8ec6a6735a74a56f$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $4bH2P.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $8ec6a6735a74a56f$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $4bH2P.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $8ec6a6735a74a56f$var$normalizePropsOptions(raw2, appContext, true);
            (0, $4bH2P.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $4bH2P.isObject)(comp)) cache.set(comp, (0, $4bH2P.EMPTY_ARR));
        return 0, $4bH2P.EMPTY_ARR;
    }
    if ((0, $4bH2P.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $4bH2P.camelize)(raw[i]);
        if ($8ec6a6735a74a56f$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $4bH2P.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $4bH2P.camelize)(key);
        if ($8ec6a6735a74a56f$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $4bH2P.isArray)(opt) || (0, $4bH2P.isFunction)(opt) ? {
                type: opt
            } : (0, $4bH2P.extend)({}, opt);
            if (prop) {
                const booleanIndex = $8ec6a6735a74a56f$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $8ec6a6735a74a56f$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $4bH2P.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $4bH2P.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $8ec6a6735a74a56f$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $8ec6a6735a74a56f$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $8ec6a6735a74a56f$var$isSameType(a, b) {
    return $8ec6a6735a74a56f$var$getType(a) === $8ec6a6735a74a56f$var$getType(b);
}
function $8ec6a6735a74a56f$var$getTypeIndex(type, expectedTypes) {
    if ((0, $4bH2P.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$8ec6a6735a74a56f$var$isSameType(t, type));
    else if ((0, $4bH2P.isFunction)(expectedTypes)) return $8ec6a6735a74a56f$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $8ec6a6735a74a56f$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $gGESn.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $8ec6a6735a74a56f$var$validateProp(key, resolvedValues[key], opt, !(0, $4bH2P.hasOwn)(rawProps, key) && !(0, $4bH2P.hasOwn)(rawProps, (0, $4bH2P.hyphenate)(key)));
    }
}
function $8ec6a6735a74a56f$var$validateProp(name, value1, prop, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $8ec6a6735a74a56f$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $4bH2P.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $8ec6a6735a74a56f$var$assertType(value1, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $8ec6a6735a74a56f$export$c106dd0671a0fc2d($8ec6a6735a74a56f$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $8ec6a6735a74a56f$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $8ec6a6735a74a56f$var$isSimpleType = /* @__PURE__ */ (0, $4bH2P.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $8ec6a6735a74a56f$var$assertType(value1, type) {
    let valid;
    const expectedType = $8ec6a6735a74a56f$var$getType(type);
    if ($8ec6a6735a74a56f$var$isSimpleType(expectedType)) {
        const t = typeof value1;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $4bH2P.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $4bH2P.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $8ec6a6735a74a56f$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $4bH2P.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $4bH2P.toRawType)(value1);
    const expectedValue = $8ec6a6735a74a56f$var$styleValue(value1, expectedType);
    const receivedValue = $8ec6a6735a74a56f$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $8ec6a6735a74a56f$var$isExplicable(expectedType) && !$8ec6a6735a74a56f$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($8ec6a6735a74a56f$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $8ec6a6735a74a56f$var$styleValue(value1, type) {
    if (type === "String") return `"${value1}"`;
    else if (type === "Number") return `${Number(value1)}`;
    else return `${value1}`;
}
function $8ec6a6735a74a56f$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $8ec6a6735a74a56f$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $8ec6a6735a74a56f$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $8ec6a6735a74a56f$var$normalizeSlotValue = (value1)=>(0, $4bH2P.isArray)(value1) ? value1.map($8ec6a6735a74a56f$var$normalizeVNode) : [
        $8ec6a6735a74a56f$var$normalizeVNode(value1)
    ];
const $8ec6a6735a74a56f$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $8ec6a6735a74a56f$export$694b237e827a3d23((...args)=>{
        return $8ec6a6735a74a56f$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $8ec6a6735a74a56f$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($8ec6a6735a74a56f$var$isInternalKey(key)) continue;
        const value1 = rawSlots[key];
        if ((0, $4bH2P.isFunction)(value1)) slots[key] = $8ec6a6735a74a56f$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            const normalized = $8ec6a6735a74a56f$var$normalizeSlotValue(value1);
            slots[key] = ()=>normalized;
        }
    }
};
const $8ec6a6735a74a56f$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $8ec6a6735a74a56f$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $8ec6a6735a74a56f$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $gGESn.toRaw)(children);
            (0, $4bH2P.def)(children, "_", type);
        } else $8ec6a6735a74a56f$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $8ec6a6735a74a56f$var$normalizeVNodeSlots(instance, children);
    }
    (0, $4bH2P.def)(instance.slots, $8ec6a6735a74a56f$var$InternalObjectKey, 1);
};
const $8ec6a6735a74a56f$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $4bH2P.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $4bH2P.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $8ec6a6735a74a56f$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $8ec6a6735a74a56f$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$8ec6a6735a74a56f$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $8ec6a6735a74a56f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $4bH2P.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$8ec6a6735a74a56f$var$setRef(r, oldRawRef && ((0, $4bH2P.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($8ec6a6735a74a56f$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $8ec6a6735a74a56f$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value1 = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $4bH2P.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $4bH2P.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $4bH2P.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $gGESn.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $4bH2P.isFunction)(ref)) $8ec6a6735a74a56f$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        const _isString = (0, $4bH2P.isString)(ref);
        const _isRef = (0, $gGESn.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $4bH2P.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $4bH2P.isArray)(existing) && (0, $4bH2P.remove)(existing, refValue);
                    else {
                        if (!(0, $4bH2P.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $4bH2P.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $4bH2P.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $8ec6a6735a74a56f$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $8ec6a6735a74a56f$var$hasMismatch = false;
const $8ec6a6735a74a56f$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $8ec6a6735a74a56f$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $8ec6a6735a74a56f$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $8ec6a6735a74a56f$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $8ec6a6735a74a56f$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $8ec6a6735a74a56f$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($8ec6a6735a74a56f$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $8ec6a6735a74a56f$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $8ec6a6735a74a56f$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $8ec6a6735a74a56f$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $8ec6a6735a74a56f$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $8ec6a6735a74a56f$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $8ec6a6735a74a56f$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $8ec6a6735a74a56f$var$isSVGContainer(container), optimized);
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    if (nextNode && $8ec6a6735a74a56f$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    if ($8ec6a6735a74a56f$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $8ec6a6735a74a56f$export$22f9b5ffd89dac9("") : $8ec6a6735a74a56f$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $8ec6a6735a74a56f$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $8ec6a6735a74a56f$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        const forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $4bH2P.isOn)(key) && !(0, $4bH2P.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $8ec6a6735a74a56f$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $8ec6a6735a74a56f$var$hasMismatch = true;
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $8ec6a6735a74a56f$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $8ec6a6735a74a56f$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $8ec6a6735a74a56f$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $8ec6a6735a74a56f$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $8ec6a6735a74a56f$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $8ec6a6735a74a56f$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $8ec6a6735a74a56f$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $8ec6a6735a74a56f$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $8ec6a6735a74a56f$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $8ec6a6735a74a56f$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
let $8ec6a6735a74a56f$var$supported;
let $8ec6a6735a74a56f$var$perf;
function $8ec6a6735a74a56f$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $8ec6a6735a74a56f$var$isSupported()) $8ec6a6735a74a56f$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsPerfStart(instance, type, $8ec6a6735a74a56f$var$isSupported() ? $8ec6a6735a74a56f$var$perf.now() : Date.now());
}
function $8ec6a6735a74a56f$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $8ec6a6735a74a56f$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $8ec6a6735a74a56f$var$perf.mark(endTag);
        $8ec6a6735a74a56f$var$perf.measure(`<${$8ec6a6735a74a56f$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $8ec6a6735a74a56f$var$perf.clearMarks(startTag);
        $8ec6a6735a74a56f$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsPerfEnd(instance, type, $8ec6a6735a74a56f$var$isSupported() ? $8ec6a6735a74a56f$var$perf.now() : Date.now());
}
function $8ec6a6735a74a56f$var$isSupported() {
    if ($8ec6a6735a74a56f$var$supported !== void 0) return $8ec6a6735a74a56f$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $8ec6a6735a74a56f$var$supported = true;
        $8ec6a6735a74a56f$var$perf = window.performance;
    } else $8ec6a6735a74a56f$var$supported = false;
    return $8ec6a6735a74a56f$var$supported;
}
function $8ec6a6735a74a56f$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $4bH2P.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $4bH2P.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $8ec6a6735a74a56f$var$queuePostRenderEffect = $8ec6a6735a74a56f$var$queueEffectWithSuspense;
function $8ec6a6735a74a56f$export$53ae2f996c64e9a(options) {
    return $8ec6a6735a74a56f$var$baseCreateRenderer(options);
}
function $8ec6a6735a74a56f$export$200524cf0d997ff0(options) {
    return $8ec6a6735a74a56f$var$baseCreateRenderer(options, $8ec6a6735a74a56f$var$createHydrationFunctions);
}
function $8ec6a6735a74a56f$var$baseCreateRenderer(options, createHydrationFns) {
    $8ec6a6735a74a56f$var$initFeatureFlags();
    const target = (0, $4bH2P.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $4bH2P.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$8ec6a6735a74a56f$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $8ec6a6735a74a56f$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $8ec6a6735a74a56f$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $8ec6a6735a74a56f$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $8ec6a6735a74a56f$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $8ec6a6735a74a56f$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, isSVG)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $4bH2P.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>{
            vnodeHook && $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $8ec6a6735a74a56f$var$cloneIfMounted(children[i]) : $8ec6a6735a74a56f$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $4bH2P.EMPTY_OBJ);
        const newProps = n2.props || (0, $4bH2P.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $8ec6a6735a74a56f$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $8ec6a6735a74a56f$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $8ec6a6735a74a56f$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>{
            vnodeHook && $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $8ec6a6735a74a56f$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $8ec6a6735a74a56f$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$8ec6a6735a74a56f$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $4bH2P.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $4bH2P.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $4bH2P.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $8ec6a6735a74a56f$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $8ec6a6735a74a56f$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($8ec6a6735a74a56f$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $8ec6a6735a74a56f$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($8ec6a6735a74a56f$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $8ec6a6735a74a56f$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $8ec6a6735a74a56f$var$isAsyncWrapper(initialVNode);
                $8ec6a6735a74a56f$var$toggleRecurse(instance, false);
                if (bm) (0, $4bH2P.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $8ec6a6735a74a56f$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $8ec6a6735a74a56f$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $8ec6a6735a74a56f$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $8ec6a6735a74a56f$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>$8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $8ec6a6735a74a56f$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $8ec6a6735a74a56f$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                $8ec6a6735a74a56f$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $4bH2P.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $8ec6a6735a74a56f$var$toggleRecurse(instance, true);
                const nextTree = $8ec6a6735a74a56f$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $8ec6a6735a74a56f$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $8ec6a6735a74a56f$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>$8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $gGESn.ReactiveEffect)(componentUpdateFn, ()=>$8ec6a6735a74a56f$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        $8ec6a6735a74a56f$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $8ec6a6735a74a56f$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $8ec6a6735a74a56f$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $gGESn.pauseTracking)();
        $8ec6a6735a74a56f$var$flushPreFlushCbs();
        (0, $gGESn.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $4bH2P.EMPTY_ARR);
        c2 = c2 || (0, $4bH2P.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $8ec6a6735a74a56f$var$cloneIfMounted(c2[i]) : $8ec6a6735a74a56f$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $8ec6a6735a74a56f$var$cloneIfMounted(c2[i]) : $8ec6a6735a74a56f$var$normalizeVNode(c2[i]);
            if ($8ec6a6735a74a56f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $8ec6a6735a74a56f$var$cloneIfMounted(c2[e2]) : $8ec6a6735a74a56f$var$normalizeVNode(c2[e2]);
            if ($8ec6a6735a74a56f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $8ec6a6735a74a56f$var$cloneIfMounted(c2[i]) : $8ec6a6735a74a56f$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $8ec6a6735a74a56f$var$cloneIfMounted(c2[i]) : $8ec6a6735a74a56f$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $8ec6a6735a74a56f$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $8ec6a6735a74a56f$var$getSequence(newIndexToOldIndexMap) : (0, $4bH2P.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $8ec6a6735a74a56f$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $8ec6a6735a74a56f$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $8ec6a6735a74a56f$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$8ec6a6735a74a56f$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $8ec6a6735a74a56f$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $8ec6a6735a74a56f$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>{
            vnodeHook && $8ec6a6735a74a56f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $8ec6a6735a74a56f$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $8ec6a6735a74a56f$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $8ec6a6735a74a56f$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $4bH2P.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $8ec6a6735a74a56f$var$queuePostRenderEffect(um, parentSuspense);
        $8ec6a6735a74a56f$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $8ec6a6735a74a56f$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $8ec6a6735a74a56f$var$flushPreFlushCbs();
        $8ec6a6735a74a56f$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $8ec6a6735a74a56f$var$createAppAPI(render, hydrate)
    };
}
function $8ec6a6735a74a56f$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $8ec6a6735a74a56f$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $4bH2P.isArray)(ch1) && (0, $4bH2P.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $8ec6a6735a74a56f$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $8ec6a6735a74a56f$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $8ec6a6735a74a56f$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $8ec6a6735a74a56f$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $8ec6a6735a74a56f$var$isTeleport = (type)=>type.__isTeleport;
const $8ec6a6735a74a56f$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $8ec6a6735a74a56f$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $8ec6a6735a74a56f$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $4bH2P.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $8ec6a6735a74a56f$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $8ec6a6735a74a56f$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $8ec6a6735a74a56f$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $8ec6a6735a74a56f$var$isTargetSVG(target);
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $8ec6a6735a74a56f$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $8ec6a6735a74a56f$var$isTargetSVG(target);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $8ec6a6735a74a56f$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $8ec6a6735a74a56f$var$moveTeleport(n2, container, mainAnchor, internals, 1);
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $8ec6a6735a74a56f$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $8ec6a6735a74a56f$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $8ec6a6735a74a56f$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $8ec6a6735a74a56f$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        if (doRemove || !$8ec6a6735a74a56f$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $8ec6a6735a74a56f$var$moveTeleport,
    hydrate: $8ec6a6735a74a56f$var$hydrateTeleport
};
function $8ec6a6735a74a56f$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $8ec6a6735a74a56f$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $8ec6a6735a74a56f$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $8ec6a6735a74a56f$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($8ec6a6735a74a56f$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $8ec6a6735a74a56f$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $8ec6a6735a74a56f$export$76d55a0304a371f4 = $8ec6a6735a74a56f$var$TeleportImpl;
function $8ec6a6735a74a56f$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $8ec6a6735a74a56f$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $8ec6a6735a74a56f$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $8ec6a6735a74a56f$export$4d299b491347818a = Symbol.for("v-cmt");
const $8ec6a6735a74a56f$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $8ec6a6735a74a56f$var$blockStack = [];
let $8ec6a6735a74a56f$var$currentBlock = null;
function $8ec6a6735a74a56f$export$e7eaa45e502fe5cc(disableTracking = false) {
    $8ec6a6735a74a56f$var$blockStack.push($8ec6a6735a74a56f$var$currentBlock = disableTracking ? null : []);
}
function $8ec6a6735a74a56f$var$closeBlock() {
    $8ec6a6735a74a56f$var$blockStack.pop();
    $8ec6a6735a74a56f$var$currentBlock = $8ec6a6735a74a56f$var$blockStack[$8ec6a6735a74a56f$var$blockStack.length - 1] || null;
}
let $8ec6a6735a74a56f$var$isBlockTreeEnabled = 1;
function $8ec6a6735a74a56f$export$c20bee82f26f1e27(value1) {
    $8ec6a6735a74a56f$var$isBlockTreeEnabled += value1;
}
function $8ec6a6735a74a56f$var$setupBlock(vnode) {
    vnode.dynamicChildren = $8ec6a6735a74a56f$var$isBlockTreeEnabled > 0 ? $8ec6a6735a74a56f$var$currentBlock || (0, $4bH2P.EMPTY_ARR) : null;
    $8ec6a6735a74a56f$var$closeBlock();
    if ($8ec6a6735a74a56f$var$isBlockTreeEnabled > 0 && $8ec6a6735a74a56f$var$currentBlock) $8ec6a6735a74a56f$var$currentBlock.push(vnode);
    return vnode;
}
function $8ec6a6735a74a56f$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $8ec6a6735a74a56f$var$setupBlock($8ec6a6735a74a56f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $8ec6a6735a74a56f$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $8ec6a6735a74a56f$var$setupBlock($8ec6a6735a74a56f$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $8ec6a6735a74a56f$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $8ec6a6735a74a56f$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $8ec6a6735a74a56f$var$vnodeArgsTransformer;
function $8ec6a6735a74a56f$export$83beccd3afeeb809(transformer) {
    $8ec6a6735a74a56f$var$vnodeArgsTransformer = transformer;
}
const $8ec6a6735a74a56f$var$createVNodeWithArgsTransform = (...args)=>{
    return $8ec6a6735a74a56f$var$_createVNode(...$8ec6a6735a74a56f$var$vnodeArgsTransformer ? $8ec6a6735a74a56f$var$vnodeArgsTransformer(args, $8ec6a6735a74a56f$var$currentRenderingInstance) : args);
};
const $8ec6a6735a74a56f$var$InternalObjectKey = `__vInternal`;
const $8ec6a6735a74a56f$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $8ec6a6735a74a56f$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $4bH2P.isString)(ref) || (0, $gGESn.isRef)(ref) || (0, $4bH2P.isFunction)(ref) ? {
        i: $8ec6a6735a74a56f$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $8ec6a6735a74a56f$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $8ec6a6735a74a56f$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $8ec6a6735a74a56f$var$normalizeKey(props),
        ref: props && $8ec6a6735a74a56f$var$normalizeRef(props),
        scopeId: $8ec6a6735a74a56f$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $8ec6a6735a74a56f$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $8ec6a6735a74a56f$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $4bH2P.isString)(children) ? 8 : 16;
    if ($8ec6a6735a74a56f$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $8ec6a6735a74a56f$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $8ec6a6735a74a56f$var$currentBlock.push(vnode);
    return vnode;
}
const $8ec6a6735a74a56f$export$bf5c4cf060303d58 = $8ec6a6735a74a56f$var$_createVNode;
function $8ec6a6735a74a56f$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $8ec6a6735a74a56f$var$NULL_DYNAMIC_COMPONENT) type = $8ec6a6735a74a56f$export$4d299b491347818a;
    if ($8ec6a6735a74a56f$export$3868d13f8734ae81(type)) {
        const cloned = $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $8ec6a6735a74a56f$var$normalizeChildren(cloned, children);
        if ($8ec6a6735a74a56f$var$isBlockTreeEnabled > 0 && !isBlockNode && $8ec6a6735a74a56f$var$currentBlock) {
            if (cloned.shapeFlag & 6) $8ec6a6735a74a56f$var$currentBlock[$8ec6a6735a74a56f$var$currentBlock.indexOf(type)] = cloned;
            else $8ec6a6735a74a56f$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($8ec6a6735a74a56f$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $8ec6a6735a74a56f$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $4bH2P.isString)(klass)) props.class = (0, $4bH2P.normalizeClass)(klass);
        if ((0, $4bH2P.isObject)(style)) {
            if ((0, $gGESn.isProxy)(style) && !(0, $4bH2P.isArray)(style)) style = (0, $4bH2P.extend)({}, style);
            props.style = (0, $4bH2P.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $4bH2P.isString)(type) ? 1 : $8ec6a6735a74a56f$var$isSuspense(type) ? 128 : $8ec6a6735a74a56f$var$isTeleport(type) ? 64 : (0, $4bH2P.isObject)(type) ? 4 : (0, $4bH2P.isFunction)(type) ? 2 : 0;
    return $8ec6a6735a74a56f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $8ec6a6735a74a56f$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $gGESn.isProxy)(props) || $8ec6a6735a74a56f$var$InternalObjectKey in props ? (0, $4bH2P.extend)({}, props) : props;
}
function $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $8ec6a6735a74a56f$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $8ec6a6735a74a56f$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $4bH2P.isArray)(ref) ? ref.concat($8ec6a6735a74a56f$var$normalizeRef(extraProps)) : [
            ref,
            $8ec6a6735a74a56f$var$normalizeRef(extraProps)
        ] : $8ec6a6735a74a56f$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $8ec6a6735a74a56f$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $8ec6a6735a74a56f$var$deepCloneVNode(vnode) {
    const cloned = $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $4bH2P.isArray)(vnode.children)) cloned.children = vnode.children.map($8ec6a6735a74a56f$var$deepCloneVNode);
    return cloned;
}
function $8ec6a6735a74a56f$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$5f1af8db9871e1d6, null, text, flag);
}
function $8ec6a6735a74a56f$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $8ec6a6735a74a56f$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($8ec6a6735a74a56f$export$e7eaa45e502fe5cc(), $8ec6a6735a74a56f$export$9f2dfe8048dfb22b($8ec6a6735a74a56f$export$4d299b491347818a, null, text)) : $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$4d299b491347818a, null, text);
}
function $8ec6a6735a74a56f$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$4d299b491347818a);
    else if ((0, $4bH2P.isArray)(child)) return $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $8ec6a6735a74a56f$var$cloneIfMounted(child);
    else return $8ec6a6735a74a56f$export$bf5c4cf060303d58($8ec6a6735a74a56f$export$5f1af8db9871e1d6, null, String(child));
}
function $8ec6a6735a74a56f$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $8ec6a6735a74a56f$export$ee4f9e12c0a92a1a(child);
}
function $8ec6a6735a74a56f$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $4bH2P.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $8ec6a6735a74a56f$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($8ec6a6735a74a56f$var$InternalObjectKey in children)) children._ctx = $8ec6a6735a74a56f$var$currentRenderingInstance;
            else if (slotFlag === 3 && $8ec6a6735a74a56f$var$currentRenderingInstance) {
                if ($8ec6a6735a74a56f$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $4bH2P.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $8ec6a6735a74a56f$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $8ec6a6735a74a56f$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $8ec6a6735a74a56f$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $4bH2P.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $4bH2P.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $4bH2P.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $4bH2P.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $8ec6a6735a74a56f$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $8ec6a6735a74a56f$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $8ec6a6735a74a56f$var$emptyAppContext = $8ec6a6735a74a56f$var$createAppContext();
let $8ec6a6735a74a56f$var$uid = 0;
function $8ec6a6735a74a56f$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $8ec6a6735a74a56f$var$emptyAppContext;
    const instance = {
        uid: $8ec6a6735a74a56f$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $gGESn.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $8ec6a6735a74a56f$var$normalizePropsOptions(type, appContext),
        emitsOptions: $8ec6a6735a74a56f$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $4bH2P.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $4bH2P.EMPTY_OBJ),
        data: (0, $4bH2P.EMPTY_OBJ),
        props: (0, $4bH2P.EMPTY_OBJ),
        attrs: (0, $4bH2P.EMPTY_OBJ),
        slots: (0, $4bH2P.EMPTY_OBJ),
        refs: (0, $4bH2P.EMPTY_OBJ),
        setupState: (0, $4bH2P.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $8ec6a6735a74a56f$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $8ec6a6735a74a56f$var$currentInstance = null;
const $8ec6a6735a74a56f$export$f13e630aa3915748 = ()=>$8ec6a6735a74a56f$var$currentInstance || $8ec6a6735a74a56f$var$currentRenderingInstance;
let $8ec6a6735a74a56f$var$internalSetCurrentInstance;
let $8ec6a6735a74a56f$var$globalCurrentInstanceSetters;
let $8ec6a6735a74a56f$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($8ec6a6735a74a56f$var$globalCurrentInstanceSetters = (0, $4bH2P.getGlobalThis)()[$8ec6a6735a74a56f$var$settersKey])) $8ec6a6735a74a56f$var$globalCurrentInstanceSetters = (0, $4bH2P.getGlobalThis)()[$8ec6a6735a74a56f$var$settersKey] = [];
$8ec6a6735a74a56f$var$globalCurrentInstanceSetters.push((i)=>$8ec6a6735a74a56f$var$currentInstance = i);
$8ec6a6735a74a56f$var$internalSetCurrentInstance = (instance)=>{
    if ($8ec6a6735a74a56f$var$globalCurrentInstanceSetters.length > 1) $8ec6a6735a74a56f$var$globalCurrentInstanceSetters.forEach((s)=>s(instance));
    else $8ec6a6735a74a56f$var$globalCurrentInstanceSetters[0](instance);
};
const $8ec6a6735a74a56f$var$setCurrentInstance = (instance)=>{
    $8ec6a6735a74a56f$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
const $8ec6a6735a74a56f$var$unsetCurrentInstance = ()=>{
    $8ec6a6735a74a56f$var$currentInstance && $8ec6a6735a74a56f$var$currentInstance.scope.off();
    $8ec6a6735a74a56f$var$internalSetCurrentInstance(null);
};
const $8ec6a6735a74a56f$var$isBuiltInTag = /* @__PURE__ */ (0, $4bH2P.makeMap)("slot,component");
function $8ec6a6735a74a56f$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $4bH2P.NO);
    if ($8ec6a6735a74a56f$var$isBuiltInTag(name) || appIsNativeTag(name)) $8ec6a6735a74a56f$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $8ec6a6735a74a56f$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $8ec6a6735a74a56f$var$isInSSRComponentSetup = false;
function $8ec6a6735a74a56f$var$setupComponent(instance, isSSR = false) {
    $8ec6a6735a74a56f$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $8ec6a6735a74a56f$var$isStatefulComponent(instance);
    $8ec6a6735a74a56f$var$initProps(instance, props, isStateful, isSSR);
    $8ec6a6735a74a56f$var$initSlots(instance, children);
    const setupResult = isStateful ? $8ec6a6735a74a56f$var$setupStatefulComponent(instance, isSSR) : void 0;
    $8ec6a6735a74a56f$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $8ec6a6735a74a56f$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $gGESn.markRaw)(new Proxy(instance.ctx, $8ec6a6735a74a56f$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $8ec6a6735a74a56f$var$createSetupContext(instance) : null;
        $8ec6a6735a74a56f$var$setCurrentInstance(instance);
        (0, $gGESn.pauseTracking)();
        const setupResult = $8ec6a6735a74a56f$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $gGESn.resetTracking)();
        $8ec6a6735a74a56f$var$unsetCurrentInstance();
        if ((0, $4bH2P.isPromise)(setupResult)) {
            setupResult.then($8ec6a6735a74a56f$var$unsetCurrentInstance, $8ec6a6735a74a56f$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $8ec6a6735a74a56f$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $8ec6a6735a74a56f$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $8ec6a6735a74a56f$var$handleSetupResult(instance, setupResult, isSSR);
    } else $8ec6a6735a74a56f$var$finishComponentSetup(instance, isSSR);
}
function $8ec6a6735a74a56f$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $4bH2P.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $4bH2P.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $gGESn.proxyRefs)(setupResult);
    }
    $8ec6a6735a74a56f$var$finishComponentSetup(instance, isSSR);
}
let $8ec6a6735a74a56f$var$compile;
let $8ec6a6735a74a56f$var$installWithProxy;
function $8ec6a6735a74a56f$export$667bb5a67822b941(_compile) {
    $8ec6a6735a74a56f$var$compile = _compile;
    $8ec6a6735a74a56f$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $8ec6a6735a74a56f$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $8ec6a6735a74a56f$export$c93a9c496c5211fa = ()=>!$8ec6a6735a74a56f$var$compile;
function $8ec6a6735a74a56f$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $8ec6a6735a74a56f$var$compile && !Component.render) {
            const template = Component.template || $8ec6a6735a74a56f$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $4bH2P.extend)((0, $4bH2P.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $8ec6a6735a74a56f$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $4bH2P.NOOP);
        if ($8ec6a6735a74a56f$var$installWithProxy) $8ec6a6735a74a56f$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $8ec6a6735a74a56f$var$setCurrentInstance(instance);
        (0, $gGESn.pauseTracking)();
        $8ec6a6735a74a56f$var$applyOptions(instance);
        (0, $gGESn.resetTracking)();
        $8ec6a6735a74a56f$var$unsetCurrentInstance();
    }
}
function $8ec6a6735a74a56f$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $gGESn.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $8ec6a6735a74a56f$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $gGESn.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $8ec6a6735a74a56f$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $8ec6a6735a74a56f$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $8ec6a6735a74a56f$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $gGESn.proxyRefs)((0, $gGESn.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $8ec6a6735a74a56f$var$publicPropertiesMap) return $8ec6a6735a74a56f$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $8ec6a6735a74a56f$var$publicPropertiesMap;
        }
    }));
}
const $8ec6a6735a74a56f$var$classifyRE = /(?:^|[-_])(\w)/g;
const $8ec6a6735a74a56f$var$classify = (str)=>str.replace($8ec6a6735a74a56f$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $8ec6a6735a74a56f$var$getComponentName(Component, includeInferred = true) {
    return (0, $4bH2P.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $8ec6a6735a74a56f$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $8ec6a6735a74a56f$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $8ec6a6735a74a56f$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $8ec6a6735a74a56f$var$isClassComponent(value1) {
    return (0, $4bH2P.isFunction)(value1) && "__vccOpts" in value1;
}
const $8ec6a6735a74a56f$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $gGESn.computed)(getterOrOptions, debugOptions, $8ec6a6735a74a56f$var$isInSSRComponentSetup);
};
function $8ec6a6735a74a56f$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $4bH2P.isObject)(propsOrChildren) && !(0, $4bH2P.isArray)(propsOrChildren)) {
            if ($8ec6a6735a74a56f$export$3868d13f8734ae81(propsOrChildren)) return $8ec6a6735a74a56f$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $8ec6a6735a74a56f$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $8ec6a6735a74a56f$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $8ec6a6735a74a56f$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $8ec6a6735a74a56f$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $8ec6a6735a74a56f$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $8ec6a6735a74a56f$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $8ec6a6735a74a56f$export$a976684a0efeb93f($8ec6a6735a74a56f$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $8ec6a6735a74a56f$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $8ec6a6735a74a56f$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $gGESn.toRaw)(instance.props)));
        if (instance.setupState !== (0, $4bH2P.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $4bH2P.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $gGESn.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $4bH2P.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $4bH2P.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $gGESn.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $4bH2P.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $4bH2P.isArray)(opts) && opts.includes(key) || (0, $4bH2P.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($8ec6a6735a74a56f$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $8ec6a6735a74a56f$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $8ec6a6735a74a56f$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $8ec6a6735a74a56f$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $4bH2P.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($8ec6a6735a74a56f$var$isBlockTreeEnabled > 0 && $8ec6a6735a74a56f$var$currentBlock) $8ec6a6735a74a56f$var$currentBlock.push(cached);
    return true;
}
const $8ec6a6735a74a56f$export$83d89fbfd8236492 = "3.3.4";
const $8ec6a6735a74a56f$var$_ssrUtils = {
    createComponentInstance: $8ec6a6735a74a56f$var$createComponentInstance,
    setupComponent: $8ec6a6735a74a56f$var$setupComponent,
    renderComponentRoot: $8ec6a6735a74a56f$var$renderComponentRoot,
    setCurrentRenderingInstance: $8ec6a6735a74a56f$var$setCurrentRenderingInstance,
    isVNode: $8ec6a6735a74a56f$export$3868d13f8734ae81,
    normalizeVNode: $8ec6a6735a74a56f$var$normalizeVNode
};
const $8ec6a6735a74a56f$export$a9679033567b336d = $8ec6a6735a74a56f$var$_ssrUtils;
const $8ec6a6735a74a56f$export$83cf26e06ea620e1 = null;
const $8ec6a6735a74a56f$export$dc678eddf276286e = null;

});
parcelRequire.register("gGESn", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $c26046b24d013f59$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $c26046b24d013f59$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $c26046b24d013f59$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "onScopeDispose", function () { return $c26046b24d013f59$export$a780418acd4762da; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $c26046b24d013f59$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $c26046b24d013f59$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $c26046b24d013f59$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $c26046b24d013f59$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $c26046b24d013f59$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $c26046b24d013f59$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $c26046b24d013f59$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $c26046b24d013f59$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $c26046b24d013f59$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $c26046b24d013f59$export$8d81cefd22d22260; });
$parcel$export(module.exports, "shallowReadonly", function () { return $c26046b24d013f59$export$7c4b5f2b50f09f6b; });
$parcel$export(module.exports, "isReactive", function () { return $c26046b24d013f59$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $c26046b24d013f59$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $c26046b24d013f59$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $c26046b24d013f59$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $c26046b24d013f59$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "unref", function () { return $c26046b24d013f59$export$a239a76781616204; });
$parcel$export(module.exports, "proxyRefs", function () { return $c26046b24d013f59$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "toRefs", function () { return $c26046b24d013f59$export$2e9533675e5e70e0; });
$parcel$export(module.exports, "toRef", function () { return $c26046b24d013f59$export$1f60508e4f47b4b7; });
$parcel$export(module.exports, "computed", function () { return $c26046b24d013f59$export$2983e091f1a1e8e2; });

var $4bH2P = parcelRequire("4bH2P");
function $c26046b24d013f59$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $c26046b24d013f59$var$activeEffectScope;
class $c26046b24d013f59$export$1168ed9dbc71ddbd {
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $c26046b24d013f59$var$activeEffectScope;
            try {
                $c26046b24d013f59$var$activeEffectScope = this;
                return fn();
            } finally{
                $c26046b24d013f59$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $c26046b24d013f59$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $c26046b24d013f59$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $c26046b24d013f59$var$activeEffectScope;
        if (!detached && $c26046b24d013f59$var$activeEffectScope) this.index = ($c26046b24d013f59$var$activeEffectScope.scopes || ($c26046b24d013f59$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
}
function $c26046b24d013f59$export$7056603ea81600be(detached) {
    return new $c26046b24d013f59$export$1168ed9dbc71ddbd(detached);
}
function $c26046b24d013f59$var$recordEffectScope(effect, scope = $c26046b24d013f59$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $c26046b24d013f59$export$c7be4b0125a10cba() {
    return $c26046b24d013f59$var$activeEffectScope;
}
function $c26046b24d013f59$export$a780418acd4762da(fn) {
    if ($c26046b24d013f59$var$activeEffectScope) $c26046b24d013f59$var$activeEffectScope.cleanups.push(fn);
}
const $c26046b24d013f59$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $c26046b24d013f59$var$wasTracked = (dep)=>(dep.w & $c26046b24d013f59$var$trackOpBit) > 0;
const $c26046b24d013f59$var$newTracked = (dep)=>(dep.n & $c26046b24d013f59$var$trackOpBit) > 0;
const $c26046b24d013f59$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $c26046b24d013f59$var$trackOpBit;
};
const $c26046b24d013f59$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($c26046b24d013f59$var$wasTracked(dep) && !$c26046b24d013f59$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$c26046b24d013f59$var$trackOpBit;
            dep.n &= ~$c26046b24d013f59$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $c26046b24d013f59$var$targetMap = /* @__PURE__ */ new WeakMap();
let $c26046b24d013f59$var$effectTrackDepth = 0;
let $c26046b24d013f59$var$trackOpBit = 1;
const $c26046b24d013f59$var$maxMarkerBits = 30;
let $c26046b24d013f59$var$activeEffect;
const $c26046b24d013f59$export$3c41b1a4e06acc14 = Symbol("");
const $c26046b24d013f59$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $c26046b24d013f59$export$28352bb4dd362521 {
    run() {
        if (!this.active) return this.fn();
        let parent = $c26046b24d013f59$var$activeEffect;
        let lastShouldTrack = $c26046b24d013f59$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $c26046b24d013f59$var$activeEffect;
            $c26046b24d013f59$var$activeEffect = this;
            $c26046b24d013f59$var$shouldTrack = true;
            $c26046b24d013f59$var$trackOpBit = 1 << ++$c26046b24d013f59$var$effectTrackDepth;
            if ($c26046b24d013f59$var$effectTrackDepth <= $c26046b24d013f59$var$maxMarkerBits) $c26046b24d013f59$var$initDepMarkers(this);
            else $c26046b24d013f59$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($c26046b24d013f59$var$effectTrackDepth <= $c26046b24d013f59$var$maxMarkerBits) $c26046b24d013f59$var$finalizeDepMarkers(this);
            $c26046b24d013f59$var$trackOpBit = 1 << --$c26046b24d013f59$var$effectTrackDepth;
            $c26046b24d013f59$var$activeEffect = this.parent;
            $c26046b24d013f59$var$shouldTrack = lastShouldTrack;
            this.parent = void 0;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        if ($c26046b24d013f59$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $c26046b24d013f59$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $c26046b24d013f59$var$recordEffectScope(this, scope);
    }
}
function $c26046b24d013f59$var$cleanupEffect(effect2) {
    const { deps: deps } = effect2;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $c26046b24d013f59$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $c26046b24d013f59$export$28352bb4dd362521(fn);
    if (options) {
        (0, $4bH2P.extend)(_effect, options);
        if (options.scope) $c26046b24d013f59$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $c26046b24d013f59$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $c26046b24d013f59$var$shouldTrack = true;
const $c26046b24d013f59$var$trackStack = [];
function $c26046b24d013f59$export$938a971395fef855() {
    $c26046b24d013f59$var$trackStack.push($c26046b24d013f59$var$shouldTrack);
    $c26046b24d013f59$var$shouldTrack = false;
}
function $c26046b24d013f59$export$1f8ffc6fd33b1d16() {
    $c26046b24d013f59$var$trackStack.push($c26046b24d013f59$var$shouldTrack);
    $c26046b24d013f59$var$shouldTrack = true;
}
function $c26046b24d013f59$export$c39176b1babaa8b8() {
    const last = $c26046b24d013f59$var$trackStack.pop();
    $c26046b24d013f59$var$shouldTrack = last === void 0 ? true : last;
}
function $c26046b24d013f59$export$6b2a7d5132615086(target, type, key) {
    if ($c26046b24d013f59$var$shouldTrack && $c26046b24d013f59$var$activeEffect) {
        let depsMap = $c26046b24d013f59$var$targetMap.get(target);
        if (!depsMap) $c26046b24d013f59$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $c26046b24d013f59$var$createDep());
        const eventInfo = void 0;
        $c26046b24d013f59$var$trackEffects(dep, eventInfo);
    }
}
function $c26046b24d013f59$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack2 = false;
    if ($c26046b24d013f59$var$effectTrackDepth <= $c26046b24d013f59$var$maxMarkerBits) {
        if (!$c26046b24d013f59$var$newTracked(dep)) {
            dep.n |= $c26046b24d013f59$var$trackOpBit;
            shouldTrack2 = !$c26046b24d013f59$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($c26046b24d013f59$var$activeEffect);
    if (shouldTrack2) {
        dep.add($c26046b24d013f59$var$activeEffect);
        $c26046b24d013f59$var$activeEffect.deps.push(dep);
    }
}
function $c26046b24d013f59$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $c26046b24d013f59$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $4bH2P.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $4bH2P.isArray)(target)) {
                    deps.push(depsMap.get($c26046b24d013f59$export$3c41b1a4e06acc14));
                    if ((0, $4bH2P.isMap)(target)) deps.push(depsMap.get($c26046b24d013f59$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $4bH2P.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $4bH2P.isArray)(target)) {
                    deps.push(depsMap.get($c26046b24d013f59$export$3c41b1a4e06acc14));
                    if ((0, $4bH2P.isMap)(target)) deps.push(depsMap.get($c26046b24d013f59$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $4bH2P.isMap)(target)) deps.push(depsMap.get($c26046b24d013f59$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $c26046b24d013f59$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $c26046b24d013f59$var$triggerEffects($c26046b24d013f59$var$createDep(effects));
    }
}
function $c26046b24d013f59$var$triggerEffects(dep, debuggerEventExtraInfo) {
    const effects = (0, $4bH2P.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect2 of effects)if (effect2.computed) $c26046b24d013f59$var$triggerEffect(effect2, debuggerEventExtraInfo);
    for (const effect2 of effects)if (!effect2.computed) $c26046b24d013f59$var$triggerEffect(effect2, debuggerEventExtraInfo);
}
function $c26046b24d013f59$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $c26046b24d013f59$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $c26046b24d013f59$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $c26046b24d013f59$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $c26046b24d013f59$var$isNonTrackableKeys = /* @__PURE__ */ (0, $4bH2P.makeMap)(`__proto__,__v_isRef,__isVue`);
const $c26046b24d013f59$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $4bH2P.isSymbol)));
const $c26046b24d013f59$var$get$1 = /* @__PURE__ */ $c26046b24d013f59$var$createGetter();
const $c26046b24d013f59$var$shallowGet = /* @__PURE__ */ $c26046b24d013f59$var$createGetter(false, true);
const $c26046b24d013f59$var$readonlyGet = /* @__PURE__ */ $c26046b24d013f59$var$createGetter(true);
const $c26046b24d013f59$var$shallowReadonlyGet = /* @__PURE__ */ $c26046b24d013f59$var$createGetter(true, true);
const $c26046b24d013f59$var$arrayInstrumentations = /* @__PURE__ */ $c26046b24d013f59$var$createArrayInstrumentations();
function $c26046b24d013f59$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $c26046b24d013f59$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$c26046b24d013f59$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($c26046b24d013f59$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $c26046b24d013f59$export$938a971395fef855();
            const res = $c26046b24d013f59$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $c26046b24d013f59$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $c26046b24d013f59$var$hasOwnProperty(key) {
    const obj = $c26046b24d013f59$export$ab18938b9fc5f28e(this);
    $c26046b24d013f59$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
function $c26046b24d013f59$var$createGetter(isReadonly2 = false, shallow = false) {
    return function get2(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $c26046b24d013f59$var$shallowReadonlyMap : $c26046b24d013f59$var$readonlyMap : shallow ? $c26046b24d013f59$var$shallowReactiveMap : $c26046b24d013f59$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $4bH2P.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $4bH2P.hasOwn)($c26046b24d013f59$var$arrayInstrumentations, key)) return Reflect.get($c26046b24d013f59$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $c26046b24d013f59$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $4bH2P.isSymbol)(key) ? $c26046b24d013f59$var$builtInSymbols.has(key) : $c26046b24d013f59$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $c26046b24d013f59$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($c26046b24d013f59$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $4bH2P.isIntegerKey)(key) ? res : res.value;
        if ((0, $4bH2P.isObject)(res)) return isReadonly2 ? $c26046b24d013f59$export$6ec456bd5b7b3c51(res) : $c26046b24d013f59$export$90a44edba14e47be(res);
        return res;
    };
}
const $c26046b24d013f59$var$set$1 = /* @__PURE__ */ $c26046b24d013f59$var$createSetter();
const $c26046b24d013f59$var$shallowSet = /* @__PURE__ */ $c26046b24d013f59$var$createSetter(true);
function $c26046b24d013f59$var$createSetter(shallow = false) {
    return function set2(target, key, value, receiver) {
        let oldValue = target[key];
        if ($c26046b24d013f59$export$92d09b48637741e7(oldValue) && $c26046b24d013f59$export$4f9f5282de18fc69(oldValue) && !$c26046b24d013f59$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$c26046b24d013f59$export$7f3fe6025abfa26e(value) && !$c26046b24d013f59$export$92d09b48637741e7(value)) {
                oldValue = $c26046b24d013f59$export$ab18938b9fc5f28e(oldValue);
                value = $c26046b24d013f59$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $4bH2P.isArray)(target) && $c26046b24d013f59$export$4f9f5282de18fc69(oldValue) && !$c26046b24d013f59$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $4bH2P.isArray)(target) && (0, $4bH2P.isIntegerKey)(key) ? Number(key) < target.length : (0, $4bH2P.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $c26046b24d013f59$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $c26046b24d013f59$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $4bH2P.hasChanged)(value, oldValue)) $c26046b24d013f59$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $c26046b24d013f59$var$deleteProperty(target, key) {
    const hadKey = (0, $4bH2P.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $c26046b24d013f59$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $c26046b24d013f59$var$has$1(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $4bH2P.isSymbol)(key) || !$c26046b24d013f59$var$builtInSymbols.has(key)) $c26046b24d013f59$export$6b2a7d5132615086(target, "has", key);
    return result;
}
function $c26046b24d013f59$var$ownKeys(target) {
    $c26046b24d013f59$export$6b2a7d5132615086(target, "iterate", (0, $4bH2P.isArray)(target) ? "length" : $c26046b24d013f59$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $c26046b24d013f59$var$mutableHandlers = {
    get: $c26046b24d013f59$var$get$1,
    set: $c26046b24d013f59$var$set$1,
    deleteProperty: $c26046b24d013f59$var$deleteProperty,
    has: $c26046b24d013f59$var$has$1,
    ownKeys: $c26046b24d013f59$var$ownKeys
};
const $c26046b24d013f59$var$readonlyHandlers = {
    get: $c26046b24d013f59$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $c26046b24d013f59$var$shallowReactiveHandlers = /* @__PURE__ */ (0, $4bH2P.extend)({}, $c26046b24d013f59$var$mutableHandlers, {
    get: $c26046b24d013f59$var$shallowGet,
    set: $c26046b24d013f59$var$shallowSet
});
const $c26046b24d013f59$var$shallowReadonlyHandlers = /* @__PURE__ */ (0, $4bH2P.extend)({}, $c26046b24d013f59$var$readonlyHandlers, {
    get: $c26046b24d013f59$var$shallowReadonlyGet
});
const $c26046b24d013f59$var$toShallow = (value)=>value;
const $c26046b24d013f59$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $c26046b24d013f59$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $c26046b24d013f59$export$ab18938b9fc5f28e(target);
    const rawKey = $c26046b24d013f59$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $c26046b24d013f59$export$6b2a7d5132615086(rawTarget, "get", key);
        $c26046b24d013f59$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $c26046b24d013f59$var$getProto(rawTarget);
    const wrap = isShallow ? $c26046b24d013f59$var$toShallow : isReadonly ? $c26046b24d013f59$var$toReadonly : $c26046b24d013f59$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $c26046b24d013f59$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $c26046b24d013f59$export$ab18938b9fc5f28e(target);
    const rawKey = $c26046b24d013f59$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $c26046b24d013f59$export$6b2a7d5132615086(rawTarget, "has", key);
        $c26046b24d013f59$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $c26046b24d013f59$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $c26046b24d013f59$export$6b2a7d5132615086($c26046b24d013f59$export$ab18938b9fc5f28e(target), "iterate", $c26046b24d013f59$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $c26046b24d013f59$var$add(value) {
    value = $c26046b24d013f59$export$ab18938b9fc5f28e(value);
    const target = $c26046b24d013f59$export$ab18938b9fc5f28e(this);
    const proto = $c26046b24d013f59$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $c26046b24d013f59$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $c26046b24d013f59$var$set(key, value) {
    value = $c26046b24d013f59$export$ab18938b9fc5f28e(value);
    const target = $c26046b24d013f59$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $c26046b24d013f59$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $c26046b24d013f59$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $c26046b24d013f59$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $4bH2P.hasChanged)(value, oldValue)) $c26046b24d013f59$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $c26046b24d013f59$var$deleteEntry(key) {
    const target = $c26046b24d013f59$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $c26046b24d013f59$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $c26046b24d013f59$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $c26046b24d013f59$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $c26046b24d013f59$var$clear() {
    const target = $c26046b24d013f59$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $c26046b24d013f59$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $c26046b24d013f59$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $c26046b24d013f59$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $c26046b24d013f59$var$toShallow : isReadonly ? $c26046b24d013f59$var$toReadonly : $c26046b24d013f59$var$toReactive;
        !isReadonly && $c26046b24d013f59$export$6b2a7d5132615086(rawTarget, "iterate", $c26046b24d013f59$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $c26046b24d013f59$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $c26046b24d013f59$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $4bH2P.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $c26046b24d013f59$var$toShallow : isReadonly ? $c26046b24d013f59$var$toReadonly : $c26046b24d013f59$var$toReactive;
        !isReadonly && $c26046b24d013f59$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $c26046b24d013f59$var$MAP_KEY_ITERATE_KEY : $c26046b24d013f59$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $c26046b24d013f59$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : this;
    };
}
function $c26046b24d013f59$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $c26046b24d013f59$var$get(this, key);
        },
        get size () {
            return $c26046b24d013f59$var$size(this);
        },
        has: $c26046b24d013f59$var$has,
        add: $c26046b24d013f59$var$add,
        set: $c26046b24d013f59$var$set,
        delete: $c26046b24d013f59$var$deleteEntry,
        clear: $c26046b24d013f59$var$clear,
        forEach: $c26046b24d013f59$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $c26046b24d013f59$var$get(this, key, false, true);
        },
        get size () {
            return $c26046b24d013f59$var$size(this);
        },
        has: $c26046b24d013f59$var$has,
        add: $c26046b24d013f59$var$add,
        set: $c26046b24d013f59$var$set,
        delete: $c26046b24d013f59$var$deleteEntry,
        clear: $c26046b24d013f59$var$clear,
        forEach: $c26046b24d013f59$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $c26046b24d013f59$var$get(this, key, true);
        },
        get size () {
            return $c26046b24d013f59$var$size(this, true);
        },
        has (key) {
            return $c26046b24d013f59$var$has.call(this, key, true);
        },
        add: $c26046b24d013f59$var$createReadonlyMethod("add"),
        set: $c26046b24d013f59$var$createReadonlyMethod("set"),
        delete: $c26046b24d013f59$var$createReadonlyMethod("delete"),
        clear: $c26046b24d013f59$var$createReadonlyMethod("clear"),
        forEach: $c26046b24d013f59$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $c26046b24d013f59$var$get(this, key, true, true);
        },
        get size () {
            return $c26046b24d013f59$var$size(this, true);
        },
        has (key) {
            return $c26046b24d013f59$var$has.call(this, key, true);
        },
        add: $c26046b24d013f59$var$createReadonlyMethod("add"),
        set: $c26046b24d013f59$var$createReadonlyMethod("set"),
        delete: $c26046b24d013f59$var$createReadonlyMethod("delete"),
        clear: $c26046b24d013f59$var$createReadonlyMethod("clear"),
        forEach: $c26046b24d013f59$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $c26046b24d013f59$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $c26046b24d013f59$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $c26046b24d013f59$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $c26046b24d013f59$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$c26046b24d013f59$var$mutableInstrumentations, $c26046b24d013f59$var$readonlyInstrumentations, $c26046b24d013f59$var$shallowInstrumentations, $c26046b24d013f59$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $c26046b24d013f59$var$createInstrumentations();
function $c26046b24d013f59$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $c26046b24d013f59$var$shallowReadonlyInstrumentations : $c26046b24d013f59$var$shallowInstrumentations : isReadonly ? $c26046b24d013f59$var$readonlyInstrumentations : $c26046b24d013f59$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $4bH2P.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $c26046b24d013f59$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $c26046b24d013f59$var$createInstrumentationGetter(false, false)
};
const $c26046b24d013f59$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $c26046b24d013f59$var$createInstrumentationGetter(false, true)
};
const $c26046b24d013f59$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $c26046b24d013f59$var$createInstrumentationGetter(true, false)
};
const $c26046b24d013f59$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $c26046b24d013f59$var$createInstrumentationGetter(true, true)
};
function $c26046b24d013f59$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $c26046b24d013f59$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $4bH2P.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $c26046b24d013f59$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $c26046b24d013f59$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $c26046b24d013f59$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $c26046b24d013f59$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $c26046b24d013f59$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $c26046b24d013f59$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $c26046b24d013f59$var$targetTypeMap((0, $4bH2P.toRawType)(value));
}
function $c26046b24d013f59$export$90a44edba14e47be(target) {
    if ($c26046b24d013f59$export$92d09b48637741e7(target)) return target;
    return $c26046b24d013f59$var$createReactiveObject(target, false, $c26046b24d013f59$var$mutableHandlers, $c26046b24d013f59$var$mutableCollectionHandlers, $c26046b24d013f59$var$reactiveMap);
}
function $c26046b24d013f59$export$8d81cefd22d22260(target) {
    return $c26046b24d013f59$var$createReactiveObject(target, false, $c26046b24d013f59$var$shallowReactiveHandlers, $c26046b24d013f59$var$shallowCollectionHandlers, $c26046b24d013f59$var$shallowReactiveMap);
}
function $c26046b24d013f59$export$6ec456bd5b7b3c51(target) {
    return $c26046b24d013f59$var$createReactiveObject(target, true, $c26046b24d013f59$var$readonlyHandlers, $c26046b24d013f59$var$readonlyCollectionHandlers, $c26046b24d013f59$var$readonlyMap);
}
function $c26046b24d013f59$export$7c4b5f2b50f09f6b(target) {
    return $c26046b24d013f59$var$createReactiveObject(target, true, $c26046b24d013f59$var$shallowReadonlyHandlers, $c26046b24d013f59$var$shallowReadonlyCollectionHandlers, $c26046b24d013f59$var$shallowReadonlyMap);
}
function $c26046b24d013f59$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $4bH2P.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $c26046b24d013f59$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $c26046b24d013f59$export$352205f445242f02(value) {
    if ($c26046b24d013f59$export$92d09b48637741e7(value)) return $c26046b24d013f59$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $c26046b24d013f59$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $c26046b24d013f59$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $c26046b24d013f59$export$5f3ca29d057519b3(value) {
    return $c26046b24d013f59$export$352205f445242f02(value) || $c26046b24d013f59$export$92d09b48637741e7(value);
}
function $c26046b24d013f59$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $c26046b24d013f59$export$ab18938b9fc5f28e(raw) : observed;
}
function $c26046b24d013f59$export$995ab8b13ad7a9d0(value) {
    (0, $4bH2P.def)(value, "__v_skip", true);
    return value;
}
const $c26046b24d013f59$var$toReactive = (value)=>(0, $4bH2P.isObject)(value) ? $c26046b24d013f59$export$90a44edba14e47be(value) : value;
const $c26046b24d013f59$var$toReadonly = (value)=>(0, $4bH2P.isObject)(value) ? $c26046b24d013f59$export$6ec456bd5b7b3c51(value) : value;
function $c26046b24d013f59$var$trackRefValue(ref2) {
    if ($c26046b24d013f59$var$shouldTrack && $c26046b24d013f59$var$activeEffect) {
        ref2 = $c26046b24d013f59$export$ab18938b9fc5f28e(ref2);
        $c26046b24d013f59$var$trackEffects(ref2.dep || (ref2.dep = $c26046b24d013f59$var$createDep()));
    }
}
function $c26046b24d013f59$var$triggerRefValue(ref2, newVal) {
    ref2 = $c26046b24d013f59$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $c26046b24d013f59$var$triggerEffects(dep);
}
function $c26046b24d013f59$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $c26046b24d013f59$export$eff4d24c3ff7876e(value) {
    return $c26046b24d013f59$var$createRef(value, false);
}
function $c26046b24d013f59$export$9b7bc5fe3b17c8b3(value) {
    return $c26046b24d013f59$var$createRef(value, true);
}
function $c26046b24d013f59$var$createRef(rawValue, shallow) {
    if ($c26046b24d013f59$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $c26046b24d013f59$var$RefImpl(rawValue, shallow);
}
class $c26046b24d013f59$var$RefImpl {
    get value() {
        $c26046b24d013f59$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $c26046b24d013f59$export$7f3fe6025abfa26e(newVal) || $c26046b24d013f59$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $c26046b24d013f59$export$ab18938b9fc5f28e(newVal);
        if ((0, $4bH2P.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $c26046b24d013f59$var$toReactive(newVal);
            $c26046b24d013f59$var$triggerRefValue(this, newVal);
        }
    }
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $c26046b24d013f59$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $c26046b24d013f59$var$toReactive(value);
    }
}
function $c26046b24d013f59$export$f402f86588575ccc(ref2) {
    $c26046b24d013f59$var$triggerRefValue(ref2, void 0);
}
function $c26046b24d013f59$export$a239a76781616204(ref2) {
    return $c26046b24d013f59$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $c26046b24d013f59$export$30bdcc2218aa9458(source) {
    return (0, $4bH2P.isFunction)(source) ? source() : $c26046b24d013f59$export$a239a76781616204(source);
}
const $c26046b24d013f59$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$c26046b24d013f59$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($c26046b24d013f59$export$4f9f5282de18fc69(oldValue) && !$c26046b24d013f59$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $c26046b24d013f59$export$f353fd1b97db3fa0(objectWithRefs) {
    return $c26046b24d013f59$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $c26046b24d013f59$var$shallowUnwrapHandlers);
}
class $c26046b24d013f59$var$CustomRefImpl {
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$c26046b24d013f59$var$trackRefValue(this), ()=>$c26046b24d013f59$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
}
function $c26046b24d013f59$export$a20c2dd6199824cb(factory) {
    return new $c26046b24d013f59$var$CustomRefImpl(factory);
}
function $c26046b24d013f59$export$2e9533675e5e70e0(object) {
    const ret = (0, $4bH2P.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $c26046b24d013f59$var$propertyToRef(object, key);
    return ret;
}
class $c26046b24d013f59$var$ObjectRefImpl {
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $c26046b24d013f59$var$getDepFromReactive($c26046b24d013f59$export$ab18938b9fc5f28e(this._object), this._key);
    }
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
}
class $c26046b24d013f59$var$GetterRefImpl {
    get value() {
        return this._getter();
    }
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
}
function $c26046b24d013f59$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($c26046b24d013f59$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $4bH2P.isFunction)(source)) return new $c26046b24d013f59$var$GetterRefImpl(source);
    else if ((0, $4bH2P.isObject)(source) && arguments.length > 1) return $c26046b24d013f59$var$propertyToRef(source, key, defaultValue);
    else return $c26046b24d013f59$export$eff4d24c3ff7876e(source);
}
function $c26046b24d013f59$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $c26046b24d013f59$export$4f9f5282de18fc69(val) ? val : new $c26046b24d013f59$var$ObjectRefImpl(source, key, defaultValue);
}
class $c26046b24d013f59$var$ComputedRefImpl {
    get value() {
        const self = $c26046b24d013f59$export$ab18938b9fc5f28e(this);
        $c26046b24d013f59$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $c26046b24d013f59$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $c26046b24d013f59$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
}
function $c26046b24d013f59$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $4bH2P.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $4bH2P.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $c26046b24d013f59$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
const $c26046b24d013f59$var$tick = /* @__PURE__ */ Promise.resolve();
const $c26046b24d013f59$var$queue = [];
let $c26046b24d013f59$var$queued = false;
const $c26046b24d013f59$var$scheduler = (fn)=>{
    $c26046b24d013f59$var$queue.push(fn);
    if (!$c26046b24d013f59$var$queued) {
        $c26046b24d013f59$var$queued = true;
        $c26046b24d013f59$var$tick.then($c26046b24d013f59$var$flush);
    }
};
const $c26046b24d013f59$var$flush = ()=>{
    for(let i = 0; i < $c26046b24d013f59$var$queue.length; i++)$c26046b24d013f59$var$queue[i]();
    $c26046b24d013f59$var$queue.length = 0;
    $c26046b24d013f59$var$queued = false;
};
class $c26046b24d013f59$var$DeferredComputedRefImpl {
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $c26046b24d013f59$var$trackRefValue(this);
        return $c26046b24d013f59$export$ab18938b9fc5f28e(this)._get();
    }
    constructor(getter){
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $c26046b24d013f59$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $c26046b24d013f59$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $c26046b24d013f59$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                for (const e of this.dep)if (e.computed instanceof $c26046b24d013f59$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
}
function $c26046b24d013f59$export$483264c4ec4c46ce(getter) {
    return new $c26046b24d013f59$var$DeferredComputedRefImpl(getter);
}

});
parcelRequire.register("4bH2P", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $30c99448e3ba361e$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $30c99448e3ba361e$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $30c99448e3ba361e$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $30c99448e3ba361e$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $30c99448e3ba361e$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $30c99448e3ba361e$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $30c99448e3ba361e$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $30c99448e3ba361e$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $30c99448e3ba361e$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $30c99448e3ba361e$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $30c99448e3ba361e$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $30c99448e3ba361e$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $30c99448e3ba361e$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $30c99448e3ba361e$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $30c99448e3ba361e$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $30c99448e3ba361e$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $30c99448e3ba361e$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $30c99448e3ba361e$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $30c99448e3ba361e$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $30c99448e3ba361e$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $30c99448e3ba361e$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $30c99448e3ba361e$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $30c99448e3ba361e$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $30c99448e3ba361e$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $30c99448e3ba361e$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $30c99448e3ba361e$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $30c99448e3ba361e$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $30c99448e3ba361e$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $30c99448e3ba361e$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $30c99448e3ba361e$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $30c99448e3ba361e$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $30c99448e3ba361e$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $30c99448e3ba361e$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $30c99448e3ba361e$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $30c99448e3ba361e$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "normalizeStyle", function () { return $30c99448e3ba361e$export$8756898546458274; });
$parcel$export(module.exports, "normalizeClass", function () { return $30c99448e3ba361e$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $30c99448e3ba361e$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $30c99448e3ba361e$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $30c99448e3ba361e$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $30c99448e3ba361e$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $30c99448e3ba361e$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "looseEqual", function () { return $30c99448e3ba361e$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $30c99448e3ba361e$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $30c99448e3ba361e$export$b5b1545233b45293; });
function $30c99448e3ba361e$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $30c99448e3ba361e$export$cf583d23ab39677c = {};
const $30c99448e3ba361e$export$6bd8558f433f1cc1 = [];
const $30c99448e3ba361e$export$5702a91a6f42969f = ()=>{};
const $30c99448e3ba361e$export$c01351c0af048e39 = ()=>false;
const $30c99448e3ba361e$var$onRE = /^on[^a-z]/;
const $30c99448e3ba361e$export$1a2d97de39ecbb75 = (key)=>$30c99448e3ba361e$var$onRE.test(key);
const $30c99448e3ba361e$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $30c99448e3ba361e$export$8b58be045bf06082 = Object.assign;
const $30c99448e3ba361e$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $30c99448e3ba361e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $30c99448e3ba361e$export$b5a638e9b3fff9f3 = (val, key)=>$30c99448e3ba361e$var$hasOwnProperty.call(val, key);
const $30c99448e3ba361e$export$43bee75e5e14138e = Array.isArray;
const $30c99448e3ba361e$export$5c90113a285f2241 = (val)=>$30c99448e3ba361e$export$1dccc787cc36538b(val) === "[object Map]";
const $30c99448e3ba361e$export$6750766a7c7ec627 = (val)=>$30c99448e3ba361e$export$1dccc787cc36538b(val) === "[object Set]";
const $30c99448e3ba361e$export$871608497c498473 = (val)=>$30c99448e3ba361e$export$1dccc787cc36538b(val) === "[object Date]";
const $30c99448e3ba361e$export$49841c62b9eff15 = (val)=>$30c99448e3ba361e$export$1dccc787cc36538b(val) === "[object RegExp]";
const $30c99448e3ba361e$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $30c99448e3ba361e$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $30c99448e3ba361e$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $30c99448e3ba361e$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $30c99448e3ba361e$export$4369c812aac99591 = (val)=>{
    return $30c99448e3ba361e$export$a6cdc56e425d0d0a(val) && $30c99448e3ba361e$export$f6e2535fb5126e54(val.then) && $30c99448e3ba361e$export$f6e2535fb5126e54(val.catch);
};
const $30c99448e3ba361e$export$830c053460e5ddf6 = Object.prototype.toString;
const $30c99448e3ba361e$export$1dccc787cc36538b = (value)=>$30c99448e3ba361e$export$830c053460e5ddf6.call(value);
const $30c99448e3ba361e$export$5ad0a3c360b8fbb5 = (value)=>{
    return $30c99448e3ba361e$export$1dccc787cc36538b(value).slice(8, -1);
};
const $30c99448e3ba361e$export$53b83ca8eaab0383 = (val)=>$30c99448e3ba361e$export$1dccc787cc36538b(val) === "[object Object]";
const $30c99448e3ba361e$export$e2a2b93446ec9fe = (key)=>$30c99448e3ba361e$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $30c99448e3ba361e$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $30c99448e3ba361e$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $30c99448e3ba361e$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $30c99448e3ba361e$var$camelizeRE = /-(\w)/g;
const $30c99448e3ba361e$export$161d051f5dd25de7 = $30c99448e3ba361e$var$cacheStringFunction((str)=>{
    return str.replace($30c99448e3ba361e$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $30c99448e3ba361e$var$hyphenateRE = /\B([A-Z])/g;
const $30c99448e3ba361e$export$6e6a0a3676c4b8bb = $30c99448e3ba361e$var$cacheStringFunction((str)=>str.replace($30c99448e3ba361e$var$hyphenateRE, "-$1").toLowerCase());
const $30c99448e3ba361e$export$9a00dee1beb8f576 = $30c99448e3ba361e$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
const $30c99448e3ba361e$export$8c022799eeaaefcd = $30c99448e3ba361e$var$cacheStringFunction((str)=>str ? `on${$30c99448e3ba361e$export$9a00dee1beb8f576(str)}` : ``);
const $30c99448e3ba361e$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $30c99448e3ba361e$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $30c99448e3ba361e$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $30c99448e3ba361e$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $30c99448e3ba361e$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $30c99448e3ba361e$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $30c99448e3ba361e$var$_globalThis;
const $30c99448e3ba361e$export$ff5f2eeb11fc7e14 = ()=>{
    return $30c99448e3ba361e$var$_globalThis || ($30c99448e3ba361e$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $30c99448e3ba361e$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $30c99448e3ba361e$export$53d5e12f9a1d3cde(name) {
    return $30c99448e3ba361e$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $30c99448e3ba361e$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $30c99448e3ba361e$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $30c99448e3ba361e$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $30c99448e3ba361e$export$d6571a1911e4f27e = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8($30c99448e3ba361e$var$GLOBALS_WHITE_LISTED);
const $30c99448e3ba361e$var$range = 2;
function $30c99448e3ba361e$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $30c99448e3ba361e$var$range; j <= i + $30c99448e3ba361e$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $30c99448e3ba361e$export$8756898546458274(value) {
    if ($30c99448e3ba361e$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $30c99448e3ba361e$export$844ec244b1367d54(item) ? $30c99448e3ba361e$export$76a205ce979d066a(item) : $30c99448e3ba361e$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($30c99448e3ba361e$export$844ec244b1367d54(value)) return value;
    else if ($30c99448e3ba361e$export$a6cdc56e425d0d0a(value)) return value;
}
const $30c99448e3ba361e$var$listDelimiterRE = /;(?![^(]*\))/g;
const $30c99448e3ba361e$var$propertyDelimiterRE = /:([^]+)/;
const $30c99448e3ba361e$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $30c99448e3ba361e$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($30c99448e3ba361e$var$styleCommentRE, "").split($30c99448e3ba361e$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($30c99448e3ba361e$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $30c99448e3ba361e$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $30c99448e3ba361e$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $30c99448e3ba361e$export$6e6a0a3676c4b8bb(key);
        if ($30c99448e3ba361e$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $30c99448e3ba361e$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($30c99448e3ba361e$export$844ec244b1367d54(value)) res = value;
    else if ($30c99448e3ba361e$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $30c99448e3ba361e$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($30c99448e3ba361e$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $30c99448e3ba361e$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$30c99448e3ba361e$export$844ec244b1367d54(klass)) props.class = $30c99448e3ba361e$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $30c99448e3ba361e$export$8756898546458274(style);
    return props;
}
const $30c99448e3ba361e$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $30c99448e3ba361e$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $30c99448e3ba361e$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $30c99448e3ba361e$export$1ccf854a0984f890 = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8($30c99448e3ba361e$var$HTML_TAGS);
const $30c99448e3ba361e$export$6328ce7565ea1049 = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8($30c99448e3ba361e$var$SVG_TAGS);
const $30c99448e3ba361e$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8($30c99448e3ba361e$var$VOID_TAGS);
const $30c99448e3ba361e$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $30c99448e3ba361e$export$d186f5eb2e810715 = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8($30c99448e3ba361e$var$specialBooleanAttrs);
const $30c99448e3ba361e$export$f763ba3b84e9cd8c = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8($30c99448e3ba361e$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $30c99448e3ba361e$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $30c99448e3ba361e$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $30c99448e3ba361e$var$attrValidationCache = {};
function $30c99448e3ba361e$export$d55ef77660f30d12(name) {
    if ($30c99448e3ba361e$var$attrValidationCache.hasOwnProperty(name)) return $30c99448e3ba361e$var$attrValidationCache[name];
    const isUnsafe = $30c99448e3ba361e$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $30c99448e3ba361e$var$attrValidationCache[name] = !isUnsafe;
}
const $30c99448e3ba361e$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $30c99448e3ba361e$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $30c99448e3ba361e$export$80da416f43933831 = /* @__PURE__ */ $30c99448e3ba361e$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $30c99448e3ba361e$var$escapeRE = /["'&<>]/;
function $30c99448e3ba361e$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $30c99448e3ba361e$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $30c99448e3ba361e$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $30c99448e3ba361e$export$7b105034a53bde5f(src) {
    return src.replace($30c99448e3ba361e$var$commentStripRE, "");
}
function $30c99448e3ba361e$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $30c99448e3ba361e$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $30c99448e3ba361e$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $30c99448e3ba361e$export$871608497c498473(a);
    let bValidType = $30c99448e3ba361e$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $30c99448e3ba361e$export$a244864fd9645c7f(a);
    bValidType = $30c99448e3ba361e$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $30c99448e3ba361e$export$43bee75e5e14138e(a);
    bValidType = $30c99448e3ba361e$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $30c99448e3ba361e$var$looseCompareArrays(a, b) : false;
    aValidType = $30c99448e3ba361e$export$a6cdc56e425d0d0a(a);
    bValidType = $30c99448e3ba361e$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$30c99448e3ba361e$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $30c99448e3ba361e$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$30c99448e3ba361e$export$ae8015769846262c(item, val));
}
const $30c99448e3ba361e$export$b5b1545233b45293 = (val)=>{
    return $30c99448e3ba361e$export$844ec244b1367d54(val) ? val : val == null ? "" : $30c99448e3ba361e$export$43bee75e5e14138e(val) || $30c99448e3ba361e$export$a6cdc56e425d0d0a(val) && (val.toString === $30c99448e3ba361e$export$830c053460e5ddf6 || !$30c99448e3ba361e$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $30c99448e3ba361e$var$replacer, 2) : String(val);
};
const $30c99448e3ba361e$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $30c99448e3ba361e$var$replacer(_key, val.value);
    else if ($30c99448e3ba361e$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($30c99448e3ba361e$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($30c99448e3ba361e$export$a6cdc56e425d0d0a(val) && !$30c99448e3ba361e$export$43bee75e5e14138e(val) && !$30c99448e3ba361e$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});



parcelRequire.register("brqXq", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("cfZzL")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("cfZzL")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("cfZzL")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("4bH2P")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("cfZzL")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("cfZzL")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("cfZzL")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("cfZzL")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("cfZzL")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("cfZzL")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("cfZzL")).createRenderer; });
$parcel$export(module.exports, "createSlots", function () { return (parcelRequire("cfZzL")).createSlots; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("cfZzL")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("cfZzL")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("cfZzL")).createVNode; });
$parcel$export(module.exports, "defineAsyncComponent", function () { return (parcelRequire("cfZzL")).defineAsyncComponent; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("cfZzL")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("cfZzL")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("cfZzL")).getCurrentInstance; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("gGESn")).getCurrentScope; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("cfZzL")).getTransitionRawChildren; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("cfZzL")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("cfZzL")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("cfZzL")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("cfZzL")).inject; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("gGESn")).isReactive; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("gGESn")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("cfZzL")).isRuntimeOnly; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("gGESn")).markRaw; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("cfZzL")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("cfZzL")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("4bH2P")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("4bH2P")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("cfZzL")).onActivated; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("cfZzL")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("cfZzL")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("cfZzL")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("cfZzL")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("cfZzL")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("cfZzL")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("cfZzL")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("cfZzL")).pushScopeId; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("gGESn")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("gGESn")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("cfZzL")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("cfZzL")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("cfZzL")).resolveComponent; });
$parcel$export(module.exports, "resolveDirective", function () { return (parcelRequire("cfZzL")).resolveDirective; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("cfZzL")).resolveDynamicComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("cfZzL")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("cfZzL")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("cfZzL")).Static; });
$parcel$export(module.exports, "toHandlers", function () { return (parcelRequire("cfZzL")).toHandlers; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("gGESn")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("cfZzL")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("cfZzL")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("cfZzL")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("cfZzL")).watchEffect; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("cfZzL")).watchPostEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("cfZzL")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("cfZzL")).withDirectives; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("gGESn")).effectScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("gGESn")).onScopeDispose; });
$parcel$export(module.exports, "shallowReadonly", function () { return (parcelRequire("gGESn")).shallowReadonly; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("gGESn")).shallowRef; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("gGESn")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("gGESn")).toRefs; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("gGESn")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("4bH2P")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("4bH2P")).toDisplayString; });

$parcel$export(module.exports, "Transition", function () { return $854720849964243d$export$be58926105124dd4; });
$parcel$export(module.exports, "vModelText", function () { return $854720849964243d$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelCheckbox", function () { return $854720849964243d$export$8847c2e532b35714; });
$parcel$export(module.exports, "vModelRadio", function () { return $854720849964243d$export$b4356c59b38b7aa9; });
$parcel$export(module.exports, "vModelSelect", function () { return $854720849964243d$export$87d227567b51ca39; });
$parcel$export(module.exports, "vModelDynamic", function () { return $854720849964243d$export$5ad5c0e01ff62c5; });
$parcel$export(module.exports, "withModifiers", function () { return $854720849964243d$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $854720849964243d$export$f691a8759658f782; });
$parcel$export(module.exports, "vShow", function () { return $854720849964243d$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "createApp", function () { return $854720849964243d$export$4e373c34abfa8c68; });
parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $cfZzL = parcelRequire("cfZzL");
var $gGESn = parcelRequire("gGESn");parcelRequire("gGESn");parcelRequire("4bH2P");

var $4bH2P = parcelRequire("4bH2P");
const $854720849964243d$var$svgNS = "http://www.w3.org/2000/svg";
const $854720849964243d$var$doc = typeof document !== "undefined" ? document : null;
const $854720849964243d$var$templateContainer = $854720849964243d$var$doc && /* @__PURE__ */ $854720849964243d$var$doc.createElement("template");
const $854720849964243d$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $854720849964243d$var$doc.createElementNS($854720849964243d$var$svgNS, tag) : $854720849964243d$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$854720849964243d$var$doc.createTextNode(text),
    createComment: (text)=>$854720849964243d$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$854720849964243d$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $854720849964243d$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $854720849964243d$var$templateContainer.content;
            if (isSVG) {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
function $854720849964243d$var$patchClass(el, value, isSVG) {
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $854720849964243d$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $4bH2P.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $4bH2P.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $854720849964243d$var$setStyle(style, key, "");
        }
        for(const key in next)$854720849964243d$var$setStyle(style, key, next[key]);
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $854720849964243d$var$semicolonRE = /[^\\];\s*$/;
const $854720849964243d$var$importantRE = /\s*!important$/;
function $854720849964243d$var$setStyle(style, name, val) {
    if ((0, $4bH2P.isArray)(val)) val.forEach((v)=>$854720849964243d$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $854720849964243d$var$autoPrefix(style, name);
            if ($854720849964243d$var$importantRE.test(val)) style.setProperty((0, $4bH2P.hyphenate)(prefixed), val.replace($854720849964243d$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $854720849964243d$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $854720849964243d$var$prefixCache = {};
function $854720849964243d$var$autoPrefix(style, rawName) {
    const cached = $854720849964243d$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $4bH2P.camelize)(rawName);
    if (name !== "filter" && name in style) return $854720849964243d$var$prefixCache[rawName] = name;
    name = (0, $4bH2P.capitalize)(name);
    for(let i = 0; i < $854720849964243d$var$prefixes.length; i++){
        const prefixed = $854720849964243d$var$prefixes[i] + name;
        if (prefixed in style) return $854720849964243d$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $854720849964243d$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $854720849964243d$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($854720849964243d$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($854720849964243d$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $4bH2P.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $4bH2P.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $854720849964243d$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        const oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $4bH2P.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $854720849964243d$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $854720849964243d$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $854720849964243d$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $854720849964243d$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $854720849964243d$var$createInvoker(nextValue, instance);
            $854720849964243d$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $854720849964243d$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $854720849964243d$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $854720849964243d$var$parseName(name) {
    let options;
    if ($854720849964243d$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($854720849964243d$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $4bH2P.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $854720849964243d$var$cachedNow = 0;
const $854720849964243d$var$p = /* @__PURE__ */ Promise.resolve();
const $854720849964243d$var$getNow = ()=>$854720849964243d$var$cachedNow || ($854720849964243d$var$p.then(()=>$854720849964243d$var$cachedNow = 0), $854720849964243d$var$cachedNow = Date.now());
function $854720849964243d$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $cfZzL.callWithAsyncErrorHandling)($854720849964243d$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $854720849964243d$var$getNow();
    return invoker;
}
function $854720849964243d$var$patchStopImmediatePropagation(e, value) {
    if ((0, $4bH2P.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $854720849964243d$var$nativeOnRE = /^on[a-z]/;
const $854720849964243d$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $854720849964243d$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $854720849964243d$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $4bH2P.isOn)(key)) {
        if (!(0, $4bH2P.isModelListener)(key)) $854720849964243d$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $854720849964243d$var$shouldSetAsProp(el, key, nextValue, isSVG)) $854720849964243d$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $854720849964243d$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $854720849964243d$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $854720849964243d$var$nativeOnRE.test(key) && (0, $4bH2P.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($854720849964243d$var$nativeOnRE.test(key) && (0, $4bH2P.isString)(value)) return false;
    return key in el;
}
function $854720849964243d$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $cfZzL.defineComponent)(options);
    class VueCustomElement extends $854720849964243d$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $854720849964243d$export$6debb2e68f212638 = (options)=>{
    return $854720849964243d$export$a00e2346eabbdbef(options, $854720849964243d$export$fa8d919ba61d84db);
};
const $854720849964243d$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $854720849964243d$export$b337c1a55163dbe3 extends $854720849964243d$var$BaseClass {
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $cfZzL.nextTick)(()=>{
            if (!this._connected) {
                $854720849964243d$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $4bH2P.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $4bH2P.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $4bH2P.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $4bH2P.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $4bH2P.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $4bH2P.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $4bH2P.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $4bH2P.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $4bH2P.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $4bH2P.hyphenate)(key));
            }
        }
    }
    _update() {
        $854720849964243d$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $cfZzL.createVNode)(this._def, (0, $4bH2P.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $4bH2P.hyphenate)(event) !== event) dispatch((0, $4bH2P.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $854720849964243d$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
}
function $854720849964243d$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $cfZzL.getCurrentInstance)();
        if (!instance) return 0, $4bH2P.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $4bH2P.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $4bH2P.EMPTY_OBJ;
        return mod;
    }
}
function $854720849964243d$export$ef28b76f07940108(getter) {
    const instance = (0, $cfZzL.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$854720849964243d$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $854720849964243d$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $cfZzL.watchPostEffect)(setVars);
    (0, $cfZzL.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $cfZzL.onUnmounted)(()=>ob.disconnect());
    });
}
function $854720849964243d$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $854720849964243d$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $854720849964243d$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $cfZzL.Fragment)) vnode.children.forEach((c)=>$854720849964243d$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $cfZzL.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $854720849964243d$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $854720849964243d$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $854720849964243d$var$TRANSITION = "transition";
const $854720849964243d$var$ANIMATION = "animation";
const $854720849964243d$export$be58926105124dd4 = (props, { slots: slots })=>(0, $cfZzL.h)((0, $cfZzL.BaseTransition), $854720849964243d$var$resolveTransitionProps(props), slots);
$854720849964243d$export$be58926105124dd4.displayName = "Transition";
const $854720849964243d$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $854720849964243d$var$TransitionPropsValidators = $854720849964243d$export$be58926105124dd4.props = /* @__PURE__ */ (0, $4bH2P.extend)({}, (0, $cfZzL.BaseTransitionPropsValidators), $854720849964243d$var$DOMTransitionPropsValidators);
const $854720849964243d$var$callHook = (hook, args = [])=>{
    if ((0, $4bH2P.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $854720849964243d$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $4bH2P.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $854720849964243d$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $854720849964243d$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $854720849964243d$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $854720849964243d$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $854720849964243d$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $854720849964243d$var$removeTransitionClass(el, leaveFromClass);
        $854720849964243d$var$removeTransitionClass(el, leaveToClass);
        $854720849964243d$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $854720849964243d$var$callHook(hook, [
                el,
                resolve
            ]);
            $854720849964243d$var$nextFrame(()=>{
                $854720849964243d$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $854720849964243d$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$854720849964243d$var$hasExplicitCallback(hook)) $854720849964243d$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $4bH2P.extend)(baseProps, {
        onBeforeEnter (el) {
            $854720849964243d$var$callHook(onBeforeEnter, [
                el
            ]);
            $854720849964243d$var$addTransitionClass(el, enterFromClass);
            $854720849964243d$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $854720849964243d$var$callHook(onBeforeAppear, [
                el
            ]);
            $854720849964243d$var$addTransitionClass(el, appearFromClass);
            $854720849964243d$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $854720849964243d$var$addTransitionClass(el, leaveFromClass);
            $854720849964243d$var$forceReflow();
            $854720849964243d$var$addTransitionClass(el, leaveActiveClass);
            $854720849964243d$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $854720849964243d$var$removeTransitionClass(el, leaveFromClass);
                $854720849964243d$var$addTransitionClass(el, leaveToClass);
                if (!$854720849964243d$var$hasExplicitCallback(onLeave)) $854720849964243d$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $854720849964243d$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $854720849964243d$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $854720849964243d$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $854720849964243d$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $854720849964243d$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $4bH2P.isObject)(duration)) return [
        $854720849964243d$var$NumberOf(duration.enter),
        $854720849964243d$var$NumberOf(duration.leave)
    ];
    else {
        const n = $854720849964243d$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $854720849964243d$var$NumberOf(val) {
    const res = (0, $4bH2P.toNumber)(val);
    return res;
}
function $854720849964243d$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function $854720849964243d$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = void 0;
    }
}
function $854720849964243d$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $854720849964243d$var$endId = 0;
function $854720849964243d$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$854720849964243d$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $854720849964243d$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $854720849964243d$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$854720849964243d$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$854720849964243d$var$TRANSITION}Duration`);
    const transitionTimeout = $854720849964243d$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$854720849964243d$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$854720849964243d$var$ANIMATION}Duration`);
    const animationTimeout = $854720849964243d$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $854720849964243d$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $854720849964243d$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $854720849964243d$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $854720849964243d$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $854720849964243d$var$TRANSITION : $854720849964243d$var$ANIMATION : null;
        propCount = type ? type === $854720849964243d$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $854720849964243d$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$854720849964243d$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $854720849964243d$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$854720849964243d$var$toMs(d) + $854720849964243d$var$toMs(delays[i])));
}
function $854720849964243d$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $854720849964243d$var$forceReflow() {
    return document.body.offsetHeight;
}
const $854720849964243d$var$positionMap = /* @__PURE__ */ new WeakMap();
const $854720849964243d$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $854720849964243d$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $4bH2P.extend)({}, $854720849964243d$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $cfZzL.getCurrentInstance)();
        const state = (0, $cfZzL.useTransitionState)();
        let prevChildren;
        let children;
        (0, $cfZzL.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$854720849964243d$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($854720849964243d$var$callPendingCbs);
            prevChildren.forEach($854720849964243d$var$recordPosition);
            const movedChildren = prevChildren.filter($854720849964243d$var$applyTranslation);
            $854720849964243d$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $854720849964243d$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $854720849964243d$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $gGESn.toRaw)(props);
            const cssTransitionProps = $854720849964243d$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $cfZzL.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $cfZzL.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $cfZzL.setTransitionHooks)(child, (0, $cfZzL.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $cfZzL.setTransitionHooks)(child, (0, $cfZzL.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $854720849964243d$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $cfZzL.createVNode)(tag, null, children);
        };
    }
};
const $854720849964243d$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $854720849964243d$var$removeMode($854720849964243d$var$TransitionGroupImpl.props);
const $854720849964243d$export$19ffa8f511f7bc2e = $854720849964243d$var$TransitionGroupImpl;
function $854720849964243d$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $854720849964243d$var$recordPosition(c) {
    $854720849964243d$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $854720849964243d$var$applyTranslation(c) {
    const oldPos = $854720849964243d$var$positionMap.get(c);
    const newPos = $854720849964243d$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $854720849964243d$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $854720849964243d$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $854720849964243d$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $4bH2P.isArray)(fn) ? (value)=>(0, $4bH2P.invokeArrayFns)(fn, value) : fn;
};
function $854720849964243d$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $854720849964243d$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $854720849964243d$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $854720849964243d$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $4bH2P.looseToNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $854720849964243d$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $854720849964243d$var$addEventListener(el, "compositionstart", $854720849964243d$var$onCompositionStart);
            $854720849964243d$var$addEventListener(el, "compositionend", $854720849964243d$var$onCompositionEnd);
            $854720849964243d$var$addEventListener(el, "change", $854720849964243d$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $4bH2P.looseToNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $854720849964243d$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
        $854720849964243d$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $854720849964243d$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $4bH2P.isArray)(modelValue)) {
                const index = (0, $4bH2P.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $4bH2P.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($854720849964243d$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $854720849964243d$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
        $854720849964243d$var$setChecked(el, binding, vnode);
    }
};
function $854720849964243d$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $4bH2P.isArray)(value)) el.checked = (0, $4bH2P.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $4bH2P.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $4bH2P.looseEqual)(value, $854720849964243d$var$getCheckboxValue(el, true));
}
const $854720849964243d$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $4bH2P.looseEqual)(value, vnode.props.value);
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
        $854720849964243d$var$addEventListener(el, "change", ()=>{
            el._assign($854720849964243d$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $4bH2P.looseEqual)(value, vnode.props.value);
    }
};
const $854720849964243d$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $4bH2P.isSet)(value);
        $854720849964243d$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $4bH2P.looseToNumber)($854720849964243d$var$getValue(o)) : $854720849964243d$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $854720849964243d$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $854720849964243d$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $854720849964243d$var$setSelected(el, value);
    }
};
function $854720849964243d$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $4bH2P.isArray)(value) && !(0, $4bH2P.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $854720849964243d$var$getValue(option);
        if (isMultiple) {
            if ((0, $4bH2P.isArray)(value)) option.selected = (0, $4bH2P.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $4bH2P.looseEqual)($854720849964243d$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $854720849964243d$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $854720849964243d$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $854720849964243d$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $854720849964243d$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $854720849964243d$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $854720849964243d$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $854720849964243d$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $854720849964243d$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $854720849964243d$export$87d227567b51ca39;
        case "TEXTAREA":
            return $854720849964243d$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $854720849964243d$export$8847c2e532b35714;
                case "radio":
                    return $854720849964243d$export$b4356c59b38b7aa9;
                default:
                    return $854720849964243d$export$f1f88689f5728478;
            }
    }
}
function $854720849964243d$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $854720849964243d$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $854720849964243d$var$initVModelForSSR() {
    $854720849964243d$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $854720849964243d$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $4bH2P.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $854720849964243d$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $4bH2P.isArray)(value)) {
            if (vnode.props && (0, $4bH2P.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $4bH2P.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $854720849964243d$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $854720849964243d$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $854720849964243d$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $854720849964243d$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$854720849964243d$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $854720849964243d$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $854720849964243d$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
const $854720849964243d$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $854720849964243d$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $4bH2P.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $854720849964243d$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $854720849964243d$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $854720849964243d$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $854720849964243d$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $854720849964243d$var$setDisplay(el, false);
            });
        } else $854720849964243d$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $854720849964243d$var$setDisplay(el, value);
    }
};
function $854720849964243d$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
function $854720849964243d$var$initVShowForSSR() {
    $854720849964243d$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $854720849964243d$var$rendererOptions = /* @__PURE__ */ (0, $4bH2P.extend)({
    patchProp: $854720849964243d$var$patchProp
}, $854720849964243d$var$nodeOps);
let $854720849964243d$var$renderer;
let $854720849964243d$var$enabledHydration = false;
function $854720849964243d$var$ensureRenderer() {
    return $854720849964243d$var$renderer || ($854720849964243d$var$renderer = (0, $cfZzL.createRenderer)($854720849964243d$var$rendererOptions));
}
function $854720849964243d$var$ensureHydrationRenderer() {
    $854720849964243d$var$renderer = $854720849964243d$var$enabledHydration ? $854720849964243d$var$renderer : (0, $cfZzL.createHydrationRenderer)($854720849964243d$var$rendererOptions);
    $854720849964243d$var$enabledHydration = true;
    return $854720849964243d$var$renderer;
}
const $854720849964243d$export$b3890eb0ae9dca99 = (...args)=>{
    $854720849964243d$var$ensureRenderer().render(...args);
};
const $854720849964243d$export$fa8d919ba61d84db = (...args)=>{
    $854720849964243d$var$ensureHydrationRenderer().hydrate(...args);
};
const $854720849964243d$export$4e373c34abfa8c68 = (...args)=>{
    const app = $854720849964243d$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $854720849964243d$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $4bH2P.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $854720849964243d$export$35800275c0037383 = (...args)=>{
    const app = $854720849964243d$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $854720849964243d$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $854720849964243d$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $4bH2P.isHTMLTag)(tag) || (0, $4bH2P.isSVGTag)(tag),
        writable: false
    });
}
function $854720849964243d$var$injectCompilerOptionsCheck(app) {
    if ((0, $cfZzL.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $cfZzL.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $cfZzL.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $cfZzL.warn)(msg);
            }
        });
    }
}
function $854720849964243d$var$normalizeContainer(container) {
    if ((0, $4bH2P.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $854720849964243d$var$ssrDirectiveInitialized = false;
const $854720849964243d$export$800b28255aa678d9 = ()=>{
    if (!$854720849964243d$var$ssrDirectiveInitialized) {
        $854720849964243d$var$ssrDirectiveInitialized = true;
        $854720849964243d$var$initVModelForSSR();
        $854720849964243d$var$initVShowForSSR();
    }
};

});


parcelRequire.register("jgrCW", function(module, exports) {

$parcel$export(module.exports, "createPinia", function () { return $015536410247eacb$export$4b9f6a0748623d44; });
$parcel$export(module.exports, "defineStore", function () { return $015536410247eacb$export$5061c4f75bbcb4a; });
$parcel$export(module.exports, "mapStores", function () { return $015536410247eacb$export$4701f243feba9f88; });
$parcel$export(module.exports, "mapState", function () { return $015536410247eacb$export$a337c713bdba072; });
$parcel$export(module.exports, "mapActions", function () { return $015536410247eacb$export$1d73b9b98821f6dc; });
$parcel$export(module.exports, "mapWritableState", function () { return $015536410247eacb$export$c069310e76f1a3e7; });
/*!
  * pinia v2.0.29
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("aOmmZ");
var $cfZzL = parcelRequire("cfZzL");
var $gGESn = parcelRequire("gGESn");
var $aOmmZ = parcelRequire("aOmmZ");

var $hR09i = parcelRequire("hR09i");
/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */ let $015536410247eacb$var$activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */ const $015536410247eacb$export$89ffb8149ccd46af = (pinia)=>$015536410247eacb$var$activePinia = pinia;
/**
 * Get the currently active pinia if there is any.
 */ const $015536410247eacb$export$d0cc41ca14a2d060 = ()=>(0, $cfZzL.getCurrentInstance)() && (0, $cfZzL.inject)($015536410247eacb$var$piniaSymbol) || $015536410247eacb$var$activePinia;
const $015536410247eacb$var$piniaSymbol = /* istanbul ignore next */ Symbol();
function $015536410247eacb$var$isPlainObject(// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */ var $015536410247eacb$export$d97371ba8df8c539;
(function(MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */ MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */ MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */ MutationType["patchFunction"] = "patch function";
// maybe reset? for $state = {} and $reset
})($015536410247eacb$export$d97371ba8df8c539 || ($015536410247eacb$export$d97371ba8df8c539 = {}));
const $015536410247eacb$var$IS_CLIENT = typeof window !== "undefined";
/**
 * Should we add the devtools plugins.
 * - only if dev mode or forced through the prod devtools flag
 * - not in test
 * - only if window exists (could change in the future)
 */ const $015536410247eacb$var$USE_DEVTOOLS = typeof __VUE_PROD_DEVTOOLS__ !== "undefined" && __VUE_PROD_DEVTOOLS__ && true && $015536410247eacb$var$IS_CLIENT;
/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */ // The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const $015536410247eacb$var$_global = /*#__PURE__*/ (()=>typeof window === "object" && window.window === window ? window : typeof self === "object" && self.self === self ? self : typeof $parcel$global === "object" && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === "object" ? globalThis : {
        HTMLElement: null
    })();
function $015536410247eacb$var$bom(blob, { autoBom: autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(0xfeff),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $015536410247eacb$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = function() {
        $015536410247eacb$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error("could not download file");
    };
    xhr.send();
}
function $015536410247eacb$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open("HEAD", url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function $015536410247eacb$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent("click"));
    } catch (e) {
        const evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const $015536410247eacb$var$_navigator = typeof navigator === "object" ? navigator : {
    userAgent: ""
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const $015536410247eacb$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($015536410247eacb$var$_navigator.userAgent) && /AppleWebKit/.test($015536410247eacb$var$_navigator.userAgent) && !/Safari/.test($015536410247eacb$var$_navigator.userAgent))();
const $015536410247eacb$var$saveAs = !$015536410247eacb$var$IS_CLIENT ? ()=>{} // noop
 : typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !$015536410247eacb$var$isMacOSWebView ? $015536410247eacb$var$downloadSaveAs : "msSaveOrOpenBlob" in $015536410247eacb$var$_navigator ? $015536410247eacb$var$msSaveAs : $015536410247eacb$var$fileSaverSaveAs;
function $015536410247eacb$var$downloadSaveAs(blob, name = "download", opts) {
    const a = document.createElement("a");
    a.download = name;
    a.rel = "noopener"; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === "string") {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($015536410247eacb$var$corsEnabled(a.href)) $015536410247eacb$var$download(blob, name, opts);
            else {
                a.target = "_blank";
                $015536410247eacb$var$click(a);
            }
        } else $015536410247eacb$var$click(a);
    } else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function() {
            $015536410247eacb$var$click(a);
        }, 0);
    }
}
function $015536410247eacb$var$msSaveAs(blob, name = "download", opts) {
    if (typeof blob === "string") {
        if ($015536410247eacb$var$corsEnabled(blob)) $015536410247eacb$var$download(blob, name, opts);
        else {
            const a = document.createElement("a");
            a.href = blob;
            a.target = "_blank";
            setTimeout(function() {
                $015536410247eacb$var$click(a);
            });
        }
    } else // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob($015536410247eacb$var$bom(blob, opts), name);
}
function $015536410247eacb$var$fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open("", "_blank");
    if (popup) popup.document.title = popup.document.body.innerText = "downloading...";
    if (typeof blob === "string") return $015536410247eacb$var$download(blob, name, opts);
    const force = blob.type === "application/octet-stream";
    const isSafari = /constructor/i.test(String($015536410247eacb$var$_global.HTMLElement)) || "safari" in $015536410247eacb$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $015536410247eacb$var$isMacOSWebView) && typeof FileReader !== "undefined") {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== "string") {
                popup = null;
                throw new Error("Wrong reader.result type");
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}
/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */ function $015536410247eacb$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === "function") __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    else if (type === "error") console.error(piniaMessage);
    else if (type === "warn") console.warn(piniaMessage);
    else console.log(piniaMessage);
}
function $015536410247eacb$var$isPinia(o) {
    return "_a" in o && "install" in o;
}
function $015536410247eacb$var$checkClipboardAccess() {
    if (!("clipboard" in navigator)) {
        $015536410247eacb$var$toastMessage(`Your browser doesn't support the Clipboard API`, "error");
        return true;
    }
}
function $015536410247eacb$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes("document is not focused")) {
        $015536410247eacb$var$toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn");
        return true;
    }
    return false;
}
async function $015536410247eacb$var$actionGlobalCopyState(pinia) {
    if ($015536410247eacb$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $015536410247eacb$var$toastMessage("Global state copied to clipboard.");
    } catch (error) {
        if ($015536410247eacb$var$checkNotFocusedError(error)) return;
        $015536410247eacb$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $015536410247eacb$var$actionGlobalPasteState(pinia) {
    if ($015536410247eacb$var$checkClipboardAccess()) return;
    try {
        pinia.state.value = JSON.parse(await navigator.clipboard.readText());
        $015536410247eacb$var$toastMessage("Global state pasted from clipboard.");
    } catch (error) {
        if ($015536410247eacb$var$checkNotFocusedError(error)) return;
        $015536410247eacb$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, "error");
        console.error(error);
    }
}
async function $015536410247eacb$var$actionGlobalSaveState(pinia) {
    try {
        $015536410247eacb$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: "text/plain;charset=utf-8"
        }), "pinia-state.json");
    } catch (error) {
        $015536410247eacb$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
let $015536410247eacb$var$fileInput;
function $015536410247eacb$var$getFileOpener() {
    if (!$015536410247eacb$var$fileInput) {
        $015536410247eacb$var$fileInput = document.createElement("input");
        $015536410247eacb$var$fileInput.type = "file";
        $015536410247eacb$var$fileInput.accept = ".json";
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $015536410247eacb$var$fileInput.onchange = async ()=>{
                const files = $015536410247eacb$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            $015536410247eacb$var$fileInput.oncancel = ()=>resolve(null);
            $015536410247eacb$var$fileInput.onerror = reject;
            $015536410247eacb$var$fileInput.click();
        });
    }
    return openFile;
}
async function $015536410247eacb$var$actionGlobalOpenStateFile(pinia) {
    try {
        const open1 = await $015536410247eacb$var$getFileOpener();
        const result = await open1();
        if (!result) return;
        const { text: text, file: file } = result;
        pinia.state.value = JSON.parse(text);
        $015536410247eacb$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $015536410247eacb$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, "error");
        console.error(error);
    }
}
function $015536410247eacb$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $015536410247eacb$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $015536410247eacb$var$PINIA_ROOT_ID = "_root";
function $015536410247eacb$var$formatStoreForInspectorTree(store) {
    return $015536410247eacb$var$isPinia(store) ? {
        id: $015536410247eacb$var$PINIA_ROOT_ID,
        label: $015536410247eacb$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $015536410247eacb$var$formatStoreForInspectorState(store) {
    if ($015536410247eacb$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: false,
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $015536410247eacb$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) // TODO: handle add and delete for arrays and objects
    return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $015536410247eacb$var$formatDisplay(events.type),
        key: $015536410247eacb$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $015536410247eacb$var$formatMutationType(type) {
    switch(type){
        case $015536410247eacb$export$d97371ba8df8c539.direct:
            return "mutation";
        case $015536410247eacb$export$d97371ba8df8c539.patchFunction:
            return "$patch";
        case $015536410247eacb$export$d97371ba8df8c539.patchObject:
            return "$patch";
        default:
            return "unknown";
    }
}
// timeline can be paused when directly changing the state
let $015536410247eacb$var$isTimelineActive = true;
const $015536410247eacb$var$componentStateTypes = [];
const $015536410247eacb$var$MUTATIONS_LAYER_ID = "pinia:mutations";
const $015536410247eacb$var$INSPECTOR_ID = "pinia";
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */ const $015536410247eacb$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */ function $015536410247eacb$var$registerPiniaDevtools(app, pinia) {
    (0, $hR09i.setupDevtoolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $015536410247eacb$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $015536410247eacb$var$toastMessage("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.addTimelineLayer({
            id: $015536410247eacb$var$MUTATIONS_LAYER_ID,
            label: `Pinia 🍍`,
            color: 0xe5df88
        });
        api.addInspector({
            id: $015536410247eacb$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: "storage",
            treeFilterPlaceholder: "Search stores",
            actions: [
                {
                    icon: "content_copy",
                    action: ()=>{
                        $015536410247eacb$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: "Serialize and copy the state"
                },
                {
                    icon: "content_paste",
                    action: async ()=>{
                        await $015536410247eacb$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($015536410247eacb$var$INSPECTOR_ID);
                        api.sendInspectorState($015536410247eacb$var$INSPECTOR_ID);
                    },
                    tooltip: "Replace the state with the content of your clipboard"
                },
                {
                    icon: "save",
                    action: ()=>{
                        $015536410247eacb$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: "Save the state as a JSON file"
                },
                {
                    icon: "folder_open",
                    action: async ()=>{
                        await $015536410247eacb$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($015536410247eacb$var$INSPECTOR_ID);
                        api.sendInspectorState($015536410247eacb$var$INSPECTOR_ID);
                    },
                    tooltip: "Import the state from a JSON file"
                }
            ],
            nodeActions: [
                {
                    icon: "restore",
                    tooltip: "Reset the state (option store only)",
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $015536410247eacb$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, "warn");
                        else if (!store._isOptionsAPI) $015536410247eacb$var$toastMessage(`Cannot reset "${nodeId}" store because it's a setup store.`, "warn");
                        else {
                            store.$reset();
                            $015536410247eacb$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload, ctx)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $015536410247eacb$var$getStoreType(store.$id),
                        key: "state",
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $gGESn.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: "restore",
                                        tooltip: "Reset the state of this store",
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $015536410247eacb$var$getStoreType(store.$id),
                        key: "getters",
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                // @ts-expect-error: we just want to show it in devtools
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $015536410247eacb$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>"$id" in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $015536410247eacb$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($015536410247eacb$var$formatStoreForInspectorTree);
            }
        });
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $015536410247eacb$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $015536410247eacb$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) // this could be the selected store restored for a different project
                // so it's better not to say anything here
                return;
                if (inspectedStore) payload.state = $015536410247eacb$var$formatStoreForInspectorState(inspectedStore);
            }
        });
        api.on.editInspectorState((payload, ctx)=>{
            if (payload.app === app && payload.inspectorId === $015536410247eacb$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $015536410247eacb$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $015536410247eacb$var$toastMessage(`store "${payload.nodeId}" not found`, "error");
                const { path: path } = payload;
                if (!$015536410247eacb$var$isPinia(inspectedStore)) // access only the state
                {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift("$state");
                } else // Root access, we can omit the `.value` because the devtools API does it for us
                path.unshift("state");
                $015536410247eacb$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $015536410247eacb$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, "");
                const store = pinia._s.get(storeId);
                if (!store) return $015536410247eacb$var$toastMessage(`store "${storeId}" not found`, "error");
                const { path: path } = payload;
                if (path[0] !== "state") return $015536410247eacb$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = "$state";
                $015536410247eacb$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $015536410247eacb$var$isTimelineActive = true;
            }
        });
    });
}
function $015536410247eacb$var$addStoreToDevtools(app, store) {
    if (!$015536410247eacb$var$componentStateTypes.includes($015536410247eacb$var$getStoreType(store.$id))) $015536410247eacb$var$componentStateTypes.push($015536410247eacb$var$getStoreType(store.$id));
    (0, $hR09i.setupDevtoolsPlugin)({
        id: "dev.esm.pinia",
        label: "Pinia \uD83C\uDF4D",
        logo: "https://pinia.vuejs.org/logo.svg",
        packageName: "pinia",
        homepage: "https://pinia.vuejs.org",
        componentStateTypes: $015536410247eacb$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: "Notify about new/deleted stores",
                type: "boolean",
                defaultValue: true
            }
        }
    }, (api)=>{
        // gracefully handle errors
        const now = typeof api.now === "function" ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $015536410247eacb$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $015536410247eacb$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: "start",
                    data: {
                        store: $015536410247eacb$var$formatDisplay(store.$id),
                        action: $015536410247eacb$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $015536410247eacb$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $015536410247eacb$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: "end",
                        data: {
                            store: $015536410247eacb$var$formatDisplay(store.$id),
                            action: $015536410247eacb$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $015536410247eacb$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $015536410247eacb$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: "error",
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: "end",
                        data: {
                            store: $015536410247eacb$var$formatDisplay(store.$id),
                            action: $015536410247eacb$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $cfZzL.watch)(()=>(0, $gGESn.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($015536410247eacb$var$INSPECTOR_ID);
                if ($015536410247eacb$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $015536410247eacb$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "Change",
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $015536410247eacb$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($015536410247eacb$var$INSPECTOR_ID);
            if (!$015536410247eacb$var$isTimelineActive) return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: $015536410247eacb$var$formatMutationType(type),
                data: {
                    store: $015536410247eacb$var$formatDisplay(store.$id),
                    ...$015536410247eacb$var$formatEventData(events)
                },
                groupId: $015536410247eacb$var$activeAction
            };
            // reset for the next mutation
            $015536410247eacb$var$activeAction = undefined;
            if (type === $015536410247eacb$export$d97371ba8df8c539.patchFunction) eventData.subtitle = "⤵️";
            else if (type === $015536410247eacb$export$d97371ba8df8c539.patchObject) eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data["rawEvent(s)"] = {
                _custom: {
                    display: "DebuggerEvent",
                    type: "object",
                    tooltip: "raw DebuggerEvent[]",
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $015536410247eacb$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: "sync"
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $gGESn.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $015536410247eacb$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: "HMR update",
                    data: {
                        store: $015536410247eacb$var$formatDisplay(store.$id),
                        info: $015536410247eacb$var$formatDisplay(`HMR update`)
                    }
                }
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree($015536410247eacb$var$INSPECTOR_ID);
            api.sendInspectorState($015536410247eacb$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($015536410247eacb$var$INSPECTOR_ID);
            api.sendInspectorState($015536410247eacb$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $015536410247eacb$var$toastMessage(`Disposed "${store.$id}" store 🗑`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree($015536410247eacb$var$INSPECTOR_ID);
        api.sendInspectorState($015536410247eacb$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $015536410247eacb$var$toastMessage(`"${store.$id}" store installed 🆕`);
    });
}
let $015536410247eacb$var$runningActionId = 0;
let $015536410247eacb$var$activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */ function $015536410247eacb$var$patchActionForGrouping(store, actionNames) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName)=>{
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0, $gGESn.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        // setActivePinia(store._p)
        // the running action id is incremented in a before action hook
        const _actionId = $015536410247eacb$var$runningActionId;
        const trackedStore = new Proxy(store, {
            get (...args) {
                $015536410247eacb$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $015536410247eacb$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        });
        return actions[actionName].apply(trackedStore, arguments);
    };
}
/**
 * pinia.use(devtoolsPlugin)
 */ function $015536410247eacb$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    // HMR module
    if (store.$id.startsWith("__hot:")) return;
    // detect option api vs setup api
    if (options.state) store._isOptionsAPI = true;
    // only wrap actions in option-defined stores as this technique relies on
    // wrapping the context of the action with a proxy
    if (typeof options.state === "function") {
        $015536410247eacb$var$patchActionForGrouping(// @ts-expect-error: can cast the store...
        store, Object.keys(options.actions));
        const originalHotUpdate = store._hotUpdate;
        // Upgrade the HMR to also update the new actions
        (0, $gGESn.toRaw)(store)._hotUpdate = function(newStore) {
            originalHotUpdate.apply(this, arguments);
            $015536410247eacb$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions));
        };
    }
    $015536410247eacb$var$addStoreToDevtools(app, // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}
/**
 * Creates a Pinia instance to be used by the application
 */ function $015536410247eacb$export$4b9f6a0748623d44() {
    const scope = (0, $gGESn.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(()=>(0, $gGESn.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0, $gGESn.markRaw)({
        install (app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            $015536410247eacb$export$89ffb8149ccd46af(pinia);
            if (!(0, $aOmmZ.isVue2)) {
                pinia._a = app;
                app.provide($015536410247eacb$var$piniaSymbol, pinia);
                app.config.globalProperties.$pinia = pinia;
                /* istanbul ignore else */ if ($015536410247eacb$var$USE_DEVTOOLS) $015536410247eacb$var$registerPiniaDevtools(app, pinia);
                toBeInstalled.forEach((plugin)=>_p.push(plugin));
                toBeInstalled = [];
            }
        },
        use (plugin) {
            if (!this._a && !(0, $aOmmZ.isVue2)) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state: state
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if ($015536410247eacb$var$USE_DEVTOOLS && typeof Proxy !== "undefined") pinia.use($015536410247eacb$var$devtoolsPlugin);
    return pinia;
}
/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */ const $015536410247eacb$var$isUseStore = (fn)=>{
    return typeof fn === "function" && typeof fn.$id === "string";
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */ function $015536410247eacb$var$patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in oldState){
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($015536410247eacb$var$isPlainObject(targetValue) && $015536410247eacb$var$isPlainObject(subPatch) && !(0, $gGESn.isRef)(subPatch) && !(0, $gGESn.isReactive)(subPatch)) newState[key] = $015536410247eacb$var$patchObject(targetValue, subPatch);
        else // objects are either a bit more complex (e.g. refs) or primitives, so we
        // just set the whole thing
        if (0, $aOmmZ.isVue2) (0, $aOmmZ.set)(newState, key, subPatch);
        else newState[key] = subPatch;
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */ function $015536410247eacb$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
const $015536410247eacb$var$noop = ()=>{};
function $015536410247eacb$var$addSubscription(subscriptions, callback, detached, onCleanup = $015536410247eacb$var$noop) {
    subscriptions.push(callback);
    const removeSubscription = ()=>{
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && (0, $gGESn.getCurrentScope)()) (0, $gGESn.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $015536410247eacb$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback)=>{
        callback(...args);
    });
}
function $015536410247eacb$var$mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    // Handle Set instances
    if (target instanceof Set && patchToApply instanceof Set) patchToApply.forEach(target.add, target);
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in patchToApply){
        if (!patchToApply.hasOwnProperty(key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($015536410247eacb$var$isPlainObject(targetValue) && $015536410247eacb$var$isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, $gGESn.isRef)(subPatch) && !(0, $gGESn.isReactive)(subPatch)) // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
        // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
        // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
        target[key] = $015536410247eacb$var$mergeReactiveObjects(targetValue, subPatch);
        else // @ts-expect-error: subPatch is a valid value
        target[key] = subPatch;
    }
    return target;
}
const $015536410247eacb$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
const $015536410247eacb$var$skipHydrateMap = /*#__PURE__*/ new WeakMap();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */ function $015536410247eacb$export$dbb88672ab248e88(obj) {
    return (0, $aOmmZ.isVue2) ? /* istanbul ignore next */ $015536410247eacb$var$skipHydrateMap.set(obj, 1) && obj : Object.defineProperty(obj, $015536410247eacb$var$skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */ function $015536410247eacb$var$shouldHydrate(obj) {
    return (0, $aOmmZ.isVue2) ? /* istanbul ignore next */ !$015536410247eacb$var$skipHydrateMap.has(obj) : !$015536410247eacb$var$isPlainObject(obj) || !obj.hasOwnProperty($015536410247eacb$var$skipHydrateSymbol);
}
const { assign: $015536410247eacb$var$assign } = Object;
function $015536410247eacb$var$isComputed(o) {
    return !!((0, $gGESn.isRef)(o) && o.effect);
}
function $015536410247eacb$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) {
            /* istanbul ignore if */ if (0, $aOmmZ.isVue2) (0, $aOmmZ.set)(pinia.state.value, id, state ? state() : {});
            else pinia.state.value[id] = state ? state() : {};
        }
        // avoid creating a state in pinia.state.value
        const localState = (0, $gGESn.toRefs)(pinia.state.value[id]);
        return $015536410247eacb$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $gGESn.markRaw)((0, $gGESn.computed)(()=>{
                $015536410247eacb$export$89ffb8149ccd46af(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                /* istanbul ignore next */ if ((0, $aOmmZ.isVue2) && !store._r) return;
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $015536410247eacb$var$createSetupStore(id, setup, options, pinia, hot, true);
    store.$reset = function $reset() {
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state)=>{
            $015536410247eacb$var$assign($state, newState);
        });
    };
    return store;
}
function $015536410247eacb$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $015536410247eacb$var$assign({
        actions: {}
    }, options);
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true
    };
    var event;
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = (0, $gGESn.markRaw)([]);
    let actionSubscriptions = (0, $gGESn.markRaw)([]);
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && true) {
        /* istanbul ignore if */ if (0, $aOmmZ.isVue2) (0, $aOmmZ.set)(pinia.state.value, $id, {});
        else pinia.state.value[$id] = {};
    }
    const hotState = (0, $gGESn.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === "function") {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: $015536410247eacb$export$d97371ba8df8c539.patchFunction,
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $015536410247eacb$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: $015536410247eacb$export$d97371ba8df8c539.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $cfZzL.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        $015536410247eacb$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    /* istanbul ignore next */ const $reset = $015536410247eacb$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Wraps an action to handle subscriptions.
     *
     * @param name - name of the action
     * @param action - action to wrap
     * @returns a wrapped action to handle subscriptions
     */ function wrapAction(name, action) {
        return function() {
            $015536410247eacb$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            $015536410247eacb$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: name,
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = action.apply(this && this.$id === $id ? this : store, args);
            // handle sync errors
            } catch (error) {
                $015536410247eacb$var$triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $015536410247eacb$var$triggerSubscriptions(afterCallbackList, value);
                return value;
            }).catch((error)=>{
                $015536410247eacb$var$triggerSubscriptions(onErrorCallbackList, error);
                return Promise.reject(error);
            });
            // allow the afterCallback to override the return value
            $015536410247eacb$var$triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
    }
    const _hmrPayload = /*#__PURE__*/ (0, $gGESn.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: // _s: scope,
        $id,
        $onAction: $015536410247eacb$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            const removeSubscription = $015536410247eacb$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $cfZzL.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === "sync" ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: $015536410247eacb$export$d97371ba8df8c539.direct,
                        events: debuggerEvents
                    }, state);
                }, $015536410247eacb$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    /* istanbul ignore if */ if (0, $aOmmZ.isVue2) // start as non ready
    partialStore._r = false;
    const store = (0, $gGESn.reactive)($015536410247eacb$var$USE_DEVTOOLS ? $015536410247eacb$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $gGESn.markRaw)(new Set())
    }, partialStore) : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = pinia._e.run(()=>{
        scope = (0, $gGESn.effectScope)();
        return scope.run(()=>setup());
    });
    // overwrite existing actions to support $onAction
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $gGESn.isRef)(prop) && !$015536410247eacb$var$isComputed(prop) || (0, $gGESn.isReactive)(prop)) {
            if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && $015536410247eacb$var$shouldHydrate(prop)) {
                    if ((0, $gGESn.isRef)(prop)) prop.value = initialState[key];
                    else // probably a reactive object, lets recursively assign
                    // @ts-expect-error: prop is unknown
                    $015536410247eacb$var$mergeReactiveObjects(prop, initialState[key]);
                }
                // transfer the ref to the pinia state to keep everything in sync
                /* istanbul ignore if */ if (0, $aOmmZ.isVue2) (0, $aOmmZ.set)(pinia.state.value[$id], key, prop);
                else pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === "function") {
            // @ts-expect-error: we are overriding the function we avoid wrapping if
            const actionValue = wrapAction(key, prop);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            /* istanbul ignore if */ if (0, $aOmmZ.isVue2) (0, $aOmmZ.set)(setupStore, key, actionValue);
            else // @ts-expect-error
            setupStore[key] = actionValue;
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */ if (0, $aOmmZ.isVue2) Object.keys(setupStore).forEach((key)=>{
        (0, $aOmmZ.set)(store, key, setupStore[key]);
    });
    else {
        $015536410247eacb$var$assign(store, setupStore);
        // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
        // Make `storeToRefs()` work with `reactive()` #799
        $015536410247eacb$var$assign((0, $gGESn.toRaw)(store), setupStore);
    }
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, "$state", {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                $015536410247eacb$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if ($015536410247eacb$var$USE_DEVTOOLS) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false
        };
        [
            "_p",
            "_hmrPayload",
            "_getters",
            "_customProperties"
        ].forEach((p)=>{
            Object.defineProperty(store, p, {
                value: store[p],
                ...nonEnumerable
            });
        });
    }
    /* istanbul ignore if */ if (0, $aOmmZ.isVue2) // mark the store as ready before plugins
    store._r = true;
    // apply all plugins
    pinia._p.forEach((extender)=>{
        /* istanbul ignore else */ if ($015536410247eacb$var$USE_DEVTOOLS) {
            const extensions = scope.run(()=>extender({
                    store: store,
                    app: pinia._a,
                    pinia: pinia,
                    options: optionsForPlugin
                }));
            Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
            $015536410247eacb$var$assign(store, extensions);
        } else $015536410247eacb$var$assign(store, scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            })));
    });
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
function $015536410247eacb$export$5061c4f75bbcb4a(// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
    let id;
    let options;
    const isSetupStore = typeof setup === "function";
    if (typeof idOrOptions === "string") {
        id = idOrOptions;
        // the option store setup will contain the actual options in this case
        options = isSetupStore ? setupOptions : setup;
    } else {
        options = idOrOptions;
        id = idOrOptions.id;
    }
    function useStore(pinia, hot) {
        const currentInstance = (0, $cfZzL.getCurrentInstance)();
        pinia = pinia || currentInstance && (0, $cfZzL.inject)($015536410247eacb$var$piniaSymbol, null);
        if (pinia) $015536410247eacb$export$89ffb8149ccd46af(pinia);
        pinia = $015536410247eacb$var$activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) $015536410247eacb$var$createSetupStore(id, setup, options, pinia);
            else $015536410247eacb$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}
let $015536410247eacb$var$mapStoreSuffix = "Store";
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */ function $015536410247eacb$export$3c0d0850ffd38177(suffix // could be 'Store' but that would be annoying for JS
) {
    $015536410247eacb$var$mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */ function $015536410247eacb$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + $015536410247eacb$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $015536410247eacb$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            // for some reason TS is unable to infer the type of storeKey to be a
            // function
            return typeof storeKey === "function" ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */ const $015536410247eacb$export$74d9085e6d5a97cb = $015536410247eacb$export$a337c713bdba072;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $015536410247eacb$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $015536410247eacb$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-ignore
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                // it's easier to type it here as any
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-ignore
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                // it's easier to type it here as any
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */ function $015536410247eacb$export$586af8bd019552de(store) {
    // See https://github.com/vuejs/pinia/issues/852
    // It's easier to just use toRefs() even if it includes more stuff
    if (0, $aOmmZ.isVue2) // @ts-expect-error: toRefs include methods and others
    return (0, $gGESn.toRefs)(store);
    else {
        store = (0, $gGESn.toRaw)(store);
        const refs = {};
        for(const key in store){
            const value = store[key];
            if ((0, $gGESn.isRef)(value) || (0, $gGESn.isReactive)(value)) // @ts-expect-error: the key is state or getter
            refs[key] = // ---
            (0, $gGESn.toRef)(store, key);
        }
        return refs;
    }
}
/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */ const $015536410247eacb$export$a99c5571bb37058e = function(_Vue) {
    // Equivalent of
    // app.config.globalProperties.$pinia = pinia
    _Vue.mixin({
        beforeCreate () {
            const options = this.$options;
            if (options.pinia) {
                const pinia = options.pinia;
                // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
                /* istanbul ignore else */ if (!this._provided) {
                    const provideCache = {};
                    Object.defineProperty(this, "_provided", {
                        get: ()=>provideCache,
                        set: (v)=>Object.assign(provideCache, v)
                    });
                }
                this._provided[$015536410247eacb$var$piniaSymbol] = pinia;
                // propagate the pinia instance in an SSR friendly way
                // avoid adding it to nuxt twice
                /* istanbul ignore else */ if (!this.$pinia) this.$pinia = pinia;
                pinia._a = this;
                if ($015536410247eacb$var$IS_CLIENT) // this allows calling useStore() outside of a component setup after
                // installing pinia's plugin
                $015536410247eacb$export$89ffb8149ccd46af(pinia);
                if ($015536410247eacb$var$USE_DEVTOOLS) $015536410247eacb$var$registerPiniaDevtools(pinia._a, pinia);
            } else if (!this.$pinia && options.parent && options.parent.$pinia) this.$pinia = options.parent.$pinia;
        },
        destroyed () {
            delete this._pStores;
        }
    });
};

});
parcelRequire.register("aOmmZ", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("gGESn")).computed; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("gGESn")).effectScope; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("cfZzL")).getCurrentInstance; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("gGESn")).getCurrentScope; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("cfZzL")).inject; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("gGESn")).isReactive; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("gGESn")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("gGESn")).markRaw; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("cfZzL")).nextTick; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("gGESn")).onScopeDispose; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("gGESn")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("gGESn")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("gGESn")).toRaw; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("gGESn")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("gGESn")).toRefs; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("gGESn")).unref; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("cfZzL")).watch; });

$parcel$export(module.exports, "isVue2", function () { return $cbf7cc4ffd949d75$export$1da84e343e81ceb9; });
$parcel$export(module.exports, "set", function () { return $cbf7cc4ffd949d75$export$adaa4cf7ef1b65be; });
parcelRequire("efXw5");
var $cbf7cc4ffd949d75$export$1da84e343e81ceb9 = false;
var $cbf7cc4ffd949d75$export$34b222e3d4733e48 = true;
var $cbf7cc4ffd949d75$export$a8cb34872e7d8b79 = undefined;
function $cbf7cc4ffd949d75$export$4b3e715f166fdd78() {}
function $cbf7cc4ffd949d75$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $cbf7cc4ffd949d75$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});

parcelRequire.register("hR09i", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", function () { return $cff7807d156e383d$export$63b9a9bba9f20f3e; });

var $gyGpI = parcelRequire("gyGpI");

var $eYtcq = parcelRequire("eYtcq");

var $iJzzA = parcelRequire("iJzzA");



function $cff7807d156e383d$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $gyGpI.getTarget)();
    const hook = (0, $gyGpI.getDevtoolsGlobalHook)();
    const enableProxy = (0, $gyGpI.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $eYtcq.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $iJzzA.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRequire.register("gyGpI", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", function () { return $c0e0b8caf85bfaac$export$5a2d366b2d9f38f6; });
$parcel$export(module.exports, "getTarget", function () { return $c0e0b8caf85bfaac$export$c22522a4dfa48e9c; });
$parcel$export(module.exports, "isProxyAvailable", function () { return $c0e0b8caf85bfaac$export$bc32a04c49ed7464; });
function $c0e0b8caf85bfaac$export$5a2d366b2d9f38f6() {
    return $c0e0b8caf85bfaac$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $c0e0b8caf85bfaac$export$c22522a4dfa48e9c() {
    // @ts-ignore
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
}
const $c0e0b8caf85bfaac$export$bc32a04c49ed7464 = typeof Proxy === "function";

});

parcelRequire.register("eYtcq", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", function () { return $ae6d51aaabd77ded$export$b1499c3bd2a3f4df; });
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", function () { return $ae6d51aaabd77ded$export$a0897f44accbe922; });
const $ae6d51aaabd77ded$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $ae6d51aaabd77ded$export$a0897f44accbe922 = "plugin:settings:set";

});

parcelRequire.register("iJzzA", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", function () { return $da380606584b630e$export$5728f3776e9b2ac1; });

var $eYtcq = parcelRequire("eYtcq");

var $7X1Ox = parcelRequire("7X1Ox");
class $da380606584b630e$export$5728f3776e9b2ac1 {
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $7X1Ox.now)();
            }
        };
        if (hook) hook.on((0, $eYtcq.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
}

});
parcelRequire.register("7X1Ox", function(module, exports) {

$parcel$export(module.exports, "now", function () { return $5c9f735354ad8453$export$461939dd4422153; });
let $5c9f735354ad8453$var$supported;
let $5c9f735354ad8453$var$perf;
function $5c9f735354ad8453$export$70d26280bc1ca547() {
    var _a;
    if ($5c9f735354ad8453$var$supported !== undefined) return $5c9f735354ad8453$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $5c9f735354ad8453$var$supported = true;
        $5c9f735354ad8453$var$perf = window.performance;
    } else if (typeof $parcel$global !== "undefined" && ((_a = $parcel$global.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $5c9f735354ad8453$var$supported = true;
        $5c9f735354ad8453$var$perf = $parcel$global.perf_hooks.performance;
    } else $5c9f735354ad8453$var$supported = false;
    return $5c9f735354ad8453$var$supported;
}
function $5c9f735354ad8453$export$461939dd4422153() {
    return $5c9f735354ad8453$export$70d26280bc1ca547() ? $5c9f735354ad8453$var$perf.now() : Date.now();
}

});




parcelRequire.register("7XpJX", function(module, exports) {

$parcel$export(module.exports, "createWebHistory", function () { return $5ecf7229ed3af5a9$export$7b4942f78e7b8a49; });
$parcel$export(module.exports, "RouterLink", function () { return $5ecf7229ed3af5a9$export$fce709ebdac448ed; });
$parcel$export(module.exports, "createRouter", function () { return $5ecf7229ed3af5a9$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "useRouter", function () { return $5ecf7229ed3af5a9$export$9a302a45f65d0572; });
$parcel$export(module.exports, "useRoute", function () { return $5ecf7229ed3af5a9$export$3f79f0b98112cf57; });
/*!
  * vue-router v4.1.6
  * (c) 2022 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $gGESn = parcelRequire("gGESn");

var $hR09i = parcelRequire("hR09i");
const $5ecf7229ed3af5a9$var$isBrowser = typeof window !== "undefined";
function $5ecf7229ed3af5a9$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $5ecf7229ed3af5a9$var$assign = Object.assign;
function $5ecf7229ed3af5a9$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $5ecf7229ed3af5a9$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $5ecf7229ed3af5a9$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $5ecf7229ed3af5a9$var$isArray = Array.isArray;
function $5ecf7229ed3af5a9$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
const $5ecf7229ed3af5a9$var$TRAILING_SLASH_RE = /\/$/;
const $5ecf7229ed3af5a9$var$removeTrailingSlash = (path)=>path.replace($5ecf7229ed3af5a9$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $5ecf7229ed3af5a9$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $5ecf7229ed3af5a9$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: hash
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $5ecf7229ed3af5a9$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $5ecf7229ed3af5a9$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $5ecf7229ed3af5a9$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $5ecf7229ed3af5a9$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $5ecf7229ed3af5a9$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $5ecf7229ed3af5a9$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $5ecf7229ed3af5a9$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$5ecf7229ed3af5a9$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $5ecf7229ed3af5a9$var$isSameRouteLocationParamsValue(a, b) {
    return $5ecf7229ed3af5a9$var$isArray(a) ? $5ecf7229ed3af5a9$var$isEquivalentArray(a, b) : $5ecf7229ed3af5a9$var$isArray(b) ? $5ecf7229ed3af5a9$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $5ecf7229ed3af5a9$var$isEquivalentArray(a, b) {
    return $5ecf7229ed3af5a9$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $5ecf7229ed3af5a9$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments// ensure we use at least the last element in the toSegments
    .slice(toPosition - (toPosition === toSegments.length ? 1 : 0)).join("/");
}
var $5ecf7229ed3af5a9$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($5ecf7229ed3af5a9$var$NavigationType || ($5ecf7229ed3af5a9$var$NavigationType = {}));
var $5ecf7229ed3af5a9$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($5ecf7229ed3af5a9$var$NavigationDirection || ($5ecf7229ed3af5a9$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $5ecf7229ed3af5a9$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $5ecf7229ed3af5a9$var$normalizeBase(base) {
    if (!base) {
        if ($5ecf7229ed3af5a9$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $5ecf7229ed3af5a9$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $5ecf7229ed3af5a9$var$BEFORE_HASH_RE = /^[^#]+#/;
function $5ecf7229ed3af5a9$var$createHref(base, location1) {
    return base.replace($5ecf7229ed3af5a9$var$BEFORE_HASH_RE, "#") + location1;
}
function $5ecf7229ed3af5a9$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $5ecf7229ed3af5a9$var$computeScrollPosition = ()=>({
        left: window.pageXOffset,
        top: window.pageYOffset
    });
function $5ecf7229ed3af5a9$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $5ecf7229ed3af5a9$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.pageXOffset, scrollToOptions.top != null ? scrollToOptions.top : window.pageYOffset);
}
function $5ecf7229ed3af5a9$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $5ecf7229ed3af5a9$var$scrollPositions = new Map();
function $5ecf7229ed3af5a9$var$saveScrollPosition(key, scrollPosition) {
    $5ecf7229ed3af5a9$var$scrollPositions.set(key, scrollPosition);
}
function $5ecf7229ed3af5a9$var$getSavedScrollPosition(key) {
    const scroll = $5ecf7229ed3af5a9$var$scrollPositions.get(key);
    // consume it so it's not used again
    $5ecf7229ed3af5a9$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $5ecf7229ed3af5a9$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param location -
 */ function $5ecf7229ed3af5a9$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $5ecf7229ed3af5a9$var$stripBase(pathFromHash, "");
    }
    const path = $5ecf7229ed3af5a9$var$stripBase(pathname, base);
    return path + search + hash;
}
function $5ecf7229ed3af5a9$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $5ecf7229ed3af5a9$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // console.log({ deltaFromCurrent })
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $5ecf7229ed3af5a9$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $5ecf7229ed3af5a9$var$NavigationDirection.forward : $5ecf7229ed3af5a9$var$NavigationDirection.back : $5ecf7229ed3af5a9$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($5ecf7229ed3af5a9$var$assign({}, history1.state, {
            scroll: $5ecf7229ed3af5a9$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("beforeunload", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $5ecf7229ed3af5a9$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $5ecf7229ed3af5a9$var$computeScrollPosition() : null
    };
}
function $5ecf7229ed3af5a9$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $5ecf7229ed3af5a9$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $5ecf7229ed3af5a9$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $5ecf7229ed3af5a9$var$assign({}, history1.state, $5ecf7229ed3af5a9$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $5ecf7229ed3af5a9$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $5ecf7229ed3af5a9$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $5ecf7229ed3af5a9$var$assign({}, $5ecf7229ed3af5a9$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $5ecf7229ed3af5a9$export$7b4942f78e7b8a49(base) {
    base = $5ecf7229ed3af5a9$var$normalizeBase(base);
    const historyNavigation = $5ecf7229ed3af5a9$var$useHistoryStateNavigation(base);
    const historyListeners = $5ecf7229ed3af5a9$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $5ecf7229ed3af5a9$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $5ecf7229ed3af5a9$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $5ecf7229ed3af5a9$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $5ecf7229ed3af5a9$var$START
    ];
    let position = 0;
    base = $5ecf7229ed3af5a9$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position === queue.length) // we are at the end, we can simply append a new entry
        queue.push(location1);
        else {
            // we are in the middle, we remove everything from here in the queue
            queue.splice(position);
            queue.push(location1);
        }
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $5ecf7229ed3af5a9$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $5ecf7229ed3af5a9$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $5ecf7229ed3af5a9$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $5ecf7229ed3af5a9$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $5ecf7229ed3af5a9$var$NavigationDirection.back : $5ecf7229ed3af5a9$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $5ecf7229ed3af5a9$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $5ecf7229ed3af5a9$export$7b4942f78e7b8a49(base);
}
function $5ecf7229ed3af5a9$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $5ecf7229ed3af5a9$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $5ecf7229ed3af5a9$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $5ecf7229ed3af5a9$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $5ecf7229ed3af5a9$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($5ecf7229ed3af5a9$export$35710516f95d6a57 || ($5ecf7229ed3af5a9$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $5ecf7229ed3af5a9$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$5ecf7229ed3af5a9$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
function $5ecf7229ed3af5a9$var$createRouterError(type, params) {
    return $5ecf7229ed3af5a9$var$assign(new Error(), {
        type: type,
        [$5ecf7229ed3af5a9$var$NavigationFailureSymbol]: true
    }, params);
}
function $5ecf7229ed3af5a9$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $5ecf7229ed3af5a9$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $5ecf7229ed3af5a9$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $5ecf7229ed3af5a9$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if ("path" in to) return to.path;
    const location1 = {};
    for (const key of $5ecf7229ed3af5a9$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $5ecf7229ed3af5a9$var$BASE_PARAM_PATTERN = "[^/]+?";
const $5ecf7229ed3af5a9$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $5ecf7229ed3af5a9$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $5ecf7229ed3af5a9$var$tokensToParser(segments, extraOptions) {
    const options = $5ecf7229ed3af5a9$var$assign({}, $5ecf7229ed3af5a9$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($5ecf7229ed3af5a9$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $5ecf7229ed3af5a9$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $5ecf7229ed3af5a9$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($5ecf7229ed3af5a9$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $5ecf7229ed3af5a9$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $5ecf7229ed3af5a9$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $5ecf7229ed3af5a9$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $5ecf7229ed3af5a9$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($5ecf7229ed3af5a9$var$isLastScoreNegative(aScore)) return 1;
        if ($5ecf7229ed3af5a9$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $5ecf7229ed3af5a9$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $5ecf7229ed3af5a9$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $5ecf7229ed3af5a9$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $5ecf7229ed3af5a9$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $5ecf7229ed3af5a9$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($5ecf7229ed3af5a9$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $5ecf7229ed3af5a9$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $5ecf7229ed3af5a9$var$tokensToParser($5ecf7229ed3af5a9$var$tokenizePath(record.path), options);
    const matcher = $5ecf7229ed3af5a9$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $5ecf7229ed3af5a9$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $5ecf7229ed3af5a9$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $5ecf7229ed3af5a9$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $5ecf7229ed3af5a9$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($5ecf7229ed3af5a9$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $5ecf7229ed3af5a9$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$5ecf7229ed3af5a9$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $5ecf7229ed3af5a9$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($5ecf7229ed3af5a9$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $5ecf7229ed3af5a9$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$5ecf7229ed3af5a9$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$5ecf7229ed3af5a9$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $5ecf7229ed3af5a9$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $5ecf7229ed3af5a9$var$assign(// paramsFromLocation is a new object
            $5ecf7229ed3af5a9$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // TODO: only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $5ecf7229ed3af5a9$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if ("path" in location1) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $5ecf7229ed3af5a9$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $5ecf7229ed3af5a9$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $5ecf7229ed3af5a9$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $5ecf7229ed3af5a9$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $5ecf7229ed3af5a9$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $5ecf7229ed3af5a9$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $5ecf7229ed3af5a9$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "boolean" ? props : props[name];
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $5ecf7229ed3af5a9$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $5ecf7229ed3af5a9$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$5ecf7229ed3af5a9$var$assign(meta, record.meta), {});
}
function $5ecf7229ed3af5a9$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $5ecf7229ed3af5a9$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $5ecf7229ed3af5a9$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($5ecf7229ed3af5a9$var$isSameParam.bind(null, key))) return $5ecf7229ed3af5a9$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($5ecf7229ed3af5a9$var$isSameParam.bind(null, key))) return $5ecf7229ed3af5a9$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $5ecf7229ed3af5a9$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $5ecf7229ed3af5a9$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $5ecf7229ed3af5a9$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($5ecf7229ed3af5a9$var$isSameParam.bind(null, key))) return $5ecf7229ed3af5a9$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $5ecf7229ed3af5a9$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $5ecf7229ed3af5a9$var$isRecordChildOf(record, child));
}
/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $5ecf7229ed3af5a9$var$HASH_RE = /#/g; // %23
const $5ecf7229ed3af5a9$var$AMPERSAND_RE = /&/g; // %26
const $5ecf7229ed3af5a9$var$SLASH_RE = /\//g; // %2F
const $5ecf7229ed3af5a9$var$EQUAL_RE = /=/g; // %3D
const $5ecf7229ed3af5a9$var$IM_RE = /\?/g; // %3F
const $5ecf7229ed3af5a9$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $5ecf7229ed3af5a9$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $5ecf7229ed3af5a9$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $5ecf7229ed3af5a9$var$ENC_CARET_RE = /%5E/g; // ^
const $5ecf7229ed3af5a9$var$ENC_BACKTICK_RE = /%60/g; // `
const $5ecf7229ed3af5a9$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $5ecf7229ed3af5a9$var$ENC_PIPE_RE = /%7C/g; // |
const $5ecf7229ed3af5a9$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $5ecf7229ed3af5a9$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $5ecf7229ed3af5a9$var$commonEncode(text) {
    return encodeURI("" + text).replace($5ecf7229ed3af5a9$var$ENC_PIPE_RE, "|").replace($5ecf7229ed3af5a9$var$ENC_BRACKET_OPEN_RE, "[").replace($5ecf7229ed3af5a9$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $5ecf7229ed3af5a9$var$encodeHash(text) {
    return $5ecf7229ed3af5a9$var$commonEncode(text).replace($5ecf7229ed3af5a9$var$ENC_CURLY_OPEN_RE, "{").replace($5ecf7229ed3af5a9$var$ENC_CURLY_CLOSE_RE, "}").replace($5ecf7229ed3af5a9$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $5ecf7229ed3af5a9$var$encodeQueryValue(text) {
    return $5ecf7229ed3af5a9$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($5ecf7229ed3af5a9$var$PLUS_RE, "%2B").replace($5ecf7229ed3af5a9$var$ENC_SPACE_RE, "+").replace($5ecf7229ed3af5a9$var$HASH_RE, "%23").replace($5ecf7229ed3af5a9$var$AMPERSAND_RE, "%26").replace($5ecf7229ed3af5a9$var$ENC_BACKTICK_RE, "`").replace($5ecf7229ed3af5a9$var$ENC_CURLY_OPEN_RE, "{").replace($5ecf7229ed3af5a9$var$ENC_CURLY_CLOSE_RE, "}").replace($5ecf7229ed3af5a9$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $5ecf7229ed3af5a9$var$encodeQueryKey(text) {
    return $5ecf7229ed3af5a9$var$encodeQueryValue(text).replace($5ecf7229ed3af5a9$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $5ecf7229ed3af5a9$var$encodePath(text) {
    return $5ecf7229ed3af5a9$var$commonEncode(text).replace($5ecf7229ed3af5a9$var$HASH_RE, "%23").replace($5ecf7229ed3af5a9$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $5ecf7229ed3af5a9$var$encodeParam(text) {
    return text == null ? "" : $5ecf7229ed3af5a9$var$encodePath(text).replace($5ecf7229ed3af5a9$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $5ecf7229ed3af5a9$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $5ecf7229ed3af5a9$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($5ecf7229ed3af5a9$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $5ecf7229ed3af5a9$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $5ecf7229ed3af5a9$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$5ecf7229ed3af5a9$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $5ecf7229ed3af5a9$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $5ecf7229ed3af5a9$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $5ecf7229ed3af5a9$var$isArray(value) ? value.map((v)=>v && $5ecf7229ed3af5a9$var$encodeQueryValue(v)) : [
            value && $5ecf7229ed3af5a9$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $5ecf7229ed3af5a9$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $5ecf7229ed3af5a9$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $5ecf7229ed3af5a9$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $5ecf7229ed3af5a9$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $5ecf7229ed3af5a9$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $5ecf7229ed3af5a9$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $5ecf7229ed3af5a9$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $5ecf7229ed3af5a9$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers,
        reset: reset
    };
}
function $5ecf7229ed3af5a9$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $cfZzL.onUnmounted)(removeFromList);
    (0, $cfZzL.onDeactivated)(removeFromList);
    (0, $cfZzL.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $5ecf7229ed3af5a9$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $5ecf7229ed3af5a9$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $5ecf7229ed3af5a9$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $5ecf7229ed3af5a9$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $5ecf7229ed3af5a9$var$guardToPromiseFn(guard, to, from, record, name) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($5ecf7229ed3af5a9$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($5ecf7229ed3af5a9$var$isRouteLocation(valid)) reject($5ecf7229ed3af5a9$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = guard.call(record && record.instances[name], to, from, next);
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $5ecf7229ed3af5a9$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $5ecf7229ed3af5a9$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $5ecf7229ed3af5a9$var$extractComponentsGuards(matched, guardType, to, from) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($5ecf7229ed3af5a9$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($5ecf7229ed3af5a9$var$guardToPromiseFn(guard, to, from, record, name));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $5ecf7229ed3af5a9$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $5ecf7229ed3af5a9$var$guardToPromiseFn(guard, to, from, record, name)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $5ecf7229ed3af5a9$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $5ecf7229ed3af5a9$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $5ecf7229ed3af5a9$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $5ecf7229ed3af5a9$export$dcf14c9974fe2767(props) {
    const router = (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$b6c0da8b9dae491f);
    const currentRoute = (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$3aca783e9a3e6e9e);
    const route = (0, $gGESn.computed)(()=>router.resolve((0, $gGESn.unref)(props.to)));
    const activeRecordIndex = (0, $gGESn.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($5ecf7229ed3af5a9$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $5ecf7229ed3af5a9$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $5ecf7229ed3af5a9$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($5ecf7229ed3af5a9$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $gGESn.computed)(()=>activeRecordIndex.value > -1 && $5ecf7229ed3af5a9$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $gGESn.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $5ecf7229ed3af5a9$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($5ecf7229ed3af5a9$var$guardEvent(e)) return router[(0, $gGESn.unref)(props.replace) ? "replace" : "push"]((0, $gGESn.unref)(props.to)).catch($5ecf7229ed3af5a9$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $5ecf7229ed3af5a9$var$isBrowser) {
        const instance = (0, $cfZzL.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $cfZzL.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $gGESn.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $5ecf7229ed3af5a9$var$RouterLinkImpl = /*#__PURE__*/ (0, $cfZzL.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $5ecf7229ed3af5a9$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $gGESn.reactive)($5ecf7229ed3af5a9$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$b6c0da8b9dae491f);
        const elClass = (0, $gGESn.computed)(()=>({
                [$5ecf7229ed3af5a9$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$5ecf7229ed3af5a9$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $cfZzL.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $5ecf7229ed3af5a9$export$fce709ebdac448ed = $5ecf7229ed3af5a9$var$RouterLinkImpl;
function $5ecf7229ed3af5a9$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $5ecf7229ed3af5a9$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$5ecf7229ed3af5a9$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $5ecf7229ed3af5a9$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $5ecf7229ed3af5a9$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $5ecf7229ed3af5a9$var$RouterViewImpl = /*#__PURE__*/ (0, $cfZzL.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$54c8124bead129f8);
        const routeToDisplay = (0, $gGESn.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $gGESn.computed)(()=>{
            let initialDepth = (0, $gGESn.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $gGESn.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $cfZzL.provide)($5ecf7229ed3af5a9$export$9b3825c34ca1427a, (0, $gGESn.computed)(()=>depth.value + 1));
        (0, $cfZzL.provide)($5ecf7229ed3af5a9$export$7f4879db1558672d, matchedRouteRef);
        (0, $cfZzL.provide)($5ecf7229ed3af5a9$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $gGESn.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $cfZzL.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$5ecf7229ed3af5a9$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $5ecf7229ed3af5a9$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $cfZzL.h)(ViewComponent, $5ecf7229ed3af5a9$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $5ecf7229ed3af5a9$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $5ecf7229ed3af5a9$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $5ecf7229ed3af5a9$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $5ecf7229ed3af5a9$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $5ecf7229ed3af5a9$export$d941f00e9b9a537 = $5ecf7229ed3af5a9$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $5ecf7229ed3af5a9$var$warnDeprecatedUsage() {
    const instance = (0, $cfZzL.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition"))) {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $5ecf7229ed3af5a9$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $5ecf7229ed3af5a9$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $5ecf7229ed3af5a9$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$5ecf7229ed3af5a9$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $5ecf7229ed3af5a9$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $5ecf7229ed3af5a9$var$routerId = 0;
function $5ecf7229ed3af5a9$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $5ecf7229ed3af5a9$var$routerId++;
    (0, $hR09i.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $5ecf7229ed3af5a9$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $5ecf7229ed3af5a9$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($5ecf7229ed3af5a9$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let backgroundColor = $5ecf7229ed3af5a9$var$ORANGE_400;
                    let tooltip = "";
                    if (devtoolsData.isExactActive) {
                        backgroundColor = $5ecf7229ed3af5a9$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $5ecf7229ed3af5a9$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $cfZzL.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $5ecf7229ed3af5a9$var$formatDisplay("beforeEach"),
                from: $5ecf7229ed3af5a9$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $5ecf7229ed3af5a9$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $5ecf7229ed3af5a9$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $5ecf7229ed3af5a9$var$formatDisplay("❌");
            } else data.status = $5ecf7229ed3af5a9$var$formatDisplay("✅");
            // we set here to have the right order
            data.from = $5ecf7229ed3af5a9$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $5ecf7229ed3af5a9$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent);
            // reset match state to false
            routes.forEach($5ecf7229ed3af5a9$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $5ecf7229ed3af5a9$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$5ecf7229ed3af5a9$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($5ecf7229ed3af5a9$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $5ecf7229ed3af5a9$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $5ecf7229ed3af5a9$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $5ecf7229ed3af5a9$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$5ecf7229ed3af5a9$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $5ecf7229ed3af5a9$var$PINK_500 = 0xec4899;
const $5ecf7229ed3af5a9$var$BLUE_600 = 0x2563eb;
const $5ecf7229ed3af5a9$var$LIME_500 = 0x84cc16;
const $5ecf7229ed3af5a9$var$CYAN_400 = 0x22d3ee;
const $5ecf7229ed3af5a9$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $5ecf7229ed3af5a9$var$DARK = 0x666666;
function $5ecf7229ed3af5a9$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $5ecf7229ed3af5a9$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $5ecf7229ed3af5a9$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $5ecf7229ed3af5a9$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $5ecf7229ed3af5a9$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $5ecf7229ed3af5a9$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $5ecf7229ed3af5a9$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($5ecf7229ed3af5a9$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($5ecf7229ed3af5a9$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $5ecf7229ed3af5a9$var$routeRecordId = 0;
const $5ecf7229ed3af5a9$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $5ecf7229ed3af5a9$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $5ecf7229ed3af5a9$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$5ecf7229ed3af5a9$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$5ecf7229ed3af5a9$var$markRouteRecordActive(childRoute, currentRoute));
}
function $5ecf7229ed3af5a9$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($5ecf7229ed3af5a9$var$resetMatchStateOnRouteRecord);
}
function $5ecf7229ed3af5a9$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($5ecf7229ed3af5a9$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$5ecf7229ed3af5a9$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $5ecf7229ed3af5a9$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$5ecf7229ed3af5a9$var$isRouteMatching(child, filter));
}
function $5ecf7229ed3af5a9$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $5ecf7229ed3af5a9$export$baddd0131ee8c05b(options) {
    const matcher = $5ecf7229ed3af5a9$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $5ecf7229ed3af5a9$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $5ecf7229ed3af5a9$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $5ecf7229ed3af5a9$var$useCallbacks();
    const beforeResolveGuards = $5ecf7229ed3af5a9$var$useCallbacks();
    const afterGuards = $5ecf7229ed3af5a9$var$useCallbacks();
    const currentRoute = (0, $gGESn.shallowRef)($5ecf7229ed3af5a9$export$e44be9a9779c480b);
    let pendingLocation = $5ecf7229ed3af5a9$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($5ecf7229ed3af5a9$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $5ecf7229ed3af5a9$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $5ecf7229ed3af5a9$var$applyToParams.bind(null, $5ecf7229ed3af5a9$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $5ecf7229ed3af5a9$var$applyToParams.bind(null, $5ecf7229ed3af5a9$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($5ecf7229ed3af5a9$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $5ecf7229ed3af5a9$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $5ecf7229ed3af5a9$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $5ecf7229ed3af5a9$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $5ecf7229ed3af5a9$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if ("path" in rawLocation) matcherLocation = $5ecf7229ed3af5a9$var$assign({}, rawLocation, {
            path: $5ecf7229ed3af5a9$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $5ecf7229ed3af5a9$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $5ecf7229ed3af5a9$var$assign({}, rawLocation, {
                params: encodeParams(rawLocation.params)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $5ecf7229ed3af5a9$var$stringifyURL(stringifyQuery$1, $5ecf7229ed3af5a9$var$assign({}, rawLocation, {
            hash: $5ecf7229ed3af5a9$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $5ecf7229ed3af5a9$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $5ecf7229ed3af5a9$export$d33b45a8f796a30 ? $5ecf7229ed3af5a9$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $5ecf7229ed3af5a9$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $5ecf7229ed3af5a9$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $5ecf7229ed3af5a9$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($5ecf7229ed3af5a9$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $5ecf7229ed3af5a9$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: "path" in newTargetLocation ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($5ecf7229ed3af5a9$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $5ecf7229ed3af5a9$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $5ecf7229ed3af5a9$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $5ecf7229ed3af5a9$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$5ecf7229ed3af5a9$export$873de56207a30e5a(error) ? $5ecf7229ed3af5a9$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($5ecf7229ed3af5a9$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $5ecf7229ed3af5a9$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $5ecf7229ed3af5a9$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $5ecf7229ed3af5a9$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $5ecf7229ed3af5a9$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($5ecf7229ed3af5a9$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return $5ecf7229ed3af5a9$var$runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($5ecf7229ed3af5a9$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return $5ecf7229ed3af5a9$var$runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $5ecf7229ed3af5a9$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($5ecf7229ed3af5a9$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $5ecf7229ed3af5a9$var$runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of to.matched)// do not trigger beforeEnter on reused views
            if (record.beforeEnter && !from.matched.includes(record)) {
                if ($5ecf7229ed3af5a9$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($5ecf7229ed3af5a9$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($5ecf7229ed3af5a9$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $5ecf7229ed3af5a9$var$runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $5ecf7229ed3af5a9$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return $5ecf7229ed3af5a9$var$runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($5ecf7229ed3af5a9$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return $5ecf7229ed3af5a9$var$runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$5ecf7229ed3af5a9$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        for (const guard of afterGuards.list())guard(to, from, failure);
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $5ecf7229ed3af5a9$export$e44be9a9779c480b;
        const state = !$5ecf7229ed3af5a9$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $5ecf7229ed3af5a9$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($5ecf7229ed3af5a9$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($5ecf7229ed3af5a9$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($5ecf7229ed3af5a9$var$isBrowser) $5ecf7229ed3af5a9$var$saveScrollPosition($5ecf7229ed3af5a9$var$getScrollKey(from.fullPath, info.delta), $5ecf7229ed3af5a9$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($5ecf7229ed3af5a9$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($5ecf7229ed3af5a9$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($5ecf7229ed3af5a9$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $5ecf7229ed3af5a9$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($5ecf7229ed3af5a9$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$5ecf7229ed3af5a9$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $5ecf7229ed3af5a9$var$NavigationType.pop && $5ecf7229ed3af5a9$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch($5ecf7229ed3af5a9$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $5ecf7229ed3af5a9$var$useCallbacks();
    let errorHandlers = $5ecf7229ed3af5a9$var$useCallbacks();
    let ready;
    /**
     * Trigger errorHandlers added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorHandlers.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $5ecf7229ed3af5a9$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$5ecf7229ed3af5a9$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $5ecf7229ed3af5a9$var$getSavedScrollPosition($5ecf7229ed3af5a9$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $cfZzL.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $5ecf7229ed3af5a9$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorHandlers.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $5ecf7229ed3af5a9$export$fce709ebdac448ed);
            app.component("RouterView", $5ecf7229ed3af5a9$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $gGESn.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($5ecf7229ed3af5a9$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $5ecf7229ed3af5a9$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $5ecf7229ed3af5a9$export$e44be9a9779c480b)// @ts-expect-error: the key matches
            reactiveRoute[key] = (0, $gGESn.computed)(()=>currentRoute.value[key]);
            app.provide($5ecf7229ed3af5a9$export$b6c0da8b9dae491f, router);
            app.provide($5ecf7229ed3af5a9$export$3aca783e9a3e6e9e, (0, $gGESn.reactive)(reactiveRoute));
            app.provide($5ecf7229ed3af5a9$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $5ecf7229ed3af5a9$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $5ecf7229ed3af5a9$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $5ecf7229ed3af5a9$var$isBrowser) $5ecf7229ed3af5a9$var$addDevtools(app, router, matcher);
        }
    };
    return router;
}
function $5ecf7229ed3af5a9$var$runGuardQueue(guards) {
    return guards.reduce((promise, guard)=>promise.then(()=>guard()), Promise.resolve());
}
function $5ecf7229ed3af5a9$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$5ecf7229ed3af5a9$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$5ecf7229ed3af5a9$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $5ecf7229ed3af5a9$export$9a302a45f65d0572() {
    return (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $5ecf7229ed3af5a9$export$3f79f0b98112cf57() {
    return (0, $cfZzL.inject)($5ecf7229ed3af5a9$export$3aca783e9a3e6e9e);
}

});

parcelRequire.register("dmUxo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9bb92fa4b2fffb61$export$2e2bcd8739ae039; });
let $9bb92fa4b2fffb61$var$script;




let $9bb92fa4b2fffb61$var$initialize = ()=>{
    $9bb92fa4b2fffb61$var$script = (parcelRequire("8DLDS"));
    if ($9bb92fa4b2fffb61$var$script.__esModule) $9bb92fa4b2fffb61$var$script = $9bb92fa4b2fffb61$var$script.default;
    $9bb92fa4b2fffb61$var$script.render = (parcelRequire("kr7kp")).render;
    $9bb92fa4b2fffb61$var$script.__cssModules = {};
    (parcelRequire("9jz99")).default($9bb92fa4b2fffb61$var$script);
    $9bb92fa4b2fffb61$var$script.__scopeId = "data-v-b47427";
    $9bb92fa4b2fffb61$var$script.__file = "PromotionPage.vue";
};
$9bb92fa4b2fffb61$var$initialize();
var $9bb92fa4b2fffb61$export$2e2bcd8739ae039 = $9bb92fa4b2fffb61$var$script;

});
parcelRequire.register("8DLDS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $21d265e551b1e550$export$2e2bcd8739ae039; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");

var $jgrCW = parcelRequire("jgrCW");

var $275AC = parcelRequire("275AC");

var $lC19C = parcelRequire("lC19C");

var $frXyb = parcelRequire("frXyb");

var $kG1Cv = parcelRequire("kG1Cv");

var $lV9T6 = parcelRequire("lV9T6");

var $goO1A = parcelRequire("goO1A");









var // @vuese
// Komponent odpowiedzialny za ekran usługi Promowania.
// DOKUMENTACJA PROMOWANIA --- https://oferteo.atlassian.net/wiki/spaces/DEV/pages/293339137/FRONT+Promowanie+2.0 ---
// @group Pages | Profile
$21d265e551b1e550$export$2e2bcd8739ae039 = {
    name: "PromotionProfile",
    components: {
        PromotionIntroduction: $frXyb.default,
        PromotionSearch: $kG1Cv.default,
        PromotionActivePromotions: $lV9T6.default,
        PromotionCart: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("97lOt"))),
        PromotionSummary: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("jv47o"))),
        PromotionTutorial: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("9b7dd"))),
        PromotionMap: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("1rotU"))),
        PromotionDisableRenewModal: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("c37wd"))),
        PromotionFeedbackModal: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("6qHNK"))),
        PromotionFillProfileModal: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("lsWqs"))),
        MessageBar: (0, $cfZzL.defineAsyncComponent)(()=>Promise.resolve((parcelRequire("edw9j")))),
        PromotionSummaryModals: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("3DU1d")))
    },
    beforeRouteUpdate (to, from, next) {
        if (to.name === "PromotionProfile") this.isSummaryPage = false;
        next();
    },
    data () {
        return {
            isLoaded: false,
            isChangePromotionModalOpen: false,
            isPromotionEnabled: false,
            isFullContentVisible: false,
            isTutorialOpen: false,
            showOnboarding: false,
            promotionContent: `Promuj swoją firmę i docieraj do tysięcy Klientów bez wysiłku.
		Wskaż, gdzie mamy Cię promować i znajdź się na szczycie wyników wyszukiwania.
		Pozyskuj nowe, darmowe kontakty i nie martw się o utratę wysokiej pozycji dzięki stałej, miesięcznej opłacie.
		<span id="more-about-promotion" class="font-bold cursor-pointer">Więcej</span>`,
            isMapModalVisible: false,
            locationsTree: {},
            selectedLocations: [],
            allLocationsPerCategory: [],
            enabledPromotionsCurrentSort: "name",
            enabledPromotionsCurrentSortDir: "asc"
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $lC19C.useAppStore), [
            "isAdminModule"
        ]),
        ...(0, $jgrCW.mapState)((0, $275AC.usePromotionStore), [
            "customerId",
            "enabledPromotions",
            "isFeedbackModalVisible",
            "isDisableRenewModalVisible",
            "isFillProfileModalVisible",
            "mobileScrollTopPosition",
            "enabledListsLength",
            "isPromotionModalVisible",
            "selectedCategoryId"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $275AC.usePromotionStore), [
            "cartPromotions",
            "isLimitModalVisible",
            "isSummaryPage",
            "showConfirmationMessageBar"
        ]),
        pageHeader () {
            if (this.isSummaryPage) return "Wybierz pakiet Promowania";
            return this.$route.name === "PromotionSummary" ? "Włącz Promowanie" : "Promuj firmę";
        },
        isMobile () {
            return this.$root.$data.WindowWidth <= 768;
        },
        apiNamespace () {
            return this.isAdminModule ? "admin" : "promotion";
        },
        isPromotionsLimitReached () {
            const selectedLocationsCount = this.isMapModalVisible ? this.selectedLocations.reduce((count, { key: key })=>this.cartPromotions.some(({ locationId: locationId })=>locationId === key) ? count : count + 1, 0) : 0;
            return this.enabledPromotions.length + this.cartPromotions.length + selectedLocationsCount >= 20;
        },
        mapPreselectedLocations () {
            return this.enabledPromotions.reduce((accumulator, { idLocation: idLocation, idCategory: idCategory })=>{
                if (Number(this.selectedCategoryId) === idCategory) accumulator.push(idLocation);
                return accumulator;
            }, []);
        },
        mapPreselectedLocationsFromCart () {
            return this.cartPromotions.reduce((accumulator, { locationId: locationId, categoryId: categoryId })=>{
                if (locationId && Number(this.selectedCategoryId) === categoryId) accumulator.push(locationId);
                return accumulator;
            }, []);
        },
        mapNamesAndIdsLocations () {
            return this.allLocationsPerCategory.map(({ locationId: locationId, location: location })=>({
                    locationId: locationId,
                    locationName: location
                }));
        },
        blockedLocations () {
            return this.allLocationsPerCategory.filter(({ available: available })=>!available).map(({ locationId: locationId })=>locationId);
        }
    },
    mounted () {
        if (!this.isAdminModule) this.loadCartFromLocalStorage();
        this.getEnabledPromotions({
            scrollEnabledList: false
        });
        const promotionOnboarding = window.localStorage.getItem("PromotionOnboarding");
        if (!promotionOnboarding || promotionOnboarding !== "done") this.showOnboarding = true;
        this.isLoaded = true;
    },
    methods: {
        ...(0, $jgrCW.mapActions)((0, $275AC.usePromotionStore), [
            "getEnabledPromotions",
            "saveCartInLocalStorage",
            "loadCartFromLocalStorage",
            "addToCart",
            "togglePromotionLimitModal",
            "clearCart",
            "clearInputs"
        ]),
        goBack () {
            if (this.$route.name === "PromotionSummary") {
                this.$router.push({
                    name: "PromotionProfile"
                });
                setTimeout(()=>{
                    window.scrollTo({
                        top: this.mobileScrollTopPosition
                    });
                }, 50);
                return;
            }
            window.location.href = `${window.location.origin}/konto/profil`;
        },
        toggleVisibleContent () {
            this.isFullContentVisible = !this.isFullContentVisible;
        },
        isTutorialVisible (value) {
            this.isTutorialOpen = value;
        },
        toggleMapModal (value) {
            if (!this.selectedCategoryId) return;
            if (!value) this.selectedLocations.length = 0;
            this.isMapModalVisible = value;
        },
        assignSelectedLocations (selectedLocations) {
            this.selectedLocations = [
                ...selectedLocations
            ];
        },
        assignEnabledPromotionsCurrentSort (enabledPromotionsCurrentSort) {
            this.enabledPromotionsCurrentSort = enabledPromotionsCurrentSort;
        },
        assignEnabledPromotionsCurrentSortDir (enabledPromotionsCurrentSortDir) {
            this.enabledPromotionsCurrentSortDir = enabledPromotionsCurrentSortDir;
        },
        updateCartFromMap () {
            this.cartPromotions = this.cartPromotions.filter(({ categoryId: categoryId, locationId: locationId })=>categoryId !== Number(this.selectedCategoryId) || locationId === "location");
            this.selectedLocations.forEach((selectedLocation)=>{
                const foundLocation = this.allLocationsPerCategory.find(({ locationId: locationId })=>locationId === selectedLocation.key);
                if (!foundLocation) return;
                const item = {
                    categoryId: Number(this.selectedCategoryId),
                    locationId: selectedLocation.key,
                    price: foundLocation.price,
                    category: foundLocation.category,
                    location: foundLocation.location,
                    listUrl: foundLocation.listUrl,
                    isNew: foundLocation.isNew,
                    takenPositions: foundLocation.takenPositions,
                    isDisabled: false
                };
                this.addToCart(item, this.isPromotionsLimitReached);
            });
            this.toggleMapModal(false);
            this.clearInputs();
            this.$root.$refs.Toaster.Show("Zaktualizowano koszyk");
        },
        async getAllLocationsPerCategory (categoryId) {
            try {
                const { promotionLocationsData: promotionLocationsData } = await (0, $goO1A.default)(`/promotion/get-all-promotion-locations-data.ofer?locationCategoryDTO.categoryId=${categoryId}`);
                this.allLocationsPerCategory = [
                    ...promotionLocationsData
                ];
            } catch (error) {
                console.error(error);
            }
        },
        goToTheAdditionalServicesAdminPage () {
            document.location.replace(`/administracja/firmy/${this.customerId}/uslugi-dodatkowe`);
        },
        closeMessageBar () {
            this.showConfirmationMessageBar = false;
        }
    }
};

});
parcelRequire.register("275AC", function(module, exports) {

$parcel$export(module.exports, "usePromotionStore", function () { return $c5e5afe96f01708b$export$20d663755d5393bd; });

var $jgrCW = parcelRequire("jgrCW");

var $7XpJX = parcelRequire("7XpJX");

var $lC19C = parcelRequire("lC19C");

var $3cbAx = parcelRequire("3cbAx");

var $goO1A = parcelRequire("goO1A");
const $c5e5afe96f01708b$export$20d663755d5393bd = (0, $jgrCW.defineStore)({
    id: "promotion",
    state: ()=>{
        var _useRoute, _useRoute_params;
        return {
            customerId: (0, $lC19C.useAppStore)().isAdminModule ? Number((_useRoute = (0, $7XpJX.useRoute)()) === null || _useRoute === void 0 ? void 0 : (_useRoute_params = _useRoute.params) === null || _useRoute_params === void 0 ? void 0 : _useRoute_params.id) : (0, $3cbAx.useUserStore)().customerId,
            cartPromotions: [],
            selectedPromotionId: 0,
            isPromotionEnabled: false,
            enabledPromotions: [],
            isLimitModalVisible: false,
            isFeedbackModalVisible: false,
            isDisableRenewModalVisible: false,
            isSummaryPage: false,
            mobileScrollTopPosition: 0,
            promotionPackages: [],
            isServerError: false,
            isUnpaidInvoice: false,
            isNotEnoughPoints: false,
            isPromotionModalVisible: false,
            accountPoints: 0,
            enabledListsLength: 0,
            categoryInput: "",
            locationInput: "",
            selectedCategoryId: "",
            selectedLocationId: "",
            suggestions: [],
            suggestionsCheckboxFilter: true,
            apiNamespace: (0, $lC19C.useAppStore)().isAdminModule ? "admin" : "promotion",
            isFillProfileModalVisible: false,
            isSummaryPage: false,
            promotionIndicator: {
                hasGallery: false,
                hasMarks: false,
                hasDescription: false
            },
            showConfirmationMessageBar: false
        };
    },
    actions: {
        async getEnabledPromotions ({ scrollEnabledList: scrollEnabledList }) {
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            const url = isAdminModule ? `/admin/active-promotions.ofer?idCustomer=${this.customerId}` : "/promotion/active-promotions.ofer";
            try {
                const { result: result } = await (0, $goO1A.default)(url);
                this.enabledPromotions = [
                    ...result
                ];
                this.enabledPromotions.forEach((promotion)=>{
                    promotion.isDisabled = promotion.takenPositions >= 5;
                });
                if (scrollEnabledList) setTimeout(()=>{
                    this.scrollActivePromotionsList();
                }, 600);
            } catch (error) {
                console.error(error);
            }
        },
        async getSuggestions () {
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            let url = isAdminModule ? `/${this.apiNamespace}/get-promotion-suggestions.ofer?idCustomer=${this.customerId}&locationCategoryDTO.categoryId=${this.selectedCategoryId}` : `/${this.apiNamespace}/get-promotion-suggestions.ofer?locationCategoryDTO.categoryId=${this.selectedCategoryId}`;
            if (this.selectedLocationId) url = isAdminModule ? `/${this.apiNamespace}/get-promotion-suggestions.ofer?locationCategoryDTO.categoryId=${this.selectedCategoryId}&locationCategoryDTO.locationIdsString=${this.selectedLocationId}` : `/${this.apiNamespace}/get-promotion-suggestions.ofer?locationCategoryDTO.categoryId=${this.selectedCategoryId}&locationCategoryDTO.locationIdsString=${this.selectedLocationId}`;
            try {
                const { suggestions: suggestions } = await (0, $goO1A.default)(url);
                this.suggestions = this.processSugesstions(suggestions);
            } catch (error) {
                console.error(error);
            }
        },
        processSugesstions (suggestions) {
            this.enabledPromotions.forEach((enabledItem)=>{
                enabledItem.categoryId = Number(this.selectedCategoryId);
            });
            suggestions.forEach((suggestionItem)=>{
                suggestionItem.isDisabled = suggestionItem.takenPositions >= 5;
            });
            if (!this.suggestionsCheckboxFilter) return suggestions;
            return suggestions.filter((suggestionItem)=>suggestionItem.isFromCustomerFilters);
        },
        async getPromotionRecommendations () {
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            const url = isAdminModule ? `/${this.apiNamespace}/get-promotion-recommendations.ofer?idCustomer=${this.customerId}` : `/${this.apiNamespace}/get-promotion-recommendations.ofer`;
            try {
                const { result: result } = await (0, $goO1A.default)(url);
                this.suggestions = result;
            } catch (error) {
                console.error(error);
            }
        },
        async getPromotionIndicators () {
            const { hasGallery: hasGallery, hasMarks: hasMarks, hasDescription: hasDescription } = await (0, $goO1A.default)(`/promotion/get-profile-promotion-indicators.ofer?idCustomer=${this.customerId}`);
            this.promotionIndicator.hasGallery = hasGallery;
            this.promotionIndicator.hasMarks = hasMarks;
            this.promotionIndicator.hasDescription = hasDescription;
        },
        addToCart (item, isPromotionsLimitReached) {
            if (item.isDisabled) return;
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            if (isPromotionsLimitReached && !isAdminModule) {
                this.togglePromotionLimitModal(true);
                return;
            }
            if (!this.cartPromotions.find((cartItem)=>cartItem.listUrl === item.listUrl)) this.cartPromotions.push(item);
            if (!isAdminModule) this.saveCartInLocalStorage();
        },
        removeFromCart (item) {
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            this.cartPromotions = this.cartPromotions.filter((obj)=>obj.listUrl !== item.listUrl);
            if (!isAdminModule) this.saveCartInLocalStorage();
        },
        saveCartInLocalStorage () {
            window.localStorage.setItem("cart", JSON.stringify(this.cartPromotions));
        },
        loadCartFromLocalStorage () {
            const cartFromLocalStorage = window.localStorage.getItem("cart");
            this.cartPromotions = cartFromLocalStorage ? JSON.parse(cartFromLocalStorage) : [];
        },
        togglePromotionLimitModal (value) {
            this.isLimitModalVisible = value;
        },
        scrollActivePromotionsList () {
            const activePromotionsDiv = document.getElementById("active-promotions-items");
            if (!activePromotionsDiv) return;
            activePromotionsDiv.scrollTop = activePromotionsDiv.scrollHeight;
        },
        togglePromotionFeedbackModal (value) {
            if (!value) {
                setTimeout(()=>{
                    this.isFeedbackModalVisible = value;
                }, 600);
                return;
            }
            this.isFeedbackModalVisible = value;
        },
        toggleDisableRenewModal ({ event: event, value: value, mode: mode, id: id }) {
            if (event) event.stopPropagation();
            this.selectedPromotionId = id || 0;
            if (value) {
                this.isDisableRenewModalVisible = value;
                this.isPromotionEnabled = mode === "disable";
            } else setTimeout(()=>{
                this.isDisableRenewModalVisible = value;
                this.isPromotionEnabled = mode === "disable";
            }, 600);
        },
        async enablePromotions () {
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            const purchases = this.promotionPackages.map((promotionPackage)=>({
                    idLocation: promotionPackage.locationId,
                    idCategory: promotionPackage.categoryId,
                    initMonthDuration: Number(promotionPackage.months)
                }));
            this.resetFlags();
            const url = isAdminModule ? `/${this.apiNamespace}/purchase-promotions.ofer?idCustomer=${this.customerId}` : `/${this.apiNamespace}/purchase-promotions.ofer`;
            const response = await (0, $goO1A.default)(url, {
                promotionPurchaseJSON: JSON.stringify({
                    purchases: purchases
                })
            }, "POST");
            if (response.result === "not_enough_points") {
                this.isNotEnoughPoints = true;
                await this.getAccountPoints();
                this.isPromotionModalVisible = true;
                return;
            }
            if (response.result !== "success" && response.result !== "unpaid_invoice") {
                this.isServerError = true;
                this.isPromotionModalVisible = true;
                return;
            }
            if (response.result === "unpaid_invoice") this.isUnpaidInvoice = true;
            this.isServerError = false;
            this.enabledListsLength = this.cartPromotions.length;
            this.clearCart({
                scrollEnabledList: true
            });
            if (!this.promotionIndicator.hasGallery || !this.promotionIndicator.hasMarks || !this.promotionIndicator.hasDescription) setTimeout(()=>{
                this.isFillProfileModalVisible = true;
            }, 5000);
            this.showConfirmationMessageBar = true;
            if (this.isSummaryPage) this.$router.push({
                name: "PromotionProfile"
            });
            const target = document.querySelector(".active-promotions");
            if (!target) return;
            const { top: top } = target.getBoundingClientRect();
            window.setTimeout(()=>{
                window.scrollTo({
                    top: top - 150 > 0 ? top - 150 : 50,
                    behavior: "smooth"
                });
            }, 150);
        },
        resetFlags () {
            this.isServerError = false;
            this.isNotEnoughPoints = false;
            this.isUnpaidInvoice = false;
        },
        async getAccountPoints () {
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            try {
                const url = isAdminModule ? `/admin/get-account-balance.ofer?customerId=${this.customerId}` : "/myoferteo/konto-json/get-account-balance.ofer";
                const { data: data } = await (0, $goO1A.default)(url);
                this.accountPoints = data.accountBalance;
            } catch (error) {
                console.error(error);
            }
        },
        async clearCart ({ scrollEnabledList: scrollEnabledList }) {
            const { isAdminModule: isAdminModule } = (0, $lC19C.useAppStore)();
            this.cartPromotions.length = 0;
            await this.getEnabledPromotions({
                scrollEnabledList: scrollEnabledList
            });
            this.clearInputs();
            if (!isAdminModule) this.saveCartInLocalStorage();
        },
        clearInputs () {
            this.clearCategoryInput();
            this.clearLocationInput();
        },
        clearCategoryInput () {
            this.categoryInput = "";
            this.selectedCategoryId = "";
            this.suggestions = [];
            this.clearLocationInput();
            this.getPromotionRecommendations();
        },
        clearLocationInput () {
            this.locationInput = "";
            this.selectedLocationId = "";
            if (this.categoryInput === "") this.suggestions = [];
            if (this.selectedCategoryId) this.getSuggestions();
            else this.getPromotionRecommendations();
        }
    }
});

});
parcelRequire.register("lC19C", function(module, exports) {

$parcel$export(module.exports, "useAppStore", function () { return $ad547f86bd28b771$export$35cd30506bcba883; });

var $jgrCW = parcelRequire("jgrCW");

var $9Vpfg = parcelRequire("9Vpfg");
const $ad547f86bd28b771$export$35cd30506bcba883 = (0, $jgrCW.defineStore)({
    id: "app",
    state: ()=>({
            module: "",
            sessionId: "",
            flags: [],
            baseUrl: document.location.hostname,
            websocketUrl: "",
            googleTrackingId: "UA-2440395-3",
            googleAnalyticsData: {
                userType: "none"
            },
            fbTrackingId: "",
            userComTrackingId: ""
        }),
    getters: {
        isAdminModule: (state)=>state.module === (0, $9Vpfg.AppModules).ADMIN
    },
    actions: {
        update (rsvp) {
            this.sessionId = rsvp.sessionId || "";
            this.baseUrl = rsvp.baseUrl || document.location.hostname;
            this.websocketUrl = rsvp.baseWebsocketUrl || "";
            this.googleTrackingId = rsvp.ua || "UA-2440395-3";
            this.googleAnalyticsData = rsvp.analytics || {
                userType: "none"
            };
            this.fbTrackingId = rsvp.facebook || "1439591673009945";
            this.userComTrackingId = rsvp.userComApiKey || "";
            this.updateFlags(rsvp);
        },
        updateFlags (rsvp) {
            const { user: user } = rsvp;
            this.flags = rsvp.flags || [];
            // Dodaj flagi do debugu z localStorage
            try {
                const customFlags = window.localStorage.getItem("flags");
                if (customFlags) this.flags.push(...customFlags.split(",") || []);
            } catch (err) {
                window.localStorage.setItem("flags", "");
            }
            // Czy pierwszą stroną mają być Kontakty, czy zapytania?
            if (rsvp.newMessagesSinceLastVisit) rsvp.flags.push("newMessagesSinceLastVisit");
            // Najlepsi 2023
            const awardsDeadline = window.localStorage["awardsDeadline_2023"] || "2023-05-11";
            window.localStorage["awardsDeadline_2023"] = awardsDeadline;
            if (Number(new Date()) < Number(new Date(awardsDeadline))) this.flags.push("the_best_award_season");
            // BuyerView
            if (user) {
                if (user.passwordSet) this.flags.push("buyerPasswordSet");
                if (user.buyerViewNew) this.flags.push("buyerViewNew");
                if (user.phoneConfirmed) this.flags.push("buyerPhoneConfirmed");
            }
        },
        hasFlag (flag) {
            return this.flags.indexOf(flag) !== -1;
        },
        addFlag (flag) {
            if (!this.hasFlag(flag)) this.flags.push(flag);
        },
        removeFlag (flag) {
            const flagIndex = this.flags.findIndex((f)=>f === flag);
            if (flagIndex >= 0) this.flags.splice(flagIndex, 1);
        }
    }
});

});
parcelRequire.register("9Vpfg", function(module, exports) {

$parcel$export(module.exports, "AppModules", function () { return $3a63da07efc374f6$export$cc484f6a18e7e6bb; });
/* eslint-disable no-unused-vars */ // eslint-disable-next-line import/prefer-default-export, no-shadow
var $3a63da07efc374f6$export$cc484f6a18e7e6bb;
(function(AppModules) {
    AppModules["ADMIN"] = "Admin";
    AppModules["MY_OFERTEO"] = "CustomerView";
})($3a63da07efc374f6$export$cc484f6a18e7e6bb || ($3a63da07efc374f6$export$cc484f6a18e7e6bb = {}));

});


parcelRequire.register("3cbAx", function(module, exports) {

$parcel$export(module.exports, "useUserStore", function () { return $eb7c25fac3513697$export$cc885caaa8b7ab4e; });

var $jgrCW = parcelRequire("jgrCW");

var $goO1A = parcelRequire("goO1A");
const $eb7c25fac3513697$export$cc885caaa8b7ab4e = (0, $jgrCW.defineStore)({
    id: "user",
    state: ()=>({
            /** Identyfikator użytkownika. */ userId: 0,
            /** Identyfikator wykonawcy. */ customerId: 0,
            /** Czy użytkownik ma uprawnienia administratorskie? */ isAdmin: false,
            /** Czy użytkownik jest wykonawcą? */ isCustomer: false,
            /** Czy użytkownik jest wykonwacą Oferteo Express? */ isExpressSpecialist: false,
            /** Czy użytkownik uczestniczy w programie partnerskim? */ isPartner: false,
            /** Główna rola użytkownika */ role: "",
            /** Lista wszystkich ról użytkownika */ roles: [],
            /** Czy użytkownik zalogował się przy użyciu hasła (zamiast np. linku autowlogowującego)? */ isAuth: false,
            /** Imię użytkownika */ firstName: "",
            /** Nazwisko użytkownika */ lastName: "",
            /** Nazwa firmy użytkownika */ companyName: "",
            /** Numer telefonu użytkownika */ phone: "",
            /** Adres email użytkownika */ email: "",
            /** Miasto siedziby użytkownika */ city: "",
            /** Obrazek profilowy użytkownika */ avatar: "",
            /** Numer NIP użytkownika */ nip: {
                country: "PL",
                value: "",
                isIndividual: false
            },
            /** Adres wizytówki użytkownika */ profileUrl: "",
            /** Płeć użytkownika */ sex: "MALE",
            /** Zdobyte przez wykonawcę odznaki */ badges: [],
            /** Adres strony Najlepsi na której znajduje się wykonawca */ bestBadgeUrl: "",
            /** Procentowe wypełnienie profilu użytkownika. */ profileCompletness: 0,
            /** Aktualny stan konta użytkownika. */ accountBalance: 0,
            /** Maksymalna cena za odkrycie jednego zapytania w kategorii. */ maxCategoryPrice: 0,
            /** Limit zwrotów */ reversalLimit: 0,
            /** Informacja o postępie płatności w zewnętrznym serwisie. */ paymentProgress: "",
            /** Adres email użytkownika przy przełączeniu konta. */ loggedAs: "",
            /** flaga do prezentowania informacji debug np. w appce w postaci alertow na srodowisku tst */ frontEndDebug: false,
            /** Flaga czy użytkownik dostanie testową zachętę do kontynuowania w aplikacji */ abTestContinueInMobileApp: false
        }),
    actions: {
        update (rsvp) {
            const { user: user } = rsvp;
            if (!user) return;
            this.userId = user.idUser;
            this.customerId = user.idCustomer;
            this.isCustomer = user.idCustomer > 0;
            this.isAdmin = rsvp.role === "ADMIN";
            this.isPartner = rsvp.role === "ADMIN" || rsvp.role === "CUSTOMER";
            this.isExpressSpecialist = rsvp.expressSpecialist || false;
            this.isPartner = user.isPartner || false;
            this.role = rsvp.role || "";
            this.roles = rsvp.allRoles || [];
            this.isAuth = user.isAuth || false;
            this.firstName = user.firstName || "";
            this.lastName = user.lastName || "";
            this.companyName = user.companyName || "";
            this.phone = user.phone || "";
            this.email = user.email || "";
            this.city = user.city || "";
            this.avatar = (user.avatar || "").indexOf("images/hero") > -1 ? "" : user.avatar || "";
            this.nip = user.nip || this.nip;
            this.profileUrl = user.profileUrl || "";
            this.sex = user.sex || "MALE";
            this.badges = user.badges || [];
            this.bestBadgeUrl = user.bestUrl || "";
            this.profileCompletness = rsvp.profileCompletness || 0;
            this.accountBalance = rsvp.accountBalance || 0;
            this.maxCategoryPrice = rsvp.maxCategoryPrice || 0;
            this.reversalLimit = rsvp.reversalLimit || 0;
            this.paymentProgress = "";
            this.loggedAs = user.switchedToUsername || "";
            this.abTestContinueInMobileApp = user.abTestContinueInMobileApp || false;
        },
        /**
		 * Dodaje lub usuwa zdjęcie profilowe użytkownika,
		 * jeżeli zostało ono zmienione.
		 */ async changeAvatar (avatarField) {
            // Jeżeli nic się nie zmieniło - nic nie rób.
            if (avatarField === this.avatar) return "";
            this.avatar = avatarField || "";
            // Jeżeli był obrazek, a go nie ma - usuń go.
            if (!avatarField) {
                await (0, $goO1A.default)("/myoferteo/konto-json/delete-avatar.ofer", {}, "POST");
                return "delete-avatar";
            }
            // W przeciwnym razie - dodaj obrazek.
            const filename = `${Number(new Date())}_avatar.jpg`;
            const bs = atob(avatarField.split(",")[1]);
            const ms = avatarField.split(",")[0].split(":")[1].split(";")[0];
            const ab = new ArrayBuffer(bs.length);
            const ia = new Uint8Array(ab);
            for(let i = 0; i < bs.length; i++)ia[i] = bs.charCodeAt(i);
            await (0, $goO1A.default)("/myoferteo/konto-json/upload-avatar.ofer", {
                file: new Blob([
                    ab
                ], {
                    type: ms
                }),
                originalName: filename
            }, "POST");
            // Backend nie zwraca prawidłowej ścieżki po wysłaniu `upload-avatar.ofer`, dlatego też niezbędne jest pobranie obrazka z `hello.ofer`.
            (0, $goO1A.default)("/profile/hello.ofer").then((rsvp)=>{
                this.avatar = rsvp.user.avatar;
            });
            return "upload-avatar";
        }
    }
});

});
parcelRequire.register("goO1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88101957ac4dcd14$export$2e2bcd8739ae039; });
/**
 * Pobiera lub wysyła informacje oraz parsuje odpowiedź z JSON-a.
 * @param url - Adres docelowy
 * @param obj - Obiekt do przesłania
 * @param mode - Ustawia metodę w jaki sposób chcemy przesłać informacje
 * @param rethrowErrors - Czy przerzucać błędy? W innym przypadku, zwraca pusty obiekt
 */ function $88101957ac4dcd14$var$serverFetch(url, obj = {}, mode = "GET", rethrowErrors = false, parse = true) {
    // TODO: dodaj parametr rzeby rzócało błendem, zamiast zwracało pusty obiekt.
    return new Promise((resolve, reject)=>{
        const f = {
            method: mode,
            mode: "no-cors",
            credentials: "include"
        };
        if (obj && Object.keys(obj).length) {
            const d = new FormData();
            for(const k in obj){
                const keyname = k.indexOf("|") > -1 ? k.split("|")[0] : k;
                if (Array.isArray(obj[k])) obj[k].forEach((i)=>{
                    d.append(keyname, i);
                });
                else d.append(keyname, obj[k]);
            }
            f.body = d;
        }
        fetch(url, f).then((rsvp)=>rsvp.json()).then((rsvp)=>{
            if (parse) {
                rsvp = JSON.parse(rsvp);
                resolve(rsvp);
            } else resolve(rsvp);
        }).catch((err)=>{
            if (rethrowErrors) reject(err);
            else resolve({});
        });
    });
}
var $88101957ac4dcd14$export$2e2bcd8739ae039 = $88101957ac4dcd14$var$serverFetch;

});



parcelRequire.register("frXyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f79215c7ba04fe$export$2e2bcd8739ae039; });
let $b3f79215c7ba04fe$var$script;




let $b3f79215c7ba04fe$var$initialize = ()=>{
    $b3f79215c7ba04fe$var$script = (parcelRequire("2wvTi"));
    if ($b3f79215c7ba04fe$var$script.__esModule) $b3f79215c7ba04fe$var$script = $b3f79215c7ba04fe$var$script.default;
    $b3f79215c7ba04fe$var$script.render = (parcelRequire("i3Dg8")).render;
    $b3f79215c7ba04fe$var$script.__cssModules = {};
    (parcelRequire("hjehN")).default($b3f79215c7ba04fe$var$script);
    $b3f79215c7ba04fe$var$script.__scopeId = "data-v-59aa8e";
    $b3f79215c7ba04fe$var$script.__file = "PromotionIntroduction.vue";
};
$b3f79215c7ba04fe$var$initialize();
var $b3f79215c7ba04fe$export$2e2bcd8739ae039 = $b3f79215c7ba04fe$var$script;

});
parcelRequire.register("2wvTi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $341508b02f05ef30$export$2e2bcd8739ae039; });

var $goO1A = parcelRequire("goO1A");
var $341508b02f05ef30$export$2e2bcd8739ae039 = {
    name: "PromotionIntroduction",
    data () {
        return {
            isDetailsVisible: [
                false,
                false
            ]
        };
    },
    methods: {
        toggleDetailsVisible (index) {
            this.isDetailsVisible[index] = !this.isDetailsVisible[index];
        },
        async sendSystemNoteAndRedirect () {
            await (0, $goO1A.default)("/promotion/add-promotion-note.ofer");
            window.open("/konto/promowanie", "_blank");
        }
    }
};

});

parcelRequire.register("i3Dg8", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d256f5de75f8caec$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $d256f5de75f8caec$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-59aa8e"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $d256f5de75f8caec$var$_hoisted_1 = {
    class: "promotion-introduction-item"
};
const $d256f5de75f8caec$var$_hoisted_2 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "Twoja firma jest widoczna"),
        /*#__PURE__*/ (0, $cfZzL.createTextVNode)(" dla tysięcy Zleceniodawc\xf3w.")
    ], -1));
const $d256f5de75f8caec$var$_hoisted_3 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cfZzL.createTextVNode)("Dostajesz "),
        /*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "bezpłatne kontakty"),
        /*#__PURE__*/ (0, $cfZzL.createTextVNode)(" do Klient\xf3w, kt\xf3rzy wybrali Cię na liście firm.")
    ], -1));
const $d256f5de75f8caec$var$_hoisted_4 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "Trafiasz na szczyty list"),
        /*#__PURE__*/ (0, $cfZzL.createTextVNode)(" z najlepszymi firmami w Oferteo.")
    ], -1));
const $d256f5de75f8caec$var$_hoisted_5 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "1.", -1));
const $d256f5de75f8caec$var$_hoisted_6 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "Wybierz kategorie,"),
        /*#__PURE__*/ (0, $cfZzL.createTextVNode)(" w kt\xf3rych zależy Ci na dodatkowej widoczności.")
    ], -1));
const $d256f5de75f8caec$var$_hoisted_7 = [
    $d256f5de75f8caec$var$_hoisted_5,
    $d256f5de75f8caec$var$_hoisted_6
];
const $d256f5de75f8caec$var$_hoisted_8 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "2.", -1));
const $d256f5de75f8caec$var$_hoisted_9 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "Potwierdź zakup"),
        /*#__PURE__*/ (0, $cfZzL.createTextVNode)(" - zapłacisz punktami Oferteo.")
    ], -1));
const $d256f5de75f8caec$var$_hoisted_10 = [
    $d256f5de75f8caec$var$_hoisted_8,
    $d256f5de75f8caec$var$_hoisted_9
];
const $d256f5de75f8caec$var$_hoisted_11 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "3.", -1));
const $d256f5de75f8caec$var$_hoisted_12 = /*#__PURE__*/ $d256f5de75f8caec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, [
        /*#__PURE__*/ (0, $cfZzL.createElementVNode)("b", null, "Zyskuj bezpłatne kontakty"),
        /*#__PURE__*/ (0, $cfZzL.createTextVNode)(" i realizuj zlecenia Klient\xf3w.")
    ], -1));
const $d256f5de75f8caec$var$_hoisted_13 = [
    $d256f5de75f8caec$var$_hoisted_11,
    $d256f5de75f8caec$var$_hoisted_12
];
function $d256f5de75f8caec$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "promotion-introduction-header mt-2",
                {
                    "ml-6": _ctx.ScreenSize > 1,
                    "ml-3": _ctx.ScreenSize <= 1
                }
            ]),
            "data-component": "PromotionIntroduction.vue"
        }, " Włącz Promowanie i bądź widoczny dla os\xf3b, kt\xf3re szukają wykonawcy zlecenia! ", 2),
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "promotion-introduction text-center",
                _ctx.ScreenSize >= 1 ? "desktop-introduction" : "mobile-introduction"
            ]),
            "data-component": "PromotionIntroduction.vue"
        }, [
            (0, $cfZzL.createElementVNode)("div", $d256f5de75f8caec$var$_hoisted_1, [
                (0, $cfZzL.createElementVNode)("div", {
                    class: (0, $4bH2P.normalizeClass)([
                        "promotion-introduction-item-header",
                        {
                            "mb-4": _ctx.ScreenSize >= 1
                        }
                    ])
                }, [
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "checkmark-circle-1",
                        size: "1.75",
                        class: "mr-3"
                    }),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)([
                            "text-base",
                            {
                                "font-extrabold": _ctx.ScreenSize < 1,
                                "mt-[3px] font-bold": _ctx.ScreenSize >= 1
                            }
                        ])
                    }, " Co zyskujesz? ", 2),
                    _ctx.ScreenSize < 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                        key: 0,
                        name: "chevron-down-2",
                        size: "1.5",
                        class: (0, $4bH2P.normalizeClass)([
                            "cursor-pointer mr-1 absolute right-5",
                            {
                                "rotate-180": $data.isDetailsVisible[0]
                            }
                        ]),
                        onClick: _cache[0] || (_cache[0] = ($event)=>$options.toggleDetailsVisible(0))
                    }, null, 8, [
                        "class"
                    ])) : (0, $cfZzL.createCommentVNode)("", true)
                ], 2),
                _ctx.ScreenSize >= 1 || $data.isDetailsVisible[0] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                    key: 0
                }, [
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)(_ctx.ScreenSize >= 1 ? "desktop-text-item mb-4" : "mobile-text-item")
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "dot",
                            size: "0.75",
                            class: "text-info mt-1"
                        }),
                        $d256f5de75f8caec$var$_hoisted_2
                    ], 2),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)(_ctx.ScreenSize >= 1 ? "desktop-text-item mb-4" : "mobile-text-item")
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "dot",
                            size: "0.75",
                            class: "text-info mt-1.5"
                        }),
                        $d256f5de75f8caec$var$_hoisted_3
                    ], 2),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)(_ctx.ScreenSize >= 1 ? "desktop-text-item" : "mobile-text-item")
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "dot",
                            size: "0.75",
                            class: "text-info mt-1.5"
                        }),
                        $d256f5de75f8caec$var$_hoisted_4
                    ], 2)
                ], 64)) : (0, $cfZzL.createCommentVNode)("", true)
            ]),
            (0, $cfZzL.createElementVNode)("div", {
                class: (0, $4bH2P.normalizeClass)([
                    "promotion-introduction-item",
                    {
                        "mt-4": _ctx.ScreenSize < 1
                    }
                ])
            }, [
                (0, $cfZzL.createElementVNode)("div", {
                    class: (0, $4bH2P.normalizeClass)([
                        "promotion-introduction-item-header",
                        {
                            "mb-4": _ctx.ScreenSize >= 1
                        }
                    ])
                }, [
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "light-bulb",
                        size: "1.75",
                        class: "text-warn-500 mr-3"
                    }),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)([
                            "text-base",
                            {
                                "font-extrabold": _ctx.ScreenSize < 1,
                                "mt-[3px] font-bold": _ctx.ScreenSize >= 1
                            }
                        ])
                    }, " Jak włączyć Promowanie? ", 2),
                    _ctx.ScreenSize < 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                        key: 0,
                        name: "chevron-down-2",
                        size: "1.5",
                        class: (0, $4bH2P.normalizeClass)([
                            "cursor-pointer mr-1 absolute right-5",
                            {
                                "rotate-180": $data.isDetailsVisible[1]
                            }
                        ]),
                        onClick: _cache[1] || (_cache[1] = ($event)=>$options.toggleDetailsVisible(1))
                    }, null, 8, [
                        "class"
                    ])) : (0, $cfZzL.createCommentVNode)("", true)
                ], 2),
                _ctx.ScreenSize >= 1 || $data.isDetailsVisible[1] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                    key: 0
                }, [
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)(_ctx.ScreenSize >= 1 ? "desktop-text-item mb-4" : "mobile-text-item")
                    }, $d256f5de75f8caec$var$_hoisted_7, 2),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)(_ctx.ScreenSize >= 1 ? "desktop-text-item mb-4" : "mobile-text-item")
                    }, $d256f5de75f8caec$var$_hoisted_10, 2),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)(_ctx.ScreenSize >= 1 ? "desktop-text-item" : "mobile-text-item")
                    }, $d256f5de75f8caec$var$_hoisted_13, 2)
                ], 64)) : (0, $cfZzL.createCommentVNode)("", true)
            ], 2)
        ], 2),
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "mt-4 mb-1 text-right text-info",
                {
                    "mr-4": _ctx.ScreenSize <= 1
                }
            ]),
            "data-component": "PromotionIntroduction.vue"
        }, [
            (0, $cfZzL.createElementVNode)("span", {
                class: "cursor-pointer font-bold text-sm",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.sendSystemNoteAndRedirect && $options.sendSystemNoteAndRedirect(...args))
            }, "Dowiedz się więcej")
        ], 2)
    ], 64);
}

});

parcelRequire.register("hjehN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c99f4aec8f62796c$export$2e2bcd8739ae039; });
let $c99f4aec8f62796c$var$NOOP = ()=>{};
var $c99f4aec8f62796c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("kG1Cv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0d8fc97abe5c41e$export$2e2bcd8739ae039; });
let $f0d8fc97abe5c41e$var$script;




let $f0d8fc97abe5c41e$var$initialize = ()=>{
    $f0d8fc97abe5c41e$var$script = (parcelRequire("gi2hf"));
    if ($f0d8fc97abe5c41e$var$script.__esModule) $f0d8fc97abe5c41e$var$script = $f0d8fc97abe5c41e$var$script.default;
    $f0d8fc97abe5c41e$var$script.render = (parcelRequire("7n1Op")).render;
    $f0d8fc97abe5c41e$var$script.__cssModules = {};
    (parcelRequire("jU7xa")).default($f0d8fc97abe5c41e$var$script);
    $f0d8fc97abe5c41e$var$script.__scopeId = "data-v-942692";
    $f0d8fc97abe5c41e$var$script.__file = "PromotionSearch.vue";
};
$f0d8fc97abe5c41e$var$initialize();
var $f0d8fc97abe5c41e$export$2e2bcd8739ae039 = $f0d8fc97abe5c41e$var$script;

});
parcelRequire.register("gi2hf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d20f316372c31ae4$export$2e2bcd8739ae039; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");

var $jgrCW = parcelRequire("jgrCW");

var $lC19C = parcelRequire("lC19C");

var $275AC = parcelRequire("275AC");

var $goO1A = parcelRequire("goO1A");


var $d20f316372c31ae4$export$2e2bcd8739ae039 = {
    name: "PromotionSearch",
    components: {
        PromotionTable: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("dmGrD"))),
        TooltipElement: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("gUJ8q")))
    },
    props: {
        apiNamespace: {
            type: String,
            required: true
        },
        isPromotionsLimitReached: {
            type: Boolean,
            required: true
        },
        enabledPromotions: {
            type: Array,
            required: true
        }
    },
    emits: [
        "add-to-cart",
        "get-all-locations-per-category",
        "toggle-map-modal"
    ],
    data () {
        return {
            categories: [],
            locations: [],
            showSearchCategoriesSuggestions: false,
            showSearchLocationsSuggestions: false,
            debounceCategorySearch: 0,
            debounceLocalizationSearch: 0,
            promotionsCurrentSort: "name",
            promotionsCurrentSortDir: "asc"
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $lC19C.useAppStore), [
            "isAdminModule"
        ]),
        ...(0, $jgrCW.mapState)((0, $275AC.usePromotionStore), [
            "customerId",
            "cartPromotions",
            "suggestions"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $275AC.usePromotionStore), [
            "suggestionsCheckboxFilter",
            "categoryInput",
            "locationInput",
            "selectedCategoryId",
            "selectedLocationId"
        ]),
        isMobile () {
            return this.$root.$data.WindowWidth <= 768;
        },
        promotionsReducedByEnabled () {
            return this.suggestions.filter((suggestionItem)=>!this.enabledPromotions.find((enabledPromotionItem)=>enabledPromotionItem.listUrl === suggestionItem.listUrl));
        },
        sortedPromotions () {
            // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
            return this.promotionsReducedByEnabled.sort((promotionA, promotionB)=>{
                const modifier = this.promotionsCurrentSortDir === "desc" ? -1 : 1;
                const promotionAValue = promotionA[this.promotionsCurrentSort];
                const promotionBValue = promotionB[this.promotionsCurrentSort];
                if (typeof promotionAValue === "string" && typeof promotionBValue === "string") return promotionAValue.localeCompare(promotionBValue) * modifier;
                if (!promotionBValue || !promotionAValue) return 0;
                return (Number(promotionBValue) - Number(promotionAValue)) * modifier;
            });
        }
    },
    watch: {
        suggestionsCheckboxFilter () {
            if (this.selectedCategoryId) this.getSuggestions();
        }
    },
    mounted () {
        this.getPromotionRecommendations();
        this.getSuggestedCategories();
        this.getSuggestedLocations();
    },
    methods: {
        ...(0, $jgrCW.mapActions)((0, $275AC.usePromotionStore), [
            "addToCart",
            "getPromotionRecommendations",
            "getSuggestions",
            "clearCategoryInput"
        ]),
        async getSuggestedCategories () {
            try {
                const { result: result } = await (0, $goO1A.default)(`/${this.apiNamespace}/get-suggested-customer-promotion-categories.ofer?idCustomer=${this.customerId}`);
                this.processCategories(result);
            } catch (error) {
                console.error(error);
            }
        },
        getCategoriesBasedOnInput ({ target: target }) {
            if (this.debounceCategorySearch) clearTimeout(this.debounceCategorySearch);
            const { value: queryParam } = target;
            this.debounceCategorySearch = window.setTimeout(async ()=>{
                const { result: result } = await (0, $goO1A.default)(`/${this.apiNamespace}/get-recommended-promotion-categories.ofer?inputCategory=${queryParam}&idCustomer=${this.customerId}`);
                this.processCategories(result);
            }, 600);
        },
        async getSuggestedLocations () {
            try {
                const { result: result } = await (0, $goO1A.default)(`/${this.apiNamespace}/get-suggested-customer-promotion-locations.ofer?idCustomer=${this.customerId}`);
                this.processLocations(result);
            } catch (error) {
                console.error(error);
            }
        },
        getLocationsBasedOnInput ({ target: target }) {
            if (this.debounceLocalizationSearch) clearTimeout(this.debounceLocalizationSearch);
            const { value: queryParam } = target;
            this.debounceLocalizationSearch = window.setTimeout(async ()=>{
                const url = this.isAdminModule ? `/${this.apiNamespace}/get-recommended-promotion-locations.ofer?inputLocation=${queryParam}&idCustomer=${this.customerId}` : `/${this.apiNamespace}/get-recommended-promotion-locations.ofer?inputLocation=${queryParam}`;
                try {
                    const { result: result } = await (0, $goO1A.default)(url);
                    this.processLocations(result);
                } catch (error) {
                    console.error(error);
                }
            }, 600);
        },
        processCategories (categories) {
            this.categories = [];
            categories.forEach((category)=>{
                this.categories.push({
                    id: Object.entries(category)[0][0],
                    name: Object.entries(category)[0][1]
                });
            });
        },
        processLocations (locations) {
            this.locations = [];
            locations.forEach((location)=>{
                this.locations.push({
                    id: Object.entries(location)[0][0],
                    city: Object.entries(location)[0][1],
                    active: false
                });
            });
        },
        setCategory ({ name: name, id: id }) {
            this.categoryInput = name;
            this.selectedCategoryId = id;
            this.getSuggestions();
            this.getAllLocationsPerCategory(this.selectedCategoryId);
        },
        setLocation ({ city: city, id: id }) {
            this.locationInput = city;
            this.selectedLocationId = id;
            this.getSuggestions();
        },
        shouldLabelBeDisplayed (item, type) {
            const counter = Number(item.isNew) + Number(item.isLastPlace) + Number(item.isPremium) + Number(item.isGainingPopularity);
            if (counter > 2 && (type === "isPremium" || type === "isGainingPopularity")) return false;
            return true;
        },
        getAllLocationsPerCategory (categoryId) {
            this.$emit("get-all-locations-per-category", categoryId);
        },
        toggleMapModal () {
            this.$emit("toggle-map-modal", true);
        }
    }
};

});
parcelRequire.register("dmGrD", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("bNTxo")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("ifXZI"))
]).then(()=>parcelRequire("kcmrv"));

});
parcelRequire.register("dtXZI", function(module, exports) {
"use strict";

var $3vDZp = parcelRequire("3vDZp");
module.exports = $3vDZp(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRequire.register("3vDZp", function(module, exports) {
"use strict";
var $28e3496979ecd5eb$var$cachedBundles = {};
var $28e3496979ecd5eb$var$cachedPreloads = {};
var $28e3496979ecd5eb$var$cachedPrefetches = {};
function $28e3496979ecd5eb$var$getCache(type) {
    switch(type){
        case "preload":
            return $28e3496979ecd5eb$var$cachedPreloads;
        case "prefetch":
            return $28e3496979ecd5eb$var$cachedPrefetches;
        default:
            return $28e3496979ecd5eb$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $28e3496979ecd5eb$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("3H3FI", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2b083c6a2749fa95$export$bdfd709ae4826697; }, function (v) { return $2b083c6a2749fa95$export$bdfd709ae4826697 = v; });
var $2b083c6a2749fa95$export$bdfd709ae4826697;
var $2b083c6a2749fa95$export$c9e73fbda7da57b6;
var $2b083c6a2749fa95$export$5a759dc7a1cfb72a;
"use strict";
var $2b083c6a2749fa95$var$bundleURL = {};
function $2b083c6a2749fa95$var$getBundleURLCached(id) {
    var value = $2b083c6a2749fa95$var$bundleURL[id];
    if (!value) {
        value = $2b083c6a2749fa95$var$getBundleURL();
        $2b083c6a2749fa95$var$bundleURL[id] = value;
    }
    return value;
}
function $2b083c6a2749fa95$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2b083c6a2749fa95$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2b083c6a2749fa95$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2b083c6a2749fa95$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2b083c6a2749fa95$export$bdfd709ae4826697 = $2b083c6a2749fa95$var$getBundleURLCached;
$2b083c6a2749fa95$export$c9e73fbda7da57b6 = $2b083c6a2749fa95$var$getBaseURL;
$2b083c6a2749fa95$export$5a759dc7a1cfb72a = $2b083c6a2749fa95$var$getOrigin;

});

parcelRequire.register("johqs", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $e1ddc6948d231616$export$6503ec6e8aabbaf; }, function (v) { return $e1ddc6948d231616$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $e1ddc6948d231616$export$f7ad0328861e2f03; }, function (v) { return $e1ddc6948d231616$export$f7ad0328861e2f03 = v; });
var $e1ddc6948d231616$export$6503ec6e8aabbaf;
var $e1ddc6948d231616$export$f7ad0328861e2f03;
"use strict";
var $e1ddc6948d231616$var$mapping = {};
function $e1ddc6948d231616$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$e1ddc6948d231616$var$mapping[keys[i]] = pairs[keys[i]];
}
function $e1ddc6948d231616$var$resolve(id) {
    var resolved = $e1ddc6948d231616$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$e1ddc6948d231616$export$6503ec6e8aabbaf = $e1ddc6948d231616$var$register;
$e1ddc6948d231616$export$f7ad0328861e2f03 = $e1ddc6948d231616$var$resolve;

});

parcelRequire.register("bxz2b", function(module, exports) {
"use strict";

var $3vDZp = parcelRequire("3vDZp");
module.exports = $3vDZp(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});


parcelRequire.register("gUJ8q", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("11Wdm")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("lMlDn"))
]).then(()=>parcelRequire("j5dCT"));

});


parcelRequire.register("7n1Op", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $55dc163d93e836ec$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $55dc163d93e836ec$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-942692"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $55dc163d93e836ec$var$_hoisted_1 = /*#__PURE__*/ $55dc163d93e836ec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
        class: "font-light"
    }, " Czym są listy firm w Oferteo? Listy firm, to specjalne strony, kt\xf3re są dedykowane danej kategorii oraz lokalizacji (np. Malowanie ścian Wrocław). Pokazywane są na nich firmy, kt\xf3re wykonują dane usługi. Na te strony trafiają Zleceniodawcy i to tu najczęściej składają zapytania. Mogą też obejrzeć profile firm widocznych na liście firm. ", -1));
const $55dc163d93e836ec$var$_hoisted_2 = {
    class: "ml-1"
};
const $55dc163d93e836ec$var$_hoisted_3 = {
    class: "flex search-form"
};
const $55dc163d93e836ec$var$_hoisted_4 = {
    class: "col-half mr-2 form-input mb-0 search-form__category"
};
const $55dc163d93e836ec$var$_hoisted_5 = {
    class: "autocomplete input input-category-wrapper"
};
const $55dc163d93e836ec$var$_hoisted_6 = {
    class: "input-icon p-5"
};
const $55dc163d93e836ec$var$_hoisted_7 = {
    ref: "list",
    class: "suggestions-list suggestion-list__promotion"
};
const $55dc163d93e836ec$var$_hoisted_8 = [
    "onClick"
];
const $55dc163d93e836ec$var$_hoisted_9 = {
    class: "col-half mr-2 form-input mb-0"
};
const $55dc163d93e836ec$var$_hoisted_10 = {
    class: "autocomplete input input-location-wrapper"
};
const $55dc163d93e836ec$var$_hoisted_11 = {
    class: "input-icon p-5"
};
const $55dc163d93e836ec$var$_hoisted_12 = [
    "disabled"
];
const $55dc163d93e836ec$var$_hoisted_13 = {
    ref: "list",
    class: "suggestions-list suggestion-list__promotion"
};
const $55dc163d93e836ec$var$_hoisted_14 = [
    "onClick"
];
const $55dc163d93e836ec$var$_hoisted_15 = {
    class: "suggestions-checkbox-filter-wrapper"
};
const $55dc163d93e836ec$var$_hoisted_16 = {
    class: "input-control mx-3"
};
const $55dc163d93e836ec$var$_hoisted_17 = {
    key: 1,
    class: "promotion-checkbox"
};
const $55dc163d93e836ec$var$_hoisted_18 = /*#__PURE__*/ $55dc163d93e836ec$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
        for: "suggestions-checkbox-filter"
    }, "Pokaż tylko te usługi, kt\xf3re wykonuję", -1));
function $55dc163d93e836ec$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_TooltipElement = (0, $cfZzL.resolveComponent)("TooltipElement");
    const _component_PromotionTable = (0, $cfZzL.resolveComponent)("PromotionTable");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("section", {
        "data-component": "PromotionSearch.vue",
        class: (0, $4bH2P.normalizeClass)([
            "promotion-search-list mt-14 mb-6 ml-5 search",
            {
                "pb-1": _ctx.suggestions.length,
                "pb-4": !_ctx.suggestions.length,
                "mb-20": $options.isMobile
            }
        ])
    }, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "flex items-center justify-between mb-6",
                {
                    "ml-5": _ctx.ScreenSize < 1
                }
            ])
        }, [
            (0, $cfZzL.createElementVNode)("div", {
                class: (0, $4bH2P.normalizeClass)([
                    "heading-normal",
                    {
                        "flex": _ctx.ScreenSize >= 1
                    }
                ])
            }, [
                (0, $cfZzL.createTextVNode)(" Wybierz listy i włącz Promowanie "),
                (0, $cfZzL.createVNode)(_component_TooltipElement, {
                    class: (0, $4bH2P.normalizeClass)([
                        "promotion-tooltip",
                        {
                            "inline-block": _ctx.ScreenSize < 1
                        }
                    ])
                }, {
                    tooltipContent: (0, $cfZzL.withCtx)(()=>[
                            $55dc163d93e836ec$var$_hoisted_1
                        ]),
                    tooltipTrigger: (0, $cfZzL.withCtx)(()=>[
                            (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_2, [
                                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                    name: "info-information-circle",
                                    size: 1.1,
                                    class: "mt-1"
                                })
                            ])
                        ]),
                    _: 1
                }, 8, [
                    "class"
                ])
            ], 2)
        ], 2),
        (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_3, [
            (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_4, [
                (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_5, [
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("button", {
                        class: "clear-input-button p-5",
                        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.clearCategoryInput && _ctx.clearCategoryInput(...args))
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "close",
                            size: "0.7",
                            class: "mt-1"
                        })
                    ], 512), [
                        [
                            (0, $brqXq.vShow),
                            _ctx.categoryInput.length > 0
                        ]
                    ]),
                    (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_6, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "search",
                            class: "mt-1 text-neutral-500"
                        })
                    ]),
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                        id: "category",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.categoryInput = $event),
                        type: "text",
                        autocomplete: "off",
                        placeholder: "Szukaj po nazwie usługi",
                        onInput: _cache[2] || (_cache[2] = (...args)=>$options.getCategoriesBasedOnInput && $options.getCategoriesBasedOnInput(...args)),
                        onClick: _cache[3] || (_cache[3] = ($event)=>$data.showSearchCategoriesSuggestions = true)
                    }, null, 544), [
                        [
                            (0, $brqXq.vModelText),
                            _ctx.categoryInput
                        ]
                    ]),
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_7, [
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.categories, (category, index)=>{
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("a", {
                                key: `category-${index}`,
                                class: "cursor-pointer",
                                onClick: ($event)=>$options.setCategory(category)
                            }, (0, $4bH2P.toDisplayString)(category.name), 9, $55dc163d93e836ec$var$_hoisted_8);
                        }), 128))
                    ], 512), [
                        [
                            (0, $brqXq.vShow),
                            $data.showSearchCategoriesSuggestions
                        ]
                    ])
                ])
            ]),
            (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_9, [
                (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_10, [
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("button", {
                        class: "clear-input-button clear-location p-5",
                        onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.clearLocationInput && _ctx.clearLocationInput(...args))
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "close",
                            size: "0.7",
                            class: "mt-1"
                        })
                    ], 512), [
                        [
                            (0, $brqXq.vShow),
                            _ctx.locationInput.length > 0
                        ]
                    ]),
                    (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_11, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "pin",
                            class: "mt-1 text-neutral-500"
                        })
                    ]),
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                        id: "localization",
                        ref: "locationInput",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>_ctx.locationInput = $event),
                        autocomplete: "off",
                        class: (0, $4bH2P.normalizeClass)(!_ctx.selectedCategoryId || _ctx.categoryInput.length < 1 ? "disabled-input" : "active-input"),
                        type: "text",
                        placeholder: "Określ lokalizację (opcjonalne)",
                        disabled: !_ctx.selectedCategoryId || _ctx.categoryInput.length < 1,
                        onClick: _cache[6] || (_cache[6] = ($event)=>$data.showSearchLocationsSuggestions = true),
                        onInput: _cache[7] || (_cache[7] = (...args)=>$options.getLocationsBasedOnInput && $options.getLocationsBasedOnInput(...args))
                    }, null, 42, $55dc163d93e836ec$var$_hoisted_12), [
                        [
                            (0, $brqXq.vModelText),
                            _ctx.locationInput
                        ]
                    ]),
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_13, [
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.locations, (location, index)=>{
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("a", {
                                key: `suggestion-${index}`,
                                onClick: ($event)=>$options.setLocation(location)
                            }, (0, $4bH2P.toDisplayString)(location.city), 9, $55dc163d93e836ec$var$_hoisted_14);
                        }), 128))
                    ], 512), [
                        [
                            (0, $brqXq.vShow),
                            $data.showSearchLocationsSuggestions
                        ]
                    ]),
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "map-location-search",
                        size: "1.5",
                        class: (0, $4bH2P.normalizeClass)([
                            "map-icon",
                            {
                                "disabled-input": !_ctx.selectedCategoryId || _ctx.categoryInput.length < 1
                            }
                        ]),
                        onClick: _cache[8] || (_cache[8] = ($event)=>$options.toggleMapModal())
                    }, null, 8, [
                        "class"
                    ])
                ])
            ])
        ]),
        (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_15, [
            (0, $cfZzL.createElementVNode)("div", $55dc163d93e836ec$var$_hoisted_16, [
                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                    id: "suggestions-checkbox-filter",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>_ctx.suggestionsCheckboxFilter = $event),
                    type: "checkbox"
                }, null, 512), [
                    [
                        (0, $brqXq.vModelCheckbox),
                        _ctx.suggestionsCheckboxFilter
                    ]
                ]),
                _ctx.suggestionsCheckboxFilter ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                    key: 0,
                    name: "promotion-checkbox",
                    class: "promotion-checkbox",
                    size: "1.5"
                })) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $55dc163d93e836ec$var$_hoisted_17))
            ]),
            $55dc163d93e836ec$var$_hoisted_18
        ]),
        (0, $cfZzL.createVNode)(_component_PromotionTable, {
            module: "search",
            promotions: $options.promotionsReducedByEnabled,
            isPromotionsLimitReached: $props.isPromotionsLimitReached,
            class: "max-h-72 mb-12"
        }, null, 8, [
            "promotions",
            "isPromotionsLimitReached"
        ])
    ], 2);
}

});

parcelRequire.register("jU7xa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7d917584066c52b$export$2e2bcd8739ae039; });
let $e7d917584066c52b$var$NOOP = ()=>{};
var $e7d917584066c52b$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("lV9T6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff56975540aeabfa$export$2e2bcd8739ae039; });
let $ff56975540aeabfa$var$script;




let $ff56975540aeabfa$var$initialize = ()=>{
    $ff56975540aeabfa$var$script = (parcelRequire("ecpV6"));
    if ($ff56975540aeabfa$var$script.__esModule) $ff56975540aeabfa$var$script = $ff56975540aeabfa$var$script.default;
    $ff56975540aeabfa$var$script.render = (parcelRequire("HvtHe")).render;
    $ff56975540aeabfa$var$script.__cssModules = {};
    (parcelRequire("gpj2t")).default($ff56975540aeabfa$var$script);
    $ff56975540aeabfa$var$script.__scopeId = "data-v-f9da3d";
    $ff56975540aeabfa$var$script.__file = "PromotionActivePromotions.vue";
};
$ff56975540aeabfa$var$initialize();
var $ff56975540aeabfa$export$2e2bcd8739ae039 = $ff56975540aeabfa$var$script;

});
parcelRequire.register("ecpV6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2a1f7fce039186d8$export$2e2bcd8739ae039; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");

var $jgrCW = parcelRequire("jgrCW");

var $lC19C = parcelRequire("lC19C");

var $2a1f7fce039186d8$export$2e2bcd8739ae039 = {
    name: "PromotionActivePromotions",
    components: {
        PromotionTable: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("dmGrD")))
    },
    props: {
        apiNamespace: {
            type: String,
            required: true
        },
        enabledPromotions: {
            type: Array,
            required: true
        },
        isPromotionsLimitReached: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        "toggle-change-promotion-modal",
        "toggle-full-promotion-item-visibility",
        "assign-enabled-promotions-current-sort",
        "assign-enabled-promotions-current-sort-dir",
        "get-enabled-promotions"
    ],
    data () {
        return {
            enabledPromotionsCurrentSort: "name",
            enabledPromotionsCurrentSortDir: "asc"
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $lC19C.useAppStore), [
            "isAdminModule"
        ]),
        enabledPromotionsSum () {
            return this.enabledPromotions.reduce((accumulator, promotion)=>accumulator + promotion.price, 0);
        }
    },
    watch: {
        enabledPromotionsCurrentSort (value) {
            this.$emit("assign-enabled-promotions-current-sort", value);
        },
        enabledPromotionsCurrentSortDir (value) {
            this.$emit("assign-enabled-promotions-current-sort-dir", value);
        }
    },
    methods: {
        sortEnabledPromotions (key) {
            if (key === this.enabledPromotionsCurrentSort) this.enabledPromotionsCurrentSortDir = this.enabledPromotionsCurrentSortDir === "asc" ? "desc" : "asc";
            this.enabledPromotionsCurrentSort = key;
        },
        showCategoriesList () {
            const category = document.getElementById("category");
            if (category) category.focus();
        }
    }
};

});

parcelRequire.register("HvtHe", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $082c6f22f21caf05$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $082c6f22f21caf05$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-f9da3d"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $082c6f22f21caf05$var$_hoisted_1 = {
    key: 0,
    "data-component": "PromotionActivePromotions.vue",
    class: "pl-5 active-promotions"
};
const $082c6f22f21caf05$var$_hoisted_2 = /*#__PURE__*/ $082c6f22f21caf05$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("span", {
        class: "block mb-2 heading-normal"
    }, "Tu Cię promujemy", -1));
const $082c6f22f21caf05$var$_hoisted_3 = [
    $082c6f22f21caf05$var$_hoisted_2
];
function $082c6f22f21caf05$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PromotionTable = (0, $cfZzL.resolveComponent)("PromotionTable");
    return $props.enabledPromotions.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("section", $082c6f22f21caf05$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "flex items-center justify-between",
                {
                    "ml-5": _ctx.ScreenSize < 1
                }
            ])
        }, $082c6f22f21caf05$var$_hoisted_3, 2),
        (0, $cfZzL.createVNode)(_component_PromotionTable, {
            module: "active-promotions",
            promotions: $props.enabledPromotions,
            isPromotionsLimitReached: $props.isPromotionsLimitReached,
            class: "max-h-72"
        }, null, 8, [
            "promotions",
            "isPromotionsLimitReached"
        ])
    ])) : (0, $cfZzL.createCommentVNode)("", true);
}

});

parcelRequire.register("gpj2t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf1dbfdffc8dfd17$export$2e2bcd8739ae039; });
let $bf1dbfdffc8dfd17$var$NOOP = ()=>{};
var $bf1dbfdffc8dfd17$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("97lOt", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("dwm7d")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("2THfg"))
]).then(()=>parcelRequire("3sZUd"));

});

parcelRequire.register("jv47o", function(module, exports) {



module.exports = (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("5ry39")).then(()=>parcelRequire("2bru9"));

});

parcelRequire.register("9b7dd", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("61cth")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("WafNM"))
]).then(()=>parcelRequire("aZW0K"));

});

parcelRequire.register("1rotU", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("ddQ2o")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("hL3Jc"))
]).then(()=>parcelRequire("leOaE"));

});

parcelRequire.register("c37wd", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("2CVXs")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("eKLsj"))
]).then(()=>parcelRequire("2txHD"));

});

parcelRequire.register("6qHNK", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("bcWXP")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("k3N29"))
]).then(()=>parcelRequire("hxjhz"));

});

parcelRequire.register("lsWqs", function(module, exports) {



module.exports = (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("2bBmE")).then(()=>parcelRequire("9R9Fk"));

});

parcelRequire.register("edw9j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a59b37c35c3f86f8$export$2e2bcd8739ae039; });
let $a59b37c35c3f86f8$var$script;



let $a59b37c35c3f86f8$var$initialize = ()=>{
    $a59b37c35c3f86f8$var$script = (parcelRequire("eKX1j"));
    if ($a59b37c35c3f86f8$var$script.__esModule) $a59b37c35c3f86f8$var$script = $a59b37c35c3f86f8$var$script.default;
    $a59b37c35c3f86f8$var$script.render = (parcelRequire("a2VDS")).render;
    (parcelRequire("dlH8L")).default($a59b37c35c3f86f8$var$script);
    $a59b37c35c3f86f8$var$script.__scopeId = "data-v-821d2b";
    $a59b37c35c3f86f8$var$script.__file = "MessageBar.vue";
};
$a59b37c35c3f86f8$var$initialize();
var $a59b37c35c3f86f8$export$2e2bcd8739ae039 = $a59b37c35c3f86f8$var$script;

});
parcelRequire.register("eKX1j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b6e66a15ae4717e6$export$2e2bcd8739ae039; });
/**
* Komponent odpowiedzialny za wyświetlanie komunikatów na belce
*/ var $b6e66a15ae4717e6$export$2e2bcd8739ae039 = {
    name: "MessageBar",
    props: {
        messageTitle: {
            type: String,
            required: true
        },
        messageContent: {
            type: String,
            required: true
        },
        messageType: {
            type: String,
            required: true
        },
        messageButtonContent: {
            type: String,
            required: false,
            default: "Rozumiem"
        }
    },
    emits: [
        "message-button-action"
    ],
    computed: {
        /** Style belki */ typeClass () {
            switch(this.messageType){
                case "success":
                    return {
                        icon: "notification-success",
                        container: "bg-[#FAFDFC] border-success",
                        text: "text-success",
                        button: "btn-success"
                    };
                case "danger":
                    return {
                        icon: "notification-danger",
                        container: "bg-[#FEFBFA] border-danger",
                        text: "text-danger",
                        button: "btn-danger"
                    };
                case "alert":
                    return {
                        icon: "notification-alert",
                        iconColor: "text-warn",
                        container: "bg-[#FFFCFA] border-accent",
                        text: "text-accent",
                        button: "btn-accent"
                    };
                case "info":
                default:
                    return {
                        icon: "notification-info",
                        container: "border-info",
                        text: "text-info",
                        button: "text-info"
                    };
            }
        }
    },
    methods: {
        messageButtonAction () {
            this.$emit("message-button-action");
        }
    }
};

});

parcelRequire.register("a2VDS", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $7506cdd26f82c708$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $7506cdd26f82c708$var$_hoisted_1 = {
    class: "container mx-auto"
};
const $7506cdd26f82c708$var$_hoisted_2 = {
    class: "lg:flex items-center"
};
const $7506cdd26f82c708$var$_hoisted_3 = {
    class: "flex mr-auto"
};
const $7506cdd26f82c708$var$_hoisted_4 = {
    class: "leading-snug flex flex-col lg:block mr-1"
};
const $7506cdd26f82c708$var$_hoisted_5 = {
    class: "font-bold text-sm lg:text-base mr-1"
};
const $7506cdd26f82c708$var$_hoisted_6 = {
    class: "mt-1 text-xs lg:text-base"
};
const $7506cdd26f82c708$var$_hoisted_7 = {
    class: "text-right flex mt-4 lg:mt-0 lg:flex-row-reverse whitespace-nowrap"
};
function $7506cdd26f82c708$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        "data-component": "MessageBar.vue",
        class: (0, $4bH2P.normalizeClass)([
            "bg-[#fef8fa] p-3",
            [
                _ctx.ScreenSize > 1 ? "shadow-elevation-y-2px" : "shadow-elevation-y-1px",
                $options.typeClass.container
            ]
        ])
    }, [
        (0, $cfZzL.createElementVNode)("div", $7506cdd26f82c708$var$_hoisted_1, [
            (0, $cfZzL.createElementVNode)("div", $7506cdd26f82c708$var$_hoisted_2, [
                (0, $cfZzL.createElementVNode)("div", $7506cdd26f82c708$var$_hoisted_3, [
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: $options.typeClass.icon,
                        size: 1,
                        class: (0, $4bH2P.normalizeClass)([
                            "shrink-0 mr-3 relative top-1 lg:scale-125",
                            $options.typeClass.iconColor || $options.typeClass.text
                        ])
                    }, null, 8, [
                        "name",
                        "class"
                    ]),
                    (0, $cfZzL.createElementVNode)("div", $7506cdd26f82c708$var$_hoisted_4, [
                        (0, $cfZzL.createElementVNode)("span", $7506cdd26f82c708$var$_hoisted_5, (0, $4bH2P.toDisplayString)($props.messageTitle), 1),
                        (0, $cfZzL.createElementVNode)("span", $7506cdd26f82c708$var$_hoisted_6, (0, $4bH2P.toDisplayString)($props.messageContent), 1)
                    ])
                ]),
                (0, $cfZzL.createElementVNode)("div", $7506cdd26f82c708$var$_hoisted_7, [
                    (0, $cfZzL.createElementVNode)("button", {
                        class: (0, $4bH2P.normalizeClass)([
                            "btn btn-small text-sm w-full",
                            [
                                _ctx.ScreenSize <= 1 ? "justify-end" : "",
                                $options.typeClass.button
                            ]
                        ]),
                        onClick: _cache[0] || (_cache[0] = (...args)=>$options.messageButtonAction && $options.messageButtonAction(...args))
                    }, (0, $4bH2P.toDisplayString)($props.messageButtonContent), 3)
                ])
            ])
        ])
    ], 2);
}

});

parcelRequire.register("dlH8L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b7eb34a85193c4e$export$2e2bcd8739ae039; });
let $9b7eb34a85193c4e$var$NOOP = ()=>{};
var $9b7eb34a85193c4e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("3DU1d", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("ePtj5")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("iVEm5"))
]).then(()=>parcelRequire("3lPq7"));

});


parcelRequire.register("kr7kp", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ee0c037cbc6cc436$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $ee0c037cbc6cc436$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-b47427"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $ee0c037cbc6cc436$var$_hoisted_1 = {
    key: 1,
    "data-component": "PromotionPage.vue"
};
const $ee0c037cbc6cc436$var$_hoisted_2 = {
    key: 1,
    class: "text-right"
};
const $ee0c037cbc6cc436$var$_hoisted_3 = /*#__PURE__*/ $ee0c037cbc6cc436$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("hr", {
        class: "promotion-hr h-0.5 bg-neutral-100 ml-auto"
    }, null, -1));
const $ee0c037cbc6cc436$var$_hoisted_4 = [
    $ee0c037cbc6cc436$var$_hoisted_3
];
const $ee0c037cbc6cc436$var$_hoisted_5 = {
    key: 2,
    class: "text-right"
};
const $ee0c037cbc6cc436$var$_hoisted_6 = /*#__PURE__*/ $ee0c037cbc6cc436$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("hr", {
        class: "promotion-hr h-0.5 bg-neutral-100 ml-auto"
    }, null, -1));
const $ee0c037cbc6cc436$var$_hoisted_7 = [
    $ee0c037cbc6cc436$var$_hoisted_6
];
const $ee0c037cbc6cc436$var$_hoisted_8 = /*#__PURE__*/ $ee0c037cbc6cc436$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
        class: "mb-2 text-black heading-large"
    }, " Nie możesz wybrać więcej niż 20 list ", -1));
const $ee0c037cbc6cc436$var$_hoisted_9 = {
    class: "mx-auto mt-7",
    style: {
        "width": "100%",
        "max-width": "320px"
    }
};
const $ee0c037cbc6cc436$var$_hoisted_10 = /*#__PURE__*/ $ee0c037cbc6cc436$var$_withScopeId(()=>/*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, " Rozumiem ", -1));
const $ee0c037cbc6cc436$var$_hoisted_11 = [
    $ee0c037cbc6cc436$var$_hoisted_10
];
function $ee0c037cbc6cc436$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loader = (0, $cfZzL.resolveComponent)("Loader");
    const _component_MessageBar = (0, $cfZzL.resolveComponent)("MessageBar");
    const _component_PageHeader = (0, $cfZzL.resolveComponent)("PageHeader");
    const _component_PromotionSummary = (0, $cfZzL.resolveComponent)("PromotionSummary");
    const _component_PromotionIntroduction = (0, $cfZzL.resolveComponent)("PromotionIntroduction");
    const _component_PromotionActivePromotions = (0, $cfZzL.resolveComponent)("PromotionActivePromotions");
    const _component_PromotionSearch = (0, $cfZzL.resolveComponent)("PromotionSearch");
    const _component_PromotionCart = (0, $cfZzL.resolveComponent)("PromotionCart");
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_ModalDialog = (0, $cfZzL.resolveComponent)("ModalDialog");
    const _component_PromotionMap = (0, $cfZzL.resolveComponent)("PromotionMap");
    const _component_PromotionDisableRenewModal = (0, $cfZzL.resolveComponent)("PromotionDisableRenewModal");
    const _component_PromotionFeedbackModal = (0, $cfZzL.resolveComponent)("PromotionFeedbackModal");
    const _component_PromotionTutorial = (0, $cfZzL.resolveComponent)("PromotionTutorial");
    const _component_PromotionFillProfileModal = (0, $cfZzL.resolveComponent)("PromotionFillProfileModal");
    const _component_PromotionSummaryModals = (0, $cfZzL.resolveComponent)("PromotionSummaryModals");
    return !$data.isLoaded ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_Loader, {
        key: 0,
        "data-component": "PromotionPage.vue"
    })) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $ee0c037cbc6cc436$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)({
                "flex flex-col-reverse": _ctx.ScreenSize <= 1
            })
        }, [
            _ctx.showConfirmationMessageBar ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_MessageBar, {
                key: 0,
                "message-title": `Promowanie jest włączone na ${_ctx.enabledListsLength} ${_ctx.enabledListsLength === 1 ? "liście" : "listach"}.`,
                "message-content": "Usługa zostanie przedłużona w zależności od wybranej kategorii. Punkty zostaną pobrane automatycznie.",
                "message-type": "info",
                class: (0, $4bH2P.normalizeClass)([
                    "mb-8",
                    {
                        "mt-10": _ctx.ScreenSize > 1
                    }
                ]),
                onMessageButtonAction: $options.closeMessageBar
            }, null, 8, [
                "message-title",
                "class",
                "onMessageButtonAction"
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            (0, $cfZzL.createVNode)(_component_PageHeader, {
                Title: $options.pageHeader,
                Subtitle: _ctx.isAdminModule ? String(_ctx.customerId) : "",
                Back: !_ctx.isAdminModule || _ctx.isSummaryPage,
                BackOnDesktop: _ctx.isSummaryPage,
                EmitInstead: true,
                class: (0, $4bH2P.normalizeClass)({
                    "pb-5": _ctx.isAdminModule
                }),
                onBackClick: $options.goBack
            }, null, 8, [
                "Title",
                "Subtitle",
                "Back",
                "BackOnDesktop",
                "class",
                "onBackClick"
            ])
        ], 2),
        _ctx.isSummaryPage ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PromotionSummary, {
            key: 0
        })) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
            key: 1
        }, [
            !_ctx.isAdminModule ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PromotionIntroduction, {
                key: 0
            })) : (0, $cfZzL.createCommentVNode)("", true),
            !_ctx.isAdminModule ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $ee0c037cbc6cc436$var$_hoisted_2, $ee0c037cbc6cc436$var$_hoisted_4)) : (0, $cfZzL.createCommentVNode)("", true),
            (0, $cfZzL.createVNode)(_component_PromotionActivePromotions, {
                ref: "activePromotions",
                apiNamespace: $options.apiNamespace,
                enabledPromotions: _ctx.enabledPromotions,
                isPromotionsLimitReached: $options.isPromotionsLimitReached,
                class: "py-5",
                onAssignEnabledPromotionsCurrentSort: $options.assignEnabledPromotionsCurrentSort,
                onAssignEnabledPromotionsCurrentSortDir: $options.assignEnabledPromotionsCurrentSortDir,
                onGetEnabledPromotions: _ctx.getEnabledPromotions
            }, null, 8, [
                "apiNamespace",
                "enabledPromotions",
                "isPromotionsLimitReached",
                "onAssignEnabledPromotionsCurrentSort",
                "onAssignEnabledPromotionsCurrentSortDir",
                "onGetEnabledPromotions"
            ]),
            $options.isMobile && _ctx.enabledPromotions.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $ee0c037cbc6cc436$var$_hoisted_5, $ee0c037cbc6cc436$var$_hoisted_7)) : (0, $cfZzL.createCommentVNode)("", true),
            (0, $cfZzL.createVNode)(_component_PromotionSearch, {
                ref: "promotionSearch",
                apiNamespace: $options.apiNamespace,
                enabledPromotions: _ctx.enabledPromotions,
                isPromotionsLimitReached: $options.isPromotionsLimitReached,
                onGetAllLocationsPerCategory: $options.getAllLocationsPerCategory,
                onToggleMapModal: $options.toggleMapModal
            }, null, 8, [
                "apiNamespace",
                "enabledPromotions",
                "isPromotionsLimitReached",
                "onGetAllLocationsPerCategory",
                "onToggleMapModal"
            ]),
            (0, $cfZzL.createVNode)(_component_PromotionCart, {
                apiNamespace: $options.apiNamespace,
                isTutorialOpen: $data.isTutorialOpen,
                isPromotionsLimitReached: $options.isPromotionsLimitReached,
                onToggleMapModal: $options.toggleMapModal
            }, null, 8, [
                "apiNamespace",
                "isTutorialOpen",
                "isPromotionsLimitReached",
                "onToggleMapModal"
            ]),
            (0, $cfZzL.createVNode)(_component_ModalDialog, {
                class: "absolute flex flex-col items-center justify-center p-3 text-center bg-white promotion-limit-modal-wrapper is-dialog",
                style: {
                    "z-index": "2049"
                },
                Visible: _ctx.isLimitModalVisible
            }, {
                default: (0, $cfZzL.withCtx)(()=>[
                        (0, $cfZzL.createElementVNode)("button", {
                            class: "absolute top-0 right-0 p-3 z-32",
                            onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.togglePromotionLimitModal(false))
                        }, [
                            (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                name: "close",
                                size: "1"
                            })
                        ]),
                        (0, $cfZzL.createElementVNode)("div", null, [
                            (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                name: "exclamation-circle",
                                size: "4",
                                class: "mb-3",
                                style: {
                                    "color": "var(--accent)"
                                }
                            }),
                            $ee0c037cbc6cc436$var$_hoisted_8,
                            (0, $cfZzL.createElementVNode)("div", $ee0c037cbc6cc436$var$_hoisted_9, [
                                (0, $cfZzL.createElementVNode)("button", {
                                    class: "w-full btn btn-primary",
                                    onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.togglePromotionLimitModal(false))
                                }, $ee0c037cbc6cc436$var$_hoisted_11)
                            ])
                        ])
                    ]),
                _: 1
            }, 8, [
                "Visible"
            ]),
            $data.isMapModalVisible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PromotionMap, {
                key: 3,
                preselectedLocations: $options.mapPreselectedLocations,
                preselectedLocationsFromCart: $options.mapPreselectedLocationsFromCart,
                blockedLocations: $options.blockedLocations,
                isPromotionsLimitReached: $options.isPromotionsLimitReached,
                namesAndIdsLocations: $options.mapNamesAndIdsLocations,
                onToggleMapModal: $options.toggleMapModal,
                onAssignSelectedLocations: $options.assignSelectedLocations,
                onUpdateCartFromMap: $options.updateCartFromMap
            }, null, 8, [
                "preselectedLocations",
                "preselectedLocationsFromCart",
                "blockedLocations",
                "isPromotionsLimitReached",
                "namesAndIdsLocations",
                "onToggleMapModal",
                "onAssignSelectedLocations",
                "onUpdateCartFromMap"
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            _ctx.isDisableRenewModalVisible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PromotionDisableRenewModal, {
                key: 4
            })) : (0, $cfZzL.createCommentVNode)("", true),
            _ctx.isFeedbackModalVisible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PromotionFeedbackModal, {
                key: 5,
                apiNamespace: $options.apiNamespace
            }, null, 8, [
                "apiNamespace"
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            ($data.showOnboarding, (0, $cfZzL.createCommentVNode)("", true))
        ], 64)),
        _ctx.isFillProfileModalVisible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PromotionFillProfileModal, {
            key: 2
        })) : (0, $cfZzL.createCommentVNode)("", true),
        ($data.showOnboarding, (0, $cfZzL.createCommentVNode)("", true)),
        _ctx.isPromotionModalVisible || Boolean(_ctx.$route.query.rechargeAccount) ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PromotionSummaryModals, {
            key: 4
        })) : (0, $cfZzL.createCommentVNode)("", true)
    ]));
}

});

parcelRequire.register("9jz99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c8126c42d7cfa3c$export$2e2bcd8739ae039; });
let $6c8126c42d7cfa3c$var$NOOP = ()=>{};
var $6c8126c42d7cfa3c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("cg0Ld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec791b5205138cb$export$2e2bcd8739ae039; });
let $8ec791b5205138cb$var$script;



let $8ec791b5205138cb$var$initialize = ()=>{
    $8ec791b5205138cb$var$script = (parcelRequire("khU0u"));
    if ($8ec791b5205138cb$var$script.__esModule) $8ec791b5205138cb$var$script = $8ec791b5205138cb$var$script.default;
    $8ec791b5205138cb$var$script.render = (parcelRequire("5gqlj")).render;
    (parcelRequire("6oZ2S")).default($8ec791b5205138cb$var$script);
    $8ec791b5205138cb$var$script.__scopeId = "data-v-4014c7";
    $8ec791b5205138cb$var$script.__file = "DummyElement.vue";
};
$8ec791b5205138cb$var$initialize();
var $8ec791b5205138cb$export$2e2bcd8739ae039 = $8ec791b5205138cb$var$script;

});
parcelRequire.register("khU0u", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $929d749f73da0e49$export$2e2bcd8739ae039; });
// @vuese
// Pusty komponent wysyłający zdarzenia `mounted` i `created`.
// @group Base Components
var $929d749f73da0e49$export$2e2bcd8739ae039 = {
    name: "DummyElement",
    emits: [
        "mounted",
        "created"
    ],
    mounted () {
        this.$emit("mounted");
    },
    created () {
        this.$emit("created");
    }
};

});

parcelRequire.register("5gqlj", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $3d52e17f33776d43$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
const $3d52e17f33776d43$var$_hoisted_1 = {
    "data-component": "DummyElement.vue"
};
function $3d52e17f33776d43$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $3d52e17f33776d43$var$_hoisted_1);
}

});

parcelRequire.register("6oZ2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a945654106ffd10$export$2e2bcd8739ae039; });
let $4a945654106ffd10$var$NOOP = ()=>{};
var $4a945654106ffd10$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("20lOb", function(module, exports) {

$parcel$export(module.exports, "useLocationStore", function () { return $768905d7e797197c$export$5327744dfd9bbb52; });

var $jgrCW = parcelRequire("jgrCW");
const $768905d7e797197c$export$5327744dfd9bbb52 = (0, $jgrCW.defineStore)({
    id: "location",
    state: ()=>({
            countries: [
                {
                    Value: "locationPl",
                    Label: "Polska"
                },
                {
                    Value: "locationDe",
                    Label: "Niemcy"
                },
                {
                    Value: "locationRus",
                    Label: "Rosja"
                },
                {
                    Value: "locationSk",
                    Label: "Słowacja"
                },
                {
                    Value: "locationCz",
                    Label: "Czechy"
                },
                {
                    Value: "locationGb",
                    Label: "Wielka Brytania"
                },
                {
                    Value: "locationIrl",
                    Label: "Irlandia"
                },
                {
                    Value: "locationAfg",
                    Label: "Afganistan"
                },
                {
                    Value: "locationAl",
                    Label: "Albania"
                },
                {
                    Value: "locationAnd",
                    Label: "Andora"
                },
                {
                    Value: "locationAs",
                    Label: "Arabia Saudyjska"
                },
                {
                    Value: "locationA",
                    Label: "Austria"
                },
                {
                    Value: "locationAz",
                    Label: "Azerbejdżan"
                },
                {
                    Value: "locationB",
                    Label: "Belgia"
                },
                {
                    Value: "locationBy",
                    Label: "Białoruś"
                },
                {
                    Value: "locationBih",
                    Label: "Bośnia i Hercegowina"
                },
                {
                    Value: "locationBg",
                    Label: "Bułgaria"
                },
                {
                    Value: "locationChn",
                    Label: "Chiny"
                },
                {
                    Value: "locationHr",
                    Label: "Chorwacja"
                },
                {
                    Value: "locationCy",
                    Label: "Cypr"
                },
                {
                    Value: "locationMne",
                    Label: "Czarnog\xf3ra"
                },
                {
                    Value: "locationCz",
                    Label: "Czechy"
                },
                {
                    Value: "locationDk",
                    Label: "Dania"
                },
                {
                    Value: "locationEst",
                    Label: "Estonia"
                },
                {
                    Value: "locationFin",
                    Label: "Finlandia"
                },
                {
                    Value: "locationF",
                    Label: "Francja"
                },
                {
                    Value: "locationGr",
                    Label: "Grecja"
                },
                {
                    Value: "locationGe",
                    Label: "Gruzja"
                },
                {
                    Value: "locationE",
                    Label: "Hiszpania"
                },
                {
                    Value: "locationNl",
                    Label: "Holandia"
                },
                {
                    Value: "locationInd",
                    Label: "Indie"
                },
                {
                    Value: "locationIrq",
                    Label: "Irak"
                },
                {
                    Value: "locationIr",
                    Label: "Iran"
                },
                {
                    Value: "locationIrl",
                    Label: "Irlandia"
                },
                {
                    Value: "locationIs",
                    Label: "Islandia"
                },
                {
                    Value: "locationCan",
                    Label: "Kanada"
                },
                {
                    Value: "locationKz",
                    Label: "Kazachstan"
                },
                {
                    Value: "locationKgz",
                    Label: "Kirgistan"
                },
                {
                    Value: "locationFl",
                    Label: "Liechtenstein"
                },
                {
                    Value: "locationLt",
                    Label: "Litwa"
                },
                {
                    Value: "locationL",
                    Label: "Luksemburg"
                },
                {
                    Value: "locationLv",
                    Label: "Łotwa"
                },
                {
                    Value: "locationMk",
                    Label: "Macedonia"
                },
                {
                    Value: "locationM",
                    Label: "Malta"
                },
                {
                    Value: "locationMa",
                    Label: "Maroko"
                },
                {
                    Value: "locationMd",
                    Label: "Mołdawia"
                },
                {
                    Value: "locationMc",
                    Label: "Monako"
                },
                {
                    Value: "locationMn",
                    Label: "Mongolia"
                },
                {
                    Value: "locationDe",
                    Label: "Niemcy"
                },
                {
                    Value: "locationN",
                    Label: "Norwegia"
                },
                {
                    Value: "locationSy",
                    Label: "Palestyna"
                },
                {
                    Value: "locationP",
                    Label: "Portugalia"
                },
                {
                    Value: "locationPl",
                    Label: "Polska"
                },
                {
                    Value: "locationRus",
                    Label: "Rosja"
                },
                {
                    Value: "locationRo",
                    Label: "Rumunia"
                },
                {
                    Value: "locationSrb",
                    Label: "Serbia"
                },
                {
                    Value: "locationSk",
                    Label: "Słowacja"
                },
                {
                    Value: "locationSlo",
                    Label: "Słowenia"
                },
                {
                    Value: "locationUsa",
                    Label: "Stany Zjednoczone"
                },
                {
                    Value: "locationSyr",
                    Label: "Syria"
                },
                {
                    Value: "locationCh",
                    Label: "Szwajcaria"
                },
                {
                    Value: "locationS",
                    Label: "Szwecja"
                },
                {
                    Value: "locationTr",
                    Label: "Turcja"
                },
                {
                    Value: "locationTm",
                    Label: "Turkmenistan"
                },
                {
                    Value: "locationUa",
                    Label: "Ukraina"
                },
                {
                    Value: "locationUz",
                    Label: "Uzbekistan"
                },
                {
                    Value: "locationH",
                    Label: "Węgry"
                },
                {
                    Value: "locationGb",
                    Label: "Wielka Brytania"
                },
                {
                    Value: "locationI",
                    Label: "Włochy"
                }
            ],
            poland: [
                {
                    Value: "locationPlDl",
                    Label: "Dolnośląskie"
                },
                {
                    Value: "locationPlKp",
                    Label: "Kujawsko-pomorskie"
                },
                {
                    Value: "locationPlLbl",
                    Label: "Lubelskie"
                },
                {
                    Value: "locationPlLbs",
                    Label: "Lubuskie"
                },
                {
                    Value: "locationPlLd",
                    Label: "Ł\xf3dzkie"
                },
                {
                    Value: "locationPlMp",
                    Label: "Małopolskie"
                },
                {
                    Value: "locationPlMz",
                    Label: "Mazowieckie"
                },
                {
                    Value: "locationPlOp",
                    Label: "Opolskie"
                },
                {
                    Value: "locationPlPk",
                    Label: "Podkarpackie"
                },
                {
                    Value: "locationPlPdl",
                    Label: "Podlaskie"
                },
                {
                    Value: "locationPlPm",
                    Label: "Pomorskie"
                },
                {
                    Value: "locationPlSl",
                    Label: "Śląskie"
                },
                {
                    Value: "locationPlSw",
                    Label: "Świętokrzyskie"
                },
                {
                    Value: "locationPlWm",
                    Label: "Warmińsko-mazurskie"
                },
                {
                    Value: "locationPlWp",
                    Label: "Wielkopolskie"
                },
                {
                    Value: "locationPlZp",
                    Label: "Zachodniopomorskie"
                }
            ],
            districts: {}
        }),
    getters: {
        foreignCountries: (state)=>state.countries.filter((country)=>country.Value !== "locationPl"),
        countriesByCode: (state)=>{
            const result = [];
            state.countries.forEach((c)=>{
                const countryCode = c.Value.replace("location", "").toUpperCase();
                result.push({
                    Value: countryCode,
                    Label: `<span class="suggestions-list-hide">${countryCode}</span><span class="dropdown-button-hide">${c.Label}</span>`
                });
            });
            return result;
        }
    },
    actions: {
        async getDistrict (region) {
            if (this.districts[region]) return this.districts[region];
            let result = [];
            const url = `/common/dictionary/zip/districts.ofer?zipSearch.idLocationExt=${region}`;
            await fetch(url).then((rsvp)=>rsvp.text()).then((rsvp)=>{
                const o = new DOMParser().parseFromString(rsvp, "text/html").querySelectorAll("option");
                result = Array.prototype.map.call(o, (r)=>({
                        Value: r.value,
                        Label: r.innerText.replace("powiat ", "")
                    }));
            });
            this.districts[region] = result;
            return result;
        }
    }
});

});

parcelRequire.register("eYjM4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ae66020f42d55e26$export$2e2bcd8739ae039; });
let $ae66020f42d55e26$var$script;



let $ae66020f42d55e26$var$initialize = ()=>{
    $ae66020f42d55e26$var$script = (parcelRequire("d6KtB"));
    if ($ae66020f42d55e26$var$script.__esModule) $ae66020f42d55e26$var$script = $ae66020f42d55e26$var$script.default;
    $ae66020f42d55e26$var$script.render = (parcelRequire("2wVl1")).render;
    (parcelRequire("2yXjt")).default($ae66020f42d55e26$var$script);
    $ae66020f42d55e26$var$script.__scopeId = "data-v-94015f";
    $ae66020f42d55e26$var$script.__file = "PromptDialog.vue";
};
$ae66020f42d55e26$var$initialize();
var $ae66020f42d55e26$export$2e2bcd8739ae039 = $ae66020f42d55e26$var$script;

});
parcelRequire.register("d6KtB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3dc1d73aa4761193$export$2e2bcd8739ae039; });

var $iPqED = parcelRequire("iPqED");
var /*
	Okno dialogowe z pytaniem oraz przyciskami.
*/ $3dc1d73aa4761193$export$2e2bcd8739ae039 = {
    name: "PromptDialog",
    components: {
        BaseDialog: $iPqED.default
    },
    props: {
        /**
		 * Czy modal ma być wyświetlony?
		 */ modelValue: {
            type: Boolean,
            default: false
        },
        /**
		 * Zamiast aktualizować model przy wywołaniu akcji, wywołaj `window.history.back()`.
		 */ historyMode: {
            type: Boolean,
            default: true
        },
        /**
		 * Tytuł pytania
		 */ title: {
            type: String,
            default: ""
        },
        /**
		 * Treść pytania
		 */ body: {
            type: String,
            default: ""
        },
        /**
		 * Treść przycisku potwierdzającego
		 */ confirmText: {
            type: String,
            default: "OK"
        },
        /**
		 * Treść przycisku pomocniczego (jeżeli puste - nie wyświetlaj)
		 */ secondaryText: {
            type: String,
            default: ""
        },
        /**
		 * Treść przycisku anulującego dialog (może mieć inne działanie
		 * niż inny sposób zamknięcia okna, poprzez sprawdzenie parametru akcji `@dimissed`)
		 */ dismissText: {
            type: String,
            default: "Anuluj"
        },
        /**
		 * Czy dismissButton ma mieć ramke?
		 */ isDismissButtonBorder: {
            type: Boolean,
            default: false
        },
        /**
		 * Typ okna dialogowego
		 */ type: {
            type: String,
            default: "default"
        }
    },
    emits: [
        "update:modelValue",
        "dismissed",
        "confirmed",
        "confirmed-secondary",
        "opened",
        "closed"
    ],
    methods: {
        /**
		 * Po kliknięciu przycisku wysyła odpowiednie zdarzenie (`confirmed`, `confirmed-secondary`, `dismissed`)
		 * @param name Typ przycisku
		 * @param source Źródło kliknięcia (przycisk, krzyżyk, nakładka)
		 */ emitAction (name, source = "button") {
            this.$emit(name, source);
            this.close();
        },
        /**
		 * Zamyka okno dialogowe: w zależności od właściwościwości `historyMode`, ustawia
		 */ close () {
            this.$refs.dialog.close();
        }
    }
};

});
parcelRequire.register("iPqED", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $db51aa6a66e612dd$export$2e2bcd8739ae039; });
let $db51aa6a66e612dd$var$script;




let $db51aa6a66e612dd$var$initialize = ()=>{
    $db51aa6a66e612dd$var$script = (parcelRequire("ljTwE"));
    if ($db51aa6a66e612dd$var$script.__esModule) $db51aa6a66e612dd$var$script = $db51aa6a66e612dd$var$script.default;
    $db51aa6a66e612dd$var$script.render = (parcelRequire("85A9j")).render;
    $db51aa6a66e612dd$var$script.__cssModules = {};
    (parcelRequire("l2dwC")).default($db51aa6a66e612dd$var$script);
    $db51aa6a66e612dd$var$script.__scopeId = "data-v-a873e1";
    $db51aa6a66e612dd$var$script.__file = "BaseDialog.vue";
};
$db51aa6a66e612dd$var$initialize();
var $db51aa6a66e612dd$export$2e2bcd8739ae039 = $db51aa6a66e612dd$var$script;

});
parcelRequire.register("ljTwE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7454dba018258686$export$2e2bcd8739ae039; });
var /*
	Okno dialogowe.
*/ $7454dba018258686$export$2e2bcd8739ae039 = {
    name: "BaseDialog",
    props: {
        /**
		 * Czy modal ma być wyświetlony?
		 */ modelValue: {
            type: Boolean,
            default: false
        },
        /**
		 * Zamiast aktualizować model przy wywołaniu akcji, wywołaj `window.history.back()`.
		 */ historyMode: {
            type: Boolean,
            default: true
        },
        /**
		 * Czy zamknąć okno po kliknięciu na nakładkę?
		 */ closeOnOverlay: {
            type: Boolean,
            default: true
        },
        /**
		 * Czy wyświetlić przycisk do zamknięcia?
		 */ displayClose: {
            type: Boolean,
            default: true
        },
        /**
		 * Czy wyświetlić przycisk wywołujący akcję cofnięcia (jeżeli okno posiada tytuł i jesteśmy na mobilce)?
		 */ displayBack: {
            type: Boolean,
            default: true
        },
        /**
		 * Tytuł okna dialogowego
		 */ windowTitle: {
            type: String,
            default: ""
        },
        /**
		 * Jakiego stylu użyć dla okna dialogowego?
		 */ type: {
            type: String,
            default: "default"
        },
        /*
 		* Klasy, które powinny być zastosowane do wewnętrznego kontenera
 		*/ contentClass: {
            type: String,
            default: ""
        },
        /**
		 * Atrybut data test potrzebny testerom
		 */ dataTest: {
            type: String,
            default: undefined
        }
    },
    emits: [
        "update:modelValue",
        "dismissed",
        "opened",
        "closed",
        "go-back"
    ],
    data () {
        return {
            /**
			 * Pokaż zawartość okna (po zakończeniu animacji nakładki)
			 */ showContent: this.modelValue,
            /** Styl okna dialogowego */ contentStyle: {
                default: "max-w-[564px] rounded-t-lg sm:rounded-b-lg text-center sm:text-left py-6 px-8",
                window: "max-w-[600px] sm:max-h-[600px] sm:rounded-lg h-full",
                large: "max-w-[760px] rounded-t-lg sm:rounded-b-lg text-center sm:text-left py-6 px-8"
            }
        };
    },
    computed: {
        isWindow () {
            return this.type === "window";
        }
    },
    watch: {
        /**
		 * Podczas zmiany stanu wyświetlenia okna, wyślij odpowiedni event o stanie otwarcia dialogu
		 */ modelValue (value) {
            if (value) this.$emit("opened");
            else this.$emit("closed");
        }
    },
    methods: {
        /**
		 * Po kliknięciu przycisku wysyła odpowiednie zdarzenie (`dismissed`)
		 * @param source Źródło kliknięcia (przycisk, nakładka)
		 */ dismiss (source) {
            if (source === "overlay" && !this.closeOnOverlay) return;
            this.$emit("dismissed", source);
            this.close();
        },
        /**
		 * Zamyka okno dialogowe: w zależności od właściwościwości `historyMode`, ustawia
		 */ close () {
            this.showContent = false;
            if (this.historyMode) window.history.back();
            else this.$emit("update:modelValue", false);
        }
    }
};

});

parcelRequire.register("85A9j", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $5e3ad4d9feba1292$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $brqXq = parcelRequire("brqXq");
var $4bH2P = parcelRequire("4bH2P");
const $5e3ad4d9feba1292$var$_hoisted_1 = [
    "innerHTML"
];
const $5e3ad4d9feba1292$var$_hoisted_2 = [
    "innerHTML"
];
const $5e3ad4d9feba1292$var$_hoisted_3 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "grow"
}, null, -1);
const $5e3ad4d9feba1292$var$_hoisted_4 = {
    key: 1,
    class: "sm:mb-4 flex justify-end mb-5 -mx-2"
};
const $5e3ad4d9feba1292$var$_hoisted_5 = {
    key: 2,
    class: "bg-white shadow-default py-3 px-4 lg:px-6 sticky w-full"
};
function $5e3ad4d9feba1292$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)((0, $brqXq.Transition), {
        name: "dialog-fade",
        onAfterEnter: _cache[7] || (_cache[7] = ($event)=>$data.showContent = true)
    }, {
        default: (0, $cfZzL.withCtx)(()=>[
                $props.modelValue ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                    key: 0,
                    "data-component": "BaseDialog.vue",
                    class: "prompt-dialog | !max-w-full fixed inset-0 grid items-end sm:items-center bg-black/50 z-2048",
                    onClick: _cache[6] || (_cache[6] = ($event)=>$options.dismiss("overlay"))
                }, [
                    (0, $cfZzL.createVNode)((0, $brqXq.Transition), {
                        name: "dialog-slide",
                        onAfterLeave: _cache[5] || (_cache[5] = ($event)=>$data.showContent = false)
                    }, {
                        default: (0, $cfZzL.withCtx)(()=>[
                                $data.showContent ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                    key: 0,
                                    class: (0, $4bH2P.normalizeClass)([
                                        "prompt-dialog-content | relative bg-white w-full mx-auto flex flex-col max-h-full overflow-hidden",
                                        [
                                            $data.contentStyle[$props.type],
                                            $props.contentClass
                                        ]
                                    ]),
                                    onClick: _cache[4] || (_cache[4] = (0, $brqXq.withModifiers)(()=>{}, [
                                        "stop"
                                    ]))
                                }, [
                                    $options.isWindow ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                        key: 0,
                                        class: (0, $4bH2P.normalizeClass)([
                                            "shrink-0 flex items-center gap-2",
                                            _ctx.ScreenSize < 1 ? "py-4 px-5 border-neutral-100 border-b shadow-sm" : "pt-6 pb-10 px-6 justify-between"
                                        ])
                                    }, [
                                        _ctx.ScreenSize >= 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                            key: 0
                                        }, [
                                            (0, $cfZzL.createElementVNode)("div", {
                                                class: "heading-5",
                                                innerHTML: $props.windowTitle
                                            }, null, 8, $5e3ad4d9feba1292$var$_hoisted_1),
                                            $props.displayClose ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                                                key: 0,
                                                "data-test": $props.dataTest && `${$props.dataTest}__close`,
                                                class: "text-neutral-700 cursor-pointer p-[10px]",
                                                name: "close",
                                                size: 2,
                                                onClick: _cache[0] || (_cache[0] = ($event)=>$options.dismiss("window"))
                                            }, null, 8, [
                                                "data-test"
                                            ])) : (0, $cfZzL.createCommentVNode)("", true)
                                        ], 64)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                            key: 1
                                        }, [
                                            $props.displayBack ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                                                key: 0,
                                                class: "p-1",
                                                name: "arrow-left",
                                                size: 1.5,
                                                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("go-back"))
                                            })) : (0, $cfZzL.createCommentVNode)("", true),
                                            (0, $cfZzL.createElementVNode)("div", {
                                                class: "font-bold text-base",
                                                innerHTML: $props.windowTitle
                                            }, null, 8, $5e3ad4d9feba1292$var$_hoisted_2),
                                            $5e3ad4d9feba1292$var$_hoisted_3,
                                            $props.displayClose ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                                                key: 1,
                                                "data-test": $props.dataTest && `${$props.dataTest}__close`,
                                                class: "p-2",
                                                name: "close",
                                                size: 1.5,
                                                onClick: _cache[2] || (_cache[2] = ($event)=>$options.dismiss("window"))
                                            }, null, 8, [
                                                "data-test"
                                            ])) : (0, $cfZzL.createCommentVNode)("", true)
                                        ], 64))
                                    ], 2)) : $props.displayClose ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $5e3ad4d9feba1292$var$_hoisted_4, [
                                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                            class: "text-neutral-700 cursor-pointer p-[10px]",
                                            "data-test": $props.dataTest && `${$props.dataTest}__close`,
                                            name: "close",
                                            size: 2,
                                            onClick: _cache[3] || (_cache[3] = ($event)=>$options.dismiss("window"))
                                        }, null, 8, [
                                            "data-test"
                                        ])
                                    ])) : (0, $cfZzL.createCommentVNode)("", true),
                                    (0, $cfZzL.createElementVNode)("div", {
                                        class: (0, $4bH2P.normalizeClass)([
                                            "grow",
                                            {
                                                "px-4 lg:px-6 overflow-y-auto": $options.isWindow
                                            }
                                        ])
                                    }, [
                                        (0, $cfZzL.renderSlot)(_ctx.$slots, "default")
                                    ], 2),
                                    _ctx.$slots.footer ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $5e3ad4d9feba1292$var$_hoisted_5, [
                                        (0, $cfZzL.renderSlot)(_ctx.$slots, "footer")
                                    ])) : (0, $cfZzL.createCommentVNode)("", true)
                                ], 2)) : (0, $cfZzL.createCommentVNode)("", true)
                            ]),
                        _: 3
                    })
                ])) : (0, $cfZzL.createCommentVNode)("", true)
            ]),
        _: 3
    });
}

});

parcelRequire.register("l2dwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f50446b06109f67c$export$2e2bcd8739ae039; });
let $f50446b06109f67c$var$NOOP = ()=>{};
var $f50446b06109f67c$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("2wVl1", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $1d7b0c1844f40063$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $brqXq = parcelRequire("brqXq");
var $4bH2P = parcelRequire("4bH2P");
const $1d7b0c1844f40063$var$_hoisted_1 = {
    class: "flex flex-col gap-3 sm:text-base text-sm"
};
const $1d7b0c1844f40063$var$_hoisted_2 = [
    "innerHTML"
];
const $1d7b0c1844f40063$var$_hoisted_3 = [
    "innerHTML"
];
const $1d7b0c1844f40063$var$_hoisted_4 = {
    class: "sm:flex-row-reverse sm:mb-0 w-max sm:w-full flex flex-col gap-2 mx-auto mt-6 mb-2"
};
const $1d7b0c1844f40063$var$_hoisted_5 = [
    "innerHTML"
];
const $1d7b0c1844f40063$var$_hoisted_6 = [
    "innerHTML"
];
const $1d7b0c1844f40063$var$_hoisted_7 = [
    "innerHTML"
];
function $1d7b0c1844f40063$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseDialog = (0, $cfZzL.resolveComponent)("BaseDialog");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseDialog, {
        "data-component": "PromptDialog.vue",
        ref: "dialog",
        modelValue: $props.modelValue,
        historyMode: $props.historyMode,
        type: $props.type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>{
            _ctx.$emit("update:modelValue", $event);
        }),
        onDismissed: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("dismissed", $event)),
        onOpened: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("opened")),
        onClosed: _cache[6] || (_cache[6] = ($event)=>_ctx.$emit("closed"))
    }, {
        default: (0, $cfZzL.withCtx)(()=>[
                (0, $cfZzL.createElementVNode)("div", $1d7b0c1844f40063$var$_hoisted_1, [
                    $props.title ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: 0,
                        class: "text-xl font-bold",
                        innerHTML: $props.title
                    }, null, 8, $1d7b0c1844f40063$var$_hoisted_2)) : (0, $cfZzL.createCommentVNode)("", true),
                    $props.body ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: 1,
                        innerHTML: $props.body
                    }, null, 8, $1d7b0c1844f40063$var$_hoisted_3)) : (0, $cfZzL.createCommentVNode)("", true),
                    (0, $cfZzL.renderSlot)(_ctx.$slots, "default")
                ]),
                (0, $cfZzL.createElementVNode)("div", $1d7b0c1844f40063$var$_hoisted_4, [
                    $props.confirmText ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                        key: 0,
                        "data-test": "prompt_dialog__confirm",
                        class: "btn btn-info btn-medium",
                        onClick: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)(($event)=>$options.emitAction("confirmed", "button"), [
                            "prevent"
                        ])),
                        innerHTML: $props.confirmText
                    }, null, 8, $1d7b0c1844f40063$var$_hoisted_5)) : (0, $cfZzL.createCommentVNode)("", true),
                    $props.secondaryText ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                        key: 1,
                        "data-test": "prompt_dialog__confirm_secondary",
                        class: "btn btn-outline-info btn-medium ml-0 sm:ml-auto",
                        onClick: _cache[1] || (_cache[1] = (0, $brqXq.withModifiers)(($event)=>$options.emitAction("confirmed-secondary", "button"), [
                            "prevent"
                        ])),
                        innerHTML: $props.secondaryText
                    }, null, 8, $1d7b0c1844f40063$var$_hoisted_6)) : (0, $cfZzL.createCommentVNode)("", true),
                    $props.dismissText ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                        key: 2,
                        "data-test": "prompt_dialog__dissmised",
                        class: (0, $4bH2P.normalizeClass)([
                            "btn btn-medium text-info",
                            {
                                "border border-solid border-info": $props.isDismissButtonBorder
                            }
                        ]),
                        onClick: _cache[2] || (_cache[2] = (0, $brqXq.withModifiers)(($event)=>$options.emitAction("dismissed", "button"), [
                            "prevent"
                        ])),
                        innerHTML: $props.dismissText
                    }, null, 10, $1d7b0c1844f40063$var$_hoisted_7)) : (0, $cfZzL.createCommentVNode)("", true)
                ])
            ]),
        _: 3
    }, 8, [
        "modelValue",
        "historyMode",
        "type"
    ]);
}

});

parcelRequire.register("2yXjt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ddcc41da7a8700f$export$2e2bcd8739ae039; });
let $1ddcc41da7a8700f$var$NOOP = ()=>{};
var $1ddcc41da7a8700f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("f3OCz", function(module, exports) {

$parcel$export(module.exports, "getDeviceType", function () { return $3119c61f510d0a22$export$abfb0136cf8e916b; });
$parcel$export(module.exports, "getDeviceData", function () { return $3119c61f510d0a22$export$fb9ff29788bfaf04; });
$parcel$export(module.exports, "getUserAgent", function () { return $3119c61f510d0a22$export$7935961ef7719cb0; });
$parcel$export(module.exports, "default", function () { return $3119c61f510d0a22$export$2e2bcd8739ae039; });
/*
	Zwraca rodzaj urządzenia: czy jest to wersja webowa (z rozróżnieniem na desktop / mobile), czy też aplikacjaze sklepu.
	@param includeAppType - dodaj typ aplikacji (Buyer/Seller)
*/ const $3119c61f510d0a22$export$abfb0136cf8e916b = (includeAppType = false)=>{
    const { userAgent: userAgent } = navigator;
    const isIpad = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1 || /iPad/i.test(userAgent);
    const isPhone = /Android|iPhone/i.test(userAgent);
    const isApp = window.localStorage["IsApp"] === "yes" || userAgent.indexOf("appstore.oferteo") > -1;
    let result = isPhone || isIpad ? "WebAppMobile" : "WebAppDesktop";
    if (!isApp && window.matchMedia("(display-mode: standalone)").matches) result += "Pwa";
    if (isApp) {
        result = userAgent.indexOf("appstore.oferteo") > -1 ? "AppleApp" : "AndroidApp";
        if (includeAppType) result = `${result}-${window.localStorage.getItem("isBuyerApp") === "true" ? "BuyerApp" : "SellerApp"}`;
    }
    return result;
};
const $3119c61f510d0a22$export$fb9ff29788bfaf04 = ()=>{
    const result = window.matchMedia("(pointer: fine)").matches ? "desktop" : "mobile";
    return result;
};
const $3119c61f510d0a22$export$7935961ef7719cb0 = ()=>{
    const result = navigator.userAgent;
    return result;
};
var $3119c61f510d0a22$export$2e2bcd8739ae039 = $3119c61f510d0a22$export$abfb0136cf8e916b;

});

parcelRequire.register("kdEbn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb8430f55ea0d6fb$export$2e2bcd8739ae039; });
let $eb8430f55ea0d6fb$var$script;



let $eb8430f55ea0d6fb$var$initialize = ()=>{
    $eb8430f55ea0d6fb$var$script = (parcelRequire("NKKr7"));
    if ($eb8430f55ea0d6fb$var$script.__esModule) $eb8430f55ea0d6fb$var$script = $eb8430f55ea0d6fb$var$script.default;
    $eb8430f55ea0d6fb$var$script.render = (parcelRequire("lc6Vd")).render;
    (parcelRequire("cQd8K")).default($eb8430f55ea0d6fb$var$script);
    $eb8430f55ea0d6fb$var$script.__scopeId = "data-v-ef0378";
    $eb8430f55ea0d6fb$var$script.__file = "NipInput.vue";
};
$eb8430f55ea0d6fb$var$initialize();
var $eb8430f55ea0d6fb$export$2e2bcd8739ae039 = $eb8430f55ea0d6fb$var$script;

});
parcelRequire.register("NKKr7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e10859da6fff64c9$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $20lOb = parcelRequire("20lOb");

var $goO1A = parcelRequire("goO1A");

var $3cbAx = parcelRequire("3cbAx");
var $e10859da6fff64c9$export$2e2bcd8739ae039 = {
    name: "NipInput",
    props: {
        modelValue: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            default: "nipInput"
        },
        dataTest: {
            type: String,
            default: "nip"
        },
        doNotBlock: {
            type: Boolean,
            default: false
        },
        forceDisabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "update:modelValue",
        "dirty"
    ],
    data () {
        const hotlineLink = '<a href="/kontakt.html" target="_blank" class="font-bold page-link text-info">Biurem obsługi Klienta</a>';
        return {
            isChanging: false,
            validationMessages: {
                NIP_TOO_LONG: "Nieprawidłowa długość numeru NIP",
                NIP_WRONG_LENGTH: "Nieprawidłowa długość numeru NIP",
                NIP_CONTAINS_NON_DIGIT: "Numer NIP może zawierać tylko cyfry",
                NIP_WRONG_CHECKSUM: "Nieprawidłowa suma kontrolna numeru NIP",
                NIP_EMPTY: "Numer NIP nie może być pusty",
                NIP_DUPLICATED: `Numer NIP jest już przypisany do innego konta. Skontaktuj się z ${hotlineLink}, aby zweryfikować konto.`,
                NIP_DISABLED: `Aby zmienić NIP, skontaktuj się z ${hotlineLink}`,
                NIP_ERROR: "Wystąpił błąd podczas sprawdzania numeru NIP"
            },
            validationMessage: "",
            isDisabled: false
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $20lOb.useLocationStore), [
            "countriesByCode"
        ]),
        ...(0, $jgrCW.mapStores)((0, $3cbAx.useUserStore)),
        wrapperOutlineClass () {
            if (this.doNotBlock && !this.validationMessage) return "";
            if (this.isDisabled && !this.doNotBlock) return "";
            if (!!this.validationMessage || !this.modelValue.isIndividual && !this.modelValue.value.length) return "!shadow-danger !shadow-outline";
            if (!this.validationMessage && this.modelValue.value.length && !this.isChanging) return "!shadow-success !shadow-outline";
            return "";
        }
    },
    mounted () {
        if (this.doNotBlock) this.validateField();
        this.setDisabled();
    },
    methods: {
        setDisabled () {
            this.isDisabled = this.doNotBlock ? false : !!this.modelValue.value && !this.validationMessage;
        },
        onKeyUp () {
            this.$emit("dirty");
            this.modelValue.value = this.modelValue.value.replace(/\D/g, "");
        },
        onKeyDown (e) {
            this.isChanging = true;
            if (this.modelValue.country !== "PL") return;
            // Enable keyboard schortcuts for copy/paste and various actions
            if (e.ctrlKey) return;
            // Ignore non-numeric characters for NIP fields for non-polish numbers.
            const allowedKeys = [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
                "Home",
                "End"
            ];
            if (!allowedKeys.includes(e.key)) e.preventDefault(); // Prevent the default action of the keypress event
        },
        onInput () {
            this.isChanging = false;
            this.modelValue.value = (this.modelValue.value || "").replace(/\D/g, "");
            this.$emit("dirty");
            this.validateField();
            this.$emit("update:modelValue", this.modelValue);
        },
        /**
		 * Wysyła żądanie do serwera o sprawdzenie poprawności wpisanych danych.
		 * @returns `true` jeżeli dane są poprawne.
		 */ async validateField () {
            this.validationMessage = "";
            const { modelValue: value } = this;
            if (value.isIndividual && !value.value) return true;
            if (this.doNotBlock && !value.value) return true;
            if (this.forceDisabled || this.isDisabled) return true;
            const rsvp = await (0, $goO1A.default)("/myoferteo/konto-json/validate-nip.ofer", {
                idCustomer: this.userStore.customerId,
                "nip.country": value.country,
                "nip.value": value.value,
                "nip.isIndividual": value.isIndividual
            }, "POST");
            if (!rsvp.status) {
                this.validationMessage = this.validationMessages["NIP_ERROR"];
                return false;
            }
            const validationMessage = rsvp.validationMessage || "";
            this.validationMessage = this.validationMessages[validationMessage] || "";
            // Jeżeli jesteśmy w trybie nieblokującym, tj. w edycji danych do faktury,
            // zignoruj komunikaty o pustym, bądź zduplikowanym NIPie.
            if (this.doNotBlock && validationMessage === "NIP_DUPLICATED") {
                this.validationMessage = "";
                return true;
            }
            return !validationMessage;
        },
        async saveNipData () {
            const actionInputJSONString = JSON.stringify({
                object: "nip",
                data: this.modelValue
            });
            await (0, $goO1A.default)("/myoferteo/konto-json/update-profile.ofer", {
                object: "nip",
                actionInputJSONString: actionInputJSONString
            }, "POST");
        }
    }
};

});

parcelRequire.register("lc6Vd", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $f6e0167945c7285f$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $f6e0167945c7285f$var$_hoisted_1 = [
    "data-test"
];
const $f6e0167945c7285f$var$_hoisted_2 = {
    class: "form-input-group form-input-nip"
};
const $f6e0167945c7285f$var$_hoisted_3 = [
    "id",
    "data-test",
    "disabled"
];
const $f6e0167945c7285f$var$_hoisted_4 = [
    "for"
];
const $f6e0167945c7285f$var$_hoisted_5 = [
    "innerHTML"
];
const $f6e0167945c7285f$var$_hoisted_6 = {
    class: "form-input-checkbox | mt-2"
};
const $f6e0167945c7285f$var$_hoisted_7 = {
    class: "input-control"
};
const $f6e0167945c7285f$var$_hoisted_8 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "i"
}, null, -1);
function $f6e0167945c7285f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DropdownSelect = (0, $cfZzL.resolveComponent)("DropdownSelect");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        class: "flex flex-col form-input",
        "data-test": `${$props.dataTest}__wrapper`
    }, [
        (0, $cfZzL.createElementVNode)("div", $f6e0167945c7285f$var$_hoisted_2, [
            (0, $cfZzL.createElementVNode)("div", {
                class: (0, $4bH2P.normalizeClass)($options.wrapperOutlineClass)
            }, [
                (0, $cfZzL.createVNode)(_component_DropdownSelect, {
                    modelValue: $props.modelValue.country,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$props.modelValue.country = $event),
                    Items: _ctx.countriesByCode,
                    Disabled: $props.forceDisabled || $data.isDisabled,
                    "data-test": `${$props.dataTest}__dropdown`,
                    onChange: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("dirty"))
                }, null, 8, [
                    "modelValue",
                    "Items",
                    "Disabled",
                    "data-test"
                ]),
                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                    id: `${$props.name}__input`,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$props.modelValue.value = $event),
                    type: "text",
                    placeholder: "0000000000",
                    "data-test": `${$props.dataTest}__input`,
                    disabled: $props.forceDisabled || $data.isDisabled,
                    onKeydown: _cache[3] || (_cache[3] = (...args)=>$options.onKeyDown && $options.onKeyDown(...args)),
                    onKeyup: _cache[4] || (_cache[4] = (...args)=>$options.onKeyUp && $options.onKeyUp(...args)),
                    onChange: _cache[5] || (_cache[5] = (...args)=>$options.onInput && $options.onInput(...args))
                }, null, 40, $f6e0167945c7285f$var$_hoisted_3), [
                    [
                        (0, $brqXq.vModelText),
                        $props.modelValue.value
                    ]
                ])
            ], 2)
        ]),
        (0, $cfZzL.createElementVNode)("label", {
            for: `${$props.name}__input`,
            class: "form-input-label",
            innerHTML: "Numer NIP"
        }, null, 8, $f6e0167945c7285f$var$_hoisted_4),
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "form-input-validation | text-xs mt-2",
                $props.forceDisabled || $data.isDisabled ? "text-neutral-700" : "text-danger"
            ]),
            innerHTML: $props.forceDisabled || $data.isDisabled ? $data.validationMessages["NIP_DISABLED"] : $data.validationMessage
        }, null, 10, $f6e0167945c7285f$var$_hoisted_5),
        !$props.doNotBlock ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 0,
            class: (0, $4bH2P.normalizeClass)({
                "grayscale pointer-events-none": !$props.modelValue.isIndividual && ($props.forceDisabled || $data.isDisabled)
            })
        }, [
            (0, $cfZzL.createElementVNode)("label", $f6e0167945c7285f$var$_hoisted_6, [
                (0, $cfZzL.createElementVNode)("div", $f6e0167945c7285f$var$_hoisted_7, [
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$props.modelValue.isIndividual = $event),
                        type: "checkbox",
                        onChange: _cache[7] || (_cache[7] = (...args)=>$options.onInput && $options.onInput(...args))
                    }, null, 544), [
                        [
                            (0, $brqXq.vModelCheckbox),
                            $props.modelValue.isIndividual
                        ]
                    ]),
                    (0, $cfZzL.createTextVNode)(),
                    $f6e0167945c7285f$var$_hoisted_8
                ]),
                (0, $cfZzL.createTextVNode)(" Jestem osobą prywatną ")
            ])
        ], 2)) : (0, $cfZzL.createCommentVNode)("", true)
    ], 8, $f6e0167945c7285f$var$_hoisted_1);
}

});

parcelRequire.register("cQd8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $959488b6c23314b5$export$2e2bcd8739ae039; });
let $959488b6c23314b5$var$NOOP = ()=>{};
var $959488b6c23314b5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("eVk47", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $add5f41fad91cd95$export$2e2bcd8739ae039; });
let $add5f41fad91cd95$var$script;




let $add5f41fad91cd95$var$initialize = ()=>{
    $add5f41fad91cd95$var$script = (parcelRequire("guwCg"));
    if ($add5f41fad91cd95$var$script.__esModule) $add5f41fad91cd95$var$script = $add5f41fad91cd95$var$script.default;
    $add5f41fad91cd95$var$script.render = (parcelRequire("1t64i")).render;
    $add5f41fad91cd95$var$script.__cssModules = {};
    (parcelRequire("kg3IJ")).default($add5f41fad91cd95$var$script);
    $add5f41fad91cd95$var$script.__scopeId = "data-v-a505fc";
    $add5f41fad91cd95$var$script.__file = "FormGroup.vue";
};
$add5f41fad91cd95$var$initialize();
var $add5f41fad91cd95$export$2e2bcd8739ae039 = $add5f41fad91cd95$var$script;

});
parcelRequire.register("guwCg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1417577346f6d8e9$export$2e2bcd8739ae039; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");

var $jgrCW = parcelRequire("jgrCW");

var $20lOb = parcelRequire("20lOb");

var $3tcGM = parcelRequire("3tcGM");

var $kdEbn = parcelRequire("kdEbn");

var $cRiX7 = parcelRequire("cRiX7");

var $48DiK = parcelRequire("48DiK");
var // @vuese
// Główny komponent odpowiedzialny za wyświetlanie formularzy, które użytkownik może edytować.
// @group Base Components | Forms
$1417577346f6d8e9$export$2e2bcd8739ae039 = (0, $cfZzL.defineComponent)({
    name: "FormGroup",
    components: {
        LocationInput: $3tcGM.default,
        NipInput: $kdEbn.default,
        PhotoGallery: $cRiX7.default
    },
    props: {
        Readonly: {
            type: Boolean,
            default: false
        },
        Form: {
            type: Array,
            required: true
        },
        PreventAutocomplete: {
            type: Array,
            Boolean: false
        },
        noPadding: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "HandleClickEvent",
        "dirty",
        "gallery-changed",
        "updated"
    ],
    data () {
        return {
            OriginalForm: "",
            Dirty: false
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $20lOb.useLocationStore), [
            "countries",
            "countriesByCode"
        ])
    },
    mounted () {
        if (!this.Readonly) this.OriginalForm = JSON.stringify(this.Form);
    },
    created () {},
    methods: {
        OnKeyDown (field, e) {
            if (e.ctrlKey) return;
            // Ignore E key for numeric fields
            if (field.Type === "Input" && field.Validation && field.Validation.indexOf("Number") > -1) {
                if (e.keyCode === 69) e.preventDefault();
            }
            // Special case for NIP input
            if (field.Type !== "NipInput") return;
            // Enable keyboard schortcuts for copy/paste
            const key = (e.key || "").toLowerCase();
            if (e.ctrlKey && [
                "c",
                "v",
                "x"
            ].includes(key)) return;
            // Ignore non-numeric characters for NIP fields
            if (e.keyCode >= 40 && e.keyCode <= 126 && e.key !== "-" && !(e.keyCode >= 48 && e.keyCode <= 57) || e.shiftKey) e.preventDefault();
        },
        CopyLink (url) {
            (0, $48DiK.copyToClipboard)(url);
        },
        HandleClickEvent () {
            this.$emit("HandleClickEvent");
        },
        GalleryChanged (item, eventType, field) {
            window.setTimeout(()=>{
                this.Dirty = true;
                this.$emit("dirty");
            }, 1000);
            if (eventType !== "input") {
                if (!field.UseCrop) this.$emit("gallery-changed", {
                    Item: item,
                    Type: eventType,
                    Field: field
                });
            } else field.Value = item;
        },
        GetFieldByName (name) {
            return this.Form.find((f)=>f.Name === name);
        },
        GetFieldInputType (f) {
            if (f.Currency) return "number";
            if (f.Validation) {
                if (f.Validation.indexOf("Phone") > -1) return "tel";
                if (f.Validation.indexOf("Email") > -1) return "email";
                if (f.Validation.indexOf("Number") > -1) return "number";
                if (f.Validation.indexOf("Currency") > -1) return "number";
                if (f.Validation.indexOf("Password") > -1) return "password";
                if (f.Validation.indexOf("PasswordIgnore") > -1) return "password";
            }
            if (f.Currency) return "number";
            return "text";
        },
        AsObject (process = {}) {
            const o = {};
            this.Form.forEach((f)=>{
                if (f.Name) {
                    if (f.Name.indexOf("x-") === 0) {
                        if (f.Name in process) process[f.Name](o, f);
                    } else if (f.Name.indexOf("|") > -1) {
                        const [fieldGroup, fieldName] = f.Name.split("|");
                        if (!(fieldGroup in o)) o[fieldGroup] = {};
                        o[fieldGroup][fieldName] = f.Value;
                    } else if (!Array.isArray(f.Name)) o[f.Name] = f.Value;
                    else for(const n in f.Name)o[f.Name[n]] = f.Value[n];
                }
            });
            return o;
        },
        ValidateField (field) {
            if (!field.Validation) return true;
            for (let v of field.Validation){
                let result;
                let options = null;
                let customMessage = null;
                if (v.indexOf("|") > -1) {
                    v = v.split("|");
                    options = v[1].indexOf(",") ? v[1].split(",") : v[1];
                    customMessage = v[2] || null;
                    v = v[0];
                }
                if (field.Autocomplete && v === "Required" && field.Value[0] < 1) {
                    this.$set(field, "ValidationMessage", "Prosimy wybrać element z listy");
                    return false;
                }
                if (!(v in this.Validate)) ;
                else if (v.endsWith("Async")) // Przepisanie całej walidacji w sposób asynchroniczy byłoby odrobinę kosztowne,
                // dlatego też na chwilę obecną sprawdzamy jedynie przy zmianie pola. TODO!
                (async ()=>{
                    result = await this.Validate[v](field.Value, options, this, field);
                    if (result) field.ValidationMessage = result || "";
                })();
                else {
                    result = this.Validate[v](field.Value, options, this, field);
                    if (result && customMessage) result = customMessage;
                    if (result) {
                        field.ValidationMessage = result || "";
                        return false;
                    }
                }
                if (field.Type === "LocationInput") {
                    try {
                        result = this.$refs[field.Name][0].ValidateLocation();
                        field.ValidationMessage = result || "";
                    } catch (err) {
                        // ponieważ było readonly:C
                        return true;
                    }
                    if (result) return false;
                }
                if (field.Autocomplete) {
                    result = !field.Value[1];
                    field.ValidationMessage = result ? "Prosimy wybrać pozycję z listy" : "";
                    if (result) return false;
                }
                if (field.Type === "Boolean" && v === "Required" && !field.Value) {
                    field.ValidationMessage = customMessage || "To pole jest wymagane.";
                    return false;
                }
            }
            return true;
        },
        ValidateForm () {
            let result = true;
            let invalidated = null;
            for (const field of this.Form)if (!this.ValidateField(field)) {
                result = false;
                if (!invalidated) invalidated = field;
            }
            if (invalidated) {
                invalidated = document.querySelector(`#${invalidated.Name}-wrapper input`);
                if (invalidated) invalidated.focus();
            }
            return result;
        },
        async ValidateFormComponents () {
            let result = true;
            const formGroupInputs = this.$refs.formGroupInput || [];
            for (let input of formGroupInputs)if (input.validateField) {
                const validation = await input.validateField();
                if (!validation) result = false;
            }
            return result;
        },
        SetAsDirty (e, f) {
            if (!this.Dirty && this.OriginalForm !== JSON.stringify(this.Form)) {
                this.Dirty = true;
                this.$emit("dirty");
            }
            if (f && f.CustomHandler) f.CustomHandler(e, f);
            if (f) f.ValidationMessage = "";
        },
        setAsClean () {
            this.Dirty = false;
        },
        /** TERAZ UŻYWAJMY TEGO */ async validate () {
            const validated = this.ValidateForm();
            if (validated) {
                const validatedComponents = await this.ValidateFormComponents();
                return validatedComponents;
            }
            return validated;
        },
        /** TERAZ UŻYWAJMY TEGO */ toObject (process = {}) {
            return this.AsObject(process);
        },
        OnInput (field) {
            this.$emit("updated", field, this.Form);
            if (field.Validation && field.Validation[0] === "Phone") field.Value = (field.Value || "").replace(/[^\+\d]/g, "");
            if (field.Type === "NipInput") field.Value.value = (field.Value.value || "").replace(/\D/g, "");
            const result = this.ValidateField(field);
            this.SetAsDirty();
            // Clear validation message.
            if (result && this.Dirty) field.ValidationMessage = "";
            return result;
        },
        TogglePassword (e) {
            const field = e.target.closest(".form-input").querySelector("input");
            const isPassword = field.type === "password";
            e.target.classList.toggle("is-visible", isPassword);
            field.type = isPassword ? "text" : "password";
        },
        OnStaticClick (field, e) {
            if (field.CustomHandler) field.CustomHandler(e, field);
        }
    }
});

});
parcelRequire.register("3tcGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $286dec4cbf242a3f$export$2e2bcd8739ae039; });
let $286dec4cbf242a3f$var$script;




let $286dec4cbf242a3f$var$initialize = ()=>{
    $286dec4cbf242a3f$var$script = (parcelRequire("f1QFG"));
    if ($286dec4cbf242a3f$var$script.__esModule) $286dec4cbf242a3f$var$script = $286dec4cbf242a3f$var$script.default;
    $286dec4cbf242a3f$var$script.render = (parcelRequire("g3rwf")).render;
    $286dec4cbf242a3f$var$script.__cssModules = {};
    (parcelRequire("gcGhm")).default($286dec4cbf242a3f$var$script);
    $286dec4cbf242a3f$var$script.__scopeId = "data-v-1114c7";
    $286dec4cbf242a3f$var$script.__file = "LocationInput.vue";
};
$286dec4cbf242a3f$var$initialize();
var $286dec4cbf242a3f$export$2e2bcd8739ae039 = $286dec4cbf242a3f$var$script;

});
parcelRequire.register("f1QFG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $76ec29a6132ad55c$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $20lOb = parcelRequire("20lOb");

var $inrct = parcelRequire("inrct");
var /**
 * Komponent odpowiedzialny za kontrolkę wyboru lokalizacji.
 */ $76ec29a6132ad55c$export$2e2bcd8739ae039 = {
    name: "LocationInput",
    props: {
        modelValue: {
            type: Object,
            default: {}
        },
        OnlyZip: {
            type: Boolean,
            default: false
        },
        /**
		 * Pokazuj kod pocztowy, a także pozwól na wyszukanie lokalizacji
		 * poprzez wpisanie kodu.
		 */ ShowZip: {
            type: Boolean,
            default: true
        },
        ShowRegion: {
            type: Boolean,
            default: true
        },
        ShowDistrict: {
            type: Boolean,
            default: true
        },
        ShowGeolocate: {
            type: Boolean,
            default: false
        },
        LocationZip: {
            type: String,
            default: ""
        },
        // czy chcemy podać tylko miasto czy część z województwem itp
        OnlyCity: {
            type: Boolean,
            default: false
        },
        DataTest: {
            type: String,
            default: ""
        }
    },
    emits: [
        "change",
        "update:modelValue"
    ],
    data () {
        return {
            Location: {},
            Validation: {
                Input: [
                    false,
                    "Prosimy wpisać miejscowość"
                ],
                Region: [
                    false,
                    "Prosimy wybrać wojew\xf3dztwo"
                ],
                District: [
                    false,
                    "Prosimy wybrać powiat"
                ],
                Zip: [
                    false,
                    "Prosimy wpisać kod pocztowy"
                ]
            },
            DistrictList: {},
            ShowLoader: false,
            WasEdited: false
        };
    },
    computed: {
        ...(0, $jgrCW.mapStores)((0, $20lOb.useLocationStore)),
        SearchUrl () {
            if (!this.IsAutocomplete) return "";
            if (this.Location.Country && this.Location.Country[0] === "locationPl" && this.DisplayZip) return "Location";
            return `/common/dictionary/zip/${this.DisplayZip ? "search-by-zip" : "search"}.ofer?query={{q}}&cc=${this.Location.Country[0] === "locationPl" ? "PL" : "DE"}`;
        },
        IsAutocomplete () {
            return this.Location.Country && (this.Location.Country[0] === "locationPl" || this.Location.Country[0] === "locationDe");
        },
        Validate () {
            return "x";
        },
        DisplayZip () {
            return this.Location.DisplayZip && this.IsAutocomplete;
        },
        ReverseCity () {
            return this.Location.City.slice().reverse();
        },
        /**
		 * Czy pokazać pole do wpisywania kodu pocztowego?
		 * Dzieje się to tylko kiedy pokazujemy kod, wybrana została
		 * Polska, a lokalizacja nie jest nierozpoznana.
		 */ DisplayZipInput () {
            const loc = this.Location;
            return this.DisplayZip && loc.Country[0] === "locationPl"; //  || loc.Country[0] === 'locationDe' && !(loc.City[1] && !loc.IsRecognized)
        }
    },
    watch: {
        modelValue (n, o) {
            this.Location = JSON.parse(JSON.stringify(n));
        }
    },
    created () {
        if (this.LocationZip) this.FetchLocationFromZip(this.LocationZip);
        this.Location = JSON.parse(JSON.stringify(this.modelValue));
        if (!this.Location.Country[0]) this.Location.Country = [
            "locationPl",
            "Polska"
        ];
        if (!this.Location.City[0]) {
            if (Array.isArray(this.Location.District[0])) {
                this.Location.District[0] = "";
                this.Location.IsRecognized = false;
            }
            if (Array.isArray(this.Location.Region[0])) {
                this.Location.Region[0] = "";
                this.Location.IsRecognized = false;
            }
        }
    },
    methods: {
        async Geolocate (mode) {
            this.ShowLoader = true;
            const geo = await (0, $inrct.default).Geolocate(mode);
            if (geo) await fetch(`/common/dictionary/zip/search.ofer?query=${geo.zip}&cc=PL`).then((res)=>res.json()).then((res)=>{
                this.OnSelect(res[0]);
                this.ShowLoader = false;
            });
            else this.ShowLoader = false;
        },
        async FetchLocationFromZip (zip) {
            if (zip && !this.modelValue.City[0]) try {
                this.ShowLoader = true;
                let response = await fetch(`/common/dictionary/zip/search.ofer?query=${zip}&cc=PL`);
                response = await response.json();
                this.OnSelect(response[0]);
            } catch (err) {
                console.error(err);
            } finally{
                this.ShowLoader = false;
            }
        },
        OnProcess (rsvp, widget) {
            if (!this.IsAutocomplete) {
                widget.WritableSuggestions = [];
                return;
            }
            this.ClearLocation(false);
            if (rsvp.length) {
                rsvp.forEach((l)=>{
                    l.Label = "";
                    if (this.DisplayZip) l.Label += `<span class="location-zip text-neutral-700 mr-1 font-bold">${l.zip}</span>`;
                    l.Label += `<span class="location-city">${l.city}</span>`;
                    l.Value = l.city;
                    if (l.location) l.Label += `<span class="location-region | text-neutral-700 text-xs ml-1">${l.location}</span>`;
                    l.Input = l.city;
                });
                widget.InputSuggestions = rsvp;
            } else {
                // wyczyść kod pocztowy jeśli miejsowość nie istnieje
                this.modelValue.City[0] = "";
                widget.InputSuggestions = [];
            }
        },
        /**
		 * Blokuje wprowadzenie znaków nie będących cyfrą bądź myślnikiem.
		 * @param e Obiekt zdarzenia
		 * @param insertDash Czy wstawić separator po drugiej cyfrze?
		 */ OnZipCode (e, insertDash = false) {
            const isNumber = e.key === String(Number.parseInt(e.key)) || e.key === "-";
            if (e.keyCode >= 40 && e.keyCode <= 126 && !isNumber) e.preventDefault();
            const target = e.target;
            if (insertDash && target && target.value.length === 2 && Number.isInteger(e.key)) target.value += "-";
        },
        OnSelect (l) {
            const ll = this.Location;
            ll.City = [
                l.zip || ll.City[0],
                l.city
            ];
            ll.Region = [
                l.idLocation,
                ""
            ];
            ll.District = [
                l.idDistrict,
                ""
            ];
            ll.Coords = [
                l.latitude,
                l.longitude
            ];
            ll.Zip = l.zip;
            ll.IsRecognized = true;
            ll.Id = l.id;
            this.CurrentState.LocationZip = ll.Zip;
            this.OnInputChange();
            this.$emit("change", this.Location);
        },
        OnBlur (e, source) {
            if (e && source) {
                // Ustalamy, czy input został zmodyfikowany, aby w razie czego go walidować.
                this.WasEdited = true;
                if (source === "city") this.Location.City = [
                    e[0] || this.Location.City[0],
                    e[1]
                ];
                if (source === "zip") this.Location.City = [
                    e[1],
                    e[0]
                ];
            }
            window.setTimeout(()=>{
                this.OnInputChange();
                this.Location.IsRecognized = Boolean(!(!this.Location.Region[0] || !this.Location.District[0]) && Boolean(this.Location.City[0]) && Boolean(this.Location.City[1]));
                if (source === "zip" && (!e[0] && e[1] || !e)) this.Location.IsRecognized = false;
            }, 100);
        },
        OnCountryChange (e) {
            this.ClearLocation(true);
            const c = this.locationStore.countries.find((country)=>country.Value === e);
            this.Location.Country = [
                e,
                c ? c.Label : ""
            ];
            this.Location.City = [
                "",
                ""
            ];
            this.OnInputChange();
        },
        OnInputChange () {
            if (this.Location.Country[0] !== "locationPl") this.Location.District = this.Location.Region = [
                "",
                ""
            ]; // FocusEvent, IsTrusted bug!
            this.$emit("update:modelValue", this.Location);
        },
        ClearLocation (all) {
            this.ClearValidation();
            if (this.$refs.autocomplete) this.$refs.autocomplete.InputSuggestions = [];
            if (this.$refs.autocompleteZip) this.$refs.autocompleteZip.InputSuggestions = [];
            if (all) {
                this.Location.Country = [
                    "locationPl",
                    "Polska"
                ];
                this.Location.City = [
                    "",
                    ""
                ];
            }
            this.Location.Region = [
                "",
                ""
            ];
            this.Location.District = [
                "",
                ""
            ];
            this.Location.Coords = [
                "",
                ""
            ];
            this.Location.IsRecognized = true;
            this.Location.Id = -1;
        },
        ClearValidation () {
            for(const vv in this.Validation)this.Validation[vv] = [
                false,
                this.Validation[vv][1]
            ];
        },
        ValidateLocation (district) {
            this.ClearValidation();
            this.OnBlur();
            if (district) this.Location.District = [
                district,
                ""
            ];
            if (!this.Location.City[1]) {
                const validationMessage = this.Validation.Input[1];
                this.Validation.Input = [
                    true,
                    validationMessage
                ];
                return validationMessage;
            }
            const checkNull = (x)=>JSON.stringify(x).includes("null");
            const isZipMissing = ()=>!this.Location.City[0] || checkNull(this.Location.City[0]);
            const isFieldMissing = (field)=>!this.Location[field][0] || checkNull(this.Location[field][0]);
            if ((!this.Location.Country[0] || this.Location.Country[0] === "locationPl") && !this.OnlyZip) {
                if (isZipMissing() || this.DisplayZipInput && this.WasEdited) {
                    if (this.OnlyCity) return "Podany kod nie pasuje do żadnej miejscowości";
                    const fields = [
                        "Region",
                        "District"
                    ];
                    for (const field of fields)if (isFieldMissing(field)) {
                        const validationMessage = this.Validation[field][1];
                        this.Validation[field] = [
                            true,
                            validationMessage
                        ];
                        return validationMessage;
                    }
                    if (this.ShowZip && isZipMissing()) {
                        const validationMessage = this.Validation.Zip[1];
                        this.Validation.Zip = [
                            true,
                            validationMessage
                        ];
                        return validationMessage;
                    }
                // przypadek gdy miasto nie znajduje się w bazie (nie ma wspolrzednych geograficznych)
                } else if (this.OnlyCity && !isFieldMissing("City") && this.Location.Coords[0] === "") return "Podana nazwa miasta nie istnieje.";
            } else if (isFieldMissing("City")) {
                const validationMessage = this.Validation.Zip[1];
                this.Validation.Zip = [
                    true,
                    validationMessage
                ];
                return validationMessage;
            } else if (this.Location.City[0].length > 10) return "Podany kod pocztowy jest za długi";
            this.OnInputChange();
            return "";
        },
        async OnRegionChange (region) {
            const ll = this.Location;
            this.ClearValidation();
            this.DistrictList = [];
            ll.Region = [
                region,
                ""
            ];
            ll.District = [
                "",
                ""
            ];
            this.DistrictList = await this.locationStore.getDistrict(ll.Region[0]);
            this.OnInputChange();
            window.setTimeout(()=>{
                this.Location.IsRecognized = false;
            }, 100);
        },
        OnDistrictChange () {
            this.ValidateLocation();
            window.setTimeout(()=>{
                this.Location.IsRecognized = false;
            }, 100);
        }
    }
};

});
parcelRequire.register("inrct", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a601bc6171234313$export$2e2bcd8739ae039; });
class $a601bc6171234313$export$2e2bcd8739ae039 {
    static async PermissionGranted() {
        return (await navigator.permissions.query({
            name: "geolocation"
        })).state === "granted";
    }
    static async Geolocate(mode = "ask") {
        return new Promise(async (resolve)=>{
            if (mode === "auto" && !await this.PermissionGranted()) {
                resolve();
                return;
            }
            navigator.geolocation.getCurrentPosition((coords)=>{
                const { latitude: latitude, longitude: longitude } = coords.coords;
                fetch(`/lists/json/find-zip-by-lat-lng.ofer?lat=${latitude}&lng=${longitude}`).then((rsvp)=>rsvp.json()).then((rsvp)=>{
                    resolve(JSON.parse(rsvp));
                });
            }, ()=>{
                alert("Prosimy o odblokowanie udostępniania lokalizacji w przeglądarce"); // eslint-disable-line no-alert
                resolve();
            });
        });
    }
}

});


parcelRequire.register("g3rwf", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $bb0245e419f34038$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $bb0245e419f34038$var$_hoisted_1 = {
    "data-component": "LocationInput.vue",
    class: "form-input-group form-input-location"
};
const $bb0245e419f34038$var$_hoisted_2 = {
    class: "relative | !shadow-none"
};
const $bb0245e419f34038$var$_hoisted_3 = {
    class: "absolute w-full"
};
const $bb0245e419f34038$var$_hoisted_4 = [
    "data-test"
];
const $bb0245e419f34038$var$_hoisted_5 = {
    key: 0,
    class: "location-input-details mt-5"
};
const $bb0245e419f34038$var$_hoisted_6 = {
    key: 0,
    class: "[ form-input-validation ] text-danger text-xs -mt-3"
};
const $bb0245e419f34038$var$_hoisted_7 = [
    "data-invalid"
];
const $bb0245e419f34038$var$_hoisted_8 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    class: "flex items-center form-input-label"
}, "Wojew\xf3dztwo", -1);
const $bb0245e419f34038$var$_hoisted_9 = [
    "innerHTML"
];
const $bb0245e419f34038$var$_hoisted_10 = [
    "data-invalid"
];
const $bb0245e419f34038$var$_hoisted_11 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    class: "flex items-center form-input-label"
}, "Powiat", -1);
const $bb0245e419f34038$var$_hoisted_12 = [
    "innerHTML"
];
const $bb0245e419f34038$var$_hoisted_13 = [
    "data-invalid"
];
const $bb0245e419f34038$var$_hoisted_14 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    class: "flex items-center form-input-label"
}, "Kod pocztowy", -1);
const $bb0245e419f34038$var$_hoisted_15 = [
    "innerHTML"
];
const $bb0245e419f34038$var$_hoisted_16 = [
    "data-invalid"
];
const $bb0245e419f34038$var$_hoisted_17 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    class: "flex items-center form-input-label"
}, "Kod pocztowy", -1);
const $bb0245e419f34038$var$_hoisted_18 = [
    "innerHTML"
];
function $bb0245e419f34038$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loader = (0, $cfZzL.resolveComponent)("Loader");
    const _component_Autocomplete = (0, $cfZzL.resolveComponent)("Autocomplete");
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_DropdownSelect = (0, $cfZzL.resolveComponent)("DropdownSelect");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $bb0245e419f34038$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("div", $bb0245e419f34038$var$_hoisted_2, [
            (0, $cfZzL.createElementVNode)("div", $bb0245e419f34038$var$_hoisted_3, [
                $props.ShowGeolocate && $data.ShowLoader ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_Loader, {
                    key: 0
                })) : (0, $cfZzL.createCommentVNode)("", true)
            ]),
            $options.DisplayZipInput ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_Autocomplete, {
                key: 0,
                ref: "autocompleteZip",
                class: "form-location-autocomplete-zip | !static mr-3 basis-32 [&>input]:px-0 [&>input]:text-center",
                modelValue: $options.ReverseCity,
                Autocomplete: $options.SearchUrl,
                Placeholder: "00-000",
                DataTest: `${$props.DataTest}__zip`,
                onProcess: $options.OnProcess,
                onSelect: $options.OnSelect,
                onBlur: _cache[0] || (_cache[0] = ($event)=>$options.OnBlur($event, "zip")),
                onKeydown: _cache[1] || (_cache[1] = ($event)=>$options.OnZipCode($event, true))
            }, null, 8, [
                "modelValue",
                "Autocomplete",
                "DataTest",
                "onProcess",
                "onSelect"
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            (0, $cfZzL.createVNode)(_component_Autocomplete, {
                ref: "autocomplete",
                class: "form-location-autocomplete-location | !static",
                modelValue: $data.Location.City,
                Autocomplete: $options.SearchUrl,
                Placeholder: $options.DisplayZipInput ? "Miejscowość" : "Miejscowość lub kod pocztowy",
                DataTest: `${$props.DataTest}__select`,
                onProcess: $options.OnProcess,
                onSelect: $options.OnSelect,
                onBlur: _cache[2] || (_cache[2] = ($event)=>$options.OnBlur($event, "city"))
            }, null, 8, [
                "modelValue",
                "Autocomplete",
                "Placeholder",
                "DataTest",
                "onProcess",
                "onSelect"
            ]),
            (0, $cfZzL.createElementVNode)("div", {
                class: "!absolute right-1 flex mr-3",
                "data-test": `${$props.DataTest}__arrow`
            }, [
                $props.ShowGeolocate ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                    key: 0,
                    class: "geolocate-icon | text-neutral-700 hover:text-accent mr-3",
                    title: "Pobierz moją lokalizację",
                    onClick: _cache[3] || (_cache[3] = ($event)=>$options.Geolocate("ask"))
                }, [
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "crosshair",
                        size: "1.5"
                    })
                ])) : (0, $cfZzL.createCommentVNode)("", true),
                (0, $cfZzL.createVNode)(_component_DropdownSelect, {
                    modelValue: $data.Location.Country[0],
                    Items: _ctx.locationStore.countries,
                    onChange: $options.OnCountryChange
                }, null, 8, [
                    "modelValue",
                    "Items",
                    "onChange"
                ])
            ], 8, $bb0245e419f34038$var$_hoisted_4)
        ]),
        ($data.Location.City[1] || $data.Location.City[0] && !$data.Location.City[1]) && !$data.Location.IsRecognized || !$options.IsAutocomplete ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $bb0245e419f34038$var$_hoisted_5, [
            (0, $cfZzL.createElementVNode)("div", {
                class: (0, $4bH2P.normalizeClass)([
                    "form-group is-editable",
                    {
                        "is-multicolumn": _ctx.ScreenSize > 0
                    }
                ])
            }, [
                $options.IsAutocomplete && !$data.Location.IsRecognized && !$data.Location.District[0] && $data.Location.Country[0] === "locationPl" && !$props.OnlyCity ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $bb0245e419f34038$var$_hoisted_6, " Nie znaleźliśmy takiej miejscowości. Popraw wpisaną nazwę lub podaj dokładne dane miejscowości: wojew\xf3dztwo i powiat. ")) : (0, $cfZzL.createCommentVNode)("", true),
                $data.Location.Country[0] === "locationPl" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                    key: 1
                }, [
                    $props.ShowRegion ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: 0,
                        class: "form-input mt-2 col-half",
                        "data-invalid": Boolean($data.Validation.Region[0])
                    }, [
                        $bb0245e419f34038$var$_hoisted_8,
                        (0, $cfZzL.createVNode)(_component_DropdownSelect, {
                            modelValue: $data.Location.Region[0],
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.Location.Region[0] = $event),
                            Items: _ctx.locationStore.poland,
                            placeholder: "Wybierz wojew\xf3dztwo",
                            class: "input",
                            onChange: $options.OnRegionChange
                        }, null, 8, [
                            "modelValue",
                            "Items",
                            "onChange"
                        ]),
                        $data.Validation.Region[0] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 0,
                            class: "[ form-input-validation ] text-danger text-2xs mt-2",
                            innerHTML: $data.Validation.Region[1]
                        }, null, 8, $bb0245e419f34038$var$_hoisted_9)) : (0, $cfZzL.createCommentVNode)("", true)
                    ], 8, $bb0245e419f34038$var$_hoisted_7)) : (0, $cfZzL.createCommentVNode)("", true),
                    $data.Location.Region[0] && $props.ShowDistrict ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: 1,
                        class: "form-input mt-2 col-half",
                        "data-invalid": Boolean($data.Validation.District[0])
                    }, [
                        $bb0245e419f34038$var$_hoisted_11,
                        (0, $cfZzL.createVNode)(_component_DropdownSelect, {
                            modelValue: $data.Location.District[0],
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.Location.District[0] = $event),
                            Items: $data.DistrictList,
                            placeholder: "Wybierz powiat",
                            class: "input",
                            onChange: $options.OnDistrictChange
                        }, null, 8, [
                            "modelValue",
                            "Items",
                            "onChange"
                        ]),
                        $data.Validation.District[0] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 0,
                            class: "[ form-input-validation ] text-danger text-2xs mt-2",
                            innerHTML: $data.Validation.District[1]
                        }, null, 8, $bb0245e419f34038$var$_hoisted_12)) : (0, $cfZzL.createCommentVNode)("", true)
                    ], 8, $bb0245e419f34038$var$_hoisted_10)) : (0, $cfZzL.createCommentVNode)("", true),
                    $data.Location.District[0] && $data.Location.Region[0] && $props.ShowZip && !$options.DisplayZipInput || $data.Location.IsTransport ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: 2,
                        class: "form-input mt-2 col-half",
                        "data-invalid": Boolean($data.Validation.Zip[0])
                    }, [
                        $bb0245e419f34038$var$_hoisted_14,
                        (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.Location.City[0] = $event),
                            type: "text",
                            maxlength: "12",
                            onKeydown: _cache[7] || (_cache[7] = ($event)=>$options.OnZipCode($event, true)),
                            onKeyup: _cache[8] || (_cache[8] = ($event)=>$data.Validation.Zip[0] = false)
                        }, null, 544), [
                            [
                                (0, $brqXq.vModelText),
                                $data.Location.City[0]
                            ]
                        ]),
                        $data.Validation.Zip[0] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 0,
                            class: "[ form-input-validation ] text-danger text-2xs mt-2",
                            innerHTML: $data.Validation.Zip[1]
                        }, null, 8, $bb0245e419f34038$var$_hoisted_15)) : (0, $cfZzL.createCommentVNode)("", true)
                    ], 8, $bb0245e419f34038$var$_hoisted_13)) : (0, $cfZzL.createCommentVNode)("", true)
                ], 64)) : (0, $cfZzL.createCommentVNode)("", true),
                $data.Location.Country[0] !== "locationPl" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                    key: 2,
                    class: "form-input mt-2 col-half",
                    "data-invalid": Boolean($data.Validation.Zip[0])
                }, [
                    $bb0245e419f34038$var$_hoisted_17,
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$data.Location.City[0] = $event),
                        type: "text",
                        onBlur: _cache[10] || (_cache[10] = (...args)=>$options.ValidateLocation && $options.ValidateLocation(...args))
                    }, null, 544), [
                        [
                            (0, $brqXq.vModelText),
                            $data.Location.City[0]
                        ]
                    ]),
                    $data.Validation.Zip[0] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: 0,
                        class: "[ form-input-validation ] text-danger text-2xs mt-2",
                        innerHTML: $data.Validation.Zip[1]
                    }, null, 8, $bb0245e419f34038$var$_hoisted_18)) : (0, $cfZzL.createCommentVNode)("", true)
                ], 8, $bb0245e419f34038$var$_hoisted_16)) : (0, $cfZzL.createCommentVNode)("", true)
            ], 2)
        ])) : (0, $cfZzL.createCommentVNode)("", true)
    ]);
}

});

parcelRequire.register("gcGhm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcbe9014ab0fcd62$export$2e2bcd8739ae039; });
let $bcbe9014ab0fcd62$var$NOOP = ()=>{};
var $bcbe9014ab0fcd62$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("cRiX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c922dd981ac841$export$2e2bcd8739ae039; });
let $95c922dd981ac841$var$script;




let $95c922dd981ac841$var$initialize = ()=>{
    $95c922dd981ac841$var$script = (parcelRequire("kwcjP"));
    if ($95c922dd981ac841$var$script.__esModule) $95c922dd981ac841$var$script = $95c922dd981ac841$var$script.default;
    $95c922dd981ac841$var$script.render = (parcelRequire("45yDD")).render;
    $95c922dd981ac841$var$script.__cssModules = {};
    (parcelRequire("25yNQ")).default($95c922dd981ac841$var$script);
    $95c922dd981ac841$var$script.__scopeId = "data-v-dadf82";
    $95c922dd981ac841$var$script.__file = "PhotoGallery.vue";
};
$95c922dd981ac841$var$initialize();
var $95c922dd981ac841$export$2e2bcd8739ae039 = $95c922dd981ac841$var$script;

});
parcelRequire.register("kwcjP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5305effba334daf2$export$2e2bcd8739ae039; });

var $4kI7C = parcelRequire("4kI7C");

var $8VbsH = parcelRequire("8VbsH");

var $eYjM4 = parcelRequire("eYjM4");
var // @vuese
// Komponent odpowiedzialny za wyświetlanie, zmianę kolejności i dodawanie grupy zdjęć.
// @group Base Components | Photos
$5305effba334daf2$export$2e2bcd8739ae039 = {
    name: "PhotoGallery",
    components: {
        PhotoEditor: $8VbsH.default,
        PromptDialog: $eYjM4.default
    },
    props: {
        modelValue: {
            type: Array,
            default () {
                return [];
            }
        },
        Readonly: {
            type: Boolean,
            default: false
        },
        Single: {
            type: Boolean,
            default: false
        },
        AllowFiles: {
            type: Boolean,
            default: false
        },
        AllowDescription: {
            type: Boolean,
            default: false
        },
        HideAddButton: {
            type: Boolean,
            default: false
        },
        UploadFieldName: {
            type: String,
            default: "upload-image"
        },
        Upload: {
            type: Object,
            default () {
                return {
                    FieldPrefix: ""
                };
            }
        },
        MaxColumns: {
            type: Number,
            default: 4
        },
        UseCropWindow: {
            type: Boolean,
            default: false
        },
        PreventSaveOnExit: {
            type: Boolean,
            default: false
        },
        AvatarMode: {
            type: Boolean,
            default: false
        },
        Draggable: {
            type: Boolean,
            default: false
        },
        Loaded: {
            type: Boolean,
            default: false
        },
        AddOneFile: {
            type: Boolean,
            default: false
        },
        AttachPerLine: {
            type: Number,
            default: 0
        },
        AttachText: {
            type: String,
            default: "Dodaj załącznik"
        },
        ForcePerLine: {
            type: Number
        },
        MaxFiles: {
            type: Number
        },
        ChatValidation: {
            type: Boolean,
            default: false
        },
        fileSizeValidation: {
            type: Number,
            default: 25
        },
        attachmentValidation: {
            type: Boolean,
            default: false
        },
        HideSinglePreview: {
            type: Boolean,
            default: false
        },
        /**
		 * Nie usuwa usuniętych elementów z tablicy, lecz zamiast tego ustawia właściwość
		 * `markForDeletion` poszczególnego zdjęcia na `true`.
		 */ markForDeletion: {
            type: Boolean,
            default: false
        },
        DataTest: {
            type: String,
            default: undefined
        },
        DragAndDroppable: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "image-saved",
        "upload",
        "validationFail",
        "onItemClick",
        "click",
        "removeItem",
        "update:modelValue",
        "addPhotosButtonClicked"
    ],
    data () {
        return {
            Photos: [],
            Dragging: false,
            DraggingIndex: false,
            DraggingImage: "",
            DraggingElementSize: 0,
            StartPoint: [
                0,
                0
            ],
            CurrentPoint: [
                0,
                0
            ],
            LocalValidationMessage: "",
            SelectedPhoto: null,
            SelectedPhotoList: [],
            SelectedPhotoIndex: 0,
            Processing: -1,
            ProcessingCancel: false,
            IsAdding: false,
            DisableUpdateModel: false,
            DragCounter: 0,
            HasErrors: false
        };
    },
    computed: {
        PerLine () {
            const r = this.ScreenSize > 0 ? 4 : 3;
            return this.AttachPerLine || this.ForcePerLine || Math.min(r, this.MaxColumns);
        },
        DraggingElement () {
            return this.$refs.GalleryContainer.children[this.DraggingIndex - 1];
        },
        AcceptType () {
            return this.AllowFiles ? "*/*" : "image/*";
        },
        IsDragging () {
            return this.DragCounter > 0;
        }
    },
    watch: {
        modelValue (n) {
            this.Photos = [
                ...n
            ];
        }
    },
    created () {
        this.Photos = JSON.parse(JSON.stringify(this.modelValue));
    },
    methods: {
        uploadSingleClicked () {
            this.$refs.ImageUploadField.click();
        },
        CloseModal () {
            if (this.UseCropWindow && !this.PreventSaveOnExit) this.State.Append({
                CropPhotoConfirmModal: true
            });
            else this.State.Append({
                CropPhotoModal: false
            }, true);
        },
        CloseModalConfirm (eventSource) {
            if (eventSource !== "button") return;
            window.setTimeout(()=>{
                this.ProcessingCancel = true;
                this.OnGallerySaved();
            }, 500);
        },
        DescriptionValidate () {
            let i = 0;
            for (const photo of this.SelectedPhotoList){
                const description = String(photo.Description || "");
                const descCount = description.length;
                if (description && (description.indexOf(">") >= 0 || description.indexOf("<") >= 0)) {
                    photo.ValidationMessage = "Wprowadzony opis zawiera niedozwolone znaki.";
                    return true;
                }
                if (descCount > 256) {
                    photo.ValidationMessage = `Wprowadzony tekst jest za długi o ${this.Format.PluralForm(descCount - 256, [
                        "znak",
                        "znaki",
                        "znak\xf3w"
                    ], true)}`;
                    this.SelectedPhotoIndex = i;
                    return true;
                }
                photo.ValidationMessage = "";
                i++;
            }
            return false;
        },
        RemovePhotoFromList (i) {
            if (this.SelectedPhotoIndex >= i) this.SelectedPhotoIndex--;
            this.SelectedPhotoList.splice(i, 1);
        },
        async OnGallerySaved () {
            const galleryDialogContent = document.querySelector(".photo-gallery-gallery .modal-dialog-content");
            if (galleryDialogContent && this.DescriptionValidate() && !this.ProcessingCancel) {
                galleryDialogContent.scrollTop = 512;
                return;
            }
            let copy = [
                ...this.Photos
            ];
            for(const j in this.SelectedPhotoList){
                this.Processing++;
                if (this.ProcessingCancel) continue;
                const editor = this.$refs.PhotoEditor[j] || this.$refs.PhotoEditor;
                const p = this.SelectedPhotoList[j];
                const i = copy.findIndex((pp)=>{
                    if (pp.date) return pp.date === p.Item.date;
                    return pp.url === p.Item.url;
                });
                copy[i].description = p.Description;
                copy[i].edited = true; // TODO: Save crop settings?
                const origFile = p.Item.file;
                const cropped = editor.GetCroppedImage();
                if (cropped) {
                    const blob = editor.Edited ? {
                        blob: (0, $4kI7C.dataURLToBlob)(cropped)
                    } : await (0, $4kI7C.sanitizeImage)(origFile, 2048);
                    const formData = this.CreateFormData(blob, `crop-${origFile.name}`);
                    const rsvp = await this.SubmitFormData(formData.Form);
                    copy[i].uploadedPath = rsvp.fileUploadName || rsvp.path;
                    if (editor.Edited) {
                        copy[i].cropped = false;
                        copy[i].url = cropped;
                    }
                }
                copy[i].isProcessing = false;
            }
            copy = copy.filter((i)=>!i.isProcessing);
            this.Set(copy);
            if (!this.AvatarMode) this.State.Travel(null, {
                ...this.CurrentState,
                CropPhotoModal: false
            }, "fromHistory");
            else this.State.Travel(null, {
                ...this.CurrentState,
                CropPhotoModal: false
            }, "fromHistory");
            this.Set(copy);
            this.$emit("image-saved");
            this.Processing = -1;
            this.ProcessingCancel = false;
        },
        async OnRotatePhoto () {
            const editor = this.$refs.PhotoEditor;
            editor.RotatePhoto();
        },
        GoBack () {
            window.history.back();
        },
        ShowFileDialog () {
            this.$refs.ImageUploadField.click();
        },
        CreateFormData (u, name) {
            const d = new FormData();
            let fileName = (name || u.blob.name || "").replace(/[^a-zA-Z01-9\.]/g, "-"); // eslint-disable-line no-useless-escape
            fileName = fileName.toLowerCase();
            if (!fileName.endsWith(".jpg") && !window.location.href.includes("/ekspert-oferteo")) fileName += ".jpg";
            const fieldPrefix = this.Upload.FieldPrefix ? `${this.Upload.FieldPrefix}.` : "";
            d.append(`${fieldPrefix}file`, u.blob, fileName);
            d.append(`${fieldPrefix}originalName`, fileName);
            d.append(`${fieldPrefix}ext`, "jpg");
            d.append(`${fieldPrefix}contentType`, "image/jpeg");
            return {
                Name: fileName,
                Form: d
            };
        },
        async SubmitFormData (data) {
            return new Promise(async (ok)=>{
                if (this.Upload.Url) fetch(this.Upload.Url, {
                    method: "POST",
                    body: data,
                    mode: "cors",
                    credentials: "include"
                }).then((rsvp)=>rsvp.json()).then((rsvp)=>{
                    try {
                        rsvp = JSON.parse(rsvp);
                        ok(rsvp);
                    } catch (err) {
                        ok({
                            err: err
                        });
                    }
                });
                else {
                    this.Set(this.Photos);
                    ok({});
                }
            });
        },
        async ImageUpload (e) {
            const appendMode = this.CurrentState.CropPhotoModal;
            this.Processing = -1;
            this.LocalValidationMessage = "";
            const validation = {
                MaxFiles: false,
                Size: false,
                TotalSize: 0,
                AllowedExtensions: [
                    "jpg",
                    "jpeg",
                    "png",
                    "pdf"
                ],
                InvalidExtension: false
            };
            this.Photos.forEach((u)=>{
                validation.TotalSize += u.fileSize;
            });
            let multipleAdded;
            if (!appendMode) {
                this.SelectedPhotoList = [];
                this.SelectedPhotoIndex = 0;
                multipleAdded = false;
            } else multipleAdded = true;
            const isMultiple = e.target.files.length > 1 || appendMode;
            let loop = 0;
            this.IsAdding = true;
            // eslint-disable-next-line no-restricted-syntax
            for (const f of e.target.files){
                let skipFile = false;
                let validExtension = false;
                if (!f) continue;
                const fileSize = f.size / 1024 / 1024;
                if (this.ChatValidation || this.attachmentValidation) {
                    if (this.ChatValidation && validation.TotalSize + fileSize > this.fileSizeValidation) {
                        validation.Size = true;
                        skipFile = true;
                    } else validation.TotalSize += fileSize;
                    if (this.attachmentValidation && fileSize > this.fileSizeValidation) {
                        validation.Size = true;
                        skipFile = true;
                    }
                    for (const ext of validation.AllowedExtensions){
                        const lowerCaseName = f.name.toLowerCase();
                        if (lowerCaseName.endsWith(ext)) {
                            validExtension = true;
                            break;
                        }
                    }
                    if (!validExtension) {
                        validation.InvalidExtension = true;
                        skipFile = true;
                    }
                }
                if (this.MaxFiles && this.Photos.length > this.MaxFiles - 1) {
                    validation.MaxFiles = true;
                    skipFile = true;
                }
                if (skipFile) continue;
                const isFile = !f.type.match(/image.*/);
                if (isFile && !this.AllowFiles && !isMultiple) {
                    this.LocalValidationMessage = "Przesyłany plik nie jest zdjęciem.";
                    continue;
                }
                let u;
                if (!isFile) u = await (0, $4kI7C.sanitizeImage)(f, 0); // Czy to jest w ogóle potrzebne?
                else u = {
                    data: f.name + f.size + f.lastModified,
                    blob: f
                };
                const formData = this.CreateFormData(u);
                u = {
                    url: u.data,
                    originalName: formData.Name,
                    uploadedPath: "",
                    isFile: isFile,
                    file: f,
                    cropped: false,
                    markedForDeletion: false,
                    date: new Date().toISOString(),
                    isProcessing: true,
                    fileSize: fileSize
                };
                if (!this.Single) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const p of this.Photos)if (u.url === p.url) {
                        if (!isMultiple) {
                            if (this.ControllerComponent) this.ControllerComponent.DataSaved = "fail:gallery:duplicate";
                            this.$emit("validationFail", "duplicate");
                            this.$refs.ImageUploadField.value = "";
                        }
                        continue;
                    }
                }
                if (this.Single) this.Photos = [
                    u
                ];
                else {
                    this.Photos.splice(loop, 0, u);
                    loop += 1;
                }
                this.Set(this.Photos);
                if (!this.UseCropWindow) {
                    this.$emit("upload", u);
                    const rsvp = await this.SubmitFormData(formData.Form);
                    const item = this.Photos.find((i)=>i.url === u.url);
                    item.uploadedPath = rsvp.fileUploadName || rsvp.path;
                } else {
                    const selectedPhoto = {
                        Uploaded: true,
                        Item: u,
                        Description: u.description,
                        ValidationMessage: "",
                        IsProcessing: true
                    };
                    this.SelectedPhotoList.push(selectedPhoto);
                    multipleAdded = true;
                }
                this.Set(this.Photos);
            }
            window.setTimeout(()=>{
                this.IsAdding = false;
            }, 1000);
            if (this.ChatValidation || this.attachmentValidation) {
                const errors = [];
                this.HasErrors = false;
                if (validation.Size) {
                    const attachmentMsg = `Plik nie może być większy niż ${this.fileSizeValidation} MB`;
                    const chatMsg = `Wiadomość jest większa niż ${this.fileSizeValidation} MB i nie możemy jej wysłać. Spróbuj jeszcze raz, dodając załączniki osobno lub zmniejszając plik.`;
                    if (this.attachmentValidation) errors.push(attachmentMsg);
                    else errors.push(chatMsg);
                }
                if (validation.InvalidExtension) errors.push(`${this.attachmentValidation ? "Format pliku jest nieprawidłowy" : "Niekt\xf3re pliki są nieprawidłowe i nie zostały dodane"}. ${this.AllowFiles ? "Obsługiwane typy plik\xf3w: JPG, PNG, PDF." : "Obsługiwane typy plik\xf3w: JPG, JPEG, PNG."}`);
                if (errors.length > 0) {
                    this.$emit("validationFail", errors);
                    this.HasErrors = true;
                }
            }
            try {
                this.$refs.ImageUploadField.value = "";
            } catch (err) {
                console.warn("ImageUpladField: Clear Failed. ", err);
            }
            if (multipleAdded && !appendMode) {
                this.SelectedPhoto = this.SelectedPhotoList[0];
                this.State.Travel(null, {
                    ...this.CurrentState,
                    CropPhotoModal: true
                }, true);
            }
        },
        OnClick (i) {
            this.$emit("onItemClick", i);
            if (this.Readonly) return;
            if (!this.Dragging) {
                if (!this.UseCropWindow) this.$emit("click", this.Photos[i]);
                else {
                    this.SelectedPhoto = {
                        Uploaded: false,
                        Item: this.Photos[i],
                        Description: this.Photos[i].description
                    };
                    this.SelectedPhotoList = [
                        this.SelectedPhoto
                    ];
                    this.State.Travel(null, {
                        ...this.CurrentState,
                        CropPhotoModal: true
                    }, true);
                }
            } else this.DraggingIndex = null;
        },
        OnDragStart (i, $e) {
            if ($e.touches) $e = $e.touches[0];
            if (this.Readonly) return;
            this.DraggingElementSize = Math.floor(this.$refs.GalleryContainer.clientWidth / this.PerLine);
            this.StartPoint = this.CurrentPoint = [
                $e.clientX,
                $e.clientY
            ];
            this.DraggingIndex = i + 1;
        },
        OnDragMove ($e) {
            if (!this.DraggingIndex) return;
            if ($e.touches) $e = $e.touches[0];
            this.CurrentPoint = [
                $e.clientX,
                $e.clientY
            ];
            if (this.Format.Distance(this.StartPoint, this.CurrentPoint) > 2) {
                this.Dragging = this.DraggingIndex;
                if (!this.DraggingElement) {
                    this.OnDragEnd();
                    return;
                }
                this.DraggingElement.classList.add("is-being-dragged");
                this.DraggingImage = this.Photos[this.DraggingIndex - 1];
            }
        },
        OnDragInsideEndTouch () {
            const $target = document.elementFromPoint(this.CurrentPoint[0], this.CurrentPoint[1]);
            this.OnDragInsideEnd({
                target: $target
            });
        },
        OnDragInsideEnd ($e) {
            if (!this.DraggingIndex || !$e.target) return;
            if (this.Format.Distance(this.StartPoint, this.CurrentPoint) <= 2) {
                this.DraggingIndex = 0;
                this.OnDragEnd();
                return;
            }
            let index = this.Photos.length - 1;
            const $target = $e.target;
            if (!$target.matches(".photo-gallery-items")) {
                const $item = $target.closest(".photo-gallery-item");
                if (!$item) {
                    this.OnDragEnd();
                    return;
                }
                const $siblings = [].slice.call($item.parentElement.children);
                index = $siblings.findIndex((c)=>c == $item); // eslint-disable-line eqeqeq
                if ($target.matches(".is-dragging-put-after")) index++;
            }
            const p = this.Photos;
            const t = p[this.DraggingIndex - 1];
            p.splice(this.DraggingIndex - 1, 1);
            p.splice(index, 0, t);
            this.Set(p);
            this.OnDragEnd();
        },
        OnDragEnd () {
            const el = this.$refs.GalleryContainer.querySelector(".is-being-dragged");
            if (el) el.classList.remove("is-being-dragged");
            this.Dragging = null;
            this.DraggingIndex = null;
            this.DraggingImage = null;
        },
        Remove (i) {
            if (this.Readonly) return;
            const p = this.Photos;
            this.$emit("removeItem", p[i]);
            if (this.markForDeletion) p[i].markedForDeletion = true;
            else p.splice(i, 1);
            this.Set(p);
        },
        RemoveSingle () {
            this.Set([]);
        },
        Set (list) {
            this.Photos = list;
            if (!this.IsAdding || !this.UseCropWindow) this.$emit("update:modelValue", this.Photos);
        },
        OnDragAndDropInput ($e) {
            if (this.Readonly) return;
            const files = $e.dataTransfer.files;
            const inputEvent = new Event("input", {
                bubbles: true
            });
            Object.defineProperty(inputEvent, "target", {
                writable: false,
                value: {
                    files: files
                }
            });
            this.DragCounter = 0;
            this.ImageUpload(inputEvent);
        },
        dragEnter () {
            this.DragCounter++;
        },
        dragLeave () {
            this.DragCounter--;
        }
    }
};

});
parcelRequire.register("4kI7C", function(module, exports) {

$parcel$export(module.exports, "dataURLToBlob", function () { return $fa71fbb012317d7a$export$9a3056f5f2717e33; });
$parcel$export(module.exports, "sanitizeImage", function () { return $fa71fbb012317d7a$export$2bc9b343ad4b1fd1; });
$parcel$export(module.exports, "rotatePhoto", function () { return $fa71fbb012317d7a$export$d3af12e959988d88; });
function $fa71fbb012317d7a$export$9a3056f5f2717e33(dataURL) {
    const BASE64_MARKER = ";base64,";
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        const parts = dataURL.split(",");
        const contentType = parts[0].split(":")[1];
        const raw = parts[1];
        return new Blob([
            raw
        ], {
            type: contentType
        });
    }
    const parts = dataURL.split(BASE64_MARKER);
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for(let i = 0; i < rawLength; ++i)uInt8Array[i] = raw.charCodeAt(i);
    return new Blob([
        uInt8Array
    ], {
        type: contentType
    });
}
function $fa71fbb012317d7a$export$2bc9b343ad4b1fd1(f, s = 2048) {
    return new Promise((resolve)=>{
        const fileReader = new FileReader();
        const image = new Image();
        let filename = `${Math.random().toString(36).slice(2)}-${f.name}`;
        filename = filename.replace(/ /g, "_").toLowerCase();
        image.addEventListener("load", ()=>{
            let w = image.width;
            let h = image.height;
            if (s > 0) {
                if (w > h) {
                    if (w > s) {
                        h *= s / w;
                        w = s;
                    }
                } else if (h > s) {
                    w *= s / h;
                    h = s;
                }
            }
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            ctx.drawImage(image, 0, 0, w, h);
            const data = canvas.toDataURL("image/jpeg");
            const blob = $fa71fbb012317d7a$export$9a3056f5f2717e33(data);
            blob.name = filename;
            resolve({
                data: data,
                blob: blob
            });
        });
        fileReader.addEventListener("load", (e)=>{
            image.src = e.target.result;
        });
        fileReader.readAsDataURL(f);
    });
}
function $fa71fbb012317d7a$export$d3af12e959988d88(src) {
    return new Promise((ok)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            const cvs = document.createElement("canvas");
            cvs.width = img.height;
            cvs.height = img.width;
            cvs.style.position = "absolute";
            const ctx = cvs.getContext("2d");
            if (!ctx) return;
            ctx.translate(img.height, img.width / img.height);
            ctx.rotate(Math.PI / 2);
            ctx.drawImage(img, 0, 0);
            ok(cvs.toDataURL("image/jpeg"));
        };
    });
}

});

parcelRequire.register("8VbsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ec89b58475d5e7$export$2e2bcd8739ae039; });
let $67ec89b58475d5e7$var$script;




let $67ec89b58475d5e7$var$initialize = ()=>{
    $67ec89b58475d5e7$var$script = (parcelRequire("hCwBE"));
    if ($67ec89b58475d5e7$var$script.__esModule) $67ec89b58475d5e7$var$script = $67ec89b58475d5e7$var$script.default;
    $67ec89b58475d5e7$var$script.render = (parcelRequire("8C8qv")).render;
    $67ec89b58475d5e7$var$script.__cssModules = {};
    (parcelRequire("1tBHA")).default($67ec89b58475d5e7$var$script);
    $67ec89b58475d5e7$var$script.__scopeId = "data-v-aa3fd2";
    $67ec89b58475d5e7$var$script.__file = "PhotoEditor.vue";
};
$67ec89b58475d5e7$var$initialize();
var $67ec89b58475d5e7$export$2e2bcd8739ae039 = $67ec89b58475d5e7$var$script;

});
parcelRequire.register("hCwBE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4300b93af4e11156$export$2e2bcd8739ae039; });

var $cKQUM = parcelRequire("cKQUM");

var $4kI7C = parcelRequire("4kI7C");
var // @vuese
// Komponent odpowiedzialny za skalowanie i kadrowanie zdjęć.
// @group Base Components | Photos
$4300b93af4e11156$export$2e2bcd8739ae039 = {
    name: "PhotoEditor",
    props: {
        modelValue: {
            required: false,
            default: null
        },
        AvatarMode: {
            type: Boolean,
            default: false
        },
        DataTest: {
            default: ""
        }
    },
    data () {
        return {
            Image: null,
            Input: null,
            Dimensions: [
                0,
                0
            ],
            Zoom: 1,
            Size: 300,
            SizeHeight: 300,
            Offset: [
                0,
                0
            ],
            OffsetBefore: [
                0,
                0
            ],
            Drag: false,
            DragStart: [
                0,
                0
            ],
            DragCurrent: [
                0,
                0
            ],
            DebugInfo: "",
            CropArea: {},
            CropAreaSize: [
                0,
                0
            ],
            Edited: false,
            StaticImage: ""
        };
    },
    computed: {
        ImageSize () {
            const [w, h] = this.Dimensions;
            const size = `${this.Size * 0.75 * this.Zoom}px`;
            return w > h ? [
                "auto",
                size
            ] : [
                size,
                "auto"
            ];
        }
    },
    watch: {
        Zoom () {
            this.Refresh();
        },
        modelValue: {
            immediate: true,
            handler (n) {
                if (n.file && !n.edited) this.SetImage(n.file);
                else this.StaticImage = n.url;
            }
        }
    },
    mounted () {
        this.SetSize();
        this.EventListener(true);
    },
    beforeUnmount () {
        // TODO: beforeUnmount generuje błędy podczas wywoływania removeEventListener?
        this.EventListener(false);
    },
    methods: {
        ConvertToTouch (e) {
            if (!e.touches) return e;
            const t = e.touches[0];
            e.clientX = t.clientX;
            e.clientY = t.clientY;
            return t;
        },
        Refresh () {
            this.Edited = this.Drag = true;
            // TODO: Nieeleganckie.
            this.OffsetBefore = this.Offset;
            this.DragStart = [
                0,
                0
            ];
            this.OnDragMove({
                clientX: 1,
                clientY: 1
            });
            this.OffsetBefore = this.Offset;
            this.DragStart = [
                0,
                0
            ];
            this.OnDragMove({
                clientX: -1,
                clientY: -1
            });
            this.Drag = false;
        },
        OnDragStart (e) {
            e = this.ConvertToTouch(e);
            if (!e.target || e.target.classList.contains("photo-editor-rotate-button")) return;
            this.OffsetBefore = this.Offset;
            this.DragStart = [
                e.clientX,
                e.clientY
            ];
            this.Drag = true;
        },
        OnDragMove (e) {
            if (!this.Drag) return;
            e = this.ConvertToTouch(e);
            const [x, y] = this.DragStart;
            const [newX, newY] = [
                x - e.clientX,
                y - e.clientY
            ];
            let [offsetX, offsetY] = [
                this.OffsetBefore[0] + newX,
                this.OffsetBefore[1] + newY
            ];
            const crop = this.$refs.CropArea;
            const img = this.$refs.ImageElement;
            if (!crop || !img) {
                console.warn("[PhotoEditor:OnDragMove] No valid $refs found!");
                return;
            }
            // TODO Czy da się pozbyć imgEdges oraz contraintować pozycję używając getBoundingClientRect()?
            const imgEdges = {
                l: (img.width - crop.offsetWidth) / 2,
                r: -(img.width - crop.offsetWidth) / 2,
                t: (img.height - crop.offsetHeight) / 2,
                b: -(img.height - crop.offsetHeight) / 2
            };
            const goingUp = y - e.clientY > 0;
            const goingLeft = x - e.clientX > 0;
            const cropAreaBound = crop.getBoundingClientRect();
            const imgBound = img.getBoundingClientRect();
            let hitBounduary = false;
            if (goingLeft && Math.floor(imgBound.left) >= Math.floor(cropAreaBound.left)) {
                offsetX = imgEdges.l;
                hitBounduary = true;
            } else if (!goingLeft && Math.floor(imgBound.right) <= Math.floor(cropAreaBound.right)) {
                offsetX = imgEdges.r;
                hitBounduary = true;
            }
            if (goingUp && Math.floor(imgBound.top) >= Math.floor(cropAreaBound.top)) {
                offsetY = imgEdges.t;
                hitBounduary = true;
            } else if (!goingUp && Math.floor(imgBound.bottom) <= Math.floor(cropAreaBound.bottom)) {
                offsetY = imgEdges.b;
                hitBounduary = true;
            }
            this.Offset = [
                offsetX,
                offsetY
            ];
            if (hitBounduary) this.OnDragStart(e);
            const scale = this.Dimensions[0] / img.width;
            const cropSize = [
                this.CropAreaSize[0] || this.Size * 0.75,
                this.CropAreaSize[1] || this.Size * 0.75
            ];
            const area = {
                l: -offsetX + (img.width - cropSize[0]) / 2,
                r: -1,
                t: -offsetY + (img.height - cropSize[1]) / 2,
                b: -1,
                w: -1,
                h: -1
            };
            area.r = area.l + cropSize[0];
            area.b = area.t + cropSize[1];
            for(const p in area){
                area[p] *= scale;
                area[p] = Math.round(area[p]);
            }
            area.w = area.r - area.l;
            area.h = area.b - area.t;
            this.CropArea = area;
        },
        OnDragEnd () {
            this.Drag = false;
            window.setTimeout(()=>{
                this.Refresh();
            }, 150); // TODO: nextTick?
        },
        async RotatePhoto () {
            const [x, y] = this.Dimensions;
            this.Zoom = 1;
            this.Dimensions = [
                y,
                x
            ];
            this.Offset = this.OffsetBefore = [
                0,
                0
            ];
            this.Edited = true;
            const rotated = await (0, $4kI7C.rotatePhoto)(this.Input);
            const blob = (0, $4kI7C.dataURLToBlob)(rotated);
            this.SetImage(blob);
            this.SetSize();
            window.setTimeout(()=>{
                this.Refresh();
            }, 150); // TODO: nextTick?
        },
        GetCroppedImage () {
            try {
                const area = this.CropArea;
                let canvas = document.createElement("canvas");
                canvas.width = area.w;
                canvas.height = area.h;
                if (!this.Image) {
                    console.warn("[PhotoEditor:GetCroppedImage] No valid this.Image found!");
                    return null;
                }
                canvas.getContext("2d").drawImage(this.Image, area.l, area.t, area.w, area.h, 0, 0, area.w, area.h);
                const s = 2048;
                if (area.w > s || area.h > s) {
                    let [w, h] = [
                        area.w,
                        area.h
                    ];
                    if (w > h) {
                        if (w > s) {
                            h *= s / w;
                            w = s;
                        }
                    } else if (h > s) {
                        w *= s / h;
                        h = s;
                    }
                    const resized = document.createElement("canvas");
                    resized.width = w;
                    resized.height = h;
                    resized.getContext("2d").drawImage(canvas, 0, 0, w, h);
                    canvas = resized;
                }
                return canvas.toDataURL("image/jpeg");
            } catch (err) {
                console.warn("GetCroppedImage", err);
            }
            return null;
        },
        async OnInputChange () {
            const img = await this.GetImage(this.$refs.Input.files[0]);
            this.Input = img.data;
            this.Dimensions = img.dimensions;
        },
        SetCropAreaSize () {
            if (this.AvatarMode) return;
            // TODO: Wypróbuj jak byłoby to z nextTick
            window.setTimeout(()=>{
                if (!this.$refs.ImageElement) return;
                const img = this.$refs.ImageElement.getBoundingClientRect();
                this.CropAreaSize = [
                    Math.floor(img.width),
                    Math.floor(img.height)
                ];
            }, 150);
        },
        async SetImage (f) {
            const img = await this.GetImage(f);
            this.Input = img.data;
            this.Dimensions = img.dimensions;
            this.SetCropAreaSize();
        },
        GetImage (f) {
            return new Promise((resolve)=>{
                const fileReader = new FileReader();
                const img = new Image();
                (0, $cKQUM.addHandler)(img, "load", ()=>{
                    const w = img.width;
                    const h = img.height;
                    const canvas = document.createElement("canvas");
                    canvas.width = w;
                    canvas.height = h;
                    canvas.getContext("2d").drawImage(img, 0, 0, w, h);
                    const data = canvas.toDataURL("image/jpeg");
                    this.Image = img;
                    resolve({
                        data: data,
                        dimensions: [
                            w,
                            h
                        ]
                    });
                });
                (0, $cKQUM.addHandler)(fileReader, "load", (e)=>{
                    img.src = e.target.result;
                });
                fileReader.readAsDataURL(f);
            });
        },
        EventListener (add) {
            const method = `${add ? "add" : "remove"}EventListener`;
            const ev = (element, events, handler)=>{
                if (!element) return;
                events.forEach((e)=>{
                    element[method](e, handler);
                });
            };
            ev(this.$refs.PhotoEditorPreview, [
                "mousedown",
                "touchstart"
            ], this.OnDragStart);
            ev(document.body, [
                "mousemove",
                "touchmove"
            ], this.OnDragMove);
            ev(document.body, [
                "mouseup",
                "touchend"
            ], this.OnDragEnd);
            ev(window, [
                "resize"
            ], this.SetSize);
        },
        SetSize () {
            const el = this.$refs.PhotoEditorPreview;
            this.Size = el ? el.offsetWidth : 300;
            this.SizeHeight = el ? el.offsetHeight : 300;
            this.SetCropAreaSize();
        }
    }
};

});
parcelRequire.register("cKQUM", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $1866267ec850df07$export$a4e09611e30da72e; });
$parcel$export(module.exports, "removeHandler", function () { return $1866267ec850df07$export$bbe7f9b98f820cde; });
function $1866267ec850df07$export$a4e09611e30da72e(el, type, listener, debugName = "") {
    if (!el) {
        console.warn(`AddHandler:${type}:${debugName}`);
        return;
    }
    type.split(" ").forEach((t)=>{
        el.addEventListener(t, listener);
    });
}
function $1866267ec850df07$export$bbe7f9b98f820cde(el, type, listener, debugName = "") {
    if (!el) {
        console.warn(`RemoveHandler:${type}:${debugName}`);
        return;
    }
    type.split(" ").forEach((t)=>{
        el.removeEventListener(t, listener);
    });
}

});


parcelRequire.register("8C8qv", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $645868b0c5e619f3$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $645868b0c5e619f3$var$_hoisted_1 = {
    key: 0,
    "data-component": "PhotoEditor.vue",
    class: "flex flex-col items-center justify-center mb-3"
};
const $645868b0c5e619f3$var$_hoisted_2 = [
    "data-test",
    "src"
];
const $645868b0c5e619f3$var$_hoisted_3 = [
    "data-test"
];
const $645868b0c5e619f3$var$_hoisted_4 = {
    class: "[ photo-editor-offset ]"
};
const $645868b0c5e619f3$var$_hoisted_5 = [
    "data-test",
    "src"
];
const $645868b0c5e619f3$var$_hoisted_6 = {
    class: "flex items-center mt-3"
};
const $645868b0c5e619f3$var$_hoisted_7 = {
    class: "widget-slider"
};
const $645868b0c5e619f3$var$_hoisted_8 = [
    "value"
];
const $645868b0c5e619f3$var$_hoisted_9 = [
    "data-test"
];
function $645868b0c5e619f3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return $data.StaticImage ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $645868b0c5e619f3$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("img", {
            class: "[ image-upload-preview ] rounded",
            "data-test": `${$props.DataTest}__photo_editor__image`,
            src: $data.StaticImage
        }, null, 8, $645868b0c5e619f3$var$_hoisted_2)
    ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        key: 1,
        "data-component": "PhotoEditor.vue",
        class: (0, $4bH2P.normalizeClass)([
            "[ photo-editor ]",
            {
                "is-avatar-mode": $props.AvatarMode
            }
        ])
    }, [
        (0, $cfZzL.createElementVNode)("div", {
            ref: "PhotoEditorPreview",
            class: "[ photo-editor-preview ]",
            "data-test": `${$props.DataTest}__photo_editor__preview`,
            style: (0, $4bH2P.normalizeStyle)({
                width: "100%",
                "min-height": $data.Size + "px"
            })
        }, [
            (0, $cfZzL.createElementVNode)("div", {
                ref: "CropArea",
                class: "[ photo-editor-crop-area ]",
                style: (0, $4bH2P.normalizeStyle)({
                    width: ($data.CropAreaSize[0] || $data.Size * .75) + "px",
                    height: ($data.CropAreaSize[1] || $data.Size * .75) + "px"
                })
            }, [
                $props.AvatarMode ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                    key: 0,
                    class: "[ photo-editor-rotate-button ] absolute right-0 bottom-0 text-white",
                    onClick: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)((...args)=>$options.RotatePhoto && $options.RotatePhoto(...args), [
                        "prevent",
                        "stop"
                    ]))
                }, [
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "rotate",
                        size: "2.25"
                    })
                ])) : (0, $cfZzL.createCommentVNode)("", true)
            ], 4),
            !$props.AvatarMode ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                key: 0,
                class: "[ photo-editor-rotate-button ] absolute right-0 bottom-0 text-white",
                onClick: _cache[1] || (_cache[1] = (0, $brqXq.withModifiers)((...args)=>$options.RotatePhoto && $options.RotatePhoto(...args), [
                    "prevent",
                    "stop"
                ]))
            }, [
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "rotate",
                    size: "2.25"
                })
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            (0, $cfZzL.createElementVNode)("div", $645868b0c5e619f3$var$_hoisted_4, [
                (0, $cfZzL.createElementVNode)("img", {
                    ref: "ImageElement",
                    "data-test": `${$props.DataTest}__photo_editor__image`,
                    src: $data.Input,
                    style: (0, $4bH2P.normalizeStyle)({
                        width: $options.ImageSize[0],
                        height: $options.ImageSize[1],
                        transform: "translate(" + $data.Offset[0] + "px, " + $data.Offset[1] + "px)"
                    })
                }, null, 12, $645868b0c5e619f3$var$_hoisted_5)
            ])
        ], 12, $645868b0c5e619f3$var$_hoisted_3),
        (0, $cfZzL.createElementVNode)("div", $645868b0c5e619f3$var$_hoisted_6, [
            (0, $cfZzL.createVNode)(_component_BaseIcon, {
                name: "search",
                size: "1",
                class: "mr-3",
                "data-test": `${$props.DataTest}__photo_editor__zoom`
            }, null, 8, [
                "data-test"
            ]),
            (0, $cfZzL.createElementVNode)("div", $645868b0c5e619f3$var$_hoisted_7, [
                (0, $cfZzL.createElementVNode)("progress", {
                    max: 1,
                    value: $data.Zoom - 1
                }, null, 8, $645868b0c5e619f3$var$_hoisted_8),
                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.Zoom = $event),
                    type: "range",
                    min: "1",
                    max: "2",
                    step: "0.01",
                    "data-test": `${$props.DataTest}__photo_editor__range`
                }, null, 8, $645868b0c5e619f3$var$_hoisted_9), [
                    [
                        (0, $brqXq.vModelText),
                        $data.Zoom
                    ]
                ])
            ])
        ])
    ], 2));
}

});

parcelRequire.register("1tBHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1135beb36bae9cc0$export$2e2bcd8739ae039; });
let $1135beb36bae9cc0$var$NOOP = ()=>{};
var $1135beb36bae9cc0$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("45yDD", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $2fa27f7fdd385af4$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $2fa27f7fdd385af4$var$_hoisted_1 = {
    key: 0,
    class: "p-3 text-center"
};
const $2fa27f7fdd385af4$var$_hoisted_2 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_3 = [
    "onMousedown",
    "onTouchstart"
];
const $2fa27f7fdd385af4$var$_hoisted_4 = [
    "onClick",
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_5 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "left-0 is-dragging-sequence is-dragging-put-before"
}, null, -1);
const $2fa27f7fdd385af4$var$_hoisted_6 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "right-0 is-dragging-sequence is-dragging-put-after"
}, null, -1);
const $2fa27f7fdd385af4$var$_hoisted_7 = [
    "data-test",
    "onTouchstart",
    "onClick"
];
const $2fa27f7fdd385af4$var$_hoisted_8 = [
    "onClick"
];
const $2fa27f7fdd385af4$var$_hoisted_9 = {
    class: "absolute inset-0 flex flex-col items-center justify-center"
};
const $2fa27f7fdd385af4$var$_hoisted_10 = {
    class: "mt-3 text-xs ellipsis",
    style: {
        "max-width": "calc(100% - 32px)"
    }
};
const $2fa27f7fdd385af4$var$_hoisted_11 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "left-0 is-dragging-sequence is-dragging-put-before"
}, null, -1);
const $2fa27f7fdd385af4$var$_hoisted_12 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "right-0 is-dragging-sequence is-dragging-put-after"
}, null, -1);
const $2fa27f7fdd385af4$var$_hoisted_13 = [
    "onClick"
];
const $2fa27f7fdd385af4$var$_hoisted_14 = [
    "for"
];
const $2fa27f7fdd385af4$var$_hoisted_15 = {
    class: "flex items-center justify-center text-info-design"
};
const $2fa27f7fdd385af4$var$_hoisted_16 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "text-sm"
}, "Dodaj zdjęcia", -1);
const $2fa27f7fdd385af4$var$_hoisted_17 = [
    "for",
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_18 = {
    class: "bg-white bg-center bg-no-repeat bg-cover border rounded b aspect-square border-black/10"
};
const $2fa27f7fdd385af4$var$_hoisted_19 = {
    class: "absolute inset-0 flex flex-col items-center justify-center"
};
const $2fa27f7fdd385af4$var$_hoisted_20 = {
    class: "mt-3"
};
const $2fa27f7fdd385af4$var$_hoisted_21 = {
    key: 0,
    class: "[ photo-gallery-dragging ]"
};
const $2fa27f7fdd385af4$var$_hoisted_22 = {
    key: 1,
    class: "[ photo-gallery-dragging-overlay ]"
};
const $2fa27f7fdd385af4$var$_hoisted_23 = {
    class: "[ form-input-validation ] text-danger text-2xs mt-2"
};
const $2fa27f7fdd385af4$var$_hoisted_24 = [
    "id",
    "accept",
    "multiple"
];
const $2fa27f7fdd385af4$var$_hoisted_25 = {
    key: 1,
    class: "photo-gallery | is-single"
};
const $2fa27f7fdd385af4$var$_hoisted_26 = [
    "id",
    "accept"
];
const $2fa27f7fdd385af4$var$_hoisted_27 = {
    key: 0,
    class: "flex items-center justify-center gap-2 mt-3"
};
const $2fa27f7fdd385af4$var$_hoisted_28 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_29 = [
    "for"
];
const $2fa27f7fdd385af4$var$_hoisted_30 = [
    "data-test",
    "textContent"
];
const $2fa27f7fdd385af4$var$_hoisted_31 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_32 = {
    key: 0,
    class: "relative w-40 h-40 border rounded-lg border-neutral-200"
};
const $2fa27f7fdd385af4$var$_hoisted_33 = [
    "data-test",
    "src"
];
const $2fa27f7fdd385af4$var$_hoisted_34 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_35 = {
    class: "flex flex-col gap-4"
};
const $2fa27f7fdd385af4$var$_hoisted_36 = [
    "data-test",
    "textContent"
];
const $2fa27f7fdd385af4$var$_hoisted_37 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_38 = {
    key: 0,
    class: "absolute inset-0 flex flex-col items-center justify-center bg-white z-64"
};
const $2fa27f7fdd385af4$var$_hoisted_39 = {
    class: "mb-5 heading-small"
};
const $2fa27f7fdd385af4$var$_hoisted_40 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_41 = {
    class: "photo-gallery-container"
};
const $2fa27f7fdd385af4$var$_hoisted_42 = {
    class: "flex"
};
const $2fa27f7fdd385af4$var$_hoisted_43 = {
    key: 0,
    class: "photo-gallery-list | flex px-7 py-3 mb-3 mt-5 bg-neutral-100 scroll-gray"
};
const $2fa27f7fdd385af4$var$_hoisted_44 = [
    "onClick"
];
const $2fa27f7fdd385af4$var$_hoisted_45 = [
    "src"
];
const $2fa27f7fdd385af4$var$_hoisted_46 = [
    "onClick"
];
const $2fa27f7fdd385af4$var$_hoisted_47 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_48 = {
    class: "photo-gallery-panels"
};
const $2fa27f7fdd385af4$var$_hoisted_49 = {
    key: 0
};
const $2fa27f7fdd385af4$var$_hoisted_50 = {
    class: "[ form-group ] is-editable"
};
const $2fa27f7fdd385af4$var$_hoisted_51 = [
    "data-invalid"
];
const $2fa27f7fdd385af4$var$_hoisted_52 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    for: "selected-photo-description"
}, "Opis", -1);
const $2fa27f7fdd385af4$var$_hoisted_53 = [
    "data-test",
    "onUpdate:modelValue",
    "onKeypress"
];
const $2fa27f7fdd385af4$var$_hoisted_54 = {
    class: "[ form-input-validation ] text-danger text-xs mt-2"
};
const $2fa27f7fdd385af4$var$_hoisted_55 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "mt-2 mb-3 text-neutral-700"
}, " Opis nie jest obowiązkowy. Jeśli go dodasz, pojawi się pod zdjęciem. ", -1);
const $2fa27f7fdd385af4$var$_hoisted_56 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_57 = {
    key: 0,
    class: "flex items-center pb-7 px-7"
};
const $2fa27f7fdd385af4$var$_hoisted_58 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("hr", {
    class: "flex-auto"
}, null, -1);
const $2fa27f7fdd385af4$var$_hoisted_59 = [
    "data-test"
];
const $2fa27f7fdd385af4$var$_hoisted_60 = {
    key: 1,
    class: "sticky bottom-0 flex items-center flex-none p-3 mt-auto -mb-5 bg-white shadow-default z-48"
};
const $2fa27f7fdd385af4$var$_hoisted_61 = [
    "data-test"
];
function $2fa27f7fdd385af4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loader = (0, $cfZzL.resolveComponent)("Loader");
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_BaseAvatar = (0, $cfZzL.resolveComponent)("BaseAvatar");
    const _component_PageHeader = (0, $cfZzL.resolveComponent)("PageHeader");
    const _component_PhotoEditor = (0, $cfZzL.resolveComponent)("PhotoEditor");
    const _component_ModalDialog = (0, $cfZzL.resolveComponent)("ModalDialog");
    const _component_PromptDialog = (0, $cfZzL.resolveComponent)("PromptDialog");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        "data-component": "PhotoGallery.vue",
        class: (0, $4bH2P.normalizeClass)([
            "photo-gallery-wrapper",
            {
                "is-adding": $data.IsAdding
            }
        ])
    }, [
        !$props.Single ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 0,
            class: "[ photo-gallery ]",
            onMousemove: _cache[14] || (_cache[14] = (...args)=>$options.OnDragMove && $options.OnDragMove(...args)),
            onMouseup: _cache[15] || (_cache[15] = (...args)=>$options.OnDragEnd && $options.OnDragEnd(...args)),
            onTouchmove: _cache[16] || (_cache[16] = (...args)=>$options.OnDragMove && $options.OnDragMove(...args)),
            onTouchend: _cache[17] || (_cache[17] = (...args)=>$options.OnDragEnd && $options.OnDragEnd(...args))
        }, [
            (0, $cfZzL.createElementVNode)("div", {
                class: (0, $4bH2P.normalizeClass)({
                    "is-dragging": $data.DraggingIndex
                })
            }, [
                $data.IsAdding ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_1, [
                    (0, $cfZzL.createVNode)(_component_Loader)
                ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                    key: 1,
                    ref: "GalleryContainer",
                    class: "photo-gallery-items | flex items-center flex-wrap -m-1",
                    "data-test": $props.DataTest && `${$props.DataTest}__all_photos`,
                    onMouseup: _cache[11] || (_cache[11] = (0, $brqXq.withModifiers)((...args)=>$options.OnDragInsideEnd && $options.OnDragInsideEnd(...args), [
                        "stop"
                    ])),
                    onTouchend: _cache[12] || (_cache[12] = (0, $brqXq.withModifiers)((...args)=>$options.OnDragInsideEndTouch && $options.OnDragInsideEndTouch(...args), [
                        "stop"
                    ]))
                }, [
                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.Photos, (Photo, Index)=>{
                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                            key: Photo.date || Photo.url
                        }, [
                            !Photo.markedForDeletion ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                key: 0,
                                class: "[ photo-gallery-item ] relative p-1",
                                style: (0, $4bH2P.normalizeStyle)({
                                    flex: `0 0 calc(100% / ${$options.PerLine})`
                                }),
                                onMousedown: ($event)=>$options.OnDragStart(Index, $event),
                                onTouchstart: ($event)=>$options.OnDragStart(Index, $event)
                            }, [
                                !Photo.isFile ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                    key: 0
                                }, [
                                    $props.Loaded && Index === 0 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_Loader, {
                                        key: 0,
                                        Type: "ring",
                                        size: "small"
                                    })) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                        key: 1,
                                        class: "bg-white bg-center bg-no-repeat bg-cover border rounded aspect-square border-black/10",
                                        style: (0, $4bH2P.normalizeStyle)({
                                            backgroundImage: `url('${Photo.url}')`
                                        }),
                                        onClick: ($event)=>$options.OnClick(Index, $event),
                                        "data-test": $props.DataTest && `${$props.DataTest}__loaded_photo`
                                    }, [
                                        $2fa27f7fdd385af4$var$_hoisted_5,
                                        $2fa27f7fdd385af4$var$_hoisted_6,
                                        !$props.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                                            key: 0,
                                            class: "absolute top-0 right-0 p-2 text-white rounded-full bg-danger",
                                            style: {
                                                "background": "rgba(0, 0, 0, 0.25)"
                                            },
                                            "data-test": $props.DataTest && `${$props.DataTest}__loaded_photo__remove`,
                                            onTouchstart: (0, $brqXq.withModifiers)(($event)=>$options.Remove(Index), [
                                                "prevent",
                                                "stop"
                                            ]),
                                            onMousedown: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)(()=>{}, [
                                                "prevent",
                                                "stop"
                                            ])),
                                            onTouchend: _cache[1] || (_cache[1] = (0, $brqXq.withModifiers)(()=>{}, [
                                                "prevent",
                                                "stop"
                                            ])),
                                            onClick: (0, $brqXq.withModifiers)(($event)=>$options.Remove(Index), [
                                                "prevent",
                                                "stop"
                                            ])
                                        }, [
                                            (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                                name: "trash",
                                                size: "1"
                                            })
                                        ], 40, $2fa27f7fdd385af4$var$_hoisted_7)) : (0, $cfZzL.createCommentVNode)("", true)
                                    ], 12, $2fa27f7fdd385af4$var$_hoisted_4))
                                ], 64)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                    key: 1,
                                    class: "bg-white bg-center bg-no-repeat bg-cover border rounded aspect-square border-black/10",
                                    onClick: ($event)=>$options.OnClick(Index, $event)
                                }, [
                                    (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_9, [
                                        $props.Loaded && Index === 0 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_Loader, {
                                            key: 0,
                                            Type: "ring",
                                            size: "small"
                                        })) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                            key: 1
                                        }, [
                                            (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                                name: "attach",
                                                size: "1.5"
                                            }),
                                            (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_10, (0, $4bH2P.toDisplayString)(Photo.originalName), 1)
                                        ], 64))
                                    ]),
                                    $2fa27f7fdd385af4$var$_hoisted_11,
                                    $2fa27f7fdd385af4$var$_hoisted_12,
                                    !$props.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                                        key: 0,
                                        class: "absolute top-0 right-0 p-2 text-white rounded-full bg-danger",
                                        style: {
                                            "background": "rgba(0, 0, 0, 0.25)"
                                        },
                                        onMousedown: _cache[2] || (_cache[2] = (0, $brqXq.withModifiers)(()=>{}, [
                                            "prevent",
                                            "stop"
                                        ])),
                                        onTouchend: _cache[3] || (_cache[3] = (0, $brqXq.withModifiers)(()=>{}, [
                                            "prevent",
                                            "stop"
                                        ])),
                                        onClick: (0, $brqXq.withModifiers)(($event)=>$options.Remove(Index), [
                                            "prevent",
                                            "stop"
                                        ])
                                    }, [
                                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                            name: "trash",
                                            size: "1"
                                        })
                                    ], 40, $2fa27f7fdd385af4$var$_hoisted_13)) : (0, $cfZzL.createCommentVNode)("", true)
                                ], 8, $2fa27f7fdd385af4$var$_hoisted_8))
                            ], 44, $2fa27f7fdd385af4$var$_hoisted_3)) : (0, $cfZzL.createCommentVNode)("", true)
                        ], 64);
                    }), 128)),
                    !$props.Readonly && !$props.HideAddButton && $props.DragAndDroppable && $data.Photos.length < 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("label", {
                        key: 0,
                        for: $props.UploadFieldName,
                        class: (0, $4bH2P.normalizeClass)([
                            "drag-area | w-full px-2.5 py-2.5 rounded-lg border flex-col justify-center items-center gap-2.5 inline-flex",
                            {
                                "!text-[#0009] !border-[#0009]": $options.IsDragging,
                                "!border-danger": $data.LocalValidationMessage !== "" || $data.HasErrors
                            }
                        ]),
                        onDragover: _cache[4] || (_cache[4] = (0, $brqXq.withModifiers)(()=>{}, [
                            "prevent"
                        ])),
                        onDrop: _cache[5] || (_cache[5] = (0, $brqXq.withModifiers)((...args)=>$options.OnDragAndDropInput && $options.OnDragAndDropInput(...args), [
                            "prevent"
                        ])),
                        onDragenter: _cache[6] || (_cache[6] = (...args)=>$options.dragEnter && $options.dragEnter(...args)),
                        onDragleave: _cache[7] || (_cache[7] = (...args)=>$options.dragLeave && $options.dragLeave(...args)),
                        onClick: _cache[8] || (_cache[8] = ($event)=>_ctx.$emit("addPhotosButtonClicked"))
                    }, [
                        (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_15, [
                            (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                class: "mr-3 pt-[1px]",
                                name: "camera-photo"
                            }),
                            $2fa27f7fdd385af4$var$_hoisted_16
                        ])
                    ], 42, $2fa27f7fdd385af4$var$_hoisted_14)) : (0, $cfZzL.createCommentVNode)("", true),
                    !$props.Readonly && !$props.HideAddButton && (!$props.DragAndDroppable || $props.DragAndDroppable && $data.Photos.length > 0) ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("label", {
                        key: 1,
                        for: $props.UploadFieldName,
                        class: "add-photo | relative p-1",
                        style: (0, $4bH2P.normalizeStyle)({
                            flex: `0 0 calc(100% / ${$options.PerLine})`
                        }),
                        "data-test": $props.DataTest && `${$props.DataTest}__upload_photo`,
                        onDragover: _cache[9] || (_cache[9] = (0, $brqXq.withModifiers)(()=>{}, [
                            "prevent"
                        ])),
                        onDrop: _cache[10] || (_cache[10] = (0, $brqXq.withModifiers)((...args)=>$options.OnDragAndDropInput && $options.OnDragAndDropInput(...args), [
                            "prevent"
                        ]))
                    }, [
                        (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_18, [
                            (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_19, [
                                !$props.AllowFiles ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                                    key: 0,
                                    name: "photo-add",
                                    size: "2",
                                    "data-test": $props.DataTest && `${$props.DataTest}__upload_photo_icon`
                                }, null, 8, [
                                    "data-test"
                                ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                    key: 1
                                }, [
                                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                        name: "plus",
                                        size: "2",
                                        "data-test": $props.DataTest && `${$props.DataTest}__upload_photo_icon`
                                    }, null, 8, [
                                        "data-test"
                                    ]),
                                    (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_20, (0, $4bH2P.toDisplayString)($props.AttachText), 1)
                                ], 64))
                            ])
                        ])
                    ], 44, $2fa27f7fdd385af4$var$_hoisted_17)) : (0, $cfZzL.createCommentVNode)("", true)
                ], 40, $2fa27f7fdd385af4$var$_hoisted_2))
            ], 2),
            $data.DraggingIndex ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_21)) : (0, $cfZzL.createCommentVNode)("", true),
            $data.DraggingImage ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_22, [
                (0, $cfZzL.createElementVNode)("div", {
                    class: "bg-center bg-no-repeat bg-cover rounded shadow-large",
                    style: (0, $4bH2P.normalizeStyle)({
                        left: $data.CurrentPoint[0] + "px",
                        top: $data.CurrentPoint[1] + "px",
                        backgroundImage: `url(${$data.DraggingImage.url})`,
                        height: $data.DraggingElementSize + "px",
                        width: $data.DraggingElementSize + "px"
                    })
                }, null, 4)
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_23, (0, $4bH2P.toDisplayString)($data.LocalValidationMessage), 1),
            (0, $cfZzL.createElementVNode)("input", {
                id: $props.UploadFieldName,
                ref: "ImageUploadField",
                type: "file",
                accept: $options.AcceptType,
                multiple: !$props.Single && !$props.AddOneFile,
                hidden: "",
                onChange: _cache[13] || (_cache[13] = (...args)=>$options.ImageUpload && $options.ImageUpload(...args))
            }, null, 40, $2fa27f7fdd385af4$var$_hoisted_24)
        ], 32)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_25, [
            (0, $cfZzL.createElementVNode)("input", {
                id: $props.UploadFieldName,
                ref: "ImageUploadField",
                type: "file",
                accept: $options.AcceptType,
                hidden: "",
                onChange: _cache[18] || (_cache[18] = (...args)=>$options.ImageUpload && $options.ImageUpload(...args))
            }, null, 40, $2fa27f7fdd385af4$var$_hoisted_26),
            $props.HideSinglePreview ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_27, [
                $data.Photos.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                    key: 0,
                    "data-test": $props.DataTest && `${$props.DataTest}__photo__button_remove`,
                    class: "mx-2 btn text-accent",
                    onClick: _cache[19] || (_cache[19] = (0, $brqXq.withModifiers)((...args)=>$options.RemoveSingle && $options.RemoveSingle(...args), [
                        "prevent",
                        "stop"
                    ])),
                    textContent: "Usuń"
                }, null, 8, $2fa27f7fdd385af4$var$_hoisted_28)) : (0, $cfZzL.createCommentVNode)("", true),
                (0, $cfZzL.createElementVNode)("label", {
                    for: $props.UploadFieldName
                }, [
                    (0, $cfZzL.createElementVNode)("button", {
                        "data-test": $props.DataTest && `${$props.DataTest}__photo__button_edit_add`,
                        class: "mx-2 btn btn-medium btn-outline-accent",
                        onClick: _cache[20] || (_cache[20] = (0, $brqXq.withModifiers)(()=>{}, [
                            "prevent",
                            "stop"
                        ])),
                        textContent: (0, $4bH2P.toDisplayString)(`${$data.Photos.length ? "Zmień" : "Dodaj"} zdjęcie`)
                    }, null, 8, $2fa27f7fdd385af4$var$_hoisted_30)
                ], 8, $2fa27f7fdd385af4$var$_hoisted_29)
            ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                key: 1,
                "data-test": $props.DataTest && `${$props.DataTest}__photo`,
                class: "flex flex-col items-center justify-center gap-4 rounded-lg lg:gap-10 lg:flex-row lg:py-10 lg:border border-neutral-200",
                onClick: _cache[24] || (_cache[24] = ($event)=>_ctx.$refs["ImageUploadField"].click())
            }, [
                $data.Photos.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_32, [
                    (0, $cfZzL.createElementVNode)("img", {
                        class: "object-cover w-full h-full rounded-lg",
                        "data-test": $props.DataTest && `${$props.DataTest}__image`,
                        src: $data.Photos[0].url
                    }, null, 8, $2fa27f7fdd385af4$var$_hoisted_33),
                    $data.Photos.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                        key: 0,
                        "data-test": $props.DataTest && `${$props.DataTest}__photo__button_remove`,
                        class: "absolute top-0 right-0 hidden w-6 h-6 m-1 text-black bg-white rounded-full lg:flex",
                        onClick: _cache[21] || (_cache[21] = (0, $brqXq.withModifiers)((...args)=>$options.RemoveSingle && $options.RemoveSingle(...args), [
                            "prevent",
                            "stop"
                        ]))
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "close",
                            size: 0.5
                        })
                    ], 8, $2fa27f7fdd385af4$var$_hoisted_34)) : (0, $cfZzL.createCommentVNode)("", true)
                ])) : $props.AvatarMode ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseAvatar, {
                    key: 1,
                    user: _ctx.User,
                    "hide-image": true,
                    size: "xl"
                }, null, 8, [
                    "user"
                ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                    key: 2,
                    name: "photo",
                    size: "4",
                    class: "text-neutral-300"
                })),
                (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_35, [
                    (0, $cfZzL.createElementVNode)("button", {
                        ref: "UploadButton",
                        "data-test": $props.DataTest && `${$props.DataTest}__photo__button_edit_add`,
                        class: "btn btn-medium btn-outline-accent",
                        onClick: _cache[22] || (_cache[22] = (0, $brqXq.withModifiers)(($event)=>_ctx.$refs["ImageUploadField"].click(), [
                            "prevent",
                            "stop"
                        ])),
                        textContent: (0, $4bH2P.toDisplayString)(`${$data.Photos.length ? "Zmień" : "Dodaj"} zdjęcie`)
                    }, null, 8, $2fa27f7fdd385af4$var$_hoisted_36),
                    $data.Photos.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                        key: 0,
                        "data-test": $props.DataTest && `${$props.DataTest}__photo__button_remove`,
                        class: "btn btn-medium text-accent lg:hidden",
                        onClick: _cache[23] || (_cache[23] = (0, $brqXq.withModifiers)((...args)=>$options.RemoveSingle && $options.RemoveSingle(...args), [
                            "prevent",
                            "stop"
                        ])),
                        textContent: "Usuń"
                    }, null, 8, $2fa27f7fdd385af4$var$_hoisted_37)) : (0, $cfZzL.createCommentVNode)("", true)
                ])
            ], 8, $2fa27f7fdd385af4$var$_hoisted_31))
        ])),
        (0, $cfZzL.createVNode)(_component_ModalDialog, {
            class: (0, $4bH2P.normalizeClass)([
                "photo-gallery-dialog is-dialog",
                {
                    "is-fullscreen": _ctx.ScreenSize <= 1,
                    "is-photo-only": !$props.AllowDescription
                }
            ]),
            Visible: $data.SelectedPhoto && _ctx.CurrentState.CropPhotoModal
        }, {
            default: (0, $cfZzL.withCtx)(()=>[
                    !$props.Single && $data.Processing > -1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_38, [
                        (0, $cfZzL.createVNode)(_component_Loader),
                        (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_39, " Przetwarzanie " + (0, $4bH2P.toDisplayString)($data.Processing) + " z " + (0, $4bH2P.toDisplayString)(_ctx.Format.PluralForm($data.SelectedPhotoList.length, [
                            "zdjęcia",
                            "zdjęć",
                            "zdjęć"
                        ], true)), 1),
                        (0, $cfZzL.createElementVNode)("button", {
                            class: "btn btn-primary",
                            onClick: _cache[25] || (_cache[25] = (0, $brqXq.withModifiers)(($event)=>$data.ProcessingCancel = true, [
                                "prevent"
                            ]))
                        }, " Przerwij ")
                    ])) : (0, $cfZzL.createCommentVNode)("", true),
                    _ctx.ScreenSize > 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                        key: 1,
                        class: "absolute top-0 right-0 p-3",
                        onClick: _cache[26] || (_cache[26] = (0, $brqXq.withModifiers)((...args)=>$options.CloseModal && $options.CloseModal(...args), [
                            "prevent"
                        ])),
                        "data-test": $props.DataTest && `${$props.DataTest}__modal__close`
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "close",
                            size: 1
                        })
                    ], 8, $2fa27f7fdd385af4$var$_hoisted_40)) : (0, $cfZzL.createCommentVNode)("", true),
                    $data.SelectedPhoto || $data.SelectedPhotoList.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                        key: 2
                    }, [
                        (0, $cfZzL.createVNode)(_component_PageHeader, {
                            Title: !$props.Single ? "Dodaj zdjęcia" : "Dodaj zdjęcie",
                            Back: false,
                            Buttons: [
                                {
                                    Icon: "close",
                                    Action: "close"
                                }
                            ],
                            onButtonClick: $options.CloseModal
                        }, null, 8, [
                            "Title",
                            "onButtonClick"
                        ]),
                        (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_41, [
                            (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_42, [
                                !$props.Single ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_43, [
                                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.SelectedPhotoList, (Photo, i)=>{
                                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                            key: Photo.Item.originalName,
                                            class: (0, $4bH2P.normalizeClass)([
                                                "relative m-1 shrink-0",
                                                {
                                                    "is-selected": $data.SelectedPhotoIndex === i
                                                }
                                            ]),
                                            onClick: ($event)=>$data.SelectedPhotoIndex = i
                                        }, [
                                            (0, $cfZzL.createElementVNode)("img", {
                                                src: Photo.Item.url
                                            }, null, 8, $2fa27f7fdd385af4$var$_hoisted_45),
                                            _ctx.ScreenSize > 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                                                key: 0,
                                                class: "photo-gallery-delete-photo | absolute right-0 top-0 text-white p-1 rounded-full",
                                                style: {
                                                    "background": "rgba(0, 0, 0, 0.25)"
                                                },
                                                onClick: (0, $brqXq.withModifiers)(($event)=>$options.RemovePhotoFromList(i), [
                                                    "prevent"
                                                ])
                                            }, [
                                                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                                    name: "trash",
                                                    size: "1"
                                                })
                                            ], 8, $2fa27f7fdd385af4$var$_hoisted_46)) : (0, $cfZzL.createCommentVNode)("", true)
                                        ], 10, $2fa27f7fdd385af4$var$_hoisted_44);
                                    }), 128)),
                                    (0, $cfZzL.createElementVNode)("div", {
                                        class: "photo-gallery-list-add | flex-none flex items-center justify-center border border-black/10 rounded bg-white",
                                        onClick: _cache[27] || (_cache[27] = (...args)=>$options.ShowFileDialog && $options.ShowFileDialog(...args)),
                                        "data-test": $props.DataTest && `${$props.DataTest}__modal__add_photo`
                                    }, [
                                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                            name: "plus",
                                            size: "1"
                                        })
                                    ], 8, $2fa27f7fdd385af4$var$_hoisted_47)
                                ])) : (0, $cfZzL.createCommentVNode)("", true),
                                (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_48, [
                                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.SelectedPhotoList, (Photo, i)=>{
                                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                            key: Photo.Item.originalName,
                                            class: (0, $4bH2P.normalizeClass)([
                                                "photo-gallery-panel | flex p-5",
                                                {
                                                    "is-selected": $data.SelectedPhotoIndex === i
                                                }
                                            ])
                                        }, [
                                            (0, $cfZzL.createVNode)(_component_PhotoEditor, {
                                                ref_for: true,
                                                ref: "PhotoEditor",
                                                modelValue: Photo.Item,
                                                "onUpdate:modelValue": ($event)=>Photo.Item = $event,
                                                AvatarMode: $props.AvatarMode,
                                                DataTest: `${$props.DataTest}__modal`
                                            }, null, 8, [
                                                "modelValue",
                                                "onUpdate:modelValue",
                                                "AvatarMode",
                                                "DataTest"
                                            ]),
                                            $props.AllowDescription ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_49, [
                                                (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_50, [
                                                    (0, $cfZzL.createElementVNode)("div", {
                                                        class: "form-input form-multiline",
                                                        "data-invalid": Boolean(Photo.ValidationMessage)
                                                    }, [
                                                        $2fa27f7fdd385af4$var$_hoisted_52,
                                                        (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("textarea", {
                                                            id: "selected-photo-description",
                                                            "data-test": $props.DataTest && `${$props.DataTest}__modal__description`,
                                                            "onUpdate:modelValue": ($event)=>Photo.Description = $event,
                                                            onBlur: _cache[28] || (_cache[28] = ($event)=>$options.DescriptionValidate()),
                                                            onKeypress: ($event)=>Photo.ValidationMessage = ""
                                                        }, null, 40, $2fa27f7fdd385af4$var$_hoisted_53), [
                                                            [
                                                                (0, $brqXq.vModelText),
                                                                Photo.Description
                                                            ]
                                                        ]),
                                                        (0, $cfZzL.createElementVNode)("div", $2fa27f7fdd385af4$var$_hoisted_54, (0, $4bH2P.toDisplayString)(Photo.ValidationMessage), 1)
                                                    ], 8, $2fa27f7fdd385af4$var$_hoisted_51)
                                                ]),
                                                $2fa27f7fdd385af4$var$_hoisted_55,
                                                _ctx.ScreenSize <= 1 && !$props.Single && $data.SelectedPhotoList.length > 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                                                    key: 0,
                                                    class: "photo-gallery-remove-photo | mt-5 btn btn-outline-black w-full",
                                                    onClick: _cache[29] || (_cache[29] = (0, $brqXq.withModifiers)(($event)=>$options.RemovePhotoFromList($data.SelectedPhotoIndex), [
                                                        "prevent"
                                                    ])),
                                                    "data-test": $props.DataTest && `${$props.DataTest}__modal__remove_photo`
                                                }, " Usuń zdjęcie ", 8, $2fa27f7fdd385af4$var$_hoisted_56)) : (0, $cfZzL.createCommentVNode)("", true)
                                            ])) : (0, $cfZzL.createCommentVNode)("", true)
                                        ], 2);
                                    }), 128))
                                ])
                            ]),
                            _ctx.ScreenSize > 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_57, [
                                $data.SelectedPhoto && $data.SelectedPhoto.Item.file && !$props.UseCropWindow ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                                    key: 0,
                                    class: "btn-gray btn-small",
                                    onClick: _cache[30] || (_cache[30] = (0, $brqXq.withModifiers)((...args)=>$options.OnRotatePhoto && $options.OnRotatePhoto(...args), [
                                        "prevent"
                                    ]))
                                }, " Obr\xf3ć ")) : (0, $cfZzL.createCommentVNode)("", true),
                                $2fa27f7fdd385af4$var$_hoisted_58,
                                (0, $cfZzL.createElementVNode)("button", {
                                    class: "btn-primary btn",
                                    "data-test": $props.DataTest && `${$props.DataTest}__modal__add_btn`,
                                    onClick: _cache[31] || (_cache[31] = (0, $brqXq.withModifiers)((...args)=>$options.OnGallerySaved && $options.OnGallerySaved(...args), [
                                        "prevent"
                                    ]))
                                }, " Dodaj " + (0, $4bH2P.toDisplayString)($data.SelectedPhotoList.length > 1 ? _ctx.Format.PluralForm($data.SelectedPhotoList.length, [
                                    "zdjęcie",
                                    "zdjęcia",
                                    "zdjęć"
                                ], true) : ""), 9, $2fa27f7fdd385af4$var$_hoisted_59)
                            ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2fa27f7fdd385af4$var$_hoisted_60, [
                                $data.SelectedPhoto && $data.SelectedPhoto.Item.file && !$props.UseCropWindow ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                                    key: 0,
                                    class: "mr-3 btn btn-gray",
                                    onClick: _cache[32] || (_cache[32] = (0, $brqXq.withModifiers)((...args)=>$options.OnRotatePhoto && $options.OnRotatePhoto(...args), [
                                        "prevent"
                                    ]))
                                }, " Obr\xf3ć ")) : (0, $cfZzL.createCommentVNode)("", true),
                                (0, $cfZzL.createElementVNode)("button", {
                                    class: "w-full btn btn-primary",
                                    "data-test": $props.DataTest && `${$props.DataTest}__modal__add_btn`,
                                    onClick: _cache[33] || (_cache[33] = (0, $brqXq.withModifiers)((...args)=>$options.OnGallerySaved && $options.OnGallerySaved(...args), [
                                        "prevent"
                                    ]))
                                }, " Dodaj " + (0, $4bH2P.toDisplayString)($data.SelectedPhotoList.length > 1 ? _ctx.Format.PluralForm($data.SelectedPhotoList.length, [
                                    "zdjęcie",
                                    "zdjęcia",
                                    "zdjęć"
                                ], true) : ""), 9, $2fa27f7fdd385af4$var$_hoisted_61)
                            ]))
                        ])
                    ], 64)) : (0, $cfZzL.createCommentVNode)("", true)
                ]),
            _: 1
        }, 8, [
            "class",
            "Visible"
        ]),
        (0, $cfZzL.createVNode)(_component_PromptDialog, {
            modelValue: _ctx.CurrentState.CropPhotoConfirmModal,
            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event)=>_ctx.CurrentState.CropPhotoConfirmModal = $event),
            title: "Czy chcesz dodać wybrane zdjęcia?",
            "dismiss-text": "Nie, wyjdź bez dodawania",
            "confirm-text": "Tak, dodaj zdjęcia",
            onDismissed: $options.CloseModalConfirm
        }, null, 8, [
            "modelValue",
            "onDismissed"
        ])
    ], 2);
}

});

parcelRequire.register("25yNQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18570b894ad448f2$export$2e2bcd8739ae039; });
let $18570b894ad448f2$var$NOOP = ()=>{};
var $18570b894ad448f2$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("48DiK", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", function () { return $9f3f205e66d67eee$export$2cdf1b96a9f86d16; });
$parcel$export(module.exports, "shareUrl", function () { return $9f3f205e66d67eee$export$1e123b158203636f; });
$parcel$export(module.exports, "downloadUrl", function () { return $9f3f205e66d67eee$export$8a96edb1c96563f4; });
$parcel$export(module.exports, "GetMailboxUrl", function () { return $9f3f205e66d67eee$export$ec14913271514ab7; });
/**
 * Kopiuje tekst do schowka.
 * @param text Tekst do skopiowania
 */ async function $9f3f205e66d67eee$export$2cdf1b96a9f86d16(text) {
    if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        return;
    }
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
}
function $9f3f205e66d67eee$export$1e123b158203636f(url, title) {
    if (window.navigator.share && window.innerWidth < 768) {
        window.navigator.share({
            title: title,
            text: "",
            url: url
        });
        return true;
    }
    return false;
}
function $9f3f205e66d67eee$export$8a96edb1c96563f4(url, filename) {
    const link = document.createElement("a");
    link.href = url;
    if (filename) link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function $9f3f205e66d67eee$export$ec14913271514ab7(s) {
    if (!s || s.indexOf("@") === -1) return "";
    s = s.split("@")[1];
    const list = {
        "wp.pl": "profil.wp.pl",
        "wp.eu": "profil.wp.pl",
        "poczta.wp.pl": "profil.wp.pl",
        "xl.wp.pl": "profil.wp.pl",
        "gmail.com": "gmail.com",
        "googlemail.com": "gmail.com",
        "o2.pl": "poczta.o2.pl",
        "prokonto.pl": "poczta.o2.pl",
        "go2.pl": "poczta.o2.pl",
        "tlen.pl": "poczta.o2.pl",
        "interia.pl": "poczta.interia.pl",
        "interia.eu": "poczta.interia.pl",
        "interia.com": "poczta.interia.pl",
        "onet.pl": "konto.onet.pl",
        "op.pl": "konto.onet.pl",
        "buziaczek.pl": "konto.onet.pl",
        "amorki.pl": "konto.onet.pl",
        "poczta.onet.eu": "konto.onet.pl",
        "poczta.onet.pl": "konto.onet.pl",
        "onet.eu": "konto.onet.pl",
        "autograf.pl": "konto.onet.pl",
        "vip.onet.pl": "konto.onet.pl",
        "spoko.pl": "konto.onet.pl",
        "onet.com.pl": "konto.onet.pl",
        "vp.pl": "konto.onet.pl",
        "adres.pl": "konto.onet.pl",
        "opoczta.pl": "konto.onet.pl",
        "outlook.com": "outlook.live.com",
        "hotmail.com": "outlook.live.com",
        "gazeta.pl": "oauth.gazeta.pl",
        "g.pl": "oauth.gazeta.pl",
        "yahoo.com": "login.yahoo.com",
        "yahoo.pl": "login.yahoo.com",
        "yahoo.co.uk": "login.yahoo.com",
        "icloud.com": "icloud.com",
        "neostrada.pl": "webmail.neostrada.pl",
        "mail.ru": "mail.ru",
        "bk.ru": "mail.ru",
        "inbox.ru": "mail.ru",
        "yandex.ru": "passport.yandex.ru",
        "ukr.net": "mail.ukr.net",
        "post.pl": "login.poczta.home.pl",
        "home.pl": "login.poczta.home.pl",
        "data.pl": "login.poczta.home.pl",
        "list.pl": "login.poczta.home.pl",
        "rambler.ru": "games.rambler.ru",
        "orange.pl": "poczta.orange.pl",
        "int.pl": "int.pl",
        "gmx.de": "gmx.de"
    };
    return list[s] ? `//${list[s]}` : "Nie znaleziono serwisu pocztowego dla tego adresu email";
}

});


parcelRequire.register("1t64i", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $111d34e7e8b43683$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $111d34e7e8b43683$var$_hoisted_1 = [
    "autocomplete"
];
const $111d34e7e8b43683$var$_hoisted_2 = [
    "onClick",
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_3 = [
    "id",
    "data-checked",
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_4 = {
    key: 0,
    class: "form-input-checkbox"
};
const $111d34e7e8b43683$var$_hoisted_5 = {
    class: "input-control"
};
const $111d34e7e8b43683$var$_hoisted_6 = [
    "id",
    "onUpdate:modelValue",
    "data-test",
    "disabled",
    "onChange"
];
const $111d34e7e8b43683$var$_hoisted_7 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "i"
}, null, -1);
const $111d34e7e8b43683$var$_hoisted_8 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_9 = {
    key: 1,
    class: "flex items-center pb-3 border-b form-input-checkbox border-black/10"
};
const $111d34e7e8b43683$var$_hoisted_10 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_11 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("hr", {
    class: "flex-auto w-2"
}, null, -1);
const $111d34e7e8b43683$var$_hoisted_12 = {
    class: "input-control input-control-toggle"
};
const $111d34e7e8b43683$var$_hoisted_13 = [
    "id",
    "onUpdate:modelValue",
    "disabled",
    "data-test",
    "onChange"
];
const $111d34e7e8b43683$var$_hoisted_14 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $111d34e7e8b43683$var$_hoisted_15 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_16 = [
    "id",
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_17 = {
    key: 0,
    class: "flex items-center"
};
const $111d34e7e8b43683$var$_hoisted_18 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_19 = [
    "data-test",
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_20 = {
    key: 0
};
const $111d34e7e8b43683$var$_hoisted_21 = [
    "id",
    "onUpdate:modelValue",
    "type",
    "disabled",
    "placeholder",
    "maxlength",
    "data-test",
    "onKeydown",
    "onChange"
];
const $111d34e7e8b43683$var$_hoisted_22 = {
    key: 2,
    class: "absolute top-0 bottom-0 right-0 flex items-center justify-center mx-4 text-neutral-700"
};
const $111d34e7e8b43683$var$_hoisted_23 = [
    "for"
];
const $111d34e7e8b43683$var$_hoisted_24 = {
    key: 0,
    class: "text-danger mr-1"
};
const $111d34e7e8b43683$var$_hoisted_25 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_26 = {
    key: 0,
    class: "ml-auto opacity-75"
};
const $111d34e7e8b43683$var$_hoisted_27 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_28 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_29 = [
    "id",
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_30 = {
    class: "relative flex"
};
const $111d34e7e8b43683$var$_hoisted_31 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("hr", {
    style: {
        "flex": "0 0 8px"
    }
}, null, -1);
const $111d34e7e8b43683$var$_hoisted_32 = [
    "for"
];
const $111d34e7e8b43683$var$_hoisted_33 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_34 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_35 = [
    "id",
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_36 = {
    class: "relative"
};
const $111d34e7e8b43683$var$_hoisted_37 = {
    class: "input p-input text-info"
};
const $111d34e7e8b43683$var$_hoisted_38 = [
    "href",
    "data-test"
];
const $111d34e7e8b43683$var$_hoisted_39 = [
    "onClick"
];
const $111d34e7e8b43683$var$_hoisted_40 = [
    "for",
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_41 = [
    "id",
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_42 = {
    key: 0,
    class: "flex items-center"
};
const $111d34e7e8b43683$var$_hoisted_43 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_44 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_45 = {
    key: 1,
    class: "relative"
};
const $111d34e7e8b43683$var$_hoisted_46 = {
    class: "flex items-center editInput"
};
const $111d34e7e8b43683$var$_hoisted_47 = [
    "id",
    "onUpdate:modelValue",
    "type",
    "disabled",
    "placeholder",
    "maxlength",
    "onChange",
    "data-test"
];
const $111d34e7e8b43683$var$_hoisted_48 = [
    "data-test"
];
const $111d34e7e8b43683$var$_hoisted_49 = [
    "for"
];
const $111d34e7e8b43683$var$_hoisted_50 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_51 = {
    key: 0,
    class: "ml-auto opacity-75"
};
const $111d34e7e8b43683$var$_hoisted_52 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_53 = [
    "id",
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_54 = {
    key: 0,
    class: "form-input-value"
};
const $111d34e7e8b43683$var$_hoisted_55 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_56 = {
    key: 1,
    class: "form-input-group"
};
const $111d34e7e8b43683$var$_hoisted_57 = {
    class: "relative"
};
const $111d34e7e8b43683$var$_hoisted_58 = [
    "for",
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_59 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_60 = [
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_61 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_62 = [
    "id",
    "onUpdate:modelValue",
    "disabled",
    "placeholder",
    "onChange",
    "data-test"
];
const $111d34e7e8b43683$var$_hoisted_63 = [
    "for"
];
const $111d34e7e8b43683$var$_hoisted_64 = {
    class: "flex"
};
const $111d34e7e8b43683$var$_hoisted_65 = {
    key: 0,
    class: "text-danger mr-1"
};
const $111d34e7e8b43683$var$_hoisted_66 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_67 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("hr", {
    class: "flex-auto"
}, null, -1);
const $111d34e7e8b43683$var$_hoisted_68 = [
    "data-test",
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_69 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_70 = {
    key: 0,
    class: "form-input-value"
};
const $111d34e7e8b43683$var$_hoisted_71 = {
    key: 0
};
const $111d34e7e8b43683$var$_hoisted_72 = {
    key: 1,
    class: "form-input-group form-input-nip"
};
const $111d34e7e8b43683$var$_hoisted_73 = {
    class: "relative"
};
const $111d34e7e8b43683$var$_hoisted_74 = [
    "id",
    "onUpdate:modelValue",
    "data-test",
    "disabled",
    "onKeydown",
    "onChange"
];
const $111d34e7e8b43683$var$_hoisted_75 = [
    "for",
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_76 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_77 = {
    key: 2,
    class: "[ form-input-validation ] text-neutral-700 text-xs mt-2"
};
const $111d34e7e8b43683$var$_hoisted_78 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("a", {
    href: "https://www.oferteo.pl/kontakt.html",
    target: "_blank",
    class: "page-link"
}, "Biurem obsługi Klienta", -1);
const $111d34e7e8b43683$var$_hoisted_79 = [
    "data-invalid"
];
const $111d34e7e8b43683$var$_hoisted_80 = {
    key: 0,
    class: "form-input-value"
};
const $111d34e7e8b43683$var$_hoisted_81 = {
    key: 0
};
const $111d34e7e8b43683$var$_hoisted_82 = [
    "for",
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_83 = [
    "innerHTML"
];
const $111d34e7e8b43683$var$_hoisted_84 = [
    "data-test"
];
const $111d34e7e8b43683$var$_hoisted_85 = [
    "data-test"
];
const $111d34e7e8b43683$var$_hoisted_86 = {
    class: "input-control"
};
const $111d34e7e8b43683$var$_hoisted_87 = [
    "onUpdate:modelValue",
    "value",
    "onChange"
];
const $111d34e7e8b43683$var$_hoisted_88 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
function $111d34e7e8b43683$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_autocomplete = (0, $cfZzL.resolveComponent)("autocomplete");
    const _component_DatePicker = (0, $cfZzL.resolveComponent)("DatePicker");
    const _component_TimePicker = (0, $cfZzL.resolveComponent)("TimePicker");
    const _component_DropdownSelect = (0, $cfZzL.resolveComponent)("DropdownSelect");
    const _component_NipInput = (0, $cfZzL.resolveComponent)("NipInput");
    const _component_LocationInput = (0, $cfZzL.resolveComponent)("LocationInput");
    const _component_PhotoGallery = (0, $cfZzL.resolveComponent)("PhotoGallery");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("form", {
        "data-component": "FormGroup.vue",
        class: (0, $4bH2P.normalizeClass)([
            "[ form-group ] [&>*:first-child]:!mt-0",
            {
                "is-readonly": _ctx.Readonly,
                "text-neutral-700": _ctx.Readonly,
                "is-editable": !_ctx.Readonly,
                "is-multicolumn": _ctx.ScreenSize > 1,
                "p-5": !_ctx.noPadding
            }
        ]),
        autocomplete: _ctx.PreventAutocomplete ? "off" : ""
    }, [
        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(_ctx.Form, (Field, Index)=>{
            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, [
                !Field.Display || Field.Display !== "none" && Field.Display === "edit" && !_ctx.Readonly || Field.Display === "not-empty" && (!_ctx.Readonly || _ctx.Readonly && Field.Value) ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                    key: 0
                }, [
                    Field.Type === "Static" ? (0, $cfZzL.renderSlot)(_ctx.$slots, Field.Name, {
                        key: 0
                    }, ()=>[
                            ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                key: Index,
                                class: (0, $4bH2P.normalizeClass)(Field.Class),
                                onClick: ($event)=>_ctx.OnStaticClick(Field, $event),
                                innerHTML: Field.Value
                            }, null, 10, $111d34e7e8b43683$var$_hoisted_2))
                        ]) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "Var" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: Index,
                        hidden: ""
                    }, (0, $4bH2P.toDisplayString)(Field.Name + ": " + Field.Value), 1)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "Boolean" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        id: Field.Name + "-wrapper",
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-checked": Field.Value,
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        !Field.Toggle ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("label", $111d34e7e8b43683$var$_hoisted_4, [
                            (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_5, [
                                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                    id: Field.Name,
                                    "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                    type: "checkbox",
                                    "data-test": Field.DataTest,
                                    disabled: Field.Disabled,
                                    onChange: ($event)=>{
                                        _ctx.SetAsDirty(Field, $event);
                                        _ctx.OnInput(Field, $event);
                                    }
                                }, null, 40, $111d34e7e8b43683$var$_hoisted_6), [
                                    [
                                        (0, $brqXq.vModelCheckbox),
                                        Field.Value
                                    ]
                                ]),
                                $111d34e7e8b43683$var$_hoisted_7
                            ]),
                            (0, $cfZzL.createElementVNode)("span", {
                                innerHTML: Field.Label
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_8)
                        ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("label", $111d34e7e8b43683$var$_hoisted_9, [
                            (0, $cfZzL.renderSlot)(_ctx.$slots, `${Field.Name}Label`, {}, ()=>[
                                    (0, $cfZzL.createElementVNode)("span", {
                                        innerHTML: Field.Label
                                    }, null, 8, $111d34e7e8b43683$var$_hoisted_10)
                                ]),
                            $111d34e7e8b43683$var$_hoisted_11,
                            (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_12, [
                                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                    id: Field.Name,
                                    "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                    disabled: Field.Disabled,
                                    "data-test": Field.DataTest,
                                    type: "checkbox",
                                    onChange: ($event)=>{
                                        _ctx.SetAsDirty(Field, $event);
                                        _ctx.OnInput(Field, $event);
                                    }
                                }, null, 40, $111d34e7e8b43683$var$_hoisted_13), [
                                    [
                                        (0, $brqXq.vModelCheckbox),
                                        Field.Value
                                    ]
                                ]),
                                $111d34e7e8b43683$var$_hoisted_14
                            ])
                        ])),
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "[ form-input-validation ] text-danger text-xs mt-2",
                            innerHTML: Field.ValidationMessage
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_15)
                    ], 10, $111d34e7e8b43683$var$_hoisted_3)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "Input" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        id: Field.Name + "-wrapper",
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        _ctx.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_17, [
                            typeof Field.Emblem === "string" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("i", {
                                key: 0,
                                class: "mr-2 form-input-emblem text-neutral-700 icon-size-3",
                                innerHTML: Field.Emblem
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_18)) : (0, $cfZzL.createCommentVNode)("", true),
                            Field.Emblem ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                                key: 1,
                                size: "1.75",
                                class: "mr-2",
                                name: Field.Emblem.Name
                            }, null, 8, [
                                "name"
                            ])) : (0, $cfZzL.createCommentVNode)("", true),
                            (0, $cfZzL.createElementVNode)("span", {
                                class: "form-input-value",
                                "data-test": Field.DataTest,
                                innerHTML: Field.Value ? Field.Value : "(brak)"
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_19)
                        ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 1,
                            class: (0, $4bH2P.normalizeClass)([
                                "relative",
                                {
                                    "is-password-field": _ctx.GetFieldInputType(Field) === "password"
                                }
                            ])
                        }, [
                            Field.Autocomplete ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_20, [
                                (0, $cfZzL.createVNode)(_component_autocomplete, {
                                    ref_for: true,
                                    ref: Field.Name,
                                    modelValue: Field.Value,
                                    "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                    Autocomplete: Field.Autocomplete,
                                    Suggestions: Field.Suggestions,
                                    IgnoreValues: Field.IgnoreValues,
                                    onInput: ($event)=>_ctx.OnInput(Field, $event)
                                }, null, 8, [
                                    "modelValue",
                                    "onUpdate:modelValue",
                                    "Autocomplete",
                                    "Suggestions",
                                    "IgnoreValues",
                                    "onInput"
                                ])
                            ])) : (0, $cfZzL.withDirectives)(((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("input", {
                                key: 1,
                                id: Field.Name,
                                "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                type: _ctx.GetFieldInputType(Field),
                                class: (0, $4bH2P.normalizeClass)({
                                    "!pl-12": Field.HelperIcon
                                }),
                                disabled: Field.Disabled,
                                placeholder: Field.Placeholder,
                                maxlength: Field.Max,
                                "data-test": Field.DataTest,
                                onKeydown: ($event)=>_ctx.OnKeyDown(Field, $event),
                                onKeyup: _cache[0] || (_cache[0] = (...args)=>_ctx.SetAsDirty && _ctx.SetAsDirty(...args)),
                                onMousewheel: _cache[1] || (_cache[1] = (0, $brqXq.withModifiers)(()=>{}, [
                                    "prevent"
                                ])),
                                onChange: ($event)=>_ctx.OnInput(Field, $event)
                            }, null, 42, $111d34e7e8b43683$var$_hoisted_21)), [
                                [
                                    (0, $brqXq.vModelDynamic),
                                    Field.Value
                                ]
                            ]),
                            Field.Currency ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_22, " zł ")) : (0, $cfZzL.createCommentVNode)("", true),
                            _ctx.GetFieldInputType(Field) === "password" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                key: 3,
                                class: "form-input-password-toggle | absolute right-0 top-0 p-4 text-neutral",
                                onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.TogglePassword && _ctx.TogglePassword(...args))
                            }, [
                                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                    class: "form-input-password-toggle-on",
                                    size: "1.5",
                                    name: "eye-outlined-on"
                                }),
                                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                    class: "form-input-password-toggle-off",
                                    size: "1.5",
                                    name: "eye-outlined-off"
                                })
                            ])) : (0, $cfZzL.createCommentVNode)("", true),
                            Field.Icon ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                                key: 4,
                                class: (0, $4bH2P.normalizeClass)([
                                    "absolute -translate-y-1/2 right-4 top-1/2 text-accent",
                                    {
                                        "cursor-pointer": Field.IconAction
                                    }
                                ]),
                                onClick: Field.IconAction,
                                name: Field.Icon
                            }, null, 8, [
                                "class",
                                "onClick",
                                "name"
                            ])) : (0, $cfZzL.createCommentVNode)("", true),
                            Field.HelperIcon ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, (0, $cfZzL.mergeProps)({
                                key: 5
                            }, Field.HelperIcon, {
                                class: "absolute top-0 left-0 m-4 pointer-events-none text-neutral",
                                size: 1.5
                            }), null, 16)) : (0, $cfZzL.createCommentVNode)("", true)
                        ], 2)),
                        (0, $cfZzL.createElementVNode)("label", {
                            for: Field.Name,
                            class: "flex items-center form-input-label"
                        }, [
                            (0, $cfZzL.renderSlot)(_ctx.$slots, `${Field.Name}Label`, {}, ()=>[
                                    Field.Required ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("span", $111d34e7e8b43683$var$_hoisted_24, "*")) : (0, $cfZzL.createCommentVNode)("", true),
                                    (0, $cfZzL.createElementVNode)("div", {
                                        class: "pr-2",
                                        innerHTML: Field.Label
                                    }, null, 8, $111d34e7e8b43683$var$_hoisted_25)
                                ]),
                            !_ctx.Readonly && Field.DisplayCount ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_26, (0, $4bH2P.toDisplayString)(Field.Max ? Field.Max - Field.Value.length : Field.Value.length), 1)) : (0, $cfZzL.createCommentVNode)("", true)
                        ], 8, $111d34e7e8b43683$var$_hoisted_23),
                        Field.Hint ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 2,
                            class: "form-input-validation form-input-hint | text-neutral-700 text-xs mt-2",
                            innerHTML: Field.Hint
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_27)) : (0, $cfZzL.createCommentVNode)("", true),
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "[ form-input-validation ] text-danger text-xs mt-2",
                            innerHTML: Field.ValidationMessage
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_28)
                    ], 10, $111d34e7e8b43683$var$_hoisted_16)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "DateTime" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        id: Field.Name + "-wrapper",
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_30, [
                            (0, $cfZzL.createVNode)(_component_DatePicker, {
                                id: Field.Name + "date",
                                modelValue: Field.Value[0],
                                "onUpdate:modelValue": [
                                    ($event)=>Field.Value[0] = $event,
                                    ($event)=>_ctx.OnInput(Field, $event)
                                ],
                                value: Field.Value[0],
                                Disabled: Field.Disabled,
                                Min: Field.Min || "2020-01-01"
                            }, null, 8, [
                                "id",
                                "modelValue",
                                "onUpdate:modelValue",
                                "value",
                                "Disabled",
                                "Min"
                            ]),
                            $111d34e7e8b43683$var$_hoisted_31,
                            Field.Time ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_TimePicker, {
                                key: 0,
                                id: Field.Name + "date2",
                                modelValue: Field.Value[1],
                                "onUpdate:modelValue": [
                                    ($event)=>Field.Value[1] = $event,
                                    ($event)=>_ctx.OnInput(Field, $event)
                                ],
                                value: Field.Value[1],
                                Disabled: Field.Disabled
                            }, null, 8, [
                                "id",
                                "modelValue",
                                "onUpdate:modelValue",
                                "value",
                                "Disabled"
                            ])) : (0, $cfZzL.createCommentVNode)("", true)
                        ]),
                        (0, $cfZzL.createElementVNode)("label", {
                            for: Field.Name,
                            class: "flex items-center form-input-label"
                        }, [
                            (0, $cfZzL.createElementVNode)("div", {
                                innerHTML: Field.Label
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_33)
                        ], 8, $111d34e7e8b43683$var$_hoisted_32),
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "[ form-input-validation ] text-danger text-xs mt-2",
                            innerHTML: Field.ValidationMessage
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_34)
                    ], 10, $111d34e7e8b43683$var$_hoisted_29)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "CopyLink" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        id: Field.Name + "-wrapper",
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_36, [
                            (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_37, [
                                (0, $cfZzL.createElementVNode)("a", {
                                    href: Field.Value,
                                    target: "_blank",
                                    rel: "noopener",
                                    "data-test": Field.DataTest
                                }, (0, $4bH2P.toDisplayString)(Field.Value), 9, $111d34e7e8b43683$var$_hoisted_38)
                            ]),
                            (0, $cfZzL.createElementVNode)("button", {
                                class: "absolute right-0 ml-auto",
                                style: {
                                    "top": "50%",
                                    "margin-right": "8px",
                                    "transform": "translateY(-50%)"
                                },
                                onClick: (0, $brqXq.withModifiers)(($event)=>_ctx.CopyLink(Field.Value), [
                                    "prevent"
                                ])
                            }, [
                                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                    class: "text-neutral-700",
                                    name: "copy"
                                })
                            ], 8, $111d34e7e8b43683$var$_hoisted_39)
                        ]),
                        (0, $cfZzL.createElementVNode)("label", {
                            for: Field.Name,
                            class: "flex items-center form-input-label",
                            innerHTML: Field.Label
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_40)
                    ], 10, $111d34e7e8b43683$var$_hoisted_35)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "Email-Input" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        id: Field.Name + "-wrapper",
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        _ctx.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_42, [
                            Field.Emblem ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("i", {
                                key: 0,
                                class: "mr-2 form-input-emblem text-neutral-700 icon-size-3",
                                innerHTML: Field.Emblem
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_43)) : (0, $cfZzL.createCommentVNode)("", true),
                            (0, $cfZzL.createElementVNode)("span", {
                                class: "form-input-value",
                                innerHTML: Field.Value ? Field.Value : "(brak)"
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_44)
                        ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_45, [
                            (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_46, [
                                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                    id: Field.Name,
                                    "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                    style: {
                                        "border": "none",
                                        "color": "black"
                                    },
                                    type: _ctx.GetFieldInputType(Field),
                                    disabled: Field.Disabled,
                                    placeholder: Field.Placeholder,
                                    maxlength: Field.Max,
                                    onKeyup: _cache[3] || (_cache[3] = (...args)=>_ctx.SetAsDirty && _ctx.SetAsDirty(...args)),
                                    onMousewheel: _cache[4] || (_cache[4] = (0, $brqXq.withModifiers)(()=>{}, [
                                        "prevent"
                                    ])),
                                    onChange: ($event)=>_ctx.OnInput(Field, $event),
                                    "data-test": `${Field.DataTest}__input`
                                }, null, 40, $111d34e7e8b43683$var$_hoisted_47), [
                                    [
                                        (0, $brqXq.vModelDynamic),
                                        Field.Value
                                    ]
                                ]),
                                (0, $cfZzL.createElementVNode)("a", {
                                    class: "px-2 geolocate-icon hover:text-accent",
                                    "data-test": `${Field.DataTest}__zmien`,
                                    onClick: _cache[5] || (_cache[5] = (...args)=>_ctx.HandleClickEvent && _ctx.HandleClickEvent(...args))
                                }, "Zmień", 8, $111d34e7e8b43683$var$_hoisted_48)
                            ])
                        ])),
                        (0, $cfZzL.createElementVNode)("label", {
                            for: Field.Name,
                            class: "flex items-center form-input-label"
                        }, [
                            (0, $cfZzL.createElementVNode)("div", {
                                class: "pr-2",
                                innerHTML: Field.Label
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_50),
                            !_ctx.Readonly && Field.DisplayCount ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_51, (0, $4bH2P.toDisplayString)(Field.Max ? Field.Max - Field.Value.length : Field.Value.length), 1)) : (0, $cfZzL.createCommentVNode)("", true)
                        ], 8, $111d34e7e8b43683$var$_hoisted_49),
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "[ form-input-validation ] text-danger text-xs mt-2",
                            innerHTML: Field.ValidationMessage
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_52)
                    ], 10, $111d34e7e8b43683$var$_hoisted_41)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "Select" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        id: Field.Name + "-wrapper",
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        _ctx.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_54, [
                            (0, $cfZzL.createElementVNode)("span", {
                                class: "form-input-value",
                                innerHTML: Field.Value ? Field.Value : "(brak)"
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_55)
                        ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_56, [
                            (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_57, [
                                (0, $cfZzL.createVNode)(_component_DropdownSelect, {
                                    id: Field.Name,
                                    modelValue: Field.Value,
                                    "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                    Items: Field.Items || [],
                                    disabled: Field.Disabled,
                                    Placeholder: Field.Placeholder,
                                    class: "w-full px-3 bg-white",
                                    onChange: ($event)=>{
                                        _ctx.SetAsDirty();
                                        _ctx.OnInput(Field, $event);
                                    }
                                }, null, 8, [
                                    "id",
                                    "modelValue",
                                    "onUpdate:modelValue",
                                    "Items",
                                    "disabled",
                                    "Placeholder",
                                    "onChange"
                                ])
                            ])
                        ])),
                        (0, $cfZzL.createElementVNode)("label", {
                            for: Field.Name,
                            class: "form-input-label",
                            innerHTML: Field.Label
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_58),
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "[ form-input-validation ] text-danger text-xs mt-2",
                            innerHTML: Field.ValidationMessage
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_59)
                    ], 10, $111d34e7e8b43683$var$_hoisted_53)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "Multiline" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input form-multiline",
                            Field.Class
                        ]),
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        _ctx.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 0,
                            class: "form-input-value",
                            innerHTML: Field.Value ? Field.Value : ""
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_61)) : (0, $cfZzL.withDirectives)(((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("textarea", {
                            key: 1,
                            id: Field.Name,
                            "onUpdate:modelValue": ($event)=>Field.Value = $event,
                            disabled: Field.Disabled,
                            placeholder: Field.Placeholder,
                            onKeyup: _cache[6] || (_cache[6] = (...args)=>_ctx.SetAsDirty && _ctx.SetAsDirty(...args)),
                            onChange: ($event)=>_ctx.OnInput(Field, $event),
                            "data-test": `${Field.DataTest}__textarea`
                        }, null, 40, $111d34e7e8b43683$var$_hoisted_62)), [
                            [
                                (0, $brqXq.vModelText),
                                Field.Value
                            ]
                        ]),
                        (0, $cfZzL.createElementVNode)("label", {
                            for: Field.Name,
                            class: "flex items-center form-input-label"
                        }, [
                            (0, $cfZzL.renderSlot)(_ctx.$slots, `${Field.Name}Label`),
                            (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_64, [
                                Field.Required ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("span", $111d34e7e8b43683$var$_hoisted_65, "*")) : (0, $cfZzL.createCommentVNode)("", true),
                                (0, $cfZzL.createElementVNode)("div", {
                                    innerHTML: Field.Label
                                }, null, 8, $111d34e7e8b43683$var$_hoisted_66)
                            ]),
                            $111d34e7e8b43683$var$_hoisted_67,
                            !_ctx.Readonly && Field.DisplayCount && Field.Max && Field.Value.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("span", {
                                key: 0,
                                "data-test": `${Field.DataTest}__text_count`,
                                class: (0, $4bH2P.normalizeClass)({
                                    "text-success": Field.Value.length / Field.Max >= 0.05555 && Field.Value.length <= Field.Max,
                                    "text-warn": Field.Value.length / Field.Max > 0.01111 && Field.Value.length / Field.Max < 0.05555,
                                    "text-danger": Field.Value.length / Field.Max <= 0.01111 || Field.Value.length > Field.Max
                                }),
                                innerHTML: Field.Value.length + " / " + Field.Max
                            }, null, 10, $111d34e7e8b43683$var$_hoisted_68)) : (0, $cfZzL.createCommentVNode)("", true)
                        ], 8, $111d34e7e8b43683$var$_hoisted_63),
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "[ form-input-validation ] text-danger text-xs mt-2",
                            innerHTML: Field.ValidationMessage
                        }, null, 8, $111d34e7e8b43683$var$_hoisted_69)
                    ], 10, $111d34e7e8b43683$var$_hoisted_60)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "NipInput" && Field.UseComponent ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_NipInput, {
                        ref_for: true,
                        ref: "formGroupInput",
                        key: `Input${Index}`,
                        modelValue: Field.Value,
                        "onUpdate:modelValue": ($event)=>Field.Value = $event,
                        class: (0, $4bH2P.normalizeClass)(Field.Class),
                        name: Field.Name,
                        dataTest: Field.DataTest,
                        "force-disabled": Field.Disabled,
                        doNotBlock: Field.DoNotBlock,
                        onDirty: _ctx.SetAsDirty
                    }, null, 8, [
                        "modelValue",
                        "onUpdate:modelValue",
                        "class",
                        "name",
                        "dataTest",
                        "force-disabled",
                        "doNotBlock",
                        "onDirty"
                    ])) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "NipInput" && !Field.UseComponent ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ])
                    }, [
                        !_ctx.Readonly || Field.Value[1] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                            key: 0
                        }, [
                            _ctx.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_70, [
                                Field.Value.country[0] !== "PL" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("span", $111d34e7e8b43683$var$_hoisted_71, (0, $4bH2P.toDisplayString)(Field.Value.country.value), 1)) : (0, $cfZzL.createCommentVNode)("", true),
                                (0, $cfZzL.createTextVNode)((0, $4bH2P.toDisplayString)(Field.Value.value), 1)
                            ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_72, [
                                (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_73, [
                                    (0, $cfZzL.createVNode)(_component_DropdownSelect, {
                                        modelValue: Field.Value.country,
                                        "onUpdate:modelValue": ($event)=>Field.Value.country = $event,
                                        Items: _ctx.countriesByCode,
                                        Disabled: Field.Disabled,
                                        onChange: _ctx.SetAsDirty,
                                        "data-test": `${Field.DataTest}__dropdown`
                                    }, null, 8, [
                                        "modelValue",
                                        "onUpdate:modelValue",
                                        "Items",
                                        "Disabled",
                                        "onChange",
                                        "data-test"
                                    ]),
                                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                        id: Field.Name,
                                        "onUpdate:modelValue": ($event)=>Field.Value.value = $event,
                                        type: "text",
                                        placeholder: "0000000000",
                                        "data-test": `${Field.DataTest}__input`,
                                        disabled: Field.Disabled,
                                        onKeyup: _cache[7] || (_cache[7] = (...args)=>_ctx.SetAsDirty && _ctx.SetAsDirty(...args)),
                                        onKeydown: ($event)=>_ctx.OnKeyDown(Field, $event),
                                        onMousewheel: _cache[8] || (_cache[8] = (0, $brqXq.withModifiers)(()=>{}, [
                                            "prevent"
                                        ])),
                                        onChange: ($event)=>_ctx.OnInput(Field, $event)
                                    }, null, 40, $111d34e7e8b43683$var$_hoisted_74), [
                                        [
                                            (0, $brqXq.vModelText),
                                            Field.Value.value
                                        ]
                                    ])
                                ])
                            ])),
                            (0, $cfZzL.createElementVNode)("label", {
                                for: Field.Name,
                                class: "form-input-label",
                                innerHTML: Field.Label
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_75),
                            (0, $cfZzL.createElementVNode)("div", {
                                class: "[ form-input-validation ] text-danger text-xs mt-2",
                                innerHTML: Field.ValidationMessage
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_76),
                            Field.Disabled ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_77, [
                                (0, $cfZzL.createTextVNode)(" Zmiana NIP jest możliwa tylko przez kontakt z "),
                                $111d34e7e8b43683$var$_hoisted_78,
                                (0, $cfZzL.createTextVNode)(" Oferteo.pl. ")
                            ])) : (0, $cfZzL.createCommentVNode)("", true)
                        ], 64)) : (0, $cfZzL.createCommentVNode)("", true)
                    ], 2)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "LocationInput" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-invalid": Boolean(Field.ValidationMessage)
                    }, [
                        _ctx.Readonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_80, [
                            (0, $cfZzL.createTextVNode)((0, $4bH2P.toDisplayString)(Field.Value.City.join(" ")) + " ", 1),
                            Field.Value.Country[0] !== "locationPl" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $111d34e7e8b43683$var$_hoisted_81, (0, $4bH2P.toDisplayString)(Field.Value.Country[1]), 1)) : (0, $cfZzL.createCommentVNode)("", true)
                        ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                            key: 1
                        }, [
                            (0, $cfZzL.createVNode)(_component_LocationInput, {
                                id: Field.Name,
                                ref_for: true,
                                ref: Field.Name,
                                modelValue: Field.Value,
                                "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                onChange: ($event)=>{
                                    _ctx.ValidateField(Field);
                                    _ctx.SetAsDirty(Field, $event);
                                },
                                DataTest: Field.DataTest
                            }, null, 8, [
                                "id",
                                "modelValue",
                                "onUpdate:modelValue",
                                "onChange",
                                "DataTest"
                            ]),
                            (0, $cfZzL.createElementVNode)("label", {
                                for: Field.Name,
                                class: "form-input-label",
                                innerHTML: Field.Label
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_82),
                            (0, $cfZzL.createElementVNode)("div", {
                                class: "[ form-input-validation ] text-danger text-xs mt-2",
                                innerHTML: Field.ValidationMessage
                            }, null, 8, $111d34e7e8b43683$var$_hoisted_83)
                        ], 64))
                    ], 10, $111d34e7e8b43683$var$_hoisted_79)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "PhotoGallery" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ])
                    }, [
                        (0, $cfZzL.createVNode)(_component_PhotoGallery, {
                            modelValue: Field.Value,
                            "onUpdate:modelValue": [
                                ($event)=>Field.Value = $event,
                                ($event)=>_ctx.GalleryChanged($event, "input", Field)
                            ],
                            Readonly: _ctx.Readonly,
                            Upload: Field.Upload,
                            Single: Field.Single,
                            Draggable: Field.Draggable,
                            AllowFiles: Field.AllowFiles,
                            "mark-for-deletion": Field.MarkForDeletion,
                            AvatarMode: Field.AvatarMode,
                            UseCropWindow: Field.UseCrop,
                            AllowDescription: Field.AllowDescription,
                            DataTest: Field.DataTest,
                            onClick: ($event)=>_ctx.GalleryChanged($event, "click", Field),
                            onUpload: ($event)=>_ctx.GalleryChanged($event, "upload", Field)
                        }, null, 8, [
                            "modelValue",
                            "onUpdate:modelValue",
                            "Readonly",
                            "Upload",
                            "Single",
                            "Draggable",
                            "AllowFiles",
                            "mark-for-deletion",
                            "AvatarMode",
                            "UseCropWindow",
                            "AllowDescription",
                            "DataTest",
                            "onClick",
                            "onUpload"
                        ])
                    ], 2)) : (0, $cfZzL.createCommentVNode)("", true),
                    Field.Type === "OptionList" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                        key: Index,
                        class: (0, $4bH2P.normalizeClass)([
                            "form-input",
                            Field.Class
                        ]),
                        "data-test": Field.DataTest
                    }, [
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(Field.Options, (Option, i)=>{
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("label", {
                                key: i,
                                "data-test": Option.dataTest,
                                class: "form-input-checkbox"
                            }, [
                                (0, $cfZzL.createElementVNode)("div", $111d34e7e8b43683$var$_hoisted_86, [
                                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                        "onUpdate:modelValue": ($event)=>Field.Value = $event,
                                        type: "radio",
                                        value: Option.Value,
                                        onChange: ($event)=>_ctx.OnInput(Field, $event)
                                    }, null, 40, $111d34e7e8b43683$var$_hoisted_87), [
                                        [
                                            (0, $brqXq.vModelRadio),
                                            Field.Value
                                        ]
                                    ]),
                                    $111d34e7e8b43683$var$_hoisted_88
                                ]),
                                (0, $cfZzL.createTextVNode)(" " + (0, $4bH2P.toDisplayString)(Option.Label), 1)
                            ], 8, $111d34e7e8b43683$var$_hoisted_85);
                        }), 128))
                    ], 10, $111d34e7e8b43683$var$_hoisted_84)) : (0, $cfZzL.createCommentVNode)("", true)
                ], 64)) : (0, $cfZzL.createCommentVNode)("", true)
            ], 64);
        }), 256)),
        (0, $cfZzL.renderSlot)(_ctx.$slots, "default")
    ], 10, $111d34e7e8b43683$var$_hoisted_1);
}

});

parcelRequire.register("kg3IJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf83019647ceee8$export$2e2bcd8739ae039; });
let $ebf83019647ceee8$var$NOOP = ()=>{};
var $ebf83019647ceee8$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("3x4lF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2927d3abb1ad80fb$export$2e2bcd8739ae039; });
let $2927d3abb1ad80fb$var$script;



let $2927d3abb1ad80fb$var$initialize = ()=>{
    $2927d3abb1ad80fb$var$script = (parcelRequire("lT1uY"));
    if ($2927d3abb1ad80fb$var$script.__esModule) $2927d3abb1ad80fb$var$script = $2927d3abb1ad80fb$var$script.default;
    $2927d3abb1ad80fb$var$script.render = (parcelRequire("hP4uj")).render;
    (parcelRequire("eILAH")).default($2927d3abb1ad80fb$var$script);
    $2927d3abb1ad80fb$var$script.__scopeId = "data-v-f2c2d5";
    $2927d3abb1ad80fb$var$script.__file = "ServicesPage.vue";
};
$2927d3abb1ad80fb$var$initialize();
var $2927d3abb1ad80fb$export$2e2bcd8739ae039 = $2927d3abb1ad80fb$var$script;

});
parcelRequire.register("lT1uY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5af49a3791f09240$export$2e2bcd8739ae039; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");

var $jgrCW = parcelRequire("jgrCW");

var $5UCIl = parcelRequire("5UCIl");

var $lC19C = parcelRequire("lC19C");

var $fQXQ9 = parcelRequire("fQXQ9");

var $eYjM4 = parcelRequire("eYjM4");

var $20lOb = parcelRequire("20lOb");

var $goO1A = parcelRequire("goO1A");






var /** Komponent odpowiedzialny za ekran zmiany oferowanych produktów i usług w sekcji profilowej Mojego Oferteo. */ $5af49a3791f09240$export$2e2bcd8739ae039 = {
    name: "ServicesPage",
    components: {
        PromptDialog: $eYjM4.default,
        FilterList: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("aDsf7"))),
        FilterDetails: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("krrSI"))),
        FilterCreate: (0, $cfZzL.defineAsyncComponent)(()=>Promise.resolve((parcelRequire("2Uxa9")))),
        FilterPricing: (0, $cfZzL.defineAsyncComponent)(()=>Promise.resolve((parcelRequire("kUqgA")))),
        RecommendationFeedbackModal: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("gJk1o"))),
        TenPercentDiscountConfirmationModal: (0, $cfZzL.defineAsyncComponent)(()=>(parcelRequire("5vWva")))
    },
    beforeRouteEnter (to, from, next) {
        to.query = {};
        next();
    },
    beforeRouteUpdate (to, from, next) {
        // Podczas dodawania filtru SK nie pytaj się o zapisanie zmian podczas przechodzenia,
        // ponieważ użytkownik może wtedy zapisać filtr - nawet jeżeli nie wyświetliliśmy mu
        // informacji o tym, że filtr został w ogóle dodany (no i można wtedy ustawić dowolną
        // cenę za kontakt).
        if (from.params.filterId === "dodaj-sk") this.isFilterDirty = false;
        if (this.displaySaveChanges) this.backWithNoSaving(false);
        // Jeżeli filtr został zmodyfikowany, wyświetl pytanie o zapisanie zmian
        // w momencie, kiedy użytkownik chce się cofnąć.
        if (this.isFilterDirty && to.name !== "FilterDetailsQuickMatching" && to.name !== "FilterDetailsQuickLocation" && to.name !== "FilterDetailsAutomaticMatching" && to.name !== "FilterDetailsAutomaticLocation") this.displaySaveChanges = true;
        if (this.displaySaveChanges) {
            next(false);
            return;
        }
        if (to.name === "FilterDetailsAutomatic" || to.name === "FilterDetailsQuick" || to.name === "FilterDetailsMatching") {
            this.isEditLocations = false;
            this.isEditMatching = false;
        }
        if (to.name === "FilterListItem") {
            this.isEditLocations = false;
            this.isEditMatching = false;
            this.isInsideFilterDetails = false;
            this.currentPage = "";
        }
        if (to.name === "Services") {
            this.isInsideFilterDetails = false;
            this.isEditLocations = false;
            this.isEditMatching = false;
            this.selectedCategoryGroupId = 0;
            this.currentPage = "";
        }
        next();
    },
    data () {
        return {
            /**
			 * Główny obiekt usług
			 */ services: {
                locations: {},
                tree: [],
                stats: {},
                userActivityStats: {
                    userActivityLoaded: false,
                    userActivityDays: 30,
                    matchedRfps: 0,
                    boughtRfps: 0,
                    matchedInstantRfps: 0
                },
                customer: {
                    extendedLimit: true
                },
                contactPersons: [],
                operators: [],
                selectedFilters: []
            },
            /**
			 * Nazwa typu filtru do sklonowania
			 */ itemType: "",
            /**
			 * Wynik funkcji `process` z przetworzonym na postać
			 * frontendową filtrem
			 */ processResult: {},
            /**
			 * Czy obecnie jest przeprowadzana operacja zapisu filtra?
			 */ isSavingCompleted: true,
            /**
			 * Nazwa firmy dla której wyświetlone są filtry
			 */ companyName: "",
            /**
			 * Szablon filtra potrzebny do ustawienia lokalizacji
			 * podczas dodawania wielu filtrów
			 */ filterTemplate: undefined
        };
    },
    computed: {
        ...(0, $jgrCW.mapStores)((0, $20lOb.useLocationStore)),
        ...(0, $jgrCW.mapState)((0, $lC19C.useAppStore), [
            "isAdminModule"
        ]),
        ...(0, $jgrCW.mapState)((0, $fQXQ9.useCustomerProfileViewStore), [
            "isInRecommendationPromotion",
            "isInApPromotionalCampaign"
        ]),
        ...(0, $jgrCW.mapState)((0, $5UCIl.useServicesStore), [
            "selectedFilterIndex",
            "customerId"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $5UCIl.useServicesStore), [
            "currentPage",
            "displaySaveChanges",
            "filterToRemove",
            "isEditMatching",
            "isEditLocations",
            "isFilterDirty",
            "isInsideFilterDetails",
            "groupsToRemove",
            "selectedCategoryGroupId",
            "isFreshCategory",
            "isNewCategory",
            "pricingCategoryId",
            "isRecommendationFeedbackModalVisible",
            "invalidStats",
            "isLoading",
            "visibilityTenPercentDiscountConfirmationModal",
            "potentialMatches"
        ]),
        /**
		 * Obecnie edytowany filtr
		 */ selectedFilter () {
            return this.services.selectedFilters[this.selectedFilterIndex || 0];
        },
        /**
		 * Znajduje filtr z najwyższym ID (czyli najprawdopodobniej ostatnio dodany).
		 */ lastAddedFilter () {
            let categoryIndex = 0;
            let filterIndex = 0;
            let maxFilterId = 0;
            this.services.tree.forEach(({ filters: filters }, cIndex)=>{
                filters.forEach((filter, fIndex)=>{
                    if (filter.id > maxFilterId) {
                        maxFilterId = filter.id;
                        categoryIndex = cIndex;
                        filterIndex = fIndex;
                    }
                });
            });
            return this.services.tree[categoryIndex].filters[filterIndex];
        },
        /**
		 * Początek ścieżki do API.
		 */ apiNamespace () {
            return this.isAdminModule ? "admin" : "myoferteo";
        }
    },
    mounted () {
        this.inApPromotionalCampaign();
        this.loadData();
        this.sendAnalyticsEvent("Main_Show", "show");
    },
    methods: {
        ...(0, $jgrCW.mapActions)((0, $fQXQ9.useCustomerProfileViewStore), [
            "inApPromotionalCampaign"
        ]),
        ...(0, $jgrCW.mapActions)((0, $lC19C.useAppStore), [
            "hasFlag"
        ]),
        /**
		 * Dokonuje zapisu wielu filtrów na raz
		 * @param baseFilter Filtr, z którego będą pobierane informacje.
		 * @param ids Tablica identyfikatorów filtrów do zmiany
		 * @param mode Które dane mają zostać edytowane? `edit` - dopasowanie zleceń, `location` - lokalizacje
		 */ async multiSaveFilter (baseFilter, ids, mode) {
            for (const id of ids){
                const rsvp = await (0, $goO1A.default)(`/${this.apiNamespace}/get-filter-details.ofer?idCustomer=${this.customerId}&matchingFilter.id=${id}`);
                const processed = this.process({
                    filterDetails: rsvp.filter[0]
                });
                if (!processed) continue;
                if (mode === "edit") [
                    "contractors",
                    "investors",
                    "subcontractors",
                    "discounted",
                    "individuals",
                    "notConfirmedBySms"
                ].forEach((key)=>{
                    processed.filterTypes[key] = baseFilter.filterTypes[key];
                });
                if (mode === "location" && processed.location && baseFilter.location) processed.location.selected = baseFilter.location.selected;
                await this.saveFilter(processed);
            }
            window.setTimeout(async ()=>{
                this.displaySaveChanges = false;
                this.isFilterDirty = false;
                this.currentPage = "";
                this.$router.back();
                await this.getServicesList();
            }, 1000);
        },
        /**
		 * Akcja wywoływana podczas kliknięcia przycisku zapisania zmian.
		 * Może ona być wywołana z poziomu szczegółów fitlra (dolny przycisk)
		 * lub z okna dialogowego: w tym przypadku należy cofnąć się dwukrotnie,
		 * aby pominąć wyświetlenie się tego okna.
		 * @param source Źródło kliknięcia przycisku.
		 */ async onSaveButtonClicked ({ source: source, saveForAllLocations: saveForAllLocations }) {
            const { selectedFilter: selectedFilter } = this;
            // Edycja wielu filtrów na raz
            if (String(selectedFilter.id).indexOf(",") > -1) {
                if (source.indexOf("multi-") > -1) await this.multiSaveFilter(selectedFilter, selectedFilter.id.split(","), source.split("-")[1]);
                return;
            }
            // Zapisz filtr, jeżeli nie dotyczy to strony z cenami.
            const pricing = this.$refs.FilterPricing;
            if (!pricing) {
                var _selectedFilter_location;
                // Jeżeli filtr nie ma ustawionych lokalizacji, wyświetl komunikat walidacyjny.
                const noLocationsSelected = (selectedFilter === null || selectedFilter === void 0 ? void 0 : (_selectedFilter_location = selectedFilter.location) === null || _selectedFilter_location === void 0 ? void 0 : _selectedFilter_location.selected.length) === 0;
                if (noLocationsSelected) {
                    this.Toast.Show({
                        Message: "Usługa musi mieć wybraną lokalizację",
                        Style: "fail"
                    });
                    return;
                }
                // W innym przypadku zapisz filtr.
                await this.saveFilter(selectedFilter, false, saveForAllLocations);
                setTimeout(()=>{
                    this.loadData();
                }, 1000);
            } else {
                const pricingSave = await pricing.savePrice();
                if (!pricingSave) {
                    this.displaySaveChanges = false;
                    this.isFilterDirty = false;
                    this.currentPage = "";
                    this.$router.back();
                    return;
                }
            }
            this.displaySaveChanges = false;
            this.isFilterDirty = false;
            this.currentPage = "";
            this.$router.back();
            // Wyślij analitykę
            // TODO: Rozróżnienie pomiędzy Edit_Details, Location, Matching, Price
            this.sendAnalyticsEvent("Edit_Save", "edit_save");
        },
        /**
		 * Dodaje kategorie, a następnie przenosi użytkownika na widok jej szczegółów.
		 * @param categoryIds Tablica z identyfikatorami kategorii do wstawienia
		 * @param location    Tablica z identyfikatorami lokalizacji.
		 *                    Jeżeli jest pusta - weź ją z ostatnio dodanego filtra.
		 */ async onFilterCreate (e) {
            const { categoryIds: categoryIds, location: location } = e;
            // TODO: Czy nie było metody, która dodaje kilka filtrów na raz?
            for (const id of categoryIds){
                const filter = await this.getFilterTemplate(id, location || [], false);
                if (filter) await this.saveFilter(filter, true);
            }
            window.setTimeout(async ()=>{
                this.currentPage = "";
                if (this.isAdminModule) this.$router.push({
                    name: "Services"
                });
                else {
                    // Przejdź do wybranego filtra
                    [this.selectedCategoryGroupId] = categoryIds;
                    this.isFreshCategory = true;
                    this.$router.push({
                        name: "FilterListItem",
                        params: {
                            categoryId: categoryIds[0]
                        }
                    });
                }
            }, 150);
        },
        /**
		 * Pobiera filtr z wartościami z poprzednio dodanego filtra, oraz przypisuje mu
		 * kategorię oraz ustawia lokalizacje.
		 * @param categoryId Kategoria do ustawienia
		 * @param location   Tablica z identyfikatorami lokalizacji.
		 *                   Jeżeli jest pusta - weź ją z ostatnio dodanego filtra.
		 * @param assign     Przypisz filtr do zmiennej `filterTemplate`
		 */ async getFilterTemplate (categoryId = 1, location = [], assign = false) {
            const url = `/myoferteo/get-new-filter.ofer?matchingFilter.idCustomer=${this.customerId}&matchingFilter.categories=`;
            const rsvp = await (0, $goO1A.default)(`${url}${categoryId}`);
            const filter = this.process({
                filterDetails: rsvp
            });
            if (filter) {
                filter.location = {
                    selected: location.length ? location : rsvp.filterLocations.map((l)=>l.idLocation)
                };
                this.editLocations({
                    filter: filter,
                    display: false
                });
            }
            if (assign) this.filterTemplate = filter;
            return filter;
        },
        /**
		 * Wysyła zdarzenie do analityki za pomocą GA
		 * oraz `log-myoferteo-action-stats`
		 * @param label Nazwa zadarzenia dla `log-myoferteo-action-stats`
		 * @param gtmLabel Nazwa zadarzenia dla GA
		 */ sendAnalyticsEvent (label, gtmLabel) {
            if (this.isAdminModule) return;
            this.Analytics.Gtm(`myServices_${gtmLabel || label}`);
            (0, $goO1A.default)(`/myoferteo/konto-json/log-myoferteo-action-stats.ofer?step=ProfileServices&action=${label}`);
        },
        /**
		 * Masowo ustawia lokalizacje wszystkich bezpłatnych filtrów.
		 */ async saveLocationForAll (filter) {
            var _filter_location;
            await (0, $goO1A.default)("/myoferteo/set-filter-locations.ofer", {
                idCustomer: this.customerId,
                filterLocsType: "mgFltrTypeNotif",
                selectedLocs: (_filter_location = filter.location) === null || _filter_location === void 0 ? void 0 : _filter_location.selected
            });
        },
        /**
		 * Pobiera drzewo lokalizacji wraz z ich graficzną reprezentacją
		 * z pliku `scripts/geo.js` lub, jeśli wcześniej jego zawartość
		 * została pobrana - z `localStorage`.
		 */ async growTree () {
            const JSON_VERSION = 7;
            const JSON_PATH = `/scripts/geo.js?rev=${JSON_VERSION}`;
            const JSON_TREE_KEY = "geotree";
            const treeFromLocalStorage = window.localStorage[JSON_TREE_KEY];
            if (treeFromLocalStorage) {
                // Aktualna wersja, ustaw ją.
                const { data: data, version: version } = JSON.parse(treeFromLocalStorage);
                const normalizedData = {};
                // normalize current data to lowercase
                Object.entries(data).forEach((group)=>{
                    const [key, values] = group;
                    const normalizedValues = Object.entries(values).reduce((prev, current)=>{
                        const [valueKey, value] = current;
                        const valueToLowerCase = valueKey.toLowerCase();
                        if (valueToLowerCase === "items") Object.entries(value).forEach((entry)=>{
                            const [keyItems, valueItems] = entry;
                            const normalizedItemsValues = Object.entries(valueItems).reduce((prevItems, currentItems)=>{
                                const [itemsValueKey, itemsValue] = currentItems;
                                const itemsValueToLowerCase = itemsValueKey.toLowerCase();
                                return {
                                    ...prevItems,
                                    [itemsValueToLowerCase]: itemsValue
                                };
                            }, {});
                            value[keyItems] = normalizedItemsValues;
                        });
                        return {
                            ...prev,
                            [valueToLowerCase]: value
                        };
                    }, {});
                    normalizedData[key] = normalizedValues;
                });
                if (version >= JSON_VERSION) // this.tree = { ...normalizedData };
                return normalizedData;
            }
            const getRootFromName = (name, tree)=>{
                for (const root of Object.keys(tree)){
                    if (name.startsWith(root)) return tree[root];
                }
                return undefined;
            };
            // Nie ma aktualnej, pobierz.
            const locs = {
                Countries: this.locationStore.countries,
                Poland: this.locationStore.poland
            };
            const tree = {};
            const domestic = locs.Poland;
            domestic.forEach(({ Value: Value, Label: Label })=>{
                tree[Value] = {
                    name: Label,
                    selected: 0,
                    items: {},
                    expanded: false
                };
            });
            const foreign = locs.Countries;
            tree.locationForeign = {
                name: "Zagranica",
                selected: 0,
                items: {},
                expanded: false
            };
            foreign.forEach(({ Value: Value, Label: Label })=>{
                if (Value !== "locationPl") tree.locationForeign.items[Value] = {
                    name: Label,
                    selected: false
                };
            });
            const rsvp = await fetch(JSON_PATH).then((data)=>data.json());
            const set = (items, index, locationObject)=>{
                items[index] = locationObject;
            };
            // eslint-disable-next-line guard-for-in
            for(const index in rsvp){
                const location = rsvp[index];
                const root = getRootFromName(index, tree);
                if (!root) continue;
                set(root.items, index, {
                    name: location.name,
                    selected: false,
                    geo: location.geojson
                });
                if (!location.cities) continue;
                location.cities.forEach((city, cityIndex)=>{
                    const cityRoot = getRootFromName(city.v, tree);
                    if (!cityRoot) return;
                    set(cityRoot.items, city.v, {
                        name: city.n,
                        selected: false,
                        geo: {
                            type: "Polygon",
                            coordinates: [
                                location.geojson.coordinates[Number(cityIndex) + 1]
                            ]
                        }
                    });
                });
            }
            window.localStorage[JSON_TREE_KEY] = JSON.stringify({
                version: JSON_VERSION,
                data: tree
            });
            return tree;
        },
        /**
		 * Rozdziela listę identyfikatorów kategorii na grupę krajów i powiatów.
		 * @param inputLocations Lista identyfikatorów kategorii
		 * @returns Obiekt zawierający kraje i powiaty
		 */ splitLocationsIntoGroups (inputLocations) {
            const countries = [];
            const locations = [];
            if (inputLocations) inputLocations.forEach((location)=>{
                (location.startsWith("locationPl") ? locations : countries).push(location);
            });
            return {
                countries: countries,
                locations: locations
            };
        },
        /**
		 * Przekształca listę pytań z MPO (Matchowanie Po Odpowiedziach) filtra
		 * na postać, którą backend przyjmie przy zapisie.
		 * @param filter Filtr dla którego ma być zwrócony obiekt z odpowiedziami.
		 */ saveFilterMpo (filter) {
            const mpoResult = {};
            const mpo = JSON.parse(JSON.stringify(filter.mpo));
            if ((this.isAdminModule || filter.type === "free") && mpo.length) // this format is required due the backend... [*]
            mpo.forEach((mpoQuestion, index)=>{
                Object.entries(mpoQuestion).forEach(([key, value])=>{
                    if (key === "id") key = "questionId";
                    if (key === "optionsList") key = "answersDtoList";
                    if (key !== "answersDtoList" && key !== "id" && key !== "questionId" && key !== "questionSetId") return;
                    if (key === "answersDtoList") {
                        let mpoArrayItemNewIndex = 0;
                        mpoQuestion["optionsList"].forEach((mpoArrayItem)=>{
                            if (!mpoArrayItem.checked) return;
                            Object.entries(mpoArrayItem).forEach(([mpoArrayItemKey, mpoArrayItemValue])=>{
                                if (mpoArrayItemKey !== "id" && mpoArrayItemKey !== "questionId" && mpoArrayItemKey !== "questionSetId") return;
                                mpoResult[`mpo[${index}].${key}[${mpoArrayItemNewIndex}].${mpoArrayItemKey}`] = mpoArrayItemValue;
                                mpoArrayItemNewIndex++;
                            });
                        });
                        return;
                    }
                    mpoResult[`mpo[${index}].${key}`] = value;
                });
            });
            return mpoResult;
        },
        async recalculatePotentialMatches (filter) {
            const url = "/myoferteo/get-matching-filter-potential-matches.ofer";
            const result = this.getFilterObject(filter);
            const rsvp = await (0, $goO1A.default)(url, result, "POST");
            this.potentialMatches = typeof rsvp.result === "undefined" ? -1 : rsvp.result;
        },
        getFilterObject (filter, fieldPrefix = "matchingFilter.", allLocations = false) {
            var _filter_filterTypes_age, _filter_filterTypes_age1, _filter_filterTypes_size, _filter_filterTypes_size1, _filter_location;
            const result = {};
            const operationTypeMethod = filter.isActive ? "A" : "X";
            const operationType = filter.isInitiallyActive !== filter.isActive ? operationTypeMethod : "";
            const ageFilterMin = (_filter_filterTypes_age = filter.filterTypes.age) === null || _filter_filterTypes_age === void 0 ? void 0 : _filter_filterTypes_age.minValue;
            const ageFilterMax = (_filter_filterTypes_age1 = filter.filterTypes.age) === null || _filter_filterTypes_age1 === void 0 ? void 0 : _filter_filterTypes_age1.maxValue;
            const sizeFilterMin = (_filter_filterTypes_size = filter.filterTypes.size) === null || _filter_filterTypes_size === void 0 ? void 0 : _filter_filterTypes_size.minValue;
            const sizeFilterMax = (_filter_filterTypes_size1 = filter.filterTypes.size) === null || _filter_filterTypes_size1 === void 0 ? void 0 : _filter_filterTypes_size1.maxValue;
            if (filter.tsSuspendedEnd) result.tsSuspendedEnd = filter.tsSuspendedEnd;
            if (filter.contactPerson.contactPersonId) result[`${fieldPrefix}idCustomerContactUser`] = filter.contactPerson.contactPersonId;
            Object.entries({
                ...this.saveFilterMpo(filter),
                id: filter.id,
                isActive: filter.isActive,
                categories: filter.category.categoryId,
                idCustomer: this.customerId,
                editLocations: true,
                forceLocations: false,
                updateAllLocations: allLocations || false,
                operationType: operationType,
                idType: this.getItemType({
                    type: filter.type,
                    reverse: true
                }),
                idStatus: filter.isActive ? "mgFltrStatActive" : "mgFltrStatInactive",
                idNotificationMode: filter.filterTypes.frequency,
                standardRfps: filter.filterTypes.standardRfps,
                outletRfps: filter.filterTypes.discounted,
                companies: filter.filterTypes.companies,
                individuals: filter.filterTypes.individuals,
                contractors: true,
                investors: true,
                subcontractors: true,
                notificationWithOutlet: filter.filterTypes.discounted,
                notConfirmedSmsRfps: filter.filterTypes.notConfirmedBySms,
                smsNumber: filter.quickContactSmsNumber,
                contactPrice: filter.contactPrice,
                tsSuspendedEnd: filter.tsSuspendedEnd,
                ...filter.filterTypes.age ? {
                    usedFrom: ageFilterMin !== 0 ? ageFilterMin : -1,
                    usedTo: ageFilterMax !== 0 ? ageFilterMax : -1
                } : {},
                ...filter.filterTypes.size ? {
                    sizeFrom: sizeFilterMin !== 0 ? sizeFilterMin : -1,
                    sizeTo: sizeFilterMax !== 0 ? sizeFilterMax : -1
                } : {},
                ...filter.automaticRecommendations ? {
                    imWeeklyLimit: filter.automaticRecommendations.weeklyLimit,
                    imSmsNotification: filter.automaticRecommendations.smsNumber.enabled
                } : {},
                ...this.splitLocationsIntoGroups((_filter_location = filter.location) === null || _filter_location === void 0 ? void 0 : _filter_location.selected)
            }).forEach(([k, v])=>{
                result[fieldPrefix + k] = v;
            });
            return result;
        },
        /**
		 * Aktualizuje lub dodaje nowy filtr po wcześniejszym przekształceniu go
		 * na formę zjadliwą dla backendu.
		 * @param filter Filtr do dodania lub aktualizacji
		 * @param createFilter Czy zamiast edycji istniejącego, dodać nowy filtr?
		 * @param allLocations Czy aktualizować wszystkie lokalizacjie?
		 */ async saveFilter (filter, createFilter = false, allLocations = false) {
            if (!this.isSavingCompleted) return;
            this.isSavingCompleted = false;
            // Zabezpieczka, jakby się coś wysypało przy zapisie.
            setTimeout(()=>{
                this.isSavingCompleted = true;
            }, 7500);
            const fieldPrefix = !createFilter ? "matchingFilter." : "newFilters[0].";
            const result = this.getFilterObject(filter, fieldPrefix, allLocations);
            if (createFilter && this.isAdminModule) this.isLoading = true;
            const url = `/${this.apiNamespace}/${!createFilter ? "edit" : "add-new"}-filter.ofer`;
            const rsvp = await (0, $goO1A.default)(url, result, "POST");
            if (rsvp.result !== "ok" && !rsvp.filters) console.error("Wystąpił błąd podczas dodawania kategorii.");
            // Zawsze pobieraj nowe dane, inaczej licznik matchowań nie zostanie zaktualizowany.
            // Kiedyś było to tylko w momencie, kiedy dodawano lub klonowano nowy filtr (createFilter || filter.isClone).
            await this.loadData();
            this.Toast.Show({
                Message: "Zmiany zostały zapisane"
            });
            this.isSavingCompleted = true;
            // Wyświetl okno dialogowe czy włączyć nieaktywną usługę
            const filterGroup = this.services.tree.find((group)=>filter.category.categoryId === group.categoryId);
            if (!this.isAdminModule && !(filterGroup === null || filterGroup === void 0 ? void 0 : filterGroup.isActive)) window.setTimeout(()=>{
                this.$router.push({
                    query: {
                        enableServiceOnSaveModalVisible: "true"
                    }
                });
            }, 250);
        },
        /**
		 * Przenosi użytkownika na ekran dopasowania filtra
		 */ editMatching () {
            this.isEditMatching = true;
            this.isInsideFilterDetails = true;
            const routeName = this.selectedFilter.type === "automatic" ? "FilterDetailsAutomaticMatching" : "FilterDetailsQuickMatching";
            this.$router.push({
                name: routeName,
                params: {
                    filterId: this.selectedFilter.id || (this.selectedFilter.type === "quick" ? "dodaj-sk" : "dodaj-polecanie")
                }
            });
        },
        /**
		 * Przenosi użytkownika na ekran dopasowania lokalizacji filtra.
		 * Dodatkowo generuje drzewo lokalizacji dla danego filtra.
		 */ editLocations ({ filter: filter, display: display = true }) {
            const selectedFilter = filter || this.selectedFilter;
            if (!selectedFilter.location) return;
            const { selected: selected } = selectedFilter.location;
            const locations = JSON.parse(JSON.stringify(this.services.locations, (key, value)=>key === "geo" ? undefined : value));
            // eslint-disable-next-line guard-for-in
            for(const index in locations){
                const selectedAll = selected.indexOf(index) > -1;
                locations[index].expanded = false;
                locations[index].selected = 0;
                if (selectedAll) locations[index].selected = Object.keys(locations[index].items).length;
                // eslint-disable-next-line guard-for-in
                for(const itemIndex in locations[index].items){
                    if (selectedAll) {
                        locations[index].items[itemIndex].selected = true;
                        continue;
                    }
                    if (selected.indexOf(itemIndex) > -1) {
                        locations[index].items[itemIndex].selected = true;
                        locations[index].selected++;
                    }
                }
            }
            selectedFilter.locations = {
                ...locations
            };
            selectedFilter.location = {
                ...selectedFilter.location
            };
            if (display) {
                this.isEditLocations = true;
                this.isInsideFilterDetails = true;
                const routeName = this.selectedFilter.type === "automatic" ? "FilterDetailsAutomaticLocation" : "FilterDetailsQuickLocation";
                this.$router.push({
                    name: routeName,
                    params: {
                        filterId: this.selectedFilter.id || (this.selectedFilter.type === "quick" ? "dodaj-sk" : "dodaj-polecanie")
                    }
                });
            }
        },
        /**
		 * Oblicza liczbę kategorii dla limitu posiadanych przez użytkownika filtrów.
		 * Wliczane są tylko aktywne filtry powiadomień. Na dodatek, jeżeli kategoria
		 * jest `isGeneraled` (np. wózki widłowe), policz tylko jej rodzica.
		 */ groupLimitRecalculate () {
            let hasGroups = false;
            let count = 0;
            const groups = {};
            for (const group of this.services.tree){
                const filter = group.filters.find(({ type: type })=>type === "free");
                if (!group.isActive || !filter) continue;
                const category = {
                    ...filter.category
                };
                let ignore = false;
                if (!category.isGeneraled) {
                    if (groups[category.parentId]) {
                        ignore = true;
                        hasGroups = true;
                    } else groups[category.parentId] = true;
                }
                if (!ignore) count++;
            }
            this.services.stats.hasGroupedCategories = hasGroups;
            this.services.stats.activeGroupCount = count;
        },
        /**
		 * Przekształca listę osób kontaktowych z postaci backendową na frontendową.
		 * @param contactPersons Tablica osób kontaktowych
		 */ getContactPersons (contactPersons) {
            return contactPersons.map((person)=>({
                    id: person.id,
                    fullName: person.fullName,
                    phone: person.phone,
                    email: person.login
                }));
        },
        /**
		 * Przekształca listę Operatorów Oferteo z postaci backendową na frontendową.
		 * @param operators Tablica Operatorów Oferteo
		 */ getOperators (operators) {
            return operators.map((operator)=>({
                    id: operator.idCustomer,
                    fullName: operator.fullName,
                    phone: operator.phone,
                    email: operator.login
                }));
        },
        /**
		 * Pobiera główny obiekt Usług.
		 */ async getServicesList () {
            var _rsvp_actionErrors;
            const result = [];
            const rsvp = await (0, $goO1A.default)(`/${this.apiNamespace}/get-filter-list-new.ofer?includeLocations=${String(!this.services.locations.length)}&matchingFilter.idCustomer=${this.customerId}`);
            if (rsvp === null || rsvp === void 0 ? void 0 : (_rsvp_actionErrors = rsvp.actionErrors) === null || _rsvp_actionErrors === void 0 ? void 0 : _rsvp_actionErrors.length) {
                document.location.href = "/";
                return undefined;
            }
            if (!this.services.locations.length) this.services.locations = await this.growTree();
            this.services.contactPersons = [
                ...this.getContactPersons(rsvp.contactPersons)
            ];
            if (this.isAdminModule) this.companyName = rsvp.customer[0].companyName;
            this.services.operators = this.getOperators(rsvp.kam);
            this.clearStatsCount();
            for (const filterGroup of rsvp.filterGroups){
                if (!filterGroup.filters.length) continue;
                if (!filterGroup.active) this.services.stats.hasInactiveFilterGroups = true;
                const notUndefined = (value)=>value !== undefined;
                const filters = filterGroup.filters.map((filter)=>{
                    const processed = this.process({
                        filterDetails: filter
                    });
                    if (processed) this.statsCount(processed);
                    return processed || undefined;
                }).filter(notUndefined);
                const automaticFilter = filters.find(({ type: type })=>type === "automatic");
                let automaticHasErrors = false;
                if (automaticFilter && automaticFilter.automaticRecommendations) {
                    const automatic = automaticFilter.automaticRecommendations;
                    automaticHasErrors = automatic.notEnoughBalance || automatic.needsModeration || !automatic.isCategoryVerified;
                }
                const group = {
                    name: filterGroup.categoryName,
                    categoryName: filterGroup.categoryName,
                    categoryParentName: filterGroup.filters[0].categoryListForView.split(" / ")[0],
                    categoryId: filterGroup.idCategory,
                    isActive: filterGroup.active,
                    isInitiallyActive: filterGroup.active,
                    automatic: {
                        has: filterGroup.apEnabled,
                        canBeEnabled: filterGroup.apCanBeEnabled,
                        hasErrors: automaticHasErrors
                    },
                    quickContact: {
                        has: filterGroup.skEnabled,
                        canBeEnabled: true
                    },
                    isHidden: false,
                    isApEnabled: filterGroup.apEnabled,
                    isSkEnabled: filterGroup.skEnabled,
                    isVerified: filterGroup.filters[0].filterCategories[0].verified,
                    filters: filters,
                    userActivityStats: {},
                    isPricingEnabled: filterGroup.isPricingEnabled
                };
                result.push(group);
            }
            this.services.tree = [
                ...result
            ];
            this.groupLimitRecalculate();
            this.invalidStats = this.services.stats.needsModeration || this.services.stats.notEnoughBalance;
            return rsvp;
        },
        /**
		 * Przekształca typ filtra z postaci używanej w backendzie na tą używaną
		 * we frontendzie i vice versa
		 */ getItemType ({ type: type, reverse: reverse = false }) {
            const back = [
                "mgFltrTypeNotif",
                "mgFltrTypeSk",
                "mgFltrTypeIm"
            ];
            const front = [
                "free",
                "quick",
                "automatic"
            ];
            const result = (reverse ? back : front)[(reverse ? front : back).indexOf(type)];
            this.itemType = result;
            return result;
        },
        /**
		 * Przekształca typ filtra na postać widoczną dla użytkownika
		 * @param type Typ filtra
		 */ processItemLabel (type) {
            let typeLabel = "";
            switch(type){
                case "free":
                    typeLabel = "Dopasowanie";
                    break;
                case "quick":
                    typeLabel = "Szybki kontakt";
                    break;
                case "automatic":
                    typeLabel = "Polecanie";
                    break;
                default:
                    break;
            }
            return {
                typeLabel: typeLabel
            };
        },
        /**
		 * Przekształca nazwę kategorii z postaci backendowej zawierającą pełną
		 * ścieżkę `Rodzic / Kategoria` na samą nazwę kategorii oraz usuwa z niej
		 * znaki specjalne. Dodatkowo, jeżeli kategoria nie jest liściem, dodaj
		 * do niej tekst `[BRANCH]`
		 * @param backendFilter Filtr z którego pobierana jest kategoria
		 */ processCategoryName (backendFilter) {
            const { categoryListForView: categoryListForView, category: category, isLeaf: isLeaf } = backendFilter;
            let formattedCategoryName = categoryListForView;
            formattedCategoryName = formattedCategoryName.split("<br/>").join(", ");
            if (formattedCategoryName.indexOf(" / ") !== -1) {
                const split = formattedCategoryName.split(" / ");
                formattedCategoryName = split[1] === "Pozostałe" ? formattedCategoryName.replace(" / ", " › ") : split[1];
            }
            if (formattedCategoryName === "" && category) formattedCategoryName = category.name;
            if (!isLeaf) formattedCategoryName = `[BRANCH] ${formattedCategoryName}`;
            return formattedCategoryName;
        },
        /**
		 * Przekształca 9-ciocyfrowy numer telefonu na grupę po trzy cyfry.
		 * W innym przypadku pozostawia go bez zmian.
		 * @param phoneNumber Numer telefonu
		*/ formatPhoneNumber (phoneNumber) {
            const formattedPhoneNumber = `${phoneNumber}`;
            return formattedPhoneNumber.length !== 9 ? formattedPhoneNumber : formattedPhoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
        },
        /**
		 * Przekształca tablicę zaznaczonych lokalizację na łańcuch
		 * znaków w postaci `Województwo (12 powiatów), Województwo`
		 * @param locations Tablica identyfikatorów kategorii
		 */ processSelectedLocationsLabel (locations) {
            const allLocations = JSON.parse(JSON.stringify(this.services.locations));
            const result = [];
            const poland = {};
            const foreign = [];
            for (const index of locations){
                if (index.startsWith("locationPl")) {
                    // eslint-disable-next-line guard-for-in
                    for(const allLocationIndex in allLocations){
                        if (index === allLocationIndex) {
                            poland[allLocations[allLocationIndex].name] = -1;
                            continue;
                        }
                        if (allLocations[allLocationIndex].items[index]) {
                            poland[allLocations[allLocationIndex].name] = poland[allLocations[allLocationIndex].name] ? poland[allLocations[allLocationIndex].name] + 1 : 1;
                            continue;
                        }
                    }
                    continue;
                }
                foreign.push(allLocations.locationForeign.items[index].name);
            }
            // eslint-disable-next-line guard-for-in
            for(const index in poland){
                const item = poland[index];
                result.unshift(item === -1 ? index : `${index} (${this.Format.PluralForm(item, [
                    "powiat",
                    "powiaty",
                    "powiat\xf3w"
                ], true)})`);
            }
            result.push(...foreign);
            return result.join(", ");
        },
        /**
		 * Pobiera ustawioną osobę kontaktową z podanego filtru lub pierwszą
		 * lepszą z obiektu usług.
		 * @param backendFilter Filtr z którego pobierana jest osoba kontaktowa
		 */ processContactPerson (backendFilter) {
            const contactPerson = this.services.contactPersons.find((person)=>person.id === backendFilter.idCustomerContactUser) || this.services.contactPersons[0];
            return {
                id: backendFilter.idCustomerContactUser,
                contactPersonId: backendFilter.idCustomerContactUser,
                fullName: (contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.fullName) || "",
                email: (contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.email) || "",
                phone: (contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.phone) || ""
            };
        },
        /**
		 * Przekształca informacje o wielkości filtra na łańcuch znaków.
		 * @param backendFilter Filtr do przekształcenia
		 */ processSizeLabel (backendFilter) {
            return backendFilter.sizeUnit ? `Wielkość ${backendFilter.sizeFrom ? `od ${backendFilter.sizeFrom}` : ""} ${backendFilter.sizeTo ? `do ${backendFilter.sizeTo}` : ""} ${backendFilter.sizeUnit}` : "";
        },
        /**
		 * Przekształca informacje o filtrze z postaci backendowej do frontendowej.
		 * @param filterDetails Filtr do przekształcenia
		 * @param cloneType Czy mamy sklonować dany filtr? (Ustawić `id`)
		 */ process ({ filterDetails: filterDetails, cloneType: cloneType = "" }) {
            // Sprawdź, w jakiej postaci przyszedł filtr.
            // Prawdopodobnie można to uprościć.
            const backendFilter = filterDetails.filter ? filterDetails.filter[0] || filterDetails.filter : filterDetails;
            // Zignoruj filtry, które nie mają kategorii
            if (!backendFilter.filterCategories.length) return undefined;
            if (cloneType) {
                backendFilter.id = 0;
                backendFilter.idType = this.getItemType({
                    type: cloneType,
                    reverse: true
                });
            }
            const type = this.getItemType({
                type: backendFilter.idType
            });
            const locationsIds = backendFilter.elementId ? backendFilter.filterLocations.map(({ idLocation: idLocation })=>idLocation) : [];
            const isActive = backendFilter.idStatus === "mgFltrStatActive" || backendFilter.idStatus === "mgFltrStatCalcOnly";
            const emptySizeFilter = {
                unit: "",
                minValue: 0,
                minLimit: 0,
                maxValue: 0,
                maxLimit: 1000000
            };
            const result = {
                id: backendFilter.id,
                category: {
                    categoryId: backendFilter.filterCategories[0].idCategory,
                    name: this.processCategoryName(backendFilter),
                    parentId: "",
                    isGeneraled: ""
                },
                type: type,
                ...this.processItemLabel(type),
                sizeLabel: this.processSizeLabel(backendFilter),
                automaticRecommendations: this.processAsAutomatic(backendFilter),
                promoted: {},
                contactPrice: backendFilter.contactPrice,
                contactPerson: this.processContactPerson(backendFilter),
                isActive: isActive,
                idType: backendFilter.idType,
                isInitiallyActive: isActive,
                isFrozen: backendFilter.idType === "mgFltrTypeSk",
                locations: {},
                location: {
                    mode: backendFilter.locationMode || "select",
                    selected: locationsIds,
                    radius: backendFilter.radius > 0 ? backendFilter.radius : 50,
                    center: null,
                    labels: this.processSelectedLocationsLabel(locationsIds)
                },
                quickContactSmsNumber: backendFilter.smsNumber,
                hideAdvancedSettings: true,
                minContactPrice: backendFilter.minContactPrice,
                maxContactPrice: backendFilter.maxContactPrice,
                upcommingPriceChange: backendFilter.upcommingPriceChange,
                isApSuspended: backendFilter.isApSuspended,
                tsSuspendedEnd: backendFilter.tsSuspendedEnd,
                modified: new Date(backendFilter.tsModified || backendFilter.tsCreated),
                filterTypes: {
                    size: backendFilter.sizeUnit ? {
                        unit: backendFilter.sizeUnit.toUpperCase(),
                        minValue: backendFilter.sizeFrom,
                        minLimit: 0,
                        maxValue: backendFilter.sizeTo,
                        maxLimit: 1000000
                    } : emptySizeFilter,
                    age: (backendFilter.usedFrom || backendFilter.usedTo) && (backendFilter.usedFrom > -1 || backendFilter.usedTo > -1) ? {
                        unit: "YEARS",
                        minValue: backendFilter.usedFrom,
                        minLimit: 0,
                        maxValue: backendFilter.usedTo,
                        maxLimit: 100
                    } : emptySizeFilter,
                    discounted: backendFilter.notificationWithOutlet,
                    standardRfps: backendFilter.standardRfps,
                    discountedRfps: backendFilter.outletRfps,
                    companies: backendFilter.companies,
                    individuals: backendFilter.individuals,
                    frequency: backendFilter.idNotificationMode,
                    contractors: true,
                    investors: true,
                    subcontractors: true,
                    notConfirmedBySms: backendFilter.notConfirmedSmsRfps,
                    hideNotConfirmedBySms: backendFilter.hideNotConfirmedBySms
                },
                mpo: backendFilter.mpo,
                idCustomerContactUser: backendFilter.idCustomerContactUser,
                isClone: cloneType,
                notEnoughPoints: backendFilter.notEnoughPoints,
                finalMarkBelowApThreshold: backendFilter.finalMarkBelowApThreshold,
                weeklyLimitReached: backendFilter.weeklyLimitReached,
                apValidated: backendFilter.apValidated
            };
            this.processResult = {
                ...result
            };
            return result;
        },
        /**
		 * Przekształca informacje o ustawieniach Polecania filtra z postaci
		 * backendowej do frontendowej.
		 * @param backendFilter Filtr do przekształcenia.
		 */ processAsAutomatic (backendFilter) {
            const price = backendFilter.contactPrice || backendFilter.contactPrice === 0 ? backendFilter.contactPrice : backendFilter.categoryDefaultPrice;
            return {
                canBeEnabled: backendFilter.canEnableAP,
                isCategoryValid: backendFilter.isCategoryInAP,
                isCategoryVerified: backendFilter.filterCategories[0].verified,
                needsModeration: backendFilter.imNeedsModeration,
                enabledBy: [
                    backendFilter.apEnabledOperator,
                    backendFilter.tsApEnabled
                ],
                disabledBy: [
                    backendFilter.apDisabledOperator,
                    backendFilter.tsApDisabled
                ],
                weeklyLimit: backendFilter.imWeeklyLimit && backendFilter.idType === "mgFltrTypeIm" ? backendFilter.imWeeklyLimit : price * 10,
                weeklyLimitMin: Math.round(price * 2),
                weeklyLimitMax: price * 50,
                smsNumber: {
                    enabled: backendFilter.imSmsNotification,
                    number: backendFilter.customer ? this.formatPhoneNumber(backendFilter.customer.contactPersonPhone) : "",
                    isValid: backendFilter.phoneCheck === "Kom\xf3rkowy poprawny"
                },
                recommendedClientsCount: backendFilter.recommendClientsCount,
                contactedClientsCount: backendFilter.contactClientsCount,
                remainingPoints: backendFilter.remainPoints,
                notEnoughBalance: backendFilter.notEnoughBalance
            };
        },
        /**
		 * Resetuje statystyki dla wszystkich filtrów.
		 */ clearStatsCount () {
            this.services.stats = {
                hasInactiveFilterGroups: false,
                notEnoughBalance: false,
                setLimitSum: 0,
                needsModeration: false,
                withAutomatic: false,
                withQuick: false,
                inactiveCount: 0,
                activeGroupCount: 0,
                hasGroupedCategories: false,
                groupLimitCheck: ""
            };
        },
        /**
		 * Zlicza statystyki dla wszystkich filtrów: czy istnieją usługi dodatkowe,
		 * czy limity punktów dla Polecania nie przekraczają stanu konta, etc.
		 * @param filter Kolejny zliczany filtr z listy
		 */ statsCount (filter) {
            const { stats: stats } = this.services;
            const { isActive: isActive, type: type, automaticRecommendations: automaticRecommendations } = filter;
            if (!isActive) stats.inactiveCount++;
            if (type === "quick") stats.withQuick = true;
            if (automaticRecommendations && type === "automatic") {
                stats.withAutomatic = true;
                if (isActive) stats.setLimitSum += automaticRecommendations.weeklyLimit;
                if (automaticRecommendations.needsModeration) stats.needsModeration = true;
                if (automaticRecommendations.notEnoughBalance) stats.notEnoughBalance = true;
            }
        },
        /**
		 * Pobiera listę usług oraz aktualizuje listę grup filtrów.
		 */ async loadData () {
            this.isLoading = true;
            await this.getServicesList();
            this.isLoading = false;
            if (document.location.hash) {
                const filterId = Number(document.location.hash.substr(1));
                console.log("document", filterId);
                for (let category of this.services.tree){
                    const filter = category.filters.find((filter)=>filter.id === filterId);
                    if (filter) {
                        const categoryId = category.categoryId;
                        const el = document.querySelector(`[data-category-id="${categoryId}"]`);
                        if (el) el.click();
                        break;
                    }
                }
            }
        },
        /**
		 * Przenosi użytkownika na ekran dodawania nowej usługi.
		 */ goToCreate () {
            this.currentPage = "Create";
            this.isNewCategory = true;
            this.pricingCategoryId = 0;
            this.$router.push({
                name: "FilterCreate"
            });
        },
        /**
		 * Ustawia aktualnie edytowany filtr (po wywołaniu metody `editFilter`
		 * w komponencie `FilterList`) w polu `selectedFilters` obiektu `services`
		 * @param filterToEdit Wybrany filtr do edycji
		 */ onSelectedFiltersChange (filterToEdit) {
            this.services.selectedFilters = [
                {
                    ...filterToEdit
                }
            ];
        },
        /**
		 * Usuwa pojedynczy filtr z grupy, a następnie usuwa go z listy usług.
		 * @param filterToRemove Filtr do usunięcia
		 */ async removeFilter (filterToRemove) {
            await fetch(`/${this.apiNamespace}/remove-filter.ofer?matchingFilter.idCustomer=${this.customerId}&matchingFilter.id=${filterToRemove.id}&matchingFilter.categories=${filterToRemove.categoryId}`);
            const categoryIndex = this.services.tree.findIndex((category)=>category.categoryId === filterToRemove.categoryId);
            const filterIndex = this.services.tree[categoryIndex].filters.findIndex((filter)=>filter.id === filterToRemove.id);
            this.services.tree[categoryIndex].filters.splice(filterIndex, 1);
            this.filterToRemove = {
                id: 0,
                type: "",
                categoryId: 0
            };
            this.$router.back();
            this.Toast.Show(`${filterToRemove.type === "quick" ? "Szybki Kontakt został usunięty" : "Polecanie zostało usunięte"}`);
        },
        /**
		 * Usuwa grupy filtrów, a następnie odświeża listę wszystkich usług.
		 * @param groups Tablica z grupami do usunięcia
		 */ async removeGroups (groups) {
            for (const group of groups){
                const { categoryId: categoryId } = group;
                await fetch(`/${this.apiNamespace}/remove-filter-group.ofer?matchingFilter.idCustomer=${this.customerId}&catId=${categoryId}`);
            }
            this.getServicesList();
            this.groupsToRemove = [];
            this.Toast.Show(`${groups.length > 1 ? "Kategorie zostały usunięte" : "Kategoria została usunięta"}`);
            this.$router.push({
                name: "Services"
            });
        },
        backWithNoSaving (pushRouterBack, source = "button") {
            if (source !== "button") {
                this.displaySaveChanges = false;
                return;
            }
            this.isFilterDirty = false;
            this.displaySaveChanges = false;
            if (pushRouterBack) this.$router.back();
        },
        cancelRemoveModal () {
            this.filterToRemove = {
                type: "",
                id: 0,
                categoryId: 0
            };
            this.$router.back();
        },
        cancelRemoveGroupModal () {
            this.groupsToRemove.length = 0;
            this.$router.back();
        }
    }
};

});
parcelRequire.register("5UCIl", function(module, exports) {

$parcel$export(module.exports, "useServicesStore", function () { return $4ee7578a72886659$export$8d33a82294da6ad5; });

var $jgrCW = parcelRequire("jgrCW");

var $7XpJX = parcelRequire("7XpJX");

var $lC19C = parcelRequire("lC19C");

var $3cbAx = parcelRequire("3cbAx");
const $4ee7578a72886659$export$8d33a82294da6ad5 = (0, $jgrCW.defineStore)({
    id: "services",
    state: ()=>{
        var _useRoute, _useRoute_params;
        return {
            displaySaveChanges: false,
            isNewCategory: false,
            currentPage: "",
            selectedCategoryGroupId: 0,
            groupsToRemove: [],
            selectedFilterIndex: 0,
            isEditMatching: false,
            isEditLocations: false,
            isFreshCategory: false,
            suspendFilterStatus: "",
            filterToRemove: {
                id: 0,
                type: "",
                categoryId: 0
            },
            isFilterDirty: false,
            isInsideFilterDetails: false,
            pricingCategoryId: 0,
            customerId: (0, $lC19C.useAppStore)().isAdminModule ? Number((_useRoute = (0, $7XpJX.useRoute)()) === null || _useRoute === void 0 ? void 0 : (_useRoute_params = _useRoute.params) === null || _useRoute_params === void 0 ? void 0 : _useRoute_params.id) : (0, $3cbAx.useUserStore)().customerId,
            isRecommendationFeedbackModalVisible: false,
            notifications: {
                recommendation: {
                    type: "",
                    title: "",
                    message: "",
                    button: "",
                    dismissButton: "",
                    moreInfoLink: "",
                    isVisible: false
                }
            },
            invalidStats: false,
            isLoading: false,
            isFreeRecommendationConfirmationModalVisible: false,
            potentialMatches: -1,
            visibilityTenPercentDiscountConfirmationModal: false
        };
    },
    actions: {
        /**
		 * Zwraca tablicę z aktualnym filtrem oraz tym znajdującym się w drzewie.
		 * Używamy tego sposobu, kiedy chcemy zmienić jakąś informację, a nie chcemy
		 * pobierać całej listy na nowo
		 */ selectedFilters ({ selectedFilter: selectedFilter, servicesObject: servicesObject }) {
            // @TODO - przenieść selectedFilter, servicesObject do store
            const { categoryId: categoryId } = selectedFilter.category;
            const foundGroup = servicesObject.tree.find((group)=>group.categoryId === categoryId);
            const foundFilter = foundGroup === null || foundGroup === void 0 ? void 0 : foundGroup.filters.find((filter)=>filter.id === selectedFilter.id);
            return foundFilter ? [
                selectedFilter,
                foundFilter
            ] : [];
        },
        setNotifications (apImportantMessage) {
            this.notifications.recommendation = {
                type: apImportantMessage.type || "info",
                title: apImportantMessage.title,
                message: apImportantMessage.message.replace(/<br>/g, ""),
                button: apImportantMessage.buttonLabel || "Dowiedz się więcej",
                dismissButton: apImportantMessage.dismissButtonLabel || "Przypomnij p\xf3źniej",
                moreInfoLink: apImportantMessage.moreInfoLink,
                isVisible: true
            };
        },
        labelClasses (filter) {
            if (!filter || !filter.isActive) return "bg-[#F2F2F2] text-[#666666]";
            if (this.isFilterInactive(filter)) return "bg-[#FBEAE8] text-[#DA291C]";
            if (filter.tsSuspendedEnd && this.isSuspended(filter)) return "bg-[#E7EFFB] text-[#1462D3]";
            return "bg-[#E7F3EF] text-[#0E875F]";
        },
        /**
		 * Czy filtr jest nieaktywny? (filter.isActive === false a isFilterInactive to nie to samo,
		 * pierwsze oznacza że został wyłączony ręcznie, drugie że został wyłączony automatycznie przez niespełniające warunki serwisu)
		 */ isFilterInactive (filter) {
            return filter.type === "automatic" && (filter.notEnoughPoints || filter.finalMarkBelowApThreshold || filter.weeklyLimitReached || !filter.apValidated);
        },
        /**
		 * Sprawdza, czy podany filtr Polecania lub Szybkiego Kontaktu jest zawieszony.
		 * @param {Filter} filter - Filtr do sprawdzenia
		 */ isSuspended (filter) {
            return filter.isActive && filter.tsSuspendedEnd && filter.tsSuspendedEnd > Date.now() && (filter.type === "automatic" || filter.type === "quick");
        }
    }
});

});

parcelRequire.register("fQXQ9", function(module, exports) {

$parcel$export(module.exports, "useCustomerProfileViewStore", function () { return $b8470a519b04c532$export$bcf95542247cb594; });

var $jgrCW = parcelRequire("jgrCW");
const $b8470a519b04c532$export$bcf95542247cb594 = (0, $jgrCW.defineStore)({
    id: "customer-profile-view",
    state: ()=>({
            modalsConditions: {
                nip: {
                    isChecked: false,
                    wasShown: false
                },
                expressPhoto: {
                    isChecked: false,
                    wasShown: false
                },
                promotionalAP: {
                    isChecked: false,
                    wasShown: false
                }
            },
            isInRecommendationPromotion: false,
            recommendationPromotionEndDate: "",
            isInApPromotionalCampaign: false
        }),
    actions: {
        async inApPromotionalCampaign () {
            try {
                const response = await fetch("/customer/in-ap-promotional-campaign.do");
                const data = await response.json();
                this.isInApPromotionalCampaign = data.inApPromotionalCampaign;
            } catch (error) {
                console.error("Error in customerProfileView.ts:", error);
            }
        }
    }
});

});

parcelRequire.register("aDsf7", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("ijXtk")),
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("8Xe1q")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("7vmbp"))
]).then(()=>parcelRequire("51sXe"));

});

parcelRequire.register("krrSI", function(module, exports) {



module.exports = (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("653Zy")).then(()=>parcelRequire("7WPjn"));

});

parcelRequire.register("2Uxa9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $21ea892e14077560$export$2e2bcd8739ae039; });
let $21ea892e14077560$var$script;



let $21ea892e14077560$var$initialize = ()=>{
    $21ea892e14077560$var$script = (parcelRequire("6eLUm"));
    if ($21ea892e14077560$var$script.__esModule) $21ea892e14077560$var$script = $21ea892e14077560$var$script.default;
    $21ea892e14077560$var$script.render = (parcelRequire("iNQUu")).render;
    (parcelRequire("8cSle")).default($21ea892e14077560$var$script);
    $21ea892e14077560$var$script.__scopeId = "data-v-e76e58";
    $21ea892e14077560$var$script.__file = "FilterCreate.vue";
};
$21ea892e14077560$var$initialize();
var $21ea892e14077560$export$2e2bcd8739ae039 = $21ea892e14077560$var$script;

});
parcelRequire.register("6eLUm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $220f90692850aa16$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $5UCIl = parcelRequire("5UCIl");

var $5iLYC = parcelRequire("5iLYC");

var $kUqgA = parcelRequire("kUqgA");

var $goO1A = parcelRequire("goO1A");
var /**
 * Ekran dodawania nowych kategorii na Usługach.
 */ $220f90692850aa16$export$2e2bcd8739ae039 = {
    name: "FilterCreate",
    components: {
        FilterDetailsLocation: $5iLYC.default,
        FilterPricing: $kUqgA.default
    },
    props: {
        /**
		 * Główny obiekt usług
		 */ servicesObject: {
            type: Object,
            required: true
        },
        /**
		 * Czy można wybrać kilka kategorii?
		 */ multi: {
            type: Boolean,
            default: false
        },
        /**
		 * Początek ścieżki do API.
		 */ apiNamespace: {
            type: String,
            required: true
        },
        /**
		 * Filtr na którym będą edytowane lokalizacje.
		 */ filter: {
            type: Object,
            required: false
        }
    },
    emits: [
        "get-services-list",
        "go-back",
        "toggle-loading",
        "go-to-add-group-section",
        "send-analytics-event",
        "apply-multiple-groups-changes",
        "save-multiple-groups",
        "filter-create",
        "filter-create-template"
    ],
    data () {
        return {
            /**
			 * Wyszukiwana fraza
			 */ searchQuery: "",
            /**
			 * Lista wyszukanych lub polecanych kategorii.
			 */ searchList: [],
            /**
			 * Lista wybranych kategorii do dodania.
			 */ selectedCategories: [],
            /**
			 * Czy wyświetlić komunikat walidacyjny przy próbie
			 * utworzenia filtru bez jej wybrania?
			 */ displayValidation: false,
            /**
			 * Czy filtr jest aktualnie tworzony?
			 */ isLoading: false,
            /**
			 * Czy znajdujemy się na ekranie wyboru lokalizacji
			 * w przypadku dodawania wielu filtrów na raz?
			 */ editLocation: false
        };
    },
    computed: {
        newCategoryAutocomplete () {
            const url = `/${this.apiNamespace}/get-suggested-categories.ofer?addNewCategoryUserInput={{q}}&idCustomer=${this.customerId}`;
            return {
                Value: [
                    "",
                    ""
                ],
                Autocomplete: url,
                Suggestions: []
            };
        },
        ...(0, $jgrCW.mapState)((0, $5UCIl.useServicesStore), [
            "customerId"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $5UCIl.useServicesStore), [
            "currentPage",
            "pricingCategoryId",
            "isNewCategory"
        ]),
        /**
		 * Wybrane lokalizacje
		 */ selectedLocations () {
            var _this_filter_location;
            if (!this.filter) return null;
            return (_this_filter_location = this.filter.location) === null || _this_filter_location === void 0 ? void 0 : _this_filter_location.selected;
        },
        /**
		 * Zwraca w % w jakim stopniu ma zostać wypełniony pasek postępu
		*/ progressBarDone () {
            if (this.pricingCategoryId || this.editLocation) return "100%";
            return this.selectedCategories.length ? "50%" : "0";
        }
    },
    mounted () {
        this.$emit("send-analytics-event", "Add_Category_Show", "addCategory_show");
        this.onSearch();
    },
    methods: {
        autocompleteSelect (value) {
            this.selectedCategories = [
                {
                    cid: value.Value,
                    name: value.Input,
                    service: false
                }
            ];
        },
        autocompleteProcess (list, component) {
            this.selectedCategories = [];
            if (!list.length) {
                component.InputSuggestions = [];
                return;
            }
            const { suggestedCategories: suggestedCategories } = JSON.parse(list);
            component.InputSuggestions = suggestedCategories.map(({ cid: cid, name: name })=>({
                    Value: cid,
                    Label: name,
                    Input: name
                })).filter((i)=>i.Value !== 1 && i.Value !== 999999);
        },
        /**
		 * Tworzy filtr lub kilka filtrów z wybranymi lokalizacjami z ostatniego filtra.
		 */ createFilter () {
            this.isLoading = true;
            this.$emit("filter-create", {
                categoryIds: this.selectedCategories.map((i)=>i.cid),
                location: this.selectedLocations
            });
        },
        /**
		 * Akcja po kliknięciu przycisku dodaj.
		 * Tworzy nowy filtr lub (jeżeli parametr `multi`) jest aktywny - kilka filtrów
		 * oraz przenosi użytkownika na ekran wyboru ceny.
		 * W przypadku kilku filtrów, po kliknięciu wyświetla ekran wyboru lokalizacji.
		 * Jeśli żaden z fitlrów nie został wybrany, pokaż komunikat walidacyjny.
		 */ onCreateButton () {
            const { length: length } = this.selectedCategories;
            if (length === 0) this.displayValidation = true;
            if (length === 1) this.pricingCategoryId = this.selectedCategories[0].cid;
            if (length > 1) {
                this.$emit("filter-create-template", 1, [], true);
                this.editLocation = true;
            }
            if (this.editLocation) this.createFilter();
        },
        /**
		 * Zaznacza lub odznacza wybraną kategorię z listy.
		 * Jeśli parametr `multi` nie jest aktywny, zamiast tego zastąp wybór danym elementem.
		 * @param {CategorySuggestion} category element na liście
		 */ async selectCategory (category) {
            if (!this.multi) {
                this.selectedCategories = [
                    category
                ];
                this.searchQuery = category.name;
                this.newCategoryAutocomplete.Value = [
                    "!",
                    category.name
                ];
            } else {
                const index = this.selectedCategories.findIndex((i)=>i.cid === category.cid);
                if (index === -1) this.selectedCategories.push(category);
                else this.selectedCategories.splice(index, 1);
            }
        },
        /**
		 * Wyszukuje kategorie wg. podanej `searchQuery` lub jeżeli jest pusta - listę sugerowanych kategorii.
		 */ async onSearch () {
            this.displayValidation = false;
            if (!this.multi) this.selectedCategories = [];
            const url = `/${this.apiNamespace}/get-suggested-categories.ofer?addNewCategoryUserInput=${this.searchQuery}&idCustomer=${this.customerId}`;
            const rsvp = await (0, $goO1A.default)(url);
            if (rsvp.suggestedCategories) this.searchList = rsvp.suggestedCategories.splice(0, this.multi ? 20 : 5);
        },
        backClick () {
            this.isNewCategory = false;
            this.currentPage = "";
            this.$router.back();
        }
    }
};

});
parcelRequire.register("5iLYC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3dc3d95b305a8dd9$export$2e2bcd8739ae039; });
let $3dc3d95b305a8dd9$var$script;



let $3dc3d95b305a8dd9$var$initialize = ()=>{
    $3dc3d95b305a8dd9$var$script = (parcelRequire("kSvSy"));
    if ($3dc3d95b305a8dd9$var$script.__esModule) $3dc3d95b305a8dd9$var$script = $3dc3d95b305a8dd9$var$script.default;
    $3dc3d95b305a8dd9$var$script.render = (parcelRequire("j4w4p")).render;
    (parcelRequire("e9gg3")).default($3dc3d95b305a8dd9$var$script);
    $3dc3d95b305a8dd9$var$script.__scopeId = "data-v-60d149";
    $3dc3d95b305a8dd9$var$script.__file = "FilterDetailsLocation.vue";
};
$3dc3d95b305a8dd9$var$initialize();
var $3dc3d95b305a8dd9$export$2e2bcd8739ae039 = $3dc3d95b305a8dd9$var$script;

});
parcelRequire.register("kSvSy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5dbe5d59be22ea57$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $5UCIl = parcelRequire("5UCIl");

var $cg0Ld = parcelRequire("cg0Ld");
var /**
 * Komponent wyświetlający ekran edycji lokalizacji filtra
 */ $5dbe5d59be22ea57$export$2e2bcd8739ae039 = {
    name: "FilterDetailsLocation",
    components: {
        DummyElement: $cg0Ld.default
    },
    props: {
        /**
		 * Główny obiekt usług
		 */ servicesObject: {
            type: Object,
            required: true
        },
        /**
		 * Aktualnie wybrany filtr
		 */ filter: {
            type: Object,
            required: true
        }
    },
    emits: [
        "save",
        "recalculate-potential-matches"
    ],
    data () {
        return {
            /**
			 * Ustawienia mapy z lokalizacjami
			 */ map: {
                /** Google Maps API */ google: undefined,
                /** Style dla wybranych rejonów do kliknięcia */ styles: {
                    default: {
                        strokeWeight: 2,
                        strokeColor: "#ff7800",
                        fillColor: "#ff7800"
                    },
                    false: {
                        fillOpacity: 0.0,
                        strokeOpacity: 0.15,
                        strokeColor: "#808080"
                    },
                    true: {
                        fillOpacity: 0.25,
                        strokeOpacity: 1.0,
                        strokeColor: "#ff7800"
                    },
                    blocked: {
                        fillOpacity: 0.25,
                        strokeOpacity: 1.0,
                        strokeColor: "#808080",
                        fillColor: "#808080"
                    },
                    disabled: {
                        fillOpacity: 0.25,
                        strokeOpacity: 1.0,
                        strokeColor: "#808080",
                        fillColor: "#808080"
                    },
                    "false-readonly": {
                        fillOpacity: 0.0,
                        strokeOpacity: 0.15,
                        strokeColor: "#808080"
                    },
                    "true-readonly": {
                        fillOpacity: 0.25,
                        strokeOpacity: 1.0,
                        strokeColor: "#808080",
                        fillColor: "#808080"
                    }
                }
            },
            /**
			 * Lista identyfikatorów lokalizacji odpowiadającym
			 * krają Unii Europejskiej
			 */ locationEU: [
                "locationA",
                "locationB",
                "locationBg",
                "locationHr",
                "locationCy",
                "locationCz",
                "locationDk",
                "locationEst",
                "locationFin",
                "locationF",
                "locationGr",
                "locationE",
                "locationNl",
                "locationIrl",
                "locationLt",
                "locationLv",
                "locationL",
                "locationM",
                "locationDe",
                "locationP",
                "locationRo",
                "locationS",
                "locationSk",
                "locationSlo",
                "locationH",
                "locationI"
            ]
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $5UCIl.useServicesStore), [
            "displaySaveChanges"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $5UCIl.useServicesStore), [
            "isFilterDirty"
        ]),
        /**
		 * Czy zaznaczone są wszystkie kraje UE?
		 */ isEUSelected () {
            const foreignItems = this.filter.locations.locationForeign.items;
            for (const key of this.locationEU){
                if (!foreignItems[key].selected) return false;
            }
            return true;
        }
    },
    methods: {
        /**
		 * Inicjalizuje mapę w momencie jej wyświetlenia
		 */ onMapVisible () {
            this.mapInit();
        },
        /**
		 * Pobiera Google Maps API, tworzy mapę oraz znajdujące się na niej klikalne rejony
		 */ mapInit () {
            var _this_filter_location;
            const { google: google } = window;
            if (typeof (google === null || google === void 0 ? void 0 : google.maps) === "undefined") {
                // Załaduj skrypt z Google Maps, jeżeli nie istineje i ponownie wywołaj tą funkcję.
                const script = document.createElement("script");
                window.googleMapsInit = ()=>{
                    this.mapInit();
                };
                script.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyDS_5FIo6F1j4kR2ntTHtZWWFvljo_zPP4&callback=googleMapsInit";
                document.body.appendChild(script);
                return;
            }
            // Utwórz mapę.
            if (!this.$refs.GoogleMapElement) return;
            const map = new google.maps.Map(this.$refs.GoogleMapElement, {
                zoom: 4,
                maxZoom: 9,
                minZoom: 4,
                center: {
                    lat: 51.935,
                    lng: 16.892
                },
                disableDefaultUI: true,
                gestureHandling: "greedy"
            });
            // Ustaw wygląd rejonu w zależności od jego wyglądu.
            map.data.setStyle((f)=>{
                const isReadonly = false;
                let style = String(f.getProperty("selected"));
                if (isReadonly) style += "-readonly";
                if (f.getProperty("disabled")) style = "disabled";
                if (f.getProperty("blocked")) style = "blocked";
                return {
                    ...this.map.styles.default,
                    ...this.map.styles[style]
                };
            });
            // Dodaj akcję kliknięcia w rejon.
            map.data.addListener("click", ({ feature: feature })=>{
                const isReadonly = false;
                if (isReadonly || feature.getProperty("blocked")) return;
                const isSelected = feature.getProperty("selected");
                feature.setProperty("selected", !isSelected);
                this.toggleLocation(feature.getProperty("name"), true);
            });
            // Dodaj klikalne rejony.
            const features = [];
            const selected = ((_this_filter_location = this.filter.location) === null || _this_filter_location === void 0 ? void 0 : _this_filter_location.selected) || [];
            const disabled = [];
            const blocked = [];
            for(const locationIndex in this.servicesObject.locations){
                if (locationIndex === "locationForeign") continue;
                const { items: items } = this.servicesObject.locations[locationIndex];
                // eslint-disable-next-line guard-for-in
                for(const itemIndex in items)features.push({
                    type: "Feature",
                    geometry: items[itemIndex].geo,
                    id: itemIndex,
                    properties: {
                        name: itemIndex,
                        region: locationIndex,
                        selected: selected.indexOf(itemIndex) > -1 || selected.indexOf(locationIndex) > -1,
                        disabled: disabled.indexOf(itemIndex) > -1 || disabled.indexOf(locationIndex) > -1,
                        blocked: blocked.indexOf(itemIndex) > -1 || blocked.indexOf(locationIndex) > -1
                    }
                });
            }
            map.data.addGeoJson({
                type: "FeatureCollection",
                features: features
            });
            this.map.google = map;
            window.setTimeout(()=>{
                this.mapFitBounds();
            }, 600);
        },
        /**
		 * Zaznacza lub odznacza wszystkie kraje Unii Europejskiej
		 */ toggleEU () {
            const foreignItems = this.filter.locations.locationForeign.items;
            this.locationEU.filter((key)=>!this.isEUSelected && !foreignItems[key].selected || this.isEUSelected).forEach((key)=>this.toggleLocation(key));
        },
        /**
		 * Zaznacza lub odznacza rejon na mapie, a następnie ustawia
		 * tablicę zaznaczonych lokalizacji filtru.
		 */ toggleLocation (locationName = "", isFromMap = false) {
            this.isFilterDirty = true;
            const change = {
                items: [],
                select: false,
                disableReason: ""
            };
            // Make the object...
            const { locations: locations } = this.filter;
            const locationProperties = locations[locationName];
            if (locationProperties) {
                const areAllSelected = locationProperties.selected && locationProperties.selected === Object.keys(locationProperties.items).length;
                locationProperties.selected = areAllSelected ? 0 : Object.keys(locationProperties.items).length;
                change.select = !areAllSelected;
                // eslint-disable-next-line guard-for-in
                for(const itemIndex in locationProperties.items){
                    locationProperties.items[itemIndex].selected = !areAllSelected;
                    change.items.push(itemIndex);
                }
            } else // eslint-disable-next-line guard-for-in
            for(const index in locations){
                const foundLocation = locations[index] && locations[index].items[locationName];
                if (foundLocation) {
                    const isSelected = locations[index].items[locationName].selected;
                    locations[index].items[locationName].selected = !isSelected;
                    locations[index].selected = isSelected ? locations[index].selected - 1 : locations[index].selected + 1;
                    change.select = !isSelected;
                    change.items.push(locationName);
                }
            }
            if (!isFromMap && this.map.google) {
                for (const index of change.items){
                    const feature = this.map.google.data.getFeatureById(index);
                    if (!feature) continue;
                    feature.setProperty("selected", change.select);
                }
                this.mapFitBounds();
            }
            // ...and cleanup this mess.
            const group = true;
            const result = [];
            // eslint-disable-next-line guard-for-in
            for(const index in locations){
                const areAllSelected = locations[index].selected && Object.keys(locations[index].items).length === locations[index].selected && group;
                const isSelected = locations[index].selected;
                if (areAllSelected && group && index !== "locationForeign") {
                    result.push(index);
                    continue;
                }
                if (!isSelected) continue;
                for(const itemIndex in locations[index].items)if (locations[index].items[itemIndex].selected) result.push(itemIndex);
            }
            if (this.filter.location) this.filter.location.selected = result;
            this.$emit("recalculate-potential-matches");
        },
        /**
		 * Próbuje dopasować mapę tak, aby zmieściły się na niej
		 * zaznaczone lokalizacje
		 */ mapFitBounds () {
            const { google: google } = window;
            const map = this.map.google;
            const bounds = new google.maps.LatLngBounds();
            let locationCount = 0;
            if (!map) return;
            map.data.forEach((mapFragment)=>{
                if (mapFragment.getProperty("selected")) {
                    var _mapFragment_getGeometry;
                    (_mapFragment_getGeometry = mapFragment.getGeometry()) === null || _mapFragment_getGeometry === void 0 ? void 0 : _mapFragment_getGeometry.forEachLatLng((latlng)=>{
                        bounds.extend(latlng);
                    });
                    locationCount++;
                }
            });
            if (locationCount) map.fitBounds(bounds, 16);
        }
    }
};

});

parcelRequire.register("j4w4p", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $de274484a82f0cf3$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $de274484a82f0cf3$var$_hoisted_1 = {
    class: "basis-1/2"
};
const $de274484a82f0cf3$var$_hoisted_2 = [
    "onClick"
];
const $de274484a82f0cf3$var$_hoisted_3 = [
    "onClick"
];
const $de274484a82f0cf3$var$_hoisted_4 = [
    "innerHTML"
];
const $de274484a82f0cf3$var$_hoisted_5 = {
    key: 0,
    class: "text-xs text-neutral-700"
};
const $de274484a82f0cf3$var$_hoisted_6 = {
    key: 0,
    class: "flex flex-wrap items-center px-3 pt-3 border-t border-black/10"
};
const $de274484a82f0cf3$var$_hoisted_7 = [
    "onClick",
    "innerHTML"
];
const $de274484a82f0cf3$var$_hoisted_8 = {
    class: "sticky top-0 rounded bg-neutral-100 aspect-square"
};
const $de274484a82f0cf3$var$_hoisted_9 = {
    ref: "GoogleMapElement",
    class: "absolute inset-0 flex items-center justify-center"
};
function $de274484a82f0cf3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_DummyElement = (0, $cfZzL.resolveComponent)("DummyElement");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        "data-component": "FilterDetailsLocation.vue",
        class: (0, $4bH2P.normalizeClass)([
            "flex flex-col-reverse lg:flex-row",
            {
                "inactive-panel": !$props.filter.isActive
            }
        ])
    }, [
        (0, $cfZzL.createElementVNode)("div", $de274484a82f0cf3$var$_hoisted_1, [
            ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($props.filter.locations, (group, key)=>{
                return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                    key: key,
                    class: "-mb-px border-neutral-100 border-y"
                }, [
                    (0, $cfZzL.createElementVNode)("div", {
                        class: "flex items-center h-12 px-3",
                        onClick: ($event)=>group.expanded = !group.expanded
                    }, [
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "mr-2 cursor-pointer input-control",
                            onClick: (0, $brqXq.withModifiers)(($event)=>$options.toggleLocation(String(key)), [
                                "stop"
                            ])
                        }, [
                            (0, $cfZzL.createElementVNode)("div", {
                                class: (0, $4bH2P.normalizeClass)([
                                    "is-checkbox",
                                    {
                                        "is-checked": group.selected
                                    }
                                ])
                            }, null, 2)
                        ], 8, $de274484a82f0cf3$var$_hoisted_3),
                        (0, $cfZzL.createElementVNode)("div", null, [
                            (0, $cfZzL.createElementVNode)("div", {
                                class: "text-base",
                                innerHTML: group.name
                            }, null, 8, $de274484a82f0cf3$var$_hoisted_4),
                            group.selected ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $de274484a82f0cf3$var$_hoisted_5, [
                                group.selected !== Object.keys(group.items).length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                    key: 0
                                }, [
                                    (0, $cfZzL.createTextVNode)((0, $4bH2P.toDisplayString)(`${group.selected} z ${Object.keys(group.items).length} ${String(key) === "locationForeign" ? "kraj\xf3w" : "powiat\xf3w"}`), 1)
                                ], 64)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                    key: 1
                                }, [
                                    (0, $cfZzL.createTextVNode)(" Wszystkie " + (0, $4bH2P.toDisplayString)(String(key) === "locationForeign" ? "kraje" : "powiaty"), 1)
                                ], 64))
                            ])) : (0, $cfZzL.createCommentVNode)("", true)
                        ]),
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "chevron-right",
                            size: "0.75",
                            class: (0, $4bH2P.normalizeClass)([
                                "ml-auto text-black",
                                group.expanded ? "-rotate-90" : "rotate-90"
                            ])
                        }, null, 8, [
                            "class"
                        ])
                    ], 8, $de274484a82f0cf3$var$_hoisted_2),
                    group.expanded ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $de274484a82f0cf3$var$_hoisted_6, [
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(group.items, (item, itemKey, i)=>{
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, [
                                i === 0 && String(key) === "locationForeign" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                    key: `${itemKey}ue`,
                                    class: (0, $4bH2P.normalizeClass)([
                                        "px-2 py-1 mb-3 mr-1 text-xs border rounded-full border-black/10",
                                        {
                                            "is-selected | text-info !border-info": $options.isEUSelected
                                        }
                                    ]),
                                    onClick: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)((...args)=>$options.toggleEU && $options.toggleEU(...args), [
                                        "stop"
                                    ])),
                                    innerHTML: "UE"
                                }, null, 2)) : (0, $cfZzL.createCommentVNode)("", true),
                                item.name !== "Polska" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                    key: itemKey,
                                    class: (0, $4bH2P.normalizeClass)([
                                        "px-2 py-1 mb-3 mr-1 text-xs border rounded-full border-black/10",
                                        {
                                            "is-selected | text-info !border-info": item.selected
                                        }
                                    ]),
                                    onClick: (0, $brqXq.withModifiers)(($event)=>$options.toggleLocation(String(itemKey), false), [
                                        "stop"
                                    ]),
                                    innerHTML: item.name
                                }, null, 10, $de274484a82f0cf3$var$_hoisted_7)) : (0, $cfZzL.createCommentVNode)("", true)
                            ], 64);
                        }), 256))
                    ])) : (0, $cfZzL.createCommentVNode)("", true)
                ]);
            }), 128))
        ]),
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "sticky lg:static top-16 lg:top-24 lg:px-3 w-full basis-1/2 aspect-[2/1] lg:aspect-square overflow-hidden",
                {
                    "inactive-panel": !$props.filter.isActive
                }
            ])
        }, [
            (0, $cfZzL.createElementVNode)("div", $de274484a82f0cf3$var$_hoisted_8, [
                (0, $cfZzL.createElementVNode)("div", $de274484a82f0cf3$var$_hoisted_9, null, 512),
                (0, $cfZzL.createVNode)(_component_DummyElement, {
                    onMounted: $options.onMapVisible
                }, null, 8, [
                    "onMounted"
                ])
            ])
        ], 2)
    ], 2);
}

});

parcelRequire.register("e9gg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4ce8474e9492996$export$2e2bcd8739ae039; });
let $a4ce8474e9492996$var$NOOP = ()=>{};
var $a4ce8474e9492996$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("kUqgA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f38d699921ea1749$export$2e2bcd8739ae039; });
let $f38d699921ea1749$var$script;



let $f38d699921ea1749$var$initialize = ()=>{
    $f38d699921ea1749$var$script = (parcelRequire("bJj0y"));
    if ($f38d699921ea1749$var$script.__esModule) $f38d699921ea1749$var$script = $f38d699921ea1749$var$script.default;
    $f38d699921ea1749$var$script.render = (parcelRequire("kVq5h")).render;
    (parcelRequire("2EV3C")).default($f38d699921ea1749$var$script);
    $f38d699921ea1749$var$script.__scopeId = "data-v-bfb0b0";
    $f38d699921ea1749$var$script.__file = "FilterPricing.vue";
};
$f38d699921ea1749$var$initialize();
var $f38d699921ea1749$export$2e2bcd8739ae039 = $f38d699921ea1749$var$script;

});
parcelRequire.register("bJj0y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e56d2b9301d7cabe$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $5UCIl = parcelRequire("5UCIl");

var $goO1A = parcelRequire("goO1A");
var $e56d2b9301d7cabe$export$2e2bcd8739ae039 = {
    name: "FilterPricing",
    props: {
        /**
		 * Główny obiekt usług
		 */ servicesObject: {
            type: Object,
            required: true
        },
        /**
		 * Początek ścieżki do API.
		 */ apiNamespace: {
            type: String,
            required: true
        },
        /**
		 * Identyfikator kategorii dla której ma być edytowana cena.
		 */ categoryId: {
            type: Number,
            required: true
        }
    },
    emits: [
        "filter-change",
        "save-button-clicked",
        "send-analytics-event"
    ],
    data () {
        return {
            /**
			 * Czy istnieją jakieś błędy walidacji?
			 */ validationMessage: "",
            /**
			 * Czy załadowano informacje o cenach?
			 */ isLoaded: false,
            /**
			 * Pobrane z serwera informacje o cenach
			 */ pricingInfo: {},
            /**
			 * Obsługa zdarzeń pól z wpisaniem ceny
			 */ inputHandlers: {
                blur: this.onBlur,
                input: this.onInput,
                change: this.onChange
            }
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $5UCIl.useServicesStore), [
            "customerId"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $5UCIl.useServicesStore), [
            "currentPage",
            "isNewCategory",
            "pricingCategoryId",
            "isFilterDirty"
        ]),
        /**
		 * Czy przycisk do zapisu jest aktywny? Nie powinien być w przypadku,
		 * kiedy jest wyświetlony błąd walidacji
		 */ isSaveButtonDisabled () {
            return !!this.validationMessage;
        }
    },
    mounted () {
        this.onLoad(this.categoryId);
    },
    methods: {
        async onLoad (categoryId) {
            const rsvp = await (0, $goO1A.default)(`/${this.apiNamespace}/get-category-pricing.ofer`, {
                "customerCategoryPricing.idCategory": categoryId,
                "customerCategoryPricing.idCustomer": this.customerId
            }, "POST");
            if (this.isNewCategory) this.$emit("save-button-clicked", {
                source: "no-price-for-this-category"
            });
            else {
                this.currentPage = "";
                this.pricingCategoryId = 0;
                this.$router.back();
            }
            return;
            const { result: result } = rsvp;
            if (Number(result.from) < 1) result.from = null;
            if (Number(result.to) < 1) result.to = null;
            this.pricingInfo = result;
            this.isLoaded = true;
        },
        onChange () {
            if (this.isFilterDirty || !this.isNewCategory) return;
            this.$emit("filter-change");
            this.isFilterDirty = true;
        },
        /**
		 * Wyświetla komunikat walidacyjny w momencie, kiedy cena "do" jest niższa od "od",
		 */ onBlur () {
            const { from: from, to: to } = this.pricingInfo;
            this.validationMessage = "";
            if (to && to > 0 && Number(to) < Number(from)) this.validationMessage = "Cena końcowa nie może być niższa od początkowej";
            if (from && from < 1 || to && to < 1 || from && from > 1000000 || to && to > 1000000) this.validationMessage = "Wpisz liczbę od 1 do 999 999";
            const isFromNotInt = from && String(Number.parseInt(String(from), 10)) !== String(from);
            const isToNotInt = to && String(Number.parseInt(String(to), 10)) !== String(to);
            if (isFromNotInt || isToNotInt) this.validationMessage = "Wpisz liczbę całkowitą";
        },
        /**
		 * Usuwa nienumeryczne znaki podczas wpisywania wartości
		 * @param e Obiekt zdarzenia
		 */ onInput (e) {
            this.validationMessage = "";
            const el = e.target;
            const val = Number.parseInt(el.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1").replace(/^0[^.]/, "0"), 10);
            el.value = String(val || "");
        },
        /**
		 * Pomija ekran o cenie podczas dodawania nowej kategorii
		 */ onSkipButton () {
            this.pricingInfo.from = 0;
            this.pricingInfo.to = 0;
            this.$emit("save-button-clicked", {
                source: "price"
            });
            this.$emit("send-analytics-event", "Pricing_Skip", "pricing_skip");
        },
        /**
		 * Zapisuje dane o cenie
		 * @param withEvent Czy po udanym zapisie wysłać event `save-button-clicked`?
		 */ async savePrice (withEvent = false) {
            var _params, _customerCategoryPricingfrom, _params1, _customerCategoryPricingto;
            const params = Object.keys(this.pricingInfo).reduce((a, c)=>(a[`customerCategoryPricing.${c}`] = this.pricingInfo[c], a), {});
            (_params = params)[_customerCategoryPricingfrom = "customerCategoryPricing.from"] || (_params[_customerCategoryPricingfrom] = 0);
            (_params1 = params)[_customerCategoryPricingto = "customerCategoryPricing.to"] || (_params1[_customerCategoryPricingto] = 0);
            const rsvp = await (0, $goO1A.default)(`/${this.apiNamespace}/set-category-pricing.ofer`, params, "POST");
            if (rsvp.validation) {
                this.validationMessage = rsvp.validation;
                return false;
            }
            if (withEvent) this.$emit("save-button-clicked", {
                source: "price"
            });
            return true;
        },
        backClick () {
            this.$router.back();
        }
    }
};

});

parcelRequire.register("kVq5h", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $f3bd5d47e18dac6b$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $brqXq = parcelRequire("brqXq");
const $f3bd5d47e18dac6b$var$_hoisted_1 = {
    key: 0,
    "data-component": "FilterPricing.vue",
    class: "a-loaded"
};
const $f3bd5d47e18dac6b$var$_hoisted_2 = {
    class: "p-5"
};
const $f3bd5d47e18dac6b$var$_hoisted_3 = {
    class: "font-extrabold pb-3"
};
const $f3bd5d47e18dac6b$var$_hoisted_4 = [
    "innerHTML"
];
const $f3bd5d47e18dac6b$var$_hoisted_5 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, [
    /*#__PURE__*/ (0, $cfZzL.createTextVNode)(" To tylko "),
    /*#__PURE__*/ (0, $cfZzL.createElementVNode)("span", {
        class: "font-extrabold"
    }, "szacunkowe kwoty"),
    /*#__PURE__*/ (0, $cfZzL.createTextVNode)(". Pokażemy je Twoim Klientom po złożeniu zapytania. ")
], -1);
const $f3bd5d47e18dac6b$var$_hoisted_6 = [
    "innerHTML"
];
const $f3bd5d47e18dac6b$var$_hoisted_7 = {
    class: "flex items-center mt"
};
const $f3bd5d47e18dac6b$var$_hoisted_8 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "mr-2",
    innerHTML: "od"
}, null, -1);
const $f3bd5d47e18dac6b$var$_hoisted_9 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "mx-2",
    innerHTML: "do"
}, null, -1);
const $f3bd5d47e18dac6b$var$_hoisted_10 = [
    "innerHTML"
];
const $f3bd5d47e18dac6b$var$_hoisted_11 = [
    "innerHTML"
];
const $f3bd5d47e18dac6b$var$_hoisted_12 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "lg:hidden h-24"
}, null, -1);
const $f3bd5d47e18dac6b$var$_hoisted_13 = {
    class: "lg:sticky shadow-default z-2 lg:bg-white/50 lg:shadow-white fixed inset-x-0 bottom-0 flex justify-end p-3 bg-white lg:w-max lg:ml-auto"
};
const $f3bd5d47e18dac6b$var$_hoisted_14 = [
    "disabled"
];
const $f3bd5d47e18dac6b$var$_hoisted_15 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "mx-1 lg:mx-auto"
}, null, -1);
const $f3bd5d47e18dac6b$var$_hoisted_16 = [
    "disabled"
];
const $f3bd5d47e18dac6b$var$_hoisted_17 = [
    "disabled",
    "innerHTML"
];
function $f3bd5d47e18dac6b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PageHeader = (0, $cfZzL.resolveComponent)("PageHeader");
    return $data.isLoaded ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $f3bd5d47e18dac6b$var$_hoisted_1, [
        !_ctx.isNewCategory ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_PageHeader, {
            key: 0,
            Back: true,
            BackOnDesktop: true,
            EmitInstead: true,
            Title: "Cena",
            onBackClick: $options.backClick
        }, null, 8, [
            "onBackClick"
        ])) : (0, $cfZzL.createCommentVNode)("", true),
        (0, $cfZzL.createElementVNode)("div", $f3bd5d47e18dac6b$var$_hoisted_2, [
            (0, $cfZzL.createElementVNode)("div", $f3bd5d47e18dac6b$var$_hoisted_3, [
                (0, $cfZzL.createTextVNode)(" Jak wyceniasz swoją usługę: "),
                (0, $cfZzL.createElementVNode)("div", {
                    class: "text-lg",
                    innerHTML: `${$data.pricingInfo.categoryLabel}?`
                }, null, 8, $f3bd5d47e18dac6b$var$_hoisted_4)
            ]),
            $f3bd5d47e18dac6b$var$_hoisted_5,
            (0, $cfZzL.createElementVNode)("div", null, [
                (0, $cfZzL.createElementVNode)("div", {
                    class: "font-extrabold py-5",
                    innerHTML: $data.pricingInfo.helperLabel
                }, null, 8, $f3bd5d47e18dac6b$var$_hoisted_6),
                (0, $cfZzL.createElementVNode)("div", $f3bd5d47e18dac6b$var$_hoisted_7, [
                    $f3bd5d47e18dac6b$var$_hoisted_8,
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", (0, $cfZzL.mergeProps)({
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.pricingInfo.from = $event),
                        type: "text",
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        placeholder: "0",
                        class: "text-center basis-16 px-0",
                        maxlength: "6"
                    }, (0, $cfZzL.toHandlers)($data.inputHandlers, true)), null, 16), [
                        [
                            (0, $brqXq.vModelText),
                            $data.pricingInfo.from
                        ]
                    ]),
                    $f3bd5d47e18dac6b$var$_hoisted_9,
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", (0, $cfZzL.mergeProps)({
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.pricingInfo.to = $event),
                        type: "text",
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        placeholder: "0",
                        class: "text-center basis-16 px-0",
                        maxlength: "6"
                    }, (0, $cfZzL.toHandlers)($data.inputHandlers, true)), null, 16), [
                        [
                            (0, $brqXq.vModelText),
                            $data.pricingInfo.to
                        ]
                    ]),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: "ml-2",
                        innerHTML: $data.pricingInfo.unitLabel
                    }, null, 8, $f3bd5d47e18dac6b$var$_hoisted_10)
                ]),
                (0, $cfZzL.createElementVNode)("div", {
                    class: "form-input-validation | text-danger text-xs mt-2",
                    innerHTML: $data.validationMessage
                }, null, 8, $f3bd5d47e18dac6b$var$_hoisted_11)
            ])
        ]),
        $f3bd5d47e18dac6b$var$_hoisted_12,
        (0, $cfZzL.createElementVNode)("div", $f3bd5d47e18dac6b$var$_hoisted_13, [
            _ctx.isNewCategory ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                key: 0
            }, [
                (0, $cfZzL.createElementVNode)("button", {
                    class: "btn btn-white lg:w-auto w-1/2 | px-0 lg:px-3 font-normal",
                    disabled: $options.isSaveButtonDisabled,
                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.onSkipButton && $options.onSkipButton(...args)),
                    innerHTML: "Przypomnij p\xf3źniej"
                }, null, 8, $f3bd5d47e18dac6b$var$_hoisted_14),
                $f3bd5d47e18dac6b$var$_hoisted_15,
                (0, $cfZzL.createElementVNode)("button", {
                    class: "btn btn-primary lg:w-auto w-1/2",
                    disabled: $options.isSaveButtonDisabled,
                    onClick: _cache[3] || (_cache[3] = ($event)=>$options.savePrice(true)),
                    innerHTML: "Dalej"
                }, null, 8, $f3bd5d47e18dac6b$var$_hoisted_16)
            ], 64)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                key: 1,
                class: "btn btn-primary lg:w-auto w-full",
                disabled: $options.isSaveButtonDisabled,
                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("save-button-clicked", {
                        source: "price"
                    })),
                innerHTML: _ctx.isFilterDirty ? "Zapisz" : "Gotowe"
            }, null, 8, $f3bd5d47e18dac6b$var$_hoisted_17))
        ])
    ])) : (0, $cfZzL.createCommentVNode)("", true);
}

});

parcelRequire.register("2EV3C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1efb939dfb73a463$export$2e2bcd8739ae039; });
let $1efb939dfb73a463$var$NOOP = ()=>{};
var $1efb939dfb73a463$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("iNQUu", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $db05d87299a9d409$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $db05d87299a9d409$var$_hoisted_1 = {
    key: 0,
    class: "relative h-1 bg-neutral-300 -top-1 z-48"
};
const $db05d87299a9d409$var$_hoisted_2 = {
    key: 0,
    class: "min-h-[12rem]"
};
const $db05d87299a9d409$var$_hoisted_3 = {
    class: "relative form-input"
};
const $db05d87299a9d409$var$_hoisted_4 = {
    class: "pt-6"
};
const $db05d87299a9d409$var$_hoisted_5 = {
    class: "flex flex-wrap gap-2 my-4"
};
const $db05d87299a9d409$var$_hoisted_6 = [
    "onClick",
    "innerHTML"
];
const $db05d87299a9d409$var$_hoisted_7 = {
    key: 1
};
const $db05d87299a9d409$var$_hoisted_8 = {
    class: "relative my-5 form-input"
};
const $db05d87299a9d409$var$_hoisted_9 = {
    key: 0,
    class: "mt-1 text-xs text-danger"
};
const $db05d87299a9d409$var$_hoisted_10 = {
    class: "overflow-auto"
};
const $db05d87299a9d409$var$_hoisted_11 = [
    "innerHTML"
];
const $db05d87299a9d409$var$_hoisted_12 = [
    "innerHTML"
];
const $db05d87299a9d409$var$_hoisted_13 = [
    "onClick",
    "innerHTML"
];
const $db05d87299a9d409$var$_hoisted_14 = {
    key: 0,
    class: "overflow-auto border-t border-neutral-100 max-h-32"
};
const $db05d87299a9d409$var$_hoisted_15 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "sticky top-0 pt-3 text-xs font-bold bg-white text-neutral-700",
    innerHTML: "Wybrane usługi:"
}, null, -1);
const $db05d87299a9d409$var$_hoisted_16 = [
    "onClick",
    "innerHTML"
];
const $db05d87299a9d409$var$_hoisted_17 = {
    key: 2
};
const $db05d87299a9d409$var$_hoisted_18 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "h-24 lg:hidden"
}, null, -1);
const $db05d87299a9d409$var$_hoisted_19 = {
    class: "fixed inset-x-0 bottom-0 flex justify-end p-3 bg-white lg:sticky shadow-default z-2 lg:bg-white/50 lg:shadow-white lg:w-max lg:ml-auto"
};
const $db05d87299a9d409$var$_hoisted_20 = {
    key: 2
};
function $db05d87299a9d409$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PageHeader = (0, $cfZzL.resolveComponent)("PageHeader");
    const _component_Autocomplete = (0, $cfZzL.resolveComponent)("Autocomplete");
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_FilterDetailsLocation = (0, $cfZzL.resolveComponent)("FilterDetailsLocation");
    const _component_FilterPricing = (0, $cfZzL.resolveComponent)("FilterPricing");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        "data-component": "FilterCreate.vue",
        class: (0, $4bH2P.normalizeClass)([
            "a-loaded",
            {
                "opacity-10 pointer-events-none": $data.isLoading
            }
        ])
    }, [
        (0, $cfZzL.createVNode)(_component_PageHeader, {
            Back: true,
            BackOnDesktop: true,
            EmitInstead: true,
            Title: "Dodaj usługę",
            HideBg: _ctx.ScreenSize > 1,
            onBackClick: $options.backClick
        }, null, 8, [
            "HideBg",
            "onBackClick"
        ]),
        _ctx.ScreenSize <= 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $db05d87299a9d409$var$_hoisted_1, [
            (0, $cfZzL.createElementVNode)("div", {
                class: "top-0 left-0 h-1 transition-all p-absolute bg-accent",
                style: (0, $4bH2P.normalizeStyle)({
                    width: $options.progressBarDone
                })
            }, null, 4)
        ])) : (0, $cfZzL.createCommentVNode)("", true),
        !_ctx.pricingCategoryId ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 1,
            class: (0, $4bH2P.normalizeClass)(!$data.editLocation && !$props.multi ? "bg-white p-6 lg:rounded-lg shadow flex flex-col gap-6 mt-3 lg:mx-5 lg:mt-6" : "lg:py-2 px-5")
        }, [
            !$data.editLocation && !$props.multi ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $db05d87299a9d409$var$_hoisted_2, [
                (0, $cfZzL.createElementVNode)("div", $db05d87299a9d409$var$_hoisted_3, [
                    (0, $cfZzL.createVNode)(_component_Autocomplete, {
                        modelValue: $options.newCategoryAutocomplete.Value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$options.newCategoryAutocomplete.Value = $event),
                        class: "filter-create-autocomplete | [&>input]:pl-10",
                        Autocomplete: $options.newCategoryAutocomplete.Autocomplete,
                        Suggestions: $options.newCategoryAutocomplete.Suggestions,
                        Placeholder: "Zacznij pisać nazwę usługi",
                        IgnoreValues: [
                            1,
                            999999
                        ],
                        Autoselect: false,
                        onSelect: $options.autocompleteSelect,
                        onProcess: $options.autocompleteProcess
                    }, null, 8, [
                        "modelValue",
                        "Autocomplete",
                        "Suggestions",
                        "onSelect",
                        "onProcess"
                    ]),
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "search",
                        size: "1.25",
                        class: "absolute pointer-events-none left-2 top-4 text-neutral-300"
                    })
                ]),
                (0, $cfZzL.createElementVNode)("div", $db05d87299a9d409$var$_hoisted_4, [
                    (0, $cfZzL.createTextVNode)(" Pasujące do Ciebie: "),
                    (0, $cfZzL.createElementVNode)("div", $db05d87299a9d409$var$_hoisted_5, [
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.searchList, (item)=>{
                            var _$data_selectedCategories_;
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                key: item.cid,
                                class: (0, $4bH2P.normalizeClass)([
                                    "px-3 py-1 text-sm border rounded-full cursor-pointer",
                                    item.cid === ((_$data_selectedCategories_ = $data.selectedCategories[0]) === null || _$data_selectedCategories_ === void 0 ? void 0 : _$data_selectedCategories_.cid) ? "bg-info text-white border-info" : "border-neutral-300"
                                ]),
                                onClick: ($event)=>$options.selectCategory(item),
                                innerHTML: item.name + (item.service ? "" : " <small>Sprzedaż</small>")
                            }, null, 10, $db05d87299a9d409$var$_hoisted_6);
                        }), 128))
                    ])
                ])
            ])) : !$data.editLocation ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $db05d87299a9d409$var$_hoisted_7, [
                (0, $cfZzL.createElementVNode)("div", $db05d87299a9d409$var$_hoisted_8, [
                    (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                        ref: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.searchQuery = $event),
                        type: "search",
                        class: "pl-10",
                        placeholder: "Znajdź swoją usługę",
                        autofocus: "",
                        onKeyup: _cache[2] || (_cache[2] = (...args)=>$options.onSearch && $options.onSearch(...args)),
                        onChange: _cache[3] || (_cache[3] = (...args)=>$options.onSearch && $options.onSearch(...args)),
                        onSearch: _cache[4] || (_cache[4] = (...args)=>$options.onSearch && $options.onSearch(...args))
                    }, null, 544), [
                        [
                            (0, $brqXq.vModelText),
                            $data.searchQuery
                        ]
                    ]),
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "search",
                        size: "1.25",
                        class: "absolute pointer-events-none left-2 top-4 text-neutral-300"
                    }),
                    $data.displayValidation ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $db05d87299a9d409$var$_hoisted_9, " Zacznij pisać nazwę usługi i wybierz jedną z podpowiedzi ")) : (0, $cfZzL.createCommentVNode)("", true)
                ]),
                (0, $cfZzL.createElementVNode)("div", {
                    class: "flex flex-col",
                    style: (0, $4bH2P.normalizeStyle)({
                        "max-height": `calc(100vh - ${_ctx.ScreenSize > 1 ? 21 : 16}rem)`
                    })
                }, [
                    (0, $cfZzL.createElementVNode)("div", $db05d87299a9d409$var$_hoisted_10, [
                        !$data.searchList.length && $data.searchQuery ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 0,
                            class: "my-3 font-bold",
                            innerHTML: `Przykro nam, nie znaleźliśmy usługi o nazwie ${$data.searchQuery}.`
                        }, null, 8, $db05d87299a9d409$var$_hoisted_11)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: 1,
                            class: "sticky top-0 pt-3 text-xs font-bold bg-white text-neutral-700",
                            innerHTML: $data.searchQuery ? "Znaleziono dla Ciebie:" : "Proponowane dla Ciebie:"
                        }, null, 8, $db05d87299a9d409$var$_hoisted_12)),
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.searchList, (item)=>{
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                key: item.cid,
                                class: (0, $4bH2P.normalizeClass)([
                                    "pl-3 my-3 cursor-pointer hover:text-accent",
                                    {
                                        "text-accent": $data.selectedCategories.find((i)=>i.cid === item.cid),
                                        "hidden": item.cid === 999999
                                    }
                                ]),
                                onClick: ($event)=>$options.selectCategory(item),
                                innerHTML: `${item.name} ${!item.service ? "<small>Sprzedaż</small>" : ""}`
                            }, null, 10, $db05d87299a9d409$var$_hoisted_13);
                        }), 128))
                    ]),
                    $props.multi && $data.selectedCategories.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $db05d87299a9d409$var$_hoisted_14, [
                        $db05d87299a9d409$var$_hoisted_15,
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.selectedCategories, (item)=>{
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                key: item.cid,
                                class: "pl-3 my-3 cursor-pointer hover:text-accent",
                                onClick: ($event)=>$options.selectCategory(item),
                                innerHTML: `${item.name} ${!item.service ? "<small>Sprzedaż</small>" : ""}`
                            }, null, 8, $db05d87299a9d409$var$_hoisted_16);
                        }), 128))
                    ])) : (0, $cfZzL.createCommentVNode)("", true)
                ], 4)
            ])) : $data.editLocation ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $db05d87299a9d409$var$_hoisted_17, [
                $props.filter ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_FilterDetailsLocation, {
                    key: 0,
                    servicesObject: $props.servicesObject,
                    filter: $props.filter
                }, null, 8, [
                    "servicesObject",
                    "filter"
                ])) : (0, $cfZzL.createCommentVNode)("", true)
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            $db05d87299a9d409$var$_hoisted_18,
            (0, $cfZzL.createElementVNode)("div", $db05d87299a9d409$var$_hoisted_19, [
                (0, $cfZzL.createElementVNode)("button", {
                    class: (0, $4bH2P.normalizeClass)([
                        "w-full btn btn-primary lg:w-auto",
                        {
                            "bg-neutral-300 hover:bg-neutral-300": !$data.selectedCategories.length
                        }
                    ]),
                    onClick: _cache[5] || (_cache[5] = (...args)=>$options.onCreateButton && $options.onCreateButton(...args)),
                    innerHTML: "Dodaj usługę"
                }, null, 2)
            ])
        ], 2)) : _ctx.pricingCategoryId ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $db05d87299a9d409$var$_hoisted_20, [
            (0, $cfZzL.createVNode)(_component_FilterPricing, {
                ref: "FilterPricing",
                servicesObject: $props.servicesObject,
                apiNamespace: $props.apiNamespace,
                categoryId: _ctx.pricingCategoryId,
                onSaveButtonClicked: $options.createFilter,
                onSendAnalyticsEvent: _cache[6] || (_cache[6] = ($event)=>_ctx.$emit("send-analytics-event", $event))
            }, null, 8, [
                "servicesObject",
                "apiNamespace",
                "categoryId",
                "onSaveButtonClicked"
            ])
        ])) : (0, $cfZzL.createCommentVNode)("", true)
    ], 2);
}

});

parcelRequire.register("8cSle", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f9998c881bd81ba$export$2e2bcd8739ae039; });
let $5f9998c881bd81ba$var$NOOP = ()=>{};
var $5f9998c881bd81ba$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("gJk1o", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("dtXZI"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("6VumZ")),
    (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("6Qx2i"))
]).then(()=>parcelRequire("jPaIf"));

});

parcelRequire.register("5vWva", function(module, exports) {



module.exports = (parcelRequire("bxz2b"))((parcelRequire("3H3FI")).getBundleURL("7IBUd") + (parcelRequire("johqs")).resolve("fsG04")).then(()=>parcelRequire("3S2hb"));

});


parcelRequire.register("hP4uj", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $cf9aae4d9602795d$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $brqXq = parcelRequire("brqXq");
var $4bH2P = parcelRequire("4bH2P");
const $cf9aae4d9602795d$var$_hoisted_1 = {
    "data-component": "ServicesPage.vue",
    class: "services-container | max-w-4xl mx-auto"
};
const $cf9aae4d9602795d$var$_hoisted_2 = {
    class: "a-loaded"
};
function $cf9aae4d9602795d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loader = (0, $cfZzL.resolveComponent)("Loader");
    const _component_PromptDialog = (0, $cfZzL.resolveComponent)("PromptDialog");
    const _component_FilterList = (0, $cfZzL.resolveComponent)("FilterList");
    const _component_FilterDetails = (0, $cfZzL.resolveComponent)("FilterDetails");
    const _component_FilterPricing = (0, $cfZzL.resolveComponent)("FilterPricing");
    const _component_FilterCreate = (0, $cfZzL.resolveComponent)("FilterCreate");
    const _component_RecommendationFeedbackModal = (0, $cfZzL.resolveComponent)("RecommendationFeedbackModal");
    const _component_TenPercentDiscountConfirmationModal = (0, $cfZzL.resolveComponent)("TenPercentDiscountConfirmationModal");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $cf9aae4d9602795d$var$_hoisted_1, [
        (0, $cfZzL.withDirectives)((0, $cfZzL.createVNode)(_component_Loader, null, null, 512), [
            [
                (0, $brqXq.vShow),
                _ctx.isLoading
            ]
        ]),
        (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("div", $cf9aae4d9602795d$var$_hoisted_2, [
            (0, $cfZzL.createElementVNode)("div", null, [
                (0, $cfZzL.createVNode)(_component_PromptDialog, {
                    modelValue: Boolean(_ctx.$route.query.removeGroupModalVisible),
                    historyMode: false,
                    title: `Na pewno chcesz usunąć ${_ctx.groupsToRemove && _ctx.groupsToRemove.length > 1 ? _ctx.Format.PluralForm(_ctx.groupsToRemove.length, [
                        "usługę",
                        "usługi",
                        "usług"
                    ], true) : "tę usługę"}?`,
                    body: "Nie będziesz już dostawać zleceń na tę usługę, a wszystkie jej ustawienia zostaną utracone",
                    "dismiss-text": `Nie, nie usuwaj  ${_ctx.groupsToRemove && _ctx.groupsToRemove.length > 1 ? "usług" : "usługi"}`,
                    "confirm-text": `Tak, usuń ${_ctx.groupsToRemove && _ctx.groupsToRemove.length > 1 ? "usługi" : "usługę"}`,
                    onConfirmed: _cache[0] || (_cache[0] = ($event)=>{
                        $options.removeGroups(_ctx.groupsToRemove);
                    }),
                    onDismissed: $options.cancelRemoveGroupModal
                }, null, 8, [
                    "modelValue",
                    "title",
                    "dismiss-text",
                    "confirm-text",
                    "onDismissed"
                ]),
                (0, $cfZzL.createVNode)(_component_PromptDialog, {
                    modelValue: Boolean(_ctx.$route.query.removeModalVisible),
                    historyMode: false,
                    title: `Na pewno chcesz usunąć ${_ctx.filterToRemove.type === "quick" ? "ten Szybki Kontakt" : "to Polecanie"}?`,
                    body: "Nie będziesz już dostawać zleceń na tę usługę, a wszystkie jej ustawienia zostaną utracone",
                    "dismiss-text": `Nie, nie usuwaj  ${_ctx.filterToRemove.type === "quick" ? "tego Szybkiego Kontaktu" : "tego Polecania"}`,
                    "confirm-text": `Tak, usuń ${_ctx.filterToRemove.type === "quick" ? "ten Szybki Kontakt" : "to Polecanie"}`,
                    onConfirmed: _cache[1] || (_cache[1] = ($event)=>{
                        $options.removeFilter(_ctx.filterToRemove);
                    }),
                    onDismissed: $options.cancelRemoveModal
                }, null, 8, [
                    "modelValue",
                    "title",
                    "dismiss-text",
                    "confirm-text",
                    "onDismissed"
                ]),
                (0, $cfZzL.createVNode)(_component_PromptDialog, {
                    modelValue: _ctx.displaySaveChanges,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>_ctx.displaySaveChanges = $event),
                    "history-mode": false,
                    title: "Czy chcesz zapisać zmiany?",
                    "confirm-text": "Tak, zapisz zmiany",
                    "dismiss-text": "Nie, wyjdź bez zapisywania",
                    onConfirmed: _cache[3] || (_cache[3] = ($event)=>$options.onSaveButtonClicked({
                            source: "dialog",
                            saveForAllLocations: false
                        })),
                    onDismissed: _cache[4] || (_cache[4] = ($event)=>$options.backWithNoSaving(true, $event))
                }, null, 8, [
                    "modelValue"
                ]),
                (0, $cfZzL.createElementVNode)("div", {
                    class: (0, $4bH2P.normalizeClass)([
                        "transition-opacity",
                        {
                            "opacity-50 pointer-events-none": !$data.isSavingCompleted
                        }
                    ])
                }, [
                    !_ctx.currentPage ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_FilterList, {
                        key: 0,
                        servicesObject: $data.services,
                        itemType: $data.itemType,
                        processResult: $data.processResult,
                        companyName: $data.companyName,
                        apiNamespace: $options.apiNamespace,
                        onProcess: $options.process,
                        onAddNewGroups: $options.goToCreate,
                        onGroupLimitRecalculate: $options.groupLimitRecalculate,
                        onSendAnalyticsEvent: $options.sendAnalyticsEvent,
                        onEditLocations: $options.editLocations,
                        onEditMatching: $options.editMatching,
                        onGetItemType: $options.getItemType,
                        onOnSelectedFiltersChange: $options.onSelectedFiltersChange,
                        onRecalculatePotentialMatches: $options.recalculatePotentialMatches
                    }, null, 8, [
                        "servicesObject",
                        "itemType",
                        "processResult",
                        "companyName",
                        "apiNamespace",
                        "onProcess",
                        "onAddNewGroups",
                        "onGroupLimitRecalculate",
                        "onSendAnalyticsEvent",
                        "onEditLocations",
                        "onEditMatching",
                        "onGetItemType",
                        "onOnSelectedFiltersChange",
                        "onRecalculatePotentialMatches"
                    ])) : (0, $cfZzL.createCommentVNode)("", true),
                    _ctx.currentPage === "Details" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_FilterDetails, {
                        key: 1,
                        servicesObject: $data.services,
                        apiNamespace: $options.apiNamespace,
                        onEditMatching: $options.editMatching,
                        onSendAnalyticsEvent: $options.sendAnalyticsEvent,
                        onSaveFilter: $options.saveFilter,
                        onEditLocations: $options.editLocations,
                        onSaveButtonClicked: $options.onSaveButtonClicked,
                        onRecalculatePotentialMatches: $options.recalculatePotentialMatches
                    }, null, 8, [
                        "servicesObject",
                        "apiNamespace",
                        "onEditMatching",
                        "onSendAnalyticsEvent",
                        "onSaveFilter",
                        "onEditLocations",
                        "onSaveButtonClicked",
                        "onRecalculatePotentialMatches"
                    ])) : (0, $cfZzL.createCommentVNode)("", true),
                    _ctx.currentPage === "Pricing" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_FilterPricing, {
                        key: 2,
                        ref: "FilterPricing",
                        servicesObject: $data.services,
                        apiNamespace: $options.apiNamespace,
                        categoryId: _ctx.pricingCategoryId,
                        onSaveButtonClicked: $options.onSaveButtonClicked,
                        onSendAnalyticsEvent: $options.sendAnalyticsEvent
                    }, null, 8, [
                        "servicesObject",
                        "apiNamespace",
                        "categoryId",
                        "onSaveButtonClicked",
                        "onSendAnalyticsEvent"
                    ])) : (0, $cfZzL.createCommentVNode)("", true),
                    _ctx.currentPage === "Create" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_FilterCreate, {
                        key: 3,
                        ref: "filterCreate",
                        servicesObject: $data.services,
                        multi: _ctx.isAdminModule,
                        apiNamespace: $options.apiNamespace,
                        filter: $data.filterTemplate,
                        onSendAnalyticsEvent: $options.sendAnalyticsEvent,
                        onFilterCreate: $options.onFilterCreate,
                        onFilterCreateTemplate: $options.getFilterTemplate
                    }, null, 8, [
                        "servicesObject",
                        "multi",
                        "apiNamespace",
                        "filter",
                        "onSendAnalyticsEvent",
                        "onFilterCreate",
                        "onFilterCreateTemplate"
                    ])) : (0, $cfZzL.createCommentVNode)("", true)
                ], 2)
            ])
        ], 512), [
            [
                (0, $brqXq.vShow),
                !_ctx.isLoading
            ]
        ]),
        _ctx.isRecommendationFeedbackModalVisible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_RecommendationFeedbackModal, {
            key: 0,
            servicesObject: $data.services,
            "api-namespace": $options.apiNamespace
        }, null, 8, [
            "servicesObject",
            "api-namespace"
        ])) : (0, $cfZzL.createCommentVNode)("", true),
        _ctx.visibilityTenPercentDiscountConfirmationModal ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_TenPercentDiscountConfirmationModal, {
            key: 1
        })) : (0, $cfZzL.createCommentVNode)("", true)
    ]);
}

});

parcelRequire.register("eILAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab7a1755dbfe66a8$export$2e2bcd8739ae039; });
let $ab7a1755dbfe66a8$var$NOOP = ()=>{};
var $ab7a1755dbfe66a8$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("8HeVM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $654debe0392de74a$export$2e2bcd8739ae039; });
let $654debe0392de74a$var$script;



let $654debe0392de74a$var$initialize = ()=>{
    $654debe0392de74a$var$script = (parcelRequire("4O4kI"));
    if ($654debe0392de74a$var$script.__esModule) $654debe0392de74a$var$script = $654debe0392de74a$var$script.default;
    $654debe0392de74a$var$script.render = (parcelRequire("g8qKi")).render;
    (parcelRequire("5ebGD")).default($654debe0392de74a$var$script);
    $654debe0392de74a$var$script.__scopeId = "data-v-2c4426";
    $654debe0392de74a$var$script.__file = "FilterDetailsQuick.vue";
};
$654debe0392de74a$var$initialize();
var $654debe0392de74a$export$2e2bcd8739ae039 = $654debe0392de74a$var$script;

});
parcelRequire.register("4O4kI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $886171151a870033$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $5UCIl = parcelRequire("5UCIl");

var $lC19C = parcelRequire("lC19C");

var $gKyLp = parcelRequire("gKyLp");

var $goO1A = parcelRequire("goO1A");

var $3cbAx = parcelRequire("3cbAx");
var $886171151a870033$export$2e2bcd8739ae039 = {
    name: "FilterDetailsQuick",
    components: {
        FilterDetailsCustomize: $gKyLp.default
    },
    props: {
        /**
		 * Główny obiekt usług
		 */ servicesObject: {
            type: Object,
            required: true
        },
        /**
		 * Czy używamy widoku tylko do odczytu (dla użytkownika)?
		 */ isReadonly: {
            type: Boolean,
            default: false
        },
        /**
		 * Aktualnie wybrany filtr
		 */ filter: {
            type: Object,
            required: true
        },
        /**
		 * Początek ścieżki do API.
		 */ apiNamespace: {
            type: String,
            required: true
        }
    },
    emits: [
        "save-filter",
        "edit-locations",
        "edit-matching"
    ],
    data () {
        return {
            /**
			 * Aktualnie wybrany filtr
			 */ selectedFilter: this.filter
        };
    },
    computed: {
        ...(0, $jgrCW.mapStores)((0, $3cbAx.useUserStore)),
        ...(0, $jgrCW.mapState)((0, $lC19C.useAppStore), [
            "isAdminModule"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $5UCIl.useServicesStore), [
            "isFilterDirty"
        ]),
        /**
		 * Tablica z rodzajami zleceń do wyświetlenia w trybie tylko do odczytu.
		 */ filterTypesList () {
            const result = [];
            const { filterTypes: filterTypes } = this.selectedFilter;
            if (filterTypes.companies) result.push("Firmy");
            if (filterTypes.individuals) result.push("Klienci indywidualni");
            if (filterTypes.standardRfps) result.push("Kontakty standardowe");
            if (filterTypes.discountedRfps) result.push("Kontakty z obniżoną ceną kontaktu");
            return result;
        },
        /**
		 * Wyświetla komunikat walidacyjny, jeżeli cena kontaktu jest zbyt niska.
		 */ contactPriceError () {
            const { contactPrice: contactPrice, minContactPrice: minContactPrice } = this.selectedFilter;
            return (contactPrice || -1) < minContactPrice;
        }
    },
    mounted () {
        if (this.isAdminModule) this.setDefaultContactUser();
    },
    methods: {
        /**
		 * Jeżeli cena minimalna nie jest ustawiona lub jest niższa od ceny kontaktu, popraw ją.
		 */ fixContactPrice () {
            if (this.contactPriceError) this.selectedFilter.contactPrice = this.selectedFilter.minContactPrice;
        },
        /**
		 * W przypadku wejścia na stronę przez operatora i gdy filtr nie ma przypisanej
		 * osoby kontaktowej, weź przypisz mu pierwszą lepszą.
		 */ setDefaultContactUser () {
            if (!this.isAdminModule || this.selectedFilter.idCustomerContactUser > -1) return;
            this.selectedFilter.idCustomerContactUser = 0;
            this.changeContactPerson();
        },
        /**
		 * Przy zmianie osoby kontaktowej, przypisuje jej numer telefonu do filtra.
		 */ changeContactPerson (event) {
            if (event) {
                const { value: value } = event.target;
                this.selectedFilter.contactPerson.contactPersonId = Number(value);
                this.selectedFilter.idCustomerContactUser = Number(value);
                const person = this.servicesObject.contactPersons.find((contectPerson)=>contectPerson.id === Number(value));
                if (person) this.selectedFilter.quickContactSmsNumber = person.mobile || person.phone;
                this.isFilterDirty = true;
                return;
            }
            const person = this.servicesObject.contactPersons.find((contectPerson)=>contectPerson.id === this.selectedFilter.idCustomerContactUser);
            if (!person) return;
            this.selectedFilter.quickContactSmsNumber = person.mobile || person.phone;
            this.isFilterDirty = true;
        },
        /**
		 * Wysyła wiadomość do operatora klientu z prośbą o dopasowanie filtra.
		 */ async contactOperator () {
            await (0, $goO1A.default)(`/${this.apiNamespace}/constraintsContact.ofer`, {
                subject: `Klient ${this.userStore.customerId} - Dopasowanie Klientów, prośba o kontakt`,
                idSubject: "contactConfiguration",
                surname: this.userStore.lastName,
                email: this.userStore.email,
                telephon: this.userStore.phone
            }, "POST");
            this.Toast.Show({
                Message: "Prośba o kontakt została wysłana"
            });
        },
        /**
		 * Przenosi użytkownika do edycji Lokalizacji
		 * @emits editLocations
		 */ editLocations ({ filter: filter, display: display }) {
            this.$emit("edit-locations", {
                filter: filter,
                display: display
            });
        },
        /**
		 * Przenosi użytkownika do edycji Filtrów
		 * @emits editMatching
		 */ editMatching () {
            this.$emit("edit-matching");
        },
        personPhone (person) {
            if ((!person.mobile || person.mobile === "null") && (!person.phone || person.phone === "null")) return "Brak numeru";
            return person.mobile || person.phone;
        }
    }
};

});
parcelRequire.register("gKyLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c31be89083d903c8$export$2e2bcd8739ae039; });
let $c31be89083d903c8$var$script;



let $c31be89083d903c8$var$initialize = ()=>{
    $c31be89083d903c8$var$script = (parcelRequire("lHn9o"));
    if ($c31be89083d903c8$var$script.__esModule) $c31be89083d903c8$var$script = $c31be89083d903c8$var$script.default;
    $c31be89083d903c8$var$script.render = (parcelRequire("ibC8r")).render;
    (parcelRequire("4MyMe")).default($c31be89083d903c8$var$script);
    $c31be89083d903c8$var$script.__scopeId = "data-v-a736f9";
    $c31be89083d903c8$var$script.__file = "FilterDetailsCustomize.vue";
};
$c31be89083d903c8$var$initialize();
var $c31be89083d903c8$export$2e2bcd8739ae039 = $c31be89083d903c8$var$script;

});
parcelRequire.register("lHn9o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0cda765992bd2dcc$export$2e2bcd8739ae039; });
var $0cda765992bd2dcc$export$2e2bcd8739ae039 = {
    name: "FilterDetailsCustomize",
    props: {
        /**
         * Filtr, którego szczegóły są wyświetlane.
         */ selectedFilter: {
            type: Object,
            required: true
        }
    },
    emits: [
        "edit-matching",
        "edit-locations"
    ],
    methods: {
        /**
		 * Przenosi użytkownika do edycji Lokalizacji
		 * @emits editLocations
		 */ editLocations ({ filter: filter, display: display }) {
            this.$emit("edit-locations", {
                filter: filter,
                display: display
            });
        },
        /**
		 * Przenosi użytkownika do edycji Filtrów
		 * @emits editMatching
		 */ editMatching () {
            this.$emit("edit-matching");
        }
    }
};

});

parcelRequire.register("ibC8r", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d3d6d5f16aa77940$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $d3d6d5f16aa77940$var$_hoisted_1 = {
    class: "mt-5",
    "data-component": "FilterDetailsCustomize.vue"
};
const $d3d6d5f16aa77940$var$_hoisted_2 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "flex h-0 justify-center items-center self-stretch"
}, null, -1);
const $d3d6d5f16aa77940$var$_hoisted_3 = [
    "innerHTML"
];
const $d3d6d5f16aa77940$var$_hoisted_4 = {
    key: 0
};
const $d3d6d5f16aa77940$var$_hoisted_5 = {
    class: "divide-neutral-100 divide-y mt-6"
};
const $d3d6d5f16aa77940$var$_hoisted_6 = {
    class: "font-bold text-base"
};
const $d3d6d5f16aa77940$var$_hoisted_7 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "text-neutral-700"
}, " Cechy zleceń, do kt\xf3rych Cię polecimy ", -1);
const $d3d6d5f16aa77940$var$_hoisted_8 = [
    "innerHTML"
];
const $d3d6d5f16aa77940$var$_hoisted_9 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "text-neutral-700",
    innerHTML: "Obszar, w kt\xf3rym Cię polecimy"
}, null, -1);
function $d3d6d5f16aa77940$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $d3d6d5f16aa77940$var$_hoisted_1, [
        $d3d6d5f16aa77940$var$_hoisted_2,
        (0, $cfZzL.createElementVNode)("div", {
            class: "text-xl font-bold mt-3",
            innerHTML: `Dopasuj ${$props.selectedFilter.type === "automatic" ? "Polecanie" : "Szybki kontakt"}`
        }, null, 8, $d3d6d5f16aa77940$var$_hoisted_3),
        $props.selectedFilter.type === "automatic" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $d3d6d5f16aa77940$var$_hoisted_4, " Możesz zdecydować, do jakich zleceń będzie polecana Twoja firma. Jeśli nic nie zmienisz, ustawienia będą takie same, jak dla całej usługi. ")) : (0, $cfZzL.createCommentVNode)("", true),
        (0, $cfZzL.createElementVNode)("div", $d3d6d5f16aa77940$var$_hoisted_5, [
            (0, $cfZzL.createElementVNode)("div", {
                class: "group flex items-center py-3 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.editMatching && $options.editMatching(...args))
            }, [
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: `filter-matching`,
                    size: "1.5",
                    class: "text-neutral-700 group-hover:text-accent mr-3"
                }),
                (0, $cfZzL.createElementVNode)("div", null, [
                    (0, $cfZzL.createElementVNode)("div", $d3d6d5f16aa77940$var$_hoisted_6, " Filtry dla " + (0, $4bH2P.toDisplayString)($props.selectedFilter.type === "automatic" ? "Polecania" : "Szybkiego kontaktu"), 1),
                    $d3d6d5f16aa77940$var$_hoisted_7
                ]),
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "chevron-right",
                    size: "0.75",
                    class: "text-neutral-300 ml-auto"
                })
            ]),
            (0, $cfZzL.createElementVNode)("div", {
                class: "group flex items-center py-3 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event)=>$options.editLocations({
                        filter: $props.selectedFilter,
                        display: true
                    }))
            }, [
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: `filter-location`,
                    size: "1.5",
                    class: "text-neutral-700 group-hover:text-accent mr-3"
                }),
                (0, $cfZzL.createElementVNode)("div", null, [
                    (0, $cfZzL.createElementVNode)("div", {
                        class: "font-bold text-base",
                        innerHTML: `Lokalizacja dla ${$props.selectedFilter.type === "automatic" ? "Polecania" : "Szybkiego kontaktu"}`
                    }, null, 8, $d3d6d5f16aa77940$var$_hoisted_8),
                    $d3d6d5f16aa77940$var$_hoisted_9
                ]),
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "chevron-right",
                    size: "0.75",
                    class: "text-neutral-300 ml-auto"
                })
            ])
        ])
    ]);
}

});

parcelRequire.register("4MyMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37b69f12992f758e$export$2e2bcd8739ae039; });
let $37b69f12992f758e$var$NOOP = ()=>{};
var $37b69f12992f758e$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("g8qKi", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $bbf223db3b86e2f4$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $bbf223db3b86e2f4$var$_hoisted_1 = {
    class: "pb-3"
};
const $bbf223db3b86e2f4$var$_hoisted_2 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "heading-small mt-3",
    innerHTML: "Szybki Kontakt"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_3 = {
    class: "form-input"
};
const $bbf223db3b86e2f4$var$_hoisted_4 = [
    "value"
];
const $bbf223db3b86e2f4$var$_hoisted_5 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    class: "form-input-label | text-xs uppercase my-1",
    innerHTML: "Osoba do kontaktu"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_6 = {
    class: "form-input"
};
const $bbf223db3b86e2f4$var$_hoisted_7 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    class: "form-input-label | text-xs uppercase my-1",
    innerHTML: "Powiadomienia SMS"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_8 = [
    "data-invalid"
];
const $bbf223db3b86e2f4$var$_hoisted_9 = [
    "placeholder"
];
const $bbf223db3b86e2f4$var$_hoisted_10 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("label", {
    class: "form-input-label | text-xs uppercase my-1",
    innerHTML: "Cena kontaktu"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_11 = {
    key: 0,
    class: "form-input-validation | text-danger text-xs mt-2",
    innerHTML: "Cena kontaktu powinna być ustawiona oraz być większa niż cena domyślna dla tej kategorii"
};
const $bbf223db3b86e2f4$var$_hoisted_12 = {
    key: 1,
    "data-component": "FilterDetailsQuick.vue"
};
const $bbf223db3b86e2f4$var$_hoisted_13 = {
    class: "bg-neutral-100 p-3 mt-5 text-sm rounded"
};
const $bbf223db3b86e2f4$var$_hoisted_14 = {
    class: "flex"
};
const $bbf223db3b86e2f4$var$_hoisted_15 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "heading-tiny",
    innerHTML: "Tylko do odczytu"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_16 = {
    class: "flex items-center mt-1"
};
const $bbf223db3b86e2f4$var$_hoisted_17 = [
    "href"
];
const $bbf223db3b86e2f4$var$_hoisted_18 = [
    "href"
];
const $bbf223db3b86e2f4$var$_hoisted_19 = {
    class: "divide-neutral-100 divide-y"
};
const $bbf223db3b86e2f4$var$_hoisted_20 = {
    class: "py-3"
};
const $bbf223db3b86e2f4$var$_hoisted_21 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "font-extrabold",
    innerHTML: "Osoba do kontaktu"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_22 = {
    class: "text-neutral-700"
};
const $bbf223db3b86e2f4$var$_hoisted_23 = {
    class: "flex items-center mt-1"
};
const $bbf223db3b86e2f4$var$_hoisted_24 = {
    class: "flex items-center mt-1"
};
const $bbf223db3b86e2f4$var$_hoisted_25 = {
    key: 0,
    class: "py-3"
};
const $bbf223db3b86e2f4$var$_hoisted_26 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "font-extrabold",
    innerHTML: "Cena kontaktu"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_27 = [
    "innerHTML"
];
const $bbf223db3b86e2f4$var$_hoisted_28 = {
    class: "py-3"
};
const $bbf223db3b86e2f4$var$_hoisted_29 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "font-extrabold",
    innerHTML: "Rodzaje zleceń"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_30 = [
    "innerHTML"
];
const $bbf223db3b86e2f4$var$_hoisted_31 = {
    class: "py-3"
};
const $bbf223db3b86e2f4$var$_hoisted_32 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "font-extrabold",
    innerHTML: "Lokalizacja"
}, null, -1);
const $bbf223db3b86e2f4$var$_hoisted_33 = [
    "innerHTML"
];
function $bbf223db3b86e2f4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _$data_selectedFilter_location;
    const _component_FilterDetailsCustomize = (0, $cfZzL.resolveComponent)("FilterDetailsCustomize");
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return !$props.isReadonly ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        key: 0,
        "data-component": "FilterDetailsQuick.vue",
        onChange: _cache[5] || (_cache[5] = ($event)=>_ctx.isFilterDirty = true)
    }, [
        (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_1, [
            $bbf223db3b86e2f4$var$_hoisted_2,
            (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_3, [
                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("select", {
                    "data-test": "quick_contact__contact_person",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.selectedFilter.idCustomerContactUser = $event),
                    class: "appearance-none",
                    onChange: _cache[1] || (_cache[1] = ($event)=>$options.changeContactPerson($event))
                }, [
                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($props.servicesObject.contactPersons, (person)=>{
                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("option", {
                            key: person.id,
                            value: person.id
                        }, " ✉️ " + (0, $4bH2P.toDisplayString)(person.email) + " \uD83D\uDC64 " + (0, $4bH2P.toDisplayString)(person.fullName) + " ☎️ " + (0, $4bH2P.toDisplayString)($options.personPhone(person)), 9, $bbf223db3b86e2f4$var$_hoisted_4);
                    }), 128))
                ], 544), [
                    [
                        (0, $brqXq.vModelSelect),
                        $data.selectedFilter.idCustomerContactUser
                    ]
                ]),
                $bbf223db3b86e2f4$var$_hoisted_5
            ]),
            (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_6, [
                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                    "data-test": "quick_contact__number",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.selectedFilter.quickContactSmsNumber = $event),
                    type: "text",
                    required: ""
                }, null, 512), [
                    [
                        (0, $brqXq.vModelText),
                        $data.selectedFilter.quickContactSmsNumber
                    ]
                ]),
                $bbf223db3b86e2f4$var$_hoisted_7
            ]),
            (0, $cfZzL.createElementVNode)("div", {
                class: "form-input",
                "data-invalid": $options.contactPriceError
            }, [
                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                    "data-test": "quick_contact__price",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.selectedFilter.contactPrice = $event),
                    type: "number",
                    required: "",
                    placeholder: String($data.selectedFilter.contactPrice || $data.selectedFilter.minContactPrice),
                    onBlur: _cache[4] || (_cache[4] = (...args)=>$options.fixContactPrice && $options.fixContactPrice(...args))
                }, null, 40, $bbf223db3b86e2f4$var$_hoisted_9), [
                    [
                        (0, $brqXq.vModelText),
                        $data.selectedFilter.contactPrice
                    ]
                ]),
                $bbf223db3b86e2f4$var$_hoisted_10,
                $options.contactPriceError ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $bbf223db3b86e2f4$var$_hoisted_11)) : (0, $cfZzL.createCommentVNode)("", true)
            ], 8, $bbf223db3b86e2f4$var$_hoisted_8)
        ]),
        (0, $cfZzL.createVNode)(_component_FilterDetailsCustomize, {
            selectedFilter: $data.selectedFilter,
            onEditMatching: $options.editMatching,
            onEditLocations: $options.editLocations
        }, null, 8, [
            "selectedFilter",
            "onEditMatching",
            "onEditLocations"
        ])
    ], 32)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $bbf223db3b86e2f4$var$_hoisted_12, [
        (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_13, [
            (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_14, [
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "info",
                    size: "1.25",
                    class: "mr-3"
                }),
                (0, $cfZzL.createElementVNode)("div", null, [
                    $bbf223db3b86e2f4$var$_hoisted_15,
                    (0, $cfZzL.createTextVNode)(" W celu dokonania zmian skontaktuj się ze swoim opiekunem: "),
                    (0, $cfZzL.createElementVNode)("a", $bbf223db3b86e2f4$var$_hoisted_16, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "user-circle",
                            size: "1",
                            class: "mr-1"
                        }),
                        (0, $cfZzL.createTextVNode)(" " + (0, $4bH2P.toDisplayString)($props.servicesObject.operators[0].fullName), 1)
                    ]),
                    (0, $cfZzL.createElementVNode)("a", {
                        class: "flex items-center mt-1",
                        href: `tel:${$props.servicesObject.operators[0].phone}`
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "phone",
                            size: "1",
                            class: "mr-1"
                        }),
                        (0, $cfZzL.createTextVNode)(" " + (0, $4bH2P.toDisplayString)($props.servicesObject.operators[0].phone), 1)
                    ], 8, $bbf223db3b86e2f4$var$_hoisted_17),
                    (0, $cfZzL.createElementVNode)("a", {
                        class: "flex items-center mt-1",
                        href: `mailto:${$props.servicesObject.operators[0].email}`
                    }, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "envelope",
                            size: "1",
                            class: "mr-1"
                        }),
                        (0, $cfZzL.createTextVNode)(" " + (0, $4bH2P.toDisplayString)($props.servicesObject.operators[0].email), 1)
                    ], 8, $bbf223db3b86e2f4$var$_hoisted_18)
                ])
            ]),
            (0, $cfZzL.createElementVNode)("button", {
                class: "btn-primary btn-small block mx-auto mt-3",
                onClick: _cache[6] || (_cache[6] = (0, $brqXq.withModifiers)((...args)=>$options.contactOperator && $options.contactOperator(...args), [
                    "prevent"
                ])),
                innerHTML: "Proszę o kontakt"
            })
        ]),
        (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_19, [
            (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_20, [
                $bbf223db3b86e2f4$var$_hoisted_21,
                (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_22, [
                    (0, $cfZzL.createElementVNode)("a", $bbf223db3b86e2f4$var$_hoisted_23, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "user-circle",
                            size: "1",
                            class: "mr-1"
                        }),
                        (0, $cfZzL.createTextVNode)(" " + (0, $4bH2P.toDisplayString)($data.selectedFilter.contactPerson.fullName), 1)
                    ]),
                    (0, $cfZzL.createElementVNode)("a", $bbf223db3b86e2f4$var$_hoisted_24, [
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "phone",
                            size: "1",
                            class: "mr-1"
                        }),
                        (0, $cfZzL.createTextVNode)(" " + (0, $4bH2P.toDisplayString)($data.selectedFilter.contactPerson.phone || "Nie podano"), 1)
                    ])
                ])
            ]),
            $data.selectedFilter.contactPrice ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $bbf223db3b86e2f4$var$_hoisted_25, [
                $bbf223db3b86e2f4$var$_hoisted_26,
                (0, $cfZzL.createElementVNode)("div", {
                    class: "text-neutral-700",
                    innerHTML: `${$data.selectedFilter.contactPrice || "Brak informacji o "} pkt.`
                }, null, 8, $bbf223db3b86e2f4$var$_hoisted_27)
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_28, [
                $bbf223db3b86e2f4$var$_hoisted_29,
                (0, $cfZzL.createElementVNode)("div", {
                    class: "text-neutral-700",
                    innerHTML: $options.filterTypesList.join(", ")
                }, null, 8, $bbf223db3b86e2f4$var$_hoisted_30)
            ]),
            (0, $cfZzL.createElementVNode)("div", $bbf223db3b86e2f4$var$_hoisted_31, [
                $bbf223db3b86e2f4$var$_hoisted_32,
                (0, $cfZzL.createElementVNode)("div", {
                    class: "text-neutral-700",
                    innerHTML: (_$data_selectedFilter_location = $data.selectedFilter.location) === null || _$data_selectedFilter_location === void 0 ? void 0 : _$data_selectedFilter_location.labels
                }, null, 8, $bbf223db3b86e2f4$var$_hoisted_33)
            ])
        ])
    ]));
}

});

parcelRequire.register("5ebGD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ce753459b331d0b$export$2e2bcd8739ae039; });
let $3ce753459b331d0b$var$NOOP = ()=>{};
var $3ce753459b331d0b$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("bdRDk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $82ba8313f8e52992$export$2e2bcd8739ae039; });
let $82ba8313f8e52992$var$script;



let $82ba8313f8e52992$var$initialize = ()=>{
    $82ba8313f8e52992$var$script = (parcelRequire("ilS6P"));
    if ($82ba8313f8e52992$var$script.__esModule) $82ba8313f8e52992$var$script = $82ba8313f8e52992$var$script.default;
    $82ba8313f8e52992$var$script.render = (parcelRequire("5xVMl")).render;
    (parcelRequire("fudpj")).default($82ba8313f8e52992$var$script);
    $82ba8313f8e52992$var$script.__scopeId = "data-v-40fade";
    $82ba8313f8e52992$var$script.__file = "FilterDetailsMatching.vue";
};
$82ba8313f8e52992$var$initialize();
var $82ba8313f8e52992$export$2e2bcd8739ae039 = $82ba8313f8e52992$var$script;

});
parcelRequire.register("ilS6P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $380f09c0720dc6b9$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $5UCIl = parcelRequire("5UCIl");

var $lC19C = parcelRequire("lC19C");
var /**
 * Ekran dostosowywania filtra (MPO, rodzaje zleceń, wielkość, etc.)
 */ $380f09c0720dc6b9$export$2e2bcd8739ae039 = {
    name: "FilterDetailsMatching",
    props: {
        /**
		 * Aktualnie wybrany filtr
		 */ filter: {
            type: Object,
            required: true
        }
    },
    emits: [
        "recalculate-potential-matches"
    ],
    data () {
        return {
            /**
			 * Aktualnie wybrany filtr
			 */ selectedFilter: this.filter,
            /**
			 * Etykiety dla różnych rodzajów zleceń
			 */ typeLabel: {
                discounted: "Klienci z obniżoną ceną kontaktu",
                individuals: "Osoby prywatne",
                notConfirmedBySms: "Klienci z niepotwierdzonym numerem telefonu"
            },
            /**
			 * Jednostki do pokazania w filtrze "Wielkość"
			 */ units: {
                M2: "m\xb2",
                M3: "m\xb3",
                MB: "mb",
                KG: "kg",
                PT: "punkt\xf3w",
                PUNKT: "punkt\xf3w",
                OSOBA: "os\xf3b",
                OSOBY: "os\xf3b",
                "SZT.": "sztuk",
                ZŁ: "złotych",
                T: "ton",
                YEARS: "lat"
            },
            /**
			 * Wielkość
			 */ sizeFilterFields: [
                "size",
                "age"
            ],
            rfpTypeFilter: [
                "discounted",
                "individuals",
                "notConfirmedBySms"
            ]
        };
    },
    computed: {
        ...(0, $jgrCW.mapState)((0, $lC19C.useAppStore), [
            "isAdminModule"
        ]),
        ...(0, $jgrCW.mapWritableState)((0, $5UCIl.useServicesStore), [
            "isFilterDirty"
        ])
    },
    methods: {
        onChange () {
            this.isFilterDirty = true;
            this.$emit("recalculate-potential-matches");
        },
        /**
		 * W przypadku filtrów "Wielkość" oraz "Wiek", sprawdza czy wprowadzona maksymalna
		 * wartość nie jest mniejsza od wartości minimalnej.
		 */ filterTypeRange (e, inputType) {
            const target = e.target;
            if (!target) return;
            const min = Number(target.getAttribute("min"));
            const max = Number(target.getAttribute("max"));
            let { valueAsNumber: valueAsNumber } = target;
            if (valueAsNumber > max) valueAsNumber = max;
            if (valueAsNumber < min) valueAsNumber = min;
            target.valueAsNumber = Math.floor(valueAsNumber);
            if (inputType === "from") this.selectedFilter.filterTypes["size"].minValue = valueAsNumber || null;
            else this.selectedFilter.filterTypes["size"].maxValue = valueAsNumber || null;
        },
        /**
		 * Blokuje możliwość wpisania znaków innych, niż cyfry.
		 */ filterTypeRangeKeydown (e) {
            if (e.keyCode >= 40 && e.keyCode <= 126 && !(e.keyCode >= 48 && e.keyCode <= 57) || e.shiftKey || e.key === "-") e.preventDefault();
        }
    }
};

});

parcelRequire.register("5xVMl", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $409cda78fb3f5fa1$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $409cda78fb3f5fa1$var$_hoisted_1 = {
    "data-component": "FilterDetailsMatching.vue"
};
const $409cda78fb3f5fa1$var$_hoisted_2 = [
    "innerHTML"
];
const $409cda78fb3f5fa1$var$_hoisted_3 = {
    class: "mx-3 input-control"
};
const $409cda78fb3f5fa1$var$_hoisted_4 = [
    "onUpdate:modelValue",
    "disabled"
];
const $409cda78fb3f5fa1$var$_hoisted_5 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $409cda78fb3f5fa1$var$_hoisted_6 = [
    "innerHTML"
];
const $409cda78fb3f5fa1$var$_hoisted_7 = {
    key: 0,
    class: "mb-6"
};
const $409cda78fb3f5fa1$var$_hoisted_8 = [
    "innerHTML"
];
const $409cda78fb3f5fa1$var$_hoisted_9 = {
    class: "flex items-center"
};
const $409cda78fb3f5fa1$var$_hoisted_10 = {
    class: "flex-none w-20 mx-1 mt-3 form-input"
};
const $409cda78fb3f5fa1$var$_hoisted_11 = [
    "onUpdate:modelValue",
    "min",
    "max"
];
const $409cda78fb3f5fa1$var$_hoisted_12 = {
    class: "flex-none w-20 mx-1 mt-3 form-input"
};
const $409cda78fb3f5fa1$var$_hoisted_13 = [
    "onUpdate:modelValue",
    "min",
    "max"
];
const $409cda78fb3f5fa1$var$_hoisted_14 = [
    "innerHTML"
];
const $409cda78fb3f5fa1$var$_hoisted_15 = {
    class: "mb-6"
};
const $409cda78fb3f5fa1$var$_hoisted_16 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "mb-3 font-extrabold",
    innerHTML: "Cechy klient\xf3w"
}, null, -1);
const $409cda78fb3f5fa1$var$_hoisted_17 = {
    class: "mx-3 input-control"
};
const $409cda78fb3f5fa1$var$_hoisted_18 = [
    "onUpdate:modelValue"
];
const $409cda78fb3f5fa1$var$_hoisted_19 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $409cda78fb3f5fa1$var$_hoisted_20 = [
    "textContent"
];
function $409cda78fb3f5fa1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $409cda78fb3f5fa1$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)({
                "inactive-panel": $data.selectedFilter.type === "quick" && !_ctx.isAdminModule || $data.selectedFilter.type === "automatic" && !$data.selectedFilter.isActive
            }),
            onChange: _cache[4] || (_cache[4] = (...args)=>$options.onChange && $options.onChange(...args))
        }, [
            _ctx.isAdminModule || $data.selectedFilter.type === "free" ? ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                key: 0
            }, (0, $cfZzL.renderList)($data.selectedFilter.mpo, (mpo)=>{
                return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                    key: mpo.id,
                    class: "mb-6"
                }, [
                    (0, $cfZzL.createElementVNode)("div", {
                        class: "mb-3 font-extrabold",
                        innerHTML: mpo.formLabel
                    }, null, 8, $409cda78fb3f5fa1$var$_hoisted_2),
                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(mpo.optionsList, (answerDtoObject)=>{
                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("label", {
                            key: answerDtoObject.id,
                            class: "flex items-center my-3"
                        }, [
                            (0, $cfZzL.createElementVNode)("div", $409cda78fb3f5fa1$var$_hoisted_3, [
                                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>answerDtoObject.checked = $event,
                                    disabled: mpo.optionsList.filter((option)=>option.checked).length === 1 && answerDtoObject.checked,
                                    type: "checkbox"
                                }, null, 8, $409cda78fb3f5fa1$var$_hoisted_4), [
                                    [
                                        (0, $brqXq.vModelCheckbox),
                                        answerDtoObject.checked
                                    ]
                                ]),
                                $409cda78fb3f5fa1$var$_hoisted_5
                            ]),
                            (0, $cfZzL.createElementVNode)("div", {
                                innerHTML: answerDtoObject.formLabel
                            }, null, 8, $409cda78fb3f5fa1$var$_hoisted_6)
                        ]);
                    }), 128))
                ]);
            }), 128)) : (0, $cfZzL.createCommentVNode)("", true),
            ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.sizeFilterFields, (filterType)=>{
                return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                    key: filterType
                }, [
                    $data.selectedFilter.filterTypes[filterType] && $data.selectedFilter.filterTypes[filterType].unit ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $409cda78fb3f5fa1$var$_hoisted_7, [
                        (0, $cfZzL.createElementVNode)("div", {
                            class: "font-extrabold",
                            innerHTML: filterType === "size" ? "Wielkość" : "Wiek"
                        }, null, 8, $409cda78fb3f5fa1$var$_hoisted_8),
                        (0, $cfZzL.createElementVNode)("div", $409cda78fb3f5fa1$var$_hoisted_9, [
                            (0, $cfZzL.createTextVNode)(" Od "),
                            (0, $cfZzL.createElementVNode)("div", $409cda78fb3f5fa1$var$_hoisted_10, [
                                $data.selectedFilter.filterTypes[filterType] ? (0, $cfZzL.withDirectives)(((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("input", {
                                    key: 0,
                                    "onUpdate:modelValue": ($event)=>$data.selectedFilter.filterTypes[filterType].minValue = $event,
                                    class: "p-0 text-center",
                                    type: "number",
                                    min: $data.selectedFilter.filterTypes[filterType].minLimit,
                                    max: $data.selectedFilter.filterTypes[filterType].maxValue || $data.selectedFilter.filterTypes[filterType].maxLimit,
                                    onBlur: _cache[0] || (_cache[0] = ($event)=>$options.filterTypeRange($event, "from")),
                                    onKeydown: _cache[1] || (_cache[1] = (...args)=>$options.filterTypeRangeKeydown && $options.filterTypeRangeKeydown(...args))
                                }, null, 40, $409cda78fb3f5fa1$var$_hoisted_11)), [
                                    [
                                        (0, $brqXq.vModelText),
                                        $data.selectedFilter.filterTypes[filterType].minValue
                                    ]
                                ]) : (0, $cfZzL.createCommentVNode)("", true)
                            ]),
                            (0, $cfZzL.createTextVNode)(" do "),
                            (0, $cfZzL.createElementVNode)("div", $409cda78fb3f5fa1$var$_hoisted_12, [
                                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>$data.selectedFilter.filterTypes[filterType].maxValue = $event,
                                    class: "p-0 text-center",
                                    type: "number",
                                    min: $data.selectedFilter.filterTypes[filterType].minValue || $data.selectedFilter.filterTypes[filterType].minLimit,
                                    max: $data.selectedFilter.filterTypes[filterType].maxLimit,
                                    onBlur: _cache[2] || (_cache[2] = ($event)=>$options.filterTypeRange($event, "to")),
                                    onKeydown: _cache[3] || (_cache[3] = (...args)=>$options.filterTypeRangeKeydown && $options.filterTypeRangeKeydown(...args))
                                }, null, 40, $409cda78fb3f5fa1$var$_hoisted_13), [
                                    [
                                        (0, $brqXq.vModelText),
                                        $data.selectedFilter.filterTypes[filterType].maxValue
                                    ]
                                ])
                            ]),
                            (0, $cfZzL.createElementVNode)("span", {
                                innerHTML: $data.units[$data.selectedFilter.filterTypes[filterType].unit || "YEARS"]
                            }, null, 8, $409cda78fb3f5fa1$var$_hoisted_14)
                        ])
                    ])) : (0, $cfZzL.createCommentVNode)("", true)
                ], 64);
            }), 128)),
            (0, $cfZzL.createElementVNode)("div", $409cda78fb3f5fa1$var$_hoisted_15, [
                $409cda78fb3f5fa1$var$_hoisted_16,
                ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.rfpTypeFilter, (filterType)=>{
                    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, [
                        !($data.selectedFilter.filterTypes.hideNotConfirmedBySms && filterType === "notConfirmedBySms") ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("label", {
                            key: filterType,
                            class: "flex items-center my-3"
                        }, [
                            (0, $cfZzL.createElementVNode)("div", $409cda78fb3f5fa1$var$_hoisted_17, [
                                (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
                                    "onUpdate:modelValue": ($event)=>$data.selectedFilter.filterTypes[filterType] = $event,
                                    type: "checkbox"
                                }, null, 8, $409cda78fb3f5fa1$var$_hoisted_18), [
                                    [
                                        (0, $brqXq.vModelCheckbox),
                                        $data.selectedFilter.filterTypes[filterType]
                                    ]
                                ]),
                                $409cda78fb3f5fa1$var$_hoisted_19
                            ]),
                            (0, $cfZzL.createElementVNode)("div", {
                                textContent: (0, $4bH2P.toDisplayString)($data.typeLabel[filterType])
                            }, null, 8, $409cda78fb3f5fa1$var$_hoisted_20)
                        ])) : (0, $cfZzL.createCommentVNode)("", true)
                    ], 64);
                }), 256))
            ])
        ], 34)
    ]);
}

});

parcelRequire.register("fudpj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4640ec7c9fc6781$export$2e2bcd8739ae039; });
let $b4640ec7c9fc6781$var$NOOP = ()=>{};
var $b4640ec7c9fc6781$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("3Z4ZJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2e6af16a551353ab$export$2e2bcd8739ae039; });
let $2e6af16a551353ab$var$script;



let $2e6af16a551353ab$var$initialize = ()=>{
    $2e6af16a551353ab$var$script = (parcelRequire("bwboD"));
    if ($2e6af16a551353ab$var$script.__esModule) $2e6af16a551353ab$var$script = $2e6af16a551353ab$var$script.default;
    $2e6af16a551353ab$var$script.render = (parcelRequire("EDdPw")).render;
    (parcelRequire("fsqIb")).default($2e6af16a551353ab$var$script);
    $2e6af16a551353ab$var$script.__scopeId = "data-v-83083e";
    $2e6af16a551353ab$var$script.__file = "Autocomplete.vue";
};
$2e6af16a551353ab$var$initialize();
var $2e6af16a551353ab$export$2e2bcd8739ae039 = $2e6af16a551353ab$var$script;

});
parcelRequire.register("bwboD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7aeb1d1b024d6ba0$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za kontrolkę autouzupełniania.
// @group Base Components | Forms
var $7aeb1d1b024d6ba0$export$2e2bcd8739ae039 = {
    name: "Autocomplete",
    props: {
        DataTest: {
            default: undefined
        },
        modelValue: {
            default: ""
        },
        InputName: {
            default: ""
        },
        Suggestions: {},
        Autocomplete: {
            default: ""
        },
        AutocompleteSuggestions: {},
        Placeholder: {
            default: ""
        },
        Autoselect: {
            default: true
        },
        IgnoreValues: {
            default: ()=>[]
        },
        EmblemWidth: {
            default: ""
        },
        focus: Boolean,
        IgnoreCase: {
            type: Boolean,
            default: false
        },
        type: {
            default: "text",
            type: String
        },
        disabled: {
            default: false,
            type: Boolean
        }
    },
    emits: [
        "update:modelValue",
        "process",
        "blur",
        "select",
        "focus-changed"
    ],
    data () {
        return {
            Value: "",
            Input: "",
            InputSuggestions: [],
            SelectedIndex: null,
            WritableSuggestions: this.Suggestions,
            HasFocus: false
        };
    },
    computed: {
        SuggestionsList () {
            return this.Input ? this.InputSuggestions : this.AutocompleteSuggestions || this.WritableSuggestions;
        }
    },
    watch: {
        Suggestions (n) {
            this.WritableSuggestions = n;
        },
        modelValue (n) {
            this.Value = n[0];
            this.Text = this.Input = n[1];
        }
    },
    mounted () {
        if (this.focus) this.focusInput();
    },
    created () {
        this.Value = this.modelValue[0];
        this.Text = this.Input = this.modelValue[1];
    },
    methods: {
        focusInput () {
            this.$refs.input.focus();
        },
        OnFocus () {
            this.$emit("focus-changed", true);
            this.HasFocus = true;
            if (!this.InputSuggestions.length && this.Input) this.OnInput();
        },
        OnInput (e) {
            if (e && [
                38,
                40,
                13
            ].includes(e.keyCode)) return;
            // BUG: Na Androidach, jeżeli nie został wykonany autocomplete, v-model się nie zaktualizuje.
            this.Input = this.$refs.input.value;
            const $list = this.$refs.list;
            $list.scrollTop = 0;
            const $selected = $list.querySelector(".is-active");
            if ($selected) $selected.classList.remove("is-active");
            this.SelectedIndex = null;
            if (this.AutocompleteSuggestions) {
                this.$emit("update:modelValue", [
                    this.Value,
                    this.Input
                ]);
                this.InputSuggestions = this.AutocompleteSuggestions.filter((suggestion)=>{
                    if (this.IgnoreCase) {
                        suggestion.Label = suggestion.Label.charAt(0).toUpperCase() + suggestion.Label.slice(1);
                        this.Input = this.Input.charAt(0).toUpperCase() + this.Input.slice(1);
                    }
                    return suggestion.Label.indexOf(this.Input) >= 0;
                });
                this.$emit("process", this.InputSuggestions, this);
            } else if (this.Autocomplete && this.Input) {
                let autoUrl = this.Autocomplete;
                let viaZip = false;
                if (autoUrl === "Location") {
                    viaZip = !Number.isNaN(this.Input[0]);
                    autoUrl = `/common/dictionary/zip/search${viaZip ? "-by-zip" : ""}.ofer?query={{q}}&cc=PL`;
                }
                // /common/dictionary/zip/search-by-zip.ofer?query={{q}}&cc=PL
                fetch(autoUrl.replace("{{q}}", this.Input)).then((rsvp)=>rsvp.json()).then((rsvp)=>{
                    const process = [];
                    if (this.Autocomplete.indexOf("autocomplete-form") > -1) for (const s of rsvp){
                        if (this.IgnoreValues.indexOf(s.idCategory) > -1) continue;
                        process.push({
                            Value: s.idCategory,
                            Label: s.categoryName + (s.service ? "" : '<small class="ml-1 opacity-75">Sprzedaż</small>'),
                            Input: s.categoryName,
                            Element: s
                        });
                    }
                    if (this.Autocomplete.indexOf("Location") > -1) for (const s of rsvp){
                        if (this.IgnoreValues.indexOf(s.idCategory) > -1) continue;
                        process.push({
                            Value: {
                                country: [
                                    "locationPl",
                                    "Polska"
                                ],
                                region: [
                                    s.idLocation,
                                    s.location
                                ],
                                district: [
                                    s.idDistrict,
                                    s.district
                                ],
                                city: [
                                    s.zip,
                                    s.city
                                ],
                                id: s.id
                            },
                            Label: viaZip ? `<small class="mr-1 opacity-75">${s.zip}</small> ${s.city}` : s.city,
                            Input: s.city,
                            Element: s
                        });
                    }
                    if (this.Autocomplete.indexOf("search-by-zip") > -1) for (const s of rsvp){
                        if (this.IgnoreValues.indexOf(s.idCategory) > -1) continue;
                        process.push({
                            Value: {
                                country: [
                                    "locationPl",
                                    "Polska"
                                ],
                                region: [
                                    s.idLocation,
                                    s.location
                                ],
                                district: [
                                    s.idDistrict,
                                    s.district
                                ],
                                city: [
                                    s.zip,
                                    s.city
                                ],
                                id: s.id
                            },
                            Label: `<small class="mr-1 opacity-75">${s.zip}</small> ${s.city}`,
                            Input: s.city,
                            Element: s
                        });
                    }
                    this.InputSuggestions = process;
                    this.$emit("process", rsvp, this);
                    this.$emit("update:modelValue", [
                        this.Value,
                        this.Input
                    ]);
                });
            } else {
                this.$emit("process", [], this);
                this.$emit("update:modelValue", [
                    this.Value,
                    this.Input
                ]);
            }
        },
        OnBlur () {
            this.$emit("focus-changed", false);
            window.setTimeout(()=>{
                this.HasFocus = false;
            }, 100);
            if (!this.Autoselect || this.Value === -1) return;
            const $selected = this.SelectFirst();
            this.$emit("blur", [
                null,
                this.Input
            ]);
            if ($selected) $selected.click();
            else this.$emit("update:modelValue", [
                null,
                this.Input
            ]);
        },
        OnNavigate (e) {
            if (![
                38,
                40,
                13
            ].includes(e.keyCode)) return;
            e.preventDefault();
            e.stopPropagation();
            let direction = e.keyCode === 38 ? -1 : 1;
            if (e.keyCode === 13) direction = 0;
            const $input = this.$refs.input;
            const $list = this.$refs.list;
            let $selected = this.SelectFirst();
            if (direction === 0) {
                if ($selected) $selected.click();
                $input.blur();
            } else {
                if (!$selected) $selected = direction > 0 ? $list.firstElementChild : $list.lastElementChild;
                else {
                    $selected.classList.remove("is-active");
                    $selected = direction > 0 ? $selected.nextElementSibling : $selected.previousElementSibling;
                }
                if ($selected) {
                    $selected.classList.add("is-active");
                    let index = Array.prototype.slice.call($list.children);
                    index = index.indexOf($selected);
                    $list.scrollTop = $selected.offsetHeight * (index - 2);
                }
            }
        },
        OnSelect (s) {
            this.Value = s.Value;
            this.Input = s.Input || s.Label;
            this.$emit("update:modelValue", [
                this.Value,
                this.Input
            ]);
            this.$emit("select", s);
        },
        SelectFirst () {
            const $list = this.$refs.list;
            let $selected = $list === null || $list === void 0 ? void 0 : $list.querySelector(".is-active");
            if (!$selected && $list.children.length) {
                $selected = $list.children[0];
                $selected.classList.add("is-active");
            }
            return $selected;
        }
    }
};

});

parcelRequire.register("EDdPw", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $07a22939ea228a9d$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $07a22939ea228a9d$var$_hoisted_1 = [
    "id",
    "type",
    "placeholder",
    "data-test",
    "disabled"
];
const $07a22939ea228a9d$var$_hoisted_2 = {
    ref: "list",
    class: "suggestions-list"
};
const $07a22939ea228a9d$var$_hoisted_3 = [
    "data-value",
    "onClick",
    "innerHTML"
];
function $07a22939ea228a9d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        class: (0, $4bH2P.normalizeClass)([
            "autocomplete | input",
            {
                "!border-transparent": $props.disabled,
                "has-focus": $data.HasFocus
            }
        ]),
        "data-component": "Autocomplete.vue"
    }, [
        (0, $cfZzL.withDirectives)((0, $cfZzL.createElementVNode)("input", {
            id: $props.InputName,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.Input = $event),
            type: $props.type,
            placeholder: $props.Placeholder,
            required: "",
            style: (0, $4bH2P.normalizeStyle)({
                "padding-left": $props.EmblemWidth
            }),
            onFocus: _cache[1] || (_cache[1] = (...args)=>$options.OnFocus && $options.OnFocus(...args)),
            onKeyup: _cache[2] || (_cache[2] = (...args)=>$options.OnInput && $options.OnInput(...args)),
            onBlur: _cache[3] || (_cache[3] = (...args)=>$options.OnBlur && $options.OnBlur(...args)),
            onKeydown: _cache[4] || (_cache[4] = (...args)=>$options.OnNavigate && $options.OnNavigate(...args)),
            "data-test": $props.DataTest,
            disabled: $props.disabled,
            class: (0, $4bH2P.normalizeClass)({
                "!bg-neutral-design-50": $props.disabled
            })
        }, null, 46, $07a22939ea228a9d$var$_hoisted_1), [
            [
                (0, $brqXq.vModelDynamic),
                $data.Input
            ]
        ]),
        (0, $cfZzL.createElementVNode)("div", $07a22939ea228a9d$var$_hoisted_2, [
            ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($options.SuggestionsList, (s, i)=>{
                return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, [
                    s.Label ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("a", {
                        key: i,
                        "data-value": s.Value,
                        onClick: ($event)=>$options.OnSelect(s, $event),
                        innerHTML: s.Label
                    }, null, 8, $07a22939ea228a9d$var$_hoisted_3)) : (0, $cfZzL.createCommentVNode)("", true)
                ], 64);
            }), 256))
        ], 512)
    ], 2);
}

});

parcelRequire.register("fsqIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b40e30e8c8f7684f$export$2e2bcd8739ae039; });
let $b40e30e8c8f7684f$var$NOOP = ()=>{};
var $b40e30e8c8f7684f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("3JXC7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2b93d121e29aa496$export$2e2bcd8739ae039; });
let $2b93d121e29aa496$var$script;




let $2b93d121e29aa496$var$initialize = ()=>{
    $2b93d121e29aa496$var$script = (parcelRequire("j1B3E"));
    if ($2b93d121e29aa496$var$script.__esModule) $2b93d121e29aa496$var$script = $2b93d121e29aa496$var$script.default;
    $2b93d121e29aa496$var$script.render = (parcelRequire("4a6zP")).render;
    $2b93d121e29aa496$var$script.__cssModules = {};
    (parcelRequire("1g7zN")).default($2b93d121e29aa496$var$script);
    $2b93d121e29aa496$var$script.__scopeId = "data-v-0d1aa7";
    $2b93d121e29aa496$var$script.__file = "Avatar.vue";
};
$2b93d121e29aa496$var$initialize();
var $2b93d121e29aa496$export$2e2bcd8739ae039 = $2b93d121e29aa496$var$script;

});
parcelRequire.register("j1B3E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ba8ffc18db25c9d7$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za wyświetlanie awatara użytkownika.
// @group Base Components
var $ba8ffc18db25c9d7$export$2e2bcd8739ae039 = {
    name: "BaseAvatar",
    props: {
        user: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: "lg"
        },
        hideImage: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        image () {
            var _this_user, _this_user1;
            if (this.hideImage) return "";
            return ((_this_user = this.user) === null || _this_user === void 0 ? void 0 : _this_user.Avatar) || ((_this_user1 = this.user) === null || _this_user1 === void 0 ? void 0 : _this_user1.path) || "";
        },
        initials () {
            return this.user.FirstName ? `${this.user.FirstName || ""} ${this.user.LastName || ""}` : "";
        },
        style () {
            return this.image ? {
                "background-image": `url(${this.image})`
            } : {
                "background-color": this.initials ? this.Format.AvatarColor(this.initials) : "#eeeeee"
            };
        }
    }
};

});

parcelRequire.register("4a6zP", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $307d32a1885b358a$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
function $307d32a1885b358a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        class: (0, $4bH2P.normalizeClass)([
            "flex items-center justify-center p-2 font-semibold text-white rounded-full avatar bg-accent",
            [
                `avatar--${$props.size}`
            ]
        ]),
        style: (0, $4bH2P.normalizeStyle)($options.style),
        "data-component": "Avatar.vue"
    }, [
        !$options.image && !$options.initials ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
            key: 0,
            name: "avatar",
            size: 4
        })) : !$options.image ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
            key: 1
        }, [
            (0, $cfZzL.createTextVNode)((0, $4bH2P.toDisplayString)(_ctx.Format.AvatarLetters($options.initials)), 1)
        ], 64)) : (0, $cfZzL.createCommentVNode)("", true)
    ], 6);
}

});

parcelRequire.register("1g7zN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ead2996e8b1df27$export$2e2bcd8739ae039; });
let $0ead2996e8b1df27$var$NOOP = ()=>{};
var $0ead2996e8b1df27$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("jimV5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e0c17a273428c292$export$2e2bcd8739ae039; });
let $e0c17a273428c292$var$script;



let $e0c17a273428c292$var$initialize = ()=>{
    $e0c17a273428c292$var$script = (parcelRequire("6iDky"));
    if ($e0c17a273428c292$var$script.__esModule) $e0c17a273428c292$var$script = $e0c17a273428c292$var$script.default;
    $e0c17a273428c292$var$script.render = (parcelRequire("dvd1H")).render;
    (parcelRequire("du0yZ")).default($e0c17a273428c292$var$script);
    $e0c17a273428c292$var$script.__scopeId = "data-v-cd7daa";
    $e0c17a273428c292$var$script.__file = "BaseIcon.vue";
};
$e0c17a273428c292$var$initialize();
var $e0c17a273428c292$export$2e2bcd8739ae039 = $e0c17a273428c292$var$script;

});
parcelRequire.register("6iDky", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e329ee33723e08f1$export$2e2bcd8739ae039; });

var $fy1rK = parcelRequire("fy1rK");
var // @vuese
// Komponent odpowiedzialny za wyświetlanie ikon
// @group Base Components
$e329ee33723e08f1$export$2e2bcd8739ae039 = {
    name: "BaseIcon",
    props: {
        // Nazwa ikony (zazwyczaj nazwa pliku .svg)
        name: {
            default: "placeholder",
            type: String
        },
        // Nazwa zestawu ikon (zazwyczaj nazwa folderu)
        set: {
            default: "base",
            type: String
        },
        // Wielkość ikony (w rem)
        size: {
            default: 1.25,
            type: [
                String,
                Number
            ]
        },
        // Nadpisanie wysokości (w rem)
        height: {
            default: "",
            type: [
                String,
                Number
            ]
        },
        // Styl wyświetlania
        display: {
            default: "inline-block",
            type: String
        },
        title: {
            default: undefined,
            type: String,
            required: false
        }
    },
    data () {
        return {
            library: null
        };
    },
    computed: {
        // Standardowy styl ikony: inline-block, wypełnienie z obecnego koloru, wielkość wzięta z właściwości
        style () {
            return {
                display: this.display,
                flex: ` 0 0 ${this.size}rem`,
                width: `${this.size}rem`,
                height: `${this.height || this.size}rem`,
                fill: "currentColor"
            };
        }
    },
    created () {
        this.getIconSet(this.set);
    },
    methods: {
        // @vuese
        // Pobiera zestaw ikon z pliku /iconset/${name}.json - jeżeli poleciał już request, bierze jego aktualną kopię.
        async getIconSet (name) {
            if (!window["Iconsets"]) window["Iconsets"] = {};
            const library = window["Iconsets"];
            if (!library[name]) library[name] = {
                rsvp: fetch(`/app/dist/iconset/${name}.js?rev=${(0, (/*@__PURE__*/$parcel$interopDefault($fy1rK))).rev}`)
            };
            if (!library[name].icons) {
                const rsvp = await library[name].rsvp;
                if (library[name].rsvp) library[name].icons = await rsvp.clone().json();
            }
            this.library = library[name].icons;
        }
    }
};

});
parcelRequire.register("fy1rK", function(module, exports) {
module.exports = JSON.parse('{"rev":1715749283442}');

});


parcelRequire.register("dvd1H", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9d48466656d08412$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $9d48466656d08412$var$_hoisted_1 = [
    "title",
    "innerHTML"
];
function $9d48466656d08412$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("i", {
        "data-component": "BaseIcon.vue",
        class: "i",
        style: (0, $4bH2P.normalizeStyle)($options.style),
        title: $props.title,
        innerHTML: $data.library ? $data.library[$props.name] : ""
    }, null, 12, $9d48466656d08412$var$_hoisted_1);
}

});

parcelRequire.register("du0yZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0e838ff2cd4d3c$export$2e2bcd8739ae039; });
let $9d0e838ff2cd4d3c$var$NOOP = ()=>{};
var $9d0e838ff2cd4d3c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("fqWeg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b3c673cbdb9cb927$export$2e2bcd8739ae039; });
let $b3c673cbdb9cb927$var$script;




let $b3c673cbdb9cb927$var$initialize = ()=>{
    $b3c673cbdb9cb927$var$script = (parcelRequire("gCfdJ"));
    if ($b3c673cbdb9cb927$var$script.__esModule) $b3c673cbdb9cb927$var$script = $b3c673cbdb9cb927$var$script.default;
    $b3c673cbdb9cb927$var$script.render = (parcelRequire("w5oJY")).render;
    $b3c673cbdb9cb927$var$script.__cssModules = {};
    (parcelRequire("8lAaO")).default($b3c673cbdb9cb927$var$script);
    $b3c673cbdb9cb927$var$script.__scopeId = "data-v-550417";
    $b3c673cbdb9cb927$var$script.__file = "CodeInput.vue";
};
$b3c673cbdb9cb927$var$initialize();
var $b3c673cbdb9cb927$export$2e2bcd8739ae039 = $b3c673cbdb9cb927$var$script;

});
parcelRequire.register("gCfdJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c18c00672a5f5224$export$2e2bcd8739ae039; });
var $c18c00672a5f5224$export$2e2bcd8739ae039 = {
    props: {
        digitCount: {
            type: Number,
            required: true
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean
        }
    },
    emits: [
        "code-input-complete"
    ],
    data () {
        return {
            digits: []
        };
    },
    created () {
        for(let i = 0; i < this.digitCount; i++)this.digits[i] = null;
    },
    mounted () {
        if (this.focus) this.$refs.otpCont.children[0].focus();
    },
    methods: {
        handlePaste (event) {
            const code = event.clipboardData.getData("text");
            const codeArray = code.split("");
            if (code.length !== 4) event.preventDefault();
            else if (code.length === 4) {
                this.digits.forEach((el, index)=>{
                    this.digits[index] = codeArray[index];
                });
                this.$emit("code-input-complete", this.digits.join(""));
            }
        },
        isDigitsFull () {
            for (const elem of this.digits){
                if (elem == null || elem === undefined) return false;
            }
            return true;
        },
        handleKeyDown (event, index) {
            if (event.key !== "Tab" && event.key !== "ArrowRight" && event.key !== "ArrowLeft") event.preventDefault();
            if (event.key === "Backspace") {
                this.digits[index] = null;
                if (index !== 0) this.$refs.otpCont.children[index - 1].focus();
                return;
            }
            if (new RegExp("^([0-9])$").test(event.key)) {
                this.digits[index] = event.key;
                if (index !== this.digitCount - 1) this.$refs.otpCont.children[index + 1].focus();
                if (this.isDigitsFull()) this.$emit("code-input-complete", this.digits.join(""));
            }
        }
    }
};

});

parcelRequire.register("w5oJY", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $06072d36349bcff8$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $brqXq = parcelRequire("brqXq");
const $06072d36349bcff8$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-550417"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $06072d36349bcff8$var$_hoisted_1 = {
    ref: "otpCont",
    "data-component": "CodeInput.vue"
};
const $06072d36349bcff8$var$_hoisted_2 = [
    "onUpdate:modelValue",
    "autofocus",
    "disabled",
    "onKeydown"
];
function $06072d36349bcff8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $06072d36349bcff8$var$_hoisted_1, [
        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.digits, (el, index)=>{
            return (0, $cfZzL.withDirectives)(((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("input", {
                key: el + index,
                "onUpdate:modelValue": ($event)=>$data.digits[index] = $event,
                type: "tel",
                class: "digit-box",
                autofocus: index === 0,
                maxlength: "1",
                disabled: $props.disabled,
                onKeydown: ($event)=>$options.handleKeyDown($event, index),
                onPaste: _cache[0] || (_cache[0] = ($event)=>$options.handlePaste($event))
            }, null, 40, $06072d36349bcff8$var$_hoisted_2)), [
                [
                    (0, $brqXq.vModelText),
                    $data.digits[index]
                ]
            ]);
        }), 128))
    ], 512);
}

});

parcelRequire.register("8lAaO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $613c582c00c7568e$export$2e2bcd8739ae039; });
let $613c582c00c7568e$var$NOOP = ()=>{};
var $613c582c00c7568e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("2uJvR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1d11b00c7a8764b9$export$2e2bcd8739ae039; });
let $1d11b00c7a8764b9$var$script;




let $1d11b00c7a8764b9$var$initialize = ()=>{
    $1d11b00c7a8764b9$var$script = (parcelRequire("kge0N"));
    if ($1d11b00c7a8764b9$var$script.__esModule) $1d11b00c7a8764b9$var$script = $1d11b00c7a8764b9$var$script.default;
    $1d11b00c7a8764b9$var$script.render = (parcelRequire("loYAj")).render;
    $1d11b00c7a8764b9$var$script.__cssModules = {};
    (parcelRequire("k85Um")).default($1d11b00c7a8764b9$var$script);
    $1d11b00c7a8764b9$var$script.__scopeId = "data-v-807b40";
    $1d11b00c7a8764b9$var$script.__file = "DatePicker.vue";
};
$1d11b00c7a8764b9$var$initialize();
var $1d11b00c7a8764b9$export$2e2bcd8739ae039 = $1d11b00c7a8764b9$var$script;

});
parcelRequire.register("kge0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $07e264e9bdd8da0b$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za kontrolkę kalendarza i wyboru daty.
// @group Base Components | Forms
var $07e264e9bdd8da0b$export$2e2bcd8739ae039 = {
    name: "DatePicker",
    props: {
        modelValue: {},
        Min: {
            default: "2021-14-05"
        },
        Max: {
            default: "2050-31-12"
        },
        Standalone: {
            default: false
        },
        Emblems: {},
        Disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "update:modelValue"
    ],
    data () {
        return {
            Date: {
                D: 1,
                M: 1,
                Y: 2020
            },
            ViewDate: {
                M: 12,
                Y: 2020,
                YearView: false
            },
            DayNames: [
                "pon",
                "wto",
                "śro",
                "czw",
                "pią",
                "sob",
                "nie"
            ],
            MonthNames: [
                "styczeń",
                "luty",
                "marzec",
                "kwiecień",
                "maj",
                "czerwiec",
                "lipiec",
                "sierpień",
                "wrzesień",
                "październik",
                "listopad",
                "grudzień"
            ],
            MonthView: [],
            DisplayPicker: false
        };
    },
    computed: {
        Label () {
            return new Date(this.modelValue).toLocaleDateString("pl-PL", {
                day: "numeric",
                month: "long",
                year: "numeric"
            });
        },
        MinDate () {
            return this.StringToDate(this.Min);
        },
        MaxDate () {
            return this.StringToDate(this.Max);
        }
    },
    watch: {
        modelValue (n) {
            const d = this.StringToDate(n);
            this.ViewDate = {
                M: d.M,
                Y: d.Y,
                YearView: false
            };
            this.Date = d;
            this.CreateMonthView();
        },
        Min () {
            this.CreateMonthView();
        }
    },
    created () {
        if (this.modelValue) {
            const d = this.StringToDate(this.modelValue);
            this.Date = d;
            this.ViewDate = {
                M: d.M,
                Y: d.Y,
                YearView: false
            };
        }
        if (!this.modelValue) this.$emit("update:modelValue", new Date().toISOString().split("T")[0]);
        else this.CreateMonthView();
    },
    methods: {
        TogglePicker () {
            if (!this.Disabled) this.DisplayPicker = !this.DisplayPicker;
        },
        StringToDate (s) {
            if (!s) return null;
            s = s.split("-");
            return {
                D: Number(s[2]),
                M: Number(s[1]),
                Y: Number(s[0])
            };
        },
        DateToString (d) {
            return `${d.Y}-${d.M > 9 ? d.M : `0${d.M}`}-${d.D > 9 ? d.D : `0${d.D}`}`;
        },
        SelectDate (d) {
            this.$emit("update:modelValue", this.DateToString(d));
            window.setTimeout(()=>{
                this.DisplayPicker = false;
            }, 50);
        },
        Navigate (n) {
            const vd = this.ViewDate;
            const [m, y] = this.SwitchDate(n, vd.M, vd.Y);
            vd.M = m;
            vd.Y = y;
            this.ViewDate = vd;
            this.CreateMonthView();
        },
        SwitchDate (n, m, y) {
            if (n < 0) {
                y = m < 2 ? y - 1 : y;
                m = m < 2 ? 12 : m - 1;
            }
            if (n > 0) {
                y = m > 11 ? y + 1 : y;
                m = m > 11 ? 1 : m + 1;
            }
            return [
                m,
                y
            ];
        },
        DaysInMonth (m, y) {
            const leap = y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
            return [
                31,
                leap ? 29 : 28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ][m - 1];
        },
        IsDateInRange (d) {
            const min = this.MinDate;
            const disabledMin = d.Y < min.Y || d.Y === min.Y && d.M < min.M || d.Y === min.Y && d.M === min.M && d.D < min.D;
            const disabledMax = false;
            return !disabledMin && !disabledMax;
        },
        CreateMonthView () {
            const dayOfWeek = (x)=>x === 0 ? 6 : x - 1;
            const month = this.ViewDate.M;
            const year = this.ViewDate.Y;
            let p = dayOfWeek(new Date(`${year}/${month}/1`).getDay());
            const c = this.DaysInMonth(month, year);
            let f = 42 - (p + c);
            const pastDaysInMonth = this.DaysInMonth(month < 2 ? 12 : month - 1, month < 2 ? year - 1 : year);
            const result = [];
            const dd = (n, d, m, y)=>{
                const sd = this.Date;
                [m, y] = this.SwitchDate(n, m, y);
                const isSelected = sd.Y === y && sd.M === m && sd.D === d;
                result.push({
                    Navigate: n,
                    D: d,
                    M: m,
                    Y: y,
                    Disabled: !this.IsDateInRange({
                        D: d,
                        M: m,
                        Y: y
                    }),
                    Selected: isSelected
                });
            };
            if (!p) {
                p = 7;
                f -= 7;
            }
            for(let i = 0; i < p; i++)dd(-1, pastDaysInMonth - i, month, year);
            result.reverse();
            for(let i = 0; i < c; i++)dd(0, i + 1, month, year);
            for(let i = 0; i < f; i++)dd(1, i + 1, month, year);
            this.MonthView = result;
            return result;
        }
    }
};

});

parcelRequire.register("loYAj", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $f94ad5b617b0063f$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $f94ad5b617b0063f$var$_hoisted_1 = {
    key: 0,
    class: "relative"
};
const $f94ad5b617b0063f$var$_hoisted_2 = [
    "value"
];
const $f94ad5b617b0063f$var$_hoisted_3 = {
    class: "calendarSvg-container"
};
const $f94ad5b617b0063f$var$_hoisted_4 = {
    key: 0,
    class: "datepicker-year-view"
};
const $f94ad5b617b0063f$var$_hoisted_5 = {
    class: "datepicker-header"
};
const $f94ad5b617b0063f$var$_hoisted_6 = [
    "data-disabled"
];
const $f94ad5b617b0063f$var$_hoisted_7 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "arrow-left"
}, null, -1);
const $f94ad5b617b0063f$var$_hoisted_8 = [
    $f94ad5b617b0063f$var$_hoisted_7
];
const $f94ad5b617b0063f$var$_hoisted_9 = [
    "data-disabled"
];
const $f94ad5b617b0063f$var$_hoisted_10 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "arrow-right"
}, null, -1);
const $f94ad5b617b0063f$var$_hoisted_11 = [
    $f94ad5b617b0063f$var$_hoisted_10
];
const $f94ad5b617b0063f$var$_hoisted_12 = {
    class: "datepicker-list"
};
const $f94ad5b617b0063f$var$_hoisted_13 = [
    "onClick"
];
const $f94ad5b617b0063f$var$_hoisted_14 = {
    key: 1,
    class: "datepicker-month-view"
};
const $f94ad5b617b0063f$var$_hoisted_15 = {
    class: "datepicker-header"
};
const $f94ad5b617b0063f$var$_hoisted_16 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "arrow-left"
}, null, -1);
const $f94ad5b617b0063f$var$_hoisted_17 = [
    $f94ad5b617b0063f$var$_hoisted_16
];
const $f94ad5b617b0063f$var$_hoisted_18 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", {
    class: "arrow-right"
}, null, -1);
const $f94ad5b617b0063f$var$_hoisted_19 = [
    $f94ad5b617b0063f$var$_hoisted_18
];
const $f94ad5b617b0063f$var$_hoisted_20 = {
    class: "datepicker-list"
};
const $f94ad5b617b0063f$var$_hoisted_21 = [
    "data-emblem",
    "data-day",
    "onClick"
];
function $f94ad5b617b0063f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        ref: "el",
        "data-component": "DatePicker.vue",
        class: (0, $4bH2P.normalizeClass)([
            "datepicker",
            {
                "is-active": $data.DisplayPicker,
                "is-standalone": $props.Standalone,
                "is-fixed": !$props.Standalone,
                "is-disabled": $props.Disabled
            }
        ]),
        tabindex: "0",
        onClick: _cache[7] || (_cache[7] = (...args)=>$options.TogglePicker && $options.TogglePicker(...args))
    }, [
        !$props.Standalone ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $f94ad5b617b0063f$var$_hoisted_1, [
            (0, $cfZzL.createElementVNode)("input", {
                value: $options.Label,
                readonly: ""
            }, null, 8, $f94ad5b617b0063f$var$_hoisted_2),
            (0, $cfZzL.createElementVNode)("div", $f94ad5b617b0063f$var$_hoisted_3, [
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "calendar"
                })
            ])
        ])) : (0, $cfZzL.createCommentVNode)("", true),
        $data.DisplayPicker || $props.Standalone ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 1,
            class: "datepicker-popup",
            onClick: _cache[6] || (_cache[6] = (0, $brqXq.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            $data.ViewDate.YearView ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $f94ad5b617b0063f$var$_hoisted_4, [
                (0, $cfZzL.createElementVNode)("div", $f94ad5b617b0063f$var$_hoisted_5, [
                    (0, $cfZzL.createElementVNode)("div", {
                        class: "p-1",
                        "data-disabled": $data.ViewDate.Y <= $options.MinDate.Y,
                        onClick: _cache[0] || (_cache[0] = ($event)=>$data.ViewDate.Y--)
                    }, $f94ad5b617b0063f$var$_hoisted_8, 8, $f94ad5b617b0063f$var$_hoisted_6),
                    (0, $cfZzL.createElementVNode)("div", {
                        onClick: _cache[1] || (_cache[1] = ($event)=>$data.ViewDate.YearView = false)
                    }, (0, $4bH2P.toDisplayString)($data.ViewDate.Y), 1),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: "p-1",
                        "data-disabled": $data.ViewDate.Y >= $options.MaxDate.Y,
                        onClick: _cache[2] || (_cache[2] = ($event)=>$data.ViewDate.Y++)
                    }, $f94ad5b617b0063f$var$_hoisted_11, 8, $f94ad5b617b0063f$var$_hoisted_9)
                ]),
                (0, $cfZzL.createElementVNode)("div", $f94ad5b617b0063f$var$_hoisted_12, [
                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.MonthNames, (Month, i)=>{
                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: i,
                            onClick: ($event)=>{
                                $data.ViewDate.M = i + 1;
                                $options.CreateMonthView();
                                $data.ViewDate.YearView = false;
                            }
                        }, (0, $4bH2P.toDisplayString)(Month.substr(0, 3)), 9, $f94ad5b617b0063f$var$_hoisted_13);
                    }), 128))
                ])
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            !$data.ViewDate.YearView ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $f94ad5b617b0063f$var$_hoisted_14, [
                (0, $cfZzL.createElementVNode)("div", $f94ad5b617b0063f$var$_hoisted_15, [
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)([
                            "p-1",
                            {
                                "pointer-events-none opacity-25": !($data.ViewDate.Y > $options.MinDate.Y || $data.ViewDate.Y === $options.MinDate.Y && $data.ViewDate.M > $options.MinDate.M)
                            }
                        ]),
                        onClick: _cache[3] || (_cache[3] = ($event)=>$options.Navigate(-1))
                    }, $f94ad5b617b0063f$var$_hoisted_17, 2),
                    (0, $cfZzL.createElementVNode)("div", {
                        onClick: _cache[4] || (_cache[4] = ($event)=>$data.ViewDate.YearView = true)
                    }, (0, $4bH2P.toDisplayString)($data.MonthNames[$data.ViewDate.M - 1]) + " " + (0, $4bH2P.toDisplayString)($data.ViewDate.Y), 1),
                    (0, $cfZzL.createElementVNode)("div", {
                        class: (0, $4bH2P.normalizeClass)([
                            "p-1",
                            [
                                !($data.ViewDate.Y < $options.MaxDate.Y || $data.ViewDate.Y === $options.MaxDate.Y && $data.ViewDate.M < $options.MaxDate.M) ? "pointer-events-none opacity-25" : ""
                            ]
                        ]),
                        onClick: _cache[5] || (_cache[5] = ($event)=>$options.Navigate(1))
                    }, $f94ad5b617b0063f$var$_hoisted_19, 2)
                ]),
                (0, $cfZzL.createElementVNode)("div", $f94ad5b617b0063f$var$_hoisted_20, [
                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.DayNames, (Name, i)=>{
                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: "h" + i,
                            class: "is-header"
                        }, (0, $4bH2P.toDisplayString)(Name), 1);
                    }), 128)),
                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($data.MonthView, (Day, i)=>{
                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                            key: "i" + i,
                            class: (0, $4bH2P.normalizeClass)({
                                "is-navigatable": Day.Navigate,
                                "is-selected": Day.Selected,
                                "is-disabled": Day.Disabled
                            }),
                            "data-emblem": ($props.Emblems || {})[Day.Y + ":" + Day.M + ":" + Day.D],
                            "data-day": Day.Y + ":" + Day.M + ":" + Day.D,
                            onClick: ($event)=>$options.SelectDate(Day)
                        }, (0, $4bH2P.toDisplayString)(Day.D), 11, $f94ad5b617b0063f$var$_hoisted_21);
                    }), 128))
                ])
            ])) : (0, $cfZzL.createCommentVNode)("", true)
        ])) : (0, $cfZzL.createCommentVNode)("", true)
    ], 2);
}

});

parcelRequire.register("k85Um", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea792333c122ab7d$export$2e2bcd8739ae039; });
let $ea792333c122ab7d$var$NOOP = ()=>{};
var $ea792333c122ab7d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("kX4cE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f40c93f458cbd173$export$2e2bcd8739ae039; });
let $f40c93f458cbd173$var$script;




let $f40c93f458cbd173$var$initialize = ()=>{
    $f40c93f458cbd173$var$script = (parcelRequire("j7UE9"));
    if ($f40c93f458cbd173$var$script.__esModule) $f40c93f458cbd173$var$script = $f40c93f458cbd173$var$script.default;
    $f40c93f458cbd173$var$script.render = (parcelRequire("13qqC")).render;
    $f40c93f458cbd173$var$script.__cssModules = {};
    (parcelRequire("fVDku")).default($f40c93f458cbd173$var$script);
    $f40c93f458cbd173$var$script.__scopeId = "data-v-86445a";
    $f40c93f458cbd173$var$script.__file = "DropdownSelect.vue";
};
$f40c93f458cbd173$var$initialize();
var $f40c93f458cbd173$export$2e2bcd8739ae039 = $f40c93f458cbd173$var$script;

});
parcelRequire.register("j7UE9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cb8c5678dc9afd90$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za kontrolkę wyboru elementu z listy.
// @group Base Components | Forms
var $cb8c5678dc9afd90$export$2e2bcd8739ae039 = {
    name: "DropdownSelect",
    props: {
        modelValue: {
            default: ""
        },
        Items: {
            default: ()=>new Array()
        },
        Placeholder: {
            type: String,
            default: ""
        },
        Disabled: {
            type: Boolean,
            default: false
        },
        Arrowless: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "update:modelValue",
        "change"
    ],
    data () {
        return {
            Value: "",
            Labels: {},
            Focused: false
        };
    },
    watch: {
        modelValue (n) {
            this.Value = n;
        },
        Items (n) {
            this.Labels = {};
            for (const i of n)this.Labels[i.Value] = i.Label;
        }
    },
    created () {
        try {
            for (const i of this.Items || [])this.Labels[i.Value] = i.Label;
        } catch (err) {}
        this.Value = this.modelValue;
    },
    methods: {
        OnClick () {
            if (this.Disabled) return;
            this.Focused = !this.Focused;
        },
        OnSelect (i) {
            this.Value = i.Value;
            // TODO: v to nie powinno trafić tutaj, tylko jako obsłużęnie eventu!!!!11
            if (this.Value === "MyRfps" || this.Value === "BuyerView") this.Analytics.GA4Event("ga_event", "click_rfpList");
            if (this.Value === "close") this.Analytics.GA4Event("ga_event", "click_exitRfp");
            this.$emit("update:modelValue", this.Value);
            this.$emit("change", this.Value);
        }
    }
};

});

parcelRequire.register("13qqC", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $0c4a925f0ea2357a$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $0c4a925f0ea2357a$var$_hoisted_1 = [
    "disabled"
];
const $0c4a925f0ea2357a$var$_hoisted_2 = [
    "innerHTML"
];
const $0c4a925f0ea2357a$var$_hoisted_3 = {
    class: "suggestions-list"
};
const $0c4a925f0ea2357a$var$_hoisted_4 = [
    "data-test",
    "onClick",
    "innerHTML"
];
function $0c4a925f0ea2357a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        "data-component": "DropdownSelect.vue",
        class: (0, $4bH2P.normalizeClass)([
            "dropdown",
            {
                "is-focused": $data.Focused,
                "is-arrowless": $props.Arrowless
            }
        ]),
        onClick: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)((...args)=>$options.OnClick && $options.OnClick(...args), [
            "prevent",
            "stop"
        ]))
    }, [
        (0, $cfZzL.createElementVNode)("button", {
            class: "dropdown-button",
            disabled: $props.Disabled
        }, [
            _ctx.$slots.label ? (0, $cfZzL.renderSlot)(_ctx.$slots, "label", {
                key: 0
            }) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                key: 1,
                innerHTML: $data.Labels[$data.Value] ? $data.Labels[$data.Value] : $props.Placeholder
            }, null, 8, $0c4a925f0ea2357a$var$_hoisted_2))
        ], 8, $0c4a925f0ea2357a$var$_hoisted_1),
        (0, $cfZzL.createElementVNode)("div", $0c4a925f0ea2357a$var$_hoisted_3, [
            ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($props.Items, (item, i)=>{
                return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, [
                    item.Value ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("a", {
                        "data-test": item.DataTest || "dropdown__option",
                        key: i,
                        class: (0, $4bH2P.normalizeClass)(item.Class || ""),
                        onClick: ($event)=>$options.OnSelect(item),
                        innerHTML: item.Label
                    }, null, 10, $0c4a925f0ea2357a$var$_hoisted_4)) : (0, $cfZzL.createCommentVNode)("", true)
                ], 64);
            }), 256))
        ])
    ], 2);
}

});

parcelRequire.register("fVDku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b98aafe4f8984e3f$export$2e2bcd8739ae039; });
let $b98aafe4f8984e3f$var$NOOP = ()=>{};
var $b98aafe4f8984e3f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("7ZJVF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5d21db746587b349$export$2e2bcd8739ae039; });
let $5d21db746587b349$var$script;



let $5d21db746587b349$var$initialize = ()=>{
    $5d21db746587b349$var$script = (parcelRequire("6Si1O"));
    if ($5d21db746587b349$var$script.__esModule) $5d21db746587b349$var$script = $5d21db746587b349$var$script.default;
    $5d21db746587b349$var$script.render = (parcelRequire("fMcdF")).render;
    (parcelRequire("gJli3")).default($5d21db746587b349$var$script);
    $5d21db746587b349$var$script.__scopeId = "data-v-a36fc5";
    $5d21db746587b349$var$script.__file = "ExpansionPanel.vue";
};
$5d21db746587b349$var$initialize();
var $5d21db746587b349$export$2e2bcd8739ae039 = $5d21db746587b349$var$script;

});
parcelRequire.register("6Si1O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2b3181ad31054897$export$2e2bcd8739ae039; });
var $2b3181ad31054897$export$2e2bcd8739ae039 = {
    name: "ExpansionPanel",
    props: {
        title: {
            type: String,
            required: true
        },
        contentItems: {
            type: Array,
            default: ()=>[]
        },
        icon: {
            type: Object,
            default: ()=>({
                    name: "",
                    className: [],
                    set: "base"
                })
        }
    },
    data () {
        return {
            isDetailsVisible: [
                false,
                false
            ]
        };
    },
    methods: {
        toggleDetailsVisible (index) {
            this.isDetailsVisible[index] = !this.isDetailsVisible[index];
        }
    }
};

});

parcelRequire.register("fMcdF", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b7c4d13af849a719$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $b7c4d13af849a719$var$_hoisted_1 = {
    "data-component": "ExpansionPanel.vue",
    class: "text-center mobile-introduction"
};
const $b7c4d13af849a719$var$_hoisted_2 = {
    class: "flex justify-between items-center font-bold text-left"
};
const $b7c4d13af849a719$var$_hoisted_3 = {
    class: "flex items-center"
};
const $b7c4d13af849a719$var$_hoisted_4 = {
    class: "text-base font-bold"
};
const $b7c4d13af849a719$var$_hoisted_5 = {
    key: 0,
    class: "mt-4"
};
function $b7c4d13af849a719$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $b7c4d13af849a719$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("div", {
            class: "rounded-lg shadow-elevation-y-2px bg-white p-3",
            onClick: _cache[0] || (_cache[0] = ($event)=>$options.toggleDetailsVisible(0))
        }, [
            (0, $cfZzL.createElementVNode)("div", $b7c4d13af849a719$var$_hoisted_2, [
                (0, $cfZzL.createElementVNode)("div", $b7c4d13af849a719$var$_hoisted_3, [
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: $props.icon.name,
                        size: "1.5",
                        class: (0, $4bH2P.normalizeClass)([
                            "mr-3",
                            $props.icon.className
                        ]),
                        set: $props.icon.set
                    }, null, 8, [
                        "name",
                        "class",
                        "set"
                    ]),
                    (0, $cfZzL.createElementVNode)("div", $b7c4d13af849a719$var$_hoisted_4, (0, $4bH2P.toDisplayString)($props.title), 1)
                ]),
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "chevron-down",
                    size: "0.5",
                    class: (0, $4bH2P.normalizeClass)([
                        "cursor-pointer",
                        {
                            "rotate-180": $data.isDetailsVisible[0]
                        }
                    ])
                }, null, 8, [
                    "class"
                ])
            ]),
            $data.isDetailsVisible[0] ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $b7c4d13af849a719$var$_hoisted_5, [
                (0, $cfZzL.renderSlot)(_ctx.$slots, "default")
            ])) : (0, $cfZzL.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRequire.register("gJli3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e15d1a1cc0eb25$export$2e2bcd8739ae039; });
let $c2e15d1a1cc0eb25$var$NOOP = ()=>{};
var $c2e15d1a1cc0eb25$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("dFI3A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9f41477b3721a6a7$export$2e2bcd8739ae039; });
let $9f41477b3721a6a7$var$script;




let $9f41477b3721a6a7$var$initialize = ()=>{
    $9f41477b3721a6a7$var$script = (parcelRequire("A4oYQ"));
    if ($9f41477b3721a6a7$var$script.__esModule) $9f41477b3721a6a7$var$script = $9f41477b3721a6a7$var$script.default;
    $9f41477b3721a6a7$var$script.render = (parcelRequire("1TMrZ")).render;
    $9f41477b3721a6a7$var$script.__cssModules = {};
    (parcelRequire("e3PNV")).default($9f41477b3721a6a7$var$script);
    $9f41477b3721a6a7$var$script.__scopeId = "data-v-731794";
    $9f41477b3721a6a7$var$script.__file = "FormInput.vue";
};
$9f41477b3721a6a7$var$initialize();
var $9f41477b3721a6a7$export$2e2bcd8739ae039 = $9f41477b3721a6a7$var$script;

});
parcelRequire.register("A4oYQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cba1676d0f6fe48d$export$2e2bcd8739ae039; });

var $bEsUP = parcelRequire("bEsUP");
var $cba1676d0f6fe48d$export$2e2bcd8739ae039 = {
    name: "FormInput",
    props: {
        type: {
            type: String,
            default: "text"
        },
        placeholder: String,
        name: String,
        focus: Boolean,
        modelValue: [
            String,
            Number
        ],
        autocomplete: String
    },
    emits: [
        "update:modelValue",
        "keyup"
    ],
    mounted () {
        if (this.focus) this.focusInput();
    },
    methods: {
        focusInput () {
            this.$refs.input.focus();
        },
        PreventKeyCode (e) {
            if (this.type === "number" || this.type === "tel") {
                if (this.type === "tel" && e.key !== "+") (0, $bEsUP.onlyNumber)(e);
            }
        },
        OnlyNumber (e) {
            (0, $bEsUP.onlyNumber)(e);
        }
    }
};

});
parcelRequire.register("bEsUP", function(module, exports) {

$parcel$export(module.exports, "onlyNumber", function () { return $99d1ed0c0e9b4e1e$export$932a198dfce9618e; });
$parcel$export(module.exports, "preventInput", function () { return $99d1ed0c0e9b4e1e$export$4cfe642a9c5890fe; });
function $99d1ed0c0e9b4e1e$export$932a198dfce9618e(e, allowFloat = false) {
    const a = [];
    const k = e.which;
    // Ctrl+A,Ctrl+C,Ctrl+V, Command+A
    if ((k === 65 || k === 86 || k === 67) && (e.ctrlKey === true || e.metaKey === true)) a.push(k);
    // liczby 1-9
    for(let i = 48; i < 58; i++)a.push(i);
    // klawiatura numeryczna
    for(let i = 96; i < 106; i++)a.push(i);
    // Backspace
    if (k === 8) a.push(k); // Backspace
    // Przecinek i kropka
    if (allowFloat && [
        188,
        190,
        110
    ].includes(k)) a.push(k);
    if (!(a.indexOf(k) >= 0)) e.preventDefault();
}
function $99d1ed0c0e9b4e1e$export$4cfe642a9c5890fe(e, isNumeric, allowFloat = false) {
    let proceed = false;
    const key = [
        "ArrowUp",
        "ArrowDown",
        "KeyE",
        ...isNumeric === "float" ? [
            "Period",
            "Comma",
            "NumpadDecimal"
        ] : []
    ].indexOf(e.code) > -1;
    if (e.code === "Enter") proceed = true;
    if (isNumeric && key) {
        e.preventDefault();
        // If allowFloat is true, replaces comma with period
        if (allowFloat && [
            "Comma",
            "NumpadDecimal"
        ].includes(e.code)) {
            const target = e.target;
            target.value += ".";
        }
    }
    return proceed;
}

});


parcelRequire.register("1TMrZ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $162082bc7fa9b2b2$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $162082bc7fa9b2b2$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-731794"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $162082bc7fa9b2b2$var$_hoisted_1 = {
    class: "input-container",
    "data-component": "FormInput.vue"
};
const $162082bc7fa9b2b2$var$_hoisted_2 = [
    "type",
    "value",
    "name",
    "autocomplete"
];
const $162082bc7fa9b2b2$var$_hoisted_3 = {
    class: "floating-label"
};
function $162082bc7fa9b2b2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $162082bc7fa9b2b2$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("input", {
            class: "inputText",
            required: "",
            ref: "input",
            type: $props.type,
            value: $props.modelValue,
            name: $props.name,
            autocomplete: $props.autocomplete,
            onInput: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("update:modelValue", $event.target.value)),
            onKeyup: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("keyup", $event.target.value)),
            onKeydown: _cache[2] || (_cache[2] = (...args)=>$options.PreventKeyCode && $options.PreventKeyCode(...args))
        }, null, 40, $162082bc7fa9b2b2$var$_hoisted_2),
        (0, $cfZzL.createElementVNode)("span", $162082bc7fa9b2b2$var$_hoisted_3, (0, $4bH2P.toDisplayString)($props.placeholder), 1)
    ]);
}

});

parcelRequire.register("e3PNV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3c987b9cca2efed$export$2e2bcd8739ae039; });
let $a3c987b9cca2efed$var$NOOP = ()=>{};
var $a3c987b9cca2efed$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("gW1PF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c5437bf798fd58ee$export$2e2bcd8739ae039; });
let $c5437bf798fd58ee$var$script;




let $c5437bf798fd58ee$var$initialize = ()=>{
    $c5437bf798fd58ee$var$script = (parcelRequire("gvSUB"));
    if ($c5437bf798fd58ee$var$script.__esModule) $c5437bf798fd58ee$var$script = $c5437bf798fd58ee$var$script.default;
    $c5437bf798fd58ee$var$script.render = (parcelRequire("iavHS")).render;
    $c5437bf798fd58ee$var$script.__cssModules = {};
    (parcelRequire("eDpbh")).default($c5437bf798fd58ee$var$script);
    $c5437bf798fd58ee$var$script.__scopeId = "data-v-362643";
    $c5437bf798fd58ee$var$script.__file = "Loader.vue";
};
$c5437bf798fd58ee$var$initialize();
var $c5437bf798fd58ee$export$2e2bcd8739ae039 = $c5437bf798fd58ee$var$script;

});
parcelRequire.register("gvSUB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d3ced6250d5c971c$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za wyświetlenie animacji ładowania.
// @group Base Components
var $d3ced6250d5c971c$export$2e2bcd8739ae039 = {
    name: "Loader",
    props: {
        Type: {
            default: "ellipsis",
            type: String
        },
        OptionalStyling: {
            default: "",
            type: String
        },
        // narazzie tylko dla loadera typu ring
        size: {
            type: String,
            default: "medium",
            validator: (value)=>[
                    "small",
                    "medium",
                    "large"
                ].includes(value)
        }
    },
    computed: {
        loaderSize () {
            return `ring-loader--${this.size}`;
        }
    }
};

});

parcelRequire.register("iavHS", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d3a1c17551f29613$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $d3a1c17551f29613$var$_hoisted_1 = {
    "data-component": "Loader.vue",
    class: "[ loader ] flex items-center justify-center"
};
const $d3a1c17551f29613$var$_hoisted_2 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_3 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_4 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_5 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_6 = [
    $d3a1c17551f29613$var$_hoisted_2,
    $d3a1c17551f29613$var$_hoisted_3,
    $d3a1c17551f29613$var$_hoisted_4,
    $d3a1c17551f29613$var$_hoisted_5
];
const $d3a1c17551f29613$var$_hoisted_7 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_8 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_9 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_10 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
const $d3a1c17551f29613$var$_hoisted_11 = [
    $d3a1c17551f29613$var$_hoisted_7,
    $d3a1c17551f29613$var$_hoisted_8,
    $d3a1c17551f29613$var$_hoisted_9,
    $d3a1c17551f29613$var$_hoisted_10
];
function $d3a1c17551f29613$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $d3a1c17551f29613$var$_hoisted_1, [
        $props.Type === "ring" ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 0,
            class: (0, $4bH2P.normalizeClass)([
                "ring-loader",
                $options.loaderSize
            ])
        }, $d3a1c17551f29613$var$_hoisted_6, 2)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 1,
            class: (0, $4bH2P.normalizeClass)([
                "mx-auto my-6 lds-ellipsis",
                $props.OptionalStyling
            ])
        }, $d3a1c17551f29613$var$_hoisted_11, 2))
    ]);
}

});

parcelRequire.register("eDpbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa783d9e72330658$export$2e2bcd8739ae039; });
let $aa783d9e72330658$var$NOOP = ()=>{};
var $aa783d9e72330658$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("4t2So", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $340c1a0e59728f1d$export$2e2bcd8739ae039; });
let $340c1a0e59728f1d$var$script;




let $340c1a0e59728f1d$var$initialize = ()=>{
    $340c1a0e59728f1d$var$script = (parcelRequire("71ba9"));
    if ($340c1a0e59728f1d$var$script.__esModule) $340c1a0e59728f1d$var$script = $340c1a0e59728f1d$var$script.default;
    $340c1a0e59728f1d$var$script.render = (parcelRequire("jCrgA")).render;
    $340c1a0e59728f1d$var$script.__cssModules = {};
    (parcelRequire("2DefW")).default($340c1a0e59728f1d$var$script);
    $340c1a0e59728f1d$var$script.__scopeId = "data-v-8ae3fe";
    $340c1a0e59728f1d$var$script.__file = "ModalDialog.vue";
};
$340c1a0e59728f1d$var$initialize();
var $340c1a0e59728f1d$export$2e2bcd8739ae039 = $340c1a0e59728f1d$var$script;

});
parcelRequire.register("71ba9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2884a5f6b7514ad1$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za wyświetlenie okna dialogowego.
// @group Base Components
var $2884a5f6b7514ad1$export$2e2bcd8739ae039 = {
    name: "ModalDialog",
    props: {
        Autoclose: {
            type: Boolean,
            default: false
        },
        Visible: {
            type: Boolean,
            default: false
        },
        BackOnClick: {
            type: Boolean,
            default: false
        },
        CloseOnBackdropClick: {
            type: Boolean,
            default: false
        },
        Position: {
            type: Object,
            default: ()=>({})
        },
        ContentClass: {
            type: String,
            default: ""
        }
    },
    emits: [
        "open",
        "toggle",
        "OnOverlayClick",
        "close"
    ],
    data () {
        return {
            InternalVisible: false,
            ExternalVisible: false,
            BackdropClicked: false
        };
    },
    computed: {
        Style () {
            if (Object.keys(this.Position).length > 0) return {
                ...this.Position,
                position: "absolute"
            };
            return {};
        }
    },
    watch: {
        Visible: {
            handler (v) {
                this.$emit("open");
                window.setTimeout(()=>{
                    if (v) {
                        this.InternalVisible = true;
                        this.ExternalVisible = true;
                        this.BackdropClicked = false;
                    } else this.ExternalVisible = false;
                }, 300);
            },
            immediate: true
        }
    },
    methods: {
        LogEvent (e) {
            e.target.matches(".modal-dialog") || (e.target.scrollHeight, e.target.offsetHeight);
        // e.stopPropagation();
        },
        Toggle () {
            this.$emit("toggle");
            if (this.BackOnClick && !this.BackdropClicked) {
                this.BackdropClicked = true;
                window.history.back();
            }
            if (this.CloseOnBackdropClick && !this.BackdropClicked) {
                this.BackdropClicked = true;
                this.ExternalVisible = false;
            }
            this.$emit("OnOverlayClick");
        },
        OnAnimationEnd ($event) {
            const $target = $event.target;
            const { animationName: animationName } = $event;
            if (this.Autoclose) {
                if (animationName.startsWith("modal-in")) $target.classList.add("is-staying");
                if (animationName.startsWith("hold")) {
                    this.ExternalVisible = false;
                    $target.classList.remove("is-staying");
                }
            }
            if (animationName.startsWith("modal-out")) {
                this.InternalVisible = false;
                this.$emit("close");
            }
        }
    }
};

});

parcelRequire.register("jCrgA", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $e486b77c9e6e8571$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
function $e486b77c9e6e8571$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        "data-component": "ModalDialog.vue",
        class: (0, $4bH2P.normalizeClass)([
            "[ modal-dialog ]",
            {
                "is-visible": $data.ExternalVisible,
                "is-autoclose": $props.Autoclose,
                "is-desktop": _ctx.ScreenSize > 1
            }
        ]),
        onWheel: _cache[2] || (_cache[2] = (0, $brqXq.withModifiers)(()=>{}, [
            "stop",
            "prevent"
        ])),
        onTouchstart: _cache[3] || (_cache[3] = (0, $brqXq.withModifiers)((...args)=>$options.LogEvent && $options.LogEvent(...args), [
            "stop"
        ])),
        onClick: _cache[4] || (_cache[4] = (...args)=>$options.Toggle && $options.Toggle(...args)),
        onAnimationend: _cache[5] || (_cache[5] = (...args)=>$options.OnAnimationEnd && $options.OnAnimationEnd(...args)),
        onMousewheel: _cache[6] || (_cache[6] = (0, $brqXq.withModifiers)(()=>{}, [
            "stop"
        ]))
    }, [
        $data.InternalVisible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 0,
            ref: "modal",
            class: "[ modal-dialog-wrapper ]",
            style: (0, $4bH2P.normalizeStyle)($options.Style),
            onWheel: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)(()=>{}, [
                "stop"
            ])),
            onClick: _cache[1] || (_cache[1] = (0, $brqXq.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            (0, $cfZzL.createElementVNode)("div", {
                class: (0, $4bH2P.normalizeClass)([
                    "[ modal-dialog-content ] relative",
                    $props.ContentClass
                ])
            }, [
                (0, $cfZzL.renderSlot)(_ctx.$slots, "default")
            ], 2),
            (0, $cfZzL.renderSlot)(_ctx.$slots, "footer")
        ], 36)) : (0, $cfZzL.createCommentVNode)("", true)
    ], 34);
}

});

parcelRequire.register("2DefW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eaa4847311b09e3$export$2e2bcd8739ae039; });
let $1eaa4847311b09e3$var$NOOP = ()=>{};
var $1eaa4847311b09e3$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("aofBH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $79084087b7debd96$export$2e2bcd8739ae039; });
let $79084087b7debd96$var$script;




let $79084087b7debd96$var$initialize = ()=>{
    $79084087b7debd96$var$script = (parcelRequire("4086a"));
    if ($79084087b7debd96$var$script.__esModule) $79084087b7debd96$var$script = $79084087b7debd96$var$script.default;
    $79084087b7debd96$var$script.render = (parcelRequire("f31Dn")).render;
    $79084087b7debd96$var$script.__cssModules = {};
    (parcelRequire("bOJEr")).default($79084087b7debd96$var$script);
    $79084087b7debd96$var$script.__scopeId = "data-v-fa1409";
    $79084087b7debd96$var$script.__file = "OferteoLogo.vue";
};
$79084087b7debd96$var$initialize();
var $79084087b7debd96$export$2e2bcd8739ae039 = $79084087b7debd96$var$script;

});
parcelRequire.register("4086a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ddcd68d4f81ec045$export$2e2bcd8739ae039; });
// @vuese
// Zawiera style dla logo Oferteo w pasku nawigacyjnym oraz stopce
// @todo Dodaj szablon wyświetlający logo wraz z linkiem kierującym na stronę główną.
// @group Base Components
var $ddcd68d4f81ec045$export$2e2bcd8739ae039 = {
    name: "OferteoLogo"
};

});

parcelRequire.register("f31Dn", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $af48675930e90fed$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
const $af48675930e90fed$var$_hoisted_1 = {
    "data-component": "OferteoLogo.vue",
    class: "svg svg-logotype-oferteo"
};
function $af48675930e90fed$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $af48675930e90fed$var$_hoisted_1);
}

});

parcelRequire.register("bOJEr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89a7c69a1d2e89f5$export$2e2bcd8739ae039; });
let $89a7c69a1d2e89f5$var$NOOP = ()=>{};
var $89a7c69a1d2e89f5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("2HUzI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1f8b7b86a283f1f9$export$2e2bcd8739ae039; });
let $1f8b7b86a283f1f9$var$script;




let $1f8b7b86a283f1f9$var$initialize = ()=>{
    $1f8b7b86a283f1f9$var$script = (parcelRequire("8p1ue"));
    if ($1f8b7b86a283f1f9$var$script.__esModule) $1f8b7b86a283f1f9$var$script = $1f8b7b86a283f1f9$var$script.default;
    $1f8b7b86a283f1f9$var$script.render = (parcelRequire("l0uMv")).render;
    $1f8b7b86a283f1f9$var$script.__cssModules = {};
    (parcelRequire("9OM3b")).default($1f8b7b86a283f1f9$var$script);
    $1f8b7b86a283f1f9$var$script.__scopeId = "data-v-d8bc31";
    $1f8b7b86a283f1f9$var$script.__file = "PageHeader.vue";
};
$1f8b7b86a283f1f9$var$initialize();
var $1f8b7b86a283f1f9$export$2e2bcd8739ae039 = $1f8b7b86a283f1f9$var$script;

});
parcelRequire.register("8p1ue", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3ed9a9f3bab2e7b4$export$2e2bcd8739ae039; });

var $kX4cE = parcelRequire("kX4cE");

var $d6CjH = parcelRequire("d6CjH");
var // @vuese
// Komponent odpowiedzialny za wyświetlenie nagłówka okna dialogowego.
// @group Base Components
$3ed9a9f3bab2e7b4$export$2e2bcd8739ae039 = {
    name: "PageHeader",
    components: {
        DropdownSelect: $kX4cE.default,
        MenuNavbar: $d6CjH.default
    },
    props: {
        Title: {
            type: String,
            required: false
        },
        TitleClasses: {
            type: String,
            default: ""
        },
        Subtitle: {
            type: String,
            required: false,
            default: ""
        },
        Back: {
            type: Boolean,
            default: false
        },
        BackTo: {
            type: String,
            default: ""
        },
        BackOnDesktop: {
            type: Boolean,
            default: false
        },
        Logo: {
            type: Boolean,
            default: false
        },
        LogoCenter: {
            type: Boolean,
            default: false
        },
        LogoHref: {
            type: String,
            default: "/"
        },
        Burger: {
            type: Boolean,
            default: false
        },
        EmitInstead: {
            type: Boolean,
            default: false
        },
        Buttons: {
            type: Array,
            default: ()=>[]
        },
        Menu: {
            type: Array,
            default: ()=>[]
        },
        rfpStatus: {
            type: Object,
            default: ()=>({})
        },
        HideBg: {
            type: Boolean,
            default: false
        },
        WrapperClasses: {
            type: String,
            default: ""
        }
    },
    emits: [
        "back-click",
        "button-click"
    ],
    methods: {
        OnMenuItem (actionName) {
            this.$emit("button-click", actionName);
        },
        GoBack () {
            if (this.BackTo) {
                window.location.href = this.BackTo;
                return;
            }
            if (this.EmitInstead) this.$emit("back-click");
            else this.State.Back();
        },
        TitleClick () {
            if (this.ScreenSize > 1) return;
            const el = document.querySelector(".global-navigation-submenu, .global-navigation-back");
            el === null || el === void 0 ? void 0 : el.click();
        }
    }
};

});
parcelRequire.register("d6CjH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98a98eca6db5151e$export$2e2bcd8739ae039; });
let $98a98eca6db5151e$var$script;




let $98a98eca6db5151e$var$initialize = ()=>{
    $98a98eca6db5151e$var$script = (parcelRequire("6EiW3"));
    if ($98a98eca6db5151e$var$script.__esModule) $98a98eca6db5151e$var$script = $98a98eca6db5151e$var$script.default;
    $98a98eca6db5151e$var$script.render = (parcelRequire("4oULP")).render;
    $98a98eca6db5151e$var$script.__cssModules = {};
    (parcelRequire("1pyUf")).default($98a98eca6db5151e$var$script);
    $98a98eca6db5151e$var$script.__scopeId = "data-v-fdcaf6";
    $98a98eca6db5151e$var$script.__file = "MenuNavbar.vue";
};
$98a98eca6db5151e$var$initialize();
var $98a98eca6db5151e$export$2e2bcd8739ae039 = $98a98eca6db5151e$var$script;

});
parcelRequire.register("6EiW3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8a92191a363551c0$export$2e2bcd8739ae039; });

var $jgrCW = parcelRequire("jgrCW");

var $4vLd7 = parcelRequire("4vLd7");

var $kLPO4 = parcelRequire("kLPO4");

var $3cbAx = parcelRequire("3cbAx");
var /**
 * Komponent odpowiedzialny za przycisk z głównym menu nawigacyjnym.
 */ $8a92191a363551c0$export$2e2bcd8739ae039 = {
    name: "MenuNavbar",
    components: {
        DropdownPanel: $4vLd7.default
    },
    props: {
        /**
		 * Czy pokazać przycisk w formie skróconego przycisku?
		 */ burger: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            itemClass: "flex items-center hover:text-info cursor-pointer px-4 py-3",
            customerMenu: [
                {
                    sectionName: "Wizyt\xf3wka",
                    items: [
                        {
                            name: "Promuj firmę",
                            // travelTo: ['CustomerProfileView', { Section: 'Promotion' }],
                            icon: "profile-promotion",
                            url: "/konto/profil/promowanie"
                        },
                        {
                            name: "Uzupełnij wizyt\xf3wkę",
                            travelTo: [
                                "CustomerProfileView",
                                {
                                    Section: ""
                                }
                            ],
                            icon: "profile-main",
                            url: "/konto/profil/",
                            isExpanded: false,
                            items: [
                                {
                                    name: "Informacje og\xf3lne",
                                    travelTo: [
                                        "CustomerProfileView",
                                        {
                                            Section: "BasicInfo"
                                        }
                                    ],
                                    icon: "profile-basic-info",
                                    url: "/konto/profil/informacje"
                                },
                                {
                                    name: "Kontakt",
                                    travelTo: [
                                        "CustomerProfileView",
                                        {
                                            Section: "ContactInfo"
                                        }
                                    ],
                                    icon: "profile-contact-info",
                                    url: "/konto/profil/dane-kontaktowe"
                                },
                                {
                                    name: "Opis",
                                    travelTo: [
                                        "CustomerProfileView",
                                        {
                                            Section: "Description"
                                        }
                                    ],
                                    icon: "profile-description",
                                    url: "/konto/profil/opis"
                                },
                                {
                                    name: "Zdjęcia",
                                    travelTo: [
                                        "CustomerProfileView",
                                        {
                                            Section: "Gallery"
                                        }
                                    ],
                                    icon: "profile-photos",
                                    url: "/konto/profil/galeria-zdjec"
                                },
                                {
                                    name: "Opinie",
                                    travelTo: [
                                        "CustomerProfileView",
                                        {
                                            Section: "Reviews"
                                        }
                                    ],
                                    icon: "profile-reviews",
                                    url: "/konto/profil/opinie"
                                },
                                {
                                    name: "Oferty",
                                    travelTo: [
                                        "CustomerProfileView",
                                        {
                                            Section: "Offers"
                                        }
                                    ],
                                    icon: "profile-offers",
                                    url: "/konto/profil/oferty"
                                }
                            ]
                        }
                    ]
                },
                {
                    sectionName: "Konto",
                    items: [
                        {
                            name: "Powiadomienia",
                            travelTo: [
                                "CustomerSettingsView",
                                {
                                    Section: "Notifications"
                                }
                            ],
                            icon: "account-notifications",
                            url: "/konto/ustawienia/powiadomienia"
                        },
                        {
                            name: "Ustawienia konta",
                            travelTo: [
                                "CustomerSettingsView",
                                {
                                    Section: "ChangePassword"
                                }
                            ],
                            icon: "account-settings",
                            url: "/konto/ustawienia/haslo"
                        },
                        {
                            name: "Terminarz",
                            travelTo: [
                                "SchedulerPage",
                                {}
                            ],
                            icon: "account-scheduler",
                            url: "/konto/terminarz"
                        },
                        {
                            name: "Pomoc",
                            icon: "account-help",
                            url: "/kontakt.html?idSubject=contactError"
                        }
                    ]
                },
                {
                    sectionName: "Pozostałe",
                    items: [
                        {
                            name: "Certyfikaty",
                            travelTo: [
                                "CustomerProfileView",
                                {
                                    Section: "Certificates"
                                }
                            ],
                            icon: "other-certificates",
                            url: "/konto/profil/certyfikaty"
                        },
                        {
                            name: "Ranking Najlepszych",
                            travelTo: [
                                "CustomerProfileView",
                                {
                                    Section: "Certificates",
                                    SelectedSectionId: "badges"
                                }
                            ],
                            icon: "other-the-best",
                            url: "/konto/profil/certyfikaty/odznaki"
                        },
                        {
                            name: "Program Partnerski",
                            travelTo: [
                                "CustomerProfileView",
                                {
                                    Section: "Partnership"
                                }
                            ],
                            icon: "other-partnership",
                            url: "/konto/profil/program-partnerski"
                        }
                    ]
                }
            ],
            adminMenu: [
                {
                    sectionName: "Administracja",
                    items: [
                        {
                            name: "Obsługa bieżąca",
                            icon: "",
                            url: "/admin/WFObjectList.ofer"
                        },
                        {
                            name: "Rejestracja dostawcy",
                            icon: "",
                            url: "/rejestracja/wybierz-klientow"
                        }
                    ]
                }
            ]
        };
    },
    computed: {
        ...(0, $jgrCW.mapStores)((0, $3cbAx.useUserStore)),
        menu () {
            const result = [];
            const currentModule = this.$root.Module;
            const role = this.userStore.role;
            if (role === "BUYER") result.push(this.generateBuyerMenu());
            else result.push(...this.customerMenu);
            if (role === "ADMIN") result.push(...this.adminMenu);
            result.push(this.generateFooterMenu(role, currentModule));
            return result;
        },
        userAvatar () {
            return {
                Avatar: this.userStore.avatar,
                FirstName: this.userStore.firstName,
                LastName: this.userStore.lastName
            };
        }
    },
    methods: {
        addTestName: $kLPO4.addTestName,
        /**
		 * Przenosi użytkownika na wskazaną stronę.
		 */ itemClick (item) {
            // Jeżeli element ma podelementy, to je rozwiń.
            if (item.items) {
                item.isExpanded = !item.isExpanded;
                return;
            }
            const currentModule = this.$root.Module;
            const targetModule = item.targetModule || "CustomerView";
            this.$refs.MenuPanel.Toggle();
            // Jeżeli jest to element wylogowywujący, to to zrób.
            if (item.travelTo && item.travelTo[0] === "Logout") {
                this.$root.Logout();
                return;
            }
            // Jeżeli element nie prowadzi na żadną ścieżkę lub prowadzi
            // na inny moduł, to przejdź pod wskazany URL.
            if (item.url && (!item.travelTo || currentModule !== targetModule)) {
                document.location.href = item.url;
                return;
            }
            this.State.Travel(...item.travelTo);
        },
        generateFooterMenu (role, currentModule) {
            const footer = {
                sectionName: "&nbsp;",
                items: [
                    {
                        name: "Strona gł\xf3wna Oferteo",
                        icon: "main-home",
                        url: "/"
                    }
                ]
            };
            if (role !== "BUYER" && currentModule !== "BuyerView") footer.items.push({
                name: "Przełącz na profil zleceniodawcy",
                icon: "main-switch",
                url: "/konto/moje-zapytania"
            });
            footer.items.push({
                name: "Wyloguj",
                icon: "main-logout",
                travelTo: [
                    "Logout",
                    {}
                ]
            });
            return footer;
        },
        generateBuyerMenu () {
            const buyerMenu = {
                sectionName: "&nbsp;",
                items: [
                    {
                        name: "Moje zapytania",
                        icon: "done-check-notes",
                        iconSet: "base",
                        url: "/konto/moje-zapytania"
                    }
                ]
            };
            const isLogged = this.userStore.userId > 0;
            if (isLogged) buyerMenu.items.push({
                name: "Dane kontaktowe",
                icon: "user-circle-new",
                iconSet: "base",
                url: "/rfp/dane-kontaktowe.ofer"
            });
            const isCustomer = this.userStore.isCustomer;
            buyerMenu.items.push(isCustomer ? {
                name: "Zaloguj się jako Specjalista",
                icon: "main-switch",
                url: "/logowanie"
            } : {
                name: "Dołącz do Specjalist\xf3w",
                icon: "main-switch",
                url: "/rejestracja/wybierz-klientow"
            });
            buyerMenu.items.push({
                name: "Pomoc",
                icon: "account-help",
                url: "/kontakt.html?idSubject=contactError"
            });
            return buyerMenu;
        }
    }
};

});
parcelRequire.register("4vLd7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $348eadb390502fd2$export$2e2bcd8739ae039; });
let $348eadb390502fd2$var$script;




let $348eadb390502fd2$var$initialize = ()=>{
    $348eadb390502fd2$var$script = (parcelRequire("417V5"));
    if ($348eadb390502fd2$var$script.__esModule) $348eadb390502fd2$var$script = $348eadb390502fd2$var$script.default;
    $348eadb390502fd2$var$script.render = (parcelRequire("5xcfY")).render;
    $348eadb390502fd2$var$script.__cssModules = {};
    (parcelRequire("iUUxJ")).default($348eadb390502fd2$var$script);
    $348eadb390502fd2$var$script.__scopeId = "data-v-55ec76";
    $348eadb390502fd2$var$script.__file = "DropdownPanel.vue";
};
$348eadb390502fd2$var$initialize();
var $348eadb390502fd2$export$2e2bcd8739ae039 = $348eadb390502fd2$var$script;

});
parcelRequire.register("417V5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4f79aef51462652b$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za panel wyświetlany po kliknięciu przycisku.
// @group Base Components
var $4f79aef51462652b$export$2e2bcd8739ae039 = {
    name: "DropdownPanel",
    props: {
        Direction: {
            type: String,
            default: "down left"
        },
        Focusable: {
            type: Boolean,
            default: true
        }
    },
    emits: [
        "toggle"
    ],
    data () {
        return {
            Visible: false
        };
    },
    methods: {
        OnClick () {
            this.Toggle();
        },
        OnFocusOut (e) {
            const isInside = e.currentTarget.contains(e.relatedTarget);
            if (!this.Focusable || isInside) return;
            this.Toggle(false);
        },
        Toggle (force) {
            const newState = typeof force === "boolean" ? force : !this.$data.Visible;
            this.$data.Visible = newState;
            this.$emit("toggle", newState);
        }
    }
};

});

parcelRequire.register("5xcfY", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $40798ab6e4bb5739$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $40798ab6e4bb5739$var$_hoisted_1 = [
    "data-direction"
];
const $40798ab6e4bb5739$var$_hoisted_2 = {
    key: 0,
    class: "dropdown-panel"
};
const $40798ab6e4bb5739$var$_hoisted_3 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("div", null, null, -1);
function $40798ab6e4bb5739$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        "data-component": "DropdownPanel.vue",
        class: "dropdown",
        tabindex: "0",
        onFocusout: _cache[3] || (_cache[3] = (...args)=>$options.OnFocusOut && $options.OnFocusOut(...args))
    }, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "dropdown-wrapper",
                {
                    "is-visible": $data.Visible
                }
            ]),
            "data-direction": $props.Direction,
            onClick: _cache[1] || (_cache[1] = (0, $brqXq.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            (0, $cfZzL.createElementVNode)("button", {
                class: "dropdown-button",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.OnClick && $options.OnClick(...args))
            }, [
                (0, $cfZzL.renderSlot)(_ctx.$slots, "button")
            ]),
            $data.Visible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $40798ab6e4bb5739$var$_hoisted_2, [
                (0, $cfZzL.renderSlot)(_ctx.$slots, "default")
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            $40798ab6e4bb5739$var$_hoisted_3
        ], 10, $40798ab6e4bb5739$var$_hoisted_1),
        $data.Visible && !$props.Focusable ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 0,
            class: "dropdown-backdrop",
            onClick: _cache[2] || (_cache[2] = (...args)=>$options.OnClick && $options.OnClick(...args))
        })) : (0, $cfZzL.createCommentVNode)("", true)
    ], 32);
}

});

parcelRequire.register("iUUxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc59513d35260f82$export$2e2bcd8739ae039; });
let $dc59513d35260f82$var$NOOP = ()=>{};
var $dc59513d35260f82$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("kLPO4", function(module, exports) {

$parcel$export(module.exports, "addTestName", function () { return $6dc7b17aef86877e$export$398b7674cce9803d; });
const $6dc7b17aef86877e$export$398b7674cce9803d = (prefix = "test", element)=>{
    const polishToEnglish = {
        ą: "a",
        ć: "c",
        ę: "e",
        ł: "l",
        ń: "n",
        ó: "o",
        ś: "s",
        ź: "z",
        ż: "z",
        Ą: "A",
        Ć: "C",
        Ę: "E",
        Ł: "L",
        Ń: "N",
        Ó: "O",
        Ś: "S",
        Ź: "Z",
        Ż: "Z"
    };
    const preparedElement = element.replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, (char)=>polishToEnglish[char]).replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map((word)=>word.toLowerCase()).join("_");
    return `${prefix}__${preparedElement}`;
};

});


parcelRequire.register("4oULP", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $334570bf1826d6ec$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $334570bf1826d6ec$var$_hoisted_1 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("span", {
    innerHTML: "Profil",
    "data-test": "profile"
}, null, -1);
const $334570bf1826d6ec$var$_hoisted_2 = [
    "innerHTML"
];
const $334570bf1826d6ec$var$_hoisted_3 = {
    class: "divide-y divide-neutral-100"
};
const $334570bf1826d6ec$var$_hoisted_4 = [
    "onClick",
    "data-test"
];
const $334570bf1826d6ec$var$_hoisted_5 = [
    "innerHTML"
];
const $334570bf1826d6ec$var$_hoisted_6 = {
    key: 0,
    class: "pl-6"
};
const $334570bf1826d6ec$var$_hoisted_7 = [
    "data-test",
    "onClick"
];
const $334570bf1826d6ec$var$_hoisted_8 = [
    "innerHTML"
];
const $334570bf1826d6ec$var$_hoisted_9 = {
    key: 0,
    class: "h-16"
};
function $334570bf1826d6ec$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_BaseAvatar = (0, $cfZzL.resolveComponent)("BaseAvatar");
    const _component_DropdownPanel = (0, $cfZzL.resolveComponent)("DropdownPanel");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_DropdownPanel, {
        ref: "MenuPanel",
        "data-component": "MenuNavbar.vue",
        class: "global-menu",
        Direction: "bottom right"
    }, {
        button: (0, $cfZzL.withCtx)(()=>[
                $props.burger ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                    key: 0,
                    name: "burger",
                    size: "1.5"
                })) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                    key: 1
                }, [
                    (0, $cfZzL.createVNode)(_component_BaseAvatar, {
                        user: $options.userAvatar,
                        size: "sm",
                        class: "mr-3",
                        "data-test": "avatar"
                    }, null, 8, [
                        "user"
                    ]),
                    $334570bf1826d6ec$var$_hoisted_1,
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "chevron-down",
                        size: "0.5",
                        class: "mx-2"
                    })
                ], 64))
            ]),
        default: (0, $cfZzL.withCtx)(()=>[
                (0, $cfZzL.createElementVNode)("div", null, [
                    (0, $cfZzL.createElementVNode)("div", null, [
                        ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($options.menu, (section)=>{
                            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
                                key: section.sectionName
                            }, [
                                (0, $cfZzL.createElementVNode)("div", {
                                    class: "px-4 py-3 text-base font-bold bg-neutral/5",
                                    innerHTML: section.sectionName
                                }, null, 8, $334570bf1826d6ec$var$_hoisted_2),
                                (0, $cfZzL.createElementVNode)("div", $334570bf1826d6ec$var$_hoisted_3, [
                                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(section.items, (item)=>{
                                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                            key: item.name
                                        }, [
                                            (0, $cfZzL.createElementVNode)("div", {
                                                class: (0, $4bH2P.normalizeClass)($data.itemClass),
                                                onClick: ($event)=>$options.itemClick(item),
                                                "data-test": $options.addTestName("global_menu", item.name)
                                            }, [
                                                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                                    name: item.icon,
                                                    set: item.iconSet ? item.iconSet : "menu",
                                                    size: "1.25",
                                                    class: "mr-2 text-info-50"
                                                }, null, 8, [
                                                    "name",
                                                    "set"
                                                ]),
                                                (0, $cfZzL.createElementVNode)("span", {
                                                    innerHTML: item.name
                                                }, null, 8, $334570bf1826d6ec$var$_hoisted_5),
                                                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                                    name: "chevron-right",
                                                    size: "0.75",
                                                    class: (0, $4bH2P.normalizeClass)([
                                                        "ml-auto text-neutral-900",
                                                        {
                                                            "rotate-90": item.items && !item.isExpanded,
                                                            "-rotate-90": item.isExpanded
                                                        }
                                                    ])
                                                }, null, 8, [
                                                    "class"
                                                ])
                                            ], 10, $334570bf1826d6ec$var$_hoisted_4),
                                            item.isExpanded ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $334570bf1826d6ec$var$_hoisted_6, [
                                                ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(item.items, (subItem)=>{
                                                    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                                                        key: subItem.name,
                                                        "data-test": $options.addTestName("global_menu__sub", subItem.name),
                                                        class: (0, $4bH2P.normalizeClass)($data.itemClass),
                                                        onClick: ($event)=>$options.itemClick(subItem)
                                                    }, [
                                                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                                            name: subItem.icon,
                                                            set: item.iconSet ? item.iconSet : "menu",
                                                            size: "1.25",
                                                            class: "mr-2 text-info-50"
                                                        }, null, 8, [
                                                            "name",
                                                            "set"
                                                        ]),
                                                        (0, $cfZzL.createElementVNode)("span", {
                                                            innerHTML: subItem.name
                                                        }, null, 8, $334570bf1826d6ec$var$_hoisted_8),
                                                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                                                            name: "chevron-right",
                                                            size: "0.75",
                                                            class: "ml-auto text-neutral-900"
                                                        })
                                                    ], 10, $334570bf1826d6ec$var$_hoisted_7);
                                                }), 128))
                                            ])) : (0, $cfZzL.createCommentVNode)("", true)
                                        ]);
                                    }), 128))
                                ])
                            ], 64);
                        }), 128))
                    ]),
                    _ctx.ScreenSize < 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $334570bf1826d6ec$var$_hoisted_9)) : (0, $cfZzL.createCommentVNode)("", true)
                ])
            ]),
        _: 1
    }, 512);
}

});

parcelRequire.register("1pyUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $107333e5561c1388$export$2e2bcd8739ae039; });
let $107333e5561c1388$var$NOOP = ()=>{};
var $107333e5561c1388$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("l0uMv", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $f4b17997d1101b47$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $f4b17997d1101b47$var$_hoisted_1 = [
    "href"
];
const $f4b17997d1101b47$var$_hoisted_2 = [
    "innerHTML"
];
const $f4b17997d1101b47$var$_hoisted_3 = {
    key: 4
};
const $f4b17997d1101b47$var$_hoisted_4 = [
    "innerHTML"
];
const $f4b17997d1101b47$var$_hoisted_5 = /*#__PURE__*/ (0, $cfZzL.createElementVNode)("hr", {
    class: "flex-auto"
}, null, -1);
const $f4b17997d1101b47$var$_hoisted_6 = [
    "onClick"
];
function $f4b17997d1101b47$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuNavbar = (0, $cfZzL.resolveComponent)("MenuNavbar");
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    const _component_DropdownSelect = (0, $cfZzL.resolveComponent)("DropdownSelect");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("header", {
        "data-component": "PageHeader.vue",
        class: (0, $4bH2P.normalizeClass)([
            "page-header | shadow-md px-5 sticky top-0 left-0 right-0 z-64",
            {
                "is-static": _ctx.ScreenSize > 1,
                "bg-white": _ctx.ScreenSize < 1 || !$props.HideBg
            }
        ])
    }, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "flex items-center py-5",
                $props.WrapperClasses
            ])
        }, [
            $props.Burger && _ctx.ScreenSize <= 1 ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_MenuNavbar, {
                key: 0,
                class: "mr-2",
                burger: true
            })) : $props.Back && (_ctx.ScreenSize <= 1 || $props.BackOnDesktop) ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                key: 1,
                "data-test": "page_header_arrow_left",
                class: "global-navigation-back",
                onClick: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)((...args)=>$options.GoBack && $options.GoBack(...args), [
                    "prevent"
                ]))
            }, [
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "arrow-left",
                    size: "1.5",
                    class: "mr-2"
                })
            ])) : (0, $cfZzL.createCommentVNode)("", true),
            $props.Logo ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("a", {
                key: 2,
                href: $props.LogoHref,
                class: (0, $4bH2P.normalizeClass)([
                    "svg svg-logotype-oferteo",
                    {
                        "absolute inset-x-0 mx-auto": $props.LogoCenter
                    }
                ])
            }, "Oferteo.pl", 10, $f4b17997d1101b47$var$_hoisted_1)) : $props.Title ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                key: 3,
                class: (0, $4bH2P.normalizeClass)([
                    "ml-1",
                    $props.TitleClasses
                ])
            }, [
                (0, $cfZzL.createElementVNode)("p", {
                    class: (0, $4bH2P.normalizeClass)([
                        "text-xs font-bold",
                        $props.rfpStatus.class
                    ])
                }, (0, $4bH2P.toDisplayString)($props.rfpStatus.label), 3),
                (0, $cfZzL.createElementVNode)("div", {
                    class: "!p-0 text-base font-bold",
                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.TitleClick && $options.TitleClick(...args)),
                    innerHTML: $props.Title
                }, null, 8, $f4b17997d1101b47$var$_hoisted_2)
            ], 2)) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $f4b17997d1101b47$var$_hoisted_3, [
                (0, $cfZzL.renderSlot)(_ctx.$slots, "title")
            ])),
            $props.Subtitle ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                key: 5,
                class: "text-xs ml-2 font-bold mt-1 text-neutral-700",
                innerHTML: $props.Subtitle
            }, null, 8, $f4b17997d1101b47$var$_hoisted_4)) : (0, $cfZzL.createCommentVNode)("", true),
            $f4b17997d1101b47$var$_hoisted_5,
            (0, $cfZzL.renderSlot)(_ctx.$slots, "buttons", {}, ()=>[
                    ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($props.Buttons, (Button)=>{
                        return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, [
                            _ctx.ScreenSize <= 1 || Button.AlwaysVisible ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("button", {
                                key: Button.Action,
                                class: (0, $4bH2P.normalizeClass)([
                                    "text-xs font-bold uppercase",
                                    Button.Class
                                ]),
                                onClick: (0, $brqXq.withModifiers)(($event)=>_ctx.$emit("button-click", Button.Action, $event), [
                                    "prevent"
                                ])
                            }, [
                                Button.Icon ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                                    key: 0,
                                    name: Button.Icon,
                                    size: Button.IconSize || 1,
                                    class: (0, $4bH2P.normalizeClass)(Button.IconClass)
                                }, null, 8, [
                                    "name",
                                    "size",
                                    "class"
                                ])) : (0, $cfZzL.createCommentVNode)("", true),
                                (0, $cfZzL.createTextVNode)(" " + (0, $4bH2P.toDisplayString)(Button.Label), 1)
                            ], 10, $f4b17997d1101b47$var$_hoisted_6)) : (0, $cfZzL.createCommentVNode)("", true)
                        ], 64);
                    }), 256))
                ]),
            $props.Menu.length ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_DropdownSelect, {
                key: 6,
                class: "page-header-dropdown",
                Items: $props.Menu,
                Arrowless: true,
                onChange: $options.OnMenuItem
            }, {
                label: (0, $cfZzL.withCtx)(()=>[
                        (0, $cfZzL.createVNode)(_component_BaseIcon, {
                            name: "more",
                            size: "1.25"
                        })
                    ]),
                _: 1
            }, 8, [
                "Items",
                "onChange"
            ])) : (0, $cfZzL.createCommentVNode)("", true)
        ], 2),
        (0, $cfZzL.renderSlot)(_ctx.$slots, "default")
    ], 2);
}

});

parcelRequire.register("9OM3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $725e0e5bfb69d1ba$export$2e2bcd8739ae039; });
let $725e0e5bfb69d1ba$var$NOOP = ()=>{};
var $725e0e5bfb69d1ba$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("87ifg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5e8d21449a999a38$export$2e2bcd8739ae039; });
let $5e8d21449a999a38$var$script;




let $5e8d21449a999a38$var$initialize = ()=>{
    $5e8d21449a999a38$var$script = (parcelRequire("ci8Zj"));
    if ($5e8d21449a999a38$var$script.__esModule) $5e8d21449a999a38$var$script = $5e8d21449a999a38$var$script.default;
    $5e8d21449a999a38$var$script.render = (parcelRequire("3EzZ3")).render;
    $5e8d21449a999a38$var$script.__cssModules = {};
    (parcelRequire("kH085")).default($5e8d21449a999a38$var$script);
    $5e8d21449a999a38$var$script.__scopeId = "data-v-8fc989";
    $5e8d21449a999a38$var$script.__file = "ProgressBar.vue";
};
$5e8d21449a999a38$var$initialize();
var $5e8d21449a999a38$export$2e2bcd8739ae039 = $5e8d21449a999a38$var$script;

});
parcelRequire.register("ci8Zj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $530b1bfb1fd53120$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za wyświetlenie paska postępu.
// @group Base Components
var $530b1bfb1fd53120$export$2e2bcd8739ae039 = {
    name: "ProgressBar",
    props: {
        Value: {
            type: Number,
            default: 0,
            required: true
        },
        Max: {
            type: Number,
            default: 100,
            required: false
        },
        Color: {
            type: String,
            default: "accent",
            required: false
        }
    }
};

});

parcelRequire.register("3EzZ3", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $2a910522f3ff198e$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $2a910522f3ff198e$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-8fc989"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $2a910522f3ff198e$var$_hoisted_1 = {
    "data-component": "ProgressBar.vue",
    class: "[ progress ] relative rounded-full bg-white"
};
function $2a910522f3ff198e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $2a910522f3ff198e$var$_hoisted_1, [
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "absolute rounded-full",
                "bg-" + $props.Color
            ]),
            style: (0, $4bH2P.normalizeStyle)({
                width: $props.Value / $props.Max * 100 + "%"
            })
        }, null, 6)
    ]);
}

});

parcelRequire.register("kH085", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f107ec80cba2c4a9$export$2e2bcd8739ae039; });
let $f107ec80cba2c4a9$var$NOOP = ()=>{};
var $f107ec80cba2c4a9$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("d54tq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $985f36618318a93d$export$2e2bcd8739ae039; });
let $985f36618318a93d$var$script;




let $985f36618318a93d$var$initialize = ()=>{
    $985f36618318a93d$var$script = (parcelRequire("3LVHi"));
    if ($985f36618318a93d$var$script.__esModule) $985f36618318a93d$var$script = $985f36618318a93d$var$script.default;
    $985f36618318a93d$var$script.render = (parcelRequire("7XfRn")).render;
    $985f36618318a93d$var$script.__cssModules = {};
    (parcelRequire("bhkzF")).default($985f36618318a93d$var$script);
    $985f36618318a93d$var$script.__scopeId = "data-v-6a9f47";
    $985f36618318a93d$var$script.__file = "Rating.vue";
};
$985f36618318a93d$var$initialize();
var $985f36618318a93d$export$2e2bcd8739ae039 = $985f36618318a93d$var$script;

});
parcelRequire.register("3LVHi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4e47bacd2c936ebc$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za wyświetlenie oceny w postaci gwiazdek.
// @group Base Components
var $4e47bacd2c936ebc$export$2e2bcd8739ae039 = {
    name: "Rating",
    props: {
        Size: {
            type: Number,
            default: 1.25
        },
        Value: {
            type: Number,
            default: 5
        },
        Count: {
            type: Number,
            default: 0
        },
        Average: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        DisplayText: {
            type: Boolean,
            default: false
        },
        dataTest: {
            type: String,
            default: undefined
        }
    }
};

});

parcelRequire.register("7XfRn", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $5caa5887f07ae215$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
const $5caa5887f07ae215$var$_withScopeId = (n)=>((0, $cfZzL.pushScopeId)("data-v-6a9f47"), n = n(), (0, $cfZzL.popScopeId)(), n);
const $5caa5887f07ae215$var$_hoisted_1 = {
    "data-component": "Rating.vue",
    class: "rating | flex flex-grow-0 items-center"
};
const $5caa5887f07ae215$var$_hoisted_2 = [
    "innerHTML"
];
const $5caa5887f07ae215$var$_hoisted_3 = [
    "data-test",
    "innerHTML"
];
function $5caa5887f07ae215$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $5caa5887f07ae215$var$_hoisted_1, [
        $props.DisplayText && $props.Count ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 0,
            class: "text-accent text-base font-extrabold mr-2",
            innerHTML: $props.Average
        }, null, 8, $5caa5887f07ae215$var$_hoisted_2)) : (0, $cfZzL.createCommentVNode)("", true),
        Math.ceil($props.Value / 2) ? ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
            key: 1
        }, (0, $cfZzL.renderList)(Math.ceil($props.Value / 2), (i)=>{
            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                key: i,
                class: "text-accent mr-1",
                name: "star-on",
                size: $props.Size,
                "data-test": $props.dataTest ? `${$props.dataTest}__star` : undefined
            }, null, 8, [
                "size",
                "data-test"
            ]);
        }), 128)) : (0, $cfZzL.createCommentVNode)("", true),
        5 - Math.ceil($props.Value / 2) ? ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), {
            key: 2
        }, (0, $cfZzL.renderList)(5 - Math.ceil($props.Value / 2), (i)=>{
            return (0, $cfZzL.openBlock)(), (0, $cfZzL.createBlock)(_component_BaseIcon, {
                key: i,
                class: "text-neutral-700 opacity-50 mr-1",
                name: "star-on",
                size: $props.Size,
                "data-test": $props.dataTest ? `${$props.dataTest}__star` : undefined
            }, null, 8, [
                "size",
                "data-test"
            ]);
        }), 128)) : (0, $cfZzL.createCommentVNode)("", true),
        $props.DisplayText ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 3,
            class: "text-neutral-700 mx-2",
            "data-test": $props.dataTest ? `${$props.dataTest}__label` : undefined,
            innerHTML: `(${$props.Count} ${_ctx.Format.PluralForm($props.Count, [
                "opinia",
                "opinie",
                "opinii"
            ])})`
        }, null, 8, $5caa5887f07ae215$var$_hoisted_3)) : (0, $cfZzL.createCommentVNode)("", true)
    ]);
}

});

parcelRequire.register("bhkzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83613de250539f79$export$2e2bcd8739ae039; });
let $83613de250539f79$var$NOOP = ()=>{};
var $83613de250539f79$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("aCaGN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7ba5beaa727de5b2$export$2e2bcd8739ae039; });
let $7ba5beaa727de5b2$var$script;



let $7ba5beaa727de5b2$var$initialize = ()=>{
    $7ba5beaa727de5b2$var$script = (parcelRequire("TdwtI"));
    if ($7ba5beaa727de5b2$var$script.__esModule) $7ba5beaa727de5b2$var$script = $7ba5beaa727de5b2$var$script.default;
    $7ba5beaa727de5b2$var$script.render = (parcelRequire("fwMOs")).render;
    (parcelRequire("8GmEf")).default($7ba5beaa727de5b2$var$script);
    $7ba5beaa727de5b2$var$script.__scopeId = "data-v-38898d";
    $7ba5beaa727de5b2$var$script.__file = "StarRating.vue";
};
$7ba5beaa727de5b2$var$initialize();
var $7ba5beaa727de5b2$export$2e2bcd8739ae039 = $7ba5beaa727de5b2$var$script;

});
parcelRequire.register("TdwtI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0a5fa08603a3bb68$export$2e2bcd8739ae039; });

var $jimV5 = parcelRequire("jimV5");
var $0a5fa08603a3bb68$export$2e2bcd8739ae039 = {
    name: "StarRating",
    components: {
        BaseIcon: $jimV5.default
    },
    props: {
        size: {
            default: 1.25,
            type: [
                String,
                Number
            ]
        },
        count: {
            default: 5,
            type: [
                Number
            ]
        },
        disabled: {
            default: false,
            type: Boolean
        },
        showRatingText: {
            default: false,
            type: Boolean
        },
        displayOnly: {
            default: -1,
            type: Number
        },
        noMargins: {
            default: false,
            type: Boolean
        },
        rateFromChat: {
            default: false,
            type: Boolean
        }
    },
    emits: [
        "rating"
    ],
    data () {
        return {
            rating: 0,
            hoverRating: 0,
            ratingText: `Na skali od 1 do ${this.count} gwiazdek, jak oceniasz współpracę z tym Wykonawcą?`
        };
    },
    computed: {
        style () {
            return {
                flex: ` 0 0 ${this.size}rem`,
                width: `${this.size}rem`,
                height: `${this.size}rem`
            };
        }
    },
    methods: {
        rate (star) {
            this.rating = star;
            this.changeRatingText(0);
            this.$emit("rating", star);
        },
        hover (star) {
            this.hoverRating = star;
            this.changeRatingText(0);
        },
        unhover () {
            this.hoverRating = this.rating;
            this.changeRatingText(0);
        },
        changeRatingText (star) {
            switch(star){
                case -1:
                    this.ratingText = "Tylko klienci Oferteo mogą wystawić neutralną lub negatywną opinię. Przejdź do swoich zleceń i wybierz Wykonawcę, kt\xf3remu chcesz wystawić 1-3 gwiazdki.";
                    break;
                case 0:
                    this.ratingText = `Na skali od 1 do ${this.count} gwiazdek, jak oceniasz współpracę z tym Wykonawcą?`;
                    break;
                case 1:
                    this.ratingText = "Fatalna";
                    break;
                case 2:
                    this.ratingText = "Niezadowalająca";
                    break;
                case 3:
                    this.ratingText = "Przeciętna";
                    break;
                case 4:
                    this.ratingText = "Dobra";
                    break;
                default:
                    this.ratingText = "Doskonała";
                    break;
            }
        }
    }
};

});

parcelRequire.register("fwMOs", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b4dfb562e61d35bb$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
const $b4dfb562e61d35bb$var$_hoisted_1 = [
    "onClick",
    "onMouseover"
];
const $b4dfb562e61d35bb$var$_hoisted_2 = {
    key: 0,
    class: "text-xs md:text-sm"
};
function $b4dfb562e61d35bb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        class: (0, $4bH2P.normalizeClass)([
            "inline-flex flex-col",
            {
                "opacity-50 pointer-events-none": $props.disabled,
                "pointer-events-none": $props.displayOnly >= 0
            }
        ])
    }, [
        (0, $cfZzL.renderSlot)(_ctx.$slots, "title"),
        (0, $cfZzL.createElementVNode)("div", {
            class: (0, $4bH2P.normalizeClass)([
                "flex",
                {
                    "mt-4 mb-3": !$props.noMargins
                }
            ])
        }, [
            ((0, $cfZzL.openBlock)(true), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)($props.count, (n)=>{
                return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
                    key: n,
                    class: "flex justify-center items-center px-0.5 first:pl-0",
                    style: (0, $4bH2P.normalizeStyle)($options.style),
                    onClick: ($event)=>$options.rate(n),
                    onMouseover: ($event)=>$options.hover(n),
                    onMouseout: _cache[0] || (_cache[0] = (...args)=>$options.unhover && $options.unhover(...args))
                }, [
                    (0, $cfZzL.createVNode)(_component_BaseIcon, {
                        name: "star-on",
                        class: (0, $4bH2P.normalizeClass)([
                            "cursor-pointer",
                            n <= ($props.displayOnly >= 0 ? $props.displayOnly : $data.hoverRating) ? "text-accent" : "text-neutral-design-200"
                        ]),
                        size: $props.size
                    }, null, 8, [
                        "size",
                        "class"
                    ])
                ], 44, $b4dfb562e61d35bb$var$_hoisted_1);
            }), 128))
        ], 2),
        $props.showRatingText ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("span", $b4dfb562e61d35bb$var$_hoisted_2, (0, $4bH2P.toDisplayString)($data.ratingText), 1)) : (0, $cfZzL.createCommentVNode)("", true)
    ], 2);
}

});

parcelRequire.register("8GmEf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6523d06fb05f7811$export$2e2bcd8739ae039; });
let $6523d06fb05f7811$var$NOOP = ()=>{};
var $6523d06fb05f7811$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("92YrP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $696330aa0170d90d$export$2e2bcd8739ae039; });
let $696330aa0170d90d$var$script;




let $696330aa0170d90d$var$initialize = ()=>{
    $696330aa0170d90d$var$script = (parcelRequire("5trhb"));
    if ($696330aa0170d90d$var$script.__esModule) $696330aa0170d90d$var$script = $696330aa0170d90d$var$script.default;
    $696330aa0170d90d$var$script.render = (parcelRequire("dufOM")).render;
    $696330aa0170d90d$var$script.__cssModules = {};
    (parcelRequire("cQDmP")).default($696330aa0170d90d$var$script);
    $696330aa0170d90d$var$script.__scopeId = "data-v-65a87e";
    $696330aa0170d90d$var$script.__file = "TimePicker.vue";
};
$696330aa0170d90d$var$initialize();
var $696330aa0170d90d$export$2e2bcd8739ae039 = $696330aa0170d90d$var$script;

});
parcelRequire.register("5trhb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $687162b866276c9c$export$2e2bcd8739ae039; });
// @vuese
// Komponent odpowiedzialny za kontrolkę wyboru czasu.
// TODO: Obsługa klawiatury
// @group Base Components | Forms
var $687162b866276c9c$export$2e2bcd8739ae039 = {
    name: "TimePicker",
    props: {
        modelValue: {},
        Standalone: {
            default: false
        },
        Disabled: {
            type: Boolean,
            default: false
        },
        Fluid: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "update:modelValue"
    ],
    data () {
        return {
            DisplayPicker: false,
            Time: [
                0,
                0
            ],
            Quarter: true
        };
    },
    computed: {
        Label () {
            return this.modelValue;
        }
    },
    watch: {
        modelValue (n) {
            const t = n.split(":");
            this.Time = [
                Number(t[0]),
                Number(t[1])
            ];
        },
        DisplayPicker () {
            window.setTimeout(()=>{
                if (this.$refs.PickerPopup) this.$refs.PickerPopup.querySelectorAll(".is-selected").forEach((el)=>el.scrollIntoView({
                        block: "center"
                    }));
            }, 25);
        }
    },
    created () {
        if (this.modelValue) {
            const t = this.modelValue.split(":");
            this.Time = [
                Number(t[0]),
                Number(t[1])
            ];
        }
        if (!this.modelValue) this.$emit("update:modelValue", "12:00");
    },
    methods: {
        SelectTime (h, m) {
            if (h !== null) this.Time[0] = h;
            if (m !== null) this.Time[1] = m;
            const Pad = (n)=>n > 9 ? n : `0${n}`;
            this.$emit("update:modelValue", `${Pad(this.Time[0])}:${Pad(this.Time[1])}`);
            window.setTimeout(()=>{
                this.DisplayPicker = false;
            }, 50);
        },
        TogglePicker () {
            if (!this.Disabled) this.DisplayPicker = !this.DisplayPicker;
        }
    }
};

});

parcelRequire.register("dufOM", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9d1a58d76ce2c36d$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
var $brqXq = parcelRequire("brqXq");
const $9d1a58d76ce2c36d$var$_hoisted_1 = {
    key: 0,
    class: "relative"
};
const $9d1a58d76ce2c36d$var$_hoisted_2 = [
    "value"
];
const $9d1a58d76ce2c36d$var$_hoisted_3 = {
    class: "calendarSvg-container"
};
const $9d1a58d76ce2c36d$var$_hoisted_4 = {
    class: "flex text-base w-full"
};
const $9d1a58d76ce2c36d$var$_hoisted_5 = {
    class: "col-half overflow-auto"
};
const $9d1a58d76ce2c36d$var$_hoisted_6 = [
    "onClick",
    "innerHTML"
];
const $9d1a58d76ce2c36d$var$_hoisted_7 = {
    key: 0,
    class: "col-half overflow-auto"
};
const $9d1a58d76ce2c36d$var$_hoisted_8 = [
    "onClick",
    "innerHTML"
];
const $9d1a58d76ce2c36d$var$_hoisted_9 = {
    key: 1,
    class: "col-half overflow-auto py-2"
};
const $9d1a58d76ce2c36d$var$_hoisted_10 = [
    "onClick",
    "innerHTML"
];
function $9d1a58d76ce2c36d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseIcon = (0, $cfZzL.resolveComponent)("BaseIcon");
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        ref: "el",
        "data-component": "TimePicker.vue",
        class: (0, $4bH2P.normalizeClass)([
            "timepicker",
            {
                "is-active": $data.DisplayPicker,
                "is-standalone": $props.Standalone,
                "is-fixed": !$props.Standalone,
                "is-disabled": $props.Disabled,
                "is-fluid": $props.Fluid
            }
        ]),
        tabindex: "0",
        onClick: _cache[1] || (_cache[1] = (...args)=>$options.TogglePicker && $options.TogglePicker(...args))
    }, [
        !$props.Standalone ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $9d1a58d76ce2c36d$var$_hoisted_1, [
            (0, $cfZzL.createElementVNode)("input", {
                value: $options.Label,
                readonly: ""
            }, null, 8, $9d1a58d76ce2c36d$var$_hoisted_2),
            (0, $cfZzL.createElementVNode)("div", $9d1a58d76ce2c36d$var$_hoisted_3, [
                (0, $cfZzL.createVNode)(_component_BaseIcon, {
                    name: "clock",
                    size: "1",
                    class: "text-neutral-700"
                })
            ])
        ])) : (0, $cfZzL.createCommentVNode)("", true),
        $data.DisplayPicker || $props.Standalone ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
            key: 1,
            ref: "PickerPopup",
            class: "timepicker-popup",
            onClick: _cache[0] || (_cache[0] = (0, $brqXq.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            (0, $cfZzL.createElementVNode)("div", $9d1a58d76ce2c36d$var$_hoisted_4, [
                (0, $cfZzL.createElementVNode)("div", $9d1a58d76ce2c36d$var$_hoisted_5, [
                    ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(24, (i)=>{
                        return (0, $cfZzL.createElementVNode)("div", {
                            key: i,
                            class: (0, $4bH2P.normalizeClass)([
                                "p-1",
                                {
                                    "is-selected": $data.Time[0] === i - 1
                                }
                            ]),
                            onClick: ($event)=>$options.SelectTime(i - 1, null),
                            innerHTML: (i <= 10 ? "0" : "") + (i - 1)
                        }, null, 10, $9d1a58d76ce2c36d$var$_hoisted_6);
                    }), 64))
                ]),
                !$data.Quarter ? ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $9d1a58d76ce2c36d$var$_hoisted_7, [
                    ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(60, (i)=>{
                        return (0, $cfZzL.createElementVNode)("div", {
                            key: i,
                            class: (0, $4bH2P.normalizeClass)([
                                "p-1",
                                {
                                    "is-selected": $data.Time[1] === i - 1
                                }
                            ]),
                            onClick: ($event)=>$options.SelectTime(null, i - 1),
                            innerHTML: (i <= 10 ? "0" : "") + (i - 1)
                        }, null, 10, $9d1a58d76ce2c36d$var$_hoisted_8);
                    }), 64))
                ])) : ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", $9d1a58d76ce2c36d$var$_hoisted_9, [
                    ((0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)((0, $cfZzL.Fragment), null, (0, $cfZzL.renderList)(4, (i)=>{
                        return (0, $cfZzL.createElementVNode)("div", {
                            key: i,
                            class: (0, $4bH2P.normalizeClass)([
                                "px-1 py-4",
                                {
                                    "is-selected": $data.Time[1] === (i - 1) * 15
                                }
                            ]),
                            onClick: ($event)=>$options.SelectTime(null, (i - 1) * 15),
                            innerHTML: (i * 15 <= 10 ? "0" : "") + (i - 1) * 15
                        }, null, 10, $9d1a58d76ce2c36d$var$_hoisted_10);
                    }), 64))
                ]))
            ])
        ], 512)) : (0, $cfZzL.createCommentVNode)("", true)
    ], 2);
}

});

parcelRequire.register("cQDmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95a8e0e306e4fe48$export$2e2bcd8739ae039; });
let $95a8e0e306e4fe48$var$NOOP = ()=>{};
var $95a8e0e306e4fe48$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("8PRDu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66ecb122db15012e$export$2e2bcd8739ae039; });
let $66ecb122db15012e$var$script;




let $66ecb122db15012e$var$initialize = ()=>{
    $66ecb122db15012e$var$script = (parcelRequire("8FJSh"));
    if ($66ecb122db15012e$var$script.__esModule) $66ecb122db15012e$var$script = $66ecb122db15012e$var$script.default;
    $66ecb122db15012e$var$script.render = (parcelRequire("cRMOt")).render;
    $66ecb122db15012e$var$script.__cssModules = {};
    (parcelRequire("h7kiX")).default($66ecb122db15012e$var$script);
    $66ecb122db15012e$var$script.__scopeId = "data-v-edc7f2";
    $66ecb122db15012e$var$script.__file = "ToasterElement.vue";
};
$66ecb122db15012e$var$initialize();
var $66ecb122db15012e$export$2e2bcd8739ae039 = $66ecb122db15012e$var$script;

});
parcelRequire.register("8FJSh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3f93ff8d9c3f3531$export$2e2bcd8739ae039; });
var /**
 * Komponent odpowiedzialny za wyświetlenie powiadomienia w rogu ekranu.
 */ $3f93ff8d9c3f3531$export$2e2bcd8739ae039 = {
    name: "ToasterElement",
    data () {
        return {
            CustomPositionOnDesktop: "",
            CustomPositionOnMobile: "",
            IsSnackbar: false
        };
    },
    methods: {
        /**
		 * Wyświetla powiadomienie w rogu ekranu. Może przyjąć łańcuch znaków lub obiekt z polami:
		 * * `Message` - treść wiadomości
		 * * `Cancellable` - funkcja wywoływana po kliknięciu przycisku *Cofnij*
		 * * `Style` - zmień typ powiadomienia. Możliwe wartości to: `ok` - domyślna wartość, `fail` - operacja nie powiodła się
		 */ Show (message) {
            var _$n_querySelector;
            // Przygotuj kontener i wiadomość
            const msg = typeof message === "string" ? {
                Message: message
            } : message;
            const $container = this.$refs.ToastContainer;
            this.CustomPositionOnDesktop = msg.CustomPositionOnDesktop || "";
            this.CustomPositionOnMobile = msg.CustomPositionOnMobile || "";
            this.IsSnackbar = msg.IsSnackbar || false;
            // Wyczyść istniejące powiadomienia
            $container.innerHTML = "";
            // Możliwe style powiadomienia
            const styles = {
                info: {
                    color: "info",
                    icon: '<path d="M9.16667 12.9167H11.0917M10.1325 12.9167V9.375H9.17417M10.0002 6.66796C9.97272 6.66796 9.94639 6.67886 9.92697 6.69828C9.90756 6.71769 9.89665 6.74401 9.89665 6.77147V6.77277C9.89703 6.79331 9.90348 6.81328 9.91518 6.83017C9.92688 6.84706 9.94332 6.86011 9.96242 6.86767C9.98152 6.87524 10.0024 6.87699 10.0225 6.87271C10.0426 6.86842 10.061 6.85829 10.0754 6.84358C10.0897 6.82887 10.0994 6.81025 10.1032 6.79006C10.107 6.76987 10.1047 6.749 10.0967 6.73009C10.0886 6.71118 10.0752 6.69507 10.058 6.68379C10.0408 6.6725 10.0207 6.66655 10.0002 6.66667M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"/>'
                },
                warn: {
                    color: "warn",
                    icon: '<path d="M10 10.4167V6.25M10.0002 13.3346C9.97272 13.3346 9.94639 13.3455 9.92697 13.3649C9.90756 13.3844 9.89665 13.4107 9.89665 13.4381V13.4394C9.89703 13.46 9.90348 13.4799 9.91518 13.4968C9.92688 13.5137 9.94332 13.5268 9.96242 13.5343C9.98152 13.5419 10.0024 13.5437 10.0225 13.5394C10.0426 13.5351 10.061 13.525 10.0754 13.5102C10.0897 13.4955 10.0994 13.4769 10.1032 13.4567C10.107 13.4365 10.1047 13.4157 10.0967 13.3968C10.0886 13.3778 10.0752 13.3617 10.058 13.3505C10.0408 13.3392 10.0207 13.3332 10.0002 13.3333M10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C5.8575 17.5 2.5 14.1425 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5Z"/>'
                },
                fail: {
                    color: "danger",
                    icon: '<path d="M12.3583 7.64167L7.64167 12.3583M12.3583 12.3583L7.64167 7.64167M10 17.5C5.8575 17.5 2.5 14.1425 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5Z"/>'
                },
                ok: {
                    color: "success",
                    icon: '<path d="M16.6666 5.41669L7.49992 14.5834L3.33325 10.4167"/>'
                }
            };
            // Utwórz element powiadomienia i wypełnij go treścią
            const $n = document.createElement("div");
            const style = styles[msg.Style] || styles["ok"];
            const $style = `toast-notification | ${msg.Permanent ? "is-permanent" : "is-not-permanent"} ${msg.Cancellable ? "is-cancellable" : "is-not-cancellable"} | shadow-lg rounded bg-white border-l border-l border-l-4 border-${style.color} text-sm flex items-center gap-4 p-4`;
            const $icon = this.IsSnackbar ? "" : `<svg class="text-${style.color} hidden md:block w-5 h-5 shrink-0" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${style.icon}</svg>`;
            const $cancellable = msg.Cancellable ? `<div class="toast-action-button | font-bold text-${style.color} cursor-pointer px-5">${msg.CancellableLabel || "Cofnij"}</div>` : "";
            const $closeable = msg.Permanent ? `
				<svg class="toast-close-button | w-8 h-8 -my-3 shrink-0 cursor-pointer" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<path d="M10.6667 10.6667L21.3334 21.3334M21.3334 10.6667L10.6667 21.3334"/>
				</svg>
			` : "";
            const $buttonContent = msg.ButtonContent && this.ScreenSize > 1 ? `
				<div class="toast-cta-button cursor-pointer mx-5 font-bold text-${style.color}">${msg.ButtonContent}</div>
			` : "";
            $n.setAttribute("class", `is-entering ${$style}`);
            $n.innerHTML = `
					${$icon}
					<div class="toast-message | grow w-max">${msg.Message}</div>
					${$buttonContent}
					${$cancellable}
					${$closeable}
			`;
            $container.prepend($n);
            // Dodaj możliwe przyciski (akcji, zamknięcia)
            $n.addEventListener("click", (event)=>{
                if (msg.OnClose) msg.OnClose("click");
                const { classList: classList, parentNode: parentNode } = event.target;
                const isCloseButtonClicked = classList.contains("toast-close-button") || (parentNode === null || parentNode === void 0 ? void 0 : parentNode.classList.contains("toast-close-button"));
                const isCTAButtonClicked = classList.contains("toast-cta-button") || (parentNode === null || parentNode === void 0 ? void 0 : parentNode.classList.contains("toast-cta-button"));
                // jeżeli istnieje akcja OnButtonClick i jesteśmy na mobilce to wykonaj tą akcję upewniając się że user nie kliknął w przycisk zamknięcia
                if (this.ScreenSize <= 1 && msg.OnButtonClick && !isCloseButtonClicked) msg.OnButtonClick();
                // Jeżeli użytkownik kliknie w snackbar na desktopie to nie zamykaj go (nie licząc CTA i close buttona)
                if (msg.IsSnackbar && this.ScreenSize > 1 && !isCloseButtonClicked && !isCTAButtonClicked) return;
                $n.remove();
            });
            if (msg.Cancellable || msg.Permanent) {
                var _$n_querySelector1, _$n_querySelector2;
                (_$n_querySelector1 = $n.querySelector(".toast-action-button")) === null || _$n_querySelector1 === void 0 ? void 0 : _$n_querySelector1.addEventListener("click", msg.Cancellable);
                (_$n_querySelector2 = $n.querySelector(".toast-close-button")) === null || _$n_querySelector2 === void 0 ? void 0 : _$n_querySelector2.addEventListener("click", ()=>{
                    if (msg.OnClose) msg.OnClose("button");
                    $n.remove();
                });
            }
            if (this.ScreenSize > 1 && msg.ButtonContent && msg.OnButtonClick) (_$n_querySelector = $n.querySelector(".toast-cta-button")) === null || _$n_querySelector === void 0 ? void 0 : _$n_querySelector.addEventListener("click", msg.OnButtonClick);
        },
        /**
		 * Wymuszenie zamknięcia toasta
		 */ Hide () {
            var _document_querySelector;
            (_document_querySelector = document.querySelector(".toast-container")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.remove();
        },
        /**
		 * Wewnętrzna metoda służąca do zmiany stanu wyświetlania powiadomienia (pokaż -> czekaj -> zniknij).
		 */ onAnimationEnd (e) {
            const $t = e.target;
            switch(e.animationName){
                case "toast-enter":
                    $t.className = $t.className.replace("entering", "staying");
                    break;
                case "toast-stay":
                    $t.className = $t.className.replace("staying", "leaving");
                    break;
                case "toast-leave":
                    $t.remove();
                    break;
                default:
                    break;
            }
        }
    }
};

});

parcelRequire.register("cRMOt", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $95e04c878d1499a3$export$b3890eb0ae9dca99; });
parcelRequire("efXw5");
var $cfZzL = parcelRequire("cfZzL");
var $4bH2P = parcelRequire("4bH2P");
function $95e04c878d1499a3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $cfZzL.openBlock)(), (0, $cfZzL.createElementBlock)("div", {
        ref: "ToastContainer",
        "data-component": "ToasterElement.vue",
        class: (0, $4bH2P.normalizeClass)([
            "toast-container | fixed z-[8192]",
            $data.CustomPositionOnDesktop && _ctx.ScreenSize > 1 ? $data.CustomPositionOnDesktop : $data.CustomPositionOnMobile && _ctx.ScreenSize <= 1 ? $data.CustomPositionOnMobile : "bottom-0 right-0"
        ]),
        onAnimationend: _cache[0] || (_cache[0] = (...args)=>$options.onAnimationEnd && $options.onAnimationEnd(...args))
    }, null, 34);
}

});

parcelRequire.register("h7kiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c762d732124030ac$export$2e2bcd8739ae039; });
let $c762d732124030ac$var$NOOP = ()=>{};
var $c762d732124030ac$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("e1GVK", function(module, exports) {

$parcel$export(module.exports, "useBuyerMessagesStore", function () { return $a75bdb22c50eaef5$export$9fd412d613c28c89; });

var $jgrCW = parcelRequire("jgrCW");

var $goO1A = parcelRequire("goO1A");
const $a75bdb22c50eaef5$export$9fd412d613c28c89 = (0, $jgrCW.defineStore)({
    id: "buyerMessages",
    state: ()=>({
            /**
		 * Lista wiadomości.
		 */ buyerMessagesList: [],
            /**
		 * Liczba nieprzeczytanych wiadomości.
		 */ buyerMessagesCount: 0,
            /**
		 * Czy dzwonek jest aktywny.
		 */ isBellRinging: false
        }),
    actions: {
        /**
		 * Pobiera listę wiadomości z serwera.
		 */ async update () {
            const result = [];
            const messages = (await (0, $goO1A.default)("/buyer/notification/find-all.do", {}, "GET", false, false)).all_notification_json || [];
            let readCount = 0;
            for (const msg of messages || []){
                let msgType;
                switch(msg.id_notif_type){
                    case 1:
                        msgType = "uncoverRfp";
                        break;
                    case 2:
                        msgType = "message";
                        break;
                    default:
                        msgType = "other";
                        break;
                }
                result.push({
                    id: msg.id,
                    type: msgType,
                    title: msg.title,
                    message: msg.description,
                    date: new Date(msg.ts_created),
                    isRead: msg.is_read,
                    action: msg.redirect_url
                });
                if (msg.read) readCount++;
            }
            this.buyerMessagesCount = result.length - readCount;
            this.buyerMessagesList = result;
            this.isBellRinging = false;
        },
        /**
		 * Oznacza wszystkie wiadomości jako przeczytane.
		 */ async readAll () {
            this.buyerMessagesCount = 0;
        },
        /**
		 * Oznacza wiadomość jako przeczytaną.
		 */ async markAsRead (message) {
            const { id: id } = message;
            const foundMessage = this.buyerMessagesList.find((m)=>m.id === id);
            if (foundMessage && !foundMessage.isRead) {
                foundMessage.isRead = true;
                this.buyerMessagesCount--;
                await fetch(`/buyer/notification/set-is-read-true/${id}.do`, {
                    method: "PUT"
                });
            }
        },
        async checkIfBellIsRinging () {
            await fetch("/buyer/notification/is-bell-ringing.do").then((response)=>{
                if (response.ok) response.json().then((data)=>{
                    this.isBellRinging = data;
                });
            });
        },
        async unringTheBell () {
            await fetch("/buyer/notification/set-is-ringing-bell-false.do", {
                method: "PUT"
            }).then(()=>{
                this.isBellRinging = false;
            });
        },
        ringTheBell () {
            this.isBellRinging = true;
        }
    }
});

});

parcelRequire.register("ijHoh", function(module, exports) {

$parcel$export(module.exports, "canShowDownloadAppPrompt", function () { return $be88edd04e20062d$export$890dd0070f856bac; });
$parcel$export(module.exports, "goToStore", function () { return $be88edd04e20062d$export$f4c5f2ac9fe37f36; });
function $be88edd04e20062d$export$890dd0070f856bac() {
    const isApp = window.localStorage.CordovaEnableTracking || window.localStorage["IsApp"] === "yes";
    const isBuyerApp = window.localStorage.getItem("isBuyerApp") === "true";
    const isCordova = typeof getFCMtoken !== "undefined";
    const isPWA = window.matchMedia("(display-mode: standalone)").matches;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    if (isApp || isBuyerApp || isCordova || isPWA || !isMobile) return "";
    return isSafari ? "Safari" : "Android";
}
function $be88edd04e20062d$export$f4c5f2ac9fe37f36() {
    const url = $be88edd04e20062d$export$890dd0070f856bac() === "Safari" ? "https://apps.apple.com/pl/app/oferteo-dla-specjalist%C3%B3w/id1585161508" : "https://play.google.com/store/apps/details?id=pl.oferteo.twa";
    if (url) window.location.href = url;
}

});

parcelRequire.register("jRjHW", function(module, exports) {

$parcel$export(module.exports, "useCustomerOnboardingStore", function () { return $d22ac6b18d4f36a4$export$11e16a2754b8c651; });

var $jgrCW = parcelRequire("jgrCW");
const $d22ac6b18d4f36a4$export$11e16a2754b8c651 = (0, $jgrCW.defineStore)({
    id: "customerOnboarding",
    state: ()=>({
            /**
		 * Poszczególne ekrany onboardingu do wyświetlenia.
		 */ steps: [],
            /**
		 * Ile razy został wyświetlony ekran "Dzień dobry w Oferteo"?
		 */ displayCount: 0,
            /**
		 * Szczegóły profilu użytkownika, które są wykorzystywane do wyświetlania ekranów onboardingowych.
		 * Głównie chodzi o to, czy użytkownik ma zdjęcia, opis, opinie, itp. oraz statystyki pokazywane
		 * na kafelku znajdującym się na powitalnym/końcowym ekranie.
		 */ profileDetails: {
                yearsOnMarket: 0,
                offersCount: 0,
                hasPhotos: false,
                hasDescription: false,
                hasReviews: false
            },
            /**
		 * Czy konto użytkownika wymaga weryfikacji w danej sesji?
		 */ needsVerification: false
        }),
    actions: {
        /**
		 * Uaktualnia dane dotyczące ekranów onboardingowych z początkowej odpowiedzi serwera.
		 */ update (rsvp) {
            if (!rsvp.onboarding || !rsvp.user) return;
            this.steps = rsvp.onboarding.onboardingSteps;
            this.displayCount = rsvp.onboarding.allowDisablingGoodMorning ? 10 : 0;
            this.profileDetails = {
                yearsOnMarket: rsvp.user.yearsOnMarket || 0,
                offersCount: rsvp.user.placedOffersCount || 0,
                hasPhotos: rsvp.user.hasPhotos || false,
                hasDescription: rsvp.user.hasDescription || false,
                hasReviews: rsvp.user.hasMarks || false
            };
            // Wyświetl informację o konieczności weryfikacji Autenti zamiast onboardingu.
            if (rsvp.flags.includes("needsVerification")) this.needsVerification = true;
        },
        /**
		 * Sprawdza, czy na danym URL-u można wyświetlić ekran onboardingowy zamiast zawartości strony.
		 */ canShowOnboarding (href) {
            if (href.includes("/moje-zapytania")) return false;
            if (this.needsVerification && href.includes("/konto") && !href.includes("/zapytanie")) return true;
            if (!this.steps.length) return false;
            return href.includes("/zapytania") || href.includes("/kontakty") || href.endsWith("/konto");
        }
    }
});

});

parcelRequire.register("j9iPU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30ac3d1356f0e95b$export$2e2bcd8739ae039; });

var $goO1A = parcelRequire("goO1A");

var $fpaEe = parcelRequire("fpaEe");

var $2dHT5 = parcelRequire("2dHT5");

var $aCD6p = parcelRequire("aCD6p");

var $3cbAx = parcelRequire("3cbAx");

var $lC19C = parcelRequire("lC19C");

var $jRjHW = parcelRequire("jRjHW");

var $e1GVK = parcelRequire("e1GVK");
class $30ac3d1356f0e95b$export$2e2bcd8739ae039 {
    static GetUser(rsvp, user) {
        if (!user) return {
            UserId: 0,
            CustomerId: 0,
            IsCustomer: false,
            isExpressSpecialist: false,
            Role: "",
            AllRoles: [],
            isAuth: false,
            FirstName: "",
            LastName: "",
            CompanyName: "",
            Phone: "",
            Email: "",
            City: "",
            Avatar: "",
            Nip: {
                country: "PL",
                value: "",
                isIndividual: false
            },
            abTestContinueInMobileApp: false,
            isShowGoogleLogin: rsvp.isShowGoogleLogin,
            isContinueInAppEnabledOnlyForOferteo: rsvp.isBranchIoQrLoginOnlyForOferteoEmail,
            frontEndDebug: rsvp.frontEndDebug
        };
        return {
            UserId: user.idUser,
            CustomerId: user.idCustomer,
            IsCustomer: rsvp.role === "ADMIN" || rsvp.role === "CUSTOMER",
            isExpressSpecialist: rsvp.expressSpecialist,
            Role: rsvp.role,
            AllRoles: rsvp.allRoles,
            isAuth: user.isAuth,
            FirstName: user.firstName,
            LastName: user.lastName,
            CompanyName: user.companyName,
            Phone: user.phone,
            Email: user.email,
            City: user.city || "",
            Avatar: (user.avatar || "").indexOf("images/hero") > -1 ? "" : user.avatar,
            Nip: user.nip || {
                country: "PL",
                value: "",
                isIndividual: false
            },
            LastRfpCity: user.lastRfpCity,
            abTestContinueInMobileApp: user.abTestContinueInMobileApp,
            isShowGoogleLogin: rsvp.isShowGoogleLogin,
            isContinueInAppEnabledOnlyForOferteo: rsvp.isBranchIoQrLoginOnlyForOferteoEmail
        };
    }
    Hello(allowNotCustomers) {
        return new Promise(async (resolve, reject)=>{
            const { pathname: pathname } = document.location;
            const pathSegments = pathname.split("/");
            let query = document.location.search;
            // initchat when request is from email link and user is not logged in
            // link structure from email => "moje-zapytania/rfp/:rfpId/:chatId/czat?obj=xxxxxx..."
            if (query.search("obj=") > -1 && pathname.search("moje-zapytania/rfp") && pathname.search("konto") === -1) await this.Fetch(`/rfp-json/init-chat.ofer?rfpId=${pathSegments[3]}&cid=${pathSegments[4]}&${query.substring(1)}`);
            const { href: href } = window.location;
            if (href.search("zapytania") === -1 && href.search("kontakty") === -1 && !href.endsWith("/konto/") && !href.endsWith("/konto")) {
                query = `?disableOnboarding=true${query}`;
                if (query.search("disableOnboarding=true?") > -1) query = query.replace("disableOnboarding=true?", "disableOnboarding=true&");
            }
            let rsvp = {
                baseUrl: document.location.hostname,
                flags: [],
                error: "NOT_AUTH",
                status: "ERROR",
                sessionId: ""
            };
            if (query.indexOf("asUnlogged=true") === -1) {
                const isBuyerApp = window.localStorage.getItem("isBuyerApp") === "true";
                rsvp = await (0, $goO1A.default)(`/profile/hello.ofer${query}`);
                if (isBuyerApp && rsvp.error === "NOT_AUTH") rsvp = await (0, $goO1A.default)(`/profile/hello.ofer${query}`, {}, "POST");
            }
            if (rsvp.role === "PARTNER") {
                document.location.href = "/myoferteo/program-partnerski/statystyki";
                reject(rsvp);
                return;
            }
            const User = $30ac3d1356f0e95b$export$2e2bcd8739ae039.GetUser(rsvp, rsvp.user);
            const appStore = (0, $lC19C.useAppStore)();
            appStore.sessionId = rsvp.sessionId;
            const userStore = (0, $3cbAx.useUserStore)();
            userStore.update(rsvp);
            if (User.IsCustomer) {
                const promoMessagesStore = (0, $fpaEe.usePromoMessagesStore)();
                await promoMessagesStore.update();
                const importantMessageStore = (0, $2dHT5.useImportantMessageStore)();
                importantMessageStore.update(rsvp);
                const customerRfpListStore = (0, $aCD6p.useCustomerRfpListStore)();
                await customerRfpListStore.updateAdditionalBoxes();
                customerRfpListStore.updateFlags(rsvp.flags);
                const customerOnboardingStore = (0, $jRjHW.useCustomerOnboardingStore)();
                customerOnboardingStore.update(rsvp);
            }
            if (User.Role === "BUYER" && query.indexOf("formularz") === -1) {
                const buyerMessagesStore = (0, $e1GVK.useBuyerMessagesStore)();
                await buyerMessagesStore.update();
                await buyerMessagesStore.checkIfBellIsRinging();
            }
            appStore.update(rsvp);
            resolve({
                User: User,
                needsLogin: !(rsvp.role && rsvp.role !== "BUYER" || allowNotCustomers),
                servicesNotificationMessage: rsvp.apImportantMessage,
                frontEndDebug: rsvp.frontEndDebug
            });
        });
    }
    /**
	 * Pobiera lub wysyła informacje oraz parsuje odpowiedź z JSON-a.
	 * @param url - Adres docelowy
	 * @param obj - Obiekt do przesłania
	 * @param mode - Ustawia metodę w jaki sposób chcemy przesłać informacje
	 */ async Fetch(url, obj = {}, mode = "GET") {
        const fetchResult = await (0, $goO1A.default)(url, obj, mode);
        return fetchResult;
    }
}

});
parcelRequire.register("fpaEe", function(module, exports) {

$parcel$export(module.exports, "usePromoMessagesStore", function () { return $a2338a5c0295b8c4$export$f487932924be323a; });

var $jgrCW = parcelRequire("jgrCW");

var $goO1A = parcelRequire("goO1A");
const $a2338a5c0295b8c4$export$f487932924be323a = (0, $jgrCW.defineStore)({
    id: "promoMessages",
    state: ()=>({
            /**
		 * Lista wiadomości.
		 */ promoMessagesList: [],
            /**
		 * Liczba nieprzeczytanych wiadomości.
		 */ promoMessagesCount: 0
        }),
    actions: {
        /**
		 * Pobiera listę wiadomości z serwera.
		 */ async update () {
            const result = [];
            const messages = (await (0, $goO1A.default)("/profile/messages.ofer")).serviceMessages || [];
            let readCount = 0;
            for (const msg of messages || []){
                if (msg.moreInfoLink === "DisplayAppSurvey") {
                    const isSafari = navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1;
                    const isCordova = window.localStorage["IsApp"];
                    if (navigator.userAgent.indexOf("appstore.oferteo") === -1 && (isSafari || !isCordova)) continue;
                }
                result.unshift({
                    id: msg.id,
                    type: msg.type || "info",
                    title: msg.title,
                    message: msg.message,
                    button: msg.buttonLabel || "Zobacz więcej",
                    dismissButton: msg.dismissButtonLabel || "Przypomnij p\xf3źniej",
                    action: msg.moreInfoLink,
                    date: new Date(msg.tsCreated),
                    isRead: msg.read
                });
                if (msg.read) readCount++;
            }
            this.promoMessagesCount = result.length - readCount;
            this.promoMessagesList = result;
        },
        /**
		 * Oznacza wszystkie wiadomości jako przeczytane.
		 */ async readAll () {
            this.promoMessagesCount = 0;
            await (0, $goO1A.default)("/myoferteo/konto-json/read-all-messages.ofer");
        },
        /**
		 * Oznacza wiadomość jako przeczytaną.
		 */ markAsRead (message) {
            const { id: id } = message;
            const foundMessage = this.promoMessagesList.find((m)=>m.id === id);
            if (foundMessage && !foundMessage.isRead) {
                foundMessage.isRead = true;
                this.promoMessagesCount--;
            }
        }
    }
});

});

parcelRequire.register("2dHT5", function(module, exports) {

$parcel$export(module.exports, "useImportantMessageStore", function () { return $99ae4b7b5ed92f82$export$57d991ba9e40c8a; });

var $jgrCW = parcelRequire("jgrCW");

var $ijHoh = parcelRequire("ijHoh");

var $goO1A = parcelRequire("goO1A");

var $lC19C = parcelRequire("lC19C");
const $99ae4b7b5ed92f82$export$57d991ba9e40c8a = (0, $jgrCW.defineStore)({
    id: "importantMessage",
    state: ()=>({
            /**
		 * Obiekt zawierający ważny komunikat.
		 */ message: undefined
        }),
    actions: {
        /**
		 * Przetwarza ważny komunikat, np. o braku środków na koncie z odpowiedzi na `hello.ofer`.
		 * Jeżeli nie ma żadnych innych, sprawdź czy można wyświetlić komunikat o powiadomieniach Push
		 * @param rsvp Odpowiedź serwera
		 * @returns Obiekt komunikatu
		 */ update (rsvp) {
            var _rsvp_user;
            const skipCheck = false;
            const displayServiceMessages = rsvp.canShowImportantMessage;
            // Nie pokazuj żadnej wiadomości w tej sesji
            if (!displayServiceMessages && !skipCheck) return;
            // W innym przypadku...
            const msg = rsvp.importantMessage;
            if (msg) {
                this.message = {
                    id: msg.id,
                    type: msg.type || "info",
                    title: msg.title,
                    message: msg.message.replace(/<br>/g, "").replace(/<br\/>/g, ""),
                    button: msg.buttonLabel || "Dowiedz się więcej",
                    dismissButton: msg.dismissButtonLabel || "Przypomnij p\xf3źniej",
                    action: msg.moreInfoLink
                };
                return;
            }
            this.message = this.getImportantAppMessage(!((_rsvp_user = rsvp.user) === null || _rsvp_user === void 0 ? void 0 : _rsvp_user.boxes["mobileApp"])) || this.getImportantPushMessage();
        },
        /**
		 * W przypadku, kiedy nie ma żadnych innych komunikatów z serwera,
		 * sprawdza, czy może zwrócić komunikat dotyczący pobrania aplikacji mobilnej.
		 */ getImportantAppMessage (hasApp) {
            const { customerViewAppMessageIgnored: customerViewAppMessageIgnored } = window.localStorage;
            const appType = $ijHoh.canShowDownloadAppPrompt();
            if (customerViewAppMessageIgnored || !appType) return undefined;
            if (hasApp) {
                window.localStorage.customerViewAppMessageIgnored = "";
                return undefined;
            }
            return {
                id: "app",
                type: "info",
                title: "Pobierz darmową aplikację Oferteo!",
                message: "Odbieraj wiadomości od Zlecających w aplikacji",
                button: "Pobierz",
                dismissButton: "Przypomnij p\xf3źniej",
                action: "AppDownload"
            };
        },
        /**
		 * W przypadku, kiedy nie ma żadnych ważniejszych komunikatów,
		 * zwraca informację o możliwości włączenia powiadomień Push,
		 * o ile są spełnione stosowne warunki.
		 */ getImportantPushMessage () {
            try {
                // Warunki do spełnienia:
                // - powiadomienia są obsługiwane przez przeglądarkę
                // - powiadomienia nie są wyłączone lub włączone
                // - komunikat nie został wyłączony więcej niż 3 razy
                // - komunikat nie został wyłączony podczas trwania tej sesji
                const appStore = (0, $lC19C.useAppStore)();
                const isSafari = navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1;
                const pushSupported = typeof Notification === "function" && Notification.permission === "default" && !isSafari;
                const { pushPromptDisabledCount: pushPromptDisabledCount, pushPromptDisabledSessionId: pushPromptDisabledSessionId } = window.localStorage;
                const { sessionId: sessionId } = appStore;
                const pushPromptDisabled = Number(pushPromptDisabledCount || 0) > 3 || pushPromptDisabledSessionId === sessionId;
                if (pushSupported && !pushPromptDisabled) return {
                    id: "push",
                    type: "info",
                    title: "",
                    message: "Włącz powiadomienia push o nowych zapytaniach i nie przegap żadnej okazji na zdobycie Klienta",
                    button: "Włącz",
                    dismissButton: "Przypomnij p\xf3źniej",
                    action: "EnablePushNotifications"
                };
            } catch (err) {
                console.warn("getImportantPushMessage", err);
            }
            return undefined;
        },
        /**
		 * Wyświetla informację analitycznę o zobaczeniu komunikatu.
		 */ messageSeen () {
            if (!this.message) return;
            const { id: id } = this.message;
            const idMsg = Number.isInteger(id) ? id : -1;
            (0, $goO1A.default)(`/profile/important-message-seen.ofer?idMsg=${idMsg}&id=${idMsg}&idTrack=${id}`);
        },
        /**
		 * Ukrywa komunikat i wysyła informacje analityczne do serwera.
		 * @param {*} isSuccess Czy kliknięty został przycisk akcji?
		 */ async hideMessage (isSuccess = true) {
            if (!this.message) return;
            const { id: id } = this.message;
            const idMsg = Number.isInteger(id) ? id : -1;
            this.message = undefined;
            await (0, $goO1A.default)(`/profile/important-message-${isSuccess ? "proceed" : "discard"}.ofer?idMsg=${idMsg}&id=${idMsg}&idTrack=${id}`);
        }
    }
});

});

parcelRequire.register("aCD6p", function(module, exports) {

$parcel$export(module.exports, "useCustomerRfpListStore", function () { return $c10cb9a3680a2536$export$b23989410ac6c3ae; });

var $jgrCW = parcelRequire("jgrCW");

var $ijHoh = parcelRequire("ijHoh");

var $goO1A = parcelRequire("goO1A");

var $5AUEz = parcelRequire("5AUEz");
const $c10cb9a3680a2536$export$b23989410ac6c3ae = (0, $jgrCW.defineStore)({
    id: "customerRfpList",
    state: ()=>({
            rfpsList: new (0, $5AUEz.default)("Rfps"),
            contactsList: new (0, $5AUEz.default)("Contacts"),
            additionalBoxes: {}
        }),
    actions: {
        async updateAdditionalBoxes (rsvp) {
            if (!rsvp) rsvp = await (0, $goO1A.default)("/profile/hello.ofer");
            if (!rsvp.user || !rsvp.user.boxes) return;
            if (!$ijHoh.canShowDownloadAppPrompt()) rsvp.user.boxes["mobileApp"] = false;
            let push = typeof Notification === "function" && Notification.permission === "default";
            if (navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1) push = false;
            const result = {
                notifications: {
                    enabled: push
                }
            };
            Object.keys(rsvp.user.boxes).forEach((value)=>{
                const boxName = value;
                result[boxName] = {
                    enabled: rsvp.user.boxes[boxName]
                };
            });
            this.additionalBoxes = result;
        },
        getList (listType) {
            const listName = listType ? listType.toLowerCase() : "rfps";
            return this[`${listName}List`];
        },
        updateFlags (flags) {
            if (flags && flags.indexOf("show_best_rfps") > -1) this.getList("Rfps").ShowBestRfps = true;
        }
    }
});

});
parcelRequire.register("5AUEz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9c299e7b356be6$export$2e2bcd8739ae039; });

var $jEEFu = parcelRequire("jEEFu");

var $goO1A = parcelRequire("goO1A");
class $bc9c299e7b356be6$export$2e2bcd8739ae039 {
    PrepareFilters(filters = {}, availableFilters) {
        let result = [];
        const category = {
            Name: "idCategories",
            Type: "multi",
            Label: "Kategoria",
            Items: [],
            Value: [],
            Icon: "list-desc",
            IsExpanded: false
        };
        const sort = {
            Name: "sort",
            Type: "select",
            Label: "Sortuj",
            Items: [
                {
                    Value: "SORT_DATE",
                    Label: "Od najnowszych",
                    Icon: "sort"
                },
                {
                    Value: "SORT_DISTANCE",
                    Label: "Od najbliższych",
                    Icon: "sort"
                }
            ],
            Icon: "sort",
            Value: "SORT_DATE",
            Default: "SORT_DATE",
            IsExpanded: false
        };
        if (this.ShowBestRfps) {
            sort.Items.unshift({
                Value: "SORT_BEST",
                Label: "Od najlepszych",
                Icon: "sort"
            });
            sort.Value = "SORT_BEST";
            sort.Default = "SORT_BEST";
        }
        if (this.DefaultSort) {
            sort.Value = this.DefaultSort;
            sort.Default = this.DefaultSort;
        }
        const search = {
            Name: "search",
            Type: "string",
            Label: this.Type !== "Rfps" ? "Szukaj po nazwie zlecenia" : "Szukaj po nazwie kontaktu",
            Hidden: true,
            Value: "",
            DisplayMobileInput: false
        };
        if (this.Type === "Rfps") {
            const distance = {
                Name: "distance",
                Type: "select",
                Label: "Lokalizacja",
                Items: [],
                Value: "",
                IsExpanded: false
            };
            if (availableFilters) {
                distance.Items = [];
                const d = availableFilters.distance;
                if (d > 5) distance.Items.push({
                    Value: 5,
                    Label: "do 5 kilometr\xf3w"
                });
                if (d > 10) distance.Items.push({
                    Value: 10,
                    Label: "do 10 kilometr\xf3w"
                });
                if (d > 30) distance.Items.push({
                    Value: 30,
                    Label: "do 30 kilometr\xf3w"
                });
                if (d > 50) distance.Items.push({
                    Value: 50,
                    Label: "do 50 kilometr\xf3w"
                });
                if (d > 100) distance.Items.push({
                    Value: 100,
                    Label: "do 100 kilometr\xf3w"
                });
                if (d > 250) distance.Items.push({
                    Value: 250,
                    Label: "do 250 kilometr\xf3w"
                });
                distance.Items.push({
                    Value: "",
                    Label: "wszystkie wybrane powiaty"
                });
            }
            const otherFilters = [
                {
                    Name: "withPhone",
                    Type: "bool",
                    Label: "Z numerem potwierdzonym SMS",
                    Value: false
                },
                {
                    Name: "withAttachments",
                    Type: "bool",
                    Label: "Z załącznikami",
                    Value: false
                },
                {
                    Name: "notSeen",
                    Type: "bool",
                    Label: "Nieprzeczytane",
                    Value: false
                },
                {
                    Name: "noOffers",
                    Type: "bool",
                    Label: "Bez ofert",
                    Value: false
                },
                {
                    Name: "onlyDiscounts",
                    Type: "bool",
                    Label: "Przecenione",
                    Value: false
                },
                {
                    Name: "onlyFavourites",
                    Type: "bool",
                    Label: "Obserwowane",
                    Value: false
                }
            ];
            const rfpType = {
                Name: "rfpType",
                Type: "select",
                Label: "Typ podmiotu",
                Items: [
                    {
                        Value: "",
                        Label: "Wszyscy"
                    },
                    {
                        Value: "individual",
                        Label: "Osoby prywatne"
                    },
                    {
                        Value: "company",
                        Label: "Firmy"
                    }
                ],
                Value: "",
                IsExpanded: false
            };
            if (this.ShowBestRfps) otherFilters.push({
                Name: "onlyBest",
                Type: "bool",
                Label: "Tylko najlepsze",
                Value: false
            });
            result = [
                category,
                distance,
                rfpType,
                ...otherFilters,
                sort,
                search
            ]; // , startDate
        }
        if (this.Type !== "Rfps") {
            const folder = {
                Name: "folder",
                Type: "select",
                Label: "Pokaż",
                Items: [
                    {
                        Value: "INCOMING",
                        Label: "Przychodzące",
                        Icon: "chat"
                    },
                    {
                        Value: "FAVOURITE",
                        Label: "Obserwowane",
                        Icon: "star-off"
                    },
                    {
                        Value: "WON",
                        Label: "Potwierdzone",
                        Icon: "handshake"
                    },
                    {
                        Value: "ARCHIVED",
                        Label: "Archiwum",
                        Icon: "archive-small"
                    }
                ],
                Value: "INCOMING",
                Default: "INCOMING"
            };
            const otherFilters = [
                {
                    Name: "onlyIm",
                    Type: "bool",
                    Label: "Polecanie",
                    Icon: "megaphone",
                    Value: false
                },
                {
                    Name: "onlyNew",
                    Type: "bool",
                    Label: "Nowy kontakt",
                    Icon: "dot",
                    Value: false
                },
                {
                    Name: "onlySent",
                    Type: "bool",
                    Label: "Wysłana wiadomość",
                    Icon: "reply",
                    Value: false
                },
                {
                    Name: "onlyUnread",
                    Type: "bool",
                    Label: "Nieprzeczytana wiadomość",
                    Icon: "mail-opened",
                    Value: false
                }
            ];
            result = [
                search,
                folder,
                category,
                ...otherFilters,
                sort
            ];
        }
        return result;
    }
    SetFilterQuery(filterQuery) {
        const filters = this.Filters;
        if (filterQuery) for (const q of filterQuery.split(",")){
            const qq = q.split(":");
            const filter = filters.find((f)=>f.Label.toLowerCase().replace(/ /g, "-") === qq[0]);
            let val;
            if (!filter) continue;
            switch(filter.Type){
                case "bool":
                    filter.Value = true;
                    break;
                case "select":
                    filter.Value = Number(qq[1]) == qq[1] ? Number(qq[1]) : qq[1]; // eslint-disable-line eqeqeq
                    break;
                case "multi":
                    val = [];
                    if (qq[1]) qq[1].split(";").forEach((e)=>{
                        val.push(Number(e) == e ? Number(e) : e); // eslint-disable-line eqeqeq
                    });
                    filter.Value = qq[1] ? qq[1].split(";") : [];
                    break;
                default:
                    break;
            }
        }
    }
    UpdateCategoryFilters(availableFilters) {
        const categoryFilter = this.Filters.find((f)=>f.Name === "idCategories");
        if (!(categoryFilter && availableFilters && availableFilters.categories)) return;
        const originalCategoryFilterValue = categoryFilter.Value;
        categoryFilter.Items = [];
        categoryFilter.Value = [];
        for (const category of availableFilters.categories){
            categoryFilter.Items.push({
                Value: category.id,
                Label: category.name
            });
            if (originalCategoryFilterValue.indexOf(category.id) > -1) categoryFilter.Value.push(category.id);
        }
    }
    FiltersToQuery() {
        const result = [];
        for (const f of this.Filters){
            if (f.Value === "" || Array.isArray(f.Value) && !f.Value.length || f.Value === false || f.IsTagFilter) continue;
            const name = f.Label.replace(/ /g, "-").toLowerCase();
            if (name === "sortuj") continue;
            switch(f.Type){
                case "bool":
                    result.push(name);
                    break;
                case "select":
                    result.push(`${name}:${f.Value}`);
                    break;
                case "multi":
                    result.push(`${name}:${f.Value.join()}`);
                    break;
                default:
                    break;
            }
        }
        return result.join(",");
    }
    TagFilterToggle(tag) {
        const filterIndex = this.FindTagFilterIndex(tag);
        if (filterIndex === -1) // Dodaj filtr z tagiem.
        this.Filters.push({
            Label: tag,
            Name: "tag",
            Type: "bool",
            Value: true,
            IsTagFilter: true
        });
        else // Usuń filtr z tagiem.
        this.Filters.splice(filterIndex, 1);
        this.Get();
    }
    FindTagFilterIndex(tag) {
        const result = this.Filters.findIndex((filter)=>filter.Label === tag);
        return result;
    }
    PrepareFiltersUrl(filters) {
        let result = "";
        const dataObject = {};
        const tags = [];
        filters = filters.filter((f)=>{
            const v = f.Value;
            return (v === true || v.length || typeof v === "number" && String(v).length) && v !== f.Default || f.Name === "sort";
        });
        for (const f of filters){
            if (f.IsTagFilter) {
                tags.push(f.Label);
                continue;
            }
            dataObject[`data.${f.Name}`] = f.Value;
            if (Array.isArray(f.Value)) f.Value.forEach((v)=>{
                result += `&data.${f.Name}=${v}`;
            });
            else result += `&data.${f.Name}=${f.Value}`;
            if (f.Name === "onlyFavourites") {
                dataObject["data.folder"] = "FAVOURITE";
                result += "&data.folder=FAVOURITE";
            }
        }
        dataObject["data.tags"] = tags;
        // Nie liczymy sortowania jako filtr
        let count = filters.length;
        if (dataObject["data.sort"]) count -= 1;
        return {
            Url: result,
            DataObject: dataObject,
            Count: count
        };
    }
    GetListUrl(limit = 25) {
        return `/myoferteo/konto-json/${this.Type === "Rfps" ? "zapytania" : "kontakty"}.ofer?data.limit=${limit}`;
    }
    GetContactPerson(cp, rfp) {
        cp = {
            ShortName: cp.shortName,
            FirstName: cp.firstName,
            LastName: cp.lastName,
            CompanyName: cp.companyName,
            Email: cp.email,
            Phone: cp.phone,
            Sex: cp.sex,
            OnlineStatus: cp.onlineStatus,
            Nip: cp.nip,
            OnlineStatusId: null,
            CustomerId: rfp && rfp.idCustomer ? rfp.idCustomer : 0,
            RfpId: rfp.id
        };
        cp.OnlineStatusId = cp.RfpId;
        return cp;
    }
    ReplaceHTML(input) {
        const tagsToRemove = new Set([
            "a",
            "abbr",
            "address",
            "area",
            "article",
            "aside",
            "audio",
            "b",
            "base",
            "bdi",
            "bdo",
            "blockquote",
            "body",
            "br",
            "button",
            "canvas",
            "caption",
            "cite",
            "code",
            "col",
            "colgroup",
            "data",
            "datalist",
            "dd",
            "del",
            "details",
            "dfn",
            "dialog",
            "div",
            "dl",
            "dt",
            "em",
            "embed",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "head",
            "header",
            "hr",
            "html",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "legend",
            "li",
            "link",
            "main",
            "map",
            "mark",
            "meta",
            "meter",
            "nav",
            "noscript",
            "object",
            "ol",
            "optgroup",
            "option",
            "output",
            "p",
            "param",
            "picture",
            "pre",
            "progress",
            "q",
            "rb",
            "rp",
            "rt",
            "rtc",
            "ruby",
            "s",
            "samp",
            "script",
            "section",
            "select",
            "slot",
            "small",
            "source",
            "span",
            "strong",
            "style",
            "sub",
            "summary",
            "sup",
            "svg",
            "table",
            "tbody",
            "td",
            "template",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "title",
            "tr",
            "track",
            "u",
            "ul",
            "var",
            "video",
            "wbr"
        ]);
        const pattern = new RegExp(`<\\/?(?:${Array.from(tagsToRemove).join("|")})[\\s\\S]*?>`, "gi");
        const output = input.replace(/&lt;/gi, "<").replace(/&gt;/gi, ">");
        const finalOutput = output.replace(pattern, "");
        return finalOutput;
    }
    GetRfpDescription(rfp) {
        const r = [];
        r.push({
            Label: "Kategoria",
            Value: rfp.Category[1],
            HideInPublic: true
        });
        const l = rfp.Location;
        let location = `${l.City[1]}, `;
        location += l.Country[0] === "locationPl" ? `${l.District[1]}, ${l.Region[1]}` : l.Country[1];
        r.push({
            Label: "Miejsce",
            Value: location
        });
        if (rfp.IsUncovered && rfp.ContactPerson.Nip) r.push({
            Label: "NIP",
            Value: rfp.ContactPerson.Nip
        });
        if (rfp.IsUncovered && rfp.ContactPerson.CompanyName) r.push({
            Label: "Nazwa firmy",
            Value: rfp.ContactPerson.CompanyName
        });
        if (rfp.TransportInfo) {
            const transport = (label, v)=>{
                if (!rfp.TransportInfo[v]) return;
                r.push({
                    Label: label,
                    Value: rfp.TransportInfo[v]
                });
            };
            transport("Załadunek", "AddressFrom");
            transport("Rozładunek", "AddressTo");
            transport("Termin załadunku od", "FromDate");
            transport("Termin rozładunku do", "ToDate");
            transport("Nadwozie", "CargoBody");
            transport("Ciężar ładunku", "CargoWeight");
            transport("Rodzaj ładunku", "CargoType");
        }
        let description = this.ReplaceHTML(rfp.Description);
        description = description.split("\n");
        const d = [];
        for (let line of description)try {
            line = line.trim();
            if (!line) continue;
            line = line.split(/(.+:) (.+)/gm);
            if (line.length === 1) {
                line = line[0];
                if (line.endsWith(":")) d.push({
                    Label: line.replace(":", ""),
                    Value: ""
                });
                else {
                    const val = line.startsWith("- ") ? `<div class="description-point">${line.replace("- ", "")}</div>` : `${line}<br>`;
                    d[d.length - 1].Value += val;
                }
            } else d.push({
                Label: line[1],
                Value: line[2]
            });
        } catch (err) {
            DBG("GetRfpDescription", line, err);
        }
        const other = [
            {
                Label: "Forma kontaktu",
                Value: rfp.ContactForms.join(", ").replace("Telefon, Telefon", "Telefon")
            },
            {
                Label: "Identyfikator zapytania",
                Value: rfp.Id
            }
        ];
        if (rfp.DiscountReason) other.push({
            Label: "Pow\xf3d przeceny",
            Value: rfp.DiscountReason
        });
        return [
            ...r,
            ...d,
            ...other
        ];
    }
    async SimulateFilterChange(filter) {
        const filtersCopy = JSON.parse(JSON.stringify(this.Filters));
        if (filter) {
            const replaceIdx = filtersCopy.findIndex((item)=>item.Name === filter.Name);
            if (replaceIdx > -1) filtersCopy[replaceIdx] = filter;
        }
        const url = this.GetListUrl(1) + this.PrepareFiltersUrl(filtersCopy).Url;
        const replacedUrl = url.replace("zapytania.ofer?", "rfps-counts.ofer?searchUncoverData=false&");
        // TODO: Liczba nie uzględnia filtrów tagów.
        return (await (0, $goO1A.default)(replacedUrl)).total;
    }
    ProcessRfp(r) {
        var _r_similarRfps;
        if (!r) r = {};
        let uncoverType = "NONE"; // MANUAL, QC, IM, REFUND
        if (r.uncoverType === "uncCustManual") uncoverType = "MANUAL";
        if (r.uncoverType === "uncCustSK") uncoverType = "QC";
        if (r.uncoverType === "uncBuyerAP") uncoverType = "IM";
        if (r.uncoverType === "uncBuyerPF") uncoverType = "PF";
        if (r.uncoverType === "uncFreeBuyerChoice") uncoverType = "BC";
        const rfp = {
            Id: r.id || 0,
            Title: r.title || " ",
            Url: r.titleForUrl || "0",
            IsUnread: r.unread,
            IsExpired: r.expired || r.disableReason === "INACTIVE_RFP",
            IsSeen: r.isSeen,
            IsFavourite: r.favourite,
            IsUncovered: r.uncovered && !r.refundReason,
            UncoverInProgress: false,
            PriceBelowMinimumVague: r.priceBelowMinimumVague,
            ConfirmedByBuyer: r.confirmedByBuyer,
            BuyerUndecidedNotChecked: r.buyerUndecidedNotChecked,
            BuyerUndecided: r.buyerUndecided,
            BuyerWithSmallBudget: r.buyerWithSmallBudget,
            BuyerWithSmallBudgetAfterCall: r.buyerWithSmallBudgetAfterCall,
            BuyerWithoutPhone: r.buyerWithoutPhone,
            UncoverType: uncoverType,
            DisableReason: r.disableReason === "INACTIVE_RFP" ? "" : r.disableReason,
            RefundReason: r.refundReason,
            ContactPrice: r.contactPrice,
            OriginalContactPrice: r.originalContactPrice,
            IsDiscounted: r.discounted,
            Tags: r.tags || [],
            AdditionalTags: r.additionalTags || [],
            RealizationDate: r.realizationDate,
            Description: r.description,
            // CreationDate: data aktywacja zapytania lub jego utworzenia, jeżeli nie zostało jeszcze zaktywowane
            CreationDate: r.startDate ? this.Format.Date(r.startDate) : this.Format.Date(r.creationDate),
            // StartDate: data aktywacji zapytania
            StartDate: this.Format.Date(r.startDate),
            // UncoverDate: data odkrycia zapytania przez użytkownika
            UncoverDate: this.Format.Date(r.tsUncovered),
            Size: null,
            Category: r.category ? [
                r.category.id,
                r.category.name
            ] : [
                "",
                ""
            ],
            CategoryParent: r.categoryParent ? [
                r.categoryParent.id,
                r.categoryParent.name
            ] : [
                "",
                ""
            ],
            CategoryLevel2: [
                (r.category || {}).idCategoryLevel2 || r.idCategoryLevel2 || "",
                ""
            ],
            CategoryLevel3: r.categoryLevel3 ? [
                r.categoryLevel3.id,
                r.categoryLevel3.name
            ] : [
                "",
                ""
            ],
            FirstUncoverFree: r.category ? r.category.tsFirstUncoverFree > 0 : false,
            HasChat: r.hasChat,
            ChatId: r.idChat,
            ChatUrl: r.chatUrl,
            LastMessage: r.lastMessage ? {
                Message: r.lastMessage.content ? r.lastMessage.content : "",
                IsMine: r.lastMessage.mine,
                IsRead: r.lastMessage.tsRead > 0,
                UnreadMessagesCount: r.unreadMessagesCount || -1,
                LastChatAction: r.tsLastChatAction || 0
            } : {},
            ContactPerson: null,
            Location: null,
            ContactForms: [
                "Email",
                "Czat"
            ],
            Folder: r.idFolder,
            OffersCount: r.offersCount,
            OffersCountForUser: r.offersCountForUser,
            Offers: [],
            ModerationStatus: {},
            HasPhone: r.contactPerson ? (r.contactPerson.phone || "").length > 0 : false,
            PhoneConfirmed: r.tsPhoneConfirmed > 0,
            EmailConfirmed: r.tsEmailConfirmed > 0,
            IsEmailFaulty: r.emailFaulty,
            TransportInfo: null,
            Notes: [],
            Autorefund: false,
            AutorefundRfps: [],
            PhoneConfirmationStatus: "",
            ClientRequestData: r.clientRequestData,
            Tutorials: r.tutorials,
            UncoverLimit: r.uncoversLimit,
            OffersCountLabel: null,
            IsSold: typeof r.isSold !== "undefined" ? r.isSold : r.uncoversCount >= r.uncoversLimit,
            UncoverInactiveReason: r.uncoverInactiveReason || "",
            RegisterUrl: "/rejestracja/wybierz-klientow/",
            LoadFromData: {
                startDateFrom: r.startDate,
                expiredFrom: r.expired,
                chatDateFrom: (r.lastMessage || {}).tsCreated,
                creationDateCustomerRfpFrom: r.creationDateCustomerRfp,
                recommendedDateFrom: r.recommendedDate,
                distanceFrom: r.distanceFromCustomerHead
            },
            NipVerificationStatus: "",
            PdfUrl: r.pdfUrl,
            HalfPriceBadge: r.halfPriceBadge,
            EditRfpLink: r.editRfpUrl,
            CooperationConfirmationStatus: r.cooperationConfirmationStatus || "",
            CooperationStatus: (r.cooperationConfirmationStatus || "").indexOf("confirmedBy") > -1 ? "confirmed" : r.cooperationStatus || "",
            CooperationBadge: r.cooperationBadge || "",
            CooperationStartDate: new Date(r.cooperationConfirmationTsCreated),
            InvalidRedirect: r.invalidRedirect || "",
            DiscountReason: "",
            RedirectToList: false,
            HasAttachments: r.hasAttachments || false,
            Attachments: r.attachments || [],
            InactiveReason: "",
            BlockedUncoverLimit: r.blockedUncoverLimit || 0,
            SimilarRfps: ((_r_similarRfps = r.similarRfps) === null || _r_similarRfps === void 0 ? void 0 : _r_similarRfps.map((similarRfp)=>this.ProcessRfp(similarRfp))) || [],
            isHideBuyerMail: r.hideBuyerMail,
            IsCustomerWaitingForOffers: r.isCustomerWaitingForOffers || false,
            IsLastChance: r.isLastChance || false,
            creationDateLabel: r.creationDateLabel || "",
            timePromoCountdown: r.timePromoCountdown || 0
        };
        rfp.Attachments = rfp.Attachments.map((i)=>({
                Name: i.fileName,
                Thumbnail: i.thumbnail,
                Path: i.path
            }));
        if (rfp.DisableReason === "INACTIVE_POINTS") {
            rfp.UncoverInactiveReason = rfp.DisableReason;
            rfp.DisableReason = "";
        }
        if (rfp.BlockedUncoverLimit) rfp.UncoverInactiveReason = "BLOCKED_POINTS";
        if (r.negotiatedPriceVerificationStatus) {
            let nvs = "";
            if (r.negotiatedPriceVerificationStatus === "notVerified") nvs = "NeedsVerification";
            if (r.negotiatedPriceVerificationStatus === "underVerification") nvs = "VerificationInProgress";
            rfp.NipVerificationStatus = nvs;
        }
        if (r && r.category && r.location) rfp.RegisterUrl += `?cats=${r.category.id}&loc=${r.location.city[1]}&rfpId=${r.id}`;
        if (!r.notes) r.notes = [];
        for (const n of r.notes)rfp.Notes.push({
            Id: n.id,
            Date: new Date(n.tsModified || n.tsCreated),
            Contents: n.note
        });
        if (!rfp.Id || !rfp.Title) rfp.InvalidRedirect = "/zlecenia";
        rfp.Location = r.location ? {
            Country: r.location.country,
            Region: r.location.region,
            District: r.location.district,
            City: r.location.city,
            Coords: r.location.coords
        } : {
            Country: [
                "",
                ""
            ],
            Region: [
                "",
                ""
            ],
            District: [
                "",
                ""
            ],
            City: [
                "",
                ""
            ],
            Coords: [
                "",
                ""
            ]
        };
        rfp.ContactPerson = r.contactPerson ? this.GetContactPerson(r.contactPerson, r) : {};
        if (!rfp.ContactPerson.Phone) {
            rfp.BuyerWithoutPhone = true;
            rfp.PhoneConfirmed = false;
        }
        if (!rfp.BuyerWithoutPhone) rfp.ContactForms.unshift("Telefon");
        if (r.fromAddress && r.toAddress) {
            const address = (v)=>{
                const formatted = v.match(/(.+) (\d.+)/);
                return formatted ? `${formatted[2]}, ${formatted[1]}` : v;
            };
            rfp.TransportInfo = {
                AddressFrom: address(r.fromAddress),
                AddressTo: address(r.toAddress),
                FromDate: r.fromDate,
                ToDate: r.toDate,
                CargoBody: r.body,
                CargoWeight: r.weight,
                CargoType: r.cargoType
            };
        }
        let discountReason = "";
        if (rfp.IsDiscounted) discountReason = "Inny pow\xf3d przeceny";
        if (rfp.BuyerWithoutPhone && !rfp.PriceBelowMinimumVague) discountReason = "Zleceniodawca nie podał numeru telefonu";
        if (rfp.BuyerWithSmallBudgetAfterCall) discountReason = "Budżet niższy niż zwykle";
        if (rfp.BuyerWithSmallBudget || !rfp.PriceBelowMinimumVague && (rfp.BuyerUndecided || rfp.BuyerUndecidedNotChecked)) discountReason = "Termin zlecenia jest odległy";
        if (rfp.HalfPriceBadge && !rfp.PriceBelowMinimumVague || rfp.IsDiscounted) discountReason = "Inny pow\xf3d przeceny";
        rfp.DiscountReason = discountReason;
        rfp.Description = r.description ? this.GetRfpDescription(rfp) : [];
        rfp.Offers = [];
        if (r.offers) for (const o of r.offers)rfp.Offers.push({
            Name: o.name,
            Date: this.Format.Date(o.date),
            ReviewsCount: o.reviewsCount,
            RatingAverage: o.rating.toFixed(1),
            RatingStars: Number(o.rating * 2).toFixed(0),
            CustomerId: o.idCustomer
        });
        rfp.OffersCount = rfp.Offers.length || rfp.OffersCount;
        if (rfp.OffersCount) rfp.FirstUncoverFree = false;
        if (rfp.OffersCount >= rfp.UncoverLimit) rfp.IsSold = true;
        if (rfp.UncoverLimit < 99) {
            rfp.OffersCountLabel = {
                Class: "border border-solid border-warn text-warn rounded-full px-2",
                Label: "Zapytanie z limitem odkryć"
            };
            if (rfp.OffersCount === 0) rfp.OffersCountLabel = {
                Class: "border border-solid border-warn text-warn rounded-full px-2",
                Label: "Bądź pierwszy!"
            };
            if (rfp.OffersCount === rfp.UncoverLimit - 1) rfp.OffersCountLabel = {
                Class: "border border-solid border-warn text-warn rounded-full px-2",
                Label: "Ostatnia szansa"
            };
            if (rfp.OffersCount >= rfp.UncoverLimit || rfp.IsUncovered) rfp.OffersCountLabel = {};
        }
        rfp.ModerationStatus = {
            ModeratorName: r.confirmationOperatorFirstName,
            ModeratorAvatar: r.confirmationOperatorProfileImagePath,
            IsDiscounted: r.priceBelowMinimumVague
        };
        // Automatyczny zwrot punktów.
        if (Array.isArray(r.uncoveredDuplicate) && r.uncoveredDuplicate.length) {
            rfp.Autorefund = true;
            for (const d of r.uncoveredDuplicate)rfp.AutorefundRfps.push({
                id: d.id,
                title: d.title
            });
        }
        if (r.refundReason === "Automatyczny zwrot punkt\xf3w za ponowne odkrycie danych kontaktowych") rfp.Autorefund = true;
        // Status potwierdzenia RFP
        rfp.PhoneConfirmationStatus = "Empty";
        if (rfp.HasPhone) rfp.PhoneConfirmationStatus = rfp.PhoneConfirmed ? "Confirmed" : "NotConfirmed";
        rfp.PhoneConfirmationStatus = `RfpViewNewAppPhone${rfp.PhoneConfirmationStatus}`;
        if (rfp.IsUncovered) {
            // Odkryte zapytania nie powinny mieć informacji o tym, czy wygasło lub jest sprzedane.
            rfp.IsExpired = false;
            rfp.IsSold = false;
            rfp.InvalidRedirect = "";
        } else // TODO: Wypisz tutaj wartość tekstową.
        rfp.InactiveReason = rfp.IsSold || rfp.IsExpired || rfp.InvalidRedirect || rfp.RefundReason || rfp.Autorefund || rfp.DisableReason;
        return rfp;
    }
    RefreshCurrent() {
        this.Get({
            RefreshCurrent: true
        });
    }
    async Get(options = {
        RefreshCurrent: false,
        LoadFrom: undefined,
        Filters: undefined,
        Query: undefined
    }) {
        const result = {
            Rfps: []
        };
        if (!options.LoadFrom) this.ExpiredItemsCount = 0;
        this.LoadingMore = true;
        let limit = 25;
        if (options.RefreshCurrent && this.Rfps.length) limit = this.Rfps.length;
        let url = this.GetListUrl(limit);
        if (options.LoadFrom) {
            url += `&data.idRfpFrom=${options.LoadFrom.Id}`;
            for(const param in options.LoadFrom.LoadFromData)url += `&data.${param}=${options.LoadFrom.LoadFromData[param] || ""}`;
        }
        let l;
        this.IsLoading = true;
        if (this.Filters.length) {
            const pfu = this.PrepareFiltersUrl(this.Filters);
            this.FiltersCount = pfu.Count;
            l = await (0, $goO1A.default)(url, pfu.DataObject, "POST");
            this.DefaultSort = l.defaultSort;
        } else {
            l = await (0, $goO1A.default)(url);
            this.DefaultSort = l.defaultSort;
            this.Filters = this.PrepareFilters(options.Filters, l.filter);
            if (options.Query) {
                this.SetFilterQuery(options.Query);
                const get = await this.Get(options);
                return get;
            }
        }
        this.UpdateCategoryFilters(l.filter);
        this.SetFilterQuery(options.Query);
        this.IsLoading = false;
        this.LoadingMore = false;
        if (!l) l = {
            rfps: []
        };
        this.DisplayIntroMessage = l.preRegistrationOnly || false;
        this.TotalResults = l.total;
        this.newApCategories = l.newApCategories;
        this.newApCategoriesOB = l.newApCategoriesOB;
        this.ArchivedRfpsCount = l.archivedRfpsCount || 0;
        const osl = {};
        if (!l.rfps) l.rfps = [];
        const { timePromoRfp: timePromoRfp } = l;
        if (timePromoRfp) {
            this.timePromoRfp = this.ProcessRfp(timePromoRfp);
            const cp = this.timePromoRfp.ContactPerson;
            osl[cp.OnlineStatusId] = cp.OnlineStatus;
        }
        l.rfps.forEach((r)=>{
            r = this.ProcessRfp(r);
            const cp = r.ContactPerson;
            osl[cp.OnlineStatusId] = cp.OnlineStatus;
            result.Rfps.push(r);
            if (r.IsExpired) this.ExpiredItemsCount++;
        });
        // jeżeli lista na starcie składa się z samych wygaśniętych, traktuj ją jako pustą.
        if (this.Type === "Rfps" && this.ExpiredItemsCount === result.Rfps.length && !options.LoadFrom) {
            result.Rfps = [];
            this.TotalResults = 0;
            this.ExpiredItemsCount = 0;
        }
        if (l.tutorials) {
            if (l.tutorials.pfInfoModal) this.PfInfoModal = l.tutorials.pfInfoModal;
            if (l.tutorials.pfLabelTutorial) this.PfLabelTutorial = l.tutorials.pfLabelTutorial;
        }
        this.AdditionalRfps = [];
        if (!l.additionalRfps) l.additionalRfps = [];
        l.additionalRfps.forEach((r)=>{
            if (r.IsExpired) return;
            r = this.ProcessRfp(r);
            const cp = r.ContactPerson;
            osl[cp.OnlineStatusId] = cp.OnlineStatus;
            this.AdditionalRfps.push(r);
        });
        this.AdditionalRfpsSectionLabel = l.additionalRfpsSectionLabel || "";
        this.AdditionalRfpsSectionTooltip = l.additionalRfpsSectionTooltip || "";
        this.OnlineStatusList = osl;
        if (options.LoadFrom) this.Rfps = [
            ...this.Rfps,
            ...result.Rfps
        ];
        else this.Rfps = result.Rfps;
        this.Loaded = true;
        return this.Rfps;
    }
    async UpdateOnlineStatus() {
        const b = [];
        const c = [];
        Object.keys(this.OnlineStatusList).forEach((u)=>{
            if (u.startsWith("B")) b.push(u.substr(1));
            if (u.startsWith("C")) c.push(u.substr(1));
        });
        const bl = this.GetOnlineStatusList("buyers", b);
        const cl = this.GetOnlineStatusList("custs", c);
        Promise.all([
            bl,
            cl
        ]).then((r)=>{
            this.OnlineStatusList = {
                ...r[0],
                ...r[1]
            };
        });
    }
    LoadMore() {
        const lastRfp = this.Rfps.length ? this.Rfps[this.Rfps.length - 1] : null;
        return this.Get({
            LoadFrom: lastRfp
        });
    }
    ById(id) {
        return this.Rfps.find((r)=>Number(r.Id) === Number(id));
    }
    ToggleFavourite(rfp) {
        rfp.IsFavourite = !rfp.IsFavourite;
        (0, $goO1A.default)("/myoferteo/konto-json/ulubione-zapytanie.ofer", {
            "data.idRfp": rfp.Id,
            "data.favourite": rfp.IsFavourite
        }, "POST");
    }
    RemoveRfpFromList(rfp, index) {
        const id = rfp.Id;
        if (!index) index = this.Rfps.findIndex((r)=>Number(r.Id) === Number(id));
        this.TotalResults--;
        this.Rfps.splice(index, 1);
    }
    RemoveRfp(rfp, index) {
        this.RemoveRfpFromList(rfp, index);
        (0, $goO1A.default)("/myoferteo/konto-json/usun-zapytanie.ofer", {
            "data.idRfps": rfp.Id
        }, "POST");
    }
    RemoveRfpsById(rfps) {
        const fd = new FormData();
        for (const id of rfps){
            const toRemove = this.Rfps.findIndex((r)=>Number(r.Id) === Number(id));
            if (toRemove < 0) continue;
            fd.append("data.idRfps", id);
            this.TotalResults--;
            this.Rfps.splice(toRemove, 1);
        }
        fetch("/myoferteo/konto-json/usun-zapytanie.ofer", {
            method: "POST",
            mode: "no-cors",
            credentials: "include",
            body: fd
        });
    }
    ChangeFilter(filter, filters) {
        if (!filters) filters = this.Filters;
        const filterToFound = filters.find((f)=>f.Name === filter.Name);
        if (filterToFound) {
            filterToFound.Value = filter.Value;
            this.Get();
        }
    }
    OnSearchFilter() {
        return new Promise((resolve)=>{
            this.SearchModified = true;
            window.clearTimeout(this.SearchTimeout);
            this.SearchLoader = true;
            this.SearchTimeout = window.setTimeout(async ()=>{
                await this.Get();
                this.SearchLoader = false;
                resolve(undefined);
            }, 150);
        });
    }
    UncoverRfp() {
    // Sprawdź czy sukces...
    // Sprawdź zawartość obu list.
    // Jeżeli istnieje na Zapytaniach, usuń.
    // Zaktualizuj listę Kontaktów.
    // Cofnięcie powinno powodować przeniesienie na listę kontaktów. <- da się to załatwić Travelem?
    }
    ProcessPublicInfo(rsvp, rfp, showModal) {
        const result = {
            Meta: {},
            Links: {
                CompanyListBest: null,
                CompanyListLocation: null,
                RfpListLocation: null,
                RfpList: null,
                SeeMoreClients: [],
                SeeAlso: [],
                Breadcrumbs: []
            },
            CategoryFilter: {},
            UncoveredBy: [],
            SeoRfpList: {
                Name: "",
                Items: []
            },
            SeoCompanyList: {
                Name: "",
                Items: []
            },
            SeoOfferList: {
                Name: "",
                Items: []
            },
            ShowApModal: showModal || false
        };
        // Metadane:
        rsvp = rsvp || {};
        rsvp.metaTags = rsvp.metaTags || [];
        for(const k in rsvp.metaTags)result.Meta[k] = rsvp.metaTags;
        // Rozmaite SEO-linki
        if (rsvp.links) {
            result.Links.CompanyListBest = {
                Label: rsvp.links.bestCompaniesListLocation.title,
                Url: rsvp.links.bestCompaniesListLocation.url
            };
            result.Links.CompanyListLocation = {
                Label: rsvp.links.companiesListLocation.title,
                Url: rsvp.links.companiesListLocation.url
            };
            result.Links.RfpListLocation = {
                Label: rsvp.links.rfpListLocation.title,
                Url: rsvp.links.rfpListLocation.url
            };
            result.Links.RfpList = {
                Label: rsvp.links.rfpList.title,
                Url: rsvp.links.rfpList.url
            };
        }
        // Zobacz więcej Klientów
        rsvp.moreClients = rsvp.moreClients || [];
        for (const i of rsvp.moreClients)result.Links.SeeMoreClients.push({
            Label: i.title,
            Url: i.url
        });
        // Podobne tematy
        rsvp.relatedTopics = rsvp.relatedTopics || [];
        for (const subsection of rsvp.relatedTopics){
            const arr = [];
            for (const i of subsection)arr.push({
                Label: i.title,
                Url: i.url
            });
            result.Links.SeeAlso.push(arr);
        }
        // Okruszki
        rsvp.breadCrumbs = rsvp.breadCrumbs || [];
        for (const i of rsvp.breadCrumbs)result.Links.Breadcrumbs.push({
            Label: i.anchor,
            Url: i.url
        });
        result.CategoryFilter = {
            Id: -1,
            Type: "",
            CanBeAutomatic: false
        };
        const filter = rsvp.customerFilter;
        if (filter) {
            let type = filter.idType;
            if (type === "mgFltrTypeNotif") type = "notification";
            if (type === "mgFltrTypeIm") type = "automatic";
            result.CategoryFilter = {
                Id: filter.idFilter,
                Type: type,
                CanBeAutomatic: filter.enabledForIm
            };
        }
        // Lista firm, przez które zostało odkryte zapytanie (może zastąpić istniejącą listę..?)
        rsvp.customersWhoUncovered = rsvp.customersWhoUncovered || [];
        for (const i of rsvp.customersWhoUncovered){
            const gallery = (g)=>{
                const galleryResult = [];
                for (const galleryPhoto of g.fotoList)galleryResult.push({
                    Thumbnail: galleryPhoto.thumbnailUrl,
                    Url: galleryPhoto.origUrl,
                    Description: galleryPhoto.description || galleryPhoto.alt
                });
                return galleryResult;
            };
            const review = (r)=>{
                if (!r) return {};
                const reviewResult = {
                    Author: `${r.firstName} ${r.lastName || ""}`,
                    AuthorAvatar: "#TODO",
                    Rating: this.Format.RatingToNumber(r.idMarkValue),
                    Content: r.description
                };
                return reviewResult;
            };
            result.UncoveredBy.push({
                Id: i.idCustomer,
                Avatar: i.avatarPath,
                Url: i.customerUrl,
                Name: i.companyName,
                UncoveredDate: new Date(i.tsUncovered),
                Rating: Math.round(i.rating) * 2,
                RatingAverage: i.rating,
                ReviewCount: i.reviewsCount,
                Description: i.description,
                YearsOnMarket: i.yearsOnMarket,
                YearsInOferteo: i.yearsInOferteo,
                OffersCount: i.offersCount,
                Gallery: gallery(i.portfolio),
                Review: review(i.mark)
            });
        }
        const categoryName = rfp.Category[1];
        // Listy, które pojawiają się tylko na desktopie
        rsvp.rfpsSeoBookmarks = rsvp.rfpsSeoBookmarks || [];
        for (const i of rsvp.rfpsSeoBookmarks){
            const description = (list)=>{
                // TODO: Zabić Maćka U.
                const descriptionResult = [];
                list.forEach((item)=>{
                    item = Object.entries(item)[0];
                    descriptionResult.push(`${item[0]}: ${item[1]}`);
                });
                return descriptionResult;
            };
            const isHashed = !!i.hrefHashed;
            result.SeoRfpList.Name = `Inne zlecenia z kategorii ${categoryName}`;
            result.SeoRfpList.Items.push({
                Name: i.title,
                Url: isHashed ? "#" : i.rfpUrl,
                Hash: i.hrefHashed,
                Date: new Date(i.tsActivated),
                Description: description(i.descriptionList),
                Location: i.location && i.location.city ? i.location.city[1] : "",
                OfferCount: i.uncoversCount
            });
        }
        rsvp.customersSeoBookmarks = rsvp.customersSeoBookmarks || [];
        for (const i of rsvp.customersSeoBookmarks){
            result.SeoCompanyList.Name = `Firmy z branży ${categoryName}`;
            result.SeoCompanyList.Items.push({
                Name: i.companyName,
                Url: i.url,
                Rating: i.rating,
                Description: i.description
            });
        }
        rsvp.offersSeoBookmarks = rsvp.offersSeoBookmarks || [];
        for (const i of rsvp.offersSeoBookmarks){
            result.SeoOfferList.Name = `Oferty z branży ${categoryName}`;
            result.SeoOfferList.Items.push({
                Name: i.title,
                Url: i.offerUrl,
                Description: i.description
            });
        }
        rfp.PublicInfo = result;
        return rfp;
    }
    async GetRfp(rfpId, isPublic) {
        const url = isPublic ? "/public/json/find-rfp-data.ofer?idRfp=" : "/myoferteo/konto-json/zapytanie.ofer?data.idRfp=";
        const rsvp = await (0, $goO1A.default)(url + rfpId);
        let toProcess = rsvp;
        if (isPublic) toProcess = rsvp.rfpPublicDTO ? rsvp.rfpPublicDTO.rfpData : {};
        let r = this.ProcessRfp(toProcess);
        if (isPublic) r = this.ProcessPublicInfo(rsvp.rfpPublicDTO, r, rsvp.showApModal);
        r.RedirectToList = rsvp.redirectToList;
        return r;
    }
    constructor(t){
        this.TotalResults = -1;
        this.Page = -1;
        this.Filters = [];
        this.FiltersCount = 0;
        this.CurrentFilter = {};
        this.Results = [
            {
                Type: "FILTER_SINGLE",
                Value: "ORDER_DATE",
                Options: [
                    "ORDER_DATE",
                    "ORDER_NEAREST"
                ]
            }
        ];
        this.Type = "";
        this.LastUpdated = -1;
        this.Loaded = false;
        this.LoadingMore = false;
        this.Rfps = [];
        this.AdditionalRfps = [];
        this.AdditionalRfpsSectionLabel = "";
        this.AdditionalRfpsSectionTooltip = "";
        this.Format = new (0, $jEEFu.default)();
        this.SearchModified = false;
        this.OnlineStatusList = {};
        this.DisplayIntroMessage = false;
        this.IsLoading = false;
        this.PfInfoModal = false;
        this.PfLabelTutorial = false;
        this.newApCategories = false;
        this.newApCategoriesOB = false;
        this.AdditionalSections = {};
        this.ExpiredItemsCount = 0;
        this.SearchLoader = false;
        this.ArchivedRfpsCount = 0;
        this.ShowBestRfps = false;
        this.DefaultSort = "";
        this.Type = t;
    }
}

});
parcelRequire.register("jEEFu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96229b2da8aa91ad$export$2e2bcd8739ae039; });
class $96229b2da8aa91ad$export$2e2bcd8739ae039 {
    DayOfWeek(i, short = false) {
        return this[`DayOfWeek${short ? "Short" : "Long"}`][i];
    }
    Fixed(i, digits = 2, separator = ",", noZeroes = false) {
        if (typeof i === "string" && i.indexOf(",") > -1) i = i.replace(",", ".");
        i = Number(i);
        if (!i && i !== 0) return i;
        if (digits < 0) return String(i).replace(".", separator);
        return Number(i).toFixed(digits).replace(".", separator).replace(`${separator}00`, noZeroes ? "" : `${separator}00`);
    }
    NumberToHour(i) {
        i = String(i);
        return i.length === 3 ? `${i.slice(null, 1)}:${i.slice(1)}` : `${i.slice(null, 2)}:${i.slice(2)}`;
    }
    Date(d) {
        if (typeof d === "number") return new Date(d);
        d = String(d);
        if (d.indexOf(".") > -1) d = d.split(".")[0];
        if (d.indexOf("T") === -1) d = d.split(" ").join("T");
        return new Date(d + this.TimezoneString);
    }
    NiceDate(d, month = "short") {
        const o = {
            year: "numeric",
            month: month,
            day: "numeric"
        };
        return d.toLocaleString("pl-PL", o);
    }
    NiceDateTime(d, year) {
        const o = {
            year: year,
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric"
        };
        return d.toLocaleString("pl-PL", o);
    }
    Time(d) {
        const o = {
            hour: "numeric",
            minute: "numeric"
        };
        return d.toLocaleString("pl-PL", o);
    }
    QuadraticEaseOut(currentTime, startValue, changeInValue, duration) {
        const time = currentTime / duration;
        return -changeInValue * time * (time - 2) + startValue;
    }
    constructor(){
        this.DayOfWeekLong = [
            "Poniedziałek",
            "Wtorek",
            "Środa",
            "Czwartek",
            "Piątek",
            "Sobota",
            "Niedziela"
        ];
        this.DayOfWeekShort = [
            "Pn",
            "Wt",
            "Śr",
            "Cz",
            "Pt",
            "So",
            "No"
        ];
        this.TimezoneString = `+0${-(new Date().getTimezoneOffset() / 60)}:00`;
        this.AvatarLetters = function(s) {
            const ss = s.split(" ", 2);
            return (ss[0][0] || "") + (ss[1] ? ss[1][0] || "" : "").replace("undefined", "");
        };
        this.NumberWithSpaces = function(n, nbsp) {
            return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, nbsp ? "&nbsp;" : " ");
        };
        this.PluralForm = function(n, forms, includeNumber = false, nbsp = false) {
            const one = forms[0];
            const few = forms[1];
            const many = forms[2];
            const none = forms[3];
            const fraction = forms[4];
            let suffix = many;
            n = parseInt(n, 10);
            if (n === 0 && includeNumber) return none || `Brak ${suffix}`;
            if (n > 0 && n < 5) suffix = few;
            if (n === 1) suffix = one;
            if (fraction && n > 0 && n < 1) suffix = fraction;
            const string = String(n);
            const lastDigit = Number(string[string.length - 1]);
            if (n > 10 && string.indexOf(".") === -1 && lastDigit > 1 && lastDigit < 5) suffix = few;
            return (includeNumber ? n + (nbsp ? "&nbsp;" : " ") : "") + suffix;
        };
        this.AvatarColor = function(s) {
            let sss = 0;
            for (const ss of s)sss = ss.charCodeAt(0) + ((sss << 5) - sss);
             // eslint-disable-line no-bitwise
            sss = sss % 90 * 4;
            return `hsl(${sss}, 50%, 70%)`;
        };
        this.Distance = (a, b)=>Math.sqrt((a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2);
        this.SubmitConfirm = (s = "")=>{
            if (typeof s !== "string") s = "ok";
            let param = "";
            if (s.indexOf("|") > -1) {
                s = s.split("|");
                param = s[1];
                s = s[0];
            }
            const m = this.SubmitConfirmMessage[s.toLowerCase()] || "";
            return m ? m.replace("%s", param) : this.SubmitConfirmMessage.fail;
        };
        this.RefundReason = (s)=>{
            let result = s;
            switch(s){
                case "NoContact":
                    result = "Brak kontaktu, nie można się skontaktować ze zleceniodawcą";
                    break;
                case "WrongPerson":
                    result = "Niewłaściwa osoba wskazana jako kontaktowa";
                    break;
                case "Outdated":
                    result = "Zapytanie nieaktualne już przy pierwszym kontakcie";
                    break;
                case "Duplicate":
                    result = "Duplikat zapytania, kt\xf3re już wcześniej zostało zakupione w Oferteo";
                    break;
                case "DoNotOffer":
                    result = "Nie oferuje tej usługi/produktu lub w odległej lokalizacji";
                    break;
                case "Violation":
                    result = "Naruszenie regulaminu Oferteo lub niezgodność zapytania z prawem";
                    break;
                default:
                    result = s;
            }
            return result;
        };
        this.CooperationBadge = (s)=>{
            let result = s;
            switch(s.toLowerCase()){
                case "debug":
                    result = "";
                    break;
                case "manual":
                    result = "";
                    break;
                case "qc":
                    result = "Szybki Kontakt";
                    break;
                case "im":
                    result = "Polecanie";
                    break;
                case "bc":
                    result = "Promowanie";
                    break;
                case "confirmed":
                    result = "Potwierdziłeś wsp\xf3łpracę";
                    break;
                case "buyerconfirmed":
                    result = "Klient potwierdził wsp\xf3łpracę";
                    break;
                case "reviewrequest":
                    result = "Oczekujesz na opinię";
                    break;
                case "done":
                    result = "Otrzymałeś opinię";
                    break;
                case "markrequest":
                    result = "Oczekujesz na opinię";
                    break;
                case "markadded":
                    result = "Otrzymałeś opinię";
                    break;
                case "markrequestsent":
                    result = "Wysłałeś prośbę o opinię";
                    break;
                default:
                    result = "";
            }
            return result;
        };
        this.RatingToNumber = (r)=>{
            switch(r){
                case "markValueNegative":
                    return 2;
                case "markValueSecondStar":
                    return 4;
                case "markValueNeutral":
                    return 6;
                case "markValueFourthStar":
                    return 8;
                case "markValuePositive":
                    return 10;
                default:
                    return 0;
            }
        };
        this.SubmitConfirmMessage = {
            ok: "Dane zostały zapisane",
            "ok:reviews:ask": "Wysłano prośbę o&nbsp;opinię",
            "ok:reviews:reply": "Dodano odpowiedź na&nbsp;opinię",
            "ok:reviews:share": "Skopiowano link do schowka",
            "fail:gallery:duplicate": "To zdjęcie zostało już dodane!",
            "fail:reviews:time_limit": "Możesz wysłać ponowną prośbę o&nbsp;opinie za&nbsp;%s",
            "fail:reviews:count_limit": "Wysłałeś już maksymalną liczbę przypomnień na ten adres e-mail",
            fail: "Wpisz poprawne dane i&nbsp;spr\xf3buj jeszcze raz!",
            "fail:uncover:not_enough_points": "Nie posiadasz wystarczających środk\xf3w",
            "fail:uncover:expired_points": "Dostęp do danych kontaktowych Klient\xf3w wymaga aktywnego pakietu punkt\xf3w",
            "fail:uncover:blocked": "Tw\xf3j pakiet punkt\xf3w został zablokowany.",
            "fail:uncover:uncovered": "To zapytanie jest już odkryte",
            "fail:uncover:uncovered_group": "Firma z Twojej Grupy rozpoczęła już proces składania oferty",
            "fail:uncover:uncover_limit": "Limit złożonych ofert został osiągnięty",
            "fail:uncover:rfp_expired": "Termin składania ofert już upłynął",
            "fail:uncover:rfp_sold": "Zapytanie zostało już sprzedane",
            "fail:uncover:unknown": "Wystąpił nieznany błąd",
            "ok:rfp:move:won": "Przeniesiono do wygranych",
            "ok:rfp:move:archived": "Przeniesiono do archiwum",
            "ok:rfp:move:received": "Przeniesiono do przychodzących",
            "ok:partnership_sent": "Wysłano prośbę o przystąpienie do programu partnerskiego"
        };
        this.TimeAgoInSeconds = (d)=>((Number(new Date()) - Number(d)) / 1000).toFixed();
        this.TimeAgo = (s, style = "normal", displayTime = true, useYesterday = false)=>{
            // style = normal | short
            let styleStrings = {
                today: "o ",
                yesterday: `1 dzień temu${displayTime ? " o " : ""}`,
                mins: [
                    "minutę",
                    "minuty",
                    "minut"
                ],
                hrs: [
                    "godzinę",
                    "godziny",
                    "godzin"
                ]
            };
            if (style === "short") styleStrings = {
                today: "",
                yesterday: `1 dzień temu${displayTime ? ", " : ""}`,
                mins: [
                    "min.",
                    "min.",
                    "min."
                ],
                hrs: [
                    "godz.",
                    "godz.",
                    "godz."
                ]
            };
            if (s < 0) return "teraz";
            s = parseInt(s, 10);
            if (s === 0) return "3+ dni temu";
            const now = new Date();
            const past = new Date(Date.now() - s * 1000);
            const dateDiff = now.getDate() === past.getDate() ? 0 : now.getDayOfYear() - past.getDayOfYear();
            function time(d) {
                const h = d.getHours();
                const m = d.getMinutes();
                return `${(h < 10 ? "0" : "") + h}:${m < 10 ? "0" : ""}${m}`;
            }
            const formatDayResult = (s)=>{
                if (!useYesterday) return s;
                if (s.startsWith("1 dzień temu")) return s.replace("1 dzień temu", "wczoraj");
                if (s.startsWith("2 dni temu")) return s.replace("2 dni temu", "przedwczoraj");
                return s;
            };
            if (dateDiff >= 7) return formatDayResult(`${dateDiff} dni temu`);
            if (dateDiff >= 2) return formatDayResult(`${dateDiff} dni temu${displayTime && useYesterday ? `${style === "short" ? "," : " o"} ${time(past)}` : ""}`);
            if (dateDiff === 1) return formatDayResult(styleStrings.yesterday + (displayTime ? time(past) : ""));
            if (s > 43200) return styleStrings.today + (displayTime ? time(past) : "");
            if (s > 3600) {
                const h = Math.floor(s / 3600);
                return `${this.PluralForm(h, styleStrings.hrs, true)} temu`;
            }
            if (s > 0 && s < 60) s = 60;
            if (s >= 60) {
                s = Math.floor(s / 60);
                return `${this.PluralForm(s, styleStrings.mins, true)} temu`;
            }
            return "";
        };
        this.TimeAgoWithFraction = (n, dayLimit)=>{
            let delta = n * 60;
            const d = Math.floor(delta / 86400);
            delta -= d * 86400;
            const h = Math.floor(delta / 3600) % 24;
            delta -= h * 3600;
            const m = Math.floor(delta / 60) % 60;
            delta -= m * 60;
            const result = (d ? d + (d > 1 ? " dni " : " dzień ") : "") + (h ? `${h} godz ` : "") + (m && !d ? `${m} min ` : "");
            return dayLimit && d > dayLimit ? `${dayLimit}+ dni` : result;
        };
        this.formatDate = (date, isISO)=>{
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            return isISO ? `${year}-${month}-${day}` : `${day}.${month}.${year}`;
        };
        this.Measure = [
            {
                Value: "kg",
                Label: "kg"
            },
            {
                Value: "ton",
                Label: "ton"
            },
            {
                Value: "m",
                Label: "m"
            },
            {
                Value: "m\xb2",
                Label: "m\xb2"
            },
            {
                Value: "m\xb3",
                Label: "m\xb3"
            },
            {
                Value: "szt.",
                Label: "szt."
            },
            {
                Value: "litr\xf3w",
                Label: "litr\xf3w"
            },
            {
                Value: "palet",
                Label: "palet"
            }
        ];
    }
}
(()=>{
    $96229b2da8aa91ad$export$2e2bcd8739ae039.PluralForm = function(n, forms, includeNumber = false, nbsp = false) {
        const one = forms[0];
        const few = forms[1];
        const many = forms[2];
        const none = forms[3];
        const fraction = forms[4];
        let suffix = many;
        n = parseInt(n, 10);
        if (n === 0 && includeNumber) return none || `Brak ${suffix}`;
        if (n > 0 && n < 5) suffix = few;
        if (n === 1) suffix = one;
        if (fraction && n > 0 && n < 1) suffix = fraction;
        return (includeNumber ? n + (nbsp ? "&nbsp;" : " ") : "") + suffix;
    };
})();

});




parcelRequire.register("iQIWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $040181eb3e77c99d$export$2e2bcd8739ae039; });

var $jEEFu = parcelRequire("jEEFu");
class $040181eb3e77c99d$export$2e2bcd8739ae039 {
    static Required(i) {
        let result;
        if (Array.isArray(i)) result = i.length > 0;
        else result = i !== null && i !== undefined ? String(i).trim() : "";
        return !result ? "To pole jest wymagane" : "";
    }
    static RequiredNip(i) {
        return this.Required(i.value) ? "Prosimy wpisać poprawny numer NIP" : "";
    }
    static Email(input, options) {
        const ignoreEmpty = options && options.indexOf("IgnoreEmpty") > -1;
        if (input === "" && ignoreEmpty) return "";
        if (input.endsWith("@nop")) return "";
        const filter = /^[\w%\+\-]+(\.[\w%\+\-]+)*@[\w%\+\-]+(\.[\w%\+\-]+)+$/;
        if (!filter.test(input)) return "Prosimy o wpisanie prawidłowego adresu";
        return "";
    }
    static LoginCode(s) {
        if (s.length < 4 || s.length > 4) return "Kod aktywacyjny powinien składać się z 4 cyfr";
        return "";
    }
    static Www(i) {
        if (!i) return "";
        return !i.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm) ? "Prosimy o wpisanie prawidłowego adresu" : "";
    }
    static Phone(i, s) {
        const ignoreEmpty = s && s.indexOf("IgnoreEmpty") > -1;
        const areaCodeRequired = s && s.indexOf("AreaCodeRequired") > -1;
        if (i === "" && ignoreEmpty) return "";
        if (/[a-zA-Z]+/g.test(i)) return "Numer telefonu nie może zawierać liter";
        if (/[^0-9+\- ]/g.test(i) || i.indexOf("+") > 0) return "Numer zawiera niepoprawne znaki";
        i = i.replace(/[^0-9+]/g, "");
        if (areaCodeRequired && !/[+][0-9]{11,12}/g.test(i)) return "Numer musi zawierać kod kraju";
        if (i.length > 15) return "Numer telefonu nie może być dłuższy niż 15 znak\xf3w";
        if (i.length < 9) return "Numer telefonu nie może być kr\xf3tszy niż 9 znak\xf3w";
        return "";
    }
    static IsMobilePhone(i) {
        const mobilePhoneArray = [
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "22",
            "23",
            "24",
            "25",
            "29",
            "32",
            "33",
            "34",
            "41",
            "42",
            "43",
            "44",
            "46",
            "48",
            "52",
            "54",
            "55",
            "56",
            "58",
            "59",
            "61",
            "62",
            "63",
            "65",
            "67",
            "68",
            "71",
            "74",
            "75",
            "76",
            "77",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "89",
            "91",
            "94",
            "95"
        ];
        if (this.Phone(i) === "") {
            let number = i;
            if (number.indexOf("+48") > -1) number = number.replace("+48", "");
            if (number.indexOf("+") > -1) number = number.replace("+", "");
            number = number.split("");
            if (number.length >= 9) return !mobilePhoneArray.some((el)=>number[0] + number[1] === el);
            return false;
        }
        return false;
    }
    static PureNip(i) {
        let nip = String(i);
        nip = nip.replace(/[\ \-]/gi, "");
        if (nip === "0000000000") return "Prosimy wpisać poprawny numer NIP";
        const weight = [
            6,
            5,
            7,
            2,
            3,
            4,
            5,
            6,
            7
        ];
        let sum = 0;
        const controlNumber = parseInt(nip.substring(9, 10), 10);
        for(let n = 0; n < weight.length; n++)sum += parseInt(nip.substring(n, n + 1), 10) * weight[n];
        return sum % 11 === controlNumber ? "" : "Prosimy wpisać poprawny numer NIP";
    }
    static Nip(i) {
        function isValidNip(nip) {
            nip = nip.replace(/[\ \-]/gi, "");
            if (nip === "0000000000") return "Prosimy wpisać poprawny numer NIP";
            const weight = [
                6,
                5,
                7,
                2,
                3,
                4,
                5,
                6,
                7
            ];
            let sum = 0;
            const controlNumber = parseInt(nip.substring(9, 10), 10);
            for(let n = 0; n < weight.length; n++)sum += parseInt(nip.substring(n, n + 1), 10) * weight[n];
            return sum % 11 === controlNumber;
        }
        i.value = String(i.value) || "";
        i.value = i.value.replace(/[\ \-]/gi, "");
        if (!i.value.length || i.country !== "PL") return "";
        return i.value.length !== 10 || !isValidNip(i.value) ? "Prosimy wpisać poprawny numer NIP" : "";
    }
    static Currency() {}
    static Password(i) {
        if (i.length < 8) return "Hasło powinno składać się z przynajmniej 8 znak\xf3w";
        if (i.length > 64) return "Hasło nie może być dłuższe niż 64 znaki";
        return "";
    }
    static NoPhone(s) {
        const toValidate = (s || "").toLowerCase();
        if (/www.|https*:\/\//.test(toValidate)) return "To pole nie może zawierać adresu strony internetowej.";
        if (/\d{3}.{0,3}\d{3}.{0,3}\d{3}/.test(toValidate)) return 'To pole nie może zawierać numeru telefonu. <a class="f-bold" href="/konto/profil/dane-kontaktowe">Wpisz go w Danych kontaktowych.</a>';
        return "";
    }
    static Match(current, compare, form) {
        compare = form.Form.find((f)=>f.Name === compare[0]);
        if (!compare || compare.Value === current) return "";
        return "Powt\xf3rzone hasło r\xf3żni się od wprowadzonego powyżej";
    }
    static Number(i, s) {
        if (s === "float") return !/^[0-9]+([,.][0-9]+)?$/.test(i) ? "Prosimy o wpisanie liczby" : "";
        return !Number.isInteger(Number(i)) ? "Prosimy wpisać liczbę całkowitą" : "";
    }
    static MinMax(i, s) {
        const isModal = s[2] === "modal" ? " #" : "";
        if (i && s) {
            i = Number(i);
            s[0] = Number(s[0]);
            s[1] = Number(s[1]);
            if ((s[0] || s[0] === 0) && s[1] && (i < s[0] || i > s[1])) return `Prosimy o wprowadzenie liczby z przedziału od ${Number(s[0])} do ${Number(s[1])}${isModal ? " #" : ""}.`;
            if ((s[0] || s[0] === 0) && i < s[0]) return `Prosimy o wprowadzenie liczby większej lub równej od ${Number(s[0]) - 1}${isModal ? " #" : ""}.`;
            if (s[1] && i > s[1]) return `Prosimy o wprowadzenie liczby mniejszej lub równej od ${Number(s[1]) + 1}${isModal ? " #" : ""}.`;
        }
        return "";
    }
    static Range(i, s) {
        if (i && s) {
            const isModal = s[2] === "modal" ? " #" : "";
            const len = String(i).length;
            const chars = [
                "znak",
                "znaki",
                "znak\xf3w"
            ];
            s[0] = Number(s[0]);
            s[1] = Number(s[1]);
            if (s[1] && s[0] > s[1]) s[0] = s[1];
             // BUG w formularzach!
            if (s[0] === s[1] && len === s[0]) return "";
            let msg = "";
            if (s[0] && len <= s[0]) {
                const diff = s[0] - len + 1;
                if (isModal) {
                    msg = `Wprowadzony tekst # jest za krótki o ${(0, $jEEFu.default).PluralForm(diff, chars, true)}.`;
                    msg += ` Minimalna ilość znaków to ${s[0]}.`;
                } else msg = `Podana wartość jest za krótka o ${(0, $jEEFu.default).PluralForm(diff, chars, true)}.`;
            }
            if (s[1] && len > s[1]) {
                const diff = len - s[1];
                if (isModal) {
                    msg = `Wprowadzony tekst # jest za długi o ${(0, $jEEFu.default).PluralForm(diff, chars, true)}.`;
                    msg += ` Minimalna ilość znaków to ${s[0]}.`;
                } else msg = `Podana wartość jest za długa o ${(0, $jEEFu.default).PluralForm(diff, chars, true)}.`;
            }
            return msg;
        }
        return "";
    }
    static Alphanumeric(i) {
        return !/^[a-zA-Z0-9]+$/.test(i) ? "Prosimy o wpisanie tylko liter i cyfr (bez polskich znak\xf3w)" : "";
    }
    static RangeModal(i, s) {
        if (i && s) {
            const isModal = s[2] === "modal" ? " #" : "";
            const len = String(i).length;
            const chars = [
                "znak",
                "znaki",
                "znak\xf3w"
            ];
            if (s[0] === s[1] && len === s[0]) return "";
            let msg = "";
            if (s[0] && len < s[0]) {
                const diff = s[0] - len;
                msg = `Wprowadzony tekst${isModal ? " #" : ""} jest za krótki o ${(0, $jEEFu.default).PluralForm(diff, chars, true)}.`;
                if (isModal) msg += ` Minimalna ilość znaków to ${s[0]}.`;
            }
            if (s[1] && len > s[1]) {
                const diff = len - s[1];
                msg = `Wprowadzony tekst${isModal ? " #" : ""} jest za długi o ${(0, $jEEFu.default).PluralForm(diff, chars, true)}.`;
                if (isModal) msg += ` Maksymalna ilość znaków to ${s[1]}.`;
            }
            return msg;
        }
        return "";
    }
    static CompanyName(i, s, form, field) {
        if (!i) return "";
        field.Value = i = i.replace(/( +)/g, " ");
        const isInvalid = !/^[0-9A-Za-zÀ-ÿ\\s,._+()*~'#@&sżźćńółęąśŻŹĆĄŚĘŁÓŃ""„"“” -]+$/g.test(i);
        return isInvalid ? "Nazwa firmy musi zaczynać się od litery, cyfry lub cudzysłowu. Nazwa może składać się z liter, cyfr, pojedynczych spacji oraz wybranych znak\xf3w specjalnych." : "";
    }
    static PersonName(s) {
        const rgx = RegExp("^\\p{L}+ \\p{L}+[-]{0,1}\\p{L}+$", "u");
        return !s.trim().match(rgx) ? "Prosimy o podanie imienia i nazwiska" : "";
    }
    static PersonNames(s) {
        const rgx = RegExp("^\\p{L}+ \\p{L}+[- ]{0,1}\\p{L}+$", "u");
        return !s.trim().match(rgx) ? "Prosimy o podanie imienia i nazwiska" : "";
    }
    static Street(s) {
        const rgx = /^\D+ \d/;
        return !s.match(rgx) ? "Prosimy o podanie adresu" : "";
    }
    static PostCode(postCodeFromUser) {
        const errorTxt = "Prosimy o podanie prawidłowego kodu pocztowego";
        const rgxFirstPart = /^\d{2}$/;
        const rgxSecondPart = /^\d{3}$/;
        const firstPart = postCodeFromUser.split("-")[0];
        const secondPart = postCodeFromUser.split("-")[1];
        if (!firstPart || !secondPart) return errorTxt;
        const isCorrectPostCode = rgxFirstPart.test(firstPart) && rgxSecondPart.test(secondPart);
        return isCorrectPostCode ? "" : errorTxt;
    }
    static OptionalSecondName(s) {
        const rgx = /^[a-zęóąśłżźćń]{3,}/i;
        return !s.match(rgx) ? "Prosimy o podanie imienia" : "";
    }
    static Date() {}
    static UserName() {}
    static Length(i, s) {
        if (!i) return "";
        i = String(i).length;
        if (i === 0) return "";
        if (s[0] && i < s[0]) return "Podana wartość jest za kr\xf3tka";
        if (s[1] && i > s[1]) return "Podana wartość jest za długa";
        return "";
    }
    static Facebook(i) {
        if (!i) return "";
        if (/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(i)) return "";
        return "Proszę podać poprawny adres";
    }
    static Instagram(i) {
        if (!i) return "";
        if (/^(https?:\/\/)?((w{3}\.)?)instagram.com\/.*/i.test(i)) return "";
        return "Proszę podać poprawny adres";
    }
    static async CustomProfileUrlAsync(s) {
        try {
            let rsvp = await fetch(`/myoferteo/konto-json/validate-subdomain.ofer?subdomain=${s}`);
            rsvp = await rsvp.json();
            rsvp = JSON.parse(rsvp);
            return rsvp.result === "OK" ? "" : rsvp.validationMessage;
        } catch (err) {
            console.warn(err);
        }
        return "";
    }
    static ValidateArray(s, arr) {
        // TODO: Zerżnięte z FormGroup.vue
        for (let v of arr){
            v = v.split("|");
            const validator = v[0];
            const opts = (v[1] || "").indexOf(",") > -1 ? v[1].split(",") : v[1];
            const msg = v[2];
            const result = $040181eb3e77c99d$export$2e2bcd8739ae039[validator](s, opts);
            if (result) return msg || result;
        }
        return "";
    }
    static GoToMailbox(s) {
        if (!s || s.indexOf("@") === -1) return "";
        s = s.split("@")[1];
        const list = {
            "oferteo.pl": "gmail.com",
            "wp.pl": "profil.wp.pl",
            "wp.eu": "profil.wp.pl",
            "poczta.wp.pl": "profil.wp.pl",
            "xl.wp.pl": "profil.wp.pl",
            "gmail.com": "gmail.com",
            "googlemail.com": "gmail.com",
            "o2.pl": "poczta.o2.pl",
            "prokonto.pl": "poczta.o2.pl",
            "go2.pl": "poczta.o2.pl",
            "tlen.pl": "poczta.o2.pl",
            "interia.pl": "poczta.interia.pl",
            "interia.eu": "poczta.interia.pl",
            "interia.com": "poczta.interia.pl",
            "onet.pl": "konto.onet.pl",
            "op.pl": "konto.onet.pl",
            "buziaczek.pl": "konto.onet.pl",
            "amorki.pl": "konto.onet.pl",
            "poczta.onet.eu": "konto.onet.pl",
            "poczta.onet.pl": "konto.onet.pl",
            "onet.eu": "konto.onet.pl",
            "autograf.pl": "konto.onet.pl",
            "vip.onet.pl": "konto.onet.pl",
            "spoko.pl": "konto.onet.pl",
            "onet.com.pl": "konto.onet.pl",
            "vp.pl": "konto.onet.pl",
            "adres.pl": "konto.onet.pl",
            "opoczta.pl": "konto.onet.pl",
            "outlook.com": "outlook.live.com",
            "hotmail.com": "outlook.live.com",
            "gazeta.pl": "oauth.gazeta.pl",
            "g.pl": "oauth.gazeta.pl",
            "yahoo.com": "login.yahoo.com",
            "yahoo.pl": "login.yahoo.com",
            "yahoo.co.uk": "login.yahoo.com",
            "icloud.com": "icloud.com",
            "neostrada.pl": "webmail.neostrada.pl",
            "mail.ru": "mail.ru",
            "bk.ru": "mail.ru",
            "inbox.ru": "mail.ru",
            "yandex.ru": "passport.yandex.ru",
            "ukr.net": "mail.ukr.net",
            "post.pl": "login.poczta.home.pl",
            "home.pl": "login.poczta.home.pl",
            "data.pl": "login.poczta.home.pl",
            "list.pl": "login.poczta.home.pl",
            "rambler.ru": "games.rambler.ru",
            "orange.pl": "poczta.orange.pl",
            "int.pl": "int.pl",
            "gmx.de": "gmx.de"
        };
        return list[s] ? `//${list[s]}` : "";
    }
}

});

parcelRequire.register("gpQzG", function(module, exports) {

$parcel$export(module.exports, "getAppType", function () { return $b2ddf0c640fc2215$export$7a88fe5d3687ebff; });
$parcel$export(module.exports, "isBuyerApp", function () { return $b2ddf0c640fc2215$export$389dfbe7cce36bcb; });
$parcel$export(module.exports, "isSellerApp", function () { return $b2ddf0c640fc2215$export$9688c8d8392c17d4; });
const $b2ddf0c640fc2215$export$7a88fe5d3687ebff = async ()=>{
    if (typeof wrapee !== "undefined") {
        const deviceInfoResponse = await wrapee.getMobileMetrics();
        return deviceInfoResponse.appType; // Zwraca 'BuyerApp', 'SellerApp' lub inną wartość
    }
    // Domyślne zachowanie, gdy 'wrapee' jest niezdefiniowane
    return "default";
};
const $b2ddf0c640fc2215$export$389dfbe7cce36bcb = async ()=>{
    const appType = await $b2ddf0c640fc2215$export$7a88fe5d3687ebff();
    if (appType) return appType === "BuyerApp";
    // Zwraca wartość przechowywaną lokalnie, jeśli 'wrapee' jest niezdefiniowane
    return localStorage.getItem("isBuyerApp") === "true";
};
const $b2ddf0c640fc2215$export$9688c8d8392c17d4 = async ()=>{
    const appType = await $b2ddf0c640fc2215$export$7a88fe5d3687ebff();
    if (appType) return appType === "SellerApp";
    // Zwraca wartość przechowywaną lokalnie, jeśli 'wrapee' jest niezdefiniowane
    return window.localStorage["IsApp"] === "yes" && await $b2ddf0c640fc2215$export$389dfbe7cce36bcb() === false;
};

});

parcelRequire.register("8Tf05", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00e896590112c473$export$2e2bcd8739ae039; });
const $00e896590112c473$var$appMixin = {
    computed: {
        Analytics () {
            return window.Analytics;
        },
        CurrentModule () {
            return this.$root.$data.Module;
        },
        ModuleComponent () {
            return this.$root.$refs.CurrentModule;
        },
        ControllerComponent () {
            return this.$root.$refs.CurrentModule.$refs.CurrentController;
        },
        State () {
            return this.$root.$data.StateManager;
        },
        CurrentState () {
            return this.State && this.State.CurrentState ? this.State.CurrentState.state : {};
        },
        Server () {
            return this.$root.$data.ServerManager;
        },
        User () {
            return this.$root.$data.LoggedUser;
        },
        Format () {
            return this.$root.$data.Formatters;
        },
        Validate () {
            return this.$root.$data.Validators;
        },
        ScreenSize () {
            const width = this.$root.$data.WindowWidth;
            if (width > 1680) return 4;
            if (width > 1280) return 3;
            if (width > 991) return 2;
            if (width > 640) return 1;
            return 0;
        },
        Toast () {
            return this.$root.$refs.Toaster;
        }
    },
    provide () {
        return {
            toast: this.Toast
        };
    },
    methods: {
        HasFlag (flag) {
            if (!Array.isArray(this.$root.$data.Flags)) return false;
            return this.$root.$data.Flags.indexOf(flag) !== -1;
        },
        toggleBusyState (isBusy) {
            if (isBusy === undefined) isBusy = !this.$root.$data.IsSaving;
            this.$root.$data.IsSaving = isBusy;
        }
    }
};
var $00e896590112c473$export$2e2bcd8739ae039 = $00e896590112c473$var$appMixin;

});

parcelRequire.register("j8Egn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $351a6e238e5b86a3$export$2e2bcd8739ae039; });

var $f3OCz = parcelRequire("f3OCz");
/*
	W przypadku wyłapania błędu przez Vue, wyślij go do serwera poprzez wywołanie endpointa '/common/util/jscripterror.ofer'
	oraz wyświetl błąd w konsoli. Dodatkowo, uzupełnij wiadomość o typ urządzenia oraz ID sesji.
*/ const $351a6e238e5b86a3$var$sendError = (url, line, msg)=>{
    // Wysyła informacje o błędzie do Kibany.
    const formData = new FormData();
    formData.append("href", window.location.href);
    formData.append("url", url || window.location.href);
    formData.append("line", String(line || 0));
    if (typeof wrapee !== "undefined") (async ()=>{
        const deviceInfoResponse = await wrapee.getMobileMetrics();
        console.log("metrics", deviceInfoResponse);
        const deviceInfoString = ` appVersion=${deviceInfoResponse.appVersion}, ${deviceInfoResponse.deviceType}-${deviceInfoResponse.appType}, deviceInfo=${deviceInfoResponse.deviceInfo.phoneModel}`;
        msg = msg + deviceInfoString;
    })();
    const sessionId = "";
    formData.append("msg", `[App] ${(0, $f3OCz.default)(true)} ${msg} ${sessionId}`);
    fetch("/common/util/jscripterror.ofer", {
        method: "POST",
        mode: "no-cors",
        credentials: "include",
        body: formData
    });
};
const $351a6e238e5b86a3$var$errorHandler = (msg, url, line, error)=>{
    if (msg.indexOf("NS_ERROR_STORAGE_CONSTRAINT") > -1 && navigator.userAgent.indexOf("Firefox") > -1) // Firefox posiada buga: https://bugzilla.mozilla.org/show_bug.cgi?id=1758416
    // Kiedyś próbowaliśmy to naprawić poprzeć localStorage.clear(), ale to też się nie uda, więc zlewamy temat.
    return;
    const needsReload = msg.indexOf("dynamically imported module") > -1 || msg.indexOf("] []") > -1 || msg.indexOf("[Vue:13] ") > -1 || msg.indexOf("Cannot find module") > -1;
    if (needsReload) // Failed to fetch dynamically imported module:
    // W przypadku napotkania błędu związanego z niemożnością załadowania modułu, spróbuj odświeżyć stronę.
    // Możliwe, że kolejne wczytanie strony rozwiąże problem z wyświetleniem "białej strony".
    // Nie wyłapuje to wszystkich możliwości, dlatego też jeszcze zasadzamy się na: `[Vue:13]`
    // - tak wychodzi z logów Kibany, chociaż może zdarzyć się sytuacja, że będzie to już za dużo.
    window.setTimeout(()=>{
        $351a6e238e5b86a3$var$sendError(url, line, "Module import failed: trying to reload.");
        // Używaliśmy `window.location.reload(true);`, ale wtedy nadal nie mamy pewności, że nie zostanie
        // pobrana wersja z cache, dlatego też będziemy dodawać parametr z aktualną datą.
        let { href: href } = window.location;
        href += href.indexOf("?") > -1 ? "&" : "?";
        href += `refreshDate=${Number(new Date())}`;
        document.location.replace(href);
    }, 750);
    $351a6e238e5b86a3$var$sendError(url, line, msg);
    console.warn(`😢 ${msg}`, error);
};
var $351a6e238e5b86a3$export$2e2bcd8739ae039 = $351a6e238e5b86a3$var$errorHandler;

});

parcelRequire.register("26LNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0065ddd7bc78339b$export$2e2bcd8739ae039; });
const $0065ddd7bc78339b$var$setGlobalEventListeners = ()=>{
    window.addEventListener("scroll", ()=>{
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        document.body.classList.toggle("is-page-scrolled", Boolean(scrollTop));
        document.body.classList.toggle("is-whole-page-scrolled", Boolean(scrollTop > 600));
    });
};
var $0065ddd7bc78339b$export$2e2bcd8739ae039 = $0065ddd7bc78339b$var$setGlobalEventListeners;

});

parcelRequire.register("jefcy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9a314ce10c87fff$export$2e2bcd8739ae039; });

var $j8Egn = parcelRequire("j8Egn");
const $d9a314ce10c87fff$var$vueErrorHandler = (error, vueInstance, info)=>{
    var _error_stack;
    // TODO: errorCaptured
    let stack = error === null || error === void 0 ? void 0 : (_error_stack = error.stack) === null || _error_stack === void 0 ? void 0 : _error_stack.replace(/ {4}at/g, "➜");
    stack = stack && stack.length > 2048 ? `${stack.slice(0, 2048)}...` : stack;
    const state = vueInstance.State && vueInstance.State.CurrentState && vueInstance.State.CurrentState.state ? JSON.stringify(vueInstance.State.CurrentState.state).slice(0, 512) : "n/a";
    const customer = vueInstance.User ? `CID:${vueInstance.User.CustomerId || -1},UID:${vueInstance.User.UserId || -1}` : "n/a";
    const additional = `userId⯈:${customer}|state⯈:${state}|width⯈:${window.innerWidth}|ua⯈:${navigator.userAgent}`;
    const msg = `[Vue:${info}] [${stack ? stack.split("\n").join(" ") : ""}] [${additional}]`;
    (0, $j8Egn.default)(msg, document.location.href, "1", error);
};
var $d9a314ce10c87fff$export$2e2bcd8739ae039 = $d9a314ce10c87fff$var$vueErrorHandler;

});

})();
//# sourceMappingURL=admin.31fa4f45.js.map
